/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	
	__webpack_require__(2);
	
	var SUGAR = __webpack_require__(5);
	
	// globalize these for Mango bwc:
	__webpack_require__(6);
	__webpack_require__(8);
	__webpack_require__(10);
	__webpack_require__(12);
	window.async = __webpack_require__(14);
	__webpack_require__(17);
	__webpack_require__(19);
	window.SUGAR = SUGAR;
	
	__webpack_require__(21);
	__webpack_require__(23);
	__webpack_require__(25);
	
	__webpack_require__(27);
	
	__webpack_require__(29);
	
	__webpack_require__(31);
	__webpack_require__(32);
	__webpack_require__(33);
	__webpack_require__(34);
	__webpack_require__(35);
	__webpack_require__(36);
	__webpack_require__(37);
	__webpack_require__(38);
	__webpack_require__(39);
	__webpack_require__(40);
	__webpack_require__(41);
	__webpack_require__(42);
	__webpack_require__(43);
	__webpack_require__(44);
	__webpack_require__(45);
	__webpack_require__(46);
	__webpack_require__(47);
	__webpack_require__(48);
	__webpack_require__(49);
	__webpack_require__(50);
	__webpack_require__(51);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(56);
	__webpack_require__(57);
	__webpack_require__(58);
	__webpack_require__(59);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(4))

/***/ },
/* 3 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		if (typeof execScript !== "undefined")
			execScript(src);
		else
			eval.call(null, src);
	}


/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = "/*!\r\n * crosstab JavaScript Library v0.2.7\r\n * https://github.com/tejacques/crosstab\r\n *\r\n * License: Apache 2.0 https://github.com/tejacques/crosstab/blob/master/LICENSE\r\n */\r\n; (function (define) { define('crosstab', function (require, exports, module) {\r\n    'use strict';\r\n\r\n    // --- Handle Support ---\r\n    // See: http://detectmobilebrowsers.com/about\r\n    var useragent = navigator.userAgent || navigator.vendor || window.opera;\r\n    var isMobile = (/(android|bb\\d+|meego).+mobile|avantgo|bada\\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(useragent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\\/|capi|ccwa|cdm\\-|cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|g1 u|g560|gene|gf\\-5|g\\-mo|go(\\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|i230|iac( |\\-|\\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\\/(k|l|u)|50|54|\\-[a-w])|libw|lynx|m1\\-w|m3ga|m50\\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\\/|se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|sk\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-/i.test(useragent.substr(0, 4)));\r\n\r\n    var localStorage;\r\n    try {\r\n        localStorage = window.localStorage;\r\n        localStorage = window['ie-eventlistener/storage'] || window.localStorage;\r\n    } catch (e) {\r\n        // New versions of Firefox throw a Security exception\r\n        // if cookies are disabled. See\r\n        // https://bugzilla.mozilla.org/show_bug.cgi?id=1028153\r\n    }\r\n\r\n    // When Safari on OS X or iOS is in private browsing mode,\r\n    // calling localStorage.setItem throws an exception.\r\n    //\r\n    // \"QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made\r\n    // to add something to storage that exceeded the quota.\"\r\n    var setItemAllowed = true;\r\n    try {\r\n        localStorage.setItem('__crosstab', '');\r\n        localStorage.removeItem('__crosstab');\r\n    } catch (e) {\r\n        setItemAllowed = false;\r\n    }\r\n\r\n    // Other reasons\r\n    var frozenTabEnvironment = false;\r\n\r\n    function notSupported() {\r\n        if (crosstab.supported) return;\r\n        var errorMsg = 'crosstab not supported';\r\n        var reasons = [];\r\n        if (!localStorage) {\r\n            reasons.push('localStorage not availabe');\r\n        }\r\n        if (!window.addEventListener) {\r\n            reasons.push('addEventListener not available');\r\n        }\r\n        if (isMobile) {\r\n            reasons.push('mobile browser');\r\n        }\r\n        if (frozenTabEnvironment) {\r\n            reasons.push('frozen tab environment detected');\r\n        }\r\n        if (!setItemAllowed) {\r\n            reasons.push('localStorage.setItem not allowed');\r\n        }\r\n\r\n        if (reasons.length > 0) {\r\n            errorMsg += ': ' + reasons.join(', ');\r\n        }\r\n\r\n        throw new Error(errorMsg);\r\n    }\r\n\r\n    // --- Utility ---\r\n    var util = {\r\n        keys: {\r\n            MESSAGE_KEY: 'crosstab.MESSAGE_KEY',\r\n            TABS_KEY: 'crosstab.TABS_KEY',\r\n            MASTER_TAB: 'MASTER_TAB',\r\n            SUPPORTED_KEY: 'crosstab.SUPPORTED',\r\n            FROZEN_TAB_ENVIRONMENT: 'crosstab.FROZEN_TAB_ENVIRONMENT'\r\n        }\r\n    };\r\n\r\n    var toString = Object.prototype.toString;\r\n\r\n    util.isArray = Array.isArray || function (arr) {\r\n        return arr instanceof Array;\r\n    };\r\n\r\n    util.isNumber = function (num) {\r\n        return typeof num === 'number';\r\n    };\r\n\r\n    util.isFunction = function (fn) {\r\n        return typeof fn === 'function';\r\n    };\r\n\r\n    util.forEachObj = function (obj, fn) {\r\n        for (var key in obj) {\r\n            if (obj.hasOwnProperty(key)) {\r\n                fn.call(obj, obj[key], key);\r\n            }\r\n        }\r\n    };\r\n\r\n    util.forEachArr = function (arr, fn) {\r\n        var len = arr.length;\r\n        for (var i = 0; i < len; i++) {\r\n            fn.call(arr, arr[i], i, arr);\r\n        }\r\n    };\r\n\r\n    util.forEach = function (thing, fn) {\r\n        if (util.isArray(thing)) {\r\n            util.forEachArr(thing, fn);\r\n        } else {\r\n            util.forEachObj(thing, fn);\r\n        }\r\n    };\r\n\r\n    util.map = function (thing, fn) {\r\n        var res = [];\r\n        util.forEach(thing, function (item) {\r\n            res.push(fn(item));\r\n        });\r\n\r\n        return res;\r\n    };\r\n\r\n    util.filter = function (thing, fn) {\r\n        var isArr = util.isArray(thing);\r\n        var res = isArr ? [] : {};\r\n\r\n        if (isArr) {\r\n            util.forEachArr(thing, function (value, key) {\r\n                if (fn(value, key)) {\r\n                    res.push(value);\r\n                }\r\n            });\r\n        } else {\r\n            util.forEachObj(thing, function (value, key) {\r\n                if (fn(value, key)) {\r\n                    res[key] = value;\r\n                }\r\n            });\r\n        }\r\n\r\n        return res;\r\n    };\r\n\r\n    util.now = function () {\r\n        return (new Date()).getTime();\r\n    };\r\n\r\n    util.tabs = getStoredTabs();\r\n\r\n    util.eventTypes = {\r\n        becomeMaster: 'becomeMaster',\r\n        demoteFromMaster: 'demotedFromMaster',\r\n        tabUpdated: 'tabUpdated',\r\n        tabClosed: 'tabClosed',\r\n        tabPromoted: 'tabPromoted'\r\n    };\r\n\r\n    // --- Events ---\r\n    // node.js style events, with the main difference being able\r\n    // to add/remove events by key.\r\n    util.createEventHandler = function () {\r\n        var events = {};\r\n        var subscribeKeyToListener = {};\r\n\r\n        var findHandlerByKey = function(event, key) {\r\n            var handler;\r\n            if (subscribeKeyToListener[event]) {\r\n                handler = subscribeKeyToListener[event][key];\r\n            }\r\n            return handler;\r\n        };\r\n\r\n        var findHandlerIndex = function (event, listener) {\r\n            var listenerIndex = -1;\r\n            var eventList = events[event];\r\n            if (eventList && listener) {\r\n                var len = eventList.length || 0;\r\n                for(var i = 0; i < len; i++) {\r\n                    if (eventList[i] === listener) {\r\n                        listenerIndex = i;\r\n                        break;\r\n                    }\r\n                }\r\n            }\r\n            return listenerIndex;\r\n        };\r\n\r\n        var addListener = function (event, listener, key) {\r\n            var handlers = listeners(event);\r\n\r\n            var storedHandler = findHandlerByKey(event, key);\r\n            var listenerIndex;\r\n\r\n            if (storedHandler === undefined) {\r\n                listenerIndex = handlers.length;\r\n                handlers[listenerIndex] = listener;\r\n\r\n                if (!subscribeKeyToListener[event]) {\r\n                    (subscribeKeyToListener[event] = {});\r\n                }\r\n\r\n                if (key) {\r\n                    subscribeKeyToListener[event][key] = listener;\r\n                }\r\n            } else {\r\n                listenerIndex = findHandlerIndex(event, storedHandler);\r\n                handlers[listenerIndex] = listener;\r\n            }\r\n\r\n            return key || listener;\r\n        };\r\n\r\n        var removeListener = function (event, key) {\r\n            var handler = util.isFunction(key)\r\n                ? key\r\n                : findHandlerByKey(event, key);\r\n\r\n            var listenerIndex = findHandlerIndex(event, handler);\r\n            if (listenerIndex === -1) return false;\r\n\r\n            if (events[event] && events[event][listenerIndex]) {\r\n                events[event].splice(listenerIndex, 1);\r\n                delete subscribeKeyToListener[event][key];\r\n                return true;\r\n            }\r\n            return false;\r\n        };\r\n\r\n        var removeAllListeners = function (event) {\r\n            var successful = false;\r\n            if (event) {\r\n                if (events[event]) {\r\n                    delete events[event];\r\n                    successful = true;\r\n                }\r\n                if (subscribeKeyToListener[event]) {\r\n                    delete subscribeKeyToListener[event];\r\n                    successful = successful && true;\r\n                }\r\n            } else {\r\n                events = {};\r\n                subscribeKeyToListener = {};\r\n                successful = true;\r\n            }\r\n            return successful;\r\n        };\r\n\r\n        var emit = function (event) {\r\n            var args = Array.prototype.slice.call(arguments, 1);\r\n            var handlers = listeners(event);\r\n\r\n            util.forEach(handlers, function (listener) {\r\n                if (util.isFunction(listener)) {\r\n                    listener.apply(this, args);\r\n                }\r\n            });\r\n        };\r\n\r\n        var once = function (event, listener, key) {\r\n            // Generate a unique id for this listener\r\n            while (!key || (findHandlerByKey(event, key) !== undefined)) {\r\n                key = util.generateId();\r\n            }\r\n\r\n            addListener(event, function () {\r\n                removeListener(event, key);\r\n                var args = Array.prototype.slice.call(arguments);\r\n                listener.apply(this, args);\r\n            }, key);\r\n\r\n            return key;\r\n        };\r\n\r\n        var listeners = function (event) {\r\n            var handlers = events[event] = events[event] || [];\r\n            return handlers;\r\n        };\r\n\r\n        var destructor = function() {\r\n            removeAllListeners();\r\n        };\r\n\r\n        return {\r\n            addListener: addListener,\r\n            destructor: destructor,\r\n            on: addListener,\r\n            off: function(event, key) {\r\n                var argsLen = arguments.length;\r\n                if (!argsLen) {\r\n                    return removeAllListeners();\r\n                } else if (argsLen === 1) {\r\n                    return removeAllListeners(event);\r\n                } else {\r\n                    return removeListener(event, key);\r\n                }\r\n            },\r\n            once: once,\r\n            emit: emit,\r\n            listeners: listeners,\r\n            removeListener: removeListener,\r\n            removeAllListeners: removeAllListeners\r\n        };\r\n    };\r\n\r\n    // --- Setup Events ---\r\n    var eventHandler = util.createEventHandler();\r\n\r\n    // wrap eventHandler so that setting it will not blow up\r\n    // any of the internal workings\r\n    util.events = {\r\n        addListener: eventHandler.addListener,\r\n        on: eventHandler.on,\r\n        off: eventHandler.off,\r\n        once: eventHandler.once,\r\n        emit: eventHandler.emit,\r\n        listeners: eventHandler.listeners,\r\n        removeListener: eventHandler.removeListener,\r\n        removeAllListeners: eventHandler.removeAllListeners,\r\n        destructor: eventHandler.destructor\r\n    };\r\n\r\n    var lastNewValue;\r\n    var lastOldValue;\r\n    function onStorageEvent(event) {\r\n        var eventValue;\r\n        var wasSupported = crosstab.supported;\r\n        try {\r\n            eventValue = event.newValue ? JSON.parse(event.newValue) : {};\r\n        } catch (e) {\r\n            eventValue = {};\r\n        }\r\n        if (!eventValue.id || eventValue.id === crosstab.id) {\r\n            // This is to force IE to behave properly\r\n            return;\r\n        }\r\n        if (event.newValue === lastNewValue && event.oldValue === lastOldValue) {\r\n            // Fix bug in IE11 where StorageEvents in iframes are sent twice.\r\n            return;\r\n        }\r\n        lastNewValue = event.newValue;\r\n        lastOldValue = event.oldValue;\r\n        if (event.key === util.keys.MESSAGE_KEY) {\r\n            var message = eventValue.data;\r\n            // only handle if this message was meant for this tab.\r\n            if (!message.destination || message.destination === crosstab.id) {\r\n                eventHandler.emit(message.event, message);\r\n            }\r\n        } else if (event.key === util.keys.FROZEN_TAB_ENVIRONMENT) {\r\n            frozenTabEnvironment = eventValue.data;\r\n            crosstab.supported = crosstab.supported && !eventValue.data;\r\n            //if (wasSupported) notSupported();\r\n        } else if (event.key === util.keys.SUPPORTED_KEY) {\r\n            crosstab.supported = crosstab.supported && eventValue.data;\r\n            //if(wasSupported) notSupported();\r\n        }\r\n    }\r\n\r\n    function setLocalStorageItem(key, data) {\r\n        var storageItem = {\r\n            id: crosstab.id,\r\n            data: data,\r\n            timestamp: util.now()\r\n        };\r\n\r\n        localStorage.setItem(key, JSON.stringify(storageItem));\r\n    }\r\n\r\n    function getLocalStorageItem(key) {\r\n        var item = getLocalStorageRaw(key);\r\n        return item.data;\r\n    }\r\n\r\n    function getLocalStorageRaw(key) {\r\n        var json = localStorage ? localStorage.getItem(key) : null;\r\n        var item = json ? JSON.parse(json) : {};\r\n        return item;\r\n    }\r\n\r\n    function unload() {\r\n        crosstab.stopKeepalive = true;\r\n        var numTabs = 0;\r\n        util.forEach(util.tabs, function (tab, key) {\r\n            if (key !== util.keys.MASTER_TAB) {\r\n                numTabs++;\r\n            }\r\n        });\r\n\r\n        if (numTabs === 1) {\r\n            util.tabs = {};\r\n            setStoredTabs();\r\n        } else {\r\n            broadcast(util.eventTypes.tabClosed, crosstab.id);\r\n        }\r\n\r\n    }\r\n\r\n    function restoreLoop() {\r\n        crosstab.stopKeepalive = false;\r\n        keepaliveLoop();\r\n    }\r\n\r\n    function swapUnloadEvents() {\r\n        // `beforeunload` replaced by `unload` (IE11 will be smart now)\r\n        window.removeEventListener('beforeunload', unload, false);\r\n        window.addEventListener('unload', unload, false);\r\n        restoreLoop();\r\n    }\r\n\r\n    function getMaster() {\r\n        return util.tabs[util.keys.MASTER_TAB];\r\n    }\r\n\r\n    function setMaster(newMaster) {\r\n        util.tabs[util.keys.MASTER_TAB] = newMaster;\r\n    }\r\n\r\n    function deleteMaster() {\r\n        delete util.tabs[util.keys.MASTER_TAB];\r\n    }\r\n\r\n    function getMasterId() {\r\n        var master = getMaster();\r\n\r\n        return master ? master.id : 0;\r\n    }\r\n\r\n    function isMaster() {\r\n        return getMasterId() === crosstab.id;\r\n    }\r\n\r\n    function masterTabElection() {\r\n        var maxId = null;\r\n        util.forEach(util.tabs, function (tab) {\r\n            if (!maxId || tab.id < maxId) {\r\n                maxId = tab.id;\r\n            }\r\n        });\r\n\r\n        // only broadcast the promotion if I am the new master\r\n        if (maxId === crosstab.id) {\r\n            broadcast(util.eventTypes.tabPromoted, crosstab.id);\r\n        } else {\r\n            // this is done so that in the case where multiple tabs are being\r\n            // started at the same time, and there is no current saved tab\r\n            // information, we will still have a value set for the master tab\r\n            setMaster({\r\n                id: maxId,\r\n                lastUpdated: util.now()\r\n            });\r\n        }\r\n    }\r\n\r\n    // Handle other tabs closing by updating internal tab model, and promoting\r\n    // self if we are the lowest tab id\r\n    eventHandler.addListener(util.eventTypes.tabClosed, function (message) {\r\n        var id = message.data;\r\n        if (util.tabs[id]) {\r\n            delete util.tabs[id];\r\n        }\r\n\r\n        if (!getMaster() || getMaster().id === id) {\r\n            // If the master was the closed tab, delete it and the highest\r\n            // tab ID becomes the new master, which will save the tabs\r\n            if (getMaster()) {\r\n                deleteMaster();\r\n            }\r\n            masterTabElection();\r\n        } else if (getMaster().id === crosstab.id) {\r\n            // If I am master, save the new tabs out\r\n            setStoredTabs();\r\n        }\r\n    });\r\n\r\n    eventHandler.addListener(util.eventTypes.tabUpdated, function (message) {\r\n        var tab = message.data;\r\n        util.tabs[tab.id] = tab;\r\n\r\n        // If there is no master, hold an election\r\n        if (!getMaster()) {\r\n            masterTabElection();\r\n        }\r\n\r\n        if (getMasterId() === tab.id) {\r\n            setMaster(tab);\r\n        }\r\n        if (isMaster()) {\r\n            // If I am master, save the new tabs out\r\n            setStoredTabs();\r\n        }\r\n    });\r\n\r\n    eventHandler.addListener(util.eventTypes.tabPromoted, function (message) {\r\n        var id = message.data;\r\n        var lastUpdated = message.timestamp;\r\n        var previousMaster = getMasterId();\r\n        setMaster({\r\n            id: id,\r\n            lastUpdated: lastUpdated\r\n        });\r\n\r\n        if (isMaster()\r\n            && previousMaster !== crosstab.id) {\r\n            // set the tabs in localStorage\r\n            setStoredTabs();\r\n\r\n            // emit the become master event so we can handle it accordingly\r\n            util.events.emit(util.eventTypes.becomeMaster);\r\n        } else if (!isMaster()\r\n            && previousMaster === crosstab.id) {\r\n            // emit the demoted from master event so we can clean up resources\r\n            util.events.emit(util.eventTypes.demoteFromMaster);\r\n        }\r\n    });\r\n\r\n    function pad(num, width, padChar) {\r\n        padChar = padChar || '0';\r\n        var numStr = (num.toString());\r\n\r\n        if (numStr.length >= width) {\r\n            return numStr;\r\n        }\r\n\r\n        return new Array(width - numStr.length + 1).join(padChar) + numStr;\r\n    }\r\n\r\n    util.generateId = function () {\r\n        /*jshint bitwise: false*/\r\n        return util.now().toString() + pad((Math.random() * 0x7FFFFFFF) | 0, 10);\r\n    };\r\n\r\n    // --- Setup message sending and handling ---\r\n    function broadcast(event, data, destination) {\r\n        if (!crosstab.supported) {\r\n            notSupported();\r\n        }\r\n\r\n        var message = {\r\n            id: util.generateId(),\r\n            event: event,\r\n            data: data,\r\n            destination: destination,\r\n            origin: crosstab.id,\r\n            timestamp: util.now()\r\n        };\r\n\r\n        // If the destination differs from the origin send it out, otherwise\r\n        // handle it locally\r\n        if (message.destination !== message.origin) {\r\n            setLocalStorageItem(util.keys.MESSAGE_KEY, message);\r\n        }\r\n\r\n        if (!message.destination || message.destination === message.origin) {\r\n            eventHandler.emit(event, message);\r\n        }\r\n    }\r\n\r\n    function broadcastMaster(event, data) {\r\n        broadcast(event, data, getMaster().id);\r\n    }\r\n\r\n    // ---- Return ----\r\n    var setupComplete = false;\r\n    util.events.once('setupComplete', function () {\r\n        setupComplete = true;\r\n    });\r\n\r\n    var crosstab = function (fn) {\r\n        if (setupComplete) {\r\n            fn();\r\n        } else {\r\n            util.events.once('setupComplete', fn);\r\n        }\r\n    };\r\n\r\n    crosstab.id = util.generateId();\r\n    crosstab.supported = !!localStorage && window.addEventListener && !isMobile && setItemAllowed;\r\n    crosstab.util = util;\r\n    crosstab.broadcast = broadcast;\r\n    crosstab.broadcastMaster = broadcastMaster;\r\n    crosstab.on = util.events.on;\r\n    crosstab.once = util.events.once;\r\n    crosstab.off = util.events.off;\r\n\r\n    // --- Crosstab supported ---\r\n    // Check to see if the global frozen tab environment key or supported key has been set.\r\n    if (!setupComplete && crosstab.supported) {\r\n        var frozenTabsRaw = getLocalStorageRaw(util.keys.FROZEN_TAB_ENVIRONMENT);\r\n        var frozenTabs = frozenTabsRaw.data;\r\n        if (frozenTabs === true) {\r\n            frozenTabEnvironmentDetected();\r\n        }\r\n\r\n        var supportedRaw = getLocalStorageRaw(util.keys.SUPPORTED_KEY);\r\n        var supported = supportedRaw.data;\r\n        if (supported === false || supported === true) {\r\n            // As long as it is explicitely set, use the value\r\n            crosstab.supported = supported;\r\n            util.events.emit('setupComplete');\r\n        }\r\n    }\r\n\r\n    function frozenTabEnvironmentDetected() {\r\n        crosstab.supported = false;\r\n        frozenTabEnvironment = true;\r\n        setLocalStorageItem(util.keys.FROZEN_TAB_ENVIRONMENT, true);\r\n        setLocalStorageItem(util.keys.SUPPORTED_KEY, false);\r\n    }\r\n\r\n    // --- Tab Setup ---\r\n    // 3 second keepalive\r\n    var TAB_KEEPALIVE = 3 * 1000;\r\n    // 5 second timeout\r\n    var TAB_TIMEOUT = 5 * 1000;\r\n    // 500 ms ping timeout\r\n    var PING_TIMEOUT = 500;\r\n\r\n    function getStoredTabs() {\r\n        var storedTabs = getLocalStorageItem(util.keys.TABS_KEY);\r\n        util.tabs = storedTabs || util.tabs || {};\r\n        return util.tabs;\r\n    }\r\n\r\n    function setStoredTabs() {\r\n        setLocalStorageItem(util.keys.TABS_KEY, util.tabs);\r\n    }\r\n\r\n    function keepalive() {\r\n        var now = util.now();\r\n\r\n        var myTab = {\r\n            id: crosstab.id,\r\n            lastUpdated: now\r\n        };\r\n\r\n        // broadcast tabUpdated event\r\n        broadcast(util.eventTypes.tabUpdated, myTab);\r\n\r\n        // broadcast tabClosed event for each tab that timed out\r\n        function stillAlive(tab) {\r\n            return now - tab.lastUpdated < TAB_TIMEOUT;\r\n        }\r\n\r\n        function notAlive(tab, key) {\r\n            return key !== util.keys.MASTER_TAB && !stillAlive(tab);\r\n        }\r\n\r\n        var deadTabs = util.filter(util.tabs, notAlive);\r\n        util.forEach(deadTabs, function (tab) {\r\n            broadcast(util.eventTypes.tabClosed, tab.id);\r\n        });\r\n\r\n        // check to see if setup is complete\r\n        if (!setupComplete) {\r\n            var masterTab = crosstab.util.tabs[crosstab.util.keys.MASTER_TAB];\r\n            // ping master\r\n            if (masterTab && masterTab.id !== myTab.id) {\r\n                var timeout;\r\n                var start;\r\n\r\n                crosstab.util.events.once('PONG', function () {\r\n                    if (!setupComplete) {\r\n                        clearTimeout(timeout);\r\n                        // set supported to true / frozen to false\r\n                        setLocalStorageItem(\r\n                            util.keys.SUPPORTED_KEY,\r\n                            true);\r\n                        setLocalStorageItem(\r\n                            util.keys.FROZEN_TAB_ENVIRONMENT,\r\n                            false);\r\n                        util.events.emit('setupComplete');\r\n                    }\r\n                });\r\n\r\n                start = util.now();\r\n\r\n                // There is a nested timeout here. We'll give it 100ms\r\n                // timeout, with iters \"yields\" to the event loop. So at least\r\n                // iters number of blocks of javascript will be able to run\r\n                // covering at least 100ms\r\n                var recursiveTimeout = function (iters) {\r\n                    var diff = util.now() - start;\r\n\r\n                    if (!setupComplete) {\r\n                        if (iters <= 0 && diff > PING_TIMEOUT) {\r\n                            frozenTabEnvironmentDetected();\r\n                            util.events.emit('setupComplete');\r\n                        } else {\r\n                            timeout = setTimeout(function () {\r\n                                recursiveTimeout(iters - 1);\r\n                            }, 5);\r\n                        }\r\n                    }\r\n                };\r\n\r\n                var iterations = 5;\r\n                timeout = setTimeout(function () {\r\n                    recursiveTimeout(5);\r\n                }, PING_TIMEOUT - 5 * iterations);\r\n                crosstab.broadcastMaster('PING');\r\n            } else if (masterTab && masterTab.id === myTab.id) {\r\n                util.events.emit('setupComplete');\r\n            }\r\n        }\r\n    }\r\n\r\n    function keepaliveLoop() {\r\n        if (crosstab.supported && !crosstab.stopKeepalive) {\r\n            keepalive();\r\n        }\r\n    }\r\n\r\n    // --- Check if crosstab is supported ---\r\n    if (!crosstab.supported) {\r\n        crosstab.broadcast = notSupported;\r\n    } else {\r\n        // ---- Setup Storage Listener\r\n        window.addEventListener('storage', onStorageEvent, false);\r\n        // start with the `beforeunload` event due to IE11\r\n        window.addEventListener('beforeunload', unload, false);\r\n        // swap `beforeunload` to `unload` after DOM is loaded\r\n        window.addEventListener('DOMContentLoaded', swapUnloadEvents, false);\r\n\r\n        util.events.on('PING', function (message) {\r\n            // only handle direct messages\r\n            if (!message.destination || message.destination !== crosstab.id) {\r\n                return;\r\n            }\r\n\r\n            if (util.now() - message.timestamp < PING_TIMEOUT) {\r\n                crosstab.broadcast('PONG', null, message.origin);\r\n            }\r\n        });\r\n\r\n        setInterval(keepaliveLoop, TAB_KEEPALIVE);\r\n        keepaliveLoop();\r\n    }\r\n\r\n    module.exports = crosstab;\r\n\r\n/*!\r\n * UMD/AMD/Global context Module Loader wrapper\r\n * based off https://gist.github.com/wilsonpage/8598603\r\n *\r\n * This wrapper will try to use a module loader with the\r\n * following priority:\r\n *\r\n *  1.) AMD\r\n *  2.) CommonJS\r\n *  3.) Context Variable (window in the browser)\r\n */\r\n});})(typeof define == 'function' && define.amd ? define\r\n    : (function (context) {\r\n        'use strict';\r\n        return typeof module == 'object' ? function (name, factory) {\r\n            factory(require, exports, module);\r\n        }\r\n        : function (name, factory) {\r\n            var module = {\r\n                exports: {}\r\n            };\r\n            var require = function (n) {\r\n                if (n === 'jquery') {\r\n                    n = 'jQuery';\r\n                }\r\n                return context[n];\r\n            };\r\n\r\n            factory(require, module.exports, module);\r\n            context[name] = module.exports;\r\n        };\r\n    })(this));\r\n"

/***/ },
/* 5 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var SUGAR = window.SUGAR;
	
	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	
	/**
	 * SugarCRM namespace.
	 *
	 * @ignore
	 */
	var SUGAR = SUGAR || {};
	
	SUGAR.App = function () {
	    var _app,
	        _modules = {};
	
	    /**
	     * Flag indicating an `app.sync` is in progress.
	     *
	     * @type {boolean}
	     * @private
	     */
	    var _isSyncing = false;
	
	    /**
	     * A list of callback functions to call whenever `sync` is completed.
	     *
	     * @type {Array}
	     * @private
	     */
	    var _syncCallbacks = [];
	
	    var _make$ = function _make$(selector) {
	        return selector instanceof $ ? selector : $(selector);
	    };
	
	    /**
	     * `SUGAR.App` contains the core instance of the app. All related modules
	     * can be found within the `SUGAR` namespace.
	     *
	     * An uninitialized instance will exist on page load but you will need to
	     * call {@link App#init} to initialize your instance.
	     *
	     * By default, the app uses `body` element and `div#content` as root element
	     * and content element respectively.
	     *
	     *     var app = SUGAR.App.init({
	     *         el: '#root',
	     *         contentEl: '#content'
	     *     });
	     *
	     * If you want to initialize an app without initializing its modules,
	     *
	     *     var app = SUGAR.App.init({el: '#root', silent: true});
	     *
	     *
	     * @class App
	     * @singleton
	     * @constructor Constructor class for the main framework app.
	     * @param {Object} [opts] Configuration options. See full list of options
	     *   in {@link #init}.
	     * @return {App} Application instance.
	     * @private
	     */
	    function App(opts) {
	        var appId = _.uniqueId('SugarApp_');
	        opts = opts || {};
	
	        return _.extend({
	            /**
	             * Unique application ID.
	             *
	             * @property {string}
	             */
	            appId: appId,
	
	            /**
	             * Base element to use as the root of the app.
	             *
	             * @property {jQuery}
	             */
	            $rootEl: _make$(opts.el || 'body'),
	
	            /**
	             * Content element selector.
	             *
	             * The {@link Core.Controller application controller} loads layouts
	             * into the content element.
	             *
	             * @property {jQuery}
	             */
	            $contentEl: _make$(opts.contentEl || '#content'),
	
	            /**
	             * Additional components.
	             *
	             * These components are created and rendered only once, when the
	             * application starts.
	             *
	             * Application specific code is needed for managing the components
	             * after they have been put into DOM by the framework.
	             */
	            additionalComponents: {}
	
	        }, this, Backbone.Events);
	    }
	
	    return {
	        /**
	         * Initializes the app.
	         *
	         * - Triggers {@link #event-app:init} if `opts.silent` is not `false`.
	         * - {@link #event-app:sync:error} is fired if the public metadata could
	         * not be synced.
	         *
	         * @param {Object} [opts] Initialization options.
	         * @param {string} [opts.el='body'] The selector for the
	         *   {@link #$rootEl base element} to use as the root of the app.
	         * @param {string} [opts.contentEl='#content'] The selector for the
	         *   {@link #$contentEl content element}.
	         * @param {boolean} [opts.silent=false] Flag to indicate if modules
	         *   should be initialized during application init process.
	         * @param {Function} [opts.defaultErrorHandler] Allows you to define a
	         *   custom error handler. Defaults to
	         *   {@link Core.Error#handleHttpError}.
	         *
	         * @return {App} Application instance
	         * @method
	         */
	        init: function init(opts) {
	            _app = _app || _.extend(this, new App(opts));
	            _.extend(_app, _app.beforeEvent);
	
	            // Register app specific events
	            _app.events.register(
	            /**
	             * Fires when the app object is initialized. Modules bound to
	             * this event will initialize.
	             *
	             * @event
	             */
	            'app:init', this);
	
	            _app.events.register(
	            /**
	             * Fires when the application has
	             * finished loading its dependencies and should initialize
	             * everything.
	             *
	             *     obj.on('app:start', callback);
	             *
	             * @event
	             */
	            'app:start', this);
	
	            _app.events.register(
	            /**
	             * Fires when the app is beginning to sync data / metadata from
	             * the server.
	             *
	             * @event
	             */
	            'app:sync', this);
	
	            _app.events.register(
	            /**
	             * Fires when the app has finished its syncing process and is
	             * ready to proceed.
	             *
	             * @event
	             */
	            'app:sync:complete', this);
	
	            _app.events.register(
	            /**
	             * Fires when a sync process failed.
	             *
	             * @event
	             */
	            'app:sync:error', this);
	
	            _app.events.register(
	            /**
	             * Fires when a sync process failed during initialization of
	             * the app.
	             *
	             * @event
	             */
	            'app:sync:public:error', this);
	
	            _app.events.register(
	            /**
	             * @event
	             * Fires when logging in.
	             */
	            'app:login', this);
	
	            _app.events.register(
	            /**
	             * @event
	             * Fires when login succeeds.
	             */
	            'app:login:success', this);
	
	            _app.events.register(
	            /**
	             * @event
	             * Fires when the app logs out.
	             */
	            'app:logout', this);
	
	            _app.events.register(
	            /**
	             * Fires when route changes a new view has been loaded.
	             *
	             *     obj.on('app:view:change', callback);
	             *
	             * @event
	             */
	            'app:view:change', this);
	
	            _app.events.register(
	            /**
	             * Fires when client application's user changes the locale, thus
	             * indicating that the application should "re-render" itself.
	             *
	             *     obj.on('app:local:change', callback);
	             *
	             * @event
	             */
	            'app:locale:change', this);
	
	            _app.events.register(
	            /**
	             * Fires when the language display direction changes.
	             *
	             * Possible language display directions are `RTL` and `LTR`.
	             *
	             *
	             *     obj.on('lang:direction:change', callback);
	             *
	             * @event
	             */
	            'lang:direction:change', this);
	
	            // App cache must be inited first
	            if (_app.cache) {
	                _app.cache.init(this);
	            }
	
	            // Instantiate controller: <Capitalized-appId>Controller or Controller.
	            var className = _app.utils.capitalize(_app.config ? _app.config.appId : '') + 'Controller';
	            var Klass = this[className] || this.Controller;
	
	            /**
	             * Reference to the main controller.
	             *
	             * @property {Core.Controller}
	             */
	            this.controller = new Klass();
	
	            /**
	             * Reference to the API interface that the application uses to
	             * request the server.
	             *
	             * @property {SUGAR.Api}
	             */
	            _app.api = SUGAR.Api.getInstance({
	                defaultErrorHandler: opts && opts.defaultErrorHandler ? opts.defaultErrorHandler : SUGAR.App.error.handleHttpError,
	                serverUrl: _app.config.serverUrl,
	                platform: _app.config.platform,
	                timeout: _app.config.serverTimeout,
	                keyValueStore: _app[_app.config.authStore || 'cache'],
	                clientID: _app.config.clientID,
	                disableBulkApi: _app.config.disableBulkApi,
	                externalLoginUICallback: opts && opts.externalLoginUICallback
	            });
	
	            this._init(opts);
	
	            return _app;
	        },
	
	        /**
	         * Initializes application.
	         *
	         * Performs loading css (only if `config.loadCss` is `true`), metadata
	         * sync and calls sync callback.
	         *
	         * @param {Object} opts Options.
	         * @param {boolean} [opts.silent=false] Flag to indicate if modules
	         *   should be initialized during application init process.
	         * @private
	         * @chainable
	         */
	        _init: function _init(opts) {
	            var self = this;
	            var syncCallback = function syncCallback(error) {
	
	                // _app will be nulled out if destroy was called on app before we
	                // asynchronously get here. This happens when running tests (see spec-helper).
	                if (!_app) {
	                    return;
	                }
	                if (error) {
	                    self.trigger('app:sync:public:error', error);
	                    return;
	                }
	                self._initModules();
	                self._loadConfig();
	                if (!opts.silent) {
	                    _app.trigger('app:init', self);
	                }
	                if (opts.callback && _.isFunction(opts.callback)) {
	                    opts.callback(_app);
	                }
	            };
	            var cssCallback = function cssCallback(callback) {
	                if (_app.config.loadCss) {
	                    _app.loadCss(callback);
	                } else {
	                    callback();
	                }
	            };
	            if (_app.config.syncConfig !== false) {
	                var options = {
	                    getPublic: true
	                };
	                cssCallback(function () {
	                    _app.metadata.sync(syncCallback, options);
	                });
	            } else {
	                cssCallback(function () {
	                    syncCallback();
	                });
	            }
	            return _app;
	        },
	
	        /**
	         * Initializes all modules that have an `init` function.
	         *
	         * @private
	         */
	        _initModules: function _initModules() {
	            _.each(_modules, function (module) {
	                if (_.isFunction(module.init)) {
	                    module.init(this);
	                }
	            }, this);
	        },
	
	        /**
	         * Extends base settings with settings from the server.
	         *
	         * @private
	         */
	        _loadConfig: function _loadConfig() {
	            // extend our config with settings from local storage if we have it
	            _app.config = _app.config || {};
	            _app.config = _.extend(_app.config, _app.metadata.getConfig());
	        },
	
	        /**
	         * Loads application CSS.
	         *
	         * Will make an HTTP request and retrieve either a list of CSS files to
	         * load, or directly plain text css.
	         *
	         * @param {Function} [callback] Function called once CSS is loaded.
	         */
	        loadCss: function loadCss(callback) {
	
	            _app.api.css(_app.config.platform, _app.config.themeName, {
	                success: function success(rsp) {
	
	                    if (_app.config.loadCss === 'url') {
	                        _.each(rsp.url, function (url) {
	                            $('<link>').attr({
	                                rel: 'stylesheet',
	                                href: _app.utils.buildUrl(url)
	                            }).appendTo('head');
	                        });
	                    } else {
	                        _.each(rsp.text, function (text) {
	                            $('<style>').html(text).appendTo('head');
	                        });
	                    }
	
	                    if (_.isFunction(callback)) {
	                        callback();
	                    }
	                }
	            });
	        },
	
	        /**
	         * Starts the main execution phase of the application.
	         *
	         * Triggers {@link #event-app:start}.
	         *
	         * @method
	         */
	        start: function start() {
	            _app.events.registerAjaxEvents();
	            _app.trigger('app:start', this);
	            _app.routing.start();
	        },
	
	        /**
	         * Destroys the instance of the current app.
	         */
	        destroy: function destroy() {
	            // TODO: Not properly implemented
	            if (Backbone.history) {
	                Backbone.history.stop();
	            }
	
	            _app = null;
	        },
	
	        /**
	         * Augments the application with a module.
	         *
	         * Module should be an object with an optional `init(app)` function.
	         * The init function is passed the current instance of
	         * the application when app's {@link App#init} method gets called.
	         * Use the `init` function to perform custom initialization logic during
	         * app initialization.
	         *
	         * @param {string} name Name of the module.
	         * @param {Object} obj Module to augment the app with.
	         * @param {boolean} [init=false] Flag indicating if the module should be
	         *   initialized immediately.
	         */
	        augment: function augment(name, obj, init) {
	            this[name] = obj;
	            _modules[name] = obj;
	
	            if (init && obj.init && _.isFunction(obj.init)) {
	                obj.init.call(obj, _app);
	            }
	        },
	
	        /**
	         * Syncs an app.
	         *
	         * - {@link #event-app:sync} event is fired when the sync process
	         * begins.
	         * - {@link #event-app:sync:complete} event is fired when the series of
	         * sync operations have finished.
	         * - {@link #event-app:sync:error} is fired if it failed.
	         *
	         * The events are not fired if the sync happens for public metadata.
	         *
	         * @param {Object} [options] Options. See full list of options
	         *   you can pass to {@link Core.MetadataManager#sync}.
	         * @param {Function} [options.callback] Function to be invoked when the
	         *   sync operation completes.
	         * @param {boolean} [options.getPublic=false] Flag indicating if only
	         *   public metadata should be synced.
	         * @method
	         */
	        sync: function sync(options) {
	            var self = this;
	            options = options || {};
	
	            // For public call, we need to do just metadata sync without triggering events
	            if (options.getPublic) {
	                return self.syncPublic(options);
	            }
	
	            // Register the callback if any.
	            if (options.callback) {
	                _syncCallbacks.push(options.callback);
	            }
	
	            // If already in `sync`, we can skip as the callback is registered
	            // and will be called.
	            if (_isSyncing) {
	                return;
	            }
	            _isSyncing = true;
	
	            // 1. Update server info and run compatibility check
	            // 2. Update preferred language if it was changed
	            // 3. Load user preferences
	            // 4. Fetch metadata
	            // 5. Declare models
	            async.waterfall([function (callback) {
	                self.isSynced = false;
	                self.trigger('app:sync');
	                var doUpdateLanguage = !options.noUserUpdate && (options.language || _app.cache.get('langHasChanged'));
	                if (doUpdateLanguage) {
	                    var language = options.language || _app.lang.getLanguage();
	                    self.user.updateLanguage(language, callback);
	                    _app.cache.cut('langHasChanged');
	                } else {
	                    callback();
	                }
	            }, function (cbw) {
	                async.parallel([function (callback) {
	                    self.user.load(callback);
	                }, function (callback) {
	                    self.metadata.sync(function (err) {
	                        self.data.declareModels();
	                        callback(err);
	                    }, options);
	                }], function (err) {
	                    cbw(err);
	                });
	            }, function (callback) {
	                var serverInfo = self.metadata.getServerInfo();
	                self.config.sugarLogic = self.config.sugarLogic || {};
	
	                if (serverInfo && self.config.sugarLogic.enabled && self.utils.versionCompare(serverInfo.version, self.config.sugarLogic.minServerVersion, ">=")) {
	                    self.fetchSugarLogic(callback);
	                } else {
	                    self.config.sugarLogic.enabled = false;
	                    callback();
	                }
	            }], function (err) {
	                if (err) {
	                    self.trigger('app:sync:error', err);
	                } else {
	                    self.isSynced = true;
	                    self.trigger('app:sync:complete');
	                }
	
	                _.each(_syncCallbacks, function (callback) {
	                    callback(err);
	                });
	                // Reset the properties.
	                _isSyncing = false;
	                _syncCallbacks = [];
	            });
	        },
	
	        /**
	         * Syncs public metadata.
	         *
	         * @param {Object} [options] Options. See full list of options
	         *   you can pass to {@link Core.MetadataManager#sync}.
	         * @param {Function} [options.callback] Function to be invoked when the
	         *   sync operation completes.
	         */
	        syncPublic: function syncPublic(options) {
	            options = options || {};
	            options.getPublic = true;
	            this.metadata.sync(options.callback, options);
	        },
	
	        /**
	         * Navigates to a new route.
	         *
	         * @param {Core.Context} [context] Context object to extract the module
	         *   from.
	         * @param {Data.Bean} [model] Model object to route with.
	         * @param {string} [action] Action name.
	         */
	        navigate: function navigate(context, model, action) {
	            var route, id, module;
	            context = context || _app.controller.context;
	            model = model || context.get('model');
	            id = model.id;
	            module = context.get('module') || model.module;
	
	            route = this.router.buildRoute(module, id, action);
	            this.router.navigate(route, { trigger: true });
	        },
	
	        /**
	         * Logs in this app.
	         *
	         * Triggers {@link #event-app:login:success}.
	         *
	         * @param {Object} credentials User credentials.
	         * @param {Object} credentials.username User name.
	         * @param {Object} credentials.password User password.
	         * @param {Object} [info] Extra data to be passed in login request such
	         *   as client user agent, etc.
	         * @param {Object} [callbacks] Object containing the callbacks.
	         * @param {Function} [callbacks.success] The success callback.
	         * @param {Function} [callbacks.error] The error callback.
	         * @param {Function} [callbacks.complete] The complete callback.
	         */
	        login: function login(credentials, info, callbacks) {
	            callbacks = callbacks || {};
	
	            info = info || {};
	            info.current_language = _app.lang.getLanguage();
	            _app.api.login(credentials, info, {
	                success: function success(data) {
	                    _app.trigger('app:login:success', data, credentials.username);
	                    if (callbacks.success) callbacks.success(data);
	                },
	                error: function error(_error) {
	                    _app.error.handleHttpError(_error);
	                    if (callbacks.error) callbacks.error(_error);
	                },
	                complete: callbacks.complete
	            });
	        },
	
	        /**
	         * Logs out this app.
	         *
	         * Triggers {@link #event-app:logout}.
	         *
	         * @param {Object} [callbacks] Object containing the callbacks.
	         * @param {Function} [callbacks.success] The success callback.
	         * @param {Function} [callbacks.error] The error callback.
	         * @param {Function} [callbacks.complete] The complete callback.
	         * @param {Boolean} [clear=false] Flag indicating if user information
	         *   must be deleted from cache.
	         * @return {SUGAR.HttpRequest} XHR request object.
	         */
	        logout: function logout(callbacks, clear, options) {
	            var originalComplete, originalError;
	            callbacks = callbacks || {};
	            originalComplete = callbacks.complete;
	            originalError = callbacks.error;
	
	            callbacks.complete = function (data) {
	                // The 'clear' comes from the logout URL (see router.js)
	                _app.trigger('app:logout', clear);
	                if (originalComplete) {
	                    originalComplete(data);
	                }
	            };
	            callbacks.error = function (error) {
	                _app.error.handleHttpError(error);
	                if (originalError) originalError(error);
	            };
	
	            return _app.api.logout(callbacks, options);
	        },
	
	        fetchSugarLogic: function fetchSugarLogic(callback) {
	            if (_app.config.sugarLogic.isDynamic) {
	                _app.api.call('read', _app.api.buildURL('ExpressionEngine', 'functions'), null, {
	                    success: function success(expressions) {
	                        _app.cacheSugarLogicExpressions(expressions);
	                        _app.loadSugarLogic(expressions, callback);
	                    },
	                    error: function error(err) {
	                        // TODO: Consider turning off SL altogether
	                        callback(err);
	                    }
	                }, { dataType: 'application/text' });
	            } else callback();
	        },
	
	        cacheSugarLogicExpressions: function cacheSugarLogicExpressions(expressions) {
	            _app.cache.set("sugarlogic", expressions);
	        },
	
	        _loadSugarLogic: function _loadSugarLogic() {
	            return _app.cache.get("sugarlogic");
	        },
	
	        loadSugarLogic: function loadSugarLogic(expressions, callback) {
	            return _app.compileJs(expressions || _app._loadSugarLogic(), callback);
	        },
	
	        compileJs: function compileJs(js, callback) {
	            try {
	                eval.call(window, js); // jshint ignore:line
	                if (callback) callback();
	            } catch (e) {
	                _app.logger.fatal("Failed to compile js");
	                // TODO: Consider turning off SL altogether
	                if (callback) callback(e);
	                return e;
	            }
	
	            return null;
	        },
	
	        /**
	         * Checks if the server version and flavor are compatible.
	         * @param {Object} data Server information.
	         * @return {Boolean|Object} `true` if server is compatible and an error object if not.
	         */
	        isServerCompatible: function isServerCompatible(data) {
	            var flavors = this.config.supportedServerFlavors,
	                minVersion = this.config.minServerVersion,
	                isSupportedFlavor,
	                isSupportedVersion,
	                error;
	
	            // We assume the app is not interested in the compatibility check if it doesn't have compatibility config.
	            if (_.isEmpty(flavors) && !minVersion) {
	                return true;
	            }
	
	            // Undefined or null data with defined compatibility config means the server is incompatible
	
	            isSupportedFlavor = !!(_.isEmpty(flavors) || data && _.contains(flavors, data.flavor));
	            isSupportedVersion = !!(!minVersion || data && this.utils.versionCompare(data.version, minVersion, '>='));
	
	            if (isSupportedFlavor && isSupportedVersion) {
	                return true;
	            } else if (!isSupportedVersion) {
	                error = {
	                    code: 'server_version_incompatible',
	                    label: 'ERR_SERVER_VERSION_INCOMPATIBLE'
	                };
	            } else {
	                error = {
	                    code: 'server_flavor_incompatible',
	                    label: 'ERR_SERVER_FLAVOR_INCOMPATIBLE'
	                };
	            }
	
	            error.server_info = data;
	            return error;
	        },
	
	        modules: _modules
	    };
	}();
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = SUGAR;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(7))

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = "/*! jQuery v1.11.3 | (c) 2005, 2015 jQuery Foundation, Inc. | jquery.org/license */\n!function(a,b){\"object\"==typeof module&&\"object\"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error(\"jQuery requires a window with a document\");return b(a)}:b(a)}(\"undefined\"!=typeof window?window:this,function(a,b){var c=[],d=c.slice,e=c.concat,f=c.push,g=c.indexOf,h={},i=h.toString,j=h.hasOwnProperty,k={},l=\"1.11.3\",m=function(a,b){return new m.fn.init(a,b)},n=/^[\\s\\uFEFF\\xA0]+|[\\s\\uFEFF\\xA0]+$/g,o=/^-ms-/,p=/-([\\da-z])/gi,q=function(a,b){return b.toUpperCase()};m.fn=m.prototype={jquery:l,constructor:m,selector:\"\",length:0,toArray:function(){return d.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:d.call(this)},pushStack:function(a){var b=m.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a,b){return m.each(this,a,b)},map:function(a){return this.pushStack(m.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(d.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor(null)},push:f,sort:c.sort,splice:c.splice},m.extend=m.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for(\"boolean\"==typeof g&&(j=g,g=arguments[h]||{},h++),\"object\"==typeof g||m.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(e=arguments[h]))for(d in e)a=g[d],c=e[d],g!==c&&(j&&c&&(m.isPlainObject(c)||(b=m.isArray(c)))?(b?(b=!1,f=a&&m.isArray(a)?a:[]):f=a&&m.isPlainObject(a)?a:{},g[d]=m.extend(j,f,c)):void 0!==c&&(g[d]=c));return g},m.extend({expando:\"jQuery\"+(l+Math.random()).replace(/\\D/g,\"\"),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return\"function\"===m.type(a)},isArray:Array.isArray||function(a){return\"array\"===m.type(a)},isWindow:function(a){return null!=a&&a==a.window},isNumeric:function(a){return!m.isArray(a)&&a-parseFloat(a)+1>=0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},isPlainObject:function(a){var b;if(!a||\"object\"!==m.type(a)||a.nodeType||m.isWindow(a))return!1;try{if(a.constructor&&!j.call(a,\"constructor\")&&!j.call(a.constructor.prototype,\"isPrototypeOf\"))return!1}catch(c){return!1}if(k.ownLast)for(b in a)return j.call(a,b);for(b in a);return void 0===b||j.call(a,b)},type:function(a){return null==a?a+\"\":\"object\"==typeof a||\"function\"==typeof a?h[i.call(a)]||\"object\":typeof a},globalEval:function(b){b&&m.trim(b)&&(a.execScript||function(b){a.eval.call(a,b)})(b)},camelCase:function(a){return a.replace(o,\"ms-\").replace(p,q)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b,c){var d,e=0,f=a.length,g=r(a);if(c){if(g){for(;f>e;e++)if(d=b.apply(a[e],c),d===!1)break}else for(e in a)if(d=b.apply(a[e],c),d===!1)break}else if(g){for(;f>e;e++)if(d=b.call(a[e],e,a[e]),d===!1)break}else for(e in a)if(d=b.call(a[e],e,a[e]),d===!1)break;return a},trim:function(a){return null==a?\"\":(a+\"\").replace(n,\"\")},makeArray:function(a,b){var c=b||[];return null!=a&&(r(Object(a))?m.merge(c,\"string\"==typeof a?[a]:a):f.call(c,a)),c},inArray:function(a,b,c){var d;if(b){if(g)return g.call(b,a,c);for(d=b.length,c=c?0>c?Math.max(0,d+c):c:0;d>c;c++)if(c in b&&b[c]===a)return c}return-1},merge:function(a,b){var c=+b.length,d=0,e=a.length;while(c>d)a[e++]=b[d++];if(c!==c)while(void 0!==b[d])a[e++]=b[d++];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,f=0,g=a.length,h=r(a),i=[];if(h)for(;g>f;f++)d=b(a[f],f,c),null!=d&&i.push(d);else for(f in a)d=b(a[f],f,c),null!=d&&i.push(d);return e.apply([],i)},guid:1,proxy:function(a,b){var c,e,f;return\"string\"==typeof b&&(f=a[b],b=a,a=f),m.isFunction(a)?(c=d.call(arguments,2),e=function(){return a.apply(b||this,c.concat(d.call(arguments)))},e.guid=a.guid=a.guid||m.guid++,e):void 0},now:function(){return+new Date},support:k}),m.each(\"Boolean Number String Function Array Date RegExp Object Error\".split(\" \"),function(a,b){h[\"[object \"+b+\"]\"]=b.toLowerCase()});function r(a){var b=\"length\"in a&&a.length,c=m.type(a);return\"function\"===c||m.isWindow(a)?!1:1===a.nodeType&&b?!0:\"array\"===c||0===b||\"number\"==typeof b&&b>0&&b-1 in a}var s=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u=\"sizzle\"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K=\"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped\",L=\"[\\\\x20\\\\t\\\\r\\\\n\\\\f]\",M=\"(?:\\\\\\\\.|[\\\\w-]|[^\\\\x00-\\\\xa0])+\",N=M.replace(\"w\",\"w#\"),O=\"\\\\[\"+L+\"*(\"+M+\")(?:\"+L+\"*([*^$|!~]?=)\"+L+\"*(?:'((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\"|(\"+N+\"))|)\"+L+\"*\\\\]\",P=\":(\"+M+\")(?:\\\\((('((?:\\\\\\\\.|[^\\\\\\\\'])*)'|\\\"((?:\\\\\\\\.|[^\\\\\\\\\\\"])*)\\\")|((?:\\\\\\\\.|[^\\\\\\\\()[\\\\]]|\"+O+\")*)|.*)\\\\)|)\",Q=new RegExp(L+\"+\",\"g\"),R=new RegExp(\"^\"+L+\"+|((?:^|[^\\\\\\\\])(?:\\\\\\\\.)*)\"+L+\"+$\",\"g\"),S=new RegExp(\"^\"+L+\"*,\"+L+\"*\"),T=new RegExp(\"^\"+L+\"*([>+~]|\"+L+\")\"+L+\"*\"),U=new RegExp(\"=\"+L+\"*([^\\\\]'\\\"]*?)\"+L+\"*\\\\]\",\"g\"),V=new RegExp(P),W=new RegExp(\"^\"+N+\"$\"),X={ID:new RegExp(\"^#(\"+M+\")\"),CLASS:new RegExp(\"^\\\\.(\"+M+\")\"),TAG:new RegExp(\"^(\"+M.replace(\"w\",\"w*\")+\")\"),ATTR:new RegExp(\"^\"+O),PSEUDO:new RegExp(\"^\"+P),CHILD:new RegExp(\"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\\\(\"+L+\"*(even|odd|(([+-]|)(\\\\d*)n|)\"+L+\"*(?:([+-]|)\"+L+\"*(\\\\d+)|))\"+L+\"*\\\\)|)\",\"i\"),bool:new RegExp(\"^(?:\"+K+\")$\",\"i\"),needsContext:new RegExp(\"^\"+L+\"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\\\(\"+L+\"*((?:-\\\\d)?\\\\d*)\"+L+\"*\\\\)|)(?=[^-]|$)\",\"i\")},Y=/^(?:input|select|textarea|button)$/i,Z=/^h\\d$/i,$=/^[^{]+\\{\\s*\\[native \\w/,_=/^(?:#([\\w-]+)|(\\w+)|\\.([\\w-]+))$/,aa=/[+~]/,ba=/'|\\\\/g,ca=new RegExp(\"\\\\\\\\([\\\\da-f]{1,6}\"+L+\"?|(\"+L+\")|.)\",\"ig\"),da=function(a,b,c){var d=\"0x\"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ea=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(fa){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s,w,x;if((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,d=d||[],k=b.nodeType,\"string\"!=typeof a||!a||1!==k&&9!==k&&11!==k)return d;if(!e&&p){if(11!==k&&(f=_.exec(a)))if(j=f[1]){if(9===k){if(h=b.getElementById(j),!h||!h.parentNode)return d;if(h.id===j)return d.push(h),d}else if(b.ownerDocument&&(h=b.ownerDocument.getElementById(j))&&t(b,h)&&h.id===j)return d.push(h),d}else{if(f[2])return H.apply(d,b.getElementsByTagName(a)),d;if((j=f[3])&&c.getElementsByClassName)return H.apply(d,b.getElementsByClassName(j)),d}if(c.qsa&&(!q||!q.test(a))){if(s=r=u,w=b,x=1!==k&&a,1===k&&\"object\"!==b.nodeName.toLowerCase()){o=g(a),(r=b.getAttribute(\"id\"))?s=r.replace(ba,\"\\\\$&\"):b.setAttribute(\"id\",s),s=\"[id='\"+s+\"'] \",l=o.length;while(l--)o[l]=s+ra(o[l]);w=aa.test(a)&&pa(b.parentNode)||b,x=o.join(\",\")}if(x)try{return H.apply(d,w.querySelectorAll(x)),d}catch(y){}finally{r||b.removeAttribute(\"id\")}}}return i(a.replace(R,\"$1\"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+\" \")>d.cacheLength&&delete b[a.shift()],b[c+\" \"]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement(\"div\");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split(\"|\"),e=a.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return\"input\"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return(\"input\"===c||\"button\"===c)&&b.type===a}}function oa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function pa(a){return a&&\"undefined\"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?\"HTML\"!==b.nodeName:!1},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=g.documentElement,e=g.defaultView,e&&e!==e.top&&(e.addEventListener?e.addEventListener(\"unload\",ea,!1):e.attachEvent&&e.attachEvent(\"onunload\",ea)),p=!f(g),c.attributes=ja(function(a){return a.className=\"i\",!a.getAttribute(\"className\")}),c.getElementsByTagName=ja(function(a){return a.appendChild(g.createComment(\"\")),!a.getElementsByTagName(\"*\").length}),c.getElementsByClassName=$.test(g.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!g.getElementsByName||!g.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if(\"undefined\"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c&&c.parentNode?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){return a.getAttribute(\"id\")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){var c=\"undefined\"!=typeof a.getAttributeNode&&a.getAttributeNode(\"id\");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return\"undefined\"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if(\"*\"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=$.test(g.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML=\"<a id='\"+u+\"'></a><select id='\"+u+\"-\\f]' msallowcapture=''><option selected=''></option></select>\",a.querySelectorAll(\"[msallowcapture^='']\").length&&q.push(\"[*^$]=\"+L+\"*(?:''|\\\"\\\")\"),a.querySelectorAll(\"[selected]\").length||q.push(\"\\\\[\"+L+\"*(?:value|\"+K+\")\"),a.querySelectorAll(\"[id~=\"+u+\"-]\").length||q.push(\"~=\"),a.querySelectorAll(\":checked\").length||q.push(\":checked\"),a.querySelectorAll(\"a#\"+u+\"+*\").length||q.push(\".#.+[+~]\")}),ja(function(a){var b=g.createElement(\"input\");b.setAttribute(\"type\",\"hidden\"),a.appendChild(b).setAttribute(\"name\",\"D\"),a.querySelectorAll(\"[name=d]\").length&&q.push(\"name\"+L+\"*[*^$|!~]?=\"),a.querySelectorAll(\":enabled\").length||q.push(\":enabled\",\":disabled\"),a.querySelectorAll(\"*,:x\"),q.push(\",.*:\")})),(c.matchesSelector=$.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,\"div\"),s.call(a,\"[s!='']:x\"),r.push(\"!=\",P)}),q=q.length&&new RegExp(q.join(\"|\")),r=r.length&&new RegExp(r.join(\"|\")),b=$.test(o.compareDocumentPosition),t=b||$.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===g||a.ownerDocument===v&&t(v,a)?-1:b===g||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,h=[a],i=[b];if(!e||!f)return a===g?-1:b===g?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)h.unshift(c);c=b;while(c=c.parentNode)i.unshift(c);while(h[d]===i[d])d++;return d?la(h[d],i[d]):h[d]===v?-1:i[d]===v?1:0},g):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(U,\"='$1']\"),!(!c.matchesSelector||!p||r&&r.test(b)||q&&q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.error=function(a){throw new Error(\"Syntax error, unrecognized expression: \"+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c=\"\",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if(\"string\"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:X,attrHandle:{},find:{},relative:{\">\":{dir:\"parentNode\",first:!0},\" \":{dir:\"parentNode\"},\"+\":{dir:\"previousSibling\",first:!0},\"~\":{dir:\"previousSibling\"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ca,da),a[3]=(a[3]||a[4]||a[5]||\"\").replace(ca,da),\"~=\"===a[2]&&(a[3]=\" \"+a[3]+\" \"),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),\"nth\"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*(\"even\"===a[3]||\"odd\"===a[3])),a[5]=+(a[7]+a[8]||\"odd\"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return X.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||\"\":c&&V.test(c)&&(b=g(c,!0))&&(b=c.indexOf(\")\",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ca,da).toLowerCase();return\"*\"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+\" \"];return b||(b=new RegExp(\"(^|\"+L+\")\"+a+\"(\"+L+\"|$)\"))&&y(a,function(a){return b.test(\"string\"==typeof a.className&&a.className||\"undefined\"!=typeof a.getAttribute&&a.getAttribute(\"class\")||\"\")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?\"!=\"===b:b?(e+=\"\",\"=\"===b?e===c:\"!=\"===b?e!==c:\"^=\"===b?c&&0===e.indexOf(c):\"*=\"===b?c&&e.indexOf(c)>-1:\"$=\"===b?c&&e.slice(-c.length)===c:\"~=\"===b?(\" \"+e.replace(Q,\" \")+\" \").indexOf(c)>-1:\"|=\"===b?e===c||e.slice(0,c.length+1)===c+\"-\":!1):!0}},CHILD:function(a,b,c,d,e){var f=\"nth\"!==a.slice(0,3),g=\"last\"!==a.slice(-4),h=\"of-type\"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?\"nextSibling\":\"previousSibling\",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h;if(q){if(f){while(p){l=b;while(l=l[p])if(h?l.nodeName.toLowerCase()===r:1===l.nodeType)return!1;o=p=\"only\"===a&&!o&&\"nextSibling\"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){k=q[u]||(q[u]={}),j=k[a]||[],n=j[0]===w&&j[1],m=j[0]===w&&j[2],l=n&&q.childNodes[n];while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if(1===l.nodeType&&++m&&l===b){k[a]=[w,n,m];break}}else if(s&&(j=(b[u]||(b[u]={}))[a])&&j[0]===w)m=j[1];else while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if((h?l.nodeName.toLowerCase()===r:1===l.nodeType)&&++m&&(s&&((l[u]||(l[u]={}))[a]=[w,m]),l===b))break;return m-=e,m===d||m%d===0&&m/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error(\"unsupported pseudo: \"+a);return e[u]?e(b):e.length>1?(c=[a,a,\"\",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(R,\"$1\"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(ca,da),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return W.test(a||\"\")||ga.error(\"unsupported lang: \"+a),a=a.replace(ca,da).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute(\"xml:lang\")||b.getAttribute(\"lang\"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+\"-\");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return\"input\"===b&&!!a.checked||\"option\"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Z.test(a.nodeName)},input:function(a){return Y.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return\"input\"===b&&\"button\"===a.type||\"button\"===b},text:function(a){var b;return\"input\"===a.nodeName.toLowerCase()&&\"text\"===a.type&&(null==(b=a.getAttribute(\"type\"))||\"text\"===b.toLowerCase())},first:oa(function(){return[0]}),last:oa(function(a,b){return[b-1]}),eq:oa(function(a,b,c){return[0>c?c+b:c]}),even:oa(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:oa(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:oa(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:oa(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function qa(){}qa.prototype=d.filters=d.pseudos,d.setFilters=new qa,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+\" \"];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=S.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=T.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(R,\" \")}),h=h.slice(c.length));for(g in d.filter)!(e=X[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function ra(a){for(var b=0,c=a.length,d=\"\";c>b;b++)d+=a[b].value;return d}function sa(a,b,c){var d=b.dir,e=c&&\"parentNode\"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(i=b[u]||(b[u]={}),(h=i[d])&&h[0]===w&&h[1]===f)return j[2]=h[2];if(i[d]=j,j[2]=a(b,c,g))return!0}}}function ta(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ua(a,b,c){for(var d=0,e=b.length;e>d;d++)ga(a,b[d],c);return c}function va(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function wa(a,b,c,d,e,f){return d&&!d[u]&&(d=wa(d)),e&&!e[u]&&(e=wa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ua(b||\"*\",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:va(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=va(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=va(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function xa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[\" \"],i=g?1:0,k=sa(function(a){return a===b},h,!0),l=sa(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[sa(ta(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return wa(i>1&&ta(m),i>1&&ra(a.slice(0,i-1).concat({value:\" \"===a[i-2].type?\"*\":\"\"})).replace(R,\"$1\"),c,e>i&&xa(a.slice(i,e)),f>e&&xa(a=a.slice(e)),f>e&&ra(a))}m.push(c)}return ta(m)}function ya(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,m,o,p=0,q=\"0\",r=f&&[],s=[],t=j,u=f||e&&d.find.TAG(\"*\",k),v=w+=null==t?1:Math.random()||.1,x=u.length;for(k&&(j=g!==n&&g);q!==x&&null!=(l=u[q]);q++){if(e&&l){m=0;while(o=a[m++])if(o(l,g,h)){i.push(l);break}k&&(w=v)}c&&((l=!o&&l)&&p--,f&&r.push(l))}if(p+=q,c&&q!==p){m=0;while(o=b[m++])o(r,s,g,h);if(f){if(p>0)while(q--)r[q]||s[q]||(s[q]=F.call(i));s=va(s)}H.apply(i,s),k&&!f&&s.length>0&&p+b.length>1&&ga.uniqueSort(i)}return k&&(w=v,j=t),r};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+\" \"];if(!f){b||(b=g(a)),c=b.length;while(c--)f=xa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,ya(e,d)),f.selector=a}return f},i=ga.select=function(a,b,e,f){var i,j,k,l,m,n=\"function\"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&\"ID\"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ca,da),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=X.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ca,da),aa.test(j[0].type)&&pa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&ra(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,aa.test(a)&&pa(b.parentNode)||b),e},c.sortStable=u.split(\"\").sort(B).join(\"\")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement(\"div\"))}),ja(function(a){return a.innerHTML=\"<a href='#'></a>\",\"#\"===a.firstChild.getAttribute(\"href\")})||ka(\"type|href|height|width\",function(a,b,c){return c?void 0:a.getAttribute(b,\"type\"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML=\"<input/>\",a.firstChild.setAttribute(\"value\",\"\"),\"\"===a.firstChild.getAttribute(\"value\")})||ka(\"value\",function(a,b,c){return c||\"input\"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ja(function(a){return null==a.getAttribute(\"disabled\")})||ka(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);m.find=s,m.expr=s.selectors,m.expr[\":\"]=m.expr.pseudos,m.unique=s.uniqueSort,m.text=s.getText,m.isXMLDoc=s.isXML,m.contains=s.contains;var t=m.expr.match.needsContext,u=/^<(\\w+)\\s*\\/?>(?:<\\/\\1>|)$/,v=/^.[^:#\\[\\.,]*$/;function w(a,b,c){if(m.isFunction(b))return m.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return m.grep(a,function(a){return a===b!==c});if(\"string\"==typeof b){if(v.test(b))return m.filter(b,a,c);b=m.filter(b,a)}return m.grep(a,function(a){return m.inArray(a,b)>=0!==c})}m.filter=function(a,b,c){var d=b[0];return c&&(a=\":not(\"+a+\")\"),1===b.length&&1===d.nodeType?m.find.matchesSelector(d,a)?[d]:[]:m.find.matches(a,m.grep(b,function(a){return 1===a.nodeType}))},m.fn.extend({find:function(a){var b,c=[],d=this,e=d.length;if(\"string\"!=typeof a)return this.pushStack(m(a).filter(function(){for(b=0;e>b;b++)if(m.contains(d[b],this))return!0}));for(b=0;e>b;b++)m.find(a,d[b],c);return c=this.pushStack(e>1?m.unique(c):c),c.selector=this.selector?this.selector+\" \"+a:a,c},filter:function(a){return this.pushStack(w(this,a||[],!1))},not:function(a){return this.pushStack(w(this,a||[],!0))},is:function(a){return!!w(this,\"string\"==typeof a&&t.test(a)?m(a):a||[],!1).length}});var x,y=a.document,z=/^(?:\\s*(<[\\w\\W]+>)[^>]*|#([\\w-]*))$/,A=m.fn.init=function(a,b){var c,d;if(!a)return this;if(\"string\"==typeof a){if(c=\"<\"===a.charAt(0)&&\">\"===a.charAt(a.length-1)&&a.length>=3?[null,a,null]:z.exec(a),!c||!c[1]&&b)return!b||b.jquery?(b||x).find(a):this.constructor(b).find(a);if(c[1]){if(b=b instanceof m?b[0]:b,m.merge(this,m.parseHTML(c[1],b&&b.nodeType?b.ownerDocument||b:y,!0)),u.test(c[1])&&m.isPlainObject(b))for(c in b)m.isFunction(this[c])?this[c](b[c]):this.attr(c,b[c]);return this}if(d=y.getElementById(c[2]),d&&d.parentNode){if(d.id!==c[2])return x.find(a);this.length=1,this[0]=d}return this.context=y,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):m.isFunction(a)?\"undefined\"!=typeof x.ready?x.ready(a):a(m):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),m.makeArray(a,this))};A.prototype=m.fn,x=m(y);var B=/^(?:parents|prev(?:Until|All))/,C={children:!0,contents:!0,next:!0,prev:!0};m.extend({dir:function(a,b,c){var d=[],e=a[b];while(e&&9!==e.nodeType&&(void 0===c||1!==e.nodeType||!m(e).is(c)))1===e.nodeType&&d.push(e),e=e[b];return d},sibling:function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c}}),m.fn.extend({has:function(a){var b,c=m(a,this),d=c.length;return this.filter(function(){for(b=0;d>b;b++)if(m.contains(this,c[b]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=t.test(a)||\"string\"!=typeof a?m(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&m.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?m.unique(f):f)},index:function(a){return a?\"string\"==typeof a?m.inArray(this[0],m(a)):m.inArray(a.jquery?a[0]:a,this):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(m.unique(m.merge(this.get(),m(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function D(a,b){do a=a[b];while(a&&1!==a.nodeType);return a}m.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return m.dir(a,\"parentNode\")},parentsUntil:function(a,b,c){return m.dir(a,\"parentNode\",c)},next:function(a){return D(a,\"nextSibling\")},prev:function(a){return D(a,\"previousSibling\")},nextAll:function(a){return m.dir(a,\"nextSibling\")},prevAll:function(a){return m.dir(a,\"previousSibling\")},nextUntil:function(a,b,c){return m.dir(a,\"nextSibling\",c)},prevUntil:function(a,b,c){return m.dir(a,\"previousSibling\",c)},siblings:function(a){return m.sibling((a.parentNode||{}).firstChild,a)},children:function(a){return m.sibling(a.firstChild)},contents:function(a){return m.nodeName(a,\"iframe\")?a.contentDocument||a.contentWindow.document:m.merge([],a.childNodes)}},function(a,b){m.fn[a]=function(c,d){var e=m.map(this,b,c);return\"Until\"!==a.slice(-5)&&(d=c),d&&\"string\"==typeof d&&(e=m.filter(d,e)),this.length>1&&(C[a]||(e=m.unique(e)),B.test(a)&&(e=e.reverse())),this.pushStack(e)}});var E=/\\S+/g,F={};function G(a){var b=F[a]={};return m.each(a.match(E)||[],function(a,c){b[c]=!0}),b}m.Callbacks=function(a){a=\"string\"==typeof a?F[a]||G(a):m.extend({},a);var b,c,d,e,f,g,h=[],i=!a.once&&[],j=function(l){for(c=a.memory&&l,d=!0,f=g||0,g=0,e=h.length,b=!0;h&&e>f;f++)if(h[f].apply(l[0],l[1])===!1&&a.stopOnFalse){c=!1;break}b=!1,h&&(i?i.length&&j(i.shift()):c?h=[]:k.disable())},k={add:function(){if(h){var d=h.length;!function f(b){m.each(b,function(b,c){var d=m.type(c);\"function\"===d?a.unique&&k.has(c)||h.push(c):c&&c.length&&\"string\"!==d&&f(c)})}(arguments),b?e=h.length:c&&(g=d,j(c))}return this},remove:function(){return h&&m.each(arguments,function(a,c){var d;while((d=m.inArray(c,h,d))>-1)h.splice(d,1),b&&(e>=d&&e--,f>=d&&f--)}),this},has:function(a){return a?m.inArray(a,h)>-1:!(!h||!h.length)},empty:function(){return h=[],e=0,this},disable:function(){return h=i=c=void 0,this},disabled:function(){return!h},lock:function(){return i=void 0,c||k.disable(),this},locked:function(){return!i},fireWith:function(a,c){return!h||d&&!i||(c=c||[],c=[a,c.slice?c.slice():c],b?i.push(c):j(c)),this},fire:function(){return k.fireWith(this,arguments),this},fired:function(){return!!d}};return k},m.extend({Deferred:function(a){var b=[[\"resolve\",\"done\",m.Callbacks(\"once memory\"),\"resolved\"],[\"reject\",\"fail\",m.Callbacks(\"once memory\"),\"rejected\"],[\"notify\",\"progress\",m.Callbacks(\"memory\")]],c=\"pending\",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return m.Deferred(function(c){m.each(b,function(b,f){var g=m.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&m.isFunction(a.promise)?a.promise().done(c.resolve).fail(c.reject).progress(c.notify):c[f[0]+\"With\"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?m.extend(a,d):d}},e={};return d.pipe=d.then,m.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+\"With\"](this===e?d:this,arguments),this},e[f[0]+\"With\"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=d.call(arguments),e=c.length,f=1!==e||a&&m.isFunction(a.promise)?e:0,g=1===f?a:m.Deferred(),h=function(a,b,c){return function(e){b[a]=this,c[a]=arguments.length>1?d.call(arguments):e,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(e>1)for(i=new Array(e),j=new Array(e),k=new Array(e);e>b;b++)c[b]&&m.isFunction(c[b].promise)?c[b].promise().done(h(b,k,c)).fail(g.reject).progress(h(b,j,i)):--f;return f||g.resolveWith(k,c),g.promise()}});var H;m.fn.ready=function(a){return m.ready.promise().done(a),this},m.extend({isReady:!1,readyWait:1,holdReady:function(a){a?m.readyWait++:m.ready(!0)},ready:function(a){if(a===!0?!--m.readyWait:!m.isReady){if(!y.body)return setTimeout(m.ready);m.isReady=!0,a!==!0&&--m.readyWait>0||(H.resolveWith(y,[m]),m.fn.triggerHandler&&(m(y).triggerHandler(\"ready\"),m(y).off(\"ready\")))}}});function I(){y.addEventListener?(y.removeEventListener(\"DOMContentLoaded\",J,!1),a.removeEventListener(\"load\",J,!1)):(y.detachEvent(\"onreadystatechange\",J),a.detachEvent(\"onload\",J))}function J(){(y.addEventListener||\"load\"===event.type||\"complete\"===y.readyState)&&(I(),m.ready())}m.ready.promise=function(b){if(!H)if(H=m.Deferred(),\"complete\"===y.readyState)setTimeout(m.ready);else if(y.addEventListener)y.addEventListener(\"DOMContentLoaded\",J,!1),a.addEventListener(\"load\",J,!1);else{y.attachEvent(\"onreadystatechange\",J),a.attachEvent(\"onload\",J);var c=!1;try{c=null==a.frameElement&&y.documentElement}catch(d){}c&&c.doScroll&&!function e(){if(!m.isReady){try{c.doScroll(\"left\")}catch(a){return setTimeout(e,50)}I(),m.ready()}}()}return H.promise(b)};var K=\"undefined\",L;for(L in m(k))break;k.ownLast=\"0\"!==L,k.inlineBlockNeedsLayout=!1,m(function(){var a,b,c,d;c=y.getElementsByTagName(\"body\")[0],c&&c.style&&(b=y.createElement(\"div\"),d=y.createElement(\"div\"),d.style.cssText=\"position:absolute;border:0;width:0;height:0;top:0;left:-9999px\",c.appendChild(d).appendChild(b),typeof b.style.zoom!==K&&(b.style.cssText=\"display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1\",k.inlineBlockNeedsLayout=a=3===b.offsetWidth,a&&(c.style.zoom=1)),c.removeChild(d))}),function(){var a=y.createElement(\"div\");if(null==k.deleteExpando){k.deleteExpando=!0;try{delete a.test}catch(b){k.deleteExpando=!1}}a=null}(),m.acceptData=function(a){var b=m.noData[(a.nodeName+\" \").toLowerCase()],c=+a.nodeType||1;return 1!==c&&9!==c?!1:!b||b!==!0&&a.getAttribute(\"classid\")===b};var M=/^(?:\\{[\\w\\W]*\\}|\\[[\\w\\W]*\\])$/,N=/([A-Z])/g;function O(a,b,c){if(void 0===c&&1===a.nodeType){var d=\"data-\"+b.replace(N,\"-$1\").toLowerCase();if(c=a.getAttribute(d),\"string\"==typeof c){try{c=\"true\"===c?!0:\"false\"===c?!1:\"null\"===c?null:+c+\"\"===c?+c:M.test(c)?m.parseJSON(c):c}catch(e){}m.data(a,b,c)}else c=void 0}return c}function P(a){var b;for(b in a)if((\"data\"!==b||!m.isEmptyObject(a[b]))&&\"toJSON\"!==b)return!1;\n\nreturn!0}function Q(a,b,d,e){if(m.acceptData(a)){var f,g,h=m.expando,i=a.nodeType,j=i?m.cache:a,k=i?a[h]:a[h]&&h;if(k&&j[k]&&(e||j[k].data)||void 0!==d||\"string\"!=typeof b)return k||(k=i?a[h]=c.pop()||m.guid++:h),j[k]||(j[k]=i?{}:{toJSON:m.noop}),(\"object\"==typeof b||\"function\"==typeof b)&&(e?j[k]=m.extend(j[k],b):j[k].data=m.extend(j[k].data,b)),g=j[k],e||(g.data||(g.data={}),g=g.data),void 0!==d&&(g[m.camelCase(b)]=d),\"string\"==typeof b?(f=g[b],null==f&&(f=g[m.camelCase(b)])):f=g,f}}function R(a,b,c){if(m.acceptData(a)){var d,e,f=a.nodeType,g=f?m.cache:a,h=f?a[m.expando]:m.expando;if(g[h]){if(b&&(d=c?g[h]:g[h].data)){m.isArray(b)?b=b.concat(m.map(b,m.camelCase)):b in d?b=[b]:(b=m.camelCase(b),b=b in d?[b]:b.split(\" \")),e=b.length;while(e--)delete d[b[e]];if(c?!P(d):!m.isEmptyObject(d))return}(c||(delete g[h].data,P(g[h])))&&(f?m.cleanData([a],!0):k.deleteExpando||g!=g.window?delete g[h]:g[h]=null)}}}m.extend({cache:{},noData:{\"applet \":!0,\"embed \":!0,\"object \":\"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000\"},hasData:function(a){return a=a.nodeType?m.cache[a[m.expando]]:a[m.expando],!!a&&!P(a)},data:function(a,b,c){return Q(a,b,c)},removeData:function(a,b){return R(a,b)},_data:function(a,b,c){return Q(a,b,c,!0)},_removeData:function(a,b){return R(a,b,!0)}}),m.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=m.data(f),1===f.nodeType&&!m._data(f,\"parsedAttrs\"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf(\"data-\")&&(d=m.camelCase(d.slice(5)),O(f,d,e[d])));m._data(f,\"parsedAttrs\",!0)}return e}return\"object\"==typeof a?this.each(function(){m.data(this,a)}):arguments.length>1?this.each(function(){m.data(this,a,b)}):f?O(f,a,m.data(f,a)):void 0},removeData:function(a){return this.each(function(){m.removeData(this,a)})}}),m.extend({queue:function(a,b,c){var d;return a?(b=(b||\"fx\")+\"queue\",d=m._data(a,b),c&&(!d||m.isArray(c)?d=m._data(a,b,m.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||\"fx\";var c=m.queue(a,b),d=c.length,e=c.shift(),f=m._queueHooks(a,b),g=function(){m.dequeue(a,b)};\"inprogress\"===e&&(e=c.shift(),d--),e&&(\"fx\"===b&&c.unshift(\"inprogress\"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+\"queueHooks\";return m._data(a,c)||m._data(a,c,{empty:m.Callbacks(\"once memory\").add(function(){m._removeData(a,b+\"queue\"),m._removeData(a,c)})})}}),m.fn.extend({queue:function(a,b){var c=2;return\"string\"!=typeof a&&(b=a,a=\"fx\",c--),arguments.length<c?m.queue(this[0],a):void 0===b?this:this.each(function(){var c=m.queue(this,a,b);m._queueHooks(this,a),\"fx\"===a&&\"inprogress\"!==c[0]&&m.dequeue(this,a)})},dequeue:function(a){return this.each(function(){m.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||\"fx\",[])},promise:function(a,b){var c,d=1,e=m.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};\"string\"!=typeof a&&(b=a,a=void 0),a=a||\"fx\";while(g--)c=m._data(f[g],a+\"queueHooks\"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var S=/[+-]?(?:\\d*\\.|)\\d+(?:[eE][+-]?\\d+|)/.source,T=[\"Top\",\"Right\",\"Bottom\",\"Left\"],U=function(a,b){return a=b||a,\"none\"===m.css(a,\"display\")||!m.contains(a.ownerDocument,a)},V=m.access=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if(\"object\"===m.type(c)){e=!0;for(h in c)m.access(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,m.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(m(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},W=/^(?:checkbox|radio)$/i;!function(){var a=y.createElement(\"input\"),b=y.createElement(\"div\"),c=y.createDocumentFragment();if(b.innerHTML=\"  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>\",k.leadingWhitespace=3===b.firstChild.nodeType,k.tbody=!b.getElementsByTagName(\"tbody\").length,k.htmlSerialize=!!b.getElementsByTagName(\"link\").length,k.html5Clone=\"<:nav></:nav>\"!==y.createElement(\"nav\").cloneNode(!0).outerHTML,a.type=\"checkbox\",a.checked=!0,c.appendChild(a),k.appendChecked=a.checked,b.innerHTML=\"<textarea>x</textarea>\",k.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue,c.appendChild(b),b.innerHTML=\"<input type='radio' checked='checked' name='t'/>\",k.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,k.noCloneEvent=!0,b.attachEvent&&(b.attachEvent(\"onclick\",function(){k.noCloneEvent=!1}),b.cloneNode(!0).click()),null==k.deleteExpando){k.deleteExpando=!0;try{delete b.test}catch(d){k.deleteExpando=!1}}}(),function(){var b,c,d=y.createElement(\"div\");for(b in{submit:!0,change:!0,focusin:!0})c=\"on\"+b,(k[b+\"Bubbles\"]=c in a)||(d.setAttribute(c,\"t\"),k[b+\"Bubbles\"]=d.attributes[c].expando===!1);d=null}();var X=/^(?:input|select|textarea)$/i,Y=/^key/,Z=/^(?:mouse|pointer|contextmenu)|click/,$=/^(?:focusinfocus|focusoutblur)$/,_=/^([^.]*)(?:\\.(.+)|)$/;function aa(){return!0}function ba(){return!1}function ca(){try{return y.activeElement}catch(a){}}m.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,n,o,p,q,r=m._data(a);if(r){c.handler&&(i=c,c=i.handler,e=i.selector),c.guid||(c.guid=m.guid++),(g=r.events)||(g=r.events={}),(k=r.handle)||(k=r.handle=function(a){return typeof m===K||a&&m.event.triggered===a.type?void 0:m.event.dispatch.apply(k.elem,arguments)},k.elem=a),b=(b||\"\").match(E)||[\"\"],h=b.length;while(h--)f=_.exec(b[h])||[],o=q=f[1],p=(f[2]||\"\").split(\".\").sort(),o&&(j=m.event.special[o]||{},o=(e?j.delegateType:j.bindType)||o,j=m.event.special[o]||{},l=m.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&m.expr.match.needsContext.test(e),namespace:p.join(\".\")},i),(n=g[o])||(n=g[o]=[],n.delegateCount=0,j.setup&&j.setup.call(a,d,p,k)!==!1||(a.addEventListener?a.addEventListener(o,k,!1):a.attachEvent&&a.attachEvent(\"on\"+o,k))),j.add&&(j.add.call(a,l),l.handler.guid||(l.handler.guid=c.guid)),e?n.splice(n.delegateCount++,0,l):n.push(l),m.event.global[o]=!0);a=null}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,n,o,p,q,r=m.hasData(a)&&m._data(a);if(r&&(k=r.events)){b=(b||\"\").match(E)||[\"\"],j=b.length;while(j--)if(h=_.exec(b[j])||[],o=q=h[1],p=(h[2]||\"\").split(\".\").sort(),o){l=m.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,n=k[o]||[],h=h[2]&&new RegExp(\"(^|\\\\.)\"+p.join(\"\\\\.(?:.*\\\\.|)\")+\"(\\\\.|$)\"),i=f=n.length;while(f--)g=n[f],!e&&q!==g.origType||c&&c.guid!==g.guid||h&&!h.test(g.namespace)||d&&d!==g.selector&&(\"**\"!==d||!g.selector)||(n.splice(f,1),g.selector&&n.delegateCount--,l.remove&&l.remove.call(a,g));i&&!n.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||m.removeEvent(a,o,r.handle),delete k[o])}else for(o in k)m.event.remove(a,o+b[j],c,d,!0);m.isEmptyObject(k)&&(delete r.handle,m._removeData(a,\"events\"))}},trigger:function(b,c,d,e){var f,g,h,i,k,l,n,o=[d||y],p=j.call(b,\"type\")?b.type:b,q=j.call(b,\"namespace\")?b.namespace.split(\".\"):[];if(h=l=d=d||y,3!==d.nodeType&&8!==d.nodeType&&!$.test(p+m.event.triggered)&&(p.indexOf(\".\")>=0&&(q=p.split(\".\"),p=q.shift(),q.sort()),g=p.indexOf(\":\")<0&&\"on\"+p,b=b[m.expando]?b:new m.Event(p,\"object\"==typeof b&&b),b.isTrigger=e?2:3,b.namespace=q.join(\".\"),b.namespace_re=b.namespace?new RegExp(\"(^|\\\\.)\"+q.join(\"\\\\.(?:.*\\\\.|)\")+\"(\\\\.|$)\"):null,b.result=void 0,b.target||(b.target=d),c=null==c?[b]:m.makeArray(c,[b]),k=m.event.special[p]||{},e||!k.trigger||k.trigger.apply(d,c)!==!1)){if(!e&&!k.noBubble&&!m.isWindow(d)){for(i=k.delegateType||p,$.test(i+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),l=h;l===(d.ownerDocument||y)&&o.push(l.defaultView||l.parentWindow||a)}n=0;while((h=o[n++])&&!b.isPropagationStopped())b.type=n>1?i:k.bindType||p,f=(m._data(h,\"events\")||{})[b.type]&&m._data(h,\"handle\"),f&&f.apply(h,c),f=g&&h[g],f&&f.apply&&m.acceptData(h)&&(b.result=f.apply(h,c),b.result===!1&&b.preventDefault());if(b.type=p,!e&&!b.isDefaultPrevented()&&(!k._default||k._default.apply(o.pop(),c)===!1)&&m.acceptData(d)&&g&&d[p]&&!m.isWindow(d)){l=d[g],l&&(d[g]=null),m.event.triggered=p;try{d[p]()}catch(r){}m.event.triggered=void 0,l&&(d[g]=l)}return b.result}},dispatch:function(a){a=m.event.fix(a);var b,c,e,f,g,h=[],i=d.call(arguments),j=(m._data(this,\"events\")||{})[a.type]||[],k=m.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=m.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,g=0;while((e=f.handlers[g++])&&!a.isImmediatePropagationStopped())(!a.namespace_re||a.namespace_re.test(e.namespace))&&(a.handleObj=e,a.data=e.data,c=((m.event.special[e.origType]||{}).handle||e.handler).apply(f.elem,i),void 0!==c&&(a.result=c)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&(!a.button||\"click\"!==a.type))for(;i!=this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||\"click\"!==a.type)){for(e=[],f=0;h>f;f++)d=b[f],c=d.selector+\" \",void 0===e[c]&&(e[c]=d.needsContext?m(c,this).index(i)>=0:m.find(c,this,null,[i]).length),e[c]&&e.push(d);e.length&&g.push({elem:i,handlers:e})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},fix:function(a){if(a[m.expando])return a;var b,c,d,e=a.type,f=a,g=this.fixHooks[e];g||(this.fixHooks[e]=g=Z.test(e)?this.mouseHooks:Y.test(e)?this.keyHooks:{}),d=g.props?this.props.concat(g.props):this.props,a=new m.Event(f),b=d.length;while(b--)c=d[b],a[c]=f[c];return a.target||(a.target=f.srcElement||y),3===a.target.nodeType&&(a.target=a.target.parentNode),a.metaKey=!!a.metaKey,g.filter?g.filter(a,f):a},props:\"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which\".split(\" \"),fixHooks:{},keyHooks:{props:\"char charCode key keyCode\".split(\" \"),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:\"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement\".split(\" \"),filter:function(a,b){var c,d,e,f=b.button,g=b.fromElement;return null==a.pageX&&null!=b.clientX&&(d=a.target.ownerDocument||y,e=d.documentElement,c=d.body,a.pageX=b.clientX+(e&&e.scrollLeft||c&&c.scrollLeft||0)-(e&&e.clientLeft||c&&c.clientLeft||0),a.pageY=b.clientY+(e&&e.scrollTop||c&&c.scrollTop||0)-(e&&e.clientTop||c&&c.clientTop||0)),!a.relatedTarget&&g&&(a.relatedTarget=g===a.target?b.toElement:g),a.which||void 0===f||(a.which=1&f?1:2&f?3:4&f?2:0),a}},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==ca()&&this.focus)try{return this.focus(),!1}catch(a){}},delegateType:\"focusin\"},blur:{trigger:function(){return this===ca()&&this.blur?(this.blur(),!1):void 0},delegateType:\"focusout\"},click:{trigger:function(){return m.nodeName(this,\"input\")&&\"checkbox\"===this.type&&this.click?(this.click(),!1):void 0},_default:function(a){return m.nodeName(a.target,\"a\")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c,d){var e=m.extend(new m.Event,c,{type:a,isSimulated:!0,originalEvent:{}});d?m.event.trigger(e,null,b):m.event.dispatch.call(b,e),e.isDefaultPrevented()&&c.preventDefault()}},m.removeEvent=y.removeEventListener?function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c,!1)}:function(a,b,c){var d=\"on\"+b;a.detachEvent&&(typeof a[d]===K&&(a[d]=null),a.detachEvent(d,c))},m.Event=function(a,b){return this instanceof m.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?aa:ba):this.type=a,b&&m.extend(this,b),this.timeStamp=a&&a.timeStamp||m.now(),void(this[m.expando]=!0)):new m.Event(a,b)},m.Event.prototype={isDefaultPrevented:ba,isPropagationStopped:ba,isImmediatePropagationStopped:ba,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=aa,a&&(a.preventDefault?a.preventDefault():a.returnValue=!1)},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=aa,a&&(a.stopPropagation&&a.stopPropagation(),a.cancelBubble=!0)},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=aa,a&&a.stopImmediatePropagation&&a.stopImmediatePropagation(),this.stopPropagation()}},m.each({mouseenter:\"mouseover\",mouseleave:\"mouseout\",pointerenter:\"pointerover\",pointerleave:\"pointerout\"},function(a,b){m.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!m.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),k.submitBubbles||(m.event.special.submit={setup:function(){return m.nodeName(this,\"form\")?!1:void m.event.add(this,\"click._submit keypress._submit\",function(a){var b=a.target,c=m.nodeName(b,\"input\")||m.nodeName(b,\"button\")?b.form:void 0;c&&!m._data(c,\"submitBubbles\")&&(m.event.add(c,\"submit._submit\",function(a){a._submit_bubble=!0}),m._data(c,\"submitBubbles\",!0))})},postDispatch:function(a){a._submit_bubble&&(delete a._submit_bubble,this.parentNode&&!a.isTrigger&&m.event.simulate(\"submit\",this.parentNode,a,!0))},teardown:function(){return m.nodeName(this,\"form\")?!1:void m.event.remove(this,\"._submit\")}}),k.changeBubbles||(m.event.special.change={setup:function(){return X.test(this.nodeName)?((\"checkbox\"===this.type||\"radio\"===this.type)&&(m.event.add(this,\"propertychange._change\",function(a){\"checked\"===a.originalEvent.propertyName&&(this._just_changed=!0)}),m.event.add(this,\"click._change\",function(a){this._just_changed&&!a.isTrigger&&(this._just_changed=!1),m.event.simulate(\"change\",this,a,!0)})),!1):void m.event.add(this,\"beforeactivate._change\",function(a){var b=a.target;X.test(b.nodeName)&&!m._data(b,\"changeBubbles\")&&(m.event.add(b,\"change._change\",function(a){!this.parentNode||a.isSimulated||a.isTrigger||m.event.simulate(\"change\",this.parentNode,a,!0)}),m._data(b,\"changeBubbles\",!0))})},handle:function(a){var b=a.target;return this!==b||a.isSimulated||a.isTrigger||\"radio\"!==b.type&&\"checkbox\"!==b.type?a.handleObj.handler.apply(this,arguments):void 0},teardown:function(){return m.event.remove(this,\"._change\"),!X.test(this.nodeName)}}),k.focusinBubbles||m.each({focus:\"focusin\",blur:\"focusout\"},function(a,b){var c=function(a){m.event.simulate(b,a.target,m.event.fix(a),!0)};m.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=m._data(d,b);e||d.addEventListener(a,c,!0),m._data(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=m._data(d,b)-1;e?m._data(d,b,e):(d.removeEventListener(a,c,!0),m._removeData(d,b))}}}),m.fn.extend({on:function(a,b,c,d,e){var f,g;if(\"object\"==typeof a){\"string\"!=typeof b&&(c=c||b,b=void 0);for(f in a)this.on(f,b,c,a[f],e);return this}if(null==c&&null==d?(d=b,c=b=void 0):null==d&&(\"string\"==typeof b?(d=c,c=void 0):(d=c,c=b,b=void 0)),d===!1)d=ba;else if(!d)return this;return 1===e&&(g=d,d=function(a){return m().off(a),g.apply(this,arguments)},d.guid=g.guid||(g.guid=m.guid++)),this.each(function(){m.event.add(this,a,d,c,b)})},one:function(a,b,c,d){return this.on(a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,m(a.delegateTarget).off(d.namespace?d.origType+\".\"+d.namespace:d.origType,d.selector,d.handler),this;if(\"object\"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||\"function\"==typeof b)&&(c=b,b=void 0),c===!1&&(c=ba),this.each(function(){m.event.remove(this,a,c,b)})},trigger:function(a,b){return this.each(function(){m.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?m.event.trigger(a,b,c,!0):void 0}});function da(a){var b=ea.split(\"|\"),c=a.createDocumentFragment();if(c.createElement)while(b.length)c.createElement(b.pop());return c}var ea=\"abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video\",fa=/ jQuery\\d+=\"(?:null|\\d+)\"/g,ga=new RegExp(\"<(?:\"+ea+\")[\\\\s/>]\",\"i\"),ha=/^\\s+/,ia=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\\w:]+)[^>]*)\\/>/gi,ja=/<([\\w:]+)/,ka=/<tbody/i,la=/<|&#?\\w+;/,ma=/<(?:script|style|link)/i,na=/checked\\s*(?:[^=]|=\\s*.checked.)/i,oa=/^$|\\/(?:java|ecma)script/i,pa=/^true\\/(.*)/,qa=/^\\s*<!(?:\\[CDATA\\[|--)|(?:\\]\\]|--)>\\s*$/g,ra={option:[1,\"<select multiple='multiple'>\",\"</select>\"],legend:[1,\"<fieldset>\",\"</fieldset>\"],area:[1,\"<map>\",\"</map>\"],param:[1,\"<object>\",\"</object>\"],thead:[1,\"<table>\",\"</table>\"],tr:[2,\"<table><tbody>\",\"</tbody></table>\"],col:[2,\"<table><tbody></tbody><colgroup>\",\"</colgroup></table>\"],td:[3,\"<table><tbody><tr>\",\"</tr></tbody></table>\"],_default:k.htmlSerialize?[0,\"\",\"\"]:[1,\"X<div>\",\"</div>\"]},sa=da(y),ta=sa.appendChild(y.createElement(\"div\"));ra.optgroup=ra.option,ra.tbody=ra.tfoot=ra.colgroup=ra.caption=ra.thead,ra.th=ra.td;function ua(a,b){var c,d,e=0,f=typeof a.getElementsByTagName!==K?a.getElementsByTagName(b||\"*\"):typeof a.querySelectorAll!==K?a.querySelectorAll(b||\"*\"):void 0;if(!f)for(f=[],c=a.childNodes||a;null!=(d=c[e]);e++)!b||m.nodeName(d,b)?f.push(d):m.merge(f,ua(d,b));return void 0===b||b&&m.nodeName(a,b)?m.merge([a],f):f}function va(a){W.test(a.type)&&(a.defaultChecked=a.checked)}function wa(a,b){return m.nodeName(a,\"table\")&&m.nodeName(11!==b.nodeType?b:b.firstChild,\"tr\")?a.getElementsByTagName(\"tbody\")[0]||a.appendChild(a.ownerDocument.createElement(\"tbody\")):a}function xa(a){return a.type=(null!==m.find.attr(a,\"type\"))+\"/\"+a.type,a}function ya(a){var b=pa.exec(a.type);return b?a.type=b[1]:a.removeAttribute(\"type\"),a}function za(a,b){for(var c,d=0;null!=(c=a[d]);d++)m._data(c,\"globalEval\",!b||m._data(b[d],\"globalEval\"))}function Aa(a,b){if(1===b.nodeType&&m.hasData(a)){var c,d,e,f=m._data(a),g=m._data(b,f),h=f.events;if(h){delete g.handle,g.events={};for(c in h)for(d=0,e=h[c].length;e>d;d++)m.event.add(b,c,h[c][d])}g.data&&(g.data=m.extend({},g.data))}}function Ba(a,b){var c,d,e;if(1===b.nodeType){if(c=b.nodeName.toLowerCase(),!k.noCloneEvent&&b[m.expando]){e=m._data(b);for(d in e.events)m.removeEvent(b,d,e.handle);b.removeAttribute(m.expando)}\"script\"===c&&b.text!==a.text?(xa(b).text=a.text,ya(b)):\"object\"===c?(b.parentNode&&(b.outerHTML=a.outerHTML),k.html5Clone&&a.innerHTML&&!m.trim(b.innerHTML)&&(b.innerHTML=a.innerHTML)):\"input\"===c&&W.test(a.type)?(b.defaultChecked=b.checked=a.checked,b.value!==a.value&&(b.value=a.value)):\"option\"===c?b.defaultSelected=b.selected=a.defaultSelected:(\"input\"===c||\"textarea\"===c)&&(b.defaultValue=a.defaultValue)}}m.extend({clone:function(a,b,c){var d,e,f,g,h,i=m.contains(a.ownerDocument,a);if(k.html5Clone||m.isXMLDoc(a)||!ga.test(\"<\"+a.nodeName+\">\")?f=a.cloneNode(!0):(ta.innerHTML=a.outerHTML,ta.removeChild(f=ta.firstChild)),!(k.noCloneEvent&&k.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||m.isXMLDoc(a)))for(d=ua(f),h=ua(a),g=0;null!=(e=h[g]);++g)d[g]&&Ba(e,d[g]);if(b)if(c)for(h=h||ua(a),d=d||ua(f),g=0;null!=(e=h[g]);g++)Aa(e,d[g]);else Aa(a,f);return d=ua(f,\"script\"),d.length>0&&za(d,!i&&ua(a,\"script\")),d=h=e=null,f},buildFragment:function(a,b,c,d){for(var e,f,g,h,i,j,l,n=a.length,o=da(b),p=[],q=0;n>q;q++)if(f=a[q],f||0===f)if(\"object\"===m.type(f))m.merge(p,f.nodeType?[f]:f);else if(la.test(f)){h=h||o.appendChild(b.createElement(\"div\")),i=(ja.exec(f)||[\"\",\"\"])[1].toLowerCase(),l=ra[i]||ra._default,h.innerHTML=l[1]+f.replace(ia,\"<$1></$2>\")+l[2],e=l[0];while(e--)h=h.lastChild;if(!k.leadingWhitespace&&ha.test(f)&&p.push(b.createTextNode(ha.exec(f)[0])),!k.tbody){f=\"table\"!==i||ka.test(f)?\"<table>\"!==l[1]||ka.test(f)?0:h:h.firstChild,e=f&&f.childNodes.length;while(e--)m.nodeName(j=f.childNodes[e],\"tbody\")&&!j.childNodes.length&&f.removeChild(j)}m.merge(p,h.childNodes),h.textContent=\"\";while(h.firstChild)h.removeChild(h.firstChild);h=o.lastChild}else p.push(b.createTextNode(f));h&&o.removeChild(h),k.appendChecked||m.grep(ua(p,\"input\"),va),q=0;while(f=p[q++])if((!d||-1===m.inArray(f,d))&&(g=m.contains(f.ownerDocument,f),h=ua(o.appendChild(f),\"script\"),g&&za(h),c)){e=0;while(f=h[e++])oa.test(f.type||\"\")&&c.push(f)}return h=null,o},cleanData:function(a,b){for(var d,e,f,g,h=0,i=m.expando,j=m.cache,l=k.deleteExpando,n=m.event.special;null!=(d=a[h]);h++)if((b||m.acceptData(d))&&(f=d[i],g=f&&j[f])){if(g.events)for(e in g.events)n[e]?m.event.remove(d,e):m.removeEvent(d,e,g.handle);j[f]&&(delete j[f],l?delete d[i]:typeof d.removeAttribute!==K?d.removeAttribute(i):d[i]=null,c.push(f))}}}),m.fn.extend({text:function(a){return V(this,function(a){return void 0===a?m.text(this):this.empty().append((this[0]&&this[0].ownerDocument||y).createTextNode(a))},null,a,arguments.length)},append:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=wa(this,a);b.appendChild(a)}})},prepend:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=wa(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},remove:function(a,b){for(var c,d=a?m.filter(a,this):this,e=0;null!=(c=d[e]);e++)b||1!==c.nodeType||m.cleanData(ua(c)),c.parentNode&&(b&&m.contains(c.ownerDocument,c)&&za(ua(c,\"script\")),c.parentNode.removeChild(c));return this},empty:function(){for(var a,b=0;null!=(a=this[b]);b++){1===a.nodeType&&m.cleanData(ua(a,!1));while(a.firstChild)a.removeChild(a.firstChild);a.options&&m.nodeName(a,\"select\")&&(a.options.length=0)}return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return m.clone(this,a,b)})},html:function(a){return V(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a)return 1===b.nodeType?b.innerHTML.replace(fa,\"\"):void 0;if(!(\"string\"!=typeof a||ma.test(a)||!k.htmlSerialize&&ga.test(a)||!k.leadingWhitespace&&ha.test(a)||ra[(ja.exec(a)||[\"\",\"\"])[1].toLowerCase()])){a=a.replace(ia,\"<$1></$2>\");try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(m.cleanData(ua(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=arguments[0];return this.domManip(arguments,function(b){a=this.parentNode,m.cleanData(ua(this)),a&&a.replaceChild(b,this)}),a&&(a.length||a.nodeType)?this:this.remove()},detach:function(a){return this.remove(a,!0)},domManip:function(a,b){a=e.apply([],a);var c,d,f,g,h,i,j=0,l=this.length,n=this,o=l-1,p=a[0],q=m.isFunction(p);if(q||l>1&&\"string\"==typeof p&&!k.checkClone&&na.test(p))return this.each(function(c){var d=n.eq(c);q&&(a[0]=p.call(this,c,d.html())),d.domManip(a,b)});if(l&&(i=m.buildFragment(a,this[0].ownerDocument,!1,this),c=i.firstChild,1===i.childNodes.length&&(i=c),c)){for(g=m.map(ua(i,\"script\"),xa),f=g.length;l>j;j++)d=i,j!==o&&(d=m.clone(d,!0,!0),f&&m.merge(g,ua(d,\"script\"))),b.call(this[j],d,j);if(f)for(h=g[g.length-1].ownerDocument,m.map(g,ya),j=0;f>j;j++)d=g[j],oa.test(d.type||\"\")&&!m._data(d,\"globalEval\")&&m.contains(h,d)&&(d.src?m._evalUrl&&m._evalUrl(d.src):m.globalEval((d.text||d.textContent||d.innerHTML||\"\").replace(qa,\"\")));i=c=null}return this}}),m.each({appendTo:\"append\",prependTo:\"prepend\",insertBefore:\"before\",insertAfter:\"after\",replaceAll:\"replaceWith\"},function(a,b){m.fn[a]=function(a){for(var c,d=0,e=[],g=m(a),h=g.length-1;h>=d;d++)c=d===h?this:this.clone(!0),m(g[d])[b](c),f.apply(e,c.get());return this.pushStack(e)}});var Ca,Da={};function Ea(b,c){var d,e=m(c.createElement(b)).appendTo(c.body),f=a.getDefaultComputedStyle&&(d=a.getDefaultComputedStyle(e[0]))?d.display:m.css(e[0],\"display\");return e.detach(),f}function Fa(a){var b=y,c=Da[a];return c||(c=Ea(a,b),\"none\"!==c&&c||(Ca=(Ca||m(\"<iframe frameborder='0' width='0' height='0'/>\")).appendTo(b.documentElement),b=(Ca[0].contentWindow||Ca[0].contentDocument).document,b.write(),b.close(),c=Ea(a,b),Ca.detach()),Da[a]=c),c}!function(){var a;k.shrinkWrapBlocks=function(){if(null!=a)return a;a=!1;var b,c,d;return c=y.getElementsByTagName(\"body\")[0],c&&c.style?(b=y.createElement(\"div\"),d=y.createElement(\"div\"),d.style.cssText=\"position:absolute;border:0;width:0;height:0;top:0;left:-9999px\",c.appendChild(d).appendChild(b),typeof b.style.zoom!==K&&(b.style.cssText=\"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1\",b.appendChild(y.createElement(\"div\")).style.width=\"5px\",a=3!==b.offsetWidth),c.removeChild(d),a):void 0}}();var Ga=/^margin/,Ha=new RegExp(\"^(\"+S+\")(?!px)[a-z%]+$\",\"i\"),Ia,Ja,Ka=/^(top|right|bottom|left)$/;a.getComputedStyle?(Ia=function(b){return b.ownerDocument.defaultView.opener?b.ownerDocument.defaultView.getComputedStyle(b,null):a.getComputedStyle(b,null)},Ja=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Ia(a),g=c?c.getPropertyValue(b)||c[b]:void 0,c&&(\"\"!==g||m.contains(a.ownerDocument,a)||(g=m.style(a,b)),Ha.test(g)&&Ga.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0===g?g:g+\"\"}):y.documentElement.currentStyle&&(Ia=function(a){return a.currentStyle},Ja=function(a,b,c){var d,e,f,g,h=a.style;return c=c||Ia(a),g=c?c[b]:void 0,null==g&&h&&h[b]&&(g=h[b]),Ha.test(g)&&!Ka.test(b)&&(d=h.left,e=a.runtimeStyle,f=e&&e.left,f&&(e.left=a.currentStyle.left),h.left=\"fontSize\"===b?\"1em\":g,g=h.pixelLeft+\"px\",h.left=d,f&&(e.left=f)),void 0===g?g:g+\"\"||\"auto\"});function La(a,b){return{get:function(){var c=a();if(null!=c)return c?void delete this.get:(this.get=b).apply(this,arguments)}}}!function(){var b,c,d,e,f,g,h;if(b=y.createElement(\"div\"),b.innerHTML=\"  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>\",d=b.getElementsByTagName(\"a\")[0],c=d&&d.style){c.cssText=\"float:left;opacity:.5\",k.opacity=\"0.5\"===c.opacity,k.cssFloat=!!c.cssFloat,b.style.backgroundClip=\"content-box\",b.cloneNode(!0).style.backgroundClip=\"\",k.clearCloneStyle=\"content-box\"===b.style.backgroundClip,k.boxSizing=\"\"===c.boxSizing||\"\"===c.MozBoxSizing||\"\"===c.WebkitBoxSizing,m.extend(k,{reliableHiddenOffsets:function(){return null==g&&i(),g},boxSizingReliable:function(){return null==f&&i(),f},pixelPosition:function(){return null==e&&i(),e},reliableMarginRight:function(){return null==h&&i(),h}});function i(){var b,c,d,i;c=y.getElementsByTagName(\"body\")[0],c&&c.style&&(b=y.createElement(\"div\"),d=y.createElement(\"div\"),d.style.cssText=\"position:absolute;border:0;width:0;height:0;top:0;left:-9999px\",c.appendChild(d).appendChild(b),b.style.cssText=\"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute\",e=f=!1,h=!0,a.getComputedStyle&&(e=\"1%\"!==(a.getComputedStyle(b,null)||{}).top,f=\"4px\"===(a.getComputedStyle(b,null)||{width:\"4px\"}).width,i=b.appendChild(y.createElement(\"div\")),i.style.cssText=b.style.cssText=\"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0\",i.style.marginRight=i.style.width=\"0\",b.style.width=\"1px\",h=!parseFloat((a.getComputedStyle(i,null)||{}).marginRight),b.removeChild(i)),b.innerHTML=\"<table><tr><td></td><td>t</td></tr></table>\",i=b.getElementsByTagName(\"td\"),i[0].style.cssText=\"margin:0;border:0;padding:0;display:none\",g=0===i[0].offsetHeight,g&&(i[0].style.display=\"\",i[1].style.display=\"none\",g=0===i[0].offsetHeight),c.removeChild(d))}}}(),m.swap=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};var Ma=/alpha\\([^)]*\\)/i,Na=/opacity\\s*=\\s*([^)]*)/,Oa=/^(none|table(?!-c[ea]).+)/,Pa=new RegExp(\"^(\"+S+\")(.*)$\",\"i\"),Qa=new RegExp(\"^([+-])=(\"+S+\")\",\"i\"),Ra={position:\"absolute\",visibility:\"hidden\",display:\"block\"},Sa={letterSpacing:\"0\",fontWeight:\"400\"},Ta=[\"Webkit\",\"O\",\"Moz\",\"ms\"];function Ua(a,b){if(b in a)return b;var c=b.charAt(0).toUpperCase()+b.slice(1),d=b,e=Ta.length;while(e--)if(b=Ta[e]+c,b in a)return b;return d}function Va(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=m._data(d,\"olddisplay\"),c=d.style.display,b?(f[g]||\"none\"!==c||(d.style.display=\"\"),\"\"===d.style.display&&U(d)&&(f[g]=m._data(d,\"olddisplay\",Fa(d.nodeName)))):(e=U(d),(c&&\"none\"!==c||!e)&&m._data(d,\"olddisplay\",e?c:m.css(d,\"display\"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&\"none\"!==d.style.display&&\"\"!==d.style.display||(d.style.display=b?f[g]||\"\":\"none\"));return a}function Wa(a,b,c){var d=Pa.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||\"px\"):b}function Xa(a,b,c,d,e){for(var f=c===(d?\"border\":\"content\")?4:\"width\"===b?1:0,g=0;4>f;f+=2)\"margin\"===c&&(g+=m.css(a,c+T[f],!0,e)),d?(\"content\"===c&&(g-=m.css(a,\"padding\"+T[f],!0,e)),\"margin\"!==c&&(g-=m.css(a,\"border\"+T[f]+\"Width\",!0,e))):(g+=m.css(a,\"padding\"+T[f],!0,e),\"padding\"!==c&&(g+=m.css(a,\"border\"+T[f]+\"Width\",!0,e)));return g}function Ya(a,b,c){var d=!0,e=\"width\"===b?a.offsetWidth:a.offsetHeight,f=Ia(a),g=k.boxSizing&&\"border-box\"===m.css(a,\"boxSizing\",!1,f);if(0>=e||null==e){if(e=Ja(a,b,f),(0>e||null==e)&&(e=a.style[b]),Ha.test(e))return e;d=g&&(k.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Xa(a,b,c||(g?\"border\":\"content\"),d,f)+\"px\"}m.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Ja(a,\"opacity\");return\"\"===c?\"1\":c}}}},cssNumber:{columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{\"float\":k.cssFloat?\"cssFloat\":\"styleFloat\"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=m.camelCase(b),i=a.style;if(b=m.cssProps[h]||(m.cssProps[h]=Ua(i,h)),g=m.cssHooks[b]||m.cssHooks[h],void 0===c)return g&&\"get\"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b];if(f=typeof c,\"string\"===f&&(e=Qa.exec(c))&&(c=(e[1]+1)*e[2]+parseFloat(m.css(a,b)),f=\"number\"),null!=c&&c===c&&(\"number\"!==f||m.cssNumber[h]||(c+=\"px\"),k.clearCloneStyle||\"\"!==c||0!==b.indexOf(\"background\")||(i[b]=\"inherit\"),!(g&&\"set\"in g&&void 0===(c=g.set(a,c,d)))))try{i[b]=c}catch(j){}}},css:function(a,b,c,d){var e,f,g,h=m.camelCase(b);return b=m.cssProps[h]||(m.cssProps[h]=Ua(a.style,h)),g=m.cssHooks[b]||m.cssHooks[h],g&&\"get\"in g&&(f=g.get(a,!0,c)),void 0===f&&(f=Ja(a,b,d)),\"normal\"===f&&b in Sa&&(f=Sa[b]),\"\"===c||c?(e=parseFloat(f),c===!0||m.isNumeric(e)?e||0:f):f}}),m.each([\"height\",\"width\"],function(a,b){m.cssHooks[b]={get:function(a,c,d){return c?Oa.test(m.css(a,\"display\"))&&0===a.offsetWidth?m.swap(a,Ra,function(){return Ya(a,b,d)}):Ya(a,b,d):void 0},set:function(a,c,d){var e=d&&Ia(a);return Wa(a,c,d?Xa(a,b,d,k.boxSizing&&\"border-box\"===m.css(a,\"boxSizing\",!1,e),e):0)}}}),k.opacity||(m.cssHooks.opacity={get:function(a,b){return Na.test((b&&a.currentStyle?a.currentStyle.filter:a.style.filter)||\"\")?.01*parseFloat(RegExp.$1)+\"\":b?\"1\":\"\"},set:function(a,b){var c=a.style,d=a.currentStyle,e=m.isNumeric(b)?\"alpha(opacity=\"+100*b+\")\":\"\",f=d&&d.filter||c.filter||\"\";c.zoom=1,(b>=1||\"\"===b)&&\"\"===m.trim(f.replace(Ma,\"\"))&&c.removeAttribute&&(c.removeAttribute(\"filter\"),\"\"===b||d&&!d.filter)||(c.filter=Ma.test(f)?f.replace(Ma,e):f+\" \"+e)}}),m.cssHooks.marginRight=La(k.reliableMarginRight,function(a,b){return b?m.swap(a,{display:\"inline-block\"},Ja,[a,\"marginRight\"]):void 0}),m.each({margin:\"\",padding:\"\",border:\"Width\"},function(a,b){m.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f=\"string\"==typeof c?c.split(\" \"):[c];4>d;d++)e[a+T[d]+b]=f[d]||f[d-2]||f[0];return e}},Ga.test(a)||(m.cssHooks[a+b].set=Wa)}),m.fn.extend({css:function(a,b){return V(this,function(a,b,c){var d,e,f={},g=0;if(m.isArray(b)){for(d=Ia(a),e=b.length;e>g;g++)f[b[g]]=m.css(a,b[g],!1,d);return f}return void 0!==c?m.style(a,b,c):m.css(a,b)},a,b,arguments.length>1)},show:function(){return Va(this,!0)},hide:function(){return Va(this)},toggle:function(a){return\"boolean\"==typeof a?a?this.show():this.hide():this.each(function(){U(this)?m(this).show():m(this).hide()})}});function Za(a,b,c,d,e){\nreturn new Za.prototype.init(a,b,c,d,e)}m.Tween=Za,Za.prototype={constructor:Za,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||\"swing\",this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(m.cssNumber[c]?\"\":\"px\")},cur:function(){var a=Za.propHooks[this.prop];return a&&a.get?a.get(this):Za.propHooks._default.get(this)},run:function(a){var b,c=Za.propHooks[this.prop];return this.options.duration?this.pos=b=m.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Za.propHooks._default.set(this),this}},Za.prototype.init.prototype=Za.prototype,Za.propHooks={_default:{get:function(a){var b;return null==a.elem[a.prop]||a.elem.style&&null!=a.elem.style[a.prop]?(b=m.css(a.elem,a.prop,\"\"),b&&\"auto\"!==b?b:0):a.elem[a.prop]},set:function(a){m.fx.step[a.prop]?m.fx.step[a.prop](a):a.elem.style&&(null!=a.elem.style[m.cssProps[a.prop]]||m.cssHooks[a.prop])?m.style(a.elem,a.prop,a.now+a.unit):a.elem[a.prop]=a.now}}},Za.propHooks.scrollTop=Za.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},m.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2}},m.fx=Za.prototype.init,m.fx.step={};var $a,_a,ab=/^(?:toggle|show|hide)$/,bb=new RegExp(\"^(?:([+-])=|)(\"+S+\")([a-z%]*)$\",\"i\"),cb=/queueHooks$/,db=[ib],eb={\"*\":[function(a,b){var c=this.createTween(a,b),d=c.cur(),e=bb.exec(b),f=e&&e[3]||(m.cssNumber[a]?\"\":\"px\"),g=(m.cssNumber[a]||\"px\"!==f&&+d)&&bb.exec(m.css(c.elem,a)),h=1,i=20;if(g&&g[3]!==f){f=f||g[3],e=e||[],g=+d||1;do h=h||\".5\",g/=h,m.style(c.elem,a,g+f);while(h!==(h=c.cur()/d)&&1!==h&&--i)}return e&&(g=c.start=+g||+d||0,c.unit=f,c.end=e[1]?g+(e[1]+1)*e[2]:+e[2]),c}]};function fb(){return setTimeout(function(){$a=void 0}),$a=m.now()}function gb(a,b){var c,d={height:a},e=0;for(b=b?1:0;4>e;e+=2-b)c=T[e],d[\"margin\"+c]=d[\"padding\"+c]=a;return b&&(d.opacity=d.width=a),d}function hb(a,b,c){for(var d,e=(eb[b]||[]).concat(eb[\"*\"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function ib(a,b,c){var d,e,f,g,h,i,j,l,n=this,o={},p=a.style,q=a.nodeType&&U(a),r=m._data(a,\"fxshow\");c.queue||(h=m._queueHooks(a,\"fx\"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,n.always(function(){n.always(function(){h.unqueued--,m.queue(a,\"fx\").length||h.empty.fire()})})),1===a.nodeType&&(\"height\"in b||\"width\"in b)&&(c.overflow=[p.overflow,p.overflowX,p.overflowY],j=m.css(a,\"display\"),l=\"none\"===j?m._data(a,\"olddisplay\")||Fa(a.nodeName):j,\"inline\"===l&&\"none\"===m.css(a,\"float\")&&(k.inlineBlockNeedsLayout&&\"inline\"!==Fa(a.nodeName)?p.zoom=1:p.display=\"inline-block\")),c.overflow&&(p.overflow=\"hidden\",k.shrinkWrapBlocks()||n.always(function(){p.overflow=c.overflow[0],p.overflowX=c.overflow[1],p.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],ab.exec(e)){if(delete b[d],f=f||\"toggle\"===e,e===(q?\"hide\":\"show\")){if(\"show\"!==e||!r||void 0===r[d])continue;q=!0}o[d]=r&&r[d]||m.style(a,d)}else j=void 0;if(m.isEmptyObject(o))\"inline\"===(\"none\"===j?Fa(a.nodeName):j)&&(p.display=j);else{r?\"hidden\"in r&&(q=r.hidden):r=m._data(a,\"fxshow\",{}),f&&(r.hidden=!q),q?m(a).show():n.done(function(){m(a).hide()}),n.done(function(){var b;m._removeData(a,\"fxshow\");for(b in o)m.style(a,b,o[b])});for(d in o)g=hb(q?r[d]:0,d,n),d in r||(r[d]=g.start,q&&(g.end=g.start,g.start=\"width\"===d||\"height\"===d?1:0))}}function jb(a,b){var c,d,e,f,g;for(c in a)if(d=m.camelCase(c),e=b[d],f=a[c],m.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=m.cssHooks[d],g&&\"expand\"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function kb(a,b,c){var d,e,f=0,g=db.length,h=m.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=$a||fb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:m.extend({},b),opts:m.extend(!0,{specialEasing:{}},c),originalProperties:b,originalOptions:c,startTime:$a||fb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=m.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?h.resolveWith(a,[j,b]):h.rejectWith(a,[j,b]),this}}),k=j.props;for(jb(k,j.opts.specialEasing);g>f;f++)if(d=db[f].call(j,a,k,j.opts))return d;return m.map(k,hb,j),m.isFunction(j.opts.start)&&j.opts.start.call(a,j),m.fx.timer(m.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}m.Animation=m.extend(kb,{tweener:function(a,b){m.isFunction(a)?(b=a,a=[\"*\"]):a=a.split(\" \");for(var c,d=0,e=a.length;e>d;d++)c=a[d],eb[c]=eb[c]||[],eb[c].unshift(b)},prefilter:function(a,b){b?db.unshift(a):db.push(a)}}),m.speed=function(a,b,c){var d=a&&\"object\"==typeof a?m.extend({},a):{complete:c||!c&&b||m.isFunction(a)&&a,duration:a,easing:c&&b||b&&!m.isFunction(b)&&b};return d.duration=m.fx.off?0:\"number\"==typeof d.duration?d.duration:d.duration in m.fx.speeds?m.fx.speeds[d.duration]:m.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue=\"fx\"),d.old=d.complete,d.complete=function(){m.isFunction(d.old)&&d.old.call(this),d.queue&&m.dequeue(this,d.queue)},d},m.fn.extend({fadeTo:function(a,b,c,d){return this.filter(U).css(\"opacity\",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=m.isEmptyObject(a),f=m.speed(b,c,d),g=function(){var b=kb(this,m.extend({},a),f);(e||m._data(this,\"finish\"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return\"string\"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||\"fx\",[]),this.each(function(){var b=!0,e=null!=a&&a+\"queueHooks\",f=m.timers,g=m._data(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&cb.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&m.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||\"fx\"),this.each(function(){var b,c=m._data(this),d=c[a+\"queue\"],e=c[a+\"queueHooks\"],f=m.timers,g=d?d.length:0;for(c.finish=!0,m.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),m.each([\"toggle\",\"show\",\"hide\"],function(a,b){var c=m.fn[b];m.fn[b]=function(a,d,e){return null==a||\"boolean\"==typeof a?c.apply(this,arguments):this.animate(gb(b,!0),a,d,e)}}),m.each({slideDown:gb(\"show\"),slideUp:gb(\"hide\"),slideToggle:gb(\"toggle\"),fadeIn:{opacity:\"show\"},fadeOut:{opacity:\"hide\"},fadeToggle:{opacity:\"toggle\"}},function(a,b){m.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),m.timers=[],m.fx.tick=function(){var a,b=m.timers,c=0;for($a=m.now();c<b.length;c++)a=b[c],a()||b[c]!==a||b.splice(c--,1);b.length||m.fx.stop(),$a=void 0},m.fx.timer=function(a){m.timers.push(a),a()?m.fx.start():m.timers.pop()},m.fx.interval=13,m.fx.start=function(){_a||(_a=setInterval(m.fx.tick,m.fx.interval))},m.fx.stop=function(){clearInterval(_a),_a=null},m.fx.speeds={slow:600,fast:200,_default:400},m.fn.delay=function(a,b){return a=m.fx?m.fx.speeds[a]||a:a,b=b||\"fx\",this.queue(b,function(b,c){var d=setTimeout(b,a);c.stop=function(){clearTimeout(d)}})},function(){var a,b,c,d,e;b=y.createElement(\"div\"),b.setAttribute(\"className\",\"t\"),b.innerHTML=\"  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>\",d=b.getElementsByTagName(\"a\")[0],c=y.createElement(\"select\"),e=c.appendChild(y.createElement(\"option\")),a=b.getElementsByTagName(\"input\")[0],d.style.cssText=\"top:1px\",k.getSetAttribute=\"t\"!==b.className,k.style=/top/.test(d.getAttribute(\"style\")),k.hrefNormalized=\"/a\"===d.getAttribute(\"href\"),k.checkOn=!!a.value,k.optSelected=e.selected,k.enctype=!!y.createElement(\"form\").enctype,c.disabled=!0,k.optDisabled=!e.disabled,a=y.createElement(\"input\"),a.setAttribute(\"value\",\"\"),k.input=\"\"===a.getAttribute(\"value\"),a.value=\"t\",a.setAttribute(\"type\",\"radio\"),k.radioValue=\"t\"===a.value}();var lb=/\\r/g;m.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=m.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,m(this).val()):a,null==e?e=\"\":\"number\"==typeof e?e+=\"\":m.isArray(e)&&(e=m.map(e,function(a){return null==a?\"\":a+\"\"})),b=m.valHooks[this.type]||m.valHooks[this.nodeName.toLowerCase()],b&&\"set\"in b&&void 0!==b.set(this,e,\"value\")||(this.value=e))});if(e)return b=m.valHooks[e.type]||m.valHooks[e.nodeName.toLowerCase()],b&&\"get\"in b&&void 0!==(c=b.get(e,\"value\"))?c:(c=e.value,\"string\"==typeof c?c.replace(lb,\"\"):null==c?\"\":c)}}}),m.extend({valHooks:{option:{get:function(a){var b=m.find.attr(a,\"value\");return null!=b?b:m.trim(m.text(a))}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f=\"select-one\"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],!(!c.selected&&i!==e||(k.optDisabled?c.disabled:null!==c.getAttribute(\"disabled\"))||c.parentNode.disabled&&m.nodeName(c.parentNode,\"optgroup\"))){if(b=m(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=m.makeArray(b),g=e.length;while(g--)if(d=e[g],m.inArray(m.valHooks.option.get(d),f)>=0)try{d.selected=c=!0}catch(h){d.scrollHeight}else d.selected=!1;return c||(a.selectedIndex=-1),e}}}}),m.each([\"radio\",\"checkbox\"],function(){m.valHooks[this]={set:function(a,b){return m.isArray(b)?a.checked=m.inArray(m(a).val(),b)>=0:void 0}},k.checkOn||(m.valHooks[this].get=function(a){return null===a.getAttribute(\"value\")?\"on\":a.value})});var mb,nb,ob=m.expr.attrHandle,pb=/^(?:checked|selected)$/i,qb=k.getSetAttribute,rb=k.input;m.fn.extend({attr:function(a,b){return V(this,m.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){m.removeAttr(this,a)})}}),m.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(a&&3!==f&&8!==f&&2!==f)return typeof a.getAttribute===K?m.prop(a,b,c):(1===f&&m.isXMLDoc(a)||(b=b.toLowerCase(),d=m.attrHooks[b]||(m.expr.match.bool.test(b)?nb:mb)),void 0===c?d&&\"get\"in d&&null!==(e=d.get(a,b))?e:(e=m.find.attr(a,b),null==e?void 0:e):null!==c?d&&\"set\"in d&&void 0!==(e=d.set(a,c,b))?e:(a.setAttribute(b,c+\"\"),c):void m.removeAttr(a,b))},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(E);if(f&&1===a.nodeType)while(c=f[e++])d=m.propFix[c]||c,m.expr.match.bool.test(c)?rb&&qb||!pb.test(c)?a[d]=!1:a[m.camelCase(\"default-\"+c)]=a[d]=!1:m.attr(a,c,\"\"),a.removeAttribute(qb?c:d)},attrHooks:{type:{set:function(a,b){if(!k.radioValue&&\"radio\"===b&&m.nodeName(a,\"input\")){var c=a.value;return a.setAttribute(\"type\",b),c&&(a.value=c),b}}}}}),nb={set:function(a,b,c){return b===!1?m.removeAttr(a,c):rb&&qb||!pb.test(c)?a.setAttribute(!qb&&m.propFix[c]||c,c):a[m.camelCase(\"default-\"+c)]=a[c]=!0,c}},m.each(m.expr.match.bool.source.match(/\\w+/g),function(a,b){var c=ob[b]||m.find.attr;ob[b]=rb&&qb||!pb.test(b)?function(a,b,d){var e,f;return d||(f=ob[b],ob[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,ob[b]=f),e}:function(a,b,c){return c?void 0:a[m.camelCase(\"default-\"+b)]?b.toLowerCase():null}}),rb&&qb||(m.attrHooks.value={set:function(a,b,c){return m.nodeName(a,\"input\")?void(a.defaultValue=b):mb&&mb.set(a,b,c)}}),qb||(mb={set:function(a,b,c){var d=a.getAttributeNode(c);return d||a.setAttributeNode(d=a.ownerDocument.createAttribute(c)),d.value=b+=\"\",\"value\"===c||b===a.getAttribute(c)?b:void 0}},ob.id=ob.name=ob.coords=function(a,b,c){var d;return c?void 0:(d=a.getAttributeNode(b))&&\"\"!==d.value?d.value:null},m.valHooks.button={get:function(a,b){var c=a.getAttributeNode(b);return c&&c.specified?c.value:void 0},set:mb.set},m.attrHooks.contenteditable={set:function(a,b,c){mb.set(a,\"\"===b?!1:b,c)}},m.each([\"width\",\"height\"],function(a,b){m.attrHooks[b]={set:function(a,c){return\"\"===c?(a.setAttribute(b,\"auto\"),c):void 0}}})),k.style||(m.attrHooks.style={get:function(a){return a.style.cssText||void 0},set:function(a,b){return a.style.cssText=b+\"\"}});var sb=/^(?:input|select|textarea|button|object)$/i,tb=/^(?:a|area)$/i;m.fn.extend({prop:function(a,b){return V(this,m.prop,a,b,arguments.length>1)},removeProp:function(a){return a=m.propFix[a]||a,this.each(function(){try{this[a]=void 0,delete this[a]}catch(b){}})}}),m.extend({propFix:{\"for\":\"htmlFor\",\"class\":\"className\"},prop:function(a,b,c){var d,e,f,g=a.nodeType;if(a&&3!==g&&8!==g&&2!==g)return f=1!==g||!m.isXMLDoc(a),f&&(b=m.propFix[b]||b,e=m.propHooks[b]),void 0!==c?e&&\"set\"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&\"get\"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=m.find.attr(a,\"tabindex\");return b?parseInt(b,10):sb.test(a.nodeName)||tb.test(a.nodeName)&&a.href?0:-1}}}}),k.hrefNormalized||m.each([\"href\",\"src\"],function(a,b){m.propHooks[b]={get:function(a){return a.getAttribute(b,4)}}}),k.optSelected||(m.propHooks.selected={get:function(a){var b=a.parentNode;return b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex),null}}),m.each([\"tabIndex\",\"readOnly\",\"maxLength\",\"cellSpacing\",\"cellPadding\",\"rowSpan\",\"colSpan\",\"useMap\",\"frameBorder\",\"contentEditable\"],function(){m.propFix[this.toLowerCase()]=this}),k.enctype||(m.propFix.enctype=\"encoding\");var ub=/[\\t\\r\\n\\f]/g;m.fn.extend({addClass:function(a){var b,c,d,e,f,g,h=0,i=this.length,j=\"string\"==typeof a&&a;if(m.isFunction(a))return this.each(function(b){m(this).addClass(a.call(this,b,this.className))});if(j)for(b=(a||\"\").match(E)||[];i>h;h++)if(c=this[h],d=1===c.nodeType&&(c.className?(\" \"+c.className+\" \").replace(ub,\" \"):\" \")){f=0;while(e=b[f++])d.indexOf(\" \"+e+\" \")<0&&(d+=e+\" \");g=m.trim(d),c.className!==g&&(c.className=g)}return this},removeClass:function(a){var b,c,d,e,f,g,h=0,i=this.length,j=0===arguments.length||\"string\"==typeof a&&a;if(m.isFunction(a))return this.each(function(b){m(this).removeClass(a.call(this,b,this.className))});if(j)for(b=(a||\"\").match(E)||[];i>h;h++)if(c=this[h],d=1===c.nodeType&&(c.className?(\" \"+c.className+\" \").replace(ub,\" \"):\"\")){f=0;while(e=b[f++])while(d.indexOf(\" \"+e+\" \")>=0)d=d.replace(\" \"+e+\" \",\" \");g=a?m.trim(d):\"\",c.className!==g&&(c.className=g)}return this},toggleClass:function(a,b){var c=typeof a;return\"boolean\"==typeof b&&\"string\"===c?b?this.addClass(a):this.removeClass(a):this.each(m.isFunction(a)?function(c){m(this).toggleClass(a.call(this,c,this.className,b),b)}:function(){if(\"string\"===c){var b,d=0,e=m(this),f=a.match(E)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(c===K||\"boolean\"===c)&&(this.className&&m._data(this,\"__className__\",this.className),this.className=this.className||a===!1?\"\":m._data(this,\"__className__\")||\"\")})},hasClass:function(a){for(var b=\" \"+a+\" \",c=0,d=this.length;d>c;c++)if(1===this[c].nodeType&&(\" \"+this[c].className+\" \").replace(ub,\" \").indexOf(b)>=0)return!0;return!1}}),m.each(\"blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu\".split(\" \"),function(a,b){m.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),m.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)},bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,\"**\"):this.off(b,a||\"**\",c)}});var vb=m.now(),wb=/\\?/,xb=/(,)|(\\[|{)|(}|])|\"(?:[^\"\\\\\\r\\n]|\\\\[\"\\\\\\/bfnrt]|\\\\u[\\da-fA-F]{4})*\"\\s*:?|true|false|null|-?(?!0\\d)\\d+(?:\\.\\d+|)(?:[eE][+-]?\\d+|)/g;m.parseJSON=function(b){if(a.JSON&&a.JSON.parse)return a.JSON.parse(b+\"\");var c,d=null,e=m.trim(b+\"\");return e&&!m.trim(e.replace(xb,function(a,b,e,f){return c&&b&&(d=0),0===d?a:(c=e||b,d+=!f-!e,\"\")}))?Function(\"return \"+e)():m.error(\"Invalid JSON: \"+b)},m.parseXML=function(b){var c,d;if(!b||\"string\"!=typeof b)return null;try{a.DOMParser?(d=new DOMParser,c=d.parseFromString(b,\"text/xml\")):(c=new ActiveXObject(\"Microsoft.XMLDOM\"),c.async=\"false\",c.loadXML(b))}catch(e){c=void 0}return c&&c.documentElement&&!c.getElementsByTagName(\"parsererror\").length||m.error(\"Invalid XML: \"+b),c};var yb,zb,Ab=/#.*$/,Bb=/([?&])_=[^&]*/,Cb=/^(.*?):[ \\t]*([^\\r\\n]*)\\r?$/gm,Db=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Eb=/^(?:GET|HEAD)$/,Fb=/^\\/\\//,Gb=/^([\\w.+-]+:)(?:\\/\\/(?:[^\\/?#]*@|)([^\\/?#:]*)(?::(\\d+)|)|)/,Hb={},Ib={},Jb=\"*/\".concat(\"*\");try{zb=location.href}catch(Kb){zb=y.createElement(\"a\"),zb.href=\"\",zb=zb.href}yb=Gb.exec(zb.toLowerCase())||[];function Lb(a){return function(b,c){\"string\"!=typeof b&&(c=b,b=\"*\");var d,e=0,f=b.toLowerCase().match(E)||[];if(m.isFunction(c))while(d=f[e++])\"+\"===d.charAt(0)?(d=d.slice(1)||\"*\",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Mb(a,b,c,d){var e={},f=a===Ib;function g(h){var i;return e[h]=!0,m.each(a[h]||[],function(a,h){var j=h(b,c,d);return\"string\"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e[\"*\"]&&g(\"*\")}function Nb(a,b){var c,d,e=m.ajaxSettings.flatOptions||{};for(d in b)void 0!==b[d]&&((e[d]?a:c||(c={}))[d]=b[d]);return c&&m.extend(!0,a,c),a}function Ob(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while(\"*\"===i[0])i.shift(),void 0===e&&(e=a.mimeType||b.getResponseHeader(\"Content-Type\"));if(e)for(g in h)if(h[g]&&h[g].test(e)){i.unshift(g);break}if(i[0]in c)f=i[0];else{for(g in c){if(!i[0]||a.converters[g+\" \"+i[0]]){f=g;break}d||(d=g)}f=f||d}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Pb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if(\"*\"===f)f=i;else if(\"*\"!==i&&i!==f){if(g=j[i+\" \"+f]||j[\"* \"+f],!g)for(e in j)if(h=e.split(\" \"),h[1]===f&&(g=j[i+\" \"+h[0]]||j[\"* \"+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a[\"throws\"])b=g(b);else try{b=g(b)}catch(l){return{state:\"parsererror\",error:g?l:\"No conversion from \"+i+\" to \"+f}}}return{state:\"success\",data:b}}m.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:zb,type:\"GET\",isLocal:Db.test(yb[1]),global:!0,processData:!0,async:!0,contentType:\"application/x-www-form-urlencoded; charset=UTF-8\",accepts:{\"*\":Jb,text:\"text/plain\",html:\"text/html\",xml:\"application/xml, text/xml\",json:\"application/json, text/javascript\"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:\"responseXML\",text:\"responseText\",json:\"responseJSON\"},converters:{\"* text\":String,\"text html\":!0,\"text json\":m.parseJSON,\"text xml\":m.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Nb(Nb(a,m.ajaxSettings),b):Nb(m.ajaxSettings,a)},ajaxPrefilter:Lb(Hb),ajaxTransport:Lb(Ib),ajax:function(a,b){\"object\"==typeof a&&(b=a,a=void 0),b=b||{};var c,d,e,f,g,h,i,j,k=m.ajaxSetup({},b),l=k.context||k,n=k.context&&(l.nodeType||l.jquery)?m(l):m.event,o=m.Deferred(),p=m.Callbacks(\"once memory\"),q=k.statusCode||{},r={},s={},t=0,u=\"canceled\",v={readyState:0,getResponseHeader:function(a){var b;if(2===t){if(!j){j={};while(b=Cb.exec(f))j[b[1].toLowerCase()]=b[2]}b=j[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===t?f:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return t||(a=s[c]=s[c]||a,r[a]=b),this},overrideMimeType:function(a){return t||(k.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>t)for(b in a)q[b]=[q[b],a[b]];else v.always(a[v.status]);return this},abort:function(a){var b=a||u;return i&&i.abort(b),x(0,b),this}};if(o.promise(v).complete=p.add,v.success=v.done,v.error=v.fail,k.url=((a||k.url||zb)+\"\").replace(Ab,\"\").replace(Fb,yb[1]+\"//\"),k.type=b.method||b.type||k.method||k.type,k.dataTypes=m.trim(k.dataType||\"*\").toLowerCase().match(E)||[\"\"],null==k.crossDomain&&(c=Gb.exec(k.url.toLowerCase()),k.crossDomain=!(!c||c[1]===yb[1]&&c[2]===yb[2]&&(c[3]||(\"http:\"===c[1]?\"80\":\"443\"))===(yb[3]||(\"http:\"===yb[1]?\"80\":\"443\")))),k.data&&k.processData&&\"string\"!=typeof k.data&&(k.data=m.param(k.data,k.traditional)),Mb(Hb,k,b,v),2===t)return v;h=m.event&&k.global,h&&0===m.active++&&m.event.trigger(\"ajaxStart\"),k.type=k.type.toUpperCase(),k.hasContent=!Eb.test(k.type),e=k.url,k.hasContent||(k.data&&(e=k.url+=(wb.test(e)?\"&\":\"?\")+k.data,delete k.data),k.cache===!1&&(k.url=Bb.test(e)?e.replace(Bb,\"$1_=\"+vb++):e+(wb.test(e)?\"&\":\"?\")+\"_=\"+vb++)),k.ifModified&&(m.lastModified[e]&&v.setRequestHeader(\"If-Modified-Since\",m.lastModified[e]),m.etag[e]&&v.setRequestHeader(\"If-None-Match\",m.etag[e])),(k.data&&k.hasContent&&k.contentType!==!1||b.contentType)&&v.setRequestHeader(\"Content-Type\",k.contentType),v.setRequestHeader(\"Accept\",k.dataTypes[0]&&k.accepts[k.dataTypes[0]]?k.accepts[k.dataTypes[0]]+(\"*\"!==k.dataTypes[0]?\", \"+Jb+\"; q=0.01\":\"\"):k.accepts[\"*\"]);for(d in k.headers)v.setRequestHeader(d,k.headers[d]);if(k.beforeSend&&(k.beforeSend.call(l,v,k)===!1||2===t))return v.abort();u=\"abort\";for(d in{success:1,error:1,complete:1})v[d](k[d]);if(i=Mb(Ib,k,b,v)){v.readyState=1,h&&n.trigger(\"ajaxSend\",[v,k]),k.async&&k.timeout>0&&(g=setTimeout(function(){v.abort(\"timeout\")},k.timeout));try{t=1,i.send(r,x)}catch(w){if(!(2>t))throw w;x(-1,w)}}else x(-1,\"No Transport\");function x(a,b,c,d){var j,r,s,u,w,x=b;2!==t&&(t=2,g&&clearTimeout(g),i=void 0,f=d||\"\",v.readyState=a>0?4:0,j=a>=200&&300>a||304===a,c&&(u=Ob(k,v,c)),u=Pb(k,u,v,j),j?(k.ifModified&&(w=v.getResponseHeader(\"Last-Modified\"),w&&(m.lastModified[e]=w),w=v.getResponseHeader(\"etag\"),w&&(m.etag[e]=w)),204===a||\"HEAD\"===k.type?x=\"nocontent\":304===a?x=\"notmodified\":(x=u.state,r=u.data,s=u.error,j=!s)):(s=x,(a||!x)&&(x=\"error\",0>a&&(a=0))),v.status=a,v.statusText=(b||x)+\"\",j?o.resolveWith(l,[r,x,v]):o.rejectWith(l,[v,x,s]),v.statusCode(q),q=void 0,h&&n.trigger(j?\"ajaxSuccess\":\"ajaxError\",[v,k,j?r:s]),p.fireWith(l,[v,x]),h&&(n.trigger(\"ajaxComplete\",[v,k]),--m.active||m.event.trigger(\"ajaxStop\")))}return v},getJSON:function(a,b,c){return m.get(a,b,c,\"json\")},getScript:function(a,b){return m.get(a,void 0,b,\"script\")}}),m.each([\"get\",\"post\"],function(a,b){m[b]=function(a,c,d,e){return m.isFunction(c)&&(e=e||d,d=c,c=void 0),m.ajax({url:a,type:b,dataType:e,data:c,success:d})}}),m._evalUrl=function(a){return m.ajax({url:a,type:\"GET\",dataType:\"script\",async:!1,global:!1,\"throws\":!0})},m.fn.extend({wrapAll:function(a){if(m.isFunction(a))return this.each(function(b){m(this).wrapAll(a.call(this,b))});if(this[0]){var b=m(a,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstChild&&1===a.firstChild.nodeType)a=a.firstChild;return a}).append(this)}return this},wrapInner:function(a){return this.each(m.isFunction(a)?function(b){m(this).wrapInner(a.call(this,b))}:function(){var b=m(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=m.isFunction(a);return this.each(function(c){m(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){m.nodeName(this,\"body\")||m(this).replaceWith(this.childNodes)}).end()}}),m.expr.filters.hidden=function(a){return a.offsetWidth<=0&&a.offsetHeight<=0||!k.reliableHiddenOffsets()&&\"none\"===(a.style&&a.style.display||m.css(a,\"display\"))},m.expr.filters.visible=function(a){return!m.expr.filters.hidden(a)};var Qb=/%20/g,Rb=/\\[\\]$/,Sb=/\\r?\\n/g,Tb=/^(?:submit|button|image|reset|file)$/i,Ub=/^(?:input|select|textarea|keygen)/i;function Vb(a,b,c,d){var e;if(m.isArray(b))m.each(b,function(b,e){c||Rb.test(a)?d(a,e):Vb(a+\"[\"+(\"object\"==typeof e?b:\"\")+\"]\",e,c,d)});else if(c||\"object\"!==m.type(b))d(a,b);else for(e in b)Vb(a+\"[\"+e+\"]\",b[e],c,d)}m.param=function(a,b){var c,d=[],e=function(a,b){b=m.isFunction(b)?b():null==b?\"\":b,d[d.length]=encodeURIComponent(a)+\"=\"+encodeURIComponent(b)};if(void 0===b&&(b=m.ajaxSettings&&m.ajaxSettings.traditional),m.isArray(a)||a.jquery&&!m.isPlainObject(a))m.each(a,function(){e(this.name,this.value)});else for(c in a)Vb(c,a[c],b,e);return d.join(\"&\").replace(Qb,\"+\")},m.fn.extend({serialize:function(){return m.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=m.prop(this,\"elements\");return a?m.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!m(this).is(\":disabled\")&&Ub.test(this.nodeName)&&!Tb.test(a)&&(this.checked||!W.test(a))}).map(function(a,b){var c=m(this).val();return null==c?null:m.isArray(c)?m.map(c,function(a){return{name:b.name,value:a.replace(Sb,\"\\r\\n\")}}):{name:b.name,value:c.replace(Sb,\"\\r\\n\")}}).get()}}),m.ajaxSettings.xhr=void 0!==a.ActiveXObject?function(){return!this.isLocal&&/^(get|post|head|put|delete|options)$/i.test(this.type)&&Zb()||$b()}:Zb;var Wb=0,Xb={},Yb=m.ajaxSettings.xhr();a.attachEvent&&a.attachEvent(\"onunload\",function(){for(var a in Xb)Xb[a](void 0,!0)}),k.cors=!!Yb&&\"withCredentials\"in Yb,Yb=k.ajax=!!Yb,Yb&&m.ajaxTransport(function(a){if(!a.crossDomain||k.cors){var b;return{send:function(c,d){var e,f=a.xhr(),g=++Wb;if(f.open(a.type,a.url,a.async,a.username,a.password),a.xhrFields)for(e in a.xhrFields)f[e]=a.xhrFields[e];a.mimeType&&f.overrideMimeType&&f.overrideMimeType(a.mimeType),a.crossDomain||c[\"X-Requested-With\"]||(c[\"X-Requested-With\"]=\"XMLHttpRequest\");for(e in c)void 0!==c[e]&&f.setRequestHeader(e,c[e]+\"\");f.send(a.hasContent&&a.data||null),b=function(c,e){var h,i,j;if(b&&(e||4===f.readyState))if(delete Xb[g],b=void 0,f.onreadystatechange=m.noop,e)4!==f.readyState&&f.abort();else{j={},h=f.status,\"string\"==typeof f.responseText&&(j.text=f.responseText);try{i=f.statusText}catch(k){i=\"\"}h||!a.isLocal||a.crossDomain?1223===h&&(h=204):h=j.text?200:404}j&&d(h,i,j,f.getAllResponseHeaders())},a.async?4===f.readyState?setTimeout(b):f.onreadystatechange=Xb[g]=b:b()},abort:function(){b&&b(void 0,!0)}}}});function Zb(){try{return new a.XMLHttpRequest}catch(b){}}function $b(){try{return new a.ActiveXObject(\"Microsoft.XMLHTTP\")}catch(b){}}m.ajaxSetup({accepts:{script:\"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript\"},contents:{script:/(?:java|ecma)script/},converters:{\"text script\":function(a){return m.globalEval(a),a}}}),m.ajaxPrefilter(\"script\",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type=\"GET\",a.global=!1)}),m.ajaxTransport(\"script\",function(a){if(a.crossDomain){var b,c=y.head||m(\"head\")[0]||y.documentElement;return{send:function(d,e){b=y.createElement(\"script\"),b.async=!0,a.scriptCharset&&(b.charset=a.scriptCharset),b.src=a.url,b.onload=b.onreadystatechange=function(a,c){(c||!b.readyState||/loaded|complete/.test(b.readyState))&&(b.onload=b.onreadystatechange=null,b.parentNode&&b.parentNode.removeChild(b),b=null,c||e(200,\"success\"))},c.insertBefore(b,c.firstChild)},abort:function(){b&&b.onload(void 0,!0)}}}});var _b=[],ac=/(=)\\?(?=&|$)|\\?\\?/;m.ajaxSetup({jsonp:\"callback\",jsonpCallback:function(){var a=_b.pop()||m.expando+\"_\"+vb++;return this[a]=!0,a}}),m.ajaxPrefilter(\"json jsonp\",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(ac.test(b.url)?\"url\":\"string\"==typeof b.data&&!(b.contentType||\"\").indexOf(\"application/x-www-form-urlencoded\")&&ac.test(b.data)&&\"data\");return h||\"jsonp\"===b.dataTypes[0]?(e=b.jsonpCallback=m.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(ac,\"$1\"+e):b.jsonp!==!1&&(b.url+=(wb.test(b.url)?\"&\":\"?\")+b.jsonp+\"=\"+e),b.converters[\"script json\"]=function(){return g||m.error(e+\" was not called\"),g[0]},b.dataTypes[0]=\"json\",f=a[e],a[e]=function(){g=arguments},d.always(function(){a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,_b.push(e)),g&&m.isFunction(f)&&f(g[0]),g=f=void 0}),\"script\"):void 0}),m.parseHTML=function(a,b,c){if(!a||\"string\"!=typeof a)return null;\"boolean\"==typeof b&&(c=b,b=!1),b=b||y;var d=u.exec(a),e=!c&&[];return d?[b.createElement(d[1])]:(d=m.buildFragment([a],b,e),e&&e.length&&m(e).remove(),m.merge([],d.childNodes))};var bc=m.fn.load;m.fn.load=function(a,b,c){if(\"string\"!=typeof a&&bc)return bc.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(\" \");return h>=0&&(d=m.trim(a.slice(h,a.length)),a=a.slice(0,h)),m.isFunction(b)?(c=b,b=void 0):b&&\"object\"==typeof b&&(f=\"POST\"),g.length>0&&m.ajax({url:a,type:f,dataType:\"html\",data:b}).done(function(a){e=arguments,g.html(d?m(\"<div>\").append(m.parseHTML(a)).find(d):a)}).complete(c&&function(a,b){g.each(c,e||[a.responseText,b,a])}),this},m.each([\"ajaxStart\",\"ajaxStop\",\"ajaxComplete\",\"ajaxError\",\"ajaxSuccess\",\"ajaxSend\"],function(a,b){m.fn[b]=function(a){return this.on(b,a)}}),m.expr.filters.animated=function(a){return m.grep(m.timers,function(b){return a===b.elem}).length};var cc=a.document.documentElement;function dc(a){return m.isWindow(a)?a:9===a.nodeType?a.defaultView||a.parentWindow:!1}m.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=m.css(a,\"position\"),l=m(a),n={};\"static\"===k&&(a.style.position=\"relative\"),h=l.offset(),f=m.css(a,\"top\"),i=m.css(a,\"left\"),j=(\"absolute\"===k||\"fixed\"===k)&&m.inArray(\"auto\",[f,i])>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),m.isFunction(b)&&(b=b.call(a,c,h)),null!=b.top&&(n.top=b.top-h.top+g),null!=b.left&&(n.left=b.left-h.left+e),\"using\"in b?b.using.call(a,n):l.css(n)}},m.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){m.offset.setOffset(this,a,b)});var b,c,d={top:0,left:0},e=this[0],f=e&&e.ownerDocument;if(f)return b=f.documentElement,m.contains(b,e)?(typeof e.getBoundingClientRect!==K&&(d=e.getBoundingClientRect()),c=dc(f),{top:d.top+(c.pageYOffset||b.scrollTop)-(b.clientTop||0),left:d.left+(c.pageXOffset||b.scrollLeft)-(b.clientLeft||0)}):d},position:function(){if(this[0]){var a,b,c={top:0,left:0},d=this[0];return\"fixed\"===m.css(d,\"position\")?b=d.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),m.nodeName(a[0],\"html\")||(c=a.offset()),c.top+=m.css(a[0],\"borderTopWidth\",!0),c.left+=m.css(a[0],\"borderLeftWidth\",!0)),{top:b.top-c.top-m.css(d,\"marginTop\",!0),left:b.left-c.left-m.css(d,\"marginLeft\",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent||cc;while(a&&!m.nodeName(a,\"html\")&&\"static\"===m.css(a,\"position\"))a=a.offsetParent;return a||cc})}}),m.each({scrollLeft:\"pageXOffset\",scrollTop:\"pageYOffset\"},function(a,b){var c=/Y/.test(b);m.fn[a]=function(d){return V(this,function(a,d,e){var f=dc(a);return void 0===e?f?b in f?f[b]:f.document.documentElement[d]:a[d]:void(f?f.scrollTo(c?m(f).scrollLeft():e,c?e:m(f).scrollTop()):a[d]=e)},a,d,arguments.length,null)}}),m.each([\"top\",\"left\"],function(a,b){m.cssHooks[b]=La(k.pixelPosition,function(a,c){return c?(c=Ja(a,b),Ha.test(c)?m(a).position()[b]+\"px\":c):void 0})}),m.each({Height:\"height\",Width:\"width\"},function(a,b){m.each({padding:\"inner\"+a,content:b,\"\":\"outer\"+a},function(c,d){m.fn[d]=function(d,e){var f=arguments.length&&(c||\"boolean\"!=typeof d),g=c||(d===!0||e===!0?\"margin\":\"border\");return V(this,function(b,c,d){var e;return m.isWindow(b)?b.document.documentElement[\"client\"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body[\"scroll\"+a],e[\"scroll\"+a],b.body[\"offset\"+a],e[\"offset\"+a],e[\"client\"+a])):void 0===d?m.css(b,c,g):m.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),m.fn.size=function(){return this.length},m.fn.andSelf=m.fn.addBack,\"function\"==typeof define&&define.amd&&define(\"jquery\",[],function(){return m});var ec=a.jQuery,fc=a.$;return m.noConflict=function(b){return a.$===m&&(a.$=fc),b&&a.jQuery===m&&(a.jQuery=ec),m},typeof b===K&&(a.jQuery=a.$=m),m});\n//# sourceMappingURL=jquery.min.map"

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(9))

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = "//     Underscore.js 1.8.3\n//     http://underscorejs.org\n//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors\n//     Underscore may be freely distributed under the MIT license.\n(function(){function n(n){function t(t,r,e,u,i,o){for(;i>=0&&o>i;i+=n){var a=u?u[i]:i;e=r(e,t[a],a,t)}return e}return function(r,e,u,i){e=b(e,i,4);var o=!k(r)&&m.keys(r),a=(o||r).length,c=n>0?0:a-1;return arguments.length<3&&(u=r[o?o[c]:c],c+=n),t(r,e,u,o,c,a)}}function t(n){return function(t,r,e){r=x(r,e);for(var u=O(t),i=n>0?0:u-1;i>=0&&u>i;i+=n)if(r(t[i],i,t))return i;return-1}}function r(n,t,r){return function(e,u,i){var o=0,a=O(e);if(\"number\"==typeof i)n>0?o=i>=0?i:Math.max(i+a,o):a=i>=0?Math.min(i+1,a):i+a+1;else if(r&&i&&a)return i=r(e,u),e[i]===u?i:-1;if(u!==u)return i=t(l.call(e,o,a),m.isNaN),i>=0?i+o:-1;for(i=n>0?o:a-1;i>=0&&a>i;i+=n)if(e[i]===u)return i;return-1}}function e(n,t){var r=I.length,e=n.constructor,u=m.isFunction(e)&&e.prototype||a,i=\"constructor\";for(m.has(n,i)&&!m.contains(t,i)&&t.push(i);r--;)i=I[r],i in n&&n[i]!==u[i]&&!m.contains(t,i)&&t.push(i)}var u=this,i=u._,o=Array.prototype,a=Object.prototype,c=Function.prototype,f=o.push,l=o.slice,s=a.toString,p=a.hasOwnProperty,h=Array.isArray,v=Object.keys,g=c.bind,y=Object.create,d=function(){},m=function(n){return n instanceof m?n:this instanceof m?void(this._wrapped=n):new m(n)};\"undefined\"!=typeof exports?(\"undefined\"!=typeof module&&module.exports&&(exports=module.exports=m),exports._=m):u._=m,m.VERSION=\"1.8.3\";var b=function(n,t,r){if(t===void 0)return n;switch(null==r?3:r){case 1:return function(r){return n.call(t,r)};case 2:return function(r,e){return n.call(t,r,e)};case 3:return function(r,e,u){return n.call(t,r,e,u)};case 4:return function(r,e,u,i){return n.call(t,r,e,u,i)}}return function(){return n.apply(t,arguments)}},x=function(n,t,r){return null==n?m.identity:m.isFunction(n)?b(n,t,r):m.isObject(n)?m.matcher(n):m.property(n)};m.iteratee=function(n,t){return x(n,t,1/0)};var _=function(n,t){return function(r){var e=arguments.length;if(2>e||null==r)return r;for(var u=1;e>u;u++)for(var i=arguments[u],o=n(i),a=o.length,c=0;a>c;c++){var f=o[c];t&&r[f]!==void 0||(r[f]=i[f])}return r}},j=function(n){if(!m.isObject(n))return{};if(y)return y(n);d.prototype=n;var t=new d;return d.prototype=null,t},w=function(n){return function(t){return null==t?void 0:t[n]}},A=Math.pow(2,53)-1,O=w(\"length\"),k=function(n){var t=O(n);return\"number\"==typeof t&&t>=0&&A>=t};m.each=m.forEach=function(n,t,r){t=b(t,r);var e,u;if(k(n))for(e=0,u=n.length;u>e;e++)t(n[e],e,n);else{var i=m.keys(n);for(e=0,u=i.length;u>e;e++)t(n[i[e]],i[e],n)}return n},m.map=m.collect=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=Array(u),o=0;u>o;o++){var a=e?e[o]:o;i[o]=t(n[a],a,n)}return i},m.reduce=m.foldl=m.inject=n(1),m.reduceRight=m.foldr=n(-1),m.find=m.detect=function(n,t,r){var e;return e=k(n)?m.findIndex(n,t,r):m.findKey(n,t,r),e!==void 0&&e!==-1?n[e]:void 0},m.filter=m.select=function(n,t,r){var e=[];return t=x(t,r),m.each(n,function(n,r,u){t(n,r,u)&&e.push(n)}),e},m.reject=function(n,t,r){return m.filter(n,m.negate(x(t)),r)},m.every=m.all=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=0;u>i;i++){var o=e?e[i]:i;if(!t(n[o],o,n))return!1}return!0},m.some=m.any=function(n,t,r){t=x(t,r);for(var e=!k(n)&&m.keys(n),u=(e||n).length,i=0;u>i;i++){var o=e?e[i]:i;if(t(n[o],o,n))return!0}return!1},m.contains=m.includes=m.include=function(n,t,r,e){return k(n)||(n=m.values(n)),(\"number\"!=typeof r||e)&&(r=0),m.indexOf(n,t,r)>=0},m.invoke=function(n,t){var r=l.call(arguments,2),e=m.isFunction(t);return m.map(n,function(n){var u=e?t:n[t];return null==u?u:u.apply(n,r)})},m.pluck=function(n,t){return m.map(n,m.property(t))},m.where=function(n,t){return m.filter(n,m.matcher(t))},m.findWhere=function(n,t){return m.find(n,m.matcher(t))},m.max=function(n,t,r){var e,u,i=-1/0,o=-1/0;if(null==t&&null!=n){n=k(n)?n:m.values(n);for(var a=0,c=n.length;c>a;a++)e=n[a],e>i&&(i=e)}else t=x(t,r),m.each(n,function(n,r,e){u=t(n,r,e),(u>o||u===-1/0&&i===-1/0)&&(i=n,o=u)});return i},m.min=function(n,t,r){var e,u,i=1/0,o=1/0;if(null==t&&null!=n){n=k(n)?n:m.values(n);for(var a=0,c=n.length;c>a;a++)e=n[a],i>e&&(i=e)}else t=x(t,r),m.each(n,function(n,r,e){u=t(n,r,e),(o>u||1/0===u&&1/0===i)&&(i=n,o=u)});return i},m.shuffle=function(n){for(var t,r=k(n)?n:m.values(n),e=r.length,u=Array(e),i=0;e>i;i++)t=m.random(0,i),t!==i&&(u[i]=u[t]),u[t]=r[i];return u},m.sample=function(n,t,r){return null==t||r?(k(n)||(n=m.values(n)),n[m.random(n.length-1)]):m.shuffle(n).slice(0,Math.max(0,t))},m.sortBy=function(n,t,r){return t=x(t,r),m.pluck(m.map(n,function(n,r,e){return{value:n,index:r,criteria:t(n,r,e)}}).sort(function(n,t){var r=n.criteria,e=t.criteria;if(r!==e){if(r>e||r===void 0)return 1;if(e>r||e===void 0)return-1}return n.index-t.index}),\"value\")};var F=function(n){return function(t,r,e){var u={};return r=x(r,e),m.each(t,function(e,i){var o=r(e,i,t);n(u,e,o)}),u}};m.groupBy=F(function(n,t,r){m.has(n,r)?n[r].push(t):n[r]=[t]}),m.indexBy=F(function(n,t,r){n[r]=t}),m.countBy=F(function(n,t,r){m.has(n,r)?n[r]++:n[r]=1}),m.toArray=function(n){return n?m.isArray(n)?l.call(n):k(n)?m.map(n,m.identity):m.values(n):[]},m.size=function(n){return null==n?0:k(n)?n.length:m.keys(n).length},m.partition=function(n,t,r){t=x(t,r);var e=[],u=[];return m.each(n,function(n,r,i){(t(n,r,i)?e:u).push(n)}),[e,u]},m.first=m.head=m.take=function(n,t,r){return null==n?void 0:null==t||r?n[0]:m.initial(n,n.length-t)},m.initial=function(n,t,r){return l.call(n,0,Math.max(0,n.length-(null==t||r?1:t)))},m.last=function(n,t,r){return null==n?void 0:null==t||r?n[n.length-1]:m.rest(n,Math.max(0,n.length-t))},m.rest=m.tail=m.drop=function(n,t,r){return l.call(n,null==t||r?1:t)},m.compact=function(n){return m.filter(n,m.identity)};var S=function(n,t,r,e){for(var u=[],i=0,o=e||0,a=O(n);a>o;o++){var c=n[o];if(k(c)&&(m.isArray(c)||m.isArguments(c))){t||(c=S(c,t,r));var f=0,l=c.length;for(u.length+=l;l>f;)u[i++]=c[f++]}else r||(u[i++]=c)}return u};m.flatten=function(n,t){return S(n,t,!1)},m.without=function(n){return m.difference(n,l.call(arguments,1))},m.uniq=m.unique=function(n,t,r,e){m.isBoolean(t)||(e=r,r=t,t=!1),null!=r&&(r=x(r,e));for(var u=[],i=[],o=0,a=O(n);a>o;o++){var c=n[o],f=r?r(c,o,n):c;t?(o&&i===f||u.push(c),i=f):r?m.contains(i,f)||(i.push(f),u.push(c)):m.contains(u,c)||u.push(c)}return u},m.union=function(){return m.uniq(S(arguments,!0,!0))},m.intersection=function(n){for(var t=[],r=arguments.length,e=0,u=O(n);u>e;e++){var i=n[e];if(!m.contains(t,i)){for(var o=1;r>o&&m.contains(arguments[o],i);o++);o===r&&t.push(i)}}return t},m.difference=function(n){var t=S(arguments,!0,!0,1);return m.filter(n,function(n){return!m.contains(t,n)})},m.zip=function(){return m.unzip(arguments)},m.unzip=function(n){for(var t=n&&m.max(n,O).length||0,r=Array(t),e=0;t>e;e++)r[e]=m.pluck(n,e);return r},m.object=function(n,t){for(var r={},e=0,u=O(n);u>e;e++)t?r[n[e]]=t[e]:r[n[e][0]]=n[e][1];return r},m.findIndex=t(1),m.findLastIndex=t(-1),m.sortedIndex=function(n,t,r,e){r=x(r,e,1);for(var u=r(t),i=0,o=O(n);o>i;){var a=Math.floor((i+o)/2);r(n[a])<u?i=a+1:o=a}return i},m.indexOf=r(1,m.findIndex,m.sortedIndex),m.lastIndexOf=r(-1,m.findLastIndex),m.range=function(n,t,r){null==t&&(t=n||0,n=0),r=r||1;for(var e=Math.max(Math.ceil((t-n)/r),0),u=Array(e),i=0;e>i;i++,n+=r)u[i]=n;return u};var E=function(n,t,r,e,u){if(!(e instanceof t))return n.apply(r,u);var i=j(n.prototype),o=n.apply(i,u);return m.isObject(o)?o:i};m.bind=function(n,t){if(g&&n.bind===g)return g.apply(n,l.call(arguments,1));if(!m.isFunction(n))throw new TypeError(\"Bind must be called on a function\");var r=l.call(arguments,2),e=function(){return E(n,e,t,this,r.concat(l.call(arguments)))};return e},m.partial=function(n){var t=l.call(arguments,1),r=function(){for(var e=0,u=t.length,i=Array(u),o=0;u>o;o++)i[o]=t[o]===m?arguments[e++]:t[o];for(;e<arguments.length;)i.push(arguments[e++]);return E(n,r,this,this,i)};return r},m.bindAll=function(n){var t,r,e=arguments.length;if(1>=e)throw new Error(\"bindAll must be passed function names\");for(t=1;e>t;t++)r=arguments[t],n[r]=m.bind(n[r],n);return n},m.memoize=function(n,t){var r=function(e){var u=r.cache,i=\"\"+(t?t.apply(this,arguments):e);return m.has(u,i)||(u[i]=n.apply(this,arguments)),u[i]};return r.cache={},r},m.delay=function(n,t){var r=l.call(arguments,2);return setTimeout(function(){return n.apply(null,r)},t)},m.defer=m.partial(m.delay,m,1),m.throttle=function(n,t,r){var e,u,i,o=null,a=0;r||(r={});var c=function(){a=r.leading===!1?0:m.now(),o=null,i=n.apply(e,u),o||(e=u=null)};return function(){var f=m.now();a||r.leading!==!1||(a=f);var l=t-(f-a);return e=this,u=arguments,0>=l||l>t?(o&&(clearTimeout(o),o=null),a=f,i=n.apply(e,u),o||(e=u=null)):o||r.trailing===!1||(o=setTimeout(c,l)),i}},m.debounce=function(n,t,r){var e,u,i,o,a,c=function(){var f=m.now()-o;t>f&&f>=0?e=setTimeout(c,t-f):(e=null,r||(a=n.apply(i,u),e||(i=u=null)))};return function(){i=this,u=arguments,o=m.now();var f=r&&!e;return e||(e=setTimeout(c,t)),f&&(a=n.apply(i,u),i=u=null),a}},m.wrap=function(n,t){return m.partial(t,n)},m.negate=function(n){return function(){return!n.apply(this,arguments)}},m.compose=function(){var n=arguments,t=n.length-1;return function(){for(var r=t,e=n[t].apply(this,arguments);r--;)e=n[r].call(this,e);return e}},m.after=function(n,t){return function(){return--n<1?t.apply(this,arguments):void 0}},m.before=function(n,t){var r;return function(){return--n>0&&(r=t.apply(this,arguments)),1>=n&&(t=null),r}},m.once=m.partial(m.before,2);var M=!{toString:null}.propertyIsEnumerable(\"toString\"),I=[\"valueOf\",\"isPrototypeOf\",\"toString\",\"propertyIsEnumerable\",\"hasOwnProperty\",\"toLocaleString\"];m.keys=function(n){if(!m.isObject(n))return[];if(v)return v(n);var t=[];for(var r in n)m.has(n,r)&&t.push(r);return M&&e(n,t),t},m.allKeys=function(n){if(!m.isObject(n))return[];var t=[];for(var r in n)t.push(r);return M&&e(n,t),t},m.values=function(n){for(var t=m.keys(n),r=t.length,e=Array(r),u=0;r>u;u++)e[u]=n[t[u]];return e},m.mapObject=function(n,t,r){t=x(t,r);for(var e,u=m.keys(n),i=u.length,o={},a=0;i>a;a++)e=u[a],o[e]=t(n[e],e,n);return o},m.pairs=function(n){for(var t=m.keys(n),r=t.length,e=Array(r),u=0;r>u;u++)e[u]=[t[u],n[t[u]]];return e},m.invert=function(n){for(var t={},r=m.keys(n),e=0,u=r.length;u>e;e++)t[n[r[e]]]=r[e];return t},m.functions=m.methods=function(n){var t=[];for(var r in n)m.isFunction(n[r])&&t.push(r);return t.sort()},m.extend=_(m.allKeys),m.extendOwn=m.assign=_(m.keys),m.findKey=function(n,t,r){t=x(t,r);for(var e,u=m.keys(n),i=0,o=u.length;o>i;i++)if(e=u[i],t(n[e],e,n))return e},m.pick=function(n,t,r){var e,u,i={},o=n;if(null==o)return i;m.isFunction(t)?(u=m.allKeys(o),e=b(t,r)):(u=S(arguments,!1,!1,1),e=function(n,t,r){return t in r},o=Object(o));for(var a=0,c=u.length;c>a;a++){var f=u[a],l=o[f];e(l,f,o)&&(i[f]=l)}return i},m.omit=function(n,t,r){if(m.isFunction(t))t=m.negate(t);else{var e=m.map(S(arguments,!1,!1,1),String);t=function(n,t){return!m.contains(e,t)}}return m.pick(n,t,r)},m.defaults=_(m.allKeys,!0),m.create=function(n,t){var r=j(n);return t&&m.extendOwn(r,t),r},m.clone=function(n){return m.isObject(n)?m.isArray(n)?n.slice():m.extend({},n):n},m.tap=function(n,t){return t(n),n},m.isMatch=function(n,t){var r=m.keys(t),e=r.length;if(null==n)return!e;for(var u=Object(n),i=0;e>i;i++){var o=r[i];if(t[o]!==u[o]||!(o in u))return!1}return!0};var N=function(n,t,r,e){if(n===t)return 0!==n||1/n===1/t;if(null==n||null==t)return n===t;n instanceof m&&(n=n._wrapped),t instanceof m&&(t=t._wrapped);var u=s.call(n);if(u!==s.call(t))return!1;switch(u){case\"[object RegExp]\":case\"[object String]\":return\"\"+n==\"\"+t;case\"[object Number]\":return+n!==+n?+t!==+t:0===+n?1/+n===1/t:+n===+t;case\"[object Date]\":case\"[object Boolean]\":return+n===+t}var i=\"[object Array]\"===u;if(!i){if(\"object\"!=typeof n||\"object\"!=typeof t)return!1;var o=n.constructor,a=t.constructor;if(o!==a&&!(m.isFunction(o)&&o instanceof o&&m.isFunction(a)&&a instanceof a)&&\"constructor\"in n&&\"constructor\"in t)return!1}r=r||[],e=e||[];for(var c=r.length;c--;)if(r[c]===n)return e[c]===t;if(r.push(n),e.push(t),i){if(c=n.length,c!==t.length)return!1;for(;c--;)if(!N(n[c],t[c],r,e))return!1}else{var f,l=m.keys(n);if(c=l.length,m.keys(t).length!==c)return!1;for(;c--;)if(f=l[c],!m.has(t,f)||!N(n[f],t[f],r,e))return!1}return r.pop(),e.pop(),!0};m.isEqual=function(n,t){return N(n,t)},m.isEmpty=function(n){return null==n?!0:k(n)&&(m.isArray(n)||m.isString(n)||m.isArguments(n))?0===n.length:0===m.keys(n).length},m.isElement=function(n){return!(!n||1!==n.nodeType)},m.isArray=h||function(n){return\"[object Array]\"===s.call(n)},m.isObject=function(n){var t=typeof n;return\"function\"===t||\"object\"===t&&!!n},m.each([\"Arguments\",\"Function\",\"String\",\"Number\",\"Date\",\"RegExp\",\"Error\"],function(n){m[\"is\"+n]=function(t){return s.call(t)===\"[object \"+n+\"]\"}}),m.isArguments(arguments)||(m.isArguments=function(n){return m.has(n,\"callee\")}),\"function\"!=typeof/./&&\"object\"!=typeof Int8Array&&(m.isFunction=function(n){return\"function\"==typeof n||!1}),m.isFinite=function(n){return isFinite(n)&&!isNaN(parseFloat(n))},m.isNaN=function(n){return m.isNumber(n)&&n!==+n},m.isBoolean=function(n){return n===!0||n===!1||\"[object Boolean]\"===s.call(n)},m.isNull=function(n){return null===n},m.isUndefined=function(n){return n===void 0},m.has=function(n,t){return null!=n&&p.call(n,t)},m.noConflict=function(){return u._=i,this},m.identity=function(n){return n},m.constant=function(n){return function(){return n}},m.noop=function(){},m.property=w,m.propertyOf=function(n){return null==n?function(){}:function(t){return n[t]}},m.matcher=m.matches=function(n){return n=m.extendOwn({},n),function(t){return m.isMatch(t,n)}},m.times=function(n,t,r){var e=Array(Math.max(0,n));t=b(t,r,1);for(var u=0;n>u;u++)e[u]=t(u);return e},m.random=function(n,t){return null==t&&(t=n,n=0),n+Math.floor(Math.random()*(t-n+1))},m.now=Date.now||function(){return(new Date).getTime()};var B={\"&\":\"&amp;\",\"<\":\"&lt;\",\">\":\"&gt;\",'\"':\"&quot;\",\"'\":\"&#x27;\",\"`\":\"&#x60;\"},T=m.invert(B),R=function(n){var t=function(t){return n[t]},r=\"(?:\"+m.keys(n).join(\"|\")+\")\",e=RegExp(r),u=RegExp(r,\"g\");return function(n){return n=null==n?\"\":\"\"+n,e.test(n)?n.replace(u,t):n}};m.escape=R(B),m.unescape=R(T),m.result=function(n,t,r){var e=null==n?void 0:n[t];return e===void 0&&(e=r),m.isFunction(e)?e.call(n):e};var q=0;m.uniqueId=function(n){var t=++q+\"\";return n?n+t:t},m.templateSettings={evaluate:/<%([\\s\\S]+?)%>/g,interpolate:/<%=([\\s\\S]+?)%>/g,escape:/<%-([\\s\\S]+?)%>/g};var K=/(.)^/,z={\"'\":\"'\",\"\\\\\":\"\\\\\",\"\\r\":\"r\",\"\\n\":\"n\",\"\\u2028\":\"u2028\",\"\\u2029\":\"u2029\"},D=/\\\\|'|\\r|\\n|\\u2028|\\u2029/g,L=function(n){return\"\\\\\"+z[n]};m.template=function(n,t,r){!t&&r&&(t=r),t=m.defaults({},t,m.templateSettings);var e=RegExp([(t.escape||K).source,(t.interpolate||K).source,(t.evaluate||K).source].join(\"|\")+\"|$\",\"g\"),u=0,i=\"__p+='\";n.replace(e,function(t,r,e,o,a){return i+=n.slice(u,a).replace(D,L),u=a+t.length,r?i+=\"'+\\n((__t=(\"+r+\"))==null?'':_.escape(__t))+\\n'\":e?i+=\"'+\\n((__t=(\"+e+\"))==null?'':__t)+\\n'\":o&&(i+=\"';\\n\"+o+\"\\n__p+='\"),t}),i+=\"';\\n\",t.variable||(i=\"with(obj||{}){\\n\"+i+\"}\\n\"),i=\"var __t,__p='',__j=Array.prototype.join,\"+\"print=function(){__p+=__j.call(arguments,'');};\\n\"+i+\"return __p;\\n\";try{var o=new Function(t.variable||\"obj\",\"_\",i)}catch(a){throw a.source=i,a}var c=function(n){return o.call(this,n,m)},f=t.variable||\"obj\";return c.source=\"function(\"+f+\"){\\n\"+i+\"}\",c},m.chain=function(n){var t=m(n);return t._chain=!0,t};var P=function(n,t){return n._chain?m(t).chain():t};m.mixin=function(n){m.each(m.functions(n),function(t){var r=m[t]=n[t];m.prototype[t]=function(){var n=[this._wrapped];return f.apply(n,arguments),P(this,r.apply(m,n))}})},m.mixin(m),m.each([\"pop\",\"push\",\"reverse\",\"shift\",\"sort\",\"splice\",\"unshift\"],function(n){var t=o[n];m.prototype[n]=function(){var r=this._wrapped;return t.apply(r,arguments),\"shift\"!==n&&\"splice\"!==n||0!==r.length||delete r[0],P(this,r)}}),m.each([\"concat\",\"join\",\"slice\"],function(n){var t=o[n];m.prototype[n]=function(){return P(this,t.apply(this._wrapped,arguments))}}),m.prototype.value=function(){return this._wrapped},m.prototype.valueOf=m.prototype.toJSON=m.prototype.value,m.prototype.toString=function(){return\"\"+this._wrapped},\"function\"==typeof define&&define.amd&&define(\"underscore\",[],function(){return m})}).call(this);\n//# sourceMappingURL=underscore-min.map"

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(11))

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = "(function(t){var e=typeof self==\"object\"&&self.self==self&&self||typeof global==\"object\"&&global.global==global&&global;if(typeof define===\"function\"&&define.amd){define([\"underscore\",\"jquery\",\"exports\"],function(i,r,n){e.Backbone=t(e,n,i,r)})}else if(typeof exports!==\"undefined\"){var i=require(\"underscore\"),r;try{r=require(\"jquery\")}catch(n){}t(e,exports,i,r)}else{e.Backbone=t(e,{},e._,e.jQuery||e.Zepto||e.ender||e.$)}})(function(t,e,i,r){var n=t.Backbone;var s=Array.prototype.slice;e.VERSION=\"1.2.3\";e.$=r;e.noConflict=function(){t.Backbone=n;return this};e.emulateHTTP=false;e.emulateJSON=false;var a=function(t,e,r){switch(t){case 1:return function(){return i[e](this[r])};case 2:return function(t){return i[e](this[r],t)};case 3:return function(t,n){return i[e](this[r],h(t,this),n)};case 4:return function(t,n,s){return i[e](this[r],h(t,this),n,s)};default:return function(){var t=s.call(arguments);t.unshift(this[r]);return i[e].apply(i,t)}}};var o=function(t,e,r){i.each(e,function(e,n){if(i[n])t.prototype[n]=a(e,n,r)})};var h=function(t,e){if(i.isFunction(t))return t;if(i.isObject(t)&&!e._isModel(t))return u(t);if(i.isString(t))return function(e){return e.get(t)};return t};var u=function(t){var e=i.matches(t);return function(t){return e(t.attributes)}};var l=e.Events={};var c=/\\s+/;var f=function(t,e,r,n,s){var a=0,o;if(r&&typeof r===\"object\"){if(n!==void 0&&\"context\"in s&&s.context===void 0)s.context=n;for(o=i.keys(r);a<o.length;a++){e=f(t,e,o[a],r[o[a]],s)}}else if(r&&c.test(r)){for(o=r.split(c);a<o.length;a++){e=t(e,o[a],n,s)}}else{e=t(e,r,n,s)}return e};l.on=function(t,e,i){return d(this,t,e,i)};var d=function(t,e,i,r,n){t._events=f(v,t._events||{},e,i,{context:r,ctx:t,listening:n});if(n){var s=t._listeners||(t._listeners={});s[n.id]=n}return t};l.listenTo=function(t,e,r){if(!t)return this;var n=t._listenId||(t._listenId=i.uniqueId(\"l\"));var s=this._listeningTo||(this._listeningTo={});var a=s[n];if(!a){var o=this._listenId||(this._listenId=i.uniqueId(\"l\"));a=s[n]={obj:t,objId:n,id:o,listeningTo:s,count:0}}d(t,e,r,this,a);return this};var v=function(t,e,i,r){if(i){var n=t[e]||(t[e]=[]);var s=r.context,a=r.ctx,o=r.listening;if(o)o.count++;n.push({callback:i,context:s,ctx:s||a,listening:o})}return t};l.off=function(t,e,i){if(!this._events)return this;this._events=f(g,this._events,t,e,{context:i,listeners:this._listeners});return this};l.stopListening=function(t,e,r){var n=this._listeningTo;if(!n)return this;var s=t?[t._listenId]:i.keys(n);for(var a=0;a<s.length;a++){var o=n[s[a]];if(!o)break;o.obj.off(e,r,this)}if(i.isEmpty(n))this._listeningTo=void 0;return this};var g=function(t,e,r,n){if(!t)return;var s=0,a;var o=n.context,h=n.listeners;if(!e&&!r&&!o){var u=i.keys(h);for(;s<u.length;s++){a=h[u[s]];delete h[a.id];delete a.listeningTo[a.objId]}return}var l=e?[e]:i.keys(t);for(;s<l.length;s++){e=l[s];var c=t[e];if(!c)break;var f=[];for(var d=0;d<c.length;d++){var v=c[d];if(r&&r!==v.callback&&r!==v.callback._callback||o&&o!==v.context){f.push(v)}else{a=v.listening;if(a&&--a.count===0){delete h[a.id];delete a.listeningTo[a.objId]}}}if(f.length){t[e]=f}else{delete t[e]}}if(i.size(t))return t};l.once=function(t,e,r){var n=f(p,{},t,e,i.bind(this.off,this));return this.on(n,void 0,r)};l.listenToOnce=function(t,e,r){var n=f(p,{},e,r,i.bind(this.stopListening,this,t));return this.listenTo(t,n)};var p=function(t,e,r,n){if(r){var s=t[e]=i.once(function(){n(e,s);r.apply(this,arguments)});s._callback=r}return t};l.trigger=function(t){if(!this._events)return this;var e=Math.max(0,arguments.length-1);var i=Array(e);for(var r=0;r<e;r++)i[r]=arguments[r+1];f(m,this._events,t,void 0,i);return this};var m=function(t,e,i,r){if(t){var n=t[e];var s=t.all;if(n&&s)s=s.slice();if(n)_(n,r);if(s)_(s,[e].concat(r))}return t};var _=function(t,e){var i,r=-1,n=t.length,s=e[0],a=e[1],o=e[2];switch(e.length){case 0:while(++r<n)(i=t[r]).callback.call(i.ctx);return;case 1:while(++r<n)(i=t[r]).callback.call(i.ctx,s);return;case 2:while(++r<n)(i=t[r]).callback.call(i.ctx,s,a);return;case 3:while(++r<n)(i=t[r]).callback.call(i.ctx,s,a,o);return;default:while(++r<n)(i=t[r]).callback.apply(i.ctx,e);return}};l.bind=l.on;l.unbind=l.off;i.extend(e,l);var y=e.Model=function(t,e){var r=t||{};e||(e={});this.cid=i.uniqueId(this.cidPrefix);this.attributes={};if(e.collection)this.collection=e.collection;if(e.parse)r=this.parse(r,e)||{};r=i.defaults({},r,i.result(this,\"defaults\"));this.set(r,e);this.changed={};this.initialize.apply(this,arguments)};i.extend(y.prototype,l,{changed:null,validationError:null,idAttribute:\"id\",cidPrefix:\"c\",initialize:function(){},toJSON:function(t){return i.clone(this.attributes)},sync:function(){return e.sync.apply(this,arguments)},get:function(t){return this.attributes[t]},escape:function(t){return i.escape(this.get(t))},has:function(t){return this.get(t)!=null},matches:function(t){return!!i.iteratee(t,this)(this.attributes)},set:function(t,e,r){if(t==null)return this;var n;if(typeof t===\"object\"){n=t;r=e}else{(n={})[t]=e}r||(r={});if(!this._validate(n,r))return false;var s=r.unset;var a=r.silent;var o=[];var h=this._changing;this._changing=true;if(!h){this._previousAttributes=i.clone(this.attributes);this.changed={}}var u=this.attributes;var l=this.changed;var c=this._previousAttributes;for(var f in n){e=n[f];if(!i.isEqual(u[f],e))o.push(f);if(!i.isEqual(c[f],e)){l[f]=e}else{delete l[f]}s?delete u[f]:u[f]=e}this.id=this.get(this.idAttribute);if(!a){if(o.length)this._pending=r;for(var d=0;d<o.length;d++){this.trigger(\"change:\"+o[d],this,u[o[d]],r)}}if(h)return this;if(!a){while(this._pending){r=this._pending;this._pending=false;this.trigger(\"change\",this,r)}}this._pending=false;this._changing=false;return this},unset:function(t,e){return this.set(t,void 0,i.extend({},e,{unset:true}))},clear:function(t){var e={};for(var r in this.attributes)e[r]=void 0;return this.set(e,i.extend({},t,{unset:true}))},hasChanged:function(t){if(t==null)return!i.isEmpty(this.changed);return i.has(this.changed,t)},changedAttributes:function(t){if(!t)return this.hasChanged()?i.clone(this.changed):false;var e=this._changing?this._previousAttributes:this.attributes;var r={};for(var n in t){var s=t[n];if(i.isEqual(e[n],s))continue;r[n]=s}return i.size(r)?r:false},previous:function(t){if(t==null||!this._previousAttributes)return null;return this._previousAttributes[t]},previousAttributes:function(){return i.clone(this._previousAttributes)},fetch:function(t){t=i.extend({parse:true},t);var e=this;var r=t.success;t.success=function(i){var n=t.parse?e.parse(i,t):i;if(!e.set(n,t))return false;if(r)r.call(t.context,e,i,t);e.trigger(\"sync\",e,i,t)};z(this,t);return this.sync(\"read\",this,t)},save:function(t,e,r){var n;if(t==null||typeof t===\"object\"){n=t;r=e}else{(n={})[t]=e}r=i.extend({validate:true,parse:true},r);var s=r.wait;if(n&&!s){if(!this.set(n,r))return false}else{if(!this._validate(n,r))return false}var a=this;var o=r.success;var h=this.attributes;r.success=function(t){a.attributes=h;var e=r.parse?a.parse(t,r):t;if(s)e=i.extend({},n,e);if(e&&!a.set(e,r))return false;if(o)o.call(r.context,a,t,r);a.trigger(\"sync\",a,t,r)};z(this,r);if(n&&s)this.attributes=i.extend({},h,n);var u=this.isNew()?\"create\":r.patch?\"patch\":\"update\";if(u===\"patch\"&&!r.attrs)r.attrs=n;var l=this.sync(u,this,r);this.attributes=h;return l},destroy:function(t){t=t?i.clone(t):{};var e=this;var r=t.success;var n=t.wait;var s=function(){e.stopListening();e.trigger(\"destroy\",e,e.collection,t)};t.success=function(i){if(n)s();if(r)r.call(t.context,e,i,t);if(!e.isNew())e.trigger(\"sync\",e,i,t)};var a=false;if(this.isNew()){i.defer(t.success)}else{z(this,t);a=this.sync(\"delete\",this,t)}if(!n)s();return a},url:function(){var t=i.result(this,\"urlRoot\")||i.result(this.collection,\"url\")||F();if(this.isNew())return t;var e=this.get(this.idAttribute);return t.replace(/[^\\/]$/,\"$&/\")+encodeURIComponent(e)},parse:function(t,e){return t},clone:function(){return new this.constructor(this.attributes)},isNew:function(){return!this.has(this.idAttribute)},isValid:function(t){return this._validate({},i.defaults({validate:true},t))},_validate:function(t,e){if(!e.validate||!this.validate)return true;t=i.extend({},this.attributes,t);var r=this.validationError=this.validate(t,e)||null;if(!r)return true;this.trigger(\"invalid\",this,r,i.extend(e,{validationError:r}));return false}});var b={keys:1,values:1,pairs:1,invert:1,pick:0,omit:0,chain:1,isEmpty:1};o(y,b,\"attributes\");var x=e.Collection=function(t,e){e||(e={});if(e.model)this.model=e.model;if(e.comparator!==void 0)this.comparator=e.comparator;this._reset();this.initialize.apply(this,arguments);if(t)this.reset(t,i.extend({silent:true},e))};var w={add:true,remove:true,merge:true};var E={add:true,remove:false};var k=function(t,e,i){i=Math.min(Math.max(i,0),t.length);var r=Array(t.length-i);var n=e.length;for(var s=0;s<r.length;s++)r[s]=t[s+i];for(s=0;s<n;s++)t[s+i]=e[s];for(s=0;s<r.length;s++)t[s+n+i]=r[s]};i.extend(x.prototype,l,{model:y,initialize:function(){},toJSON:function(t){return this.map(function(e){return e.toJSON(t)})},sync:function(){return e.sync.apply(this,arguments)},add:function(t,e){return this.set(t,i.extend({merge:false},e,E))},remove:function(t,e){e=i.extend({},e);var r=!i.isArray(t);t=r?[t]:i.clone(t);var n=this._removeModels(t,e);if(!e.silent&&n)this.trigger(\"update\",this,e);return r?n[0]:n},set:function(t,e){if(t==null)return;e=i.defaults({},e,w);if(e.parse&&!this._isModel(t))t=this.parse(t,e);var r=!i.isArray(t);t=r?[t]:t.slice();var n=e.at;if(n!=null)n=+n;if(n<0)n+=this.length+1;var s=[];var a=[];var o=[];var h={};var u=e.add;var l=e.merge;var c=e.remove;var f=false;var d=this.comparator&&n==null&&e.sort!==false;var v=i.isString(this.comparator)?this.comparator:null;var g;for(var p=0;p<t.length;p++){g=t[p];var m=this.get(g);if(m){if(l&&g!==m){var _=this._isModel(g)?g.attributes:g;if(e.parse)_=m.parse(_,e);m.set(_,e);if(d&&!f)f=m.hasChanged(v)}if(!h[m.cid]){h[m.cid]=true;s.push(m)}t[p]=m}else if(u){g=t[p]=this._prepareModel(g,e);if(g){a.push(g);this._addReference(g,e);h[g.cid]=true;s.push(g)}}}if(c){for(p=0;p<this.length;p++){g=this.models[p];if(!h[g.cid])o.push(g)}if(o.length)this._removeModels(o,e)}var y=false;var b=!d&&u&&c;if(s.length&&b){y=this.length!=s.length||i.some(this.models,function(t,e){return t!==s[e]});this.models.length=0;k(this.models,s,0);this.length=this.models.length}else if(a.length){if(d)f=true;k(this.models,a,n==null?this.length:n);this.length=this.models.length}if(f)this.sort({silent:true});if(!e.silent){for(p=0;p<a.length;p++){if(n!=null)e.index=n+p;g=a[p];g.trigger(\"add\",g,this,e)}if(f||y)this.trigger(\"sort\",this,e);if(a.length||o.length)this.trigger(\"update\",this,e)}return r?t[0]:t},reset:function(t,e){e=e?i.clone(e):{};for(var r=0;r<this.models.length;r++){this._removeReference(this.models[r],e)}e.previousModels=this.models;this._reset();t=this.add(t,i.extend({silent:true},e));if(!e.silent)this.trigger(\"reset\",this,e);return t},push:function(t,e){return this.add(t,i.extend({at:this.length},e))},pop:function(t){var e=this.at(this.length-1);return this.remove(e,t)},unshift:function(t,e){return this.add(t,i.extend({at:0},e))},shift:function(t){var e=this.at(0);return this.remove(e,t)},slice:function(){return s.apply(this.models,arguments)},get:function(t){if(t==null)return void 0;var e=this.modelId(this._isModel(t)?t.attributes:t);return this._byId[t]||this._byId[e]||this._byId[t.cid]},at:function(t){if(t<0)t+=this.length;return this.models[t]},where:function(t,e){return this[e?\"find\":\"filter\"](t)},findWhere:function(t){return this.where(t,true)},sort:function(t){var e=this.comparator;if(!e)throw new Error(\"Cannot sort a set without a comparator\");t||(t={});var r=e.length;if(i.isFunction(e))e=i.bind(e,this);if(r===1||i.isString(e)){this.models=this.sortBy(e)}else{this.models.sort(e)}if(!t.silent)this.trigger(\"sort\",this,t);return this},pluck:function(t){return i.invoke(this.models,\"get\",t)},fetch:function(t){t=i.extend({parse:true},t);var e=t.success;var r=this;t.success=function(i){var n=t.reset?\"reset\":\"set\";r[n](i,t);if(e)e.call(t.context,r,i,t);r.trigger(\"sync\",r,i,t)};z(this,t);return this.sync(\"read\",this,t)},create:function(t,e){e=e?i.clone(e):{};var r=e.wait;t=this._prepareModel(t,e);if(!t)return false;if(!r)this.add(t,e);var n=this;var s=e.success;e.success=function(t,e,i){if(r)n.add(t,i);if(s)s.call(i.context,t,e,i)};t.save(null,e);return t},parse:function(t,e){return t},clone:function(){return new this.constructor(this.models,{model:this.model,comparator:this.comparator})},modelId:function(t){return t[this.model.prototype.idAttribute||\"id\"]},_reset:function(){this.length=0;this.models=[];this._byId={}},_prepareModel:function(t,e){if(this._isModel(t)){if(!t.collection)t.collection=this;return t}e=e?i.clone(e):{};e.collection=this;var r=new this.model(t,e);if(!r.validationError)return r;this.trigger(\"invalid\",this,r.validationError,e);return false},_removeModels:function(t,e){var i=[];for(var r=0;r<t.length;r++){var n=this.get(t[r]);if(!n)continue;var s=this.indexOf(n);this.models.splice(s,1);this.length--;if(!e.silent){e.index=s;n.trigger(\"remove\",n,this,e)}i.push(n);this._removeReference(n,e)}return i.length?i:false},_isModel:function(t){return t instanceof y},_addReference:function(t,e){this._byId[t.cid]=t;var i=this.modelId(t.attributes);if(i!=null)this._byId[i]=t;t.on(\"all\",this._onModelEvent,this)},_removeReference:function(t,e){delete this._byId[t.cid];var i=this.modelId(t.attributes);if(i!=null)delete this._byId[i];if(this===t.collection)delete t.collection;t.off(\"all\",this._onModelEvent,this)},_onModelEvent:function(t,e,i,r){if(e){if((t===\"add\"||t===\"remove\")&&i!==this)return;if(t===\"destroy\")this.remove(e,r);if(t===\"change\"){var n=this.modelId(e.previousAttributes());var s=this.modelId(e.attributes);if(n!==s){if(n!=null)delete this._byId[n];if(s!=null)this._byId[s]=e}}}this.trigger.apply(this,arguments)}});var S={forEach:3,each:3,map:3,collect:3,reduce:4,foldl:4,inject:4,reduceRight:4,foldr:4,find:3,detect:3,filter:3,select:3,reject:3,every:3,all:3,some:3,any:3,include:3,includes:3,contains:3,invoke:0,max:3,min:3,toArray:1,size:1,first:3,head:3,take:3,initial:3,rest:3,tail:3,drop:3,last:3,without:0,difference:0,indexOf:3,shuffle:1,lastIndexOf:3,isEmpty:1,chain:1,sample:3,partition:3,groupBy:3,countBy:3,sortBy:3,indexBy:3};o(x,S,\"models\");var I=e.View=function(t){this.cid=i.uniqueId(\"view\");i.extend(this,i.pick(t,P));this._ensureElement();this.initialize.apply(this,arguments)};var T=/^(\\S+)\\s*(.*)$/;var P=[\"model\",\"collection\",\"el\",\"id\",\"attributes\",\"className\",\"tagName\",\"events\"];i.extend(I.prototype,l,{tagName:\"div\",$:function(t){return this.$el.find(t)},initialize:function(){},render:function(){return this},remove:function(){this._removeElement();this.stopListening();return this},_removeElement:function(){this.$el.remove()},setElement:function(t){this.undelegateEvents();this._setElement(t);this.delegateEvents();return this},_setElement:function(t){this.$el=t instanceof e.$?t:e.$(t);this.el=this.$el[0]},delegateEvents:function(t){t||(t=i.result(this,\"events\"));if(!t)return this;this.undelegateEvents();for(var e in t){var r=t[e];if(!i.isFunction(r))r=this[r];if(!r)continue;var n=e.match(T);this.delegate(n[1],n[2],i.bind(r,this))}return this},delegate:function(t,e,i){this.$el.on(t+\".delegateEvents\"+this.cid,e,i);return this},undelegateEvents:function(){if(this.$el)this.$el.off(\".delegateEvents\"+this.cid);return this},undelegate:function(t,e,i){this.$el.off(t+\".delegateEvents\"+this.cid,e,i);return this},_createElement:function(t){return document.createElement(t)},_ensureElement:function(){if(!this.el){var t=i.extend({},i.result(this,\"attributes\"));if(this.id)t.id=i.result(this,\"id\");if(this.className)t[\"class\"]=i.result(this,\"className\");this.setElement(this._createElement(i.result(this,\"tagName\")));this._setAttributes(t)}else{this.setElement(i.result(this,\"el\"))}},_setAttributes:function(t){this.$el.attr(t)}});e.sync=function(t,r,n){var s=H[t];i.defaults(n||(n={}),{emulateHTTP:e.emulateHTTP,emulateJSON:e.emulateJSON});var a={type:s,dataType:\"json\"};if(!n.url){a.url=i.result(r,\"url\")||F()}if(n.data==null&&r&&(t===\"create\"||t===\"update\"||t===\"patch\")){a.contentType=\"application/json\";a.data=JSON.stringify(n.attrs||r.toJSON(n))}if(n.emulateJSON){a.contentType=\"application/x-www-form-urlencoded\";a.data=a.data?{model:a.data}:{}}if(n.emulateHTTP&&(s===\"PUT\"||s===\"DELETE\"||s===\"PATCH\")){a.type=\"POST\";if(n.emulateJSON)a.data._method=s;var o=n.beforeSend;n.beforeSend=function(t){t.setRequestHeader(\"X-HTTP-Method-Override\",s);if(o)return o.apply(this,arguments)}}if(a.type!==\"GET\"&&!n.emulateJSON){a.processData=false}var h=n.error;n.error=function(t,e,i){n.textStatus=e;n.errorThrown=i;if(h)h.call(n.context,t,e,i)};var u=n.xhr=e.ajax(i.extend(a,n));r.trigger(\"request\",r,u,n);return u};var H={create:\"POST\",update:\"PUT\",patch:\"PATCH\",\"delete\":\"DELETE\",read:\"GET\"};e.ajax=function(){return e.$.ajax.apply(e.$,arguments)};var $=e.Router=function(t){t||(t={});if(t.routes)this.routes=t.routes;this._bindRoutes();this.initialize.apply(this,arguments)};var A=/\\((.*?)\\)/g;var C=/(\\(\\?)?:\\w+/g;var R=/\\*\\w+/g;var j=/[\\-{}\\[\\]+?.,\\\\\\^$|#\\s]/g;i.extend($.prototype,l,{initialize:function(){},route:function(t,r,n){if(!i.isRegExp(t))t=this._routeToRegExp(t);if(i.isFunction(r)){n=r;r=\"\"}if(!n)n=this[r];var s=this;e.history.route(t,function(i){var a=s._extractParameters(t,i);if(s.execute(n,a,r)!==false){s.trigger.apply(s,[\"route:\"+r].concat(a));s.trigger(\"route\",r,a);e.history.trigger(\"route\",s,r,a)}});return this},execute:function(t,e,i){if(t)t.apply(this,e)},navigate:function(t,i){e.history.navigate(t,i);return this},_bindRoutes:function(){if(!this.routes)return;this.routes=i.result(this,\"routes\");var t,e=i.keys(this.routes);while((t=e.pop())!=null){this.route(t,this.routes[t])}},_routeToRegExp:function(t){t=t.replace(j,\"\\\\$&\").replace(A,\"(?:$1)?\").replace(C,function(t,e){return e?t:\"([^/?]+)\"}).replace(R,\"([^?]*?)\");return new RegExp(\"^\"+t+\"(?:\\\\?([\\\\s\\\\S]*))?$\")},_extractParameters:function(t,e){var r=t.exec(e).slice(1);return i.map(r,function(t,e){if(e===r.length-1)return t||null;return t?decodeURIComponent(t):null})}});var M=e.History=function(){this.handlers=[];this.checkUrl=i.bind(this.checkUrl,this);if(typeof window!==\"undefined\"){this.location=window.location;this.history=window.history}};var N=/^[#\\/]|\\s+$/g;var O=/^\\/+|\\/+$/g;var U=/#.*$/;M.started=false;i.extend(M.prototype,l,{interval:50,atRoot:function(){var t=this.location.pathname.replace(/[^\\/]$/,\"$&/\");return t===this.root&&!this.getSearch()},matchRoot:function(){var t=this.decodeFragment(this.location.pathname);var e=t.slice(0,this.root.length-1)+\"/\";return e===this.root},decodeFragment:function(t){return decodeURI(t.replace(/%25/g,\"%2525\"))},getSearch:function(){var t=this.location.href.replace(/#.*/,\"\").match(/\\?.+/);return t?t[0]:\"\"},getHash:function(t){var e=(t||this).location.href.match(/#(.*)$/);return e?e[1]:\"\"},getPath:function(){var t=this.decodeFragment(this.location.pathname+this.getSearch()).slice(this.root.length-1);return t.charAt(0)===\"/\"?t.slice(1):t},getFragment:function(t){if(t==null){if(this._usePushState||!this._wantsHashChange){t=this.getPath()}else{t=this.getHash()}}return t.replace(N,\"\")},start:function(t){if(M.started)throw new Error(\"Backbone.history has already been started\");M.started=true;this.options=i.extend({root:\"/\"},this.options,t);this.root=this.options.root;this._wantsHashChange=this.options.hashChange!==false;this._hasHashChange=\"onhashchange\"in window&&(document.documentMode===void 0||document.documentMode>7);this._useHashChange=this._wantsHashChange&&this._hasHashChange;this._wantsPushState=!!this.options.pushState;this._hasPushState=!!(this.history&&this.history.pushState);this._usePushState=this._wantsPushState&&this._hasPushState;this.fragment=this.getFragment();this.root=(\"/\"+this.root+\"/\").replace(O,\"/\");if(this._wantsHashChange&&this._wantsPushState){if(!this._hasPushState&&!this.atRoot()){var e=this.root.slice(0,-1)||\"/\";this.location.replace(e+\"#\"+this.getPath());return true}else if(this._hasPushState&&this.atRoot()){this.navigate(this.getHash(),{replace:true})}}if(!this._hasHashChange&&this._wantsHashChange&&!this._usePushState){this.iframe=document.createElement(\"iframe\");this.iframe.src=\"javascript:0\";this.iframe.style.display=\"none\";this.iframe.tabIndex=-1;var r=document.body;var n=r.insertBefore(this.iframe,r.firstChild).contentWindow;n.document.open();n.document.close();n.location.hash=\"#\"+this.fragment}var s=window.addEventListener||function(t,e){return attachEvent(\"on\"+t,e)};if(this._usePushState){s(\"popstate\",this.checkUrl,false)}else if(this._useHashChange&&!this.iframe){s(\"hashchange\",this.checkUrl,false)}else if(this._wantsHashChange){this._checkUrlInterval=setInterval(this.checkUrl,this.interval)}if(!this.options.silent)return this.loadUrl()},stop:function(){var t=window.removeEventListener||function(t,e){return detachEvent(\"on\"+t,e)};if(this._usePushState){t(\"popstate\",this.checkUrl,false)}else if(this._useHashChange&&!this.iframe){t(\"hashchange\",this.checkUrl,false)}if(this.iframe){document.body.removeChild(this.iframe);this.iframe=null}if(this._checkUrlInterval)clearInterval(this._checkUrlInterval);M.started=false},route:function(t,e){this.handlers.unshift({route:t,callback:e})},checkUrl:function(t){var e=this.getFragment();if(e===this.fragment&&this.iframe){e=this.getHash(this.iframe.contentWindow)}if(e===this.fragment)return false;if(this.iframe)this.navigate(e);this.loadUrl()},loadUrl:function(t){if(!this.matchRoot())return false;t=this.fragment=this.getFragment(t);return i.some(this.handlers,function(e){if(e.route.test(t)){e.callback(t);return true}})},navigate:function(t,e){if(!M.started)return false;if(!e||e===true)e={trigger:!!e};t=this.getFragment(t||\"\");var i=this.root;if(t===\"\"||t.charAt(0)===\"?\"){i=i.slice(0,-1)||\"/\"}var r=i+t;t=this.decodeFragment(t.replace(U,\"\"));if(this.fragment===t)return;this.fragment=t;if(this._usePushState){this.history[e.replace?\"replaceState\":\"pushState\"]({},document.title,r)}else if(this._wantsHashChange){this._updateHash(this.location,t,e.replace);if(this.iframe&&t!==this.getHash(this.iframe.contentWindow)){var n=this.iframe.contentWindow;if(!e.replace){n.document.open();n.document.close()}this._updateHash(n.location,t,e.replace)}}else{return this.location.assign(r)}if(e.trigger)return this.loadUrl(t)},_updateHash:function(t,e,i){if(i){var r=t.href.replace(/(javascript:|#).*$/,\"\");t.replace(r+\"#\"+e)}else{t.hash=\"#\"+e}}});e.history=new M;var q=function(t,e){var r=this;var n;if(t&&i.has(t,\"constructor\")){n=t.constructor}else{n=function(){return r.apply(this,arguments)}}i.extend(n,r,e);var s=function(){this.constructor=n};s.prototype=r.prototype;n.prototype=new s;if(t)i.extend(n.prototype,t);n.__super__=r.prototype;return n};y.extend=x.extend=$.extend=I.extend=M.extend=q;var F=function(){throw new Error('A \"url\" property or function must be specified')};var z=function(t,e){var i=e.error;e.error=function(r){if(i)i.call(e.context,t,r,e);t.trigger(\"error\",t,r,e)}};return e});\n//# sourceMappingURL=backbone-min.map\n"

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(13))

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = "/*!\n\n handlebars v1.3.0\n\nCopyright (C) 2011 by Yehuda Katz\n\nPermission is hereby granted, free of charge, to any person obtaining a copy\nof this software and associated documentation files (the \"Software\"), to deal\nin the Software without restriction, including without limitation the rights\nto use, copy, modify, merge, publish, distribute, sublicense, and/or sell\ncopies of the Software, and to permit persons to whom the Software is\nfurnished to do so, subject to the following conditions:\n\nThe above copyright notice and this permission notice shall be included in\nall copies or substantial portions of the Software.\n\nTHE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\nIMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\nFITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\nAUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\nLIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\nOUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\nTHE SOFTWARE.\n\n@license\n*/\nvar Handlebars=function(){var a=function(){\"use strict\";function a(a){this.string=a}var b;return a.prototype.toString=function(){return\"\"+this.string},b=a}(),b=function(a){\"use strict\";function b(a){return h[a]||\"&amp;\"}function c(a,b){for(var c in b)Object.prototype.hasOwnProperty.call(b,c)&&(a[c]=b[c])}function d(a){return a instanceof g?a.toString():a||0===a?(a=\"\"+a,j.test(a)?a.replace(i,b):a):\"\"}function e(a){return a||0===a?m(a)&&0===a.length?!0:!1:!0}var f={},g=a,h={\"&\":\"&amp;\",\"<\":\"&lt;\",\">\":\"&gt;\",'\"':\"&quot;\",\"'\":\"&#x27;\",\"`\":\"&#x60;\"},i=/[&<>\"'`]/g,j=/[&<>\"'`]/;f.extend=c;var k=Object.prototype.toString;f.toString=k;var l=function(a){return\"function\"==typeof a};l(/x/)&&(l=function(a){return\"function\"==typeof a&&\"[object Function]\"===k.call(a)});var l;f.isFunction=l;var m=Array.isArray||function(a){return a&&\"object\"==typeof a?\"[object Array]\"===k.call(a):!1};return f.isArray=m,f.escapeExpression=d,f.isEmpty=e,f}(a),c=function(){\"use strict\";function a(a,b){var d;b&&b.firstLine&&(d=b.firstLine,a+=\" - \"+d+\":\"+b.firstColumn);for(var e=Error.prototype.constructor.call(this,a),f=0;f<c.length;f++)this[c[f]]=e[c[f]];d&&(this.lineNumber=d,this.column=b.firstColumn)}var b,c=[\"description\",\"fileName\",\"lineNumber\",\"message\",\"name\",\"number\",\"stack\"];return a.prototype=new Error,b=a}(),d=function(a,b){\"use strict\";function c(a,b){this.helpers=a||{},this.partials=b||{},d(this)}function d(a){a.registerHelper(\"helperMissing\",function(a){if(2===arguments.length)return void 0;throw new h(\"Missing helper: '\"+a+\"'\")}),a.registerHelper(\"blockHelperMissing\",function(b,c){var d=c.inverse||function(){},e=c.fn;return m(b)&&(b=b.call(this)),b===!0?e(this):b===!1||null==b?d(this):l(b)?b.length>0?a.helpers.each(b,c):d(this):e(b)}),a.registerHelper(\"each\",function(a,b){var c,d=b.fn,e=b.inverse,f=0,g=\"\";if(m(a)&&(a=a.call(this)),b.data&&(c=q(b.data)),a&&\"object\"==typeof a)if(l(a))for(var h=a.length;h>f;f++)c&&(c.index=f,c.first=0===f,c.last=f===a.length-1),g+=d(a[f],{data:c});else for(var i in a)a.hasOwnProperty(i)&&(c&&(c.key=i,c.index=f,c.first=0===f),g+=d(a[i],{data:c}),f++);return 0===f&&(g=e(this)),g}),a.registerHelper(\"if\",function(a,b){return m(a)&&(a=a.call(this)),!b.hash.includeZero&&!a||g.isEmpty(a)?b.inverse(this):b.fn(this)}),a.registerHelper(\"unless\",function(b,c){return a.helpers[\"if\"].call(this,b,{fn:c.inverse,inverse:c.fn,hash:c.hash})}),a.registerHelper(\"with\",function(a,b){return m(a)&&(a=a.call(this)),g.isEmpty(a)?void 0:b.fn(a)}),a.registerHelper(\"log\",function(b,c){var d=c.data&&null!=c.data.level?parseInt(c.data.level,10):1;a.log(d,b)})}function e(a,b){p.log(a,b)}var f={},g=a,h=b,i=\"1.3.0\";f.VERSION=i;var j=4;f.COMPILER_REVISION=j;var k={1:\"<= 1.0.rc.2\",2:\"== 1.0.0-rc.3\",3:\"== 1.0.0-rc.4\",4:\">= 1.0.0\"};f.REVISION_CHANGES=k;var l=g.isArray,m=g.isFunction,n=g.toString,o=\"[object Object]\";f.HandlebarsEnvironment=c,c.prototype={constructor:c,logger:p,log:e,registerHelper:function(a,b,c){if(n.call(a)===o){if(c||b)throw new h(\"Arg not supported with multiple helpers\");g.extend(this.helpers,a)}else c&&(b.not=c),this.helpers[a]=b},registerPartial:function(a,b){n.call(a)===o?g.extend(this.partials,a):this.partials[a]=b}};var p={methodMap:{0:\"debug\",1:\"info\",2:\"warn\",3:\"error\"},DEBUG:0,INFO:1,WARN:2,ERROR:3,level:3,log:function(a,b){if(p.level<=a){var c=p.methodMap[a];\"undefined\"!=typeof console&&console[c]&&console[c].call(console,b)}}};f.logger=p,f.log=e;var q=function(a){var b={};return g.extend(b,a),b};return f.createFrame=q,f}(b,c),e=function(a,b,c){\"use strict\";function d(a){var b=a&&a[0]||1,c=m;if(b!==c){if(c>b){var d=n[c],e=n[b];throw new l(\"Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (\"+d+\") or downgrade your runtime to an older version (\"+e+\").\")}throw new l(\"Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (\"+a[1]+\").\")}}function e(a,b){if(!b)throw new l(\"No environment passed to template\");var c=function(a,c,d,e,f,g){var h=b.VM.invokePartial.apply(this,arguments);if(null!=h)return h;if(b.compile){var i={helpers:e,partials:f,data:g};return f[c]=b.compile(a,{data:void 0!==g},b),f[c](d,i)}throw new l(\"The partial \"+c+\" could not be compiled when running in runtime-only mode\")},d={escapeExpression:k.escapeExpression,invokePartial:c,programs:[],program:function(a,b,c){var d=this.programs[a];return c?d=g(a,b,c):d||(d=this.programs[a]=g(a,b)),d},merge:function(a,b){var c=a||b;return a&&b&&a!==b&&(c={},k.extend(c,b),k.extend(c,a)),c},programWithDepth:b.VM.programWithDepth,noop:b.VM.noop,compilerInfo:null};return function(c,e){e=e||{};var f,g,h=e.partial?e:b;e.partial||(f=e.helpers,g=e.partials);var i=a.call(d,h,c,f,g,e.data);return e.partial||b.VM.checkRevision(d.compilerInfo),i}}function f(a,b,c){var d=Array.prototype.slice.call(arguments,3),e=function(a,e){return e=e||{},b.apply(this,[a,e.data||c].concat(d))};return e.program=a,e.depth=d.length,e}function g(a,b,c){var d=function(a,d){return d=d||{},b(a,d.data||c)};return d.program=a,d.depth=0,d}function h(a,b,c,d,e,f){var g={partial:!0,helpers:d,partials:e,data:f};if(void 0===a)throw new l(\"The partial \"+b+\" could not be found\");return a instanceof Function?a(c,g):void 0}function i(){return\"\"}var j={},k=a,l=b,m=c.COMPILER_REVISION,n=c.REVISION_CHANGES;return j.checkRevision=d,j.template=e,j.programWithDepth=f,j.program=g,j.invokePartial=h,j.noop=i,j}(b,c,d),f=function(a,b,c,d,e){\"use strict\";var f,g=a,h=b,i=c,j=d,k=e,l=function(){var a=new g.HandlebarsEnvironment;return j.extend(a,g),a.SafeString=h,a.Exception=i,a.Utils=j,a.VM=k,a.template=function(b){return k.template(b,a)},a},m=l();return m.create=l,f=m}(d,a,c,b,e),g=function(a){\"use strict\";function b(a){a=a||{},this.firstLine=a.first_line,this.firstColumn=a.first_column,this.lastColumn=a.last_column,this.lastLine=a.last_line}var c,d=a,e={ProgramNode:function(a,c,d,f){var g,h;3===arguments.length?(f=d,d=null):2===arguments.length&&(f=c,c=null),b.call(this,f),this.type=\"program\",this.statements=a,this.strip={},d?(h=d[0],h?(g={first_line:h.firstLine,last_line:h.lastLine,last_column:h.lastColumn,first_column:h.firstColumn},this.inverse=new e.ProgramNode(d,c,g)):this.inverse=new e.ProgramNode(d,c),this.strip.right=c.left):c&&(this.strip.left=c.right)},MustacheNode:function(a,c,d,f,g){if(b.call(this,g),this.type=\"mustache\",this.strip=f,null!=d&&d.charAt){var h=d.charAt(3)||d.charAt(2);this.escaped=\"{\"!==h&&\"&\"!==h}else this.escaped=!!d;this.sexpr=a instanceof e.SexprNode?a:new e.SexprNode(a,c),this.sexpr.isRoot=!0,this.id=this.sexpr.id,this.params=this.sexpr.params,this.hash=this.sexpr.hash,this.eligibleHelper=this.sexpr.eligibleHelper,this.isHelper=this.sexpr.isHelper},SexprNode:function(a,c,d){b.call(this,d),this.type=\"sexpr\",this.hash=c;var e=this.id=a[0],f=this.params=a.slice(1),g=this.eligibleHelper=e.isSimple;this.isHelper=g&&(f.length||c)},PartialNode:function(a,c,d,e){b.call(this,e),this.type=\"partial\",this.partialName=a,this.context=c,this.strip=d},BlockNode:function(a,c,e,f,g){if(b.call(this,g),a.sexpr.id.original!==f.path.original)throw new d(a.sexpr.id.original+\" doesn't match \"+f.path.original,this);this.type=\"block\",this.mustache=a,this.program=c,this.inverse=e,this.strip={left:a.strip.left,right:f.strip.right},(c||e).strip.left=a.strip.right,(e||c).strip.right=f.strip.left,e&&!c&&(this.isInverse=!0)},ContentNode:function(a,c){b.call(this,c),this.type=\"content\",this.string=a},HashNode:function(a,c){b.call(this,c),this.type=\"hash\",this.pairs=a},IdNode:function(a,c){b.call(this,c),this.type=\"ID\";for(var e=\"\",f=[],g=0,h=0,i=a.length;i>h;h++){var j=a[h].part;if(e+=(a[h].separator||\"\")+j,\"..\"===j||\".\"===j||\"this\"===j){if(f.length>0)throw new d(\"Invalid path: \"+e,this);\"..\"===j?g++:this.isScoped=!0}else f.push(j)}this.original=e,this.parts=f,this.string=f.join(\".\"),this.depth=g,this.isSimple=1===a.length&&!this.isScoped&&0===g,this.stringModeValue=this.string},PartialNameNode:function(a,c){b.call(this,c),this.type=\"PARTIAL_NAME\",this.name=a.original},DataNode:function(a,c){b.call(this,c),this.type=\"DATA\",this.id=a},StringNode:function(a,c){b.call(this,c),this.type=\"STRING\",this.original=this.string=this.stringModeValue=a},IntegerNode:function(a,c){b.call(this,c),this.type=\"INTEGER\",this.original=this.integer=a,this.stringModeValue=Number(a)},BooleanNode:function(a,c){b.call(this,c),this.type=\"BOOLEAN\",this.bool=a,this.stringModeValue=\"true\"===a},CommentNode:function(a,c){b.call(this,c),this.type=\"comment\",this.comment=a}};return c=e}(c),h=function(){\"use strict\";var a,b=function(){function a(a,b){return{left:\"~\"===a.charAt(2),right:\"~\"===b.charAt(0)||\"~\"===b.charAt(1)}}function b(){this.yy={}}var c={trace:function(){},yy:{},symbols_:{error:2,root:3,statements:4,EOF:5,program:6,simpleInverse:7,statement:8,openInverse:9,closeBlock:10,openBlock:11,mustache:12,partial:13,CONTENT:14,COMMENT:15,OPEN_BLOCK:16,sexpr:17,CLOSE:18,OPEN_INVERSE:19,OPEN_ENDBLOCK:20,path:21,OPEN:22,OPEN_UNESCAPED:23,CLOSE_UNESCAPED:24,OPEN_PARTIAL:25,partialName:26,partial_option0:27,sexpr_repetition0:28,sexpr_option0:29,dataName:30,param:31,STRING:32,INTEGER:33,BOOLEAN:34,OPEN_SEXPR:35,CLOSE_SEXPR:36,hash:37,hash_repetition_plus0:38,hashSegment:39,ID:40,EQUALS:41,DATA:42,pathSegments:43,SEP:44,$accept:0,$end:1},terminals_:{2:\"error\",5:\"EOF\",14:\"CONTENT\",15:\"COMMENT\",16:\"OPEN_BLOCK\",18:\"CLOSE\",19:\"OPEN_INVERSE\",20:\"OPEN_ENDBLOCK\",22:\"OPEN\",23:\"OPEN_UNESCAPED\",24:\"CLOSE_UNESCAPED\",25:\"OPEN_PARTIAL\",32:\"STRING\",33:\"INTEGER\",34:\"BOOLEAN\",35:\"OPEN_SEXPR\",36:\"CLOSE_SEXPR\",40:\"ID\",41:\"EQUALS\",42:\"DATA\",44:\"SEP\"},productions_:[0,[3,2],[3,1],[6,2],[6,3],[6,2],[6,1],[6,1],[6,0],[4,1],[4,2],[8,3],[8,3],[8,1],[8,1],[8,1],[8,1],[11,3],[9,3],[10,3],[12,3],[12,3],[13,4],[7,2],[17,3],[17,1],[31,1],[31,1],[31,1],[31,1],[31,1],[31,3],[37,1],[39,3],[26,1],[26,1],[26,1],[30,2],[21,1],[43,3],[43,1],[27,0],[27,1],[28,0],[28,2],[29,0],[29,1],[38,1],[38,2]],performAction:function(b,c,d,e,f,g){var h=g.length-1;switch(f){case 1:return new e.ProgramNode(g[h-1],this._$);case 2:return new e.ProgramNode([],this._$);case 3:this.$=new e.ProgramNode([],g[h-1],g[h],this._$);break;case 4:this.$=new e.ProgramNode(g[h-2],g[h-1],g[h],this._$);break;case 5:this.$=new e.ProgramNode(g[h-1],g[h],[],this._$);break;case 6:this.$=new e.ProgramNode(g[h],this._$);break;case 7:this.$=new e.ProgramNode([],this._$);break;case 8:this.$=new e.ProgramNode([],this._$);break;case 9:this.$=[g[h]];break;case 10:g[h-1].push(g[h]),this.$=g[h-1];break;case 11:this.$=new e.BlockNode(g[h-2],g[h-1].inverse,g[h-1],g[h],this._$);break;case 12:this.$=new e.BlockNode(g[h-2],g[h-1],g[h-1].inverse,g[h],this._$);break;case 13:this.$=g[h];break;case 14:this.$=g[h];break;case 15:this.$=new e.ContentNode(g[h],this._$);break;case 16:this.$=new e.CommentNode(g[h],this._$);break;case 17:this.$=new e.MustacheNode(g[h-1],null,g[h-2],a(g[h-2],g[h]),this._$);break;case 18:this.$=new e.MustacheNode(g[h-1],null,g[h-2],a(g[h-2],g[h]),this._$);break;case 19:this.$={path:g[h-1],strip:a(g[h-2],g[h])};break;case 20:this.$=new e.MustacheNode(g[h-1],null,g[h-2],a(g[h-2],g[h]),this._$);break;case 21:this.$=new e.MustacheNode(g[h-1],null,g[h-2],a(g[h-2],g[h]),this._$);break;case 22:this.$=new e.PartialNode(g[h-2],g[h-1],a(g[h-3],g[h]),this._$);break;case 23:this.$=a(g[h-1],g[h]);break;case 24:this.$=new e.SexprNode([g[h-2]].concat(g[h-1]),g[h],this._$);break;case 25:this.$=new e.SexprNode([g[h]],null,this._$);break;case 26:this.$=g[h];break;case 27:this.$=new e.StringNode(g[h],this._$);break;case 28:this.$=new e.IntegerNode(g[h],this._$);break;case 29:this.$=new e.BooleanNode(g[h],this._$);break;case 30:this.$=g[h];break;case 31:g[h-1].isHelper=!0,this.$=g[h-1];break;case 32:this.$=new e.HashNode(g[h],this._$);break;case 33:this.$=[g[h-2],g[h]];break;case 34:this.$=new e.PartialNameNode(g[h],this._$);break;case 35:this.$=new e.PartialNameNode(new e.StringNode(g[h],this._$),this._$);break;case 36:this.$=new e.PartialNameNode(new e.IntegerNode(g[h],this._$));break;case 37:this.$=new e.DataNode(g[h],this._$);break;case 38:this.$=new e.IdNode(g[h],this._$);break;case 39:g[h-2].push({part:g[h],separator:g[h-1]}),this.$=g[h-2];break;case 40:this.$=[{part:g[h]}];break;case 43:this.$=[];break;case 44:g[h-1].push(g[h]);break;case 47:this.$=[g[h]];break;case 48:g[h-1].push(g[h])}},table:[{3:1,4:2,5:[1,3],8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],22:[1,13],23:[1,14],25:[1,15]},{1:[3]},{5:[1,16],8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],22:[1,13],23:[1,14],25:[1,15]},{1:[2,2]},{5:[2,9],14:[2,9],15:[2,9],16:[2,9],19:[2,9],20:[2,9],22:[2,9],23:[2,9],25:[2,9]},{4:20,6:18,7:19,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,8],22:[1,13],23:[1,14],25:[1,15]},{4:20,6:22,7:19,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,8],22:[1,13],23:[1,14],25:[1,15]},{5:[2,13],14:[2,13],15:[2,13],16:[2,13],19:[2,13],20:[2,13],22:[2,13],23:[2,13],25:[2,13]},{5:[2,14],14:[2,14],15:[2,14],16:[2,14],19:[2,14],20:[2,14],22:[2,14],23:[2,14],25:[2,14]},{5:[2,15],14:[2,15],15:[2,15],16:[2,15],19:[2,15],20:[2,15],22:[2,15],23:[2,15],25:[2,15]},{5:[2,16],14:[2,16],15:[2,16],16:[2,16],19:[2,16],20:[2,16],22:[2,16],23:[2,16],25:[2,16]},{17:23,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:29,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:30,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:31,21:24,30:25,40:[1,28],42:[1,27],43:26},{21:33,26:32,32:[1,34],33:[1,35],40:[1,28],43:26},{1:[2,1]},{5:[2,10],14:[2,10],15:[2,10],16:[2,10],19:[2,10],20:[2,10],22:[2,10],23:[2,10],25:[2,10]},{10:36,20:[1,37]},{4:38,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,7],22:[1,13],23:[1,14],25:[1,15]},{7:39,8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,6],22:[1,13],23:[1,14],25:[1,15]},{17:23,18:[1,40],21:24,30:25,40:[1,28],42:[1,27],43:26},{10:41,20:[1,37]},{18:[1,42]},{18:[2,43],24:[2,43],28:43,32:[2,43],33:[2,43],34:[2,43],35:[2,43],36:[2,43],40:[2,43],42:[2,43]},{18:[2,25],24:[2,25],36:[2,25]},{18:[2,38],24:[2,38],32:[2,38],33:[2,38],34:[2,38],35:[2,38],36:[2,38],40:[2,38],42:[2,38],44:[1,44]},{21:45,40:[1,28],43:26},{18:[2,40],24:[2,40],32:[2,40],33:[2,40],34:[2,40],35:[2,40],36:[2,40],40:[2,40],42:[2,40],44:[2,40]},{18:[1,46]},{18:[1,47]},{24:[1,48]},{18:[2,41],21:50,27:49,40:[1,28],43:26},{18:[2,34],40:[2,34]},{18:[2,35],40:[2,35]},{18:[2,36],40:[2,36]},{5:[2,11],14:[2,11],15:[2,11],16:[2,11],19:[2,11],20:[2,11],22:[2,11],23:[2,11],25:[2,11]},{21:51,40:[1,28],43:26},{8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,3],22:[1,13],23:[1,14],25:[1,15]},{4:52,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,5],22:[1,13],23:[1,14],25:[1,15]},{14:[2,23],15:[2,23],16:[2,23],19:[2,23],20:[2,23],22:[2,23],23:[2,23],25:[2,23]},{5:[2,12],14:[2,12],15:[2,12],16:[2,12],19:[2,12],20:[2,12],22:[2,12],23:[2,12],25:[2,12]},{14:[2,18],15:[2,18],16:[2,18],19:[2,18],20:[2,18],22:[2,18],23:[2,18],25:[2,18]},{18:[2,45],21:56,24:[2,45],29:53,30:60,31:54,32:[1,57],33:[1,58],34:[1,59],35:[1,61],36:[2,45],37:55,38:62,39:63,40:[1,64],42:[1,27],43:26},{40:[1,65]},{18:[2,37],24:[2,37],32:[2,37],33:[2,37],34:[2,37],35:[2,37],36:[2,37],40:[2,37],42:[2,37]},{14:[2,17],15:[2,17],16:[2,17],19:[2,17],20:[2,17],22:[2,17],23:[2,17],25:[2,17]},{5:[2,20],14:[2,20],15:[2,20],16:[2,20],19:[2,20],20:[2,20],22:[2,20],23:[2,20],25:[2,20]},{5:[2,21],14:[2,21],15:[2,21],16:[2,21],19:[2,21],20:[2,21],22:[2,21],23:[2,21],25:[2,21]},{18:[1,66]},{18:[2,42]},{18:[1,67]},{8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,4],22:[1,13],23:[1,14],25:[1,15]},{18:[2,24],24:[2,24],36:[2,24]},{18:[2,44],24:[2,44],32:[2,44],33:[2,44],34:[2,44],35:[2,44],36:[2,44],40:[2,44],42:[2,44]},{18:[2,46],24:[2,46],36:[2,46]},{18:[2,26],24:[2,26],32:[2,26],33:[2,26],34:[2,26],35:[2,26],36:[2,26],40:[2,26],42:[2,26]},{18:[2,27],24:[2,27],32:[2,27],33:[2,27],34:[2,27],35:[2,27],36:[2,27],40:[2,27],42:[2,27]},{18:[2,28],24:[2,28],32:[2,28],33:[2,28],34:[2,28],35:[2,28],36:[2,28],40:[2,28],42:[2,28]},{18:[2,29],24:[2,29],32:[2,29],33:[2,29],34:[2,29],35:[2,29],36:[2,29],40:[2,29],42:[2,29]},{18:[2,30],24:[2,30],32:[2,30],33:[2,30],34:[2,30],35:[2,30],36:[2,30],40:[2,30],42:[2,30]},{17:68,21:24,30:25,40:[1,28],42:[1,27],43:26},{18:[2,32],24:[2,32],36:[2,32],39:69,40:[1,70]},{18:[2,47],24:[2,47],36:[2,47],40:[2,47]},{18:[2,40],24:[2,40],32:[2,40],33:[2,40],34:[2,40],35:[2,40],36:[2,40],40:[2,40],41:[1,71],42:[2,40],44:[2,40]},{18:[2,39],24:[2,39],32:[2,39],33:[2,39],34:[2,39],35:[2,39],36:[2,39],40:[2,39],42:[2,39],44:[2,39]},{5:[2,22],14:[2,22],15:[2,22],16:[2,22],19:[2,22],20:[2,22],22:[2,22],23:[2,22],25:[2,22]},{5:[2,19],14:[2,19],15:[2,19],16:[2,19],19:[2,19],20:[2,19],22:[2,19],23:[2,19],25:[2,19]},{36:[1,72]},{18:[2,48],24:[2,48],36:[2,48],40:[2,48]},{41:[1,71]},{21:56,30:60,31:73,32:[1,57],33:[1,58],34:[1,59],35:[1,61],40:[1,28],42:[1,27],43:26},{18:[2,31],24:[2,31],32:[2,31],33:[2,31],34:[2,31],35:[2,31],36:[2,31],40:[2,31],42:[2,31]},{18:[2,33],24:[2,33],36:[2,33],40:[2,33]}],defaultActions:{3:[2,2],16:[2,1],50:[2,42]},parseError:function(a){throw new Error(a)},parse:function(a){function b(){var a;return a=c.lexer.lex()||1,\"number\"!=typeof a&&(a=c.symbols_[a]||a),a}var c=this,d=[0],e=[null],f=[],g=this.table,h=\"\",i=0,j=0,k=0;this.lexer.setInput(a),this.lexer.yy=this.yy,this.yy.lexer=this.lexer,this.yy.parser=this,\"undefined\"==typeof this.lexer.yylloc&&(this.lexer.yylloc={});var l=this.lexer.yylloc;f.push(l);var m=this.lexer.options&&this.lexer.options.ranges;\"function\"==typeof this.yy.parseError&&(this.parseError=this.yy.parseError);for(var n,o,p,q,r,s,t,u,v,w={};;){if(p=d[d.length-1],this.defaultActions[p]?q=this.defaultActions[p]:((null===n||\"undefined\"==typeof n)&&(n=b()),q=g[p]&&g[p][n]),\"undefined\"==typeof q||!q.length||!q[0]){var x=\"\";if(!k){v=[];for(s in g[p])this.terminals_[s]&&s>2&&v.push(\"'\"+this.terminals_[s]+\"'\");x=this.lexer.showPosition?\"Parse error on line \"+(i+1)+\":\\n\"+this.lexer.showPosition()+\"\\nExpecting \"+v.join(\", \")+\", got '\"+(this.terminals_[n]||n)+\"'\":\"Parse error on line \"+(i+1)+\": Unexpected \"+(1==n?\"end of input\":\"'\"+(this.terminals_[n]||n)+\"'\"),this.parseError(x,{text:this.lexer.match,token:this.terminals_[n]||n,line:this.lexer.yylineno,loc:l,expected:v})}}if(q[0]instanceof Array&&q.length>1)throw new Error(\"Parse Error: multiple actions possible at state: \"+p+\", token: \"+n);switch(q[0]){case 1:d.push(n),e.push(this.lexer.yytext),f.push(this.lexer.yylloc),d.push(q[1]),n=null,o?(n=o,o=null):(j=this.lexer.yyleng,h=this.lexer.yytext,i=this.lexer.yylineno,l=this.lexer.yylloc,k>0&&k--);break;case 2:if(t=this.productions_[q[1]][1],w.$=e[e.length-t],w._$={first_line:f[f.length-(t||1)].first_line,last_line:f[f.length-1].last_line,first_column:f[f.length-(t||1)].first_column,last_column:f[f.length-1].last_column},m&&(w._$.range=[f[f.length-(t||1)].range[0],f[f.length-1].range[1]]),r=this.performAction.call(w,h,j,i,this.yy,q[1],e,f),\"undefined\"!=typeof r)return r;t&&(d=d.slice(0,-1*t*2),e=e.slice(0,-1*t),f=f.slice(0,-1*t)),d.push(this.productions_[q[1]][0]),e.push(w.$),f.push(w._$),u=g[d[d.length-2]][d[d.length-1]],d.push(u);break;case 3:return!0}}return!0}},d=function(){var a={EOF:1,parseError:function(a,b){if(!this.yy.parser)throw new Error(a);this.yy.parser.parseError(a,b)},setInput:function(a){return this._input=a,this._more=this._less=this.done=!1,this.yylineno=this.yyleng=0,this.yytext=this.matched=this.match=\"\",this.conditionStack=[\"INITIAL\"],this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0},this.options.ranges&&(this.yylloc.range=[0,0]),this.offset=0,this},input:function(){var a=this._input[0];this.yytext+=a,this.yyleng++,this.offset++,this.match+=a,this.matched+=a;var b=a.match(/(?:\\r\\n?|\\n).*/g);return b?(this.yylineno++,this.yylloc.last_line++):this.yylloc.last_column++,this.options.ranges&&this.yylloc.range[1]++,this._input=this._input.slice(1),a},unput:function(a){var b=a.length,c=a.split(/(?:\\r\\n?|\\n)/g);this._input=a+this._input,this.yytext=this.yytext.substr(0,this.yytext.length-b-1),this.offset-=b;var d=this.match.split(/(?:\\r\\n?|\\n)/g);this.match=this.match.substr(0,this.match.length-1),this.matched=this.matched.substr(0,this.matched.length-1),c.length-1&&(this.yylineno-=c.length-1);var e=this.yylloc.range;return this.yylloc={first_line:this.yylloc.first_line,last_line:this.yylineno+1,first_column:this.yylloc.first_column,last_column:c?(c.length===d.length?this.yylloc.first_column:0)+d[d.length-c.length].length-c[0].length:this.yylloc.first_column-b},this.options.ranges&&(this.yylloc.range=[e[0],e[0]+this.yyleng-b]),this},more:function(){return this._more=!0,this},less:function(a){this.unput(this.match.slice(a))},pastInput:function(){var a=this.matched.substr(0,this.matched.length-this.match.length);return(a.length>20?\"...\":\"\")+a.substr(-20).replace(/\\n/g,\"\")},upcomingInput:function(){var a=this.match;return a.length<20&&(a+=this._input.substr(0,20-a.length)),(a.substr(0,20)+(a.length>20?\"...\":\"\")).replace(/\\n/g,\"\")},showPosition:function(){var a=this.pastInput(),b=new Array(a.length+1).join(\"-\");return a+this.upcomingInput()+\"\\n\"+b+\"^\"},next:function(){if(this.done)return this.EOF;this._input||(this.done=!0);var a,b,c,d,e;this._more||(this.yytext=\"\",this.match=\"\");for(var f=this._currentRules(),g=0;g<f.length&&(c=this._input.match(this.rules[f[g]]),!c||b&&!(c[0].length>b[0].length)||(b=c,d=g,this.options.flex));g++);return b?(e=b[0].match(/(?:\\r\\n?|\\n).*/g),e&&(this.yylineno+=e.length),this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:e?e[e.length-1].length-e[e.length-1].match(/\\r?\\n?/)[0].length:this.yylloc.last_column+b[0].length},this.yytext+=b[0],this.match+=b[0],this.matches=b,this.yyleng=this.yytext.length,this.options.ranges&&(this.yylloc.range=[this.offset,this.offset+=this.yyleng]),this._more=!1,this._input=this._input.slice(b[0].length),this.matched+=b[0],a=this.performAction.call(this,this.yy,this,f[d],this.conditionStack[this.conditionStack.length-1]),this.done&&this._input&&(this.done=!1),a?a:void 0):\"\"===this._input?this.EOF:this.parseError(\"Lexical error on line \"+(this.yylineno+1)+\". Unrecognized text.\\n\"+this.showPosition(),{text:\"\",token:null,line:this.yylineno})},lex:function(){var a=this.next();return\"undefined\"!=typeof a?a:this.lex()},begin:function(a){this.conditionStack.push(a)},popState:function(){return this.conditionStack.pop()},_currentRules:function(){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules},topState:function(){return this.conditionStack[this.conditionStack.length-2]},pushState:function(a){this.begin(a)}};return a.options={},a.performAction=function(a,b,c,d){function e(a,c){return b.yytext=b.yytext.substr(a,b.yyleng-c)}switch(c){case 0:if(\"\\\\\\\\\"===b.yytext.slice(-2)?(e(0,1),this.begin(\"mu\")):\"\\\\\"===b.yytext.slice(-1)?(e(0,1),this.begin(\"emu\")):this.begin(\"mu\"),b.yytext)return 14;break;case 1:return 14;case 2:return this.popState(),14;case 3:return e(0,4),this.popState(),15;case 4:return 35;case 5:return 36;case 6:return 25;case 7:return 16;case 8:return 20;case 9:return 19;case 10:return 19;case 11:return 23;case 12:return 22;case 13:this.popState(),this.begin(\"com\");break;case 14:return e(3,5),this.popState(),15;case 15:return 22;case 16:return 41;case 17:return 40;case 18:return 40;case 19:return 44;case 20:break;case 21:return this.popState(),24;case 22:return this.popState(),18;case 23:return b.yytext=e(1,2).replace(/\\\\\"/g,'\"'),32;case 24:return b.yytext=e(1,2).replace(/\\\\'/g,\"'\"),32;case 25:return 42;case 26:return 34;case 27:return 34;case 28:return 33;case 29:return 40;case 30:return b.yytext=e(1,2),40;case 31:return\"INVALID\";case 32:return 5}},a.rules=[/^(?:[^\\x00]*?(?=(\\{\\{)))/,/^(?:[^\\x00]+)/,/^(?:[^\\x00]{2,}?(?=(\\{\\{|\\\\\\{\\{|\\\\\\\\\\{\\{|$)))/,/^(?:[\\s\\S]*?--\\}\\})/,/^(?:\\()/,/^(?:\\))/,/^(?:\\{\\{(~)?>)/,/^(?:\\{\\{(~)?#)/,/^(?:\\{\\{(~)?\\/)/,/^(?:\\{\\{(~)?\\^)/,/^(?:\\{\\{(~)?\\s*else\\b)/,/^(?:\\{\\{(~)?\\{)/,/^(?:\\{\\{(~)?&)/,/^(?:\\{\\{!--)/,/^(?:\\{\\{![\\s\\S]*?\\}\\})/,/^(?:\\{\\{(~)?)/,/^(?:=)/,/^(?:\\.\\.)/,/^(?:\\.(?=([=~}\\s\\/.)])))/,/^(?:[\\/.])/,/^(?:\\s+)/,/^(?:\\}(~)?\\}\\})/,/^(?:(~)?\\}\\})/,/^(?:\"(\\\\[\"]|[^\"])*\")/,/^(?:'(\\\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\\s)])))/,/^(?:false(?=([~}\\s)])))/,/^(?:-?[0-9]+(?=([~}\\s)])))/,/^(?:([^\\s!\"#%-,\\.\\/;->@\\[-\\^`\\{-~]+(?=([=~}\\s\\/.)]))))/,/^(?:\\[[^\\]]*\\])/,/^(?:.)/,/^(?:$)/],a.conditions={mu:{rules:[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32],inclusive:!1},emu:{rules:[2],inclusive:!1},com:{rules:[3],inclusive:!1},INITIAL:{rules:[0,1,32],inclusive:!0}},a}();return c.lexer=d,b.prototype=c,c.Parser=b,new b}();return a=b}(),i=function(a,b){\"use strict\";function c(a){return a.constructor===f.ProgramNode?a:(e.yy=f,e.parse(a))}var d={},e=a,f=b;return d.parser=e,d.parse=c,d}(h,g),j=function(a){\"use strict\";function b(){}function c(a,b,c){if(null==a||\"string\"!=typeof a&&a.constructor!==c.AST.ProgramNode)throw new f(\"You must pass a string or Handlebars AST to Handlebars.precompile. You passed \"+a);b=b||{},\"data\"in b||(b.data=!0);var d=c.parse(a),e=(new c.Compiler).compile(d,b);return(new c.JavaScriptCompiler).compile(e,b)}function d(a,b,c){function d(){var d=c.parse(a),e=(new c.Compiler).compile(d,b),f=(new c.JavaScriptCompiler).compile(e,b,void 0,!0);return c.template(f)}if(null==a||\"string\"!=typeof a&&a.constructor!==c.AST.ProgramNode)throw new f(\"You must pass a string or Handlebars AST to Handlebars.compile. You passed \"+a);b=b||{},\"data\"in b||(b.data=!0);var e;return function(a,b){return e||(e=d()),e.call(this,a,b)}}var e={},f=a;return e.Compiler=b,b.prototype={compiler:b,disassemble:function(){for(var a,b,c,d=this.opcodes,e=[],f=0,g=d.length;g>f;f++)if(a=d[f],\"DECLARE\"===a.opcode)e.push(\"DECLARE \"+a.name+\"=\"+a.value);else{b=[];for(var h=0;h<a.args.length;h++)c=a.args[h],\"string\"==typeof c&&(c='\"'+c.replace(\"\\n\",\"\\\\n\")+'\"'),b.push(c);e.push(a.opcode+\" \"+b.join(\" \"))}return e.join(\"\\n\")},equals:function(a){var b=this.opcodes.length;if(a.opcodes.length!==b)return!1;for(var c=0;b>c;c++){var d=this.opcodes[c],e=a.opcodes[c];if(d.opcode!==e.opcode||d.args.length!==e.args.length)return!1;for(var f=0;f<d.args.length;f++)if(d.args[f]!==e.args[f])return!1}if(b=this.children.length,a.children.length!==b)return!1;for(c=0;b>c;c++)if(!this.children[c].equals(a.children[c]))return!1;return!0},guid:0,compile:function(a,b){this.opcodes=[],this.children=[],this.depths={list:[]},this.options=b;var c=this.options.knownHelpers;if(this.options.knownHelpers={helperMissing:!0,blockHelperMissing:!0,each:!0,\"if\":!0,unless:!0,\"with\":!0,log:!0},c)for(var d in c)this.options.knownHelpers[d]=c[d];return this.accept(a)},accept:function(a){var b,c=a.strip||{};return c.left&&this.opcode(\"strip\"),b=this[a.type](a),c.right&&this.opcode(\"strip\"),b},program:function(a){for(var b=a.statements,c=0,d=b.length;d>c;c++)this.accept(b[c]);return this.isSimple=1===d,this.depths.list=this.depths.list.sort(function(a,b){return a-b}),this},compileProgram:function(a){var b,c=(new this.compiler).compile(a,this.options),d=this.guid++;this.usePartial=this.usePartial||c.usePartial,this.children[d]=c;for(var e=0,f=c.depths.list.length;f>e;e++)b=c.depths.list[e],2>b||this.addDepth(b-1);return d},block:function(a){var b=a.mustache,c=a.program,d=a.inverse;c&&(c=this.compileProgram(c)),d&&(d=this.compileProgram(d));var e=b.sexpr,f=this.classifySexpr(e);\"helper\"===f?this.helperSexpr(e,c,d):\"simple\"===f?(this.simpleSexpr(e),this.opcode(\"pushProgram\",c),this.opcode(\"pushProgram\",d),this.opcode(\"emptyHash\"),this.opcode(\"blockValue\")):(this.ambiguousSexpr(e,c,d),this.opcode(\"pushProgram\",c),this.opcode(\"pushProgram\",d),this.opcode(\"emptyHash\"),this.opcode(\"ambiguousBlockValue\")),this.opcode(\"append\")},hash:function(a){var b,c,d=a.pairs;this.opcode(\"pushHash\");for(var e=0,f=d.length;f>e;e++)b=d[e],c=b[1],this.options.stringParams?(c.depth&&this.addDepth(c.depth),this.opcode(\"getContext\",c.depth||0),this.opcode(\"pushStringParam\",c.stringModeValue,c.type),\"sexpr\"===c.type&&this.sexpr(c)):this.accept(c),this.opcode(\"assignToHash\",b[0]);this.opcode(\"popHash\")},partial:function(a){var b=a.partialName;this.usePartial=!0,a.context?this.ID(a.context):this.opcode(\"push\",\"depth0\"),this.opcode(\"invokePartial\",b.name),this.opcode(\"append\")},content:function(a){this.opcode(\"appendContent\",a.string)},mustache:function(a){this.sexpr(a.sexpr),a.escaped&&!this.options.noEscape?this.opcode(\"appendEscaped\"):this.opcode(\"append\")},ambiguousSexpr:function(a,b,c){var d=a.id,e=d.parts[0],f=null!=b||null!=c;this.opcode(\"getContext\",d.depth),this.opcode(\"pushProgram\",b),this.opcode(\"pushProgram\",c),this.opcode(\"invokeAmbiguous\",e,f)},simpleSexpr:function(a){var b=a.id;\"DATA\"===b.type?this.DATA(b):b.parts.length?this.ID(b):(this.addDepth(b.depth),this.opcode(\"getContext\",b.depth),this.opcode(\"pushContext\")),this.opcode(\"resolvePossibleLambda\")},helperSexpr:function(a,b,c){var d=this.setupFullMustacheParams(a,b,c),e=a.id.parts[0];if(this.options.knownHelpers[e])this.opcode(\"invokeKnownHelper\",d.length,e);else{if(this.options.knownHelpersOnly)throw new f(\"You specified knownHelpersOnly, but used the unknown helper \"+e,a);this.opcode(\"invokeHelper\",d.length,e,a.isRoot)}},sexpr:function(a){var b=this.classifySexpr(a);\"simple\"===b?this.simpleSexpr(a):\"helper\"===b?this.helperSexpr(a):this.ambiguousSexpr(a)},ID:function(a){this.addDepth(a.depth),this.opcode(\"getContext\",a.depth);var b=a.parts[0];b?this.opcode(\"lookupOnContext\",a.parts[0]):this.opcode(\"pushContext\");for(var c=1,d=a.parts.length;d>c;c++)this.opcode(\"lookup\",a.parts[c])},DATA:function(a){if(this.options.data=!0,a.id.isScoped||a.id.depth)throw new f(\"Scoped data references are not supported: \"+a.original,a);this.opcode(\"lookupData\");for(var b=a.id.parts,c=0,d=b.length;d>c;c++)this.opcode(\"lookup\",b[c])},STRING:function(a){this.opcode(\"pushString\",a.string)},INTEGER:function(a){this.opcode(\"pushLiteral\",a.integer)},BOOLEAN:function(a){this.opcode(\"pushLiteral\",a.bool)},comment:function(){},opcode:function(a){this.opcodes.push({opcode:a,args:[].slice.call(arguments,1)})},declare:function(a,b){this.opcodes.push({opcode:\"DECLARE\",name:a,value:b})},addDepth:function(a){0!==a&&(this.depths[a]||(this.depths[a]=!0,this.depths.list.push(a)))},classifySexpr:function(a){var b=a.isHelper,c=a.eligibleHelper,d=this.options;if(c&&!b){var e=a.id.parts[0];d.knownHelpers[e]?b=!0:d.knownHelpersOnly&&(c=!1)}return b?\"helper\":c?\"ambiguous\":\"simple\"},pushParams:function(a){for(var b,c=a.length;c--;)b=a[c],this.options.stringParams?(b.depth&&this.addDepth(b.depth),this.opcode(\"getContext\",b.depth||0),this.opcode(\"pushStringParam\",b.stringModeValue,b.type),\"sexpr\"===b.type&&this.sexpr(b)):this[b.type](b)},setupFullMustacheParams:function(a,b,c){var d=a.params;return this.pushParams(d),this.opcode(\"pushProgram\",b),this.opcode(\"pushProgram\",c),a.hash?this.hash(a.hash):this.opcode(\"emptyHash\"),d}},e.precompile=c,e.compile=d,e}(c),k=function(a,b){\"use strict\";function c(a){this.value=a}function d(){}var e,f=a.COMPILER_REVISION,g=a.REVISION_CHANGES,h=a.log,i=b;d.prototype={nameLookup:function(a,b){var c,e;return 0===a.indexOf(\"depth\")&&(c=!0),e=/^[0-9]+$/.test(b)?a+\"[\"+b+\"]\":d.isValidJavaScriptVariableName(b)?a+\".\"+b:a+\"['\"+b+\"']\",c?\"(\"+a+\" && \"+e+\")\":e},compilerInfo:function(){var a=f,b=g[a];return\"this.compilerInfo = [\"+a+\",'\"+b+\"'];\\n\"},appendToBuffer:function(a){return this.environment.isSimple?\"return \"+a+\";\":{appendToBuffer:!0,content:a,toString:function(){return\"buffer += \"+a+\";\"}}},initializeBuffer:function(){return this.quotedString(\"\")},namespace:\"Handlebars\",compile:function(a,b,c,d){this.environment=a,this.options=b||{},h(\"debug\",this.environment.disassemble()+\"\\n\\n\"),this.name=this.environment.name,this.isChild=!!c,this.context=c||{programs:[],environments:[],aliases:{}},this.preamble(),this.stackSlot=0,this.stackVars=[],this.registers={list:[]},this.hashes=[],this.compileStack=[],this.inlineStack=[],this.compileChildren(a,b);\nvar e,f=a.opcodes;this.i=0;for(var g=f.length;this.i<g;this.i++)e=f[this.i],\"DECLARE\"===e.opcode?this[e.name]=e.value:this[e.opcode].apply(this,e.args),e.opcode!==this.stripNext&&(this.stripNext=!1);if(this.pushSource(\"\"),this.stackSlot||this.inlineStack.length||this.compileStack.length)throw new i(\"Compile completed with content left on stack\");return this.createFunctionContext(d)},preamble:function(){var a=[];if(this.isChild)a.push(\"\");else{var b=this.namespace,c=\"helpers = this.merge(helpers, \"+b+\".helpers);\";this.environment.usePartial&&(c=c+\" partials = this.merge(partials, \"+b+\".partials);\"),this.options.data&&(c+=\" data = data || {};\"),a.push(c)}this.environment.isSimple?a.push(\"\"):a.push(\", buffer = \"+this.initializeBuffer()),this.lastContext=0,this.source=a},createFunctionContext:function(a){var b=this.stackVars.concat(this.registers.list);if(b.length>0&&(this.source[1]=this.source[1]+\", \"+b.join(\", \")),!this.isChild)for(var c in this.context.aliases)this.context.aliases.hasOwnProperty(c)&&(this.source[1]=this.source[1]+\", \"+c+\"=\"+this.context.aliases[c]);this.source[1]&&(this.source[1]=\"var \"+this.source[1].substring(2)+\";\"),this.isChild||(this.source[1]+=\"\\n\"+this.context.programs.join(\"\\n\")+\"\\n\"),this.environment.isSimple||this.pushSource(\"return buffer;\");for(var d=this.isChild?[\"depth0\",\"data\"]:[\"Handlebars\",\"depth0\",\"helpers\",\"partials\",\"data\"],e=0,f=this.environment.depths.list.length;f>e;e++)d.push(\"depth\"+this.environment.depths.list[e]);var g=this.mergeSource();if(this.isChild||(g=this.compilerInfo()+g),a)return d.push(g),Function.apply(this,d);var i=\"function \"+(this.name||\"\")+\"(\"+d.join(\",\")+\") {\\n  \"+g+\"}\";return h(\"debug\",i+\"\\n\\n\"),i},mergeSource:function(){for(var a,b=\"\",c=0,d=this.source.length;d>c;c++){var e=this.source[c];e.appendToBuffer?a=a?a+\"\\n    + \"+e.content:e.content:(a&&(b+=\"buffer += \"+a+\";\\n  \",a=void 0),b+=e+\"\\n  \")}return b},blockValue:function(){this.context.aliases.blockHelperMissing=\"helpers.blockHelperMissing\";var a=[\"depth0\"];this.setupParams(0,a),this.replaceStack(function(b){return a.splice(1,0,b),\"blockHelperMissing.call(\"+a.join(\", \")+\")\"})},ambiguousBlockValue:function(){this.context.aliases.blockHelperMissing=\"helpers.blockHelperMissing\";var a=[\"depth0\"];this.setupParams(0,a);var b=this.topStack();a.splice(1,0,b),this.pushSource(\"if (!\"+this.lastHelper+\") { \"+b+\" = blockHelperMissing.call(\"+a.join(\", \")+\"); }\")},appendContent:function(a){this.pendingContent&&(a=this.pendingContent+a),this.stripNext&&(a=a.replace(/^\\s+/,\"\")),this.pendingContent=a},strip:function(){this.pendingContent&&(this.pendingContent=this.pendingContent.replace(/\\s+$/,\"\")),this.stripNext=\"strip\"},append:function(){this.flushInline();var a=this.popStack();this.pushSource(\"if(\"+a+\" || \"+a+\" === 0) { \"+this.appendToBuffer(a)+\" }\"),this.environment.isSimple&&this.pushSource(\"else { \"+this.appendToBuffer(\"''\")+\" }\")},appendEscaped:function(){this.context.aliases.escapeExpression=\"this.escapeExpression\",this.pushSource(this.appendToBuffer(\"escapeExpression(\"+this.popStack()+\")\"))},getContext:function(a){this.lastContext!==a&&(this.lastContext=a)},lookupOnContext:function(a){this.push(this.nameLookup(\"depth\"+this.lastContext,a,\"context\"))},pushContext:function(){this.pushStackLiteral(\"depth\"+this.lastContext)},resolvePossibleLambda:function(){this.context.aliases.functionType='\"function\"',this.replaceStack(function(a){return\"typeof \"+a+\" === functionType ? \"+a+\".apply(depth0) : \"+a})},lookup:function(a){this.replaceStack(function(b){return b+\" == null || \"+b+\" === false ? \"+b+\" : \"+this.nameLookup(b,a,\"context\")})},lookupData:function(){this.pushStackLiteral(\"data\")},pushStringParam:function(a,b){this.pushStackLiteral(\"depth\"+this.lastContext),this.pushString(b),\"sexpr\"!==b&&(\"string\"==typeof a?this.pushString(a):this.pushStackLiteral(a))},emptyHash:function(){this.pushStackLiteral(\"{}\"),this.options.stringParams&&(this.push(\"{}\"),this.push(\"{}\"))},pushHash:function(){this.hash&&this.hashes.push(this.hash),this.hash={values:[],types:[],contexts:[]}},popHash:function(){var a=this.hash;this.hash=this.hashes.pop(),this.options.stringParams&&(this.push(\"{\"+a.contexts.join(\",\")+\"}\"),this.push(\"{\"+a.types.join(\",\")+\"}\")),this.push(\"{\\n    \"+a.values.join(\",\\n    \")+\"\\n  }\")},pushString:function(a){this.pushStackLiteral(this.quotedString(a))},push:function(a){return this.inlineStack.push(a),a},pushLiteral:function(a){this.pushStackLiteral(a)},pushProgram:function(a){null!=a?this.pushStackLiteral(this.programExpression(a)):this.pushStackLiteral(null)},invokeHelper:function(a,b,c){this.context.aliases.helperMissing=\"helpers.helperMissing\",this.useRegister(\"helper\");var d=this.lastHelper=this.setupHelper(a,b,!0),e=this.nameLookup(\"depth\"+this.lastContext,b,\"context\"),f=\"helper = \"+d.name+\" || \"+e;d.paramsInit&&(f+=\",\"+d.paramsInit),this.push(\"(\"+f+\",helper ? helper.call(\"+d.callParams+\") : helperMissing.call(\"+d.helperMissingParams+\"))\"),c||this.flushInline()},invokeKnownHelper:function(a,b){var c=this.setupHelper(a,b);this.push(c.name+\".call(\"+c.callParams+\")\")},invokeAmbiguous:function(a,b){this.context.aliases.functionType='\"function\"',this.useRegister(\"helper\"),this.emptyHash();var c=this.setupHelper(0,a,b),d=this.lastHelper=this.nameLookup(\"helpers\",a,\"helper\"),e=this.nameLookup(\"depth\"+this.lastContext,a,\"context\"),f=this.nextStack();c.paramsInit&&this.pushSource(c.paramsInit),this.pushSource(\"if (helper = \"+d+\") { \"+f+\" = helper.call(\"+c.callParams+\"); }\"),this.pushSource(\"else { helper = \"+e+\"; \"+f+\" = typeof helper === functionType ? helper.call(\"+c.callParams+\") : helper; }\")},invokePartial:function(a){var b=[this.nameLookup(\"partials\",a,\"partial\"),\"'\"+a+\"'\",this.popStack(),\"helpers\",\"partials\"];this.options.data&&b.push(\"data\"),this.context.aliases.self=\"this\",this.push(\"self.invokePartial(\"+b.join(\", \")+\")\")},assignToHash:function(a){var b,c,d=this.popStack();this.options.stringParams&&(c=this.popStack(),b=this.popStack());var e=this.hash;b&&e.contexts.push(\"'\"+a+\"': \"+b),c&&e.types.push(\"'\"+a+\"': \"+c),e.values.push(\"'\"+a+\"': (\"+d+\")\")},compiler:d,compileChildren:function(a,b){for(var c,d,e=a.children,f=0,g=e.length;g>f;f++){c=e[f],d=new this.compiler;var h=this.matchExistingProgram(c);null==h?(this.context.programs.push(\"\"),h=this.context.programs.length,c.index=h,c.name=\"program\"+h,this.context.programs[h]=d.compile(c,b,this.context),this.context.environments[h]=c):(c.index=h,c.name=\"program\"+h)}},matchExistingProgram:function(a){for(var b=0,c=this.context.environments.length;c>b;b++){var d=this.context.environments[b];if(d&&d.equals(a))return b}},programExpression:function(a){if(this.context.aliases.self=\"this\",null==a)return\"self.noop\";for(var b,c=this.environment.children[a],d=c.depths.list,e=[c.index,c.name,\"data\"],f=0,g=d.length;g>f;f++)b=d[f],1===b?e.push(\"depth0\"):e.push(\"depth\"+(b-1));return(0===d.length?\"self.program(\":\"self.programWithDepth(\")+e.join(\", \")+\")\"},register:function(a,b){this.useRegister(a),this.pushSource(a+\" = \"+b+\";\")},useRegister:function(a){this.registers[a]||(this.registers[a]=!0,this.registers.list.push(a))},pushStackLiteral:function(a){return this.push(new c(a))},pushSource:function(a){this.pendingContent&&(this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent))),this.pendingContent=void 0),a&&this.source.push(a)},pushStack:function(a){this.flushInline();var b=this.incrStack();return a&&this.pushSource(b+\" = \"+a+\";\"),this.compileStack.push(b),b},replaceStack:function(a){var b,d,e,f=\"\",g=this.isInline();if(g){var h=this.popStack(!0);if(h instanceof c)b=h.value,e=!0;else{d=!this.stackSlot;var i=d?this.incrStack():this.topStackName();f=\"(\"+this.push(i)+\" = \"+h+\"),\",b=this.topStack()}}else b=this.topStack();var j=a.call(this,b);return g?(e||this.popStack(),d&&this.stackSlot--,this.push(\"(\"+f+j+\")\")):(/^stack/.test(b)||(b=this.nextStack()),this.pushSource(b+\" = (\"+f+j+\");\")),b},nextStack:function(){return this.pushStack()},incrStack:function(){return this.stackSlot++,this.stackSlot>this.stackVars.length&&this.stackVars.push(\"stack\"+this.stackSlot),this.topStackName()},topStackName:function(){return\"stack\"+this.stackSlot},flushInline:function(){var a=this.inlineStack;if(a.length){this.inlineStack=[];for(var b=0,d=a.length;d>b;b++){var e=a[b];e instanceof c?this.compileStack.push(e):this.pushStack(e)}}},isInline:function(){return this.inlineStack.length},popStack:function(a){var b=this.isInline(),d=(b?this.inlineStack:this.compileStack).pop();if(!a&&d instanceof c)return d.value;if(!b){if(!this.stackSlot)throw new i(\"Invalid stack pop\");this.stackSlot--}return d},topStack:function(a){var b=this.isInline()?this.inlineStack:this.compileStack,d=b[b.length-1];return!a&&d instanceof c?d.value:d},quotedString:function(a){return'\"'+a.replace(/\\\\/g,\"\\\\\\\\\").replace(/\"/g,'\\\\\"').replace(/\\n/g,\"\\\\n\").replace(/\\r/g,\"\\\\r\").replace(/\\u2028/g,\"\\\\u2028\").replace(/\\u2029/g,\"\\\\u2029\")+'\"'},setupHelper:function(a,b,c){var d=[],e=this.setupParams(a,d,c),f=this.nameLookup(\"helpers\",b,\"helper\");return{params:d,paramsInit:e,name:f,callParams:[\"depth0\"].concat(d).join(\", \"),helperMissingParams:c&&[\"depth0\",this.quotedString(b)].concat(d).join(\", \")}},setupOptions:function(a,b){var c,d,e,f=[],g=[],h=[];f.push(\"hash:\"+this.popStack()),this.options.stringParams&&(f.push(\"hashTypes:\"+this.popStack()),f.push(\"hashContexts:\"+this.popStack())),d=this.popStack(),e=this.popStack(),(e||d)&&(e||(this.context.aliases.self=\"this\",e=\"self.noop\"),d||(this.context.aliases.self=\"this\",d=\"self.noop\"),f.push(\"inverse:\"+d),f.push(\"fn:\"+e));for(var i=0;a>i;i++)c=this.popStack(),b.push(c),this.options.stringParams&&(h.push(this.popStack()),g.push(this.popStack()));return this.options.stringParams&&(f.push(\"contexts:[\"+g.join(\",\")+\"]\"),f.push(\"types:[\"+h.join(\",\")+\"]\")),this.options.data&&f.push(\"data:data\"),f},setupParams:function(a,b,c){var d=\"{\"+this.setupOptions(a,b).join(\",\")+\"}\";return c?(this.useRegister(\"options\"),b.push(\"options\"),\"options=\"+d):(b.push(d),\"\")}};for(var j=\"break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield\".split(\" \"),k=d.RESERVED_WORDS={},l=0,m=j.length;m>l;l++)k[j[l]]=!0;return d.isValidJavaScriptVariableName=function(a){return!d.RESERVED_WORDS[a]&&/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(a)?!0:!1},e=d}(d,c),l=function(a,b,c,d,e){\"use strict\";var f,g=a,h=b,i=c.parser,j=c.parse,k=d.Compiler,l=d.compile,m=d.precompile,n=e,o=g.create,p=function(){var a=o();return a.compile=function(b,c){return l(b,c,a)},a.precompile=function(b,c){return m(b,c,a)},a.AST=h,a.Compiler=k,a.JavaScriptCompiler=n,a.Parser=i,a.parse=j,a};return g=p(),g.create=p,f=g}(f,g,i,j,k);return l}();"

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	// This file is just added for convenience so this repository can be
	// directly checked out into a project's deps folder
	module.exports = __webpack_require__(15);


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/*global setTimeout: false, console: false */
	(function () {
	
	    var async = {};
	
	    // global on the server, window in the browser
	    var root = this,
	        previous_async = root.async;
	
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = async;
	    }
	    else {
	        root.async = async;
	    }
	
	    async.noConflict = function () {
	        root.async = previous_async;
	        return async;
	    };
	
	    //// cross-browser compatiblity functions ////
	
	    var _forEach = function (arr, iterator) {
	        if (arr.forEach) {
	            return arr.forEach(iterator);
	        }
	        for (var i = 0; i < arr.length; i += 1) {
	            iterator(arr[i], i, arr);
	        }
	    };
	
	    var _map = function (arr, iterator) {
	        if (arr.map) {
	            return arr.map(iterator);
	        }
	        var results = [];
	        _forEach(arr, function (x, i, a) {
	            results.push(iterator(x, i, a));
	        });
	        return results;
	    };
	
	    var _reduce = function (arr, iterator, memo) {
	        if (arr.reduce) {
	            return arr.reduce(iterator, memo);
	        }
	        _forEach(arr, function (x, i, a) {
	            memo = iterator(memo, x, i, a);
	        });
	        return memo;
	    };
	
	    var _keys = function (obj) {
	        if (Object.keys) {
	            return Object.keys(obj);
	        }
	        var keys = [];
	        for (var k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                keys.push(k);
	            }
	        }
	        return keys;
	    };
	
	    //// exported async module functions ////
	
	    //// nextTick implementation with browser-compatible fallback ////
	    if (typeof process === 'undefined' || !(process.nextTick)) {
	        async.nextTick = function (fn) {
	            setTimeout(fn, 0);
	        };
	    }
	    else {
	        async.nextTick = process.nextTick;
	    }
	
	    async.forEach = function (arr, iterator, callback) {
	        callback = callback || function () {};
	        if (!arr.length) {
	            return callback();
	        }
	        var completed = 0;
	        _forEach(arr, function (x) {
	            iterator(x, function (err) {
	                if (err) {
	                    callback(err);
	                    callback = function () {};
	                }
	                else {
	                    completed += 1;
	                    if (completed === arr.length) {
	                        callback();
	                    }
	                }
	            });
	        });
	    };
	
	    async.forEachSeries = function (arr, iterator, callback) {
	        callback = callback || function () {};
	        if (!arr.length) {
	            return callback();
	        }
	        var completed = 0;
	        var iterate = function () {
	            iterator(arr[completed], function (err) {
	                if (err) {
	                    callback(err);
	                    callback = function () {};
	                }
	                else {
	                    completed += 1;
	                    if (completed === arr.length) {
	                        callback();
	                    }
	                    else {
	                        iterate();
	                    }
	                }
	            });
	        };
	        iterate();
	    };
	    
	    async.forEachLimit = function (arr, limit, iterator, callback) {
	        callback = callback || function () {};
	        if (!arr.length || limit <= 0) {
	            return callback(); 
	        }
	        var completed = 0;
	        var started = 0;
	        var running = 0;
	        
	        (function replenish () {
	          if (completed === arr.length) {
	              return callback();
	          }
	          
	          while (running < limit && started < arr.length) {
	            iterator(arr[started], function (err) {
	              if (err) {
	                  callback(err);
	                  callback = function () {};
	              }
	              else {
	                  completed += 1;
	                  running -= 1;
	                  if (completed === arr.length) {
	                      callback();
	                  }
	                  else {
	                      replenish();
	                  }
	              }
	            });
	            started += 1;
	            running += 1;
	          }
	        })();
	    };
	
	
	    var doParallel = function (fn) {
	        return function () {
	            var args = Array.prototype.slice.call(arguments);
	            return fn.apply(null, [async.forEach].concat(args));
	        };
	    };
	    var doSeries = function (fn) {
	        return function () {
	            var args = Array.prototype.slice.call(arguments);
	            return fn.apply(null, [async.forEachSeries].concat(args));
	        };
	    };
	
	
	    var _asyncMap = function (eachfn, arr, iterator, callback) {
	        var results = [];
	        arr = _map(arr, function (x, i) {
	            return {index: i, value: x};
	        });
	        eachfn(arr, function (x, callback) {
	            iterator(x.value, function (err, v) {
	                results[x.index] = v;
	                callback(err);
	            });
	        }, function (err) {
	            callback(err, results);
	        });
	    };
	    async.map = doParallel(_asyncMap);
	    async.mapSeries = doSeries(_asyncMap);
	
	
	    // reduce only has a series version, as doing reduce in parallel won't
	    // work in many situations.
	    async.reduce = function (arr, memo, iterator, callback) {
	        async.forEachSeries(arr, function (x, callback) {
	            iterator(memo, x, function (err, v) {
	                memo = v;
	                callback(err);
	            });
	        }, function (err) {
	            callback(err, memo);
	        });
	    };
	    // inject alias
	    async.inject = async.reduce;
	    // foldl alias
	    async.foldl = async.reduce;
	
	    async.reduceRight = function (arr, memo, iterator, callback) {
	        var reversed = _map(arr, function (x) {
	            return x;
	        }).reverse();
	        async.reduce(reversed, memo, iterator, callback);
	    };
	    // foldr alias
	    async.foldr = async.reduceRight;
	
	    var _filter = function (eachfn, arr, iterator, callback) {
	        var results = [];
	        arr = _map(arr, function (x, i) {
	            return {index: i, value: x};
	        });
	        eachfn(arr, function (x, callback) {
	            iterator(x.value, function (v) {
	                if (v) {
	                    results.push(x);
	                }
	                callback();
	            });
	        }, function (err) {
	            callback(_map(results.sort(function (a, b) {
	                return a.index - b.index;
	            }), function (x) {
	                return x.value;
	            }));
	        });
	    };
	    async.filter = doParallel(_filter);
	    async.filterSeries = doSeries(_filter);
	    // select alias
	    async.select = async.filter;
	    async.selectSeries = async.filterSeries;
	
	    var _reject = function (eachfn, arr, iterator, callback) {
	        var results = [];
	        arr = _map(arr, function (x, i) {
	            return {index: i, value: x};
	        });
	        eachfn(arr, function (x, callback) {
	            iterator(x.value, function (v) {
	                if (!v) {
	                    results.push(x);
	                }
	                callback();
	            });
	        }, function (err) {
	            callback(_map(results.sort(function (a, b) {
	                return a.index - b.index;
	            }), function (x) {
	                return x.value;
	            }));
	        });
	    };
	    async.reject = doParallel(_reject);
	    async.rejectSeries = doSeries(_reject);
	
	    var _detect = function (eachfn, arr, iterator, main_callback) {
	        eachfn(arr, function (x, callback) {
	            iterator(x, function (result) {
	                if (result) {
	                    main_callback(x);
	                    main_callback = function () {};
	                }
	                else {
	                    callback();
	                }
	            });
	        }, function (err) {
	            main_callback();
	        });
	    };
	    async.detect = doParallel(_detect);
	    async.detectSeries = doSeries(_detect);
	
	    async.some = function (arr, iterator, main_callback) {
	        async.forEach(arr, function (x, callback) {
	            iterator(x, function (v) {
	                if (v) {
	                    main_callback(true);
	                    main_callback = function () {};
	                }
	                callback();
	            });
	        }, function (err) {
	            main_callback(false);
	        });
	    };
	    // any alias
	    async.any = async.some;
	
	    async.every = function (arr, iterator, main_callback) {
	        async.forEach(arr, function (x, callback) {
	            iterator(x, function (v) {
	                if (!v) {
	                    main_callback(false);
	                    main_callback = function () {};
	                }
	                callback();
	            });
	        }, function (err) {
	            main_callback(true);
	        });
	    };
	    // all alias
	    async.all = async.every;
	
	    async.sortBy = function (arr, iterator, callback) {
	        async.map(arr, function (x, callback) {
	            iterator(x, function (err, criteria) {
	                if (err) {
	                    callback(err);
	                }
	                else {
	                    callback(null, {value: x, criteria: criteria});
	                }
	            });
	        }, function (err, results) {
	            if (err) {
	                return callback(err);
	            }
	            else {
	                var fn = function (left, right) {
	                    var a = left.criteria, b = right.criteria;
	                    return a < b ? -1 : a > b ? 1 : 0;
	                };
	                callback(null, _map(results.sort(fn), function (x) {
	                    return x.value;
	                }));
	            }
	        });
	    };
	
	    async.auto = function (tasks, callback) {
	        callback = callback || function () {};
	        var keys = _keys(tasks);
	        if (!keys.length) {
	            return callback(null);
	        }
	
	        var results = {};
	
	        var listeners = [];
	        var addListener = function (fn) {
	            listeners.unshift(fn);
	        };
	        var removeListener = function (fn) {
	            for (var i = 0; i < listeners.length; i += 1) {
	                if (listeners[i] === fn) {
	                    listeners.splice(i, 1);
	                    return;
	                }
	            }
	        };
	        var taskComplete = function () {
	            _forEach(listeners.slice(0), function (fn) {
	                fn();
	            });
	        };
	
	        addListener(function () {
	            if (_keys(results).length === keys.length) {
	                callback(null, results);
	                callback = function () {};
	            }
	        });
	
	        _forEach(keys, function (k) {
	            var task = (tasks[k] instanceof Function) ? [tasks[k]]: tasks[k];
	            var taskCallback = function (err) {
	                if (err) {
	                    callback(err);
	                    // stop subsequent errors hitting callback multiple times
	                    callback = function () {};
	                }
	                else {
	                    var args = Array.prototype.slice.call(arguments, 1);
	                    if (args.length <= 1) {
	                        args = args[0];
	                    }
	                    results[k] = args;
	                    taskComplete();
	                }
	            };
	            var requires = task.slice(0, Math.abs(task.length - 1)) || [];
	            var ready = function () {
	                return _reduce(requires, function (a, x) {
	                    return (a && results.hasOwnProperty(x));
	                }, true);
	            };
	            if (ready()) {
	                task[task.length - 1](taskCallback, results);
	            }
	            else {
	                var listener = function () {
	                    if (ready()) {
	                        removeListener(listener);
	                        task[task.length - 1](taskCallback, results);
	                    }
	                };
	                addListener(listener);
	            }
	        });
	    };
	
	    async.waterfall = function (tasks, callback) {
	        callback = callback || function () {};
	        if (!tasks.length) {
	            return callback();
	        }
	        var wrapIterator = function (iterator) {
	            return function (err) {
	                if (err) {
	                    callback(err);
	                    callback = function () {};
	                }
	                else {
	                    var args = Array.prototype.slice.call(arguments, 1);
	                    var next = iterator.next();
	                    if (next) {
	                        args.push(wrapIterator(next));
	                    }
	                    else {
	                        args.push(callback);
	                    }
	                    async.nextTick(function () {
	                        iterator.apply(null, args);
	                    });
	                }
	            };
	        };
	        wrapIterator(async.iterator(tasks))();
	    };
	
	    async.parallel = function (tasks, callback) {
	        callback = callback || function () {};
	        if (tasks.constructor === Array) {
	            async.map(tasks, function (fn, callback) {
	                if (fn) {
	                    fn(function (err) {
	                        var args = Array.prototype.slice.call(arguments, 1);
	                        if (args.length <= 1) {
	                            args = args[0];
	                        }
	                        callback.call(null, err, args);
	                    });
	                }
	            }, callback);
	        }
	        else {
	            var results = {};
	            async.forEach(_keys(tasks), function (k, callback) {
	                tasks[k](function (err) {
	                    var args = Array.prototype.slice.call(arguments, 1);
	                    if (args.length <= 1) {
	                        args = args[0];
	                    }
	                    results[k] = args;
	                    callback(err);
	                });
	            }, function (err) {
	                callback(err, results);
	            });
	        }
	    };
	
	    async.series = function (tasks, callback) {
	        callback = callback || function () {};
	        if (tasks.constructor === Array) {
	            async.mapSeries(tasks, function (fn, callback) {
	                if (fn) {
	                    fn(function (err) {
	                        var args = Array.prototype.slice.call(arguments, 1);
	                        if (args.length <= 1) {
	                            args = args[0];
	                        }
	                        callback.call(null, err, args);
	                    });
	                }
	            }, callback);
	        }
	        else {
	            var results = {};
	            async.forEachSeries(_keys(tasks), function (k, callback) {
	                tasks[k](function (err) {
	                    var args = Array.prototype.slice.call(arguments, 1);
	                    if (args.length <= 1) {
	                        args = args[0];
	                    }
	                    results[k] = args;
	                    callback(err);
	                });
	            }, function (err) {
	                callback(err, results);
	            });
	        }
	    };
	
	    async.iterator = function (tasks) {
	        var makeCallback = function (index) {
	            var fn = function () {
	                if (tasks.length) {
	                    tasks[index].apply(null, arguments);
	                }
	                return fn.next();
	            };
	            fn.next = function () {
	                return (index < tasks.length - 1) ? makeCallback(index + 1): null;
	            };
	            return fn;
	        };
	        return makeCallback(0);
	    };
	
	    async.apply = function (fn) {
	        var args = Array.prototype.slice.call(arguments, 1);
	        return function () {
	            return fn.apply(
	                null, args.concat(Array.prototype.slice.call(arguments))
	            );
	        };
	    };
	
	    var _concat = function (eachfn, arr, fn, callback) {
	        var r = [];
	        eachfn(arr, function (x, cb) {
	            fn(x, function (err, y) {
	                r = r.concat(y || []);
	                cb(err);
	            });
	        }, function (err) {
	            callback(err, r);
	        });
	    };
	    async.concat = doParallel(_concat);
	    async.concatSeries = doSeries(_concat);
	
	    async.whilst = function (test, iterator, callback) {
	        if (test()) {
	            iterator(function (err) {
	                if (err) {
	                    return callback(err);
	                }
	                async.whilst(test, iterator, callback);
	            });
	        }
	        else {
	            callback();
	        }
	    };
	
	    async.until = function (test, iterator, callback) {
	        if (!test()) {
	            iterator(function (err) {
	                if (err) {
	                    return callback(err);
	                }
	                async.until(test, iterator, callback);
	            });
	        }
	        else {
	            callback();
	        }
	    };
	
	    async.queue = function (worker, concurrency) {
	        var workers = 0;
	        var q = {
	            tasks: [],
	            concurrency: concurrency,
	            saturated: null,
	            empty: null,
	            drain: null,
	            push: function (data, callback) {
	                if(data.constructor !== Array) {
	                    data = [data];
	                }
	                _forEach(data, function(task) {
	                    q.tasks.push({
	                        data: task,
	                        callback: typeof callback === 'function' ? callback : null
	                    });
	                    if (q.saturated && q.tasks.length == concurrency) {
	                        q.saturated();
	                    }
	                    async.nextTick(q.process);
	                });
	            },
	            process: function () {
	                if (workers < q.concurrency && q.tasks.length) {
	                    var task = q.tasks.shift();
	                    if(q.empty && q.tasks.length == 0) q.empty();
	                    workers += 1;
	                    worker(task.data, function () {
	                        workers -= 1;
	                        if (task.callback) {
	                            task.callback.apply(task, arguments);
	                        }
	                        if(q.drain && q.tasks.length + workers == 0) q.drain();
	                        q.process();
	                    });
	                }
	            },
	            length: function () {
	                return q.tasks.length;
	            },
	            running: function () {
	                return workers;
	            }
	        };
	        return q;
	    };
	
	    var _console_fn = function (name) {
	        return function (fn) {
	            var args = Array.prototype.slice.call(arguments, 1);
	            fn.apply(null, args.concat([function (err) {
	                var args = Array.prototype.slice.call(arguments, 1);
	                if (typeof console !== 'undefined') {
	                    if (err) {
	                        if (console.error) {
	                            console.error(err);
	                        }
	                    }
	                    else if (console[name]) {
	                        _forEach(args, function (x) {
	                            console[name](x);
	                        });
	                    }
	                }
	            }]));
	        };
	    };
	    async.log = _console_fn('log');
	    async.dir = _console_fn('dir');
	    /*async.info = _console_fn('info');
	    async.warn = _console_fn('warn');
	    async.error = _console_fn('error');*/
	
	    async.memoize = function (fn, hasher) {
	        var memo = {};
	        var queues = {};
	        hasher = hasher || function (x) {
	            return x;
	        };
	        var memoized = function () {
	            var args = Array.prototype.slice.call(arguments);
	            var callback = args.pop();
	            var key = hasher.apply(null, args);
	            if (key in memo) {
	                callback.apply(null, memo[key]);
	            }
	            else if (key in queues) {
	                queues[key].push(callback);
	            }
	            else {
	                queues[key] = [callback];
	                fn.apply(null, args.concat([function () {
	                    memo[key] = arguments;
	                    var q = queues[key];
	                    delete queues[key];
	                    for (var i = 0, l = q.length; i < l; i++) {
	                      q[i].apply(null, arguments);
	                    }
	                }]));
	            }
	        };
	        memoized.unmemoized = fn;
	        return memoized;
	    };
	
	    async.unmemoize = function (fn) {
	      return function () {
	        return (fn.unmemoized || fn).apply(null, arguments);
	      };
	    };
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ },
/* 16 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(18))

/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = "//! moment.js\n//! version : 2.11.2\n//! authors : Tim Wood, Iskren Chernev, Moment.js contributors\n//! license : MIT\n//! momentjs.com\n!function(a,b){\"object\"==typeof exports&&\"undefined\"!=typeof module?module.exports=b():\"function\"==typeof define&&define.amd?define(b):a.moment=b()}(this,function(){\"use strict\";function a(){return Uc.apply(null,arguments)}function b(a){Uc=a}function c(a){return\"[object Array]\"===Object.prototype.toString.call(a)}function d(a){return a instanceof Date||\"[object Date]\"===Object.prototype.toString.call(a)}function e(a,b){var c,d=[];for(c=0;c<a.length;++c)d.push(b(a[c],c));return d}function f(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function g(a,b){for(var c in b)f(b,c)&&(a[c]=b[c]);return f(b,\"toString\")&&(a.toString=b.toString),f(b,\"valueOf\")&&(a.valueOf=b.valueOf),a}function h(a,b,c,d){return Da(a,b,c,d,!0).utc()}function i(){return{empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1}}function j(a){return null==a._pf&&(a._pf=i()),a._pf}function k(a){if(null==a._isValid){var b=j(a);a._isValid=!(isNaN(a._d.getTime())||!(b.overflow<0)||b.empty||b.invalidMonth||b.invalidWeekday||b.nullInput||b.invalidFormat||b.userInvalidated),a._strict&&(a._isValid=a._isValid&&0===b.charsLeftOver&&0===b.unusedTokens.length&&void 0===b.bigHour)}return a._isValid}function l(a){var b=h(NaN);return null!=a?g(j(b),a):j(b).userInvalidated=!0,b}function m(a){return void 0===a}function n(a,b){var c,d,e;if(m(b._isAMomentObject)||(a._isAMomentObject=b._isAMomentObject),m(b._i)||(a._i=b._i),m(b._f)||(a._f=b._f),m(b._l)||(a._l=b._l),m(b._strict)||(a._strict=b._strict),m(b._tzm)||(a._tzm=b._tzm),m(b._isUTC)||(a._isUTC=b._isUTC),m(b._offset)||(a._offset=b._offset),m(b._pf)||(a._pf=j(b)),m(b._locale)||(a._locale=b._locale),Wc.length>0)for(c in Wc)d=Wc[c],e=b[d],m(e)||(a[d]=e);return a}function o(b){n(this,b),this._d=new Date(null!=b._d?b._d.getTime():NaN),Xc===!1&&(Xc=!0,a.updateOffset(this),Xc=!1)}function p(a){return a instanceof o||null!=a&&null!=a._isAMomentObject}function q(a){return 0>a?Math.ceil(a):Math.floor(a)}function r(a){var b=+a,c=0;return 0!==b&&isFinite(b)&&(c=q(b)),c}function s(a,b,c){var d,e=Math.min(a.length,b.length),f=Math.abs(a.length-b.length),g=0;for(d=0;e>d;d++)(c&&a[d]!==b[d]||!c&&r(a[d])!==r(b[d]))&&g++;return g+f}function t(){}function u(a){return a?a.toLowerCase().replace(\"_\",\"-\"):a}function v(a){for(var b,c,d,e,f=0;f<a.length;){for(e=u(a[f]).split(\"-\"),b=e.length,c=u(a[f+1]),c=c?c.split(\"-\"):null;b>0;){if(d=w(e.slice(0,b).join(\"-\")))return d;if(c&&c.length>=b&&s(e,c,!0)>=b-1)break;b--}f++}return null}function w(a){var b=null;if(!Yc[a]&&\"undefined\"!=typeof module&&module&&module.exports)try{b=Vc._abbr,require(\"./locale/\"+a),x(b)}catch(c){}return Yc[a]}function x(a,b){var c;return a&&(c=m(b)?z(a):y(a,b),c&&(Vc=c)),Vc._abbr}function y(a,b){return null!==b?(b.abbr=a,Yc[a]=Yc[a]||new t,Yc[a].set(b),x(a),Yc[a]):(delete Yc[a],null)}function z(a){var b;if(a&&a._locale&&a._locale._abbr&&(a=a._locale._abbr),!a)return Vc;if(!c(a)){if(b=w(a))return b;a=[a]}return v(a)}function A(a,b){var c=a.toLowerCase();Zc[c]=Zc[c+\"s\"]=Zc[b]=a}function B(a){return\"string\"==typeof a?Zc[a]||Zc[a.toLowerCase()]:void 0}function C(a){var b,c,d={};for(c in a)f(a,c)&&(b=B(c),b&&(d[b]=a[c]));return d}function D(a){return a instanceof Function||\"[object Function]\"===Object.prototype.toString.call(a)}function E(b,c){return function(d){return null!=d?(G(this,b,d),a.updateOffset(this,c),this):F(this,b)}}function F(a,b){return a.isValid()?a._d[\"get\"+(a._isUTC?\"UTC\":\"\")+b]():NaN}function G(a,b,c){a.isValid()&&a._d[\"set\"+(a._isUTC?\"UTC\":\"\")+b](c)}function H(a,b){var c;if(\"object\"==typeof a)for(c in a)this.set(c,a[c]);else if(a=B(a),D(this[a]))return this[a](b);return this}function I(a,b,c){var d=\"\"+Math.abs(a),e=b-d.length,f=a>=0;return(f?c?\"+\":\"\":\"-\")+Math.pow(10,Math.max(0,e)).toString().substr(1)+d}function J(a,b,c,d){var e=d;\"string\"==typeof d&&(e=function(){return this[d]()}),a&&(bd[a]=e),b&&(bd[b[0]]=function(){return I(e.apply(this,arguments),b[1],b[2])}),c&&(bd[c]=function(){return this.localeData().ordinal(e.apply(this,arguments),a)})}function K(a){return a.match(/\\[[\\s\\S]/)?a.replace(/^\\[|\\]$/g,\"\"):a.replace(/\\\\/g,\"\")}function L(a){var b,c,d=a.match($c);for(b=0,c=d.length;c>b;b++)bd[d[b]]?d[b]=bd[d[b]]:d[b]=K(d[b]);return function(e){var f=\"\";for(b=0;c>b;b++)f+=d[b]instanceof Function?d[b].call(e,a):d[b];return f}}function M(a,b){return a.isValid()?(b=N(b,a.localeData()),ad[b]=ad[b]||L(b),ad[b](a)):a.localeData().invalidDate()}function N(a,b){function c(a){return b.longDateFormat(a)||a}var d=5;for(_c.lastIndex=0;d>=0&&_c.test(a);)a=a.replace(_c,c),_c.lastIndex=0,d-=1;return a}function O(a,b,c){td[a]=D(b)?b:function(a,d){return a&&c?c:b}}function P(a,b){return f(td,a)?td[a](b._strict,b._locale):new RegExp(Q(a))}function Q(a){return R(a.replace(\"\\\\\",\"\").replace(/\\\\(\\[)|\\\\(\\])|\\[([^\\]\\[]*)\\]|\\\\(.)/g,function(a,b,c,d,e){return b||c||d||e}))}function R(a){return a.replace(/[-\\/\\\\^$*+?.()|[\\]{}]/g,\"\\\\$&\")}function S(a,b){var c,d=b;for(\"string\"==typeof a&&(a=[a]),\"number\"==typeof b&&(d=function(a,c){c[b]=r(a)}),c=0;c<a.length;c++)ud[a[c]]=d}function T(a,b){S(a,function(a,c,d,e){d._w=d._w||{},b(a,d._w,d,e)})}function U(a,b,c){null!=b&&f(ud,a)&&ud[a](b,c._a,c,a)}function V(a,b){return new Date(Date.UTC(a,b+1,0)).getUTCDate()}function W(a,b){return c(this._months)?this._months[a.month()]:this._months[Ed.test(b)?\"format\":\"standalone\"][a.month()]}function X(a,b){return c(this._monthsShort)?this._monthsShort[a.month()]:this._monthsShort[Ed.test(b)?\"format\":\"standalone\"][a.month()]}function Y(a,b,c){var d,e,f;for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),d=0;12>d;d++){if(e=h([2e3,d]),c&&!this._longMonthsParse[d]&&(this._longMonthsParse[d]=new RegExp(\"^\"+this.months(e,\"\").replace(\".\",\"\")+\"$\",\"i\"),this._shortMonthsParse[d]=new RegExp(\"^\"+this.monthsShort(e,\"\").replace(\".\",\"\")+\"$\",\"i\")),c||this._monthsParse[d]||(f=\"^\"+this.months(e,\"\")+\"|^\"+this.monthsShort(e,\"\"),this._monthsParse[d]=new RegExp(f.replace(\".\",\"\"),\"i\")),c&&\"MMMM\"===b&&this._longMonthsParse[d].test(a))return d;if(c&&\"MMM\"===b&&this._shortMonthsParse[d].test(a))return d;if(!c&&this._monthsParse[d].test(a))return d}}function Z(a,b){var c;return a.isValid()?\"string\"==typeof b&&(b=a.localeData().monthsParse(b),\"number\"!=typeof b)?a:(c=Math.min(a.date(),V(a.year(),b)),a._d[\"set\"+(a._isUTC?\"UTC\":\"\")+\"Month\"](b,c),a):a}function $(b){return null!=b?(Z(this,b),a.updateOffset(this,!0),this):F(this,\"Month\")}function _(){return V(this.year(),this.month())}function aa(a){return this._monthsParseExact?(f(this,\"_monthsRegex\")||ca.call(this),a?this._monthsShortStrictRegex:this._monthsShortRegex):this._monthsShortStrictRegex&&a?this._monthsShortStrictRegex:this._monthsShortRegex}function ba(a){return this._monthsParseExact?(f(this,\"_monthsRegex\")||ca.call(this),a?this._monthsStrictRegex:this._monthsRegex):this._monthsStrictRegex&&a?this._monthsStrictRegex:this._monthsRegex}function ca(){function a(a,b){return b.length-a.length}var b,c,d=[],e=[],f=[];for(b=0;12>b;b++)c=h([2e3,b]),d.push(this.monthsShort(c,\"\")),e.push(this.months(c,\"\")),f.push(this.months(c,\"\")),f.push(this.monthsShort(c,\"\"));for(d.sort(a),e.sort(a),f.sort(a),b=0;12>b;b++)d[b]=R(d[b]),e[b]=R(e[b]),f[b]=R(f[b]);this._monthsRegex=new RegExp(\"^(\"+f.join(\"|\")+\")\",\"i\"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp(\"^(\"+e.join(\"|\")+\")$\",\"i\"),this._monthsShortStrictRegex=new RegExp(\"^(\"+d.join(\"|\")+\")$\",\"i\")}function da(a){var b,c=a._a;return c&&-2===j(a).overflow&&(b=c[wd]<0||c[wd]>11?wd:c[xd]<1||c[xd]>V(c[vd],c[wd])?xd:c[yd]<0||c[yd]>24||24===c[yd]&&(0!==c[zd]||0!==c[Ad]||0!==c[Bd])?yd:c[zd]<0||c[zd]>59?zd:c[Ad]<0||c[Ad]>59?Ad:c[Bd]<0||c[Bd]>999?Bd:-1,j(a)._overflowDayOfYear&&(vd>b||b>xd)&&(b=xd),j(a)._overflowWeeks&&-1===b&&(b=Cd),j(a)._overflowWeekday&&-1===b&&(b=Dd),j(a).overflow=b),a}function ea(b){a.suppressDeprecationWarnings===!1&&\"undefined\"!=typeof console&&console.warn&&console.warn(\"Deprecation warning: \"+b)}function fa(a,b){var c=!0;return g(function(){return c&&(ea(a+\"\\nArguments: \"+Array.prototype.slice.call(arguments).join(\", \")+\"\\n\"+(new Error).stack),c=!1),b.apply(this,arguments)},b)}function ga(a,b){Jd[a]||(ea(b),Jd[a]=!0)}function ha(a){var b,c,d,e,f,g,h=a._i,i=Kd.exec(h)||Ld.exec(h);if(i){for(j(a).iso=!0,b=0,c=Nd.length;c>b;b++)if(Nd[b][1].exec(i[1])){e=Nd[b][0],d=Nd[b][2]!==!1;break}if(null==e)return void(a._isValid=!1);if(i[3]){for(b=0,c=Od.length;c>b;b++)if(Od[b][1].exec(i[3])){f=(i[2]||\" \")+Od[b][0];break}if(null==f)return void(a._isValid=!1)}if(!d&&null!=f)return void(a._isValid=!1);if(i[4]){if(!Md.exec(i[4]))return void(a._isValid=!1);g=\"Z\"}a._f=e+(f||\"\")+(g||\"\"),wa(a)}else a._isValid=!1}function ia(b){var c=Pd.exec(b._i);return null!==c?void(b._d=new Date(+c[1])):(ha(b),void(b._isValid===!1&&(delete b._isValid,a.createFromInputFallback(b))))}function ja(a,b,c,d,e,f,g){var h=new Date(a,b,c,d,e,f,g);return 100>a&&a>=0&&isFinite(h.getFullYear())&&h.setFullYear(a),h}function ka(a){var b=new Date(Date.UTC.apply(null,arguments));return 100>a&&a>=0&&isFinite(b.getUTCFullYear())&&b.setUTCFullYear(a),b}function la(a){return ma(a)?366:365}function ma(a){return a%4===0&&a%100!==0||a%400===0}function na(){return ma(this.year())}function oa(a,b,c){var d=7+b-c,e=(7+ka(a,0,d).getUTCDay()-b)%7;return-e+d-1}function pa(a,b,c,d,e){var f,g,h=(7+c-d)%7,i=oa(a,d,e),j=1+7*(b-1)+h+i;return 0>=j?(f=a-1,g=la(f)+j):j>la(a)?(f=a+1,g=j-la(a)):(f=a,g=j),{year:f,dayOfYear:g}}function qa(a,b,c){var d,e,f=oa(a.year(),b,c),g=Math.floor((a.dayOfYear()-f-1)/7)+1;return 1>g?(e=a.year()-1,d=g+ra(e,b,c)):g>ra(a.year(),b,c)?(d=g-ra(a.year(),b,c),e=a.year()+1):(e=a.year(),d=g),{week:d,year:e}}function ra(a,b,c){var d=oa(a,b,c),e=oa(a+1,b,c);return(la(a)-d+e)/7}function sa(a,b,c){return null!=a?a:null!=b?b:c}function ta(b){var c=new Date(a.now());return b._useUTC?[c.getUTCFullYear(),c.getUTCMonth(),c.getUTCDate()]:[c.getFullYear(),c.getMonth(),c.getDate()]}function ua(a){var b,c,d,e,f=[];if(!a._d){for(d=ta(a),a._w&&null==a._a[xd]&&null==a._a[wd]&&va(a),a._dayOfYear&&(e=sa(a._a[vd],d[vd]),a._dayOfYear>la(e)&&(j(a)._overflowDayOfYear=!0),c=ka(e,0,a._dayOfYear),a._a[wd]=c.getUTCMonth(),a._a[xd]=c.getUTCDate()),b=0;3>b&&null==a._a[b];++b)a._a[b]=f[b]=d[b];for(;7>b;b++)a._a[b]=f[b]=null==a._a[b]?2===b?1:0:a._a[b];24===a._a[yd]&&0===a._a[zd]&&0===a._a[Ad]&&0===a._a[Bd]&&(a._nextDay=!0,a._a[yd]=0),a._d=(a._useUTC?ka:ja).apply(null,f),null!=a._tzm&&a._d.setUTCMinutes(a._d.getUTCMinutes()-a._tzm),a._nextDay&&(a._a[yd]=24)}}function va(a){var b,c,d,e,f,g,h,i;b=a._w,null!=b.GG||null!=b.W||null!=b.E?(f=1,g=4,c=sa(b.GG,a._a[vd],qa(Ea(),1,4).year),d=sa(b.W,1),e=sa(b.E,1),(1>e||e>7)&&(i=!0)):(f=a._locale._week.dow,g=a._locale._week.doy,c=sa(b.gg,a._a[vd],qa(Ea(),f,g).year),d=sa(b.w,1),null!=b.d?(e=b.d,(0>e||e>6)&&(i=!0)):null!=b.e?(e=b.e+f,(b.e<0||b.e>6)&&(i=!0)):e=f),1>d||d>ra(c,f,g)?j(a)._overflowWeeks=!0:null!=i?j(a)._overflowWeekday=!0:(h=pa(c,d,e,f,g),a._a[vd]=h.year,a._dayOfYear=h.dayOfYear)}function wa(b){if(b._f===a.ISO_8601)return void ha(b);b._a=[],j(b).empty=!0;var c,d,e,f,g,h=\"\"+b._i,i=h.length,k=0;for(e=N(b._f,b._locale).match($c)||[],c=0;c<e.length;c++)f=e[c],d=(h.match(P(f,b))||[])[0],d&&(g=h.substr(0,h.indexOf(d)),g.length>0&&j(b).unusedInput.push(g),h=h.slice(h.indexOf(d)+d.length),k+=d.length),bd[f]?(d?j(b).empty=!1:j(b).unusedTokens.push(f),U(f,d,b)):b._strict&&!d&&j(b).unusedTokens.push(f);j(b).charsLeftOver=i-k,h.length>0&&j(b).unusedInput.push(h),j(b).bigHour===!0&&b._a[yd]<=12&&b._a[yd]>0&&(j(b).bigHour=void 0),b._a[yd]=xa(b._locale,b._a[yd],b._meridiem),ua(b),da(b)}function xa(a,b,c){var d;return null==c?b:null!=a.meridiemHour?a.meridiemHour(b,c):null!=a.isPM?(d=a.isPM(c),d&&12>b&&(b+=12),d||12!==b||(b=0),b):b}function ya(a){var b,c,d,e,f;if(0===a._f.length)return j(a).invalidFormat=!0,void(a._d=new Date(NaN));for(e=0;e<a._f.length;e++)f=0,b=n({},a),null!=a._useUTC&&(b._useUTC=a._useUTC),b._f=a._f[e],wa(b),k(b)&&(f+=j(b).charsLeftOver,f+=10*j(b).unusedTokens.length,j(b).score=f,(null==d||d>f)&&(d=f,c=b));g(a,c||b)}function za(a){if(!a._d){var b=C(a._i);a._a=e([b.year,b.month,b.day||b.date,b.hour,b.minute,b.second,b.millisecond],function(a){return a&&parseInt(a,10)}),ua(a)}}function Aa(a){var b=new o(da(Ba(a)));return b._nextDay&&(b.add(1,\"d\"),b._nextDay=void 0),b}function Ba(a){var b=a._i,e=a._f;return a._locale=a._locale||z(a._l),null===b||void 0===e&&\"\"===b?l({nullInput:!0}):(\"string\"==typeof b&&(a._i=b=a._locale.preparse(b)),p(b)?new o(da(b)):(c(e)?ya(a):e?wa(a):d(b)?a._d=b:Ca(a),k(a)||(a._d=null),a))}function Ca(b){var f=b._i;void 0===f?b._d=new Date(a.now()):d(f)?b._d=new Date(+f):\"string\"==typeof f?ia(b):c(f)?(b._a=e(f.slice(0),function(a){return parseInt(a,10)}),ua(b)):\"object\"==typeof f?za(b):\"number\"==typeof f?b._d=new Date(f):a.createFromInputFallback(b)}function Da(a,b,c,d,e){var f={};return\"boolean\"==typeof c&&(d=c,c=void 0),f._isAMomentObject=!0,f._useUTC=f._isUTC=e,f._l=c,f._i=a,f._f=b,f._strict=d,Aa(f)}function Ea(a,b,c,d){return Da(a,b,c,d,!1)}function Fa(a,b){var d,e;if(1===b.length&&c(b[0])&&(b=b[0]),!b.length)return Ea();for(d=b[0],e=1;e<b.length;++e)(!b[e].isValid()||b[e][a](d))&&(d=b[e]);return d}function Ga(){var a=[].slice.call(arguments,0);return Fa(\"isBefore\",a)}function Ha(){var a=[].slice.call(arguments,0);return Fa(\"isAfter\",a)}function Ia(a){var b=C(a),c=b.year||0,d=b.quarter||0,e=b.month||0,f=b.week||0,g=b.day||0,h=b.hour||0,i=b.minute||0,j=b.second||0,k=b.millisecond||0;this._milliseconds=+k+1e3*j+6e4*i+36e5*h,this._days=+g+7*f,this._months=+e+3*d+12*c,this._data={},this._locale=z(),this._bubble()}function Ja(a){return a instanceof Ia}function Ka(a,b){J(a,0,0,function(){var a=this.utcOffset(),c=\"+\";return 0>a&&(a=-a,c=\"-\"),c+I(~~(a/60),2)+b+I(~~a%60,2)})}function La(a,b){var c=(b||\"\").match(a)||[],d=c[c.length-1]||[],e=(d+\"\").match(Ud)||[\"-\",0,0],f=+(60*e[1])+r(e[2]);return\"+\"===e[0]?f:-f}function Ma(b,c){var e,f;return c._isUTC?(e=c.clone(),f=(p(b)||d(b)?+b:+Ea(b))-+e,e._d.setTime(+e._d+f),a.updateOffset(e,!1),e):Ea(b).local()}function Na(a){return 15*-Math.round(a._d.getTimezoneOffset()/15)}function Oa(b,c){var d,e=this._offset||0;return this.isValid()?null!=b?(\"string\"==typeof b?b=La(qd,b):Math.abs(b)<16&&(b=60*b),!this._isUTC&&c&&(d=Na(this)),this._offset=b,this._isUTC=!0,null!=d&&this.add(d,\"m\"),e!==b&&(!c||this._changeInProgress?cb(this,Za(b-e,\"m\"),1,!1):this._changeInProgress||(this._changeInProgress=!0,a.updateOffset(this,!0),this._changeInProgress=null)),this):this._isUTC?e:Na(this):null!=b?this:NaN}function Pa(a,b){return null!=a?(\"string\"!=typeof a&&(a=-a),this.utcOffset(a,b),this):-this.utcOffset()}function Qa(a){return this.utcOffset(0,a)}function Ra(a){return this._isUTC&&(this.utcOffset(0,a),this._isUTC=!1,a&&this.subtract(Na(this),\"m\")),this}function Sa(){return this._tzm?this.utcOffset(this._tzm):\"string\"==typeof this._i&&this.utcOffset(La(pd,this._i)),this}function Ta(a){return this.isValid()?(a=a?Ea(a).utcOffset():0,(this.utcOffset()-a)%60===0):!1}function Ua(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()}function Va(){if(!m(this._isDSTShifted))return this._isDSTShifted;var a={};if(n(a,this),a=Ba(a),a._a){var b=a._isUTC?h(a._a):Ea(a._a);this._isDSTShifted=this.isValid()&&s(a._a,b.toArray())>0}else this._isDSTShifted=!1;return this._isDSTShifted}function Wa(){return this.isValid()?!this._isUTC:!1}function Xa(){return this.isValid()?this._isUTC:!1}function Ya(){return this.isValid()?this._isUTC&&0===this._offset:!1}function Za(a,b){var c,d,e,g=a,h=null;return Ja(a)?g={ms:a._milliseconds,d:a._days,M:a._months}:\"number\"==typeof a?(g={},b?g[b]=a:g.milliseconds=a):(h=Vd.exec(a))?(c=\"-\"===h[1]?-1:1,g={y:0,d:r(h[xd])*c,h:r(h[yd])*c,m:r(h[zd])*c,s:r(h[Ad])*c,ms:r(h[Bd])*c}):(h=Wd.exec(a))?(c=\"-\"===h[1]?-1:1,g={y:$a(h[2],c),M:$a(h[3],c),d:$a(h[4],c),h:$a(h[5],c),m:$a(h[6],c),s:$a(h[7],c),w:$a(h[8],c)}):null==g?g={}:\"object\"==typeof g&&(\"from\"in g||\"to\"in g)&&(e=ab(Ea(g.from),Ea(g.to)),g={},g.ms=e.milliseconds,g.M=e.months),d=new Ia(g),Ja(a)&&f(a,\"_locale\")&&(d._locale=a._locale),d}function $a(a,b){var c=a&&parseFloat(a.replace(\",\",\".\"));return(isNaN(c)?0:c)*b}function _a(a,b){var c={milliseconds:0,months:0};return c.months=b.month()-a.month()+12*(b.year()-a.year()),a.clone().add(c.months,\"M\").isAfter(b)&&--c.months,c.milliseconds=+b-+a.clone().add(c.months,\"M\"),c}function ab(a,b){var c;return a.isValid()&&b.isValid()?(b=Ma(b,a),a.isBefore(b)?c=_a(a,b):(c=_a(b,a),c.milliseconds=-c.milliseconds,c.months=-c.months),c):{milliseconds:0,months:0}}function bb(a,b){return function(c,d){var e,f;return null===d||isNaN(+d)||(ga(b,\"moment().\"+b+\"(period, number) is deprecated. Please use moment().\"+b+\"(number, period).\"),f=c,c=d,d=f),c=\"string\"==typeof c?+c:c,e=Za(c,d),cb(this,e,a),this}}function cb(b,c,d,e){var f=c._milliseconds,g=c._days,h=c._months;b.isValid()&&(e=null==e?!0:e,f&&b._d.setTime(+b._d+f*d),g&&G(b,\"Date\",F(b,\"Date\")+g*d),h&&Z(b,F(b,\"Month\")+h*d),e&&a.updateOffset(b,g||h))}function db(a,b){var c=a||Ea(),d=Ma(c,this).startOf(\"day\"),e=this.diff(d,\"days\",!0),f=-6>e?\"sameElse\":-1>e?\"lastWeek\":0>e?\"lastDay\":1>e?\"sameDay\":2>e?\"nextDay\":7>e?\"nextWeek\":\"sameElse\",g=b&&(D(b[f])?b[f]():b[f]);return this.format(g||this.localeData().calendar(f,this,Ea(c)))}function eb(){return new o(this)}function fb(a,b){var c=p(a)?a:Ea(a);return this.isValid()&&c.isValid()?(b=B(m(b)?\"millisecond\":b),\"millisecond\"===b?+this>+c:+c<+this.clone().startOf(b)):!1}function gb(a,b){var c=p(a)?a:Ea(a);return this.isValid()&&c.isValid()?(b=B(m(b)?\"millisecond\":b),\"millisecond\"===b?+c>+this:+this.clone().endOf(b)<+c):!1}function hb(a,b,c){return this.isAfter(a,c)&&this.isBefore(b,c)}function ib(a,b){var c,d=p(a)?a:Ea(a);return this.isValid()&&d.isValid()?(b=B(b||\"millisecond\"),\"millisecond\"===b?+this===+d:(c=+d,+this.clone().startOf(b)<=c&&c<=+this.clone().endOf(b))):!1}function jb(a,b){return this.isSame(a,b)||this.isAfter(a,b)}function kb(a,b){return this.isSame(a,b)||this.isBefore(a,b)}function lb(a,b,c){var d,e,f,g;return this.isValid()?(d=Ma(a,this),d.isValid()?(e=6e4*(d.utcOffset()-this.utcOffset()),b=B(b),\"year\"===b||\"month\"===b||\"quarter\"===b?(g=mb(this,d),\"quarter\"===b?g/=3:\"year\"===b&&(g/=12)):(f=this-d,g=\"second\"===b?f/1e3:\"minute\"===b?f/6e4:\"hour\"===b?f/36e5:\"day\"===b?(f-e)/864e5:\"week\"===b?(f-e)/6048e5:f),c?g:q(g)):NaN):NaN}function mb(a,b){var c,d,e=12*(b.year()-a.year())+(b.month()-a.month()),f=a.clone().add(e,\"months\");return 0>b-f?(c=a.clone().add(e-1,\"months\"),d=(b-f)/(f-c)):(c=a.clone().add(e+1,\"months\"),d=(b-f)/(c-f)),-(e+d)}function nb(){return this.clone().locale(\"en\").format(\"ddd MMM DD YYYY HH:mm:ss [GMT]ZZ\")}function ob(){var a=this.clone().utc();return 0<a.year()&&a.year()<=9999?D(Date.prototype.toISOString)?this.toDate().toISOString():M(a,\"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]\"):M(a,\"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]\")}function pb(b){var c=M(this,b||a.defaultFormat);return this.localeData().postformat(c)}function qb(a,b){return this.isValid()&&(p(a)&&a.isValid()||Ea(a).isValid())?Za({to:this,from:a}).locale(this.locale()).humanize(!b):this.localeData().invalidDate()}function rb(a){return this.from(Ea(),a)}function sb(a,b){return this.isValid()&&(p(a)&&a.isValid()||Ea(a).isValid())?Za({from:this,to:a}).locale(this.locale()).humanize(!b):this.localeData().invalidDate()}function tb(a){return this.to(Ea(),a)}function ub(a){var b;return void 0===a?this._locale._abbr:(b=z(a),null!=b&&(this._locale=b),this)}function vb(){return this._locale}function wb(a){switch(a=B(a)){case\"year\":this.month(0);case\"quarter\":case\"month\":this.date(1);case\"week\":case\"isoWeek\":case\"day\":this.hours(0);case\"hour\":this.minutes(0);case\"minute\":this.seconds(0);case\"second\":this.milliseconds(0)}return\"week\"===a&&this.weekday(0),\"isoWeek\"===a&&this.isoWeekday(1),\"quarter\"===a&&this.month(3*Math.floor(this.month()/3)),this}function xb(a){return a=B(a),void 0===a||\"millisecond\"===a?this:this.startOf(a).add(1,\"isoWeek\"===a?\"week\":a).subtract(1,\"ms\")}function yb(){return+this._d-6e4*(this._offset||0)}function zb(){return Math.floor(+this/1e3)}function Ab(){return this._offset?new Date(+this):this._d}function Bb(){var a=this;return[a.year(),a.month(),a.date(),a.hour(),a.minute(),a.second(),a.millisecond()]}function Cb(){var a=this;return{years:a.year(),months:a.month(),date:a.date(),hours:a.hours(),minutes:a.minutes(),seconds:a.seconds(),milliseconds:a.milliseconds()}}function Db(){return this.isValid()?this.toISOString():\"null\"}function Eb(){return k(this)}function Fb(){return g({},j(this))}function Gb(){return j(this).overflow}function Hb(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}}function Ib(a,b){J(0,[a,a.length],0,b)}function Jb(a){return Nb.call(this,a,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)}function Kb(a){return Nb.call(this,a,this.isoWeek(),this.isoWeekday(),1,4)}function Lb(){return ra(this.year(),1,4)}function Mb(){var a=this.localeData()._week;return ra(this.year(),a.dow,a.doy)}function Nb(a,b,c,d,e){var f;return null==a?qa(this,d,e).year:(f=ra(a,d,e),b>f&&(b=f),Ob.call(this,a,b,c,d,e))}function Ob(a,b,c,d,e){var f=pa(a,b,c,d,e),g=ka(f.year,0,f.dayOfYear);return this.year(g.getUTCFullYear()),this.month(g.getUTCMonth()),this.date(g.getUTCDate()),this}function Pb(a){return null==a?Math.ceil((this.month()+1)/3):this.month(3*(a-1)+this.month()%3)}function Qb(a){return qa(a,this._week.dow,this._week.doy).week}function Rb(){return this._week.dow}function Sb(){return this._week.doy}function Tb(a){var b=this.localeData().week(this);return null==a?b:this.add(7*(a-b),\"d\")}function Ub(a){var b=qa(this,1,4).week;return null==a?b:this.add(7*(a-b),\"d\")}function Vb(a,b){return\"string\"!=typeof a?a:isNaN(a)?(a=b.weekdaysParse(a),\"number\"==typeof a?a:null):parseInt(a,10)}function Wb(a,b){return c(this._weekdays)?this._weekdays[a.day()]:this._weekdays[this._weekdays.isFormat.test(b)?\"format\":\"standalone\"][a.day()]}function Xb(a){return this._weekdaysShort[a.day()]}function Yb(a){return this._weekdaysMin[a.day()]}function Zb(a,b,c){var d,e,f;for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),d=0;7>d;d++){if(e=Ea([2e3,1]).day(d),c&&!this._fullWeekdaysParse[d]&&(this._fullWeekdaysParse[d]=new RegExp(\"^\"+this.weekdays(e,\"\").replace(\".\",\".?\")+\"$\",\"i\"),this._shortWeekdaysParse[d]=new RegExp(\"^\"+this.weekdaysShort(e,\"\").replace(\".\",\".?\")+\"$\",\"i\"),this._minWeekdaysParse[d]=new RegExp(\"^\"+this.weekdaysMin(e,\"\").replace(\".\",\".?\")+\"$\",\"i\")),this._weekdaysParse[d]||(f=\"^\"+this.weekdays(e,\"\")+\"|^\"+this.weekdaysShort(e,\"\")+\"|^\"+this.weekdaysMin(e,\"\"),this._weekdaysParse[d]=new RegExp(f.replace(\".\",\"\"),\"i\")),c&&\"dddd\"===b&&this._fullWeekdaysParse[d].test(a))return d;if(c&&\"ddd\"===b&&this._shortWeekdaysParse[d].test(a))return d;if(c&&\"dd\"===b&&this._minWeekdaysParse[d].test(a))return d;if(!c&&this._weekdaysParse[d].test(a))return d}}function $b(a){if(!this.isValid())return null!=a?this:NaN;var b=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=a?(a=Vb(a,this.localeData()),this.add(a-b,\"d\")):b}function _b(a){if(!this.isValid())return null!=a?this:NaN;var b=(this.day()+7-this.localeData()._week.dow)%7;return null==a?b:this.add(a-b,\"d\")}function ac(a){return this.isValid()?null==a?this.day()||7:this.day(this.day()%7?a:a-7):null!=a?this:NaN}function bc(a){var b=Math.round((this.clone().startOf(\"day\")-this.clone().startOf(\"year\"))/864e5)+1;return null==a?b:this.add(a-b,\"d\")}function cc(){return this.hours()%12||12}function dc(a,b){J(a,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),b)})}function ec(a,b){return b._meridiemParse}function fc(a){return\"p\"===(a+\"\").toLowerCase().charAt(0)}function gc(a,b,c){return a>11?c?\"pm\":\"PM\":c?\"am\":\"AM\"}function hc(a,b){b[Bd]=r(1e3*(\"0.\"+a))}function ic(){return this._isUTC?\"UTC\":\"\"}function jc(){return this._isUTC?\"Coordinated Universal Time\":\"\"}function kc(a){return Ea(1e3*a)}function lc(){return Ea.apply(null,arguments).parseZone()}function mc(a,b,c){var d=this._calendar[a];return D(d)?d.call(b,c):d}function nc(a){var b=this._longDateFormat[a],c=this._longDateFormat[a.toUpperCase()];return b||!c?b:(this._longDateFormat[a]=c.replace(/MMMM|MM|DD|dddd/g,function(a){return a.slice(1)}),this._longDateFormat[a])}function oc(){return this._invalidDate}function pc(a){return this._ordinal.replace(\"%d\",a)}function qc(a){return a}function rc(a,b,c,d){var e=this._relativeTime[c];return D(e)?e(a,b,c,d):e.replace(/%d/i,a)}function sc(a,b){var c=this._relativeTime[a>0?\"future\":\"past\"];return D(c)?c(b):c.replace(/%s/i,b)}function tc(a){var b,c;for(c in a)b=a[c],D(b)?this[c]=b:this[\"_\"+c]=b;this._ordinalParseLenient=new RegExp(this._ordinalParse.source+\"|\"+/\\d{1,2}/.source)}function uc(a,b,c,d){var e=z(),f=h().set(d,b);return e[c](f,a)}function vc(a,b,c,d,e){if(\"number\"==typeof a&&(b=a,a=void 0),a=a||\"\",null!=b)return uc(a,b,c,e);var f,g=[];for(f=0;d>f;f++)g[f]=uc(a,f,c,e);return g}function wc(a,b){return vc(a,b,\"months\",12,\"month\")}function xc(a,b){return vc(a,b,\"monthsShort\",12,\"month\")}function yc(a,b){return vc(a,b,\"weekdays\",7,\"day\")}function zc(a,b){return vc(a,b,\"weekdaysShort\",7,\"day\")}function Ac(a,b){return vc(a,b,\"weekdaysMin\",7,\"day\")}function Bc(){var a=this._data;return this._milliseconds=se(this._milliseconds),this._days=se(this._days),this._months=se(this._months),a.milliseconds=se(a.milliseconds),a.seconds=se(a.seconds),a.minutes=se(a.minutes),a.hours=se(a.hours),a.months=se(a.months),a.years=se(a.years),this}function Cc(a,b,c,d){var e=Za(b,c);return a._milliseconds+=d*e._milliseconds,a._days+=d*e._days,a._months+=d*e._months,a._bubble()}function Dc(a,b){return Cc(this,a,b,1)}function Ec(a,b){return Cc(this,a,b,-1)}function Fc(a){return 0>a?Math.floor(a):Math.ceil(a)}function Gc(){var a,b,c,d,e,f=this._milliseconds,g=this._days,h=this._months,i=this._data;return f>=0&&g>=0&&h>=0||0>=f&&0>=g&&0>=h||(f+=864e5*Fc(Ic(h)+g),g=0,h=0),i.milliseconds=f%1e3,a=q(f/1e3),i.seconds=a%60,b=q(a/60),i.minutes=b%60,c=q(b/60),i.hours=c%24,g+=q(c/24),e=q(Hc(g)),h+=e,g-=Fc(Ic(e)),d=q(h/12),h%=12,i.days=g,i.months=h,i.years=d,this}function Hc(a){return 4800*a/146097}function Ic(a){return 146097*a/4800}function Jc(a){var b,c,d=this._milliseconds;if(a=B(a),\"month\"===a||\"year\"===a)return b=this._days+d/864e5,c=this._months+Hc(b),\"month\"===a?c:c/12;switch(b=this._days+Math.round(Ic(this._months)),a){case\"week\":return b/7+d/6048e5;case\"day\":return b+d/864e5;case\"hour\":return 24*b+d/36e5;case\"minute\":return 1440*b+d/6e4;case\"second\":return 86400*b+d/1e3;case\"millisecond\":return Math.floor(864e5*b)+d;default:throw new Error(\"Unknown unit \"+a)}}function Kc(){return this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*r(this._months/12)}function Lc(a){return function(){return this.as(a)}}function Mc(a){return a=B(a),this[a+\"s\"]()}function Nc(a){return function(){return this._data[a]}}function Oc(){return q(this.days()/7)}function Pc(a,b,c,d,e){return e.relativeTime(b||1,!!c,a,d)}function Qc(a,b,c){var d=Za(a).abs(),e=Ie(d.as(\"s\")),f=Ie(d.as(\"m\")),g=Ie(d.as(\"h\")),h=Ie(d.as(\"d\")),i=Ie(d.as(\"M\")),j=Ie(d.as(\"y\")),k=e<Je.s&&[\"s\",e]||1>=f&&[\"m\"]||f<Je.m&&[\"mm\",f]||1>=g&&[\"h\"]||g<Je.h&&[\"hh\",g]||1>=h&&[\"d\"]||h<Je.d&&[\"dd\",h]||1>=i&&[\"M\"]||i<Je.M&&[\"MM\",i]||1>=j&&[\"y\"]||[\"yy\",j];return k[2]=b,k[3]=+a>0,k[4]=c,Pc.apply(null,k)}function Rc(a,b){return void 0===Je[a]?!1:void 0===b?Je[a]:(Je[a]=b,!0)}function Sc(a){var b=this.localeData(),c=Qc(this,!a,b);return a&&(c=b.pastFuture(+this,c)),b.postformat(c)}function Tc(){var a,b,c,d=Ke(this._milliseconds)/1e3,e=Ke(this._days),f=Ke(this._months);a=q(d/60),b=q(a/60),d%=60,a%=60,c=q(f/12),f%=12;var g=c,h=f,i=e,j=b,k=a,l=d,m=this.asSeconds();return m?(0>m?\"-\":\"\")+\"P\"+(g?g+\"Y\":\"\")+(h?h+\"M\":\"\")+(i?i+\"D\":\"\")+(j||k||l?\"T\":\"\")+(j?j+\"H\":\"\")+(k?k+\"M\":\"\")+(l?l+\"S\":\"\"):\"P0D\"}var Uc,Vc,Wc=a.momentProperties=[],Xc=!1,Yc={},Zc={},$c=/(\\[[^\\[]*\\])|(\\\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,_c=/(\\[[^\\[]*\\])|(\\\\)?(LTS|LT|LL?L?L?|l{1,4})/g,ad={},bd={},cd=/\\d/,dd=/\\d\\d/,ed=/\\d{3}/,fd=/\\d{4}/,gd=/[+-]?\\d{6}/,hd=/\\d\\d?/,id=/\\d\\d\\d\\d?/,jd=/\\d\\d\\d\\d\\d\\d?/,kd=/\\d{1,3}/,ld=/\\d{1,4}/,md=/[+-]?\\d{1,6}/,nd=/\\d+/,od=/[+-]?\\d+/,pd=/Z|[+-]\\d\\d:?\\d\\d/gi,qd=/Z|[+-]\\d\\d(?::?\\d\\d)?/gi,rd=/[+-]?\\d+(\\.\\d{1,3})?/,sd=/[0-9]*['a-z\\u00A0-\\u05FF\\u0700-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]+|[\\u0600-\\u06FF\\/]+(\\s*?[\\u0600-\\u06FF]+){1,2}/i,td={},ud={},vd=0,wd=1,xd=2,yd=3,zd=4,Ad=5,Bd=6,Cd=7,Dd=8;J(\"M\",[\"MM\",2],\"Mo\",function(){return this.month()+1}),J(\"MMM\",0,0,function(a){return this.localeData().monthsShort(this,a)}),J(\"MMMM\",0,0,function(a){return this.localeData().months(this,a)}),A(\"month\",\"M\"),O(\"M\",hd),O(\"MM\",hd,dd),O(\"MMM\",function(a,b){return b.monthsShortRegex(a)}),O(\"MMMM\",function(a,b){return b.monthsRegex(a)}),S([\"M\",\"MM\"],function(a,b){b[wd]=r(a)-1}),S([\"MMM\",\"MMMM\"],function(a,b,c,d){var e=c._locale.monthsParse(a,d,c._strict);null!=e?b[wd]=e:j(c).invalidMonth=a});var Ed=/D[oD]?(\\[[^\\[\\]]*\\]|\\s+)+MMMM?/,Fd=\"January_February_March_April_May_June_July_August_September_October_November_December\".split(\"_\"),Gd=\"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec\".split(\"_\"),Hd=sd,Id=sd,Jd={};a.suppressDeprecationWarnings=!1;var Kd=/^\\s*((?:[+-]\\d{6}|\\d{4})-(?:\\d\\d-\\d\\d|W\\d\\d-\\d|W\\d\\d|\\d\\d\\d|\\d\\d))(?:(T| )(\\d\\d(?::\\d\\d(?::\\d\\d(?:[.,]\\d+)?)?)?)([\\+\\-]\\d\\d(?::?\\d\\d)?|\\s*Z)?)?/,Ld=/^\\s*((?:[+-]\\d{6}|\\d{4})(?:\\d\\d\\d\\d|W\\d\\d\\d|W\\d\\d|\\d\\d\\d|\\d\\d))(?:(T| )(\\d\\d(?:\\d\\d(?:\\d\\d(?:[.,]\\d+)?)?)?)([\\+\\-]\\d\\d(?::?\\d\\d)?|\\s*Z)?)?/,Md=/Z|[+-]\\d\\d(?::?\\d\\d)?/,Nd=[[\"YYYYYY-MM-DD\",/[+-]\\d{6}-\\d\\d-\\d\\d/],[\"YYYY-MM-DD\",/\\d{4}-\\d\\d-\\d\\d/],[\"GGGG-[W]WW-E\",/\\d{4}-W\\d\\d-\\d/],[\"GGGG-[W]WW\",/\\d{4}-W\\d\\d/,!1],[\"YYYY-DDD\",/\\d{4}-\\d{3}/],[\"YYYY-MM\",/\\d{4}-\\d\\d/,!1],[\"YYYYYYMMDD\",/[+-]\\d{10}/],[\"YYYYMMDD\",/\\d{8}/],[\"GGGG[W]WWE\",/\\d{4}W\\d{3}/],[\"GGGG[W]WW\",/\\d{4}W\\d{2}/,!1],[\"YYYYDDD\",/\\d{7}/]],Od=[[\"HH:mm:ss.SSSS\",/\\d\\d:\\d\\d:\\d\\d\\.\\d+/],[\"HH:mm:ss,SSSS\",/\\d\\d:\\d\\d:\\d\\d,\\d+/],[\"HH:mm:ss\",/\\d\\d:\\d\\d:\\d\\d/],[\"HH:mm\",/\\d\\d:\\d\\d/],[\"HHmmss.SSSS\",/\\d\\d\\d\\d\\d\\d\\.\\d+/],[\"HHmmss,SSSS\",/\\d\\d\\d\\d\\d\\d,\\d+/],[\"HHmmss\",/\\d\\d\\d\\d\\d\\d/],[\"HHmm\",/\\d\\d\\d\\d/],[\"HH\",/\\d\\d/]],Pd=/^\\/?Date\\((\\-?\\d+)/i;a.createFromInputFallback=fa(\"moment construction falls back to js Date. This is discouraged and will be removed in upcoming major release. Please refer to https://github.com/moment/moment/issues/1407 for more info.\",function(a){a._d=new Date(a._i+(a._useUTC?\" UTC\":\"\"))}),J(\"Y\",0,0,function(){var a=this.year();return 9999>=a?\"\"+a:\"+\"+a}),J(0,[\"YY\",2],0,function(){return this.year()%100}),J(0,[\"YYYY\",4],0,\"year\"),J(0,[\"YYYYY\",5],0,\"year\"),J(0,[\"YYYYYY\",6,!0],0,\"year\"),A(\"year\",\"y\"),O(\"Y\",od),O(\"YY\",hd,dd),O(\"YYYY\",ld,fd),O(\"YYYYY\",md,gd),O(\"YYYYYY\",md,gd),S([\"YYYYY\",\"YYYYYY\"],vd),S(\"YYYY\",function(b,c){c[vd]=2===b.length?a.parseTwoDigitYear(b):r(b)}),S(\"YY\",function(b,c){c[vd]=a.parseTwoDigitYear(b)}),S(\"Y\",function(a,b){b[vd]=parseInt(a,10)}),a.parseTwoDigitYear=function(a){return r(a)+(r(a)>68?1900:2e3)};var Qd=E(\"FullYear\",!1);a.ISO_8601=function(){};var Rd=fa(\"moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548\",function(){var a=Ea.apply(null,arguments);return this.isValid()&&a.isValid()?this>a?this:a:l()}),Sd=fa(\"moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548\",function(){var a=Ea.apply(null,arguments);return this.isValid()&&a.isValid()?a>this?this:a:l()}),Td=function(){return Date.now?Date.now():+new Date};Ka(\"Z\",\":\"),Ka(\"ZZ\",\"\"),O(\"Z\",qd),O(\"ZZ\",qd),S([\"Z\",\"ZZ\"],function(a,b,c){c._useUTC=!0,c._tzm=La(qd,a)});var Ud=/([\\+\\-]|\\d\\d)/gi;a.updateOffset=function(){};var Vd=/^(\\-)?(?:(\\d*)[. ])?(\\d+)\\:(\\d+)(?:\\:(\\d+)\\.?(\\d{3})?\\d*)?$/,Wd=/^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;\nZa.fn=Ia.prototype;var Xd=bb(1,\"add\"),Yd=bb(-1,\"subtract\");a.defaultFormat=\"YYYY-MM-DDTHH:mm:ssZ\";var Zd=fa(\"moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.\",function(a){return void 0===a?this.localeData():this.locale(a)});J(0,[\"gg\",2],0,function(){return this.weekYear()%100}),J(0,[\"GG\",2],0,function(){return this.isoWeekYear()%100}),Ib(\"gggg\",\"weekYear\"),Ib(\"ggggg\",\"weekYear\"),Ib(\"GGGG\",\"isoWeekYear\"),Ib(\"GGGGG\",\"isoWeekYear\"),A(\"weekYear\",\"gg\"),A(\"isoWeekYear\",\"GG\"),O(\"G\",od),O(\"g\",od),O(\"GG\",hd,dd),O(\"gg\",hd,dd),O(\"GGGG\",ld,fd),O(\"gggg\",ld,fd),O(\"GGGGG\",md,gd),O(\"ggggg\",md,gd),T([\"gggg\",\"ggggg\",\"GGGG\",\"GGGGG\"],function(a,b,c,d){b[d.substr(0,2)]=r(a)}),T([\"gg\",\"GG\"],function(b,c,d,e){c[e]=a.parseTwoDigitYear(b)}),J(\"Q\",0,\"Qo\",\"quarter\"),A(\"quarter\",\"Q\"),O(\"Q\",cd),S(\"Q\",function(a,b){b[wd]=3*(r(a)-1)}),J(\"w\",[\"ww\",2],\"wo\",\"week\"),J(\"W\",[\"WW\",2],\"Wo\",\"isoWeek\"),A(\"week\",\"w\"),A(\"isoWeek\",\"W\"),O(\"w\",hd),O(\"ww\",hd,dd),O(\"W\",hd),O(\"WW\",hd,dd),T([\"w\",\"ww\",\"W\",\"WW\"],function(a,b,c,d){b[d.substr(0,1)]=r(a)});var $d={dow:0,doy:6};J(\"D\",[\"DD\",2],\"Do\",\"date\"),A(\"date\",\"D\"),O(\"D\",hd),O(\"DD\",hd,dd),O(\"Do\",function(a,b){return a?b._ordinalParse:b._ordinalParseLenient}),S([\"D\",\"DD\"],xd),S(\"Do\",function(a,b){b[xd]=r(a.match(hd)[0],10)});var _d=E(\"Date\",!0);J(\"d\",0,\"do\",\"day\"),J(\"dd\",0,0,function(a){return this.localeData().weekdaysMin(this,a)}),J(\"ddd\",0,0,function(a){return this.localeData().weekdaysShort(this,a)}),J(\"dddd\",0,0,function(a){return this.localeData().weekdays(this,a)}),J(\"e\",0,0,\"weekday\"),J(\"E\",0,0,\"isoWeekday\"),A(\"day\",\"d\"),A(\"weekday\",\"e\"),A(\"isoWeekday\",\"E\"),O(\"d\",hd),O(\"e\",hd),O(\"E\",hd),O(\"dd\",sd),O(\"ddd\",sd),O(\"dddd\",sd),T([\"dd\",\"ddd\",\"dddd\"],function(a,b,c,d){var e=c._locale.weekdaysParse(a,d,c._strict);null!=e?b.d=e:j(c).invalidWeekday=a}),T([\"d\",\"e\",\"E\"],function(a,b,c,d){b[d]=r(a)});var ae=\"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday\".split(\"_\"),be=\"Sun_Mon_Tue_Wed_Thu_Fri_Sat\".split(\"_\"),ce=\"Su_Mo_Tu_We_Th_Fr_Sa\".split(\"_\");J(\"DDD\",[\"DDDD\",3],\"DDDo\",\"dayOfYear\"),A(\"dayOfYear\",\"DDD\"),O(\"DDD\",kd),O(\"DDDD\",ed),S([\"DDD\",\"DDDD\"],function(a,b,c){c._dayOfYear=r(a)}),J(\"H\",[\"HH\",2],0,\"hour\"),J(\"h\",[\"hh\",2],0,cc),J(\"hmm\",0,0,function(){return\"\"+cc.apply(this)+I(this.minutes(),2)}),J(\"hmmss\",0,0,function(){return\"\"+cc.apply(this)+I(this.minutes(),2)+I(this.seconds(),2)}),J(\"Hmm\",0,0,function(){return\"\"+this.hours()+I(this.minutes(),2)}),J(\"Hmmss\",0,0,function(){return\"\"+this.hours()+I(this.minutes(),2)+I(this.seconds(),2)}),dc(\"a\",!0),dc(\"A\",!1),A(\"hour\",\"h\"),O(\"a\",ec),O(\"A\",ec),O(\"H\",hd),O(\"h\",hd),O(\"HH\",hd,dd),O(\"hh\",hd,dd),O(\"hmm\",id),O(\"hmmss\",jd),O(\"Hmm\",id),O(\"Hmmss\",jd),S([\"H\",\"HH\"],yd),S([\"a\",\"A\"],function(a,b,c){c._isPm=c._locale.isPM(a),c._meridiem=a}),S([\"h\",\"hh\"],function(a,b,c){b[yd]=r(a),j(c).bigHour=!0}),S(\"hmm\",function(a,b,c){var d=a.length-2;b[yd]=r(a.substr(0,d)),b[zd]=r(a.substr(d)),j(c).bigHour=!0}),S(\"hmmss\",function(a,b,c){var d=a.length-4,e=a.length-2;b[yd]=r(a.substr(0,d)),b[zd]=r(a.substr(d,2)),b[Ad]=r(a.substr(e)),j(c).bigHour=!0}),S(\"Hmm\",function(a,b,c){var d=a.length-2;b[yd]=r(a.substr(0,d)),b[zd]=r(a.substr(d))}),S(\"Hmmss\",function(a,b,c){var d=a.length-4,e=a.length-2;b[yd]=r(a.substr(0,d)),b[zd]=r(a.substr(d,2)),b[Ad]=r(a.substr(e))});var de=/[ap]\\.?m?\\.?/i,ee=E(\"Hours\",!0);J(\"m\",[\"mm\",2],0,\"minute\"),A(\"minute\",\"m\"),O(\"m\",hd),O(\"mm\",hd,dd),S([\"m\",\"mm\"],zd);var fe=E(\"Minutes\",!1);J(\"s\",[\"ss\",2],0,\"second\"),A(\"second\",\"s\"),O(\"s\",hd),O(\"ss\",hd,dd),S([\"s\",\"ss\"],Ad);var ge=E(\"Seconds\",!1);J(\"S\",0,0,function(){return~~(this.millisecond()/100)}),J(0,[\"SS\",2],0,function(){return~~(this.millisecond()/10)}),J(0,[\"SSS\",3],0,\"millisecond\"),J(0,[\"SSSS\",4],0,function(){return 10*this.millisecond()}),J(0,[\"SSSSS\",5],0,function(){return 100*this.millisecond()}),J(0,[\"SSSSSS\",6],0,function(){return 1e3*this.millisecond()}),J(0,[\"SSSSSSS\",7],0,function(){return 1e4*this.millisecond()}),J(0,[\"SSSSSSSS\",8],0,function(){return 1e5*this.millisecond()}),J(0,[\"SSSSSSSSS\",9],0,function(){return 1e6*this.millisecond()}),A(\"millisecond\",\"ms\"),O(\"S\",kd,cd),O(\"SS\",kd,dd),O(\"SSS\",kd,ed);var he;for(he=\"SSSS\";he.length<=9;he+=\"S\")O(he,nd);for(he=\"S\";he.length<=9;he+=\"S\")S(he,hc);var ie=E(\"Milliseconds\",!1);J(\"z\",0,0,\"zoneAbbr\"),J(\"zz\",0,0,\"zoneName\");var je=o.prototype;je.add=Xd,je.calendar=db,je.clone=eb,je.diff=lb,je.endOf=xb,je.format=pb,je.from=qb,je.fromNow=rb,je.to=sb,je.toNow=tb,je.get=H,je.invalidAt=Gb,je.isAfter=fb,je.isBefore=gb,je.isBetween=hb,je.isSame=ib,je.isSameOrAfter=jb,je.isSameOrBefore=kb,je.isValid=Eb,je.lang=Zd,je.locale=ub,je.localeData=vb,je.max=Sd,je.min=Rd,je.parsingFlags=Fb,je.set=H,je.startOf=wb,je.subtract=Yd,je.toArray=Bb,je.toObject=Cb,je.toDate=Ab,je.toISOString=ob,je.toJSON=Db,je.toString=nb,je.unix=zb,je.valueOf=yb,je.creationData=Hb,je.year=Qd,je.isLeapYear=na,je.weekYear=Jb,je.isoWeekYear=Kb,je.quarter=je.quarters=Pb,je.month=$,je.daysInMonth=_,je.week=je.weeks=Tb,je.isoWeek=je.isoWeeks=Ub,je.weeksInYear=Mb,je.isoWeeksInYear=Lb,je.date=_d,je.day=je.days=$b,je.weekday=_b,je.isoWeekday=ac,je.dayOfYear=bc,je.hour=je.hours=ee,je.minute=je.minutes=fe,je.second=je.seconds=ge,je.millisecond=je.milliseconds=ie,je.utcOffset=Oa,je.utc=Qa,je.local=Ra,je.parseZone=Sa,je.hasAlignedHourOffset=Ta,je.isDST=Ua,je.isDSTShifted=Va,je.isLocal=Wa,je.isUtcOffset=Xa,je.isUtc=Ya,je.isUTC=Ya,je.zoneAbbr=ic,je.zoneName=jc,je.dates=fa(\"dates accessor is deprecated. Use date instead.\",_d),je.months=fa(\"months accessor is deprecated. Use month instead\",$),je.years=fa(\"years accessor is deprecated. Use year instead\",Qd),je.zone=fa(\"moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779\",Pa);var ke=je,le={sameDay:\"[Today at] LT\",nextDay:\"[Tomorrow at] LT\",nextWeek:\"dddd [at] LT\",lastDay:\"[Yesterday at] LT\",lastWeek:\"[Last] dddd [at] LT\",sameElse:\"L\"},me={LTS:\"h:mm:ss A\",LT:\"h:mm A\",L:\"MM/DD/YYYY\",LL:\"MMMM D, YYYY\",LLL:\"MMMM D, YYYY h:mm A\",LLLL:\"dddd, MMMM D, YYYY h:mm A\"},ne=\"Invalid date\",oe=\"%d\",pe=/\\d{1,2}/,qe={future:\"in %s\",past:\"%s ago\",s:\"a few seconds\",m:\"a minute\",mm:\"%d minutes\",h:\"an hour\",hh:\"%d hours\",d:\"a day\",dd:\"%d days\",M:\"a month\",MM:\"%d months\",y:\"a year\",yy:\"%d years\"},re=t.prototype;re._calendar=le,re.calendar=mc,re._longDateFormat=me,re.longDateFormat=nc,re._invalidDate=ne,re.invalidDate=oc,re._ordinal=oe,re.ordinal=pc,re._ordinalParse=pe,re.preparse=qc,re.postformat=qc,re._relativeTime=qe,re.relativeTime=rc,re.pastFuture=sc,re.set=tc,re.months=W,re._months=Fd,re.monthsShort=X,re._monthsShort=Gd,re.monthsParse=Y,re._monthsRegex=Id,re.monthsRegex=ba,re._monthsShortRegex=Hd,re.monthsShortRegex=aa,re.week=Qb,re._week=$d,re.firstDayOfYear=Sb,re.firstDayOfWeek=Rb,re.weekdays=Wb,re._weekdays=ae,re.weekdaysMin=Yb,re._weekdaysMin=ce,re.weekdaysShort=Xb,re._weekdaysShort=be,re.weekdaysParse=Zb,re.isPM=fc,re._meridiemParse=de,re.meridiem=gc,x(\"en\",{ordinalParse:/\\d{1,2}(th|st|nd|rd)/,ordinal:function(a){var b=a%10,c=1===r(a%100/10)?\"th\":1===b?\"st\":2===b?\"nd\":3===b?\"rd\":\"th\";return a+c}}),a.lang=fa(\"moment.lang is deprecated. Use moment.locale instead.\",x),a.langData=fa(\"moment.langData is deprecated. Use moment.localeData instead.\",z);var se=Math.abs,te=Lc(\"ms\"),ue=Lc(\"s\"),ve=Lc(\"m\"),we=Lc(\"h\"),xe=Lc(\"d\"),ye=Lc(\"w\"),ze=Lc(\"M\"),Ae=Lc(\"y\"),Be=Nc(\"milliseconds\"),Ce=Nc(\"seconds\"),De=Nc(\"minutes\"),Ee=Nc(\"hours\"),Fe=Nc(\"days\"),Ge=Nc(\"months\"),He=Nc(\"years\"),Ie=Math.round,Je={s:45,m:45,h:22,d:26,M:11},Ke=Math.abs,Le=Ia.prototype;Le.abs=Bc,Le.add=Dc,Le.subtract=Ec,Le.as=Jc,Le.asMilliseconds=te,Le.asSeconds=ue,Le.asMinutes=ve,Le.asHours=we,Le.asDays=xe,Le.asWeeks=ye,Le.asMonths=ze,Le.asYears=Ae,Le.valueOf=Kc,Le._bubble=Gc,Le.get=Mc,Le.milliseconds=Be,Le.seconds=Ce,Le.minutes=De,Le.hours=Ee,Le.days=Fe,Le.weeks=Oc,Le.months=Ge,Le.years=He,Le.humanize=Sc,Le.toISOString=Tc,Le.toString=Tc,Le.toJSON=Tc,Le.locale=ub,Le.localeData=vb,Le.toIsoString=fa(\"toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)\",Tc),Le.lang=Zd,J(\"X\",0,0,\"unix\"),J(\"x\",0,0,\"valueOf\"),O(\"x\",od),O(\"X\",rd),S(\"X\",function(a,b,c){c._d=new Date(1e3*parseFloat(a,10))}),S(\"x\",function(a,b,c){c._d=new Date(r(a))}),a.version=\"2.11.2\",b(Ea),a.fn=ke,a.min=Ga,a.max=Ha,a.now=Td,a.utc=h,a.unix=kc,a.months=wc,a.isDate=d,a.locale=x,a.invalid=l,a.duration=Za,a.isMoment=p,a.weekdays=yc,a.parseZone=lc,a.localeData=z,a.isDuration=Ja,a.monthsShort=xc,a.weekdaysMin=Ac,a.defineLocale=y,a.weekdaysShort=zc,a.normalizeUnits=B,a.relativeTimeThreshold=Rc,a.prototype=ke;var Me=a;return Me});"

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(20))

/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = "/* Copyright (c) 2010-2013 Marcus Westin */\n\"use strict\";(function(e,t){typeof define==\"function\"&&define.amd?define([],t):typeof exports==\"object\"?module.exports=t():e.store=t()})(this,function(){function o(){try{return r in t&&t[r]}catch(e){return!1}}var e={},t=typeof window!=\"undefined\"?window:global,n=t.document,r=\"localStorage\",i=\"script\",s;e.disabled=!1,e.version=\"1.3.20\",e.set=function(e,t){},e.get=function(e,t){},e.has=function(t){return e.get(t)!==undefined},e.remove=function(e){},e.clear=function(){},e.transact=function(t,n,r){r==null&&(r=n,n=null),n==null&&(n={});var i=e.get(t,n);r(i),e.set(t,i)},e.getAll=function(){},e.forEach=function(){},e.serialize=function(e){return JSON.stringify(e)},e.deserialize=function(e){if(typeof e!=\"string\")return undefined;try{return JSON.parse(e)}catch(t){return e||undefined}};if(o())s=t[r],e.set=function(t,n){return n===undefined?e.remove(t):(s.setItem(t,e.serialize(n)),n)},e.get=function(t,n){var r=e.deserialize(s.getItem(t));return r===undefined?n:r},e.remove=function(e){s.removeItem(e)},e.clear=function(){s.clear()},e.getAll=function(){var t={};return e.forEach(function(e,n){t[e]=n}),t},e.forEach=function(t){for(var n=0;n<s.length;n++){var r=s.key(n);t(r,e.get(r))}};else if(n&&n.documentElement.addBehavior){var u,a;try{a=new ActiveXObject(\"htmlfile\"),a.open(),a.write(\"<\"+i+\">document.w=window</\"+i+'><iframe src=\"/favicon.ico\"></iframe>'),a.close(),u=a.w.frames[0].document,s=u.createElement(\"div\")}catch(f){s=n.createElement(\"div\"),u=n.body}var l=function(t){return function(){var n=Array.prototype.slice.call(arguments,0);n.unshift(s),u.appendChild(s),s.addBehavior(\"#default#userData\"),s.load(r);var i=t.apply(e,n);return u.removeChild(s),i}},c=new RegExp(\"[!\\\"#$%&'()*+,/\\\\\\\\:;<=>?@[\\\\]^`{|}~]\",\"g\"),h=function(e){return e.replace(/^d/,\"___$&\").replace(c,\"___\")};e.set=l(function(t,n,i){return n=h(n),i===undefined?e.remove(n):(t.setAttribute(n,e.serialize(i)),t.save(r),i)}),e.get=l(function(t,n,r){n=h(n);var i=e.deserialize(t.getAttribute(n));return i===undefined?r:i}),e.remove=l(function(e,t){t=h(t),e.removeAttribute(t),e.save(r)}),e.clear=l(function(e){var t=e.XMLDocument.documentElement.attributes;e.load(r);for(var n=t.length-1;n>=0;n--)e.removeAttribute(t[n].name);e.save(r)}),e.getAll=function(t){var n={};return e.forEach(function(e,t){n[e]=t}),n},e.forEach=l(function(t,n){var r=t.XMLDocument.documentElement.attributes;for(var i=0,s;s=r[i];++i)n(s.name,e.deserialize(t.getAttribute(s.name)))})}try{var p=\"__storejs__\";e.set(p,p),e.get(p)!=p&&(e.disabled=!0),e.remove(p)}catch(f){e.disabled=!0}return e.enabled=!e.disabled,e});"

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(22))

/***/ },
/* 22 */
/***/ function(module, exports) {

	module.exports = "/*! jQuery Migrate v1.2.1 | (c) 2005, 2013 jQuery Foundation, Inc. and other contributors | jquery.org/license */\njQuery.migrateMute===void 0&&(jQuery.migrateMute=!0),function(e,t,n){function r(n){var r=t.console;i[n]||(i[n]=!0,e.migrateWarnings.push(n),r&&r.warn&&!e.migrateMute&&(r.warn(\"JQMIGRATE: \"+n),e.migrateTrace&&r.trace&&r.trace()))}function a(t,a,i,o){if(Object.defineProperty)try{return Object.defineProperty(t,a,{configurable:!0,enumerable:!0,get:function(){return r(o),i},set:function(e){r(o),i=e}}),n}catch(s){}e._definePropertyBroken=!0,t[a]=i}var i={};e.migrateWarnings=[],!e.migrateMute&&t.console&&t.console.log&&t.console.log(\"JQMIGRATE: Logging is active\"),e.migrateTrace===n&&(e.migrateTrace=!0),e.migrateReset=function(){i={},e.migrateWarnings.length=0},\"BackCompat\"===document.compatMode&&r(\"jQuery is not compatible with Quirks Mode\");var o=e(\"<input/>\",{size:1}).attr(\"size\")&&e.attrFn,s=e.attr,u=e.attrHooks.value&&e.attrHooks.value.get||function(){return null},c=e.attrHooks.value&&e.attrHooks.value.set||function(){return n},l=/^(?:input|button)$/i,d=/^[238]$/,p=/^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,f=/^(?:checked|selected)$/i;a(e,\"attrFn\",o||{},\"jQuery.attrFn is deprecated\"),e.attr=function(t,a,i,u){var c=a.toLowerCase(),g=t&&t.nodeType;return u&&(4>s.length&&r(\"jQuery.fn.attr( props, pass ) is deprecated\"),t&&!d.test(g)&&(o?a in o:e.isFunction(e.fn[a])))?e(t)[a](i):(\"type\"===a&&i!==n&&l.test(t.nodeName)&&t.parentNode&&r(\"Can't change the 'type' of an input or button in IE 6/7/8\"),!e.attrHooks[c]&&p.test(c)&&(e.attrHooks[c]={get:function(t,r){var a,i=e.prop(t,r);return i===!0||\"boolean\"!=typeof i&&(a=t.getAttributeNode(r))&&a.nodeValue!==!1?r.toLowerCase():n},set:function(t,n,r){var a;return n===!1?e.removeAttr(t,r):(a=e.propFix[r]||r,a in t&&(t[a]=!0),t.setAttribute(r,r.toLowerCase())),r}},f.test(c)&&r(\"jQuery.fn.attr('\"+c+\"') may use property instead of attribute\")),s.call(e,t,a,i))},e.attrHooks.value={get:function(e,t){var n=(e.nodeName||\"\").toLowerCase();return\"button\"===n?u.apply(this,arguments):(\"input\"!==n&&\"option\"!==n&&r(\"jQuery.fn.attr('value') no longer gets properties\"),t in e?e.value:null)},set:function(e,t){var a=(e.nodeName||\"\").toLowerCase();return\"button\"===a?c.apply(this,arguments):(\"input\"!==a&&\"option\"!==a&&r(\"jQuery.fn.attr('value', val) no longer sets properties\"),e.value=t,n)}};var g,h,v=e.fn.init,m=e.parseJSON,y=/^([^<]*)(<[\\w\\W]+>)([^>]*)$/;e.fn.init=function(t,n,a){var i;return t&&\"string\"==typeof t&&!e.isPlainObject(n)&&(i=y.exec(e.trim(t)))&&i[0]&&(\"<\"!==t.charAt(0)&&r(\"$(html) HTML strings must start with '<' character\"),i[3]&&r(\"$(html) HTML text after last tag is ignored\"),\"#\"===i[0].charAt(0)&&(r(\"HTML string cannot start with a '#' character\"),e.error(\"JQMIGRATE: Invalid selector string (XSS)\")),n&&n.context&&(n=n.context),e.parseHTML)?v.call(this,e.parseHTML(i[2],n,!0),n,a):v.apply(this,arguments)},e.fn.init.prototype=e.fn,e.parseJSON=function(e){return e||null===e?m.apply(this,arguments):(r(\"jQuery.parseJSON requires a valid JSON string\"),null)},e.uaMatch=function(e){e=e.toLowerCase();var t=/(chrome)[ \\/]([\\w.]+)/.exec(e)||/(webkit)[ \\/]([\\w.]+)/.exec(e)||/(opera)(?:.*version|)[ \\/]([\\w.]+)/.exec(e)||/(msie) ([\\w.]+)/.exec(e)||0>e.indexOf(\"compatible\")&&/(mozilla)(?:.*? rv:([\\w.]+)|)/.exec(e)||[];return{browser:t[1]||\"\",version:t[2]||\"0\"}},e.browser||(g=e.uaMatch(navigator.userAgent),h={},g.browser&&(h[g.browser]=!0,h.version=g.version),h.chrome?h.webkit=!0:h.webkit&&(h.safari=!0),e.browser=h),a(e,\"browser\",e.browser,\"jQuery.browser is deprecated\"),e.sub=function(){function t(e,n){return new t.fn.init(e,n)}e.extend(!0,t,this),t.superclass=this,t.fn=t.prototype=this(),t.fn.constructor=t,t.sub=this.sub,t.fn.init=function(r,a){return a&&a instanceof e&&!(a instanceof t)&&(a=t(a)),e.fn.init.call(this,r,a,n)},t.fn.init.prototype=t.fn;var n=t(document);return r(\"jQuery.sub() is deprecated\"),t},e.ajaxSetup({converters:{\"text json\":e.parseJSON}});var b=e.fn.data;e.fn.data=function(t){var a,i,o=this[0];return!o||\"events\"!==t||1!==arguments.length||(a=e.data(o,t),i=e._data(o,t),a!==n&&a!==i||i===n)?b.apply(this,arguments):(r(\"Use of jQuery.fn.data('events') is deprecated\"),i)};var j=/\\/(java|ecma)script/i,w=e.fn.andSelf||e.fn.addBack;e.fn.andSelf=function(){return r(\"jQuery.fn.andSelf() replaced by jQuery.fn.addBack()\"),w.apply(this,arguments)},e.clean||(e.clean=function(t,a,i,o){a=a||document,a=!a.nodeType&&a[0]||a,a=a.ownerDocument||a,r(\"jQuery.clean() is deprecated\");var s,u,c,l,d=[];if(e.merge(d,e.buildFragment(t,a).childNodes),i)for(c=function(e){return!e.type||j.test(e.type)?o?o.push(e.parentNode?e.parentNode.removeChild(e):e):i.appendChild(e):n},s=0;null!=(u=d[s]);s++)e.nodeName(u,\"script\")&&c(u)||(i.appendChild(u),u.getElementsByTagName!==n&&(l=e.grep(e.merge([],u.getElementsByTagName(\"script\")),c),d.splice.apply(d,[s+1,0].concat(l)),s+=l.length));return d});var Q=e.event.add,x=e.event.remove,k=e.event.trigger,N=e.fn.toggle,T=e.fn.live,M=e.fn.die,S=\"ajaxStart|ajaxStop|ajaxSend|ajaxComplete|ajaxError|ajaxSuccess\",C=RegExp(\"\\\\b(?:\"+S+\")\\\\b\"),H=/(?:^|\\s)hover(\\.\\S+|)\\b/,A=function(t){return\"string\"!=typeof t||e.event.special.hover?t:(H.test(t)&&r(\"'hover' pseudo-event is deprecated, use 'mouseenter mouseleave'\"),t&&t.replace(H,\"mouseenter$1 mouseleave$1\"))};e.event.props&&\"attrChange\"!==e.event.props[0]&&e.event.props.unshift(\"attrChange\",\"attrName\",\"relatedNode\",\"srcElement\"),e.event.dispatch&&a(e.event,\"handle\",e.event.dispatch,\"jQuery.event.handle is undocumented and deprecated\"),e.event.add=function(e,t,n,a,i){e!==document&&C.test(t)&&r(\"AJAX events should be attached to document: \"+t),Q.call(this,e,A(t||\"\"),n,a,i)},e.event.remove=function(e,t,n,r,a){x.call(this,e,A(t)||\"\",n,r,a)},e.fn.error=function(){var e=Array.prototype.slice.call(arguments,0);return r(\"jQuery.fn.error() is deprecated\"),e.splice(0,0,\"error\"),arguments.length?this.bind.apply(this,e):(this.triggerHandler.apply(this,e),this)},e.fn.toggle=function(t,n){if(!e.isFunction(t)||!e.isFunction(n))return N.apply(this,arguments);r(\"jQuery.fn.toggle(handler, handler...) is deprecated\");var a=arguments,i=t.guid||e.guid++,o=0,s=function(n){var r=(e._data(this,\"lastToggle\"+t.guid)||0)%o;return e._data(this,\"lastToggle\"+t.guid,r+1),n.preventDefault(),a[r].apply(this,arguments)||!1};for(s.guid=i;a.length>o;)a[o++].guid=i;return this.click(s)},e.fn.live=function(t,n,a){return r(\"jQuery.fn.live() is deprecated\"),T?T.apply(this,arguments):(e(this.context).on(t,this.selector,n,a),this)},e.fn.die=function(t,n){return r(\"jQuery.fn.die() is deprecated\"),M?M.apply(this,arguments):(e(this.context).off(t,this.selector||\"**\",n),this)},e.event.trigger=function(e,t,n,a){return n||C.test(e)||r(\"Global events are undocumented and deprecated\"),k.call(this,e,t,n||document,a)},e.each(S.split(\"|\"),function(t,n){e.event.special[n]={setup:function(){var t=this;return t!==document&&(e.event.add(document,n+\".\"+e.guid,function(){e.event.trigger(n,null,t,!0)}),e._data(this,n,e.guid++)),!1},teardown:function(){return this!==document&&e.event.remove(document,n+\".\"+e._data(this,n)),!1}}})}(jQuery,window);"

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(24))

/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports = "/*! jQuery UI - v1.11.4 - 2015-04-12\n* http://jqueryui.com\n* Includes: core.js, widget.js, mouse.js, position.js, draggable.js, droppable.js, resizable.js, selectable.js, sortable.js, accordion.js, autocomplete.js, button.js, datepicker.js, dialog.js, menu.js, progressbar.js, selectmenu.js, slider.js, spinner.js, tabs.js, tooltip.js, effect.js, effect-blind.js, effect-bounce.js, effect-clip.js, effect-drop.js, effect-explode.js, effect-fade.js, effect-fold.js, effect-highlight.js, effect-puff.js, effect-pulsate.js, effect-scale.js, effect-shake.js, effect-size.js, effect-slide.js, effect-transfer.js\n* Copyright 2015 jQuery Foundation and other contributors; Licensed MIT */\n\n(function(e){\"function\"==typeof define&&define.amd?define([\"jquery\"],e):e(jQuery)})(function(e){function t(t,s){var n,a,o,r=t.nodeName.toLowerCase();return\"area\"===r?(n=t.parentNode,a=n.name,t.href&&a&&\"map\"===n.nodeName.toLowerCase()?(o=e(\"img[usemap='#\"+a+\"']\")[0],!!o&&i(o)):!1):(/^(input|select|textarea|button|object)$/.test(r)?!t.disabled:\"a\"===r?t.href||s:s)&&i(t)}function i(t){return e.expr.filters.visible(t)&&!e(t).parents().addBack().filter(function(){return\"hidden\"===e.css(this,\"visibility\")}).length}function s(e){for(var t,i;e.length&&e[0]!==document;){if(t=e.css(\"position\"),(\"absolute\"===t||\"relative\"===t||\"fixed\"===t)&&(i=parseInt(e.css(\"zIndex\"),10),!isNaN(i)&&0!==i))return i;e=e.parent()}return 0}function n(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId=\"ui-datepicker-div\",this._inlineClass=\"ui-datepicker-inline\",this._appendClass=\"ui-datepicker-append\",this._triggerClass=\"ui-datepicker-trigger\",this._dialogClass=\"ui-datepicker-dialog\",this._disableClass=\"ui-datepicker-disabled\",this._unselectableClass=\"ui-datepicker-unselectable\",this._currentClass=\"ui-datepicker-current-day\",this._dayOverClass=\"ui-datepicker-days-cell-over\",this.regional=[],this.regional[\"\"]={closeText:\"Done\",prevText:\"Prev\",nextText:\"Next\",currentText:\"Today\",monthNames:[\"January\",\"February\",\"March\",\"April\",\"May\",\"June\",\"July\",\"August\",\"September\",\"October\",\"November\",\"December\"],monthNamesShort:[\"Jan\",\"Feb\",\"Mar\",\"Apr\",\"May\",\"Jun\",\"Jul\",\"Aug\",\"Sep\",\"Oct\",\"Nov\",\"Dec\"],dayNames:[\"Sunday\",\"Monday\",\"Tuesday\",\"Wednesday\",\"Thursday\",\"Friday\",\"Saturday\"],dayNamesShort:[\"Sun\",\"Mon\",\"Tue\",\"Wed\",\"Thu\",\"Fri\",\"Sat\"],dayNamesMin:[\"Su\",\"Mo\",\"Tu\",\"We\",\"Th\",\"Fr\",\"Sa\"],weekHeader:\"Wk\",dateFormat:\"mm/dd/yy\",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:\"\"},this._defaults={showOn:\"focus\",showAnim:\"fadeIn\",showOptions:{},defaultDate:null,appendText:\"\",buttonText:\"...\",buttonImage:\"\",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:\"c-10:c+10\",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:\"+10\",minDate:null,maxDate:null,duration:\"fast\",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:\"\",altFormat:\"\",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},e.extend(this._defaults,this.regional[\"\"]),this.regional.en=e.extend(!0,{},this.regional[\"\"]),this.regional[\"en-US\"]=e.extend(!0,{},this.regional.en),this.dpDiv=a(e(\"<div id='\"+this._mainDivId+\"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>\"))}function a(t){var i=\"button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a\";return t.delegate(i,\"mouseout\",function(){e(this).removeClass(\"ui-state-hover\"),-1!==this.className.indexOf(\"ui-datepicker-prev\")&&e(this).removeClass(\"ui-datepicker-prev-hover\"),-1!==this.className.indexOf(\"ui-datepicker-next\")&&e(this).removeClass(\"ui-datepicker-next-hover\")}).delegate(i,\"mouseover\",o)}function o(){e.datepicker._isDisabledDatepicker(v.inline?v.dpDiv.parent()[0]:v.input[0])||(e(this).parents(\".ui-datepicker-calendar\").find(\"a\").removeClass(\"ui-state-hover\"),e(this).addClass(\"ui-state-hover\"),-1!==this.className.indexOf(\"ui-datepicker-prev\")&&e(this).addClass(\"ui-datepicker-prev-hover\"),-1!==this.className.indexOf(\"ui-datepicker-next\")&&e(this).addClass(\"ui-datepicker-next-hover\"))}function r(t,i){e.extend(t,i);for(var s in i)null==i[s]&&(t[s]=i[s]);return t}function h(e){return function(){var t=this.element.val();e.apply(this,arguments),this._refresh(),t!==this.element.val()&&this._trigger(\"change\")}}e.ui=e.ui||{},e.extend(e.ui,{version:\"1.11.4\",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),e.fn.extend({scrollParent:function(t){var i=this.css(\"position\"),s=\"absolute\"===i,n=t?/(auto|scroll|hidden)/:/(auto|scroll)/,a=this.parents().filter(function(){var t=e(this);return s&&\"static\"===t.css(\"position\")?!1:n.test(t.css(\"overflow\")+t.css(\"overflow-y\")+t.css(\"overflow-x\"))}).eq(0);return\"fixed\"!==i&&a.length?a:e(this[0].ownerDocument||document)},uniqueId:function(){var e=0;return function(){return this.each(function(){this.id||(this.id=\"ui-id-\"+ ++e)})}}(),removeUniqueId:function(){return this.each(function(){/^ui-id-\\d+$/.test(this.id)&&e(this).removeAttr(\"id\")})}}),e.extend(e.expr[\":\"],{data:e.expr.createPseudo?e.expr.createPseudo(function(t){return function(i){return!!e.data(i,t)}}):function(t,i,s){return!!e.data(t,s[3])},focusable:function(i){return t(i,!isNaN(e.attr(i,\"tabindex\")))},tabbable:function(i){var s=e.attr(i,\"tabindex\"),n=isNaN(s);return(n||s>=0)&&t(i,!n)}}),e(\"<a>\").outerWidth(1).jquery||e.each([\"Width\",\"Height\"],function(t,i){function s(t,i,s,a){return e.each(n,function(){i-=parseFloat(e.css(t,\"padding\"+this))||0,s&&(i-=parseFloat(e.css(t,\"border\"+this+\"Width\"))||0),a&&(i-=parseFloat(e.css(t,\"margin\"+this))||0)}),i}var n=\"Width\"===i?[\"Left\",\"Right\"]:[\"Top\",\"Bottom\"],a=i.toLowerCase(),o={innerWidth:e.fn.innerWidth,innerHeight:e.fn.innerHeight,outerWidth:e.fn.outerWidth,outerHeight:e.fn.outerHeight};e.fn[\"inner\"+i]=function(t){return void 0===t?o[\"inner\"+i].call(this):this.each(function(){e(this).css(a,s(this,t)+\"px\")})},e.fn[\"outer\"+i]=function(t,n){return\"number\"!=typeof t?o[\"outer\"+i].call(this,t):this.each(function(){e(this).css(a,s(this,t,!0,n)+\"px\")})}}),e.fn.addBack||(e.fn.addBack=function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}),e(\"<a>\").data(\"a-b\",\"a\").removeData(\"a-b\").data(\"a-b\")&&(e.fn.removeData=function(t){return function(i){return arguments.length?t.call(this,e.camelCase(i)):t.call(this)}}(e.fn.removeData)),e.ui.ie=!!/msie [\\w.]+/.exec(navigator.userAgent.toLowerCase()),e.fn.extend({focus:function(t){return function(i,s){return\"number\"==typeof i?this.each(function(){var t=this;setTimeout(function(){e(t).focus(),s&&s.call(t)},i)}):t.apply(this,arguments)}}(e.fn.focus),disableSelection:function(){var e=\"onselectstart\"in document.createElement(\"div\")?\"selectstart\":\"mousedown\";return function(){return this.bind(e+\".ui-disableSelection\",function(e){e.preventDefault()})}}(),enableSelection:function(){return this.unbind(\".ui-disableSelection\")},zIndex:function(t){if(void 0!==t)return this.css(\"zIndex\",t);if(this.length)for(var i,s,n=e(this[0]);n.length&&n[0]!==document;){if(i=n.css(\"position\"),(\"absolute\"===i||\"relative\"===i||\"fixed\"===i)&&(s=parseInt(n.css(\"zIndex\"),10),!isNaN(s)&&0!==s))return s;n=n.parent()}return 0}}),e.ui.plugin={add:function(t,i,s){var n,a=e.ui[t].prototype;for(n in s)a.plugins[n]=a.plugins[n]||[],a.plugins[n].push([i,s[n]])},call:function(e,t,i,s){var n,a=e.plugins[t];if(a&&(s||e.element[0].parentNode&&11!==e.element[0].parentNode.nodeType))for(n=0;a.length>n;n++)e.options[a[n][0]]&&a[n][1].apply(e.element,i)}};var l=0,u=Array.prototype.slice;e.cleanData=function(t){return function(i){var s,n,a;for(a=0;null!=(n=i[a]);a++)try{s=e._data(n,\"events\"),s&&s.remove&&e(n).triggerHandler(\"remove\")}catch(o){}t(i)}}(e.cleanData),e.widget=function(t,i,s){var n,a,o,r,h={},l=t.split(\".\")[0];return t=t.split(\".\")[1],n=l+\"-\"+t,s||(s=i,i=e.Widget),e.expr[\":\"][n.toLowerCase()]=function(t){return!!e.data(t,n)},e[l]=e[l]||{},a=e[l][t],o=e[l][t]=function(e,t){return this._createWidget?(arguments.length&&this._createWidget(e,t),void 0):new o(e,t)},e.extend(o,a,{version:s.version,_proto:e.extend({},s),_childConstructors:[]}),r=new i,r.options=e.widget.extend({},r.options),e.each(s,function(t,s){return e.isFunction(s)?(h[t]=function(){var e=function(){return i.prototype[t].apply(this,arguments)},n=function(e){return i.prototype[t].apply(this,e)};return function(){var t,i=this._super,a=this._superApply;return this._super=e,this._superApply=n,t=s.apply(this,arguments),this._super=i,this._superApply=a,t}}(),void 0):(h[t]=s,void 0)}),o.prototype=e.widget.extend(r,{widgetEventPrefix:a?r.widgetEventPrefix||t:t},h,{constructor:o,namespace:l,widgetName:t,widgetFullName:n}),a?(e.each(a._childConstructors,function(t,i){var s=i.prototype;e.widget(s.namespace+\".\"+s.widgetName,o,i._proto)}),delete a._childConstructors):i._childConstructors.push(o),e.widget.bridge(t,o),o},e.widget.extend=function(t){for(var i,s,n=u.call(arguments,1),a=0,o=n.length;o>a;a++)for(i in n[a])s=n[a][i],n[a].hasOwnProperty(i)&&void 0!==s&&(t[i]=e.isPlainObject(s)?e.isPlainObject(t[i])?e.widget.extend({},t[i],s):e.widget.extend({},s):s);return t},e.widget.bridge=function(t,i){var s=i.prototype.widgetFullName||t;e.fn[t]=function(n){var a=\"string\"==typeof n,o=u.call(arguments,1),r=this;return a?this.each(function(){var i,a=e.data(this,s);return\"instance\"===n?(r=a,!1):a?e.isFunction(a[n])&&\"_\"!==n.charAt(0)?(i=a[n].apply(a,o),i!==a&&void 0!==i?(r=i&&i.jquery?r.pushStack(i.get()):i,!1):void 0):e.error(\"no such method '\"+n+\"' for \"+t+\" widget instance\"):e.error(\"cannot call methods on \"+t+\" prior to initialization; \"+\"attempted to call method '\"+n+\"'\")}):(o.length&&(n=e.widget.extend.apply(null,[n].concat(o))),this.each(function(){var t=e.data(this,s);t?(t.option(n||{}),t._init&&t._init()):e.data(this,s,new i(n,this))})),r}},e.Widget=function(){},e.Widget._childConstructors=[],e.Widget.prototype={widgetName:\"widget\",widgetEventPrefix:\"\",defaultElement:\"<div>\",options:{disabled:!1,create:null},_createWidget:function(t,i){i=e(i||this.defaultElement||this)[0],this.element=e(i),this.uuid=l++,this.eventNamespace=\".\"+this.widgetName+this.uuid,this.bindings=e(),this.hoverable=e(),this.focusable=e(),i!==this&&(e.data(i,this.widgetFullName,this),this._on(!0,this.element,{remove:function(e){e.target===i&&this.destroy()}}),this.document=e(i.style?i.ownerDocument:i.document||i),this.window=e(this.document[0].defaultView||this.document[0].parentWindow)),this.options=e.widget.extend({},this.options,this._getCreateOptions(),t),this._create(),this._trigger(\"create\",null,this._getCreateEventData()),this._init()},_getCreateOptions:e.noop,_getCreateEventData:e.noop,_create:e.noop,_init:e.noop,destroy:function(){this._destroy(),this.element.unbind(this.eventNamespace).removeData(this.widgetFullName).removeData(e.camelCase(this.widgetFullName)),this.widget().unbind(this.eventNamespace).removeAttr(\"aria-disabled\").removeClass(this.widgetFullName+\"-disabled \"+\"ui-state-disabled\"),this.bindings.unbind(this.eventNamespace),this.hoverable.removeClass(\"ui-state-hover\"),this.focusable.removeClass(\"ui-state-focus\")},_destroy:e.noop,widget:function(){return this.element},option:function(t,i){var s,n,a,o=t;if(0===arguments.length)return e.widget.extend({},this.options);if(\"string\"==typeof t)if(o={},s=t.split(\".\"),t=s.shift(),s.length){for(n=o[t]=e.widget.extend({},this.options[t]),a=0;s.length-1>a;a++)n[s[a]]=n[s[a]]||{},n=n[s[a]];if(t=s.pop(),1===arguments.length)return void 0===n[t]?null:n[t];n[t]=i}else{if(1===arguments.length)return void 0===this.options[t]?null:this.options[t];o[t]=i}return this._setOptions(o),this},_setOptions:function(e){var t;for(t in e)this._setOption(t,e[t]);return this},_setOption:function(e,t){return this.options[e]=t,\"disabled\"===e&&(this.widget().toggleClass(this.widgetFullName+\"-disabled\",!!t),t&&(this.hoverable.removeClass(\"ui-state-hover\"),this.focusable.removeClass(\"ui-state-focus\"))),this},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_on:function(t,i,s){var n,a=this;\"boolean\"!=typeof t&&(s=i,i=t,t=!1),s?(i=n=e(i),this.bindings=this.bindings.add(i)):(s=i,i=this.element,n=this.widget()),e.each(s,function(s,o){function r(){return t||a.options.disabled!==!0&&!e(this).hasClass(\"ui-state-disabled\")?(\"string\"==typeof o?a[o]:o).apply(a,arguments):void 0}\"string\"!=typeof o&&(r.guid=o.guid=o.guid||r.guid||e.guid++);var h=s.match(/^([\\w:-]*)\\s*(.*)$/),l=h[1]+a.eventNamespace,u=h[2];u?n.delegate(u,l,r):i.bind(l,r)})},_off:function(t,i){i=(i||\"\").split(\" \").join(this.eventNamespace+\" \")+this.eventNamespace,t.unbind(i).undelegate(i),this.bindings=e(this.bindings.not(t).get()),this.focusable=e(this.focusable.not(t).get()),this.hoverable=e(this.hoverable.not(t).get())},_delay:function(e,t){function i(){return(\"string\"==typeof e?s[e]:e).apply(s,arguments)}var s=this;return setTimeout(i,t||0)},_hoverable:function(t){this.hoverable=this.hoverable.add(t),this._on(t,{mouseenter:function(t){e(t.currentTarget).addClass(\"ui-state-hover\")},mouseleave:function(t){e(t.currentTarget).removeClass(\"ui-state-hover\")}})},_focusable:function(t){this.focusable=this.focusable.add(t),this._on(t,{focusin:function(t){e(t.currentTarget).addClass(\"ui-state-focus\")},focusout:function(t){e(t.currentTarget).removeClass(\"ui-state-focus\")}})},_trigger:function(t,i,s){var n,a,o=this.options[t];if(s=s||{},i=e.Event(i),i.type=(t===this.widgetEventPrefix?t:this.widgetEventPrefix+t).toLowerCase(),i.target=this.element[0],a=i.originalEvent)for(n in a)n in i||(i[n]=a[n]);return this.element.trigger(i,s),!(e.isFunction(o)&&o.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},e.each({show:\"fadeIn\",hide:\"fadeOut\"},function(t,i){e.Widget.prototype[\"_\"+t]=function(s,n,a){\"string\"==typeof n&&(n={effect:n});var o,r=n?n===!0||\"number\"==typeof n?i:n.effect||i:t;n=n||{},\"number\"==typeof n&&(n={duration:n}),o=!e.isEmptyObject(n),n.complete=a,n.delay&&s.delay(n.delay),o&&e.effects&&e.effects.effect[r]?s[t](n):r!==t&&s[r]?s[r](n.duration,n.easing,a):s.queue(function(i){e(this)[t](),a&&a.call(s[0]),i()})}}),e.widget;var d=!1;e(document).mouseup(function(){d=!1}),e.widget(\"ui.mouse\",{version:\"1.11.4\",options:{cancel:\"input,textarea,button,select,option\",distance:1,delay:0},_mouseInit:function(){var t=this;this.element.bind(\"mousedown.\"+this.widgetName,function(e){return t._mouseDown(e)}).bind(\"click.\"+this.widgetName,function(i){return!0===e.data(i.target,t.widgetName+\".preventClickEvent\")?(e.removeData(i.target,t.widgetName+\".preventClickEvent\"),i.stopImmediatePropagation(),!1):void 0}),this.started=!1},_mouseDestroy:function(){this.element.unbind(\".\"+this.widgetName),this._mouseMoveDelegate&&this.document.unbind(\"mousemove.\"+this.widgetName,this._mouseMoveDelegate).unbind(\"mouseup.\"+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(t){if(!d){this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(t),this._mouseDownEvent=t;var i=this,s=1===t.which,n=\"string\"==typeof this.options.cancel&&t.target.nodeName?e(t.target).closest(this.options.cancel).length:!1;return s&&!n&&this._mouseCapture(t)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){i.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=this._mouseStart(t)!==!1,!this._mouseStarted)?(t.preventDefault(),!0):(!0===e.data(t.target,this.widgetName+\".preventClickEvent\")&&e.removeData(t.target,this.widgetName+\".preventClickEvent\"),this._mouseMoveDelegate=function(e){return i._mouseMove(e)},this._mouseUpDelegate=function(e){return i._mouseUp(e)},this.document.bind(\"mousemove.\"+this.widgetName,this._mouseMoveDelegate).bind(\"mouseup.\"+this.widgetName,this._mouseUpDelegate),t.preventDefault(),d=!0,!0)):!0}},_mouseMove:function(t){if(this._mouseMoved){if(e.ui.ie&&(!document.documentMode||9>document.documentMode)&&!t.button)return this._mouseUp(t);if(!t.which)return this._mouseUp(t)}return(t.which||t.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(t),t.preventDefault()):(this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,t)!==!1,this._mouseStarted?this._mouseDrag(t):this._mouseUp(t)),!this._mouseStarted)},_mouseUp:function(t){return this.document.unbind(\"mousemove.\"+this.widgetName,this._mouseMoveDelegate).unbind(\"mouseup.\"+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,t.target===this._mouseDownEvent.target&&e.data(t.target,this.widgetName+\".preventClickEvent\",!0),this._mouseStop(t)),d=!1,!1},_mouseDistanceMet:function(e){return Math.max(Math.abs(this._mouseDownEvent.pageX-e.pageX),Math.abs(this._mouseDownEvent.pageY-e.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),function(){function t(e,t,i){return[parseFloat(e[0])*(p.test(e[0])?t/100:1),parseFloat(e[1])*(p.test(e[1])?i/100:1)]}function i(t,i){return parseInt(e.css(t,i),10)||0}function s(t){var i=t[0];return 9===i.nodeType?{width:t.width(),height:t.height(),offset:{top:0,left:0}}:e.isWindow(i)?{width:t.width(),height:t.height(),offset:{top:t.scrollTop(),left:t.scrollLeft()}}:i.preventDefault?{width:0,height:0,offset:{top:i.pageY,left:i.pageX}}:{width:t.outerWidth(),height:t.outerHeight(),offset:t.offset()}}e.ui=e.ui||{};var n,a,o=Math.max,r=Math.abs,h=Math.round,l=/left|center|right/,u=/top|center|bottom/,d=/[\\+\\-]\\d+(\\.[\\d]+)?%?/,c=/^\\w+/,p=/%$/,f=e.fn.position;e.position={scrollbarWidth:function(){if(void 0!==n)return n;var t,i,s=e(\"<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>\"),a=s.children()[0];return e(\"body\").append(s),t=a.offsetWidth,s.css(\"overflow\",\"scroll\"),i=a.offsetWidth,t===i&&(i=s[0].clientWidth),s.remove(),n=t-i},getScrollInfo:function(t){var i=t.isWindow||t.isDocument?\"\":t.element.css(\"overflow-x\"),s=t.isWindow||t.isDocument?\"\":t.element.css(\"overflow-y\"),n=\"scroll\"===i||\"auto\"===i&&t.width<t.element[0].scrollWidth,a=\"scroll\"===s||\"auto\"===s&&t.height<t.element[0].scrollHeight;return{width:a?e.position.scrollbarWidth():0,height:n?e.position.scrollbarWidth():0}},getWithinInfo:function(t){var i=e(t||window),s=e.isWindow(i[0]),n=!!i[0]&&9===i[0].nodeType;return{element:i,isWindow:s,isDocument:n,offset:i.offset()||{left:0,top:0},scrollLeft:i.scrollLeft(),scrollTop:i.scrollTop(),width:s||n?i.width():i.outerWidth(),height:s||n?i.height():i.outerHeight()}}},e.fn.position=function(n){if(!n||!n.of)return f.apply(this,arguments);n=e.extend({},n);var p,m,g,v,y,b,_=e(n.of),x=e.position.getWithinInfo(n.within),w=e.position.getScrollInfo(x),k=(n.collision||\"flip\").split(\" \"),T={};return b=s(_),_[0].preventDefault&&(n.at=\"left top\"),m=b.width,g=b.height,v=b.offset,y=e.extend({},v),e.each([\"my\",\"at\"],function(){var e,t,i=(n[this]||\"\").split(\" \");1===i.length&&(i=l.test(i[0])?i.concat([\"center\"]):u.test(i[0])?[\"center\"].concat(i):[\"center\",\"center\"]),i[0]=l.test(i[0])?i[0]:\"center\",i[1]=u.test(i[1])?i[1]:\"center\",e=d.exec(i[0]),t=d.exec(i[1]),T[this]=[e?e[0]:0,t?t[0]:0],n[this]=[c.exec(i[0])[0],c.exec(i[1])[0]]}),1===k.length&&(k[1]=k[0]),\"right\"===n.at[0]?y.left+=m:\"center\"===n.at[0]&&(y.left+=m/2),\"bottom\"===n.at[1]?y.top+=g:\"center\"===n.at[1]&&(y.top+=g/2),p=t(T.at,m,g),y.left+=p[0],y.top+=p[1],this.each(function(){var s,l,u=e(this),d=u.outerWidth(),c=u.outerHeight(),f=i(this,\"marginLeft\"),b=i(this,\"marginTop\"),D=d+f+i(this,\"marginRight\")+w.width,S=c+b+i(this,\"marginBottom\")+w.height,M=e.extend({},y),C=t(T.my,u.outerWidth(),u.outerHeight());\"right\"===n.my[0]?M.left-=d:\"center\"===n.my[0]&&(M.left-=d/2),\"bottom\"===n.my[1]?M.top-=c:\"center\"===n.my[1]&&(M.top-=c/2),M.left+=C[0],M.top+=C[1],a||(M.left=h(M.left),M.top=h(M.top)),s={marginLeft:f,marginTop:b},e.each([\"left\",\"top\"],function(t,i){e.ui.position[k[t]]&&e.ui.position[k[t]][i](M,{targetWidth:m,targetHeight:g,elemWidth:d,elemHeight:c,collisionPosition:s,collisionWidth:D,collisionHeight:S,offset:[p[0]+C[0],p[1]+C[1]],my:n.my,at:n.at,within:x,elem:u})}),n.using&&(l=function(e){var t=v.left-M.left,i=t+m-d,s=v.top-M.top,a=s+g-c,h={target:{element:_,left:v.left,top:v.top,width:m,height:g},element:{element:u,left:M.left,top:M.top,width:d,height:c},horizontal:0>i?\"left\":t>0?\"right\":\"center\",vertical:0>a?\"top\":s>0?\"bottom\":\"middle\"};d>m&&m>r(t+i)&&(h.horizontal=\"center\"),c>g&&g>r(s+a)&&(h.vertical=\"middle\"),h.important=o(r(t),r(i))>o(r(s),r(a))?\"horizontal\":\"vertical\",n.using.call(this,e,h)}),u.offset(e.extend(M,{using:l}))})},e.ui.position={fit:{left:function(e,t){var i,s=t.within,n=s.isWindow?s.scrollLeft:s.offset.left,a=s.width,r=e.left-t.collisionPosition.marginLeft,h=n-r,l=r+t.collisionWidth-a-n;t.collisionWidth>a?h>0&&0>=l?(i=e.left+h+t.collisionWidth-a-n,e.left+=h-i):e.left=l>0&&0>=h?n:h>l?n+a-t.collisionWidth:n:h>0?e.left+=h:l>0?e.left-=l:e.left=o(e.left-r,e.left)},top:function(e,t){var i,s=t.within,n=s.isWindow?s.scrollTop:s.offset.top,a=t.within.height,r=e.top-t.collisionPosition.marginTop,h=n-r,l=r+t.collisionHeight-a-n;t.collisionHeight>a?h>0&&0>=l?(i=e.top+h+t.collisionHeight-a-n,e.top+=h-i):e.top=l>0&&0>=h?n:h>l?n+a-t.collisionHeight:n:h>0?e.top+=h:l>0?e.top-=l:e.top=o(e.top-r,e.top)}},flip:{left:function(e,t){var i,s,n=t.within,a=n.offset.left+n.scrollLeft,o=n.width,h=n.isWindow?n.scrollLeft:n.offset.left,l=e.left-t.collisionPosition.marginLeft,u=l-h,d=l+t.collisionWidth-o-h,c=\"left\"===t.my[0]?-t.elemWidth:\"right\"===t.my[0]?t.elemWidth:0,p=\"left\"===t.at[0]?t.targetWidth:\"right\"===t.at[0]?-t.targetWidth:0,f=-2*t.offset[0];0>u?(i=e.left+c+p+f+t.collisionWidth-o-a,(0>i||r(u)>i)&&(e.left+=c+p+f)):d>0&&(s=e.left-t.collisionPosition.marginLeft+c+p+f-h,(s>0||d>r(s))&&(e.left+=c+p+f))},top:function(e,t){var i,s,n=t.within,a=n.offset.top+n.scrollTop,o=n.height,h=n.isWindow?n.scrollTop:n.offset.top,l=e.top-t.collisionPosition.marginTop,u=l-h,d=l+t.collisionHeight-o-h,c=\"top\"===t.my[1],p=c?-t.elemHeight:\"bottom\"===t.my[1]?t.elemHeight:0,f=\"top\"===t.at[1]?t.targetHeight:\"bottom\"===t.at[1]?-t.targetHeight:0,m=-2*t.offset[1];0>u?(s=e.top+p+f+m+t.collisionHeight-o-a,(0>s||r(u)>s)&&(e.top+=p+f+m)):d>0&&(i=e.top-t.collisionPosition.marginTop+p+f+m-h,(i>0||d>r(i))&&(e.top+=p+f+m))}},flipfit:{left:function(){e.ui.position.flip.left.apply(this,arguments),e.ui.position.fit.left.apply(this,arguments)},top:function(){e.ui.position.flip.top.apply(this,arguments),e.ui.position.fit.top.apply(this,arguments)}}},function(){var t,i,s,n,o,r=document.getElementsByTagName(\"body\")[0],h=document.createElement(\"div\");t=document.createElement(r?\"div\":\"body\"),s={visibility:\"hidden\",width:0,height:0,border:0,margin:0,background:\"none\"},r&&e.extend(s,{position:\"absolute\",left:\"-1000px\",top:\"-1000px\"});for(o in s)t.style[o]=s[o];t.appendChild(h),i=r||document.documentElement,i.insertBefore(t,i.firstChild),h.style.cssText=\"position: absolute; left: 10.7432222px;\",n=e(h).offset().left,a=n>10&&11>n,t.innerHTML=\"\",i.removeChild(t)}()}(),e.ui.position,e.widget(\"ui.draggable\",e.ui.mouse,{version:\"1.11.4\",widgetEventPrefix:\"drag\",options:{addClasses:!0,appendTo:\"parent\",axis:!1,connectToSortable:!1,containment:!1,cursor:\"auto\",cursorAt:!1,grid:!1,handle:!1,helper:\"original\",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:\"default\",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:\"both\",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){\"original\"===this.options.helper&&this._setPositionRelative(),this.options.addClasses&&this.element.addClass(\"ui-draggable\"),this.options.disabled&&this.element.addClass(\"ui-draggable-disabled\"),this._setHandleClassName(),this._mouseInit()},_setOption:function(e,t){this._super(e,t),\"handle\"===e&&(this._removeHandleClassName(),this._setHandleClassName())},_destroy:function(){return(this.helper||this.element).is(\".ui-draggable-dragging\")?(this.destroyOnClear=!0,void 0):(this.element.removeClass(\"ui-draggable ui-draggable-dragging ui-draggable-disabled\"),this._removeHandleClassName(),this._mouseDestroy(),void 0)},_mouseCapture:function(t){var i=this.options;return this._blurActiveElement(t),this.helper||i.disabled||e(t.target).closest(\".ui-resizable-handle\").length>0?!1:(this.handle=this._getHandle(t),this.handle?(this._blockFrames(i.iframeFix===!0?\"iframe\":i.iframeFix),!0):!1)},_blockFrames:function(t){this.iframeBlocks=this.document.find(t).map(function(){var t=e(this);return e(\"<div>\").css(\"position\",\"absolute\").appendTo(t.parent()).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).offset(t.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_blurActiveElement:function(t){var i=this.document[0];if(this.handleElement.is(t.target))try{i.activeElement&&\"body\"!==i.activeElement.nodeName.toLowerCase()&&e(i.activeElement).blur()}catch(s){}},_mouseStart:function(t){var i=this.options;return this.helper=this._createHelper(t),this.helper.addClass(\"ui-draggable-dragging\"),this._cacheHelperProportions(),e.ui.ddmanager&&(e.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css(\"position\"),this.scrollParent=this.helper.scrollParent(!0),this.offsetParent=this.helper.offsetParent(),this.hasFixedAncestor=this.helper.parents().filter(function(){return\"fixed\"===e(this).css(\"position\")}).length>0,this.positionAbs=this.element.offset(),this._refreshOffsets(t),this.originalPosition=this.position=this._generatePosition(t,!1),this.originalPageX=t.pageX,this.originalPageY=t.pageY,i.cursorAt&&this._adjustOffsetFromHelper(i.cursorAt),this._setContainment(),this._trigger(\"start\",t)===!1?(this._clear(),!1):(this._cacheHelperProportions(),e.ui.ddmanager&&!i.dropBehaviour&&e.ui.ddmanager.prepareOffsets(this,t),this._normalizeRightBottom(),this._mouseDrag(t,!0),e.ui.ddmanager&&e.ui.ddmanager.dragStart(this,t),!0)},_refreshOffsets:function(e){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:!1,parent:this._getParentOffset(),relative:this._getRelativeOffset()},this.offset.click={left:e.pageX-this.offset.left,top:e.pageY-this.offset.top}},_mouseDrag:function(t,i){if(this.hasFixedAncestor&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(t,!0),this.positionAbs=this._convertPositionTo(\"absolute\"),!i){var s=this._uiHash();if(this._trigger(\"drag\",t,s)===!1)return this._mouseUp({}),!1;this.position=s.position}return this.helper[0].style.left=this.position.left+\"px\",this.helper[0].style.top=this.position.top+\"px\",e.ui.ddmanager&&e.ui.ddmanager.drag(this,t),!1},_mouseStop:function(t){var i=this,s=!1;return e.ui.ddmanager&&!this.options.dropBehaviour&&(s=e.ui.ddmanager.drop(this,t)),this.dropped&&(s=this.dropped,this.dropped=!1),\"invalid\"===this.options.revert&&!s||\"valid\"===this.options.revert&&s||this.options.revert===!0||e.isFunction(this.options.revert)&&this.options.revert.call(this.element,s)?e(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){i._trigger(\"stop\",t)!==!1&&i._clear()}):this._trigger(\"stop\",t)!==!1&&this._clear(),!1},_mouseUp:function(t){return this._unblockFrames(),e.ui.ddmanager&&e.ui.ddmanager.dragStop(this,t),this.handleElement.is(t.target)&&this.element.focus(),e.ui.mouse.prototype._mouseUp.call(this,t)},cancel:function(){return this.helper.is(\".ui-draggable-dragging\")?this._mouseUp({}):this._clear(),this},_getHandle:function(t){return this.options.handle?!!e(t.target).closest(this.element.find(this.options.handle)).length:!0},_setHandleClassName:function(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element,this.handleElement.addClass(\"ui-draggable-handle\")},_removeHandleClassName:function(){this.handleElement.removeClass(\"ui-draggable-handle\")},_createHelper:function(t){var i=this.options,s=e.isFunction(i.helper),n=s?e(i.helper.apply(this.element[0],[t])):\"clone\"===i.helper?this.element.clone().removeAttr(\"id\"):this.element;return n.parents(\"body\").length||n.appendTo(\"parent\"===i.appendTo?this.element[0].parentNode:i.appendTo),s&&n[0]===this.element[0]&&this._setPositionRelative(),n[0]===this.element[0]||/(fixed|absolute)/.test(n.css(\"position\"))||n.css(\"position\",\"absolute\"),n},_setPositionRelative:function(){/^(?:r|a|f)/.test(this.element.css(\"position\"))||(this.element[0].style.position=\"relative\")},_adjustOffsetFromHelper:function(t){\"string\"==typeof t&&(t=t.split(\" \")),e.isArray(t)&&(t={left:+t[0],top:+t[1]||0}),\"left\"in t&&(this.offset.click.left=t.left+this.margins.left),\"right\"in t&&(this.offset.click.left=this.helperProportions.width-t.right+this.margins.left),\"top\"in t&&(this.offset.click.top=t.top+this.margins.top),\"bottom\"in t&&(this.offset.click.top=this.helperProportions.height-t.bottom+this.margins.top)},_isRootNode:function(e){return/(html|body)/i.test(e.tagName)||e===this.document[0]},_getParentOffset:function(){var t=this.offsetParent.offset(),i=this.document[0];return\"absolute\"===this.cssPosition&&this.scrollParent[0]!==i&&e.contains(this.scrollParent[0],this.offsetParent[0])&&(t.left+=this.scrollParent.scrollLeft(),t.top+=this.scrollParent.scrollTop()),this._isRootNode(this.offsetParent[0])&&(t={top:0,left:0}),{top:t.top+(parseInt(this.offsetParent.css(\"borderTopWidth\"),10)||0),left:t.left+(parseInt(this.offsetParent.css(\"borderLeftWidth\"),10)||0)}},_getRelativeOffset:function(){if(\"relative\"!==this.cssPosition)return{top:0,left:0};var e=this.element.position(),t=this._isRootNode(this.scrollParent[0]);return{top:e.top-(parseInt(this.helper.css(\"top\"),10)||0)+(t?0:this.scrollParent.scrollTop()),left:e.left-(parseInt(this.helper.css(\"left\"),10)||0)+(t?0:this.scrollParent.scrollLeft())}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css(\"marginLeft\"),10)||0,top:parseInt(this.element.css(\"marginTop\"),10)||0,right:parseInt(this.element.css(\"marginRight\"),10)||0,bottom:parseInt(this.element.css(\"marginBottom\"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var t,i,s,n=this.options,a=this.document[0];return this.relativeContainer=null,n.containment?\"window\"===n.containment?(this.containment=[e(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,e(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,e(window).scrollLeft()+e(window).width()-this.helperProportions.width-this.margins.left,e(window).scrollTop()+(e(window).height()||a.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):\"document\"===n.containment?(this.containment=[0,0,e(a).width()-this.helperProportions.width-this.margins.left,(e(a).height()||a.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):n.containment.constructor===Array?(this.containment=n.containment,void 0):(\"parent\"===n.containment&&(n.containment=this.helper[0].parentNode),i=e(n.containment),s=i[0],s&&(t=/(scroll|auto)/.test(i.css(\"overflow\")),this.containment=[(parseInt(i.css(\"borderLeftWidth\"),10)||0)+(parseInt(i.css(\"paddingLeft\"),10)||0),(parseInt(i.css(\"borderTopWidth\"),10)||0)+(parseInt(i.css(\"paddingTop\"),10)||0),(t?Math.max(s.scrollWidth,s.offsetWidth):s.offsetWidth)-(parseInt(i.css(\"borderRightWidth\"),10)||0)-(parseInt(i.css(\"paddingRight\"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(t?Math.max(s.scrollHeight,s.offsetHeight):s.offsetHeight)-(parseInt(i.css(\"borderBottomWidth\"),10)||0)-(parseInt(i.css(\"paddingBottom\"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relativeContainer=i),void 0):(this.containment=null,void 0)},_convertPositionTo:function(e,t){t||(t=this.position);var i=\"absolute\"===e?1:-1,s=this._isRootNode(this.scrollParent[0]);return{top:t.top+this.offset.relative.top*i+this.offset.parent.top*i-(\"fixed\"===this.cssPosition?-this.offset.scroll.top:s?0:this.offset.scroll.top)*i,left:t.left+this.offset.relative.left*i+this.offset.parent.left*i-(\"fixed\"===this.cssPosition?-this.offset.scroll.left:s?0:this.offset.scroll.left)*i}},_generatePosition:function(e,t){var i,s,n,a,o=this.options,r=this._isRootNode(this.scrollParent[0]),h=e.pageX,l=e.pageY;return r&&this.offset.scroll||(this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()}),t&&(this.containment&&(this.relativeContainer?(s=this.relativeContainer.offset(),i=[this.containment[0]+s.left,this.containment[1]+s.top,this.containment[2]+s.left,this.containment[3]+s.top]):i=this.containment,e.pageX-this.offset.click.left<i[0]&&(h=i[0]+this.offset.click.left),e.pageY-this.offset.click.top<i[1]&&(l=i[1]+this.offset.click.top),e.pageX-this.offset.click.left>i[2]&&(h=i[2]+this.offset.click.left),e.pageY-this.offset.click.top>i[3]&&(l=i[3]+this.offset.click.top)),o.grid&&(n=o.grid[1]?this.originalPageY+Math.round((l-this.originalPageY)/o.grid[1])*o.grid[1]:this.originalPageY,l=i?n-this.offset.click.top>=i[1]||n-this.offset.click.top>i[3]?n:n-this.offset.click.top>=i[1]?n-o.grid[1]:n+o.grid[1]:n,a=o.grid[0]?this.originalPageX+Math.round((h-this.originalPageX)/o.grid[0])*o.grid[0]:this.originalPageX,h=i?a-this.offset.click.left>=i[0]||a-this.offset.click.left>i[2]?a:a-this.offset.click.left>=i[0]?a-o.grid[0]:a+o.grid[0]:a),\"y\"===o.axis&&(h=this.originalPageX),\"x\"===o.axis&&(l=this.originalPageY)),{top:l-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+(\"fixed\"===this.cssPosition?-this.offset.scroll.top:r?0:this.offset.scroll.top),left:h-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+(\"fixed\"===this.cssPosition?-this.offset.scroll.left:r?0:this.offset.scroll.left)}\n},_clear:function(){this.helper.removeClass(\"ui-draggable-dragging\"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1,this.destroyOnClear&&this.destroy()},_normalizeRightBottom:function(){\"y\"!==this.options.axis&&\"auto\"!==this.helper.css(\"right\")&&(this.helper.width(this.helper.width()),this.helper.css(\"right\",\"auto\")),\"x\"!==this.options.axis&&\"auto\"!==this.helper.css(\"bottom\")&&(this.helper.height(this.helper.height()),this.helper.css(\"bottom\",\"auto\"))},_trigger:function(t,i,s){return s=s||this._uiHash(),e.ui.plugin.call(this,t,[i,s,this],!0),/^(drag|start|stop)/.test(t)&&(this.positionAbs=this._convertPositionTo(\"absolute\"),s.offset=this.positionAbs),e.Widget.prototype._trigger.call(this,t,i,s)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),e.ui.plugin.add(\"draggable\",\"connectToSortable\",{start:function(t,i,s){var n=e.extend({},i,{item:s.element});s.sortables=[],e(s.options.connectToSortable).each(function(){var i=e(this).sortable(\"instance\");i&&!i.options.disabled&&(s.sortables.push(i),i.refreshPositions(),i._trigger(\"activate\",t,n))})},stop:function(t,i,s){var n=e.extend({},i,{item:s.element});s.cancelHelperRemoval=!1,e.each(s.sortables,function(){var e=this;e.isOver?(e.isOver=0,s.cancelHelperRemoval=!0,e.cancelHelperRemoval=!1,e._storedCSS={position:e.placeholder.css(\"position\"),top:e.placeholder.css(\"top\"),left:e.placeholder.css(\"left\")},e._mouseStop(t),e.options.helper=e.options._helper):(e.cancelHelperRemoval=!0,e._trigger(\"deactivate\",t,n))})},drag:function(t,i,s){e.each(s.sortables,function(){var n=!1,a=this;a.positionAbs=s.positionAbs,a.helperProportions=s.helperProportions,a.offset.click=s.offset.click,a._intersectsWith(a.containerCache)&&(n=!0,e.each(s.sortables,function(){return this.positionAbs=s.positionAbs,this.helperProportions=s.helperProportions,this.offset.click=s.offset.click,this!==a&&this._intersectsWith(this.containerCache)&&e.contains(a.element[0],this.element[0])&&(n=!1),n})),n?(a.isOver||(a.isOver=1,s._parent=i.helper.parent(),a.currentItem=i.helper.appendTo(a.element).data(\"ui-sortable-item\",!0),a.options._helper=a.options.helper,a.options.helper=function(){return i.helper[0]},t.target=a.currentItem[0],a._mouseCapture(t,!0),a._mouseStart(t,!0,!0),a.offset.click.top=s.offset.click.top,a.offset.click.left=s.offset.click.left,a.offset.parent.left-=s.offset.parent.left-a.offset.parent.left,a.offset.parent.top-=s.offset.parent.top-a.offset.parent.top,s._trigger(\"toSortable\",t),s.dropped=a.element,e.each(s.sortables,function(){this.refreshPositions()}),s.currentItem=s.element,a.fromOutside=s),a.currentItem&&(a._mouseDrag(t),i.position=a.position)):a.isOver&&(a.isOver=0,a.cancelHelperRemoval=!0,a.options._revert=a.options.revert,a.options.revert=!1,a._trigger(\"out\",t,a._uiHash(a)),a._mouseStop(t,!0),a.options.revert=a.options._revert,a.options.helper=a.options._helper,a.placeholder&&a.placeholder.remove(),i.helper.appendTo(s._parent),s._refreshOffsets(t),i.position=s._generatePosition(t,!0),s._trigger(\"fromSortable\",t),s.dropped=!1,e.each(s.sortables,function(){this.refreshPositions()}))})}}),e.ui.plugin.add(\"draggable\",\"cursor\",{start:function(t,i,s){var n=e(\"body\"),a=s.options;n.css(\"cursor\")&&(a._cursor=n.css(\"cursor\")),n.css(\"cursor\",a.cursor)},stop:function(t,i,s){var n=s.options;n._cursor&&e(\"body\").css(\"cursor\",n._cursor)}}),e.ui.plugin.add(\"draggable\",\"opacity\",{start:function(t,i,s){var n=e(i.helper),a=s.options;n.css(\"opacity\")&&(a._opacity=n.css(\"opacity\")),n.css(\"opacity\",a.opacity)},stop:function(t,i,s){var n=s.options;n._opacity&&e(i.helper).css(\"opacity\",n._opacity)}}),e.ui.plugin.add(\"draggable\",\"scroll\",{start:function(e,t,i){i.scrollParentNotHidden||(i.scrollParentNotHidden=i.helper.scrollParent(!1)),i.scrollParentNotHidden[0]!==i.document[0]&&\"HTML\"!==i.scrollParentNotHidden[0].tagName&&(i.overflowOffset=i.scrollParentNotHidden.offset())},drag:function(t,i,s){var n=s.options,a=!1,o=s.scrollParentNotHidden[0],r=s.document[0];o!==r&&\"HTML\"!==o.tagName?(n.axis&&\"x\"===n.axis||(s.overflowOffset.top+o.offsetHeight-t.pageY<n.scrollSensitivity?o.scrollTop=a=o.scrollTop+n.scrollSpeed:t.pageY-s.overflowOffset.top<n.scrollSensitivity&&(o.scrollTop=a=o.scrollTop-n.scrollSpeed)),n.axis&&\"y\"===n.axis||(s.overflowOffset.left+o.offsetWidth-t.pageX<n.scrollSensitivity?o.scrollLeft=a=o.scrollLeft+n.scrollSpeed:t.pageX-s.overflowOffset.left<n.scrollSensitivity&&(o.scrollLeft=a=o.scrollLeft-n.scrollSpeed))):(n.axis&&\"x\"===n.axis||(t.pageY-e(r).scrollTop()<n.scrollSensitivity?a=e(r).scrollTop(e(r).scrollTop()-n.scrollSpeed):e(window).height()-(t.pageY-e(r).scrollTop())<n.scrollSensitivity&&(a=e(r).scrollTop(e(r).scrollTop()+n.scrollSpeed))),n.axis&&\"y\"===n.axis||(t.pageX-e(r).scrollLeft()<n.scrollSensitivity?a=e(r).scrollLeft(e(r).scrollLeft()-n.scrollSpeed):e(window).width()-(t.pageX-e(r).scrollLeft())<n.scrollSensitivity&&(a=e(r).scrollLeft(e(r).scrollLeft()+n.scrollSpeed)))),a!==!1&&e.ui.ddmanager&&!n.dropBehaviour&&e.ui.ddmanager.prepareOffsets(s,t)}}),e.ui.plugin.add(\"draggable\",\"snap\",{start:function(t,i,s){var n=s.options;s.snapElements=[],e(n.snap.constructor!==String?n.snap.items||\":data(ui-draggable)\":n.snap).each(function(){var t=e(this),i=t.offset();this!==s.element[0]&&s.snapElements.push({item:this,width:t.outerWidth(),height:t.outerHeight(),top:i.top,left:i.left})})},drag:function(t,i,s){var n,a,o,r,h,l,u,d,c,p,f=s.options,m=f.snapTolerance,g=i.offset.left,v=g+s.helperProportions.width,y=i.offset.top,b=y+s.helperProportions.height;for(c=s.snapElements.length-1;c>=0;c--)h=s.snapElements[c].left-s.margins.left,l=h+s.snapElements[c].width,u=s.snapElements[c].top-s.margins.top,d=u+s.snapElements[c].height,h-m>v||g>l+m||u-m>b||y>d+m||!e.contains(s.snapElements[c].item.ownerDocument,s.snapElements[c].item)?(s.snapElements[c].snapping&&s.options.snap.release&&s.options.snap.release.call(s.element,t,e.extend(s._uiHash(),{snapItem:s.snapElements[c].item})),s.snapElements[c].snapping=!1):(\"inner\"!==f.snapMode&&(n=m>=Math.abs(u-b),a=m>=Math.abs(d-y),o=m>=Math.abs(h-v),r=m>=Math.abs(l-g),n&&(i.position.top=s._convertPositionTo(\"relative\",{top:u-s.helperProportions.height,left:0}).top),a&&(i.position.top=s._convertPositionTo(\"relative\",{top:d,left:0}).top),o&&(i.position.left=s._convertPositionTo(\"relative\",{top:0,left:h-s.helperProportions.width}).left),r&&(i.position.left=s._convertPositionTo(\"relative\",{top:0,left:l}).left)),p=n||a||o||r,\"outer\"!==f.snapMode&&(n=m>=Math.abs(u-y),a=m>=Math.abs(d-b),o=m>=Math.abs(h-g),r=m>=Math.abs(l-v),n&&(i.position.top=s._convertPositionTo(\"relative\",{top:u,left:0}).top),a&&(i.position.top=s._convertPositionTo(\"relative\",{top:d-s.helperProportions.height,left:0}).top),o&&(i.position.left=s._convertPositionTo(\"relative\",{top:0,left:h}).left),r&&(i.position.left=s._convertPositionTo(\"relative\",{top:0,left:l-s.helperProportions.width}).left)),!s.snapElements[c].snapping&&(n||a||o||r||p)&&s.options.snap.snap&&s.options.snap.snap.call(s.element,t,e.extend(s._uiHash(),{snapItem:s.snapElements[c].item})),s.snapElements[c].snapping=n||a||o||r||p)}}),e.ui.plugin.add(\"draggable\",\"stack\",{start:function(t,i,s){var n,a=s.options,o=e.makeArray(e(a.stack)).sort(function(t,i){return(parseInt(e(t).css(\"zIndex\"),10)||0)-(parseInt(e(i).css(\"zIndex\"),10)||0)});o.length&&(n=parseInt(e(o[0]).css(\"zIndex\"),10)||0,e(o).each(function(t){e(this).css(\"zIndex\",n+t)}),this.css(\"zIndex\",n+o.length))}}),e.ui.plugin.add(\"draggable\",\"zIndex\",{start:function(t,i,s){var n=e(i.helper),a=s.options;n.css(\"zIndex\")&&(a._zIndex=n.css(\"zIndex\")),n.css(\"zIndex\",a.zIndex)},stop:function(t,i,s){var n=s.options;n._zIndex&&e(i.helper).css(\"zIndex\",n._zIndex)}}),e.ui.draggable,e.widget(\"ui.droppable\",{version:\"1.11.4\",widgetEventPrefix:\"drop\",options:{accept:\"*\",activeClass:!1,addClasses:!0,greedy:!1,hoverClass:!1,scope:\"default\",tolerance:\"intersect\",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var t,i=this.options,s=i.accept;this.isover=!1,this.isout=!0,this.accept=e.isFunction(s)?s:function(e){return e.is(s)},this.proportions=function(){return arguments.length?(t=arguments[0],void 0):t?t:t={width:this.element[0].offsetWidth,height:this.element[0].offsetHeight}},this._addToManager(i.scope),i.addClasses&&this.element.addClass(\"ui-droppable\")},_addToManager:function(t){e.ui.ddmanager.droppables[t]=e.ui.ddmanager.droppables[t]||[],e.ui.ddmanager.droppables[t].push(this)},_splice:function(e){for(var t=0;e.length>t;t++)e[t]===this&&e.splice(t,1)},_destroy:function(){var t=e.ui.ddmanager.droppables[this.options.scope];this._splice(t),this.element.removeClass(\"ui-droppable ui-droppable-disabled\")},_setOption:function(t,i){if(\"accept\"===t)this.accept=e.isFunction(i)?i:function(e){return e.is(i)};else if(\"scope\"===t){var s=e.ui.ddmanager.droppables[this.options.scope];this._splice(s),this._addToManager(i)}this._super(t,i)},_activate:function(t){var i=e.ui.ddmanager.current;this.options.activeClass&&this.element.addClass(this.options.activeClass),i&&this._trigger(\"activate\",t,this.ui(i))},_deactivate:function(t){var i=e.ui.ddmanager.current;this.options.activeClass&&this.element.removeClass(this.options.activeClass),i&&this._trigger(\"deactivate\",t,this.ui(i))},_over:function(t){var i=e.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this.options.hoverClass&&this.element.addClass(this.options.hoverClass),this._trigger(\"over\",t,this.ui(i)))},_out:function(t){var i=e.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger(\"out\",t,this.ui(i)))},_drop:function(t,i){var s=i||e.ui.ddmanager.current,n=!1;return s&&(s.currentItem||s.element)[0]!==this.element[0]?(this.element.find(\":data(ui-droppable)\").not(\".ui-draggable-dragging\").each(function(){var i=e(this).droppable(\"instance\");return i.options.greedy&&!i.options.disabled&&i.options.scope===s.options.scope&&i.accept.call(i.element[0],s.currentItem||s.element)&&e.ui.intersect(s,e.extend(i,{offset:i.element.offset()}),i.options.tolerance,t)?(n=!0,!1):void 0}),n?!1:this.accept.call(this.element[0],s.currentItem||s.element)?(this.options.activeClass&&this.element.removeClass(this.options.activeClass),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger(\"drop\",t,this.ui(s)),this.element):!1):!1},ui:function(e){return{draggable:e.currentItem||e.element,helper:e.helper,position:e.position,offset:e.positionAbs}}}),e.ui.intersect=function(){function e(e,t,i){return e>=t&&t+i>e}return function(t,i,s,n){if(!i.offset)return!1;var a=(t.positionAbs||t.position.absolute).left+t.margins.left,o=(t.positionAbs||t.position.absolute).top+t.margins.top,r=a+t.helperProportions.width,h=o+t.helperProportions.height,l=i.offset.left,u=i.offset.top,d=l+i.proportions().width,c=u+i.proportions().height;switch(s){case\"fit\":return a>=l&&d>=r&&o>=u&&c>=h;case\"intersect\":return a+t.helperProportions.width/2>l&&d>r-t.helperProportions.width/2&&o+t.helperProportions.height/2>u&&c>h-t.helperProportions.height/2;case\"pointer\":return e(n.pageY,u,i.proportions().height)&&e(n.pageX,l,i.proportions().width);case\"touch\":return(o>=u&&c>=o||h>=u&&c>=h||u>o&&h>c)&&(a>=l&&d>=a||r>=l&&d>=r||l>a&&r>d);default:return!1}}}(),e.ui.ddmanager={current:null,droppables:{\"default\":[]},prepareOffsets:function(t,i){var s,n,a=e.ui.ddmanager.droppables[t.options.scope]||[],o=i?i.type:null,r=(t.currentItem||t.element).find(\":data(ui-droppable)\").addBack();e:for(s=0;a.length>s;s++)if(!(a[s].options.disabled||t&&!a[s].accept.call(a[s].element[0],t.currentItem||t.element))){for(n=0;r.length>n;n++)if(r[n]===a[s].element[0]){a[s].proportions().height=0;continue e}a[s].visible=\"none\"!==a[s].element.css(\"display\"),a[s].visible&&(\"mousedown\"===o&&a[s]._activate.call(a[s],i),a[s].offset=a[s].element.offset(),a[s].proportions({width:a[s].element[0].offsetWidth,height:a[s].element[0].offsetHeight}))}},drop:function(t,i){var s=!1;return e.each((e.ui.ddmanager.droppables[t.options.scope]||[]).slice(),function(){this.options&&(!this.options.disabled&&this.visible&&e.ui.intersect(t,this,this.options.tolerance,i)&&(s=this._drop.call(this,i)||s),!this.options.disabled&&this.visible&&this.accept.call(this.element[0],t.currentItem||t.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,i)))}),s},dragStart:function(t,i){t.element.parentsUntil(\"body\").bind(\"scroll.droppable\",function(){t.options.refreshPositions||e.ui.ddmanager.prepareOffsets(t,i)})},drag:function(t,i){t.options.refreshPositions&&e.ui.ddmanager.prepareOffsets(t,i),e.each(e.ui.ddmanager.droppables[t.options.scope]||[],function(){if(!this.options.disabled&&!this.greedyChild&&this.visible){var s,n,a,o=e.ui.intersect(t,this,this.options.tolerance,i),r=!o&&this.isover?\"isout\":o&&!this.isover?\"isover\":null;r&&(this.options.greedy&&(n=this.options.scope,a=this.element.parents(\":data(ui-droppable)\").filter(function(){return e(this).droppable(\"instance\").options.scope===n}),a.length&&(s=e(a[0]).droppable(\"instance\"),s.greedyChild=\"isover\"===r)),s&&\"isover\"===r&&(s.isover=!1,s.isout=!0,s._out.call(s,i)),this[r]=!0,this[\"isout\"===r?\"isover\":\"isout\"]=!1,this[\"isover\"===r?\"_over\":\"_out\"].call(this,i),s&&\"isout\"===r&&(s.isout=!1,s.isover=!0,s._over.call(s,i)))}})},dragStop:function(t,i){t.element.parentsUntil(\"body\").unbind(\"scroll.droppable\"),t.options.refreshPositions||e.ui.ddmanager.prepareOffsets(t,i)}},e.ui.droppable,e.widget(\"ui.resizable\",e.ui.mouse,{version:\"1.11.4\",widgetEventPrefix:\"resize\",options:{alsoResize:!1,animate:!1,animateDuration:\"slow\",animateEasing:\"swing\",aspectRatio:!1,autoHide:!1,containment:!1,ghost:!1,grid:!1,handles:\"e,s,se\",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_num:function(e){return parseInt(e,10)||0},_isNumber:function(e){return!isNaN(parseInt(e,10))},_hasScroll:function(t,i){if(\"hidden\"===e(t).css(\"overflow\"))return!1;var s=i&&\"left\"===i?\"scrollLeft\":\"scrollTop\",n=!1;return t[s]>0?!0:(t[s]=1,n=t[s]>0,t[s]=0,n)},_create:function(){var t,i,s,n,a,o=this,r=this.options;if(this.element.addClass(\"ui-resizable\"),e.extend(this,{_aspectRatio:!!r.aspectRatio,aspectRatio:r.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:r.helper||r.ghost||r.animate?r.helper||\"ui-resizable-helper\":null}),this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)&&(this.element.wrap(e(\"<div class='ui-wrapper' style='overflow: hidden;'></div>\").css({position:this.element.css(\"position\"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css(\"top\"),left:this.element.css(\"left\")})),this.element=this.element.parent().data(\"ui-resizable\",this.element.resizable(\"instance\")),this.elementIsWrapper=!0,this.element.css({marginLeft:this.originalElement.css(\"marginLeft\"),marginTop:this.originalElement.css(\"marginTop\"),marginRight:this.originalElement.css(\"marginRight\"),marginBottom:this.originalElement.css(\"marginBottom\")}),this.originalElement.css({marginLeft:0,marginTop:0,marginRight:0,marginBottom:0}),this.originalResizeStyle=this.originalElement.css(\"resize\"),this.originalElement.css(\"resize\",\"none\"),this._proportionallyResizeElements.push(this.originalElement.css({position:\"static\",zoom:1,display:\"block\"})),this.originalElement.css({margin:this.originalElement.css(\"margin\")}),this._proportionallyResize()),this.handles=r.handles||(e(\".ui-resizable-handle\",this.element).length?{n:\".ui-resizable-n\",e:\".ui-resizable-e\",s:\".ui-resizable-s\",w:\".ui-resizable-w\",se:\".ui-resizable-se\",sw:\".ui-resizable-sw\",ne:\".ui-resizable-ne\",nw:\".ui-resizable-nw\"}:\"e,s,se\"),this._handles=e(),this.handles.constructor===String)for(\"all\"===this.handles&&(this.handles=\"n,e,s,w,se,sw,ne,nw\"),t=this.handles.split(\",\"),this.handles={},i=0;t.length>i;i++)s=e.trim(t[i]),a=\"ui-resizable-\"+s,n=e(\"<div class='ui-resizable-handle \"+a+\"'></div>\"),n.css({zIndex:r.zIndex}),\"se\"===s&&n.addClass(\"ui-icon ui-icon-gripsmall-diagonal-se\"),this.handles[s]=\".ui-resizable-\"+s,this.element.append(n);this._renderAxis=function(t){var i,s,n,a;t=t||this.element;for(i in this.handles)this.handles[i].constructor===String?this.handles[i]=this.element.children(this.handles[i]).first().show():(this.handles[i].jquery||this.handles[i].nodeType)&&(this.handles[i]=e(this.handles[i]),this._on(this.handles[i],{mousedown:o._mouseDown})),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)&&(s=e(this.handles[i],this.element),a=/sw|ne|nw|se|n|s/.test(i)?s.outerHeight():s.outerWidth(),n=[\"padding\",/ne|nw|n/.test(i)?\"Top\":/se|sw|s/.test(i)?\"Bottom\":/^e$/.test(i)?\"Right\":\"Left\"].join(\"\"),t.css(n,a),this._proportionallyResize()),this._handles=this._handles.add(this.handles[i])},this._renderAxis(this.element),this._handles=this._handles.add(this.element.find(\".ui-resizable-handle\")),this._handles.disableSelection(),this._handles.mouseover(function(){o.resizing||(this.className&&(n=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),o.axis=n&&n[1]?n[1]:\"se\")}),r.autoHide&&(this._handles.hide(),e(this.element).addClass(\"ui-resizable-autohide\").mouseenter(function(){r.disabled||(e(this).removeClass(\"ui-resizable-autohide\"),o._handles.show())}).mouseleave(function(){r.disabled||o.resizing||(e(this).addClass(\"ui-resizable-autohide\"),o._handles.hide())})),this._mouseInit()},_destroy:function(){this._mouseDestroy();var t,i=function(t){e(t).removeClass(\"ui-resizable ui-resizable-disabled ui-resizable-resizing\").removeData(\"resizable\").removeData(\"ui-resizable\").unbind(\".resizable\").find(\".ui-resizable-handle\").remove()};return this.elementIsWrapper&&(i(this.element),t=this.element,this.originalElement.css({position:t.css(\"position\"),width:t.outerWidth(),height:t.outerHeight(),top:t.css(\"top\"),left:t.css(\"left\")}).insertAfter(t),t.remove()),this.originalElement.css(\"resize\",this.originalResizeStyle),i(this.originalElement),this},_mouseCapture:function(t){var i,s,n=!1;for(i in this.handles)s=e(this.handles[i])[0],(s===t.target||e.contains(s,t.target))&&(n=!0);return!this.options.disabled&&n},_mouseStart:function(t){var i,s,n,a=this.options,o=this.element;return this.resizing=!0,this._renderProxy(),i=this._num(this.helper.css(\"left\")),s=this._num(this.helper.css(\"top\")),a.containment&&(i+=e(a.containment).scrollLeft()||0,s+=e(a.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:i,top:s},this.size=this._helper?{width:this.helper.width(),height:this.helper.height()}:{width:o.width(),height:o.height()},this.originalSize=this._helper?{width:o.outerWidth(),height:o.outerHeight()}:{width:o.width(),height:o.height()},this.sizeDiff={width:o.outerWidth()-o.width(),height:o.outerHeight()-o.height()},this.originalPosition={left:i,top:s},this.originalMousePosition={left:t.pageX,top:t.pageY},this.aspectRatio=\"number\"==typeof a.aspectRatio?a.aspectRatio:this.originalSize.width/this.originalSize.height||1,n=e(\".ui-resizable-\"+this.axis).css(\"cursor\"),e(\"body\").css(\"cursor\",\"auto\"===n?this.axis+\"-resize\":n),o.addClass(\"ui-resizable-resizing\"),this._propagate(\"start\",t),!0},_mouseDrag:function(t){var i,s,n=this.originalMousePosition,a=this.axis,o=t.pageX-n.left||0,r=t.pageY-n.top||0,h=this._change[a];return this._updatePrevProperties(),h?(i=h.apply(this,[t,o,r]),this._updateVirtualBoundaries(t.shiftKey),(this._aspectRatio||t.shiftKey)&&(i=this._updateRatio(i,t)),i=this._respectSize(i,t),this._updateCache(i),this._propagate(\"resize\",t),s=this._applyChanges(),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),e.isEmptyObject(s)||(this._updatePrevProperties(),this._trigger(\"resize\",t,this.ui()),this._applyChanges()),!1):!1},_mouseStop:function(t){this.resizing=!1;var i,s,n,a,o,r,h,l=this.options,u=this;return this._helper&&(i=this._proportionallyResizeElements,s=i.length&&/textarea/i.test(i[0].nodeName),n=s&&this._hasScroll(i[0],\"left\")?0:u.sizeDiff.height,a=s?0:u.sizeDiff.width,o={width:u.helper.width()-a,height:u.helper.height()-n},r=parseInt(u.element.css(\"left\"),10)+(u.position.left-u.originalPosition.left)||null,h=parseInt(u.element.css(\"top\"),10)+(u.position.top-u.originalPosition.top)||null,l.animate||this.element.css(e.extend(o,{top:h,left:r})),u.helper.height(u.size.height),u.helper.width(u.size.width),this._helper&&!l.animate&&this._proportionallyResize()),e(\"body\").css(\"cursor\",\"auto\"),this.element.removeClass(\"ui-resizable-resizing\"),this._propagate(\"stop\",t),this._helper&&this.helper.remove(),!1},_updatePrevProperties:function(){this.prevPosition={top:this.position.top,left:this.position.left},this.prevSize={width:this.size.width,height:this.size.height}},_applyChanges:function(){var e={};return this.position.top!==this.prevPosition.top&&(e.top=this.position.top+\"px\"),this.position.left!==this.prevPosition.left&&(e.left=this.position.left+\"px\"),this.size.width!==this.prevSize.width&&(e.width=this.size.width+\"px\"),this.size.height!==this.prevSize.height&&(e.height=this.size.height+\"px\"),this.helper.css(e),e},_updateVirtualBoundaries:function(e){var t,i,s,n,a,o=this.options;a={minWidth:this._isNumber(o.minWidth)?o.minWidth:0,maxWidth:this._isNumber(o.maxWidth)?o.maxWidth:1/0,minHeight:this._isNumber(o.minHeight)?o.minHeight:0,maxHeight:this._isNumber(o.maxHeight)?o.maxHeight:1/0},(this._aspectRatio||e)&&(t=a.minHeight*this.aspectRatio,s=a.minWidth/this.aspectRatio,i=a.maxHeight*this.aspectRatio,n=a.maxWidth/this.aspectRatio,t>a.minWidth&&(a.minWidth=t),s>a.minHeight&&(a.minHeight=s),a.maxWidth>i&&(a.maxWidth=i),a.maxHeight>n&&(a.maxHeight=n)),this._vBoundaries=a},_updateCache:function(e){this.offset=this.helper.offset(),this._isNumber(e.left)&&(this.position.left=e.left),this._isNumber(e.top)&&(this.position.top=e.top),this._isNumber(e.height)&&(this.size.height=e.height),this._isNumber(e.width)&&(this.size.width=e.width)},_updateRatio:function(e){var t=this.position,i=this.size,s=this.axis;return this._isNumber(e.height)?e.width=e.height*this.aspectRatio:this._isNumber(e.width)&&(e.height=e.width/this.aspectRatio),\"sw\"===s&&(e.left=t.left+(i.width-e.width),e.top=null),\"nw\"===s&&(e.top=t.top+(i.height-e.height),e.left=t.left+(i.width-e.width)),e},_respectSize:function(e){var t=this._vBoundaries,i=this.axis,s=this._isNumber(e.width)&&t.maxWidth&&t.maxWidth<e.width,n=this._isNumber(e.height)&&t.maxHeight&&t.maxHeight<e.height,a=this._isNumber(e.width)&&t.minWidth&&t.minWidth>e.width,o=this._isNumber(e.height)&&t.minHeight&&t.minHeight>e.height,r=this.originalPosition.left+this.originalSize.width,h=this.position.top+this.size.height,l=/sw|nw|w/.test(i),u=/nw|ne|n/.test(i);return a&&(e.width=t.minWidth),o&&(e.height=t.minHeight),s&&(e.width=t.maxWidth),n&&(e.height=t.maxHeight),a&&l&&(e.left=r-t.minWidth),s&&l&&(e.left=r-t.maxWidth),o&&u&&(e.top=h-t.minHeight),n&&u&&(e.top=h-t.maxHeight),e.width||e.height||e.left||!e.top?e.width||e.height||e.top||!e.left||(e.left=null):e.top=null,e},_getPaddingPlusBorderDimensions:function(e){for(var t=0,i=[],s=[e.css(\"borderTopWidth\"),e.css(\"borderRightWidth\"),e.css(\"borderBottomWidth\"),e.css(\"borderLeftWidth\")],n=[e.css(\"paddingTop\"),e.css(\"paddingRight\"),e.css(\"paddingBottom\"),e.css(\"paddingLeft\")];4>t;t++)i[t]=parseInt(s[t],10)||0,i[t]+=parseInt(n[t],10)||0;return{height:i[0]+i[2],width:i[1]+i[3]}},_proportionallyResize:function(){if(this._proportionallyResizeElements.length)for(var e,t=0,i=this.helper||this.element;this._proportionallyResizeElements.length>t;t++)e=this._proportionallyResizeElements[t],this.outerDimensions||(this.outerDimensions=this._getPaddingPlusBorderDimensions(e)),e.css({height:i.height()-this.outerDimensions.height||0,width:i.width()-this.outerDimensions.width||0})},_renderProxy:function(){var t=this.element,i=this.options;this.elementOffset=t.offset(),this._helper?(this.helper=this.helper||e(\"<div style='overflow:hidden;'></div>\"),this.helper.addClass(this._helper).css({width:this.element.outerWidth()-1,height:this.element.outerHeight()-1,position:\"absolute\",left:this.elementOffset.left+\"px\",top:this.elementOffset.top+\"px\",zIndex:++i.zIndex}),this.helper.appendTo(\"body\").disableSelection()):this.helper=this.element},_change:{e:function(e,t){return{width:this.originalSize.width+t}},w:function(e,t){var i=this.originalSize,s=this.originalPosition;return{left:s.left+t,width:i.width-t}},n:function(e,t,i){var s=this.originalSize,n=this.originalPosition;return{top:n.top+i,height:s.height-i}},s:function(e,t,i){return{height:this.originalSize.height+i}},se:function(t,i,s){return e.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[t,i,s]))},sw:function(t,i,s){return e.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[t,i,s]))},ne:function(t,i,s){return e.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[t,i,s]))},nw:function(t,i,s){return e.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[t,i,s]))}},_propagate:function(t,i){e.ui.plugin.call(this,t,[i,this.ui()]),\"resize\"!==t&&this._trigger(t,i,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),e.ui.plugin.add(\"resizable\",\"animate\",{stop:function(t){var i=e(this).resizable(\"instance\"),s=i.options,n=i._proportionallyResizeElements,a=n.length&&/textarea/i.test(n[0].nodeName),o=a&&i._hasScroll(n[0],\"left\")?0:i.sizeDiff.height,r=a?0:i.sizeDiff.width,h={width:i.size.width-r,height:i.size.height-o},l=parseInt(i.element.css(\"left\"),10)+(i.position.left-i.originalPosition.left)||null,u=parseInt(i.element.css(\"top\"),10)+(i.position.top-i.originalPosition.top)||null;i.element.animate(e.extend(h,u&&l?{top:u,left:l}:{}),{duration:s.animateDuration,easing:s.animateEasing,step:function(){var s={width:parseInt(i.element.css(\"width\"),10),height:parseInt(i.element.css(\"height\"),10),top:parseInt(i.element.css(\"top\"),10),left:parseInt(i.element.css(\"left\"),10)};n&&n.length&&e(n[0]).css({width:s.width,height:s.height}),i._updateCache(s),i._propagate(\"resize\",t)}})}}),e.ui.plugin.add(\"resizable\",\"containment\",{start:function(){var t,i,s,n,a,o,r,h=e(this).resizable(\"instance\"),l=h.options,u=h.element,d=l.containment,c=d instanceof e?d.get(0):/parent/.test(d)?u.parent().get(0):d;c&&(h.containerElement=e(c),/document/.test(d)||d===document?(h.containerOffset={left:0,top:0},h.containerPosition={left:0,top:0},h.parentData={element:e(document),left:0,top:0,width:e(document).width(),height:e(document).height()||document.body.parentNode.scrollHeight}):(t=e(c),i=[],e([\"Top\",\"Right\",\"Left\",\"Bottom\"]).each(function(e,s){i[e]=h._num(t.css(\"padding\"+s))}),h.containerOffset=t.offset(),h.containerPosition=t.position(),h.containerSize={height:t.innerHeight()-i[3],width:t.innerWidth()-i[1]},s=h.containerOffset,n=h.containerSize.height,a=h.containerSize.width,o=h._hasScroll(c,\"left\")?c.scrollWidth:a,r=h._hasScroll(c)?c.scrollHeight:n,h.parentData={element:c,left:s.left,top:s.top,width:o,height:r}))},resize:function(t){var i,s,n,a,o=e(this).resizable(\"instance\"),r=o.options,h=o.containerOffset,l=o.position,u=o._aspectRatio||t.shiftKey,d={top:0,left:0},c=o.containerElement,p=!0;c[0]!==document&&/static/.test(c.css(\"position\"))&&(d=h),l.left<(o._helper?h.left:0)&&(o.size.width=o.size.width+(o._helper?o.position.left-h.left:o.position.left-d.left),u&&(o.size.height=o.size.width/o.aspectRatio,p=!1),o.position.left=r.helper?h.left:0),l.top<(o._helper?h.top:0)&&(o.size.height=o.size.height+(o._helper?o.position.top-h.top:o.position.top),u&&(o.size.width=o.size.height*o.aspectRatio,p=!1),o.position.top=o._helper?h.top:0),n=o.containerElement.get(0)===o.element.parent().get(0),a=/relative|absolute/.test(o.containerElement.css(\"position\")),n&&a?(o.offset.left=o.parentData.left+o.position.left,o.offset.top=o.parentData.top+o.position.top):(o.offset.left=o.element.offset().left,o.offset.top=o.element.offset().top),i=Math.abs(o.sizeDiff.width+(o._helper?o.offset.left-d.left:o.offset.left-h.left)),s=Math.abs(o.sizeDiff.height+(o._helper?o.offset.top-d.top:o.offset.top-h.top)),i+o.size.width>=o.parentData.width&&(o.size.width=o.parentData.width-i,u&&(o.size.height=o.size.width/o.aspectRatio,p=!1)),s+o.size.height>=o.parentData.height&&(o.size.height=o.parentData.height-s,u&&(o.size.width=o.size.height*o.aspectRatio,p=!1)),p||(o.position.left=o.prevPosition.left,o.position.top=o.prevPosition.top,o.size.width=o.prevSize.width,o.size.height=o.prevSize.height)},stop:function(){var t=e(this).resizable(\"instance\"),i=t.options,s=t.containerOffset,n=t.containerPosition,a=t.containerElement,o=e(t.helper),r=o.offset(),h=o.outerWidth()-t.sizeDiff.width,l=o.outerHeight()-t.sizeDiff.height;t._helper&&!i.animate&&/relative/.test(a.css(\"position\"))&&e(this).css({left:r.left-n.left-s.left,width:h,height:l}),t._helper&&!i.animate&&/static/.test(a.css(\"position\"))&&e(this).css({left:r.left-n.left-s.left,width:h,height:l})}}),e.ui.plugin.add(\"resizable\",\"alsoResize\",{start:function(){var t=e(this).resizable(\"instance\"),i=t.options;e(i.alsoResize).each(function(){var t=e(this);t.data(\"ui-resizable-alsoresize\",{width:parseInt(t.width(),10),height:parseInt(t.height(),10),left:parseInt(t.css(\"left\"),10),top:parseInt(t.css(\"top\"),10)})})},resize:function(t,i){var s=e(this).resizable(\"instance\"),n=s.options,a=s.originalSize,o=s.originalPosition,r={height:s.size.height-a.height||0,width:s.size.width-a.width||0,top:s.position.top-o.top||0,left:s.position.left-o.left||0};e(n.alsoResize).each(function(){var t=e(this),s=e(this).data(\"ui-resizable-alsoresize\"),n={},a=t.parents(i.originalElement[0]).length?[\"width\",\"height\"]:[\"width\",\"height\",\"top\",\"left\"];e.each(a,function(e,t){var i=(s[t]||0)+(r[t]||0);i&&i>=0&&(n[t]=i||null)}),t.css(n)})},stop:function(){e(this).removeData(\"resizable-alsoresize\")}}),e.ui.plugin.add(\"resizable\",\"ghost\",{start:function(){var t=e(this).resizable(\"instance\"),i=t.options,s=t.size;t.ghost=t.originalElement.clone(),t.ghost.css({opacity:.25,display:\"block\",position:\"relative\",height:s.height,width:s.width,margin:0,left:0,top:0}).addClass(\"ui-resizable-ghost\").addClass(\"string\"==typeof i.ghost?i.ghost:\"\"),t.ghost.appendTo(t.helper)},resize:function(){var t=e(this).resizable(\"instance\");t.ghost&&t.ghost.css({position:\"relative\",height:t.size.height,width:t.size.width})},stop:function(){var t=e(this).resizable(\"instance\");t.ghost&&t.helper&&t.helper.get(0).removeChild(t.ghost.get(0))}}),e.ui.plugin.add(\"resizable\",\"grid\",{resize:function(){var t,i=e(this).resizable(\"instance\"),s=i.options,n=i.size,a=i.originalSize,o=i.originalPosition,r=i.axis,h=\"number\"==typeof s.grid?[s.grid,s.grid]:s.grid,l=h[0]||1,u=h[1]||1,d=Math.round((n.width-a.width)/l)*l,c=Math.round((n.height-a.height)/u)*u,p=a.width+d,f=a.height+c,m=s.maxWidth&&p>s.maxWidth,g=s.maxHeight&&f>s.maxHeight,v=s.minWidth&&s.minWidth>p,y=s.minHeight&&s.minHeight>f;s.grid=h,v&&(p+=l),y&&(f+=u),m&&(p-=l),g&&(f-=u),/^(se|s|e)$/.test(r)?(i.size.width=p,i.size.height=f):/^(ne)$/.test(r)?(i.size.width=p,i.size.height=f,i.position.top=o.top-c):/^(sw)$/.test(r)?(i.size.width=p,i.size.height=f,i.position.left=o.left-d):((0>=f-u||0>=p-l)&&(t=i._getPaddingPlusBorderDimensions(this)),f-u>0?(i.size.height=f,i.position.top=o.top-c):(f=u-t.height,i.size.height=f,i.position.top=o.top+a.height-f),p-l>0?(i.size.width=p,i.position.left=o.left-d):(p=l-t.width,i.size.width=p,i.position.left=o.left+a.width-p))}}),e.ui.resizable,e.widget(\"ui.selectable\",e.ui.mouse,{version:\"1.11.4\",options:{appendTo:\"body\",autoRefresh:!0,distance:0,filter:\"*\",tolerance:\"touch\",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var t,i=this;\nthis.element.addClass(\"ui-selectable\"),this.dragged=!1,this.refresh=function(){t=e(i.options.filter,i.element[0]),t.addClass(\"ui-selectee\"),t.each(function(){var t=e(this),i=t.offset();e.data(this,\"selectable-item\",{element:this,$element:t,left:i.left,top:i.top,right:i.left+t.outerWidth(),bottom:i.top+t.outerHeight(),startselected:!1,selected:t.hasClass(\"ui-selected\"),selecting:t.hasClass(\"ui-selecting\"),unselecting:t.hasClass(\"ui-unselecting\")})})},this.refresh(),this.selectees=t.addClass(\"ui-selectee\"),this._mouseInit(),this.helper=e(\"<div class='ui-selectable-helper'></div>\")},_destroy:function(){this.selectees.removeClass(\"ui-selectee\").removeData(\"selectable-item\"),this.element.removeClass(\"ui-selectable ui-selectable-disabled\"),this._mouseDestroy()},_mouseStart:function(t){var i=this,s=this.options;this.opos=[t.pageX,t.pageY],this.options.disabled||(this.selectees=e(s.filter,this.element[0]),this._trigger(\"start\",t),e(s.appendTo).append(this.helper),this.helper.css({left:t.pageX,top:t.pageY,width:0,height:0}),s.autoRefresh&&this.refresh(),this.selectees.filter(\".ui-selected\").each(function(){var s=e.data(this,\"selectable-item\");s.startselected=!0,t.metaKey||t.ctrlKey||(s.$element.removeClass(\"ui-selected\"),s.selected=!1,s.$element.addClass(\"ui-unselecting\"),s.unselecting=!0,i._trigger(\"unselecting\",t,{unselecting:s.element}))}),e(t.target).parents().addBack().each(function(){var s,n=e.data(this,\"selectable-item\");return n?(s=!t.metaKey&&!t.ctrlKey||!n.$element.hasClass(\"ui-selected\"),n.$element.removeClass(s?\"ui-unselecting\":\"ui-selected\").addClass(s?\"ui-selecting\":\"ui-unselecting\"),n.unselecting=!s,n.selecting=s,n.selected=s,s?i._trigger(\"selecting\",t,{selecting:n.element}):i._trigger(\"unselecting\",t,{unselecting:n.element}),!1):void 0}))},_mouseDrag:function(t){if(this.dragged=!0,!this.options.disabled){var i,s=this,n=this.options,a=this.opos[0],o=this.opos[1],r=t.pageX,h=t.pageY;return a>r&&(i=r,r=a,a=i),o>h&&(i=h,h=o,o=i),this.helper.css({left:a,top:o,width:r-a,height:h-o}),this.selectees.each(function(){var i=e.data(this,\"selectable-item\"),l=!1;i&&i.element!==s.element[0]&&(\"touch\"===n.tolerance?l=!(i.left>r||a>i.right||i.top>h||o>i.bottom):\"fit\"===n.tolerance&&(l=i.left>a&&r>i.right&&i.top>o&&h>i.bottom),l?(i.selected&&(i.$element.removeClass(\"ui-selected\"),i.selected=!1),i.unselecting&&(i.$element.removeClass(\"ui-unselecting\"),i.unselecting=!1),i.selecting||(i.$element.addClass(\"ui-selecting\"),i.selecting=!0,s._trigger(\"selecting\",t,{selecting:i.element}))):(i.selecting&&((t.metaKey||t.ctrlKey)&&i.startselected?(i.$element.removeClass(\"ui-selecting\"),i.selecting=!1,i.$element.addClass(\"ui-selected\"),i.selected=!0):(i.$element.removeClass(\"ui-selecting\"),i.selecting=!1,i.startselected&&(i.$element.addClass(\"ui-unselecting\"),i.unselecting=!0),s._trigger(\"unselecting\",t,{unselecting:i.element}))),i.selected&&(t.metaKey||t.ctrlKey||i.startselected||(i.$element.removeClass(\"ui-selected\"),i.selected=!1,i.$element.addClass(\"ui-unselecting\"),i.unselecting=!0,s._trigger(\"unselecting\",t,{unselecting:i.element})))))}),!1}},_mouseStop:function(t){var i=this;return this.dragged=!1,e(\".ui-unselecting\",this.element[0]).each(function(){var s=e.data(this,\"selectable-item\");s.$element.removeClass(\"ui-unselecting\"),s.unselecting=!1,s.startselected=!1,i._trigger(\"unselected\",t,{unselected:s.element})}),e(\".ui-selecting\",this.element[0]).each(function(){var s=e.data(this,\"selectable-item\");s.$element.removeClass(\"ui-selecting\").addClass(\"ui-selected\"),s.selecting=!1,s.selected=!0,s.startselected=!0,i._trigger(\"selected\",t,{selected:s.element})}),this._trigger(\"stop\",t),this.helper.remove(),!1}}),e.widget(\"ui.sortable\",e.ui.mouse,{version:\"1.11.4\",widgetEventPrefix:\"sort\",ready:!1,options:{appendTo:\"parent\",axis:!1,connectWith:!1,containment:!1,cursor:\"auto\",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:\"original\",items:\"> *\",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:\"default\",tolerance:\"intersect\",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_isOverAxis:function(e,t,i){return e>=t&&t+i>e},_isFloating:function(e){return/left|right/.test(e.css(\"float\"))||/inline|table-cell/.test(e.css(\"display\"))},_create:function(){this.containerCache={},this.element.addClass(\"ui-sortable\"),this.refresh(),this.offset=this.element.offset(),this._mouseInit(),this._setHandleClassName(),this.ready=!0},_setOption:function(e,t){this._super(e,t),\"handle\"===e&&this._setHandleClassName()},_setHandleClassName:function(){this.element.find(\".ui-sortable-handle\").removeClass(\"ui-sortable-handle\"),e.each(this.items,function(){(this.instance.options.handle?this.item.find(this.instance.options.handle):this.item).addClass(\"ui-sortable-handle\")})},_destroy:function(){this.element.removeClass(\"ui-sortable ui-sortable-disabled\").find(\".ui-sortable-handle\").removeClass(\"ui-sortable-handle\"),this._mouseDestroy();for(var e=this.items.length-1;e>=0;e--)this.items[e].item.removeData(this.widgetName+\"-item\");return this},_mouseCapture:function(t,i){var s=null,n=!1,a=this;return this.reverting?!1:this.options.disabled||\"static\"===this.options.type?!1:(this._refreshItems(t),e(t.target).parents().each(function(){return e.data(this,a.widgetName+\"-item\")===a?(s=e(this),!1):void 0}),e.data(t.target,a.widgetName+\"-item\")===a&&(s=e(t.target)),s?!this.options.handle||i||(e(this.options.handle,s).find(\"*\").addBack().each(function(){this===t.target&&(n=!0)}),n)?(this.currentItem=s,this._removeCurrentsFromItems(),!0):!1:!1)},_mouseStart:function(t,i,s){var n,a,o=this.options;if(this.currentContainer=this,this.refreshPositions(),this.helper=this._createHelper(t),this._cacheHelperProportions(),this._cacheMargins(),this.scrollParent=this.helper.scrollParent(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},e.extend(this.offset,{click:{left:t.pageX-this.offset.left,top:t.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.helper.css(\"position\",\"absolute\"),this.cssPosition=this.helper.css(\"position\"),this.originalPosition=this._generatePosition(t),this.originalPageX=t.pageX,this.originalPageY=t.pageY,o.cursorAt&&this._adjustOffsetFromHelper(o.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),o.containment&&this._setContainment(),o.cursor&&\"auto\"!==o.cursor&&(a=this.document.find(\"body\"),this.storedCursor=a.css(\"cursor\"),a.css(\"cursor\",o.cursor),this.storedStylesheet=e(\"<style>*{ cursor: \"+o.cursor+\" !important; }</style>\").appendTo(a)),o.opacity&&(this.helper.css(\"opacity\")&&(this._storedOpacity=this.helper.css(\"opacity\")),this.helper.css(\"opacity\",o.opacity)),o.zIndex&&(this.helper.css(\"zIndex\")&&(this._storedZIndex=this.helper.css(\"zIndex\")),this.helper.css(\"zIndex\",o.zIndex)),this.scrollParent[0]!==this.document[0]&&\"HTML\"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger(\"start\",t,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!s)for(n=this.containers.length-1;n>=0;n--)this.containers[n]._trigger(\"activate\",t,this._uiHash(this));return e.ui.ddmanager&&(e.ui.ddmanager.current=this),e.ui.ddmanager&&!o.dropBehaviour&&e.ui.ddmanager.prepareOffsets(this,t),this.dragging=!0,this.helper.addClass(\"ui-sortable-helper\"),this._mouseDrag(t),!0},_mouseDrag:function(t){var i,s,n,a,o=this.options,r=!1;for(this.position=this._generatePosition(t),this.positionAbs=this._convertPositionTo(\"absolute\"),this.lastPositionAbs||(this.lastPositionAbs=this.positionAbs),this.options.scroll&&(this.scrollParent[0]!==this.document[0]&&\"HTML\"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-t.pageY<o.scrollSensitivity?this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop+o.scrollSpeed:t.pageY-this.overflowOffset.top<o.scrollSensitivity&&(this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop-o.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-t.pageX<o.scrollSensitivity?this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft+o.scrollSpeed:t.pageX-this.overflowOffset.left<o.scrollSensitivity&&(this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft-o.scrollSpeed)):(t.pageY-this.document.scrollTop()<o.scrollSensitivity?r=this.document.scrollTop(this.document.scrollTop()-o.scrollSpeed):this.window.height()-(t.pageY-this.document.scrollTop())<o.scrollSensitivity&&(r=this.document.scrollTop(this.document.scrollTop()+o.scrollSpeed)),t.pageX-this.document.scrollLeft()<o.scrollSensitivity?r=this.document.scrollLeft(this.document.scrollLeft()-o.scrollSpeed):this.window.width()-(t.pageX-this.document.scrollLeft())<o.scrollSensitivity&&(r=this.document.scrollLeft(this.document.scrollLeft()+o.scrollSpeed))),r!==!1&&e.ui.ddmanager&&!o.dropBehaviour&&e.ui.ddmanager.prepareOffsets(this,t)),this.positionAbs=this._convertPositionTo(\"absolute\"),this.options.axis&&\"y\"===this.options.axis||(this.helper[0].style.left=this.position.left+\"px\"),this.options.axis&&\"x\"===this.options.axis||(this.helper[0].style.top=this.position.top+\"px\"),i=this.items.length-1;i>=0;i--)if(s=this.items[i],n=s.item[0],a=this._intersectsWithPointer(s),a&&s.instance===this.currentContainer&&n!==this.currentItem[0]&&this.placeholder[1===a?\"next\":\"prev\"]()[0]!==n&&!e.contains(this.placeholder[0],n)&&(\"semi-dynamic\"===this.options.type?!e.contains(this.element[0],n):!0)){if(this.direction=1===a?\"down\":\"up\",\"pointer\"!==this.options.tolerance&&!this._intersectsWithSides(s))break;this._rearrange(t,s),this._trigger(\"change\",t,this._uiHash());break}return this._contactContainers(t),e.ui.ddmanager&&e.ui.ddmanager.drag(this,t),this._trigger(\"sort\",t,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(t,i){if(t){if(e.ui.ddmanager&&!this.options.dropBehaviour&&e.ui.ddmanager.drop(this,t),this.options.revert){var s=this,n=this.placeholder.offset(),a=this.options.axis,o={};a&&\"x\"!==a||(o.left=n.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollLeft)),a&&\"y\"!==a||(o.top=n.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,e(this.helper).animate(o,parseInt(this.options.revert,10)||500,function(){s._clear(t)})}else this._clear(t,i);return!1}},cancel:function(){if(this.dragging){this._mouseUp({target:null}),\"original\"===this.options.helper?this.currentItem.css(this._storedCSS).removeClass(\"ui-sortable-helper\"):this.currentItem.show();for(var t=this.containers.length-1;t>=0;t--)this.containers[t]._trigger(\"deactivate\",null,this._uiHash(this)),this.containers[t].containerCache.over&&(this.containers[t]._trigger(\"out\",null,this._uiHash(this)),this.containers[t].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),\"original\"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),e.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?e(this.domPosition.prev).after(this.currentItem):e(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(t){var i=this._getItemsAsjQuery(t&&t.connected),s=[];return t=t||{},e(i).each(function(){var i=(e(t.item||this).attr(t.attribute||\"id\")||\"\").match(t.expression||/(.+)[\\-=_](.+)/);i&&s.push((t.key||i[1]+\"[]\")+\"=\"+(t.key&&t.expression?i[1]:i[2]))}),!s.length&&t.key&&s.push(t.key+\"=\"),s.join(\"&\")},toArray:function(t){var i=this._getItemsAsjQuery(t&&t.connected),s=[];return t=t||{},i.each(function(){s.push(e(t.item||this).attr(t.attribute||\"id\")||\"\")}),s},_intersectsWith:function(e){var t=this.positionAbs.left,i=t+this.helperProportions.width,s=this.positionAbs.top,n=s+this.helperProportions.height,a=e.left,o=a+e.width,r=e.top,h=r+e.height,l=this.offset.click.top,u=this.offset.click.left,d=\"x\"===this.options.axis||s+l>r&&h>s+l,c=\"y\"===this.options.axis||t+u>a&&o>t+u,p=d&&c;return\"pointer\"===this.options.tolerance||this.options.forcePointerForContainers||\"pointer\"!==this.options.tolerance&&this.helperProportions[this.floating?\"width\":\"height\"]>e[this.floating?\"width\":\"height\"]?p:t+this.helperProportions.width/2>a&&o>i-this.helperProportions.width/2&&s+this.helperProportions.height/2>r&&h>n-this.helperProportions.height/2},_intersectsWithPointer:function(e){var t=\"x\"===this.options.axis||this._isOverAxis(this.positionAbs.top+this.offset.click.top,e.top,e.height),i=\"y\"===this.options.axis||this._isOverAxis(this.positionAbs.left+this.offset.click.left,e.left,e.width),s=t&&i,n=this._getDragVerticalDirection(),a=this._getDragHorizontalDirection();return s?this.floating?a&&\"right\"===a||\"down\"===n?2:1:n&&(\"down\"===n?2:1):!1},_intersectsWithSides:function(e){var t=this._isOverAxis(this.positionAbs.top+this.offset.click.top,e.top+e.height/2,e.height),i=this._isOverAxis(this.positionAbs.left+this.offset.click.left,e.left+e.width/2,e.width),s=this._getDragVerticalDirection(),n=this._getDragHorizontalDirection();return this.floating&&n?\"right\"===n&&i||\"left\"===n&&!i:s&&(\"down\"===s&&t||\"up\"===s&&!t)},_getDragVerticalDirection:function(){var e=this.positionAbs.top-this.lastPositionAbs.top;return 0!==e&&(e>0?\"down\":\"up\")},_getDragHorizontalDirection:function(){var e=this.positionAbs.left-this.lastPositionAbs.left;return 0!==e&&(e>0?\"right\":\"left\")},refresh:function(e){return this._refreshItems(e),this._setHandleClassName(),this.refreshPositions(),this},_connectWith:function(){var e=this.options;return e.connectWith.constructor===String?[e.connectWith]:e.connectWith},_getItemsAsjQuery:function(t){function i(){r.push(this)}var s,n,a,o,r=[],h=[],l=this._connectWith();if(l&&t)for(s=l.length-1;s>=0;s--)for(a=e(l[s],this.document[0]),n=a.length-1;n>=0;n--)o=e.data(a[n],this.widgetFullName),o&&o!==this&&!o.options.disabled&&h.push([e.isFunction(o.options.items)?o.options.items.call(o.element):e(o.options.items,o.element).not(\".ui-sortable-helper\").not(\".ui-sortable-placeholder\"),o]);for(h.push([e.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):e(this.options.items,this.element).not(\".ui-sortable-helper\").not(\".ui-sortable-placeholder\"),this]),s=h.length-1;s>=0;s--)h[s][0].each(i);return e(r)},_removeCurrentsFromItems:function(){var t=this.currentItem.find(\":data(\"+this.widgetName+\"-item)\");this.items=e.grep(this.items,function(e){for(var i=0;t.length>i;i++)if(t[i]===e.item[0])return!1;return!0})},_refreshItems:function(t){this.items=[],this.containers=[this];var i,s,n,a,o,r,h,l,u=this.items,d=[[e.isFunction(this.options.items)?this.options.items.call(this.element[0],t,{item:this.currentItem}):e(this.options.items,this.element),this]],c=this._connectWith();if(c&&this.ready)for(i=c.length-1;i>=0;i--)for(n=e(c[i],this.document[0]),s=n.length-1;s>=0;s--)a=e.data(n[s],this.widgetFullName),a&&a!==this&&!a.options.disabled&&(d.push([e.isFunction(a.options.items)?a.options.items.call(a.element[0],t,{item:this.currentItem}):e(a.options.items,a.element),a]),this.containers.push(a));for(i=d.length-1;i>=0;i--)for(o=d[i][1],r=d[i][0],s=0,l=r.length;l>s;s++)h=e(r[s]),h.data(this.widgetName+\"-item\",o),u.push({item:h,instance:o,width:0,height:0,left:0,top:0})},refreshPositions:function(t){this.floating=this.items.length?\"x\"===this.options.axis||this._isFloating(this.items[0].item):!1,this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset());var i,s,n,a;for(i=this.items.length-1;i>=0;i--)s=this.items[i],s.instance!==this.currentContainer&&this.currentContainer&&s.item[0]!==this.currentItem[0]||(n=this.options.toleranceElement?e(this.options.toleranceElement,s.item):s.item,t||(s.width=n.outerWidth(),s.height=n.outerHeight()),a=n.offset(),s.left=a.left,s.top=a.top);if(this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(i=this.containers.length-1;i>=0;i--)a=this.containers[i].element.offset(),this.containers[i].containerCache.left=a.left,this.containers[i].containerCache.top=a.top,this.containers[i].containerCache.width=this.containers[i].element.outerWidth(),this.containers[i].containerCache.height=this.containers[i].element.outerHeight();return this},_createPlaceholder:function(t){t=t||this;var i,s=t.options;s.placeholder&&s.placeholder.constructor!==String||(i=s.placeholder,s.placeholder={element:function(){var s=t.currentItem[0].nodeName.toLowerCase(),n=e(\"<\"+s+\">\",t.document[0]).addClass(i||t.currentItem[0].className+\" ui-sortable-placeholder\").removeClass(\"ui-sortable-helper\");return\"tbody\"===s?t._createTrPlaceholder(t.currentItem.find(\"tr\").eq(0),e(\"<tr>\",t.document[0]).appendTo(n)):\"tr\"===s?t._createTrPlaceholder(t.currentItem,n):\"img\"===s&&n.attr(\"src\",t.currentItem.attr(\"src\")),i||n.css(\"visibility\",\"hidden\"),n},update:function(e,n){(!i||s.forcePlaceholderSize)&&(n.height()||n.height(t.currentItem.innerHeight()-parseInt(t.currentItem.css(\"paddingTop\")||0,10)-parseInt(t.currentItem.css(\"paddingBottom\")||0,10)),n.width()||n.width(t.currentItem.innerWidth()-parseInt(t.currentItem.css(\"paddingLeft\")||0,10)-parseInt(t.currentItem.css(\"paddingRight\")||0,10)))}}),t.placeholder=e(s.placeholder.element.call(t.element,t.currentItem)),t.currentItem.after(t.placeholder),s.placeholder.update(t,t.placeholder)},_createTrPlaceholder:function(t,i){var s=this;t.children().each(function(){e(\"<td>&#160;</td>\",s.document[0]).attr(\"colspan\",e(this).attr(\"colspan\")||1).appendTo(i)})},_contactContainers:function(t){var i,s,n,a,o,r,h,l,u,d,c=null,p=null;for(i=this.containers.length-1;i>=0;i--)if(!e.contains(this.currentItem[0],this.containers[i].element[0]))if(this._intersectsWith(this.containers[i].containerCache)){if(c&&e.contains(this.containers[i].element[0],c.element[0]))continue;c=this.containers[i],p=i}else this.containers[i].containerCache.over&&(this.containers[i]._trigger(\"out\",t,this._uiHash(this)),this.containers[i].containerCache.over=0);if(c)if(1===this.containers.length)this.containers[p].containerCache.over||(this.containers[p]._trigger(\"over\",t,this._uiHash(this)),this.containers[p].containerCache.over=1);else{for(n=1e4,a=null,u=c.floating||this._isFloating(this.currentItem),o=u?\"left\":\"top\",r=u?\"width\":\"height\",d=u?\"clientX\":\"clientY\",s=this.items.length-1;s>=0;s--)e.contains(this.containers[p].element[0],this.items[s].item[0])&&this.items[s].item[0]!==this.currentItem[0]&&(h=this.items[s].item.offset()[o],l=!1,t[d]-h>this.items[s][r]/2&&(l=!0),n>Math.abs(t[d]-h)&&(n=Math.abs(t[d]-h),a=this.items[s],this.direction=l?\"up\":\"down\"));if(!a&&!this.options.dropOnEmpty)return;if(this.currentContainer===this.containers[p])return this.currentContainer.containerCache.over||(this.containers[p]._trigger(\"over\",t,this._uiHash()),this.currentContainer.containerCache.over=1),void 0;a?this._rearrange(t,a,null,!0):this._rearrange(t,null,this.containers[p].element,!0),this._trigger(\"change\",t,this._uiHash()),this.containers[p]._trigger(\"change\",t,this._uiHash(this)),this.currentContainer=this.containers[p],this.options.placeholder.update(this.currentContainer,this.placeholder),this.containers[p]._trigger(\"over\",t,this._uiHash(this)),this.containers[p].containerCache.over=1}},_createHelper:function(t){var i=this.options,s=e.isFunction(i.helper)?e(i.helper.apply(this.element[0],[t,this.currentItem])):\"clone\"===i.helper?this.currentItem.clone():this.currentItem;return s.parents(\"body\").length||e(\"parent\"!==i.appendTo?i.appendTo:this.currentItem[0].parentNode)[0].appendChild(s[0]),s[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css(\"position\"),top:this.currentItem.css(\"top\"),left:this.currentItem.css(\"left\")}),(!s[0].style.width||i.forceHelperSize)&&s.width(this.currentItem.width()),(!s[0].style.height||i.forceHelperSize)&&s.height(this.currentItem.height()),s},_adjustOffsetFromHelper:function(t){\"string\"==typeof t&&(t=t.split(\" \")),e.isArray(t)&&(t={left:+t[0],top:+t[1]||0}),\"left\"in t&&(this.offset.click.left=t.left+this.margins.left),\"right\"in t&&(this.offset.click.left=this.helperProportions.width-t.right+this.margins.left),\"top\"in t&&(this.offset.click.top=t.top+this.margins.top),\"bottom\"in t&&(this.offset.click.top=this.helperProportions.height-t.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var t=this.offsetParent.offset();return\"absolute\"===this.cssPosition&&this.scrollParent[0]!==this.document[0]&&e.contains(this.scrollParent[0],this.offsetParent[0])&&(t.left+=this.scrollParent.scrollLeft(),t.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===this.document[0].body||this.offsetParent[0].tagName&&\"html\"===this.offsetParent[0].tagName.toLowerCase()&&e.ui.ie)&&(t={top:0,left:0}),{top:t.top+(parseInt(this.offsetParent.css(\"borderTopWidth\"),10)||0),left:t.left+(parseInt(this.offsetParent.css(\"borderLeftWidth\"),10)||0)}},_getRelativeOffset:function(){if(\"relative\"===this.cssPosition){var e=this.currentItem.position();return{top:e.top-(parseInt(this.helper.css(\"top\"),10)||0)+this.scrollParent.scrollTop(),left:e.left-(parseInt(this.helper.css(\"left\"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css(\"marginLeft\"),10)||0,top:parseInt(this.currentItem.css(\"marginTop\"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var t,i,s,n=this.options;\"parent\"===n.containment&&(n.containment=this.helper[0].parentNode),(\"document\"===n.containment||\"window\"===n.containment)&&(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,\"document\"===n.containment?this.document.width():this.window.width()-this.helperProportions.width-this.margins.left,(\"document\"===n.containment?this.document.width():this.window.height()||this.document[0].body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(n.containment)||(t=e(n.containment)[0],i=e(n.containment).offset(),s=\"hidden\"!==e(t).css(\"overflow\"),this.containment=[i.left+(parseInt(e(t).css(\"borderLeftWidth\"),10)||0)+(parseInt(e(t).css(\"paddingLeft\"),10)||0)-this.margins.left,i.top+(parseInt(e(t).css(\"borderTopWidth\"),10)||0)+(parseInt(e(t).css(\"paddingTop\"),10)||0)-this.margins.top,i.left+(s?Math.max(t.scrollWidth,t.offsetWidth):t.offsetWidth)-(parseInt(e(t).css(\"borderLeftWidth\"),10)||0)-(parseInt(e(t).css(\"paddingRight\"),10)||0)-this.helperProportions.width-this.margins.left,i.top+(s?Math.max(t.scrollHeight,t.offsetHeight):t.offsetHeight)-(parseInt(e(t).css(\"borderTopWidth\"),10)||0)-(parseInt(e(t).css(\"paddingBottom\"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(t,i){i||(i=this.position);var s=\"absolute\"===t?1:-1,n=\"absolute\"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&e.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,a=/(html|body)/i.test(n[0].tagName);return{top:i.top+this.offset.relative.top*s+this.offset.parent.top*s-(\"fixed\"===this.cssPosition?-this.scrollParent.scrollTop():a?0:n.scrollTop())*s,left:i.left+this.offset.relative.left*s+this.offset.parent.left*s-(\"fixed\"===this.cssPosition?-this.scrollParent.scrollLeft():a?0:n.scrollLeft())*s}},_generatePosition:function(t){var i,s,n=this.options,a=t.pageX,o=t.pageY,r=\"absolute\"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&e.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,h=/(html|body)/i.test(r[0].tagName);return\"relative\"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(t.pageX-this.offset.click.left<this.containment[0]&&(a=this.containment[0]+this.offset.click.left),t.pageY-this.offset.click.top<this.containment[1]&&(o=this.containment[1]+this.offset.click.top),t.pageX-this.offset.click.left>this.containment[2]&&(a=this.containment[2]+this.offset.click.left),t.pageY-this.offset.click.top>this.containment[3]&&(o=this.containment[3]+this.offset.click.top)),n.grid&&(i=this.originalPageY+Math.round((o-this.originalPageY)/n.grid[1])*n.grid[1],o=this.containment?i-this.offset.click.top>=this.containment[1]&&i-this.offset.click.top<=this.containment[3]?i:i-this.offset.click.top>=this.containment[1]?i-n.grid[1]:i+n.grid[1]:i,s=this.originalPageX+Math.round((a-this.originalPageX)/n.grid[0])*n.grid[0],a=this.containment?s-this.offset.click.left>=this.containment[0]&&s-this.offset.click.left<=this.containment[2]?s:s-this.offset.click.left>=this.containment[0]?s-n.grid[0]:s+n.grid[0]:s)),{top:o-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+(\"fixed\"===this.cssPosition?-this.scrollParent.scrollTop():h?0:r.scrollTop()),left:a-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+(\"fixed\"===this.cssPosition?-this.scrollParent.scrollLeft():h?0:r.scrollLeft())}},_rearrange:function(e,t,i,s){i?i[0].appendChild(this.placeholder[0]):t.item[0].parentNode.insertBefore(this.placeholder[0],\"down\"===this.direction?t.item[0]:t.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var n=this.counter;this._delay(function(){n===this.counter&&this.refreshPositions(!s)})},_clear:function(e,t){function i(e,t,i){return function(s){i._trigger(e,s,t._uiHash(t))}}this.reverting=!1;var s,n=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(s in this._storedCSS)(\"auto\"===this._storedCSS[s]||\"static\"===this._storedCSS[s])&&(this._storedCSS[s]=\"\");this.currentItem.css(this._storedCSS).removeClass(\"ui-sortable-helper\")}else this.currentItem.show();for(this.fromOutside&&!t&&n.push(function(e){this._trigger(\"receive\",e,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(\".ui-sortable-helper\")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||t||n.push(function(e){this._trigger(\"update\",e,this._uiHash())}),this!==this.currentContainer&&(t||(n.push(function(e){this._trigger(\"remove\",e,this._uiHash())}),n.push(function(e){return function(t){e._trigger(\"receive\",t,this._uiHash(this))}}.call(this,this.currentContainer)),n.push(function(e){return function(t){e._trigger(\"update\",t,this._uiHash(this))}}.call(this,this.currentContainer)))),s=this.containers.length-1;s>=0;s--)t||n.push(i(\"deactivate\",this,this.containers[s])),this.containers[s].containerCache.over&&(n.push(i(\"out\",this,this.containers[s])),this.containers[s].containerCache.over=0);if(this.storedCursor&&(this.document.find(\"body\").css(\"cursor\",this.storedCursor),this.storedStylesheet.remove()),this._storedOpacity&&this.helper.css(\"opacity\",this._storedOpacity),this._storedZIndex&&this.helper.css(\"zIndex\",\"auto\"===this._storedZIndex?\"\":this._storedZIndex),this.dragging=!1,t||this._trigger(\"beforeStop\",e,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.cancelHelperRemoval||(this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null),!t){for(s=0;n.length>s;s++)n[s].call(this,e);this._trigger(\"stop\",e,this._uiHash())}return this.fromOutside=!1,!this.cancelHelperRemoval},_trigger:function(){e.Widget.prototype._trigger.apply(this,arguments)===!1&&this.cancel()},_uiHash:function(t){var i=t||this;return{helper:i.helper,placeholder:i.placeholder||e([]),position:i.position,originalPosition:i.originalPosition,offset:i.positionAbs,item:i.currentItem,sender:t?t.element:null}}}),e.widget(\"ui.accordion\",{version:\"1.11.4\",options:{active:0,animate:{},collapsible:!1,event:\"click\",header:\"> li > :first-child,> :not(li):even\",heightStyle:\"auto\",icons:{activeHeader:\"ui-icon-triangle-1-s\",header:\"ui-icon-triangle-1-e\"},activate:null,beforeActivate:null},hideProps:{borderTopWidth:\"hide\",borderBottomWidth:\"hide\",paddingTop:\"hide\",paddingBottom:\"hide\",height:\"hide\"},showProps:{borderTopWidth:\"show\",borderBottomWidth:\"show\",paddingTop:\"show\",paddingBottom:\"show\",height:\"show\"},_create:function(){var t=this.options;this.prevShow=this.prevHide=e(),this.element.addClass(\"ui-accordion ui-widget ui-helper-reset\").attr(\"role\",\"tablist\"),t.collapsible||t.active!==!1&&null!=t.active||(t.active=0),this._processPanels(),0>t.active&&(t.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():e()}},_createIcons:function(){var t=this.options.icons;t&&(e(\"<span>\").addClass(\"ui-accordion-header-icon ui-icon \"+t.header).prependTo(this.headers),this.active.children(\".ui-accordion-header-icon\").removeClass(t.header).addClass(t.activeHeader),this.headers.addClass(\"ui-accordion-icons\"))},_destroyIcons:function(){this.headers.removeClass(\"ui-accordion-icons\").children(\".ui-accordion-header-icon\").remove()},_destroy:function(){var e;this.element.removeClass(\"ui-accordion ui-widget ui-helper-reset\").removeAttr(\"role\"),this.headers.removeClass(\"ui-accordion-header ui-accordion-header-active ui-state-default ui-corner-all ui-state-active ui-state-disabled ui-corner-top\").removeAttr(\"role\").removeAttr(\"aria-expanded\").removeAttr(\"aria-selected\").removeAttr(\"aria-controls\").removeAttr(\"tabIndex\").removeUniqueId(),this._destroyIcons(),e=this.headers.next().removeClass(\"ui-helper-reset ui-widget-content ui-corner-bottom ui-accordion-content ui-accordion-content-active ui-state-disabled\").css(\"display\",\"\").removeAttr(\"role\").removeAttr(\"aria-hidden\").removeAttr(\"aria-labelledby\").removeUniqueId(),\"content\"!==this.options.heightStyle&&e.css(\"height\",\"\")},_setOption:function(e,t){return\"active\"===e?(this._activate(t),void 0):(\"event\"===e&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(t)),this._super(e,t),\"collapsible\"!==e||t||this.options.active!==!1||this._activate(0),\"icons\"===e&&(this._destroyIcons(),t&&this._createIcons()),\"disabled\"===e&&(this.element.toggleClass(\"ui-state-disabled\",!!t).attr(\"aria-disabled\",t),this.headers.add(this.headers.next()).toggleClass(\"ui-state-disabled\",!!t)),void 0)},_keydown:function(t){if(!t.altKey&&!t.ctrlKey){var i=e.ui.keyCode,s=this.headers.length,n=this.headers.index(t.target),a=!1;switch(t.keyCode){case i.RIGHT:case i.DOWN:a=this.headers[(n+1)%s];break;case i.LEFT:case i.UP:a=this.headers[(n-1+s)%s];break;case i.SPACE:case i.ENTER:this._eventHandler(t);break;case i.HOME:a=this.headers[0];break;case i.END:a=this.headers[s-1]}a&&(e(t.target).attr(\"tabIndex\",-1),e(a).attr(\"tabIndex\",0),a.focus(),t.preventDefault())}},_panelKeyDown:function(t){t.keyCode===e.ui.keyCode.UP&&t.ctrlKey&&e(t.currentTarget).prev().focus()},refresh:function(){var t=this.options;this._processPanels(),t.active===!1&&t.collapsible===!0||!this.headers.length?(t.active=!1,this.active=e()):t.active===!1?this._activate(0):this.active.length&&!e.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(\".ui-state-disabled\").length?(t.active=!1,this.active=e()):this._activate(Math.max(0,t.active-1)):t.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){var e=this.headers,t=this.panels;this.headers=this.element.find(this.options.header).addClass(\"ui-accordion-header ui-state-default ui-corner-all\"),this.panels=this.headers.next().addClass(\"ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom\").filter(\":not(.ui-accordion-content-active)\").hide(),t&&(this._off(e.not(this.headers)),this._off(t.not(this.panels)))\n},_refresh:function(){var t,i=this.options,s=i.heightStyle,n=this.element.parent();this.active=this._findActive(i.active).addClass(\"ui-accordion-header-active ui-state-active ui-corner-top\").removeClass(\"ui-corner-all\"),this.active.next().addClass(\"ui-accordion-content-active\").show(),this.headers.attr(\"role\",\"tab\").each(function(){var t=e(this),i=t.uniqueId().attr(\"id\"),s=t.next(),n=s.uniqueId().attr(\"id\");t.attr(\"aria-controls\",n),s.attr(\"aria-labelledby\",i)}).next().attr(\"role\",\"tabpanel\"),this.headers.not(this.active).attr({\"aria-selected\":\"false\",\"aria-expanded\":\"false\",tabIndex:-1}).next().attr({\"aria-hidden\":\"true\"}).hide(),this.active.length?this.active.attr({\"aria-selected\":\"true\",\"aria-expanded\":\"true\",tabIndex:0}).next().attr({\"aria-hidden\":\"false\"}):this.headers.eq(0).attr(\"tabIndex\",0),this._createIcons(),this._setupEvents(i.event),\"fill\"===s?(t=n.height(),this.element.siblings(\":visible\").each(function(){var i=e(this),s=i.css(\"position\");\"absolute\"!==s&&\"fixed\"!==s&&(t-=i.outerHeight(!0))}),this.headers.each(function(){t-=e(this).outerHeight(!0)}),this.headers.next().each(function(){e(this).height(Math.max(0,t-e(this).innerHeight()+e(this).height()))}).css(\"overflow\",\"auto\")):\"auto\"===s&&(t=0,this.headers.next().each(function(){t=Math.max(t,e(this).css(\"height\",\"\").height())}).height(t))},_activate:function(t){var i=this._findActive(t)[0];i!==this.active[0]&&(i=i||this.active[0],this._eventHandler({target:i,currentTarget:i,preventDefault:e.noop}))},_findActive:function(t){return\"number\"==typeof t?this.headers.eq(t):e()},_setupEvents:function(t){var i={keydown:\"_keydown\"};t&&e.each(t.split(\" \"),function(e,t){i[t]=\"_eventHandler\"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,i),this._on(this.headers.next(),{keydown:\"_panelKeyDown\"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(t){var i=this.options,s=this.active,n=e(t.currentTarget),a=n[0]===s[0],o=a&&i.collapsible,r=o?e():n.next(),h=s.next(),l={oldHeader:s,oldPanel:h,newHeader:o?e():n,newPanel:r};t.preventDefault(),a&&!i.collapsible||this._trigger(\"beforeActivate\",t,l)===!1||(i.active=o?!1:this.headers.index(n),this.active=a?e():n,this._toggle(l),s.removeClass(\"ui-accordion-header-active ui-state-active\"),i.icons&&s.children(\".ui-accordion-header-icon\").removeClass(i.icons.activeHeader).addClass(i.icons.header),a||(n.removeClass(\"ui-corner-all\").addClass(\"ui-accordion-header-active ui-state-active ui-corner-top\"),i.icons&&n.children(\".ui-accordion-header-icon\").removeClass(i.icons.header).addClass(i.icons.activeHeader),n.next().addClass(\"ui-accordion-content-active\")))},_toggle:function(t){var i=t.newPanel,s=this.prevShow.length?this.prevShow:t.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=i,this.prevHide=s,this.options.animate?this._animate(i,s,t):(s.hide(),i.show(),this._toggleComplete(t)),s.attr({\"aria-hidden\":\"true\"}),s.prev().attr({\"aria-selected\":\"false\",\"aria-expanded\":\"false\"}),i.length&&s.length?s.prev().attr({tabIndex:-1,\"aria-expanded\":\"false\"}):i.length&&this.headers.filter(function(){return 0===parseInt(e(this).attr(\"tabIndex\"),10)}).attr(\"tabIndex\",-1),i.attr(\"aria-hidden\",\"false\").prev().attr({\"aria-selected\":\"true\",\"aria-expanded\":\"true\",tabIndex:0})},_animate:function(e,t,i){var s,n,a,o=this,r=0,h=e.css(\"box-sizing\"),l=e.length&&(!t.length||e.index()<t.index()),u=this.options.animate||{},d=l&&u.down||u,c=function(){o._toggleComplete(i)};return\"number\"==typeof d&&(a=d),\"string\"==typeof d&&(n=d),n=n||d.easing||u.easing,a=a||d.duration||u.duration,t.length?e.length?(s=e.show().outerHeight(),t.animate(this.hideProps,{duration:a,easing:n,step:function(e,t){t.now=Math.round(e)}}),e.hide().animate(this.showProps,{duration:a,easing:n,complete:c,step:function(e,i){i.now=Math.round(e),\"height\"!==i.prop?\"content-box\"===h&&(r+=i.now):\"content\"!==o.options.heightStyle&&(i.now=Math.round(s-t.outerHeight()-r),r=0)}}),void 0):t.animate(this.hideProps,a,n,c):e.animate(this.showProps,a,n,c)},_toggleComplete:function(e){var t=e.oldPanel;t.removeClass(\"ui-accordion-content-active\").prev().removeClass(\"ui-corner-top\").addClass(\"ui-corner-all\"),t.length&&(t.parent()[0].className=t.parent()[0].className),this._trigger(\"activate\",null,e)}}),e.widget(\"ui.menu\",{version:\"1.11.4\",defaultElement:\"<ul>\",delay:300,options:{icons:{submenu:\"ui-icon-carat-1-e\"},items:\"> *\",menus:\"ul\",position:{my:\"left-1 top\",at:\"right top\"},role:\"menu\",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.element.uniqueId().addClass(\"ui-menu ui-widget ui-widget-content\").toggleClass(\"ui-menu-icons\",!!this.element.find(\".ui-icon\").length).attr({role:this.options.role,tabIndex:0}),this.options.disabled&&this.element.addClass(\"ui-state-disabled\").attr(\"aria-disabled\",\"true\"),this._on({\"mousedown .ui-menu-item\":function(e){e.preventDefault()},\"click .ui-menu-item\":function(t){var i=e(t.target);!this.mouseHandled&&i.not(\".ui-state-disabled\").length&&(this.select(t),t.isPropagationStopped()||(this.mouseHandled=!0),i.has(\".ui-menu\").length?this.expand(t):!this.element.is(\":focus\")&&e(this.document[0].activeElement).closest(\".ui-menu\").length&&(this.element.trigger(\"focus\",[!0]),this.active&&1===this.active.parents(\".ui-menu\").length&&clearTimeout(this.timer)))},\"mouseenter .ui-menu-item\":function(t){if(!this.previousFilter){var i=e(t.currentTarget);i.siblings(\".ui-state-active\").removeClass(\"ui-state-active\"),this.focus(t,i)}},mouseleave:\"collapseAll\",\"mouseleave .ui-menu\":\"collapseAll\",focus:function(e,t){var i=this.active||this.element.find(this.options.items).eq(0);t||this.focus(e,i)},blur:function(t){this._delay(function(){e.contains(this.element[0],this.document[0].activeElement)||this.collapseAll(t)})},keydown:\"_keydown\"}),this.refresh(),this._on(this.document,{click:function(e){this._closeOnDocumentClick(e)&&this.collapseAll(e),this.mouseHandled=!1}})},_destroy:function(){this.element.removeAttr(\"aria-activedescendant\").find(\".ui-menu\").addBack().removeClass(\"ui-menu ui-widget ui-widget-content ui-menu-icons ui-front\").removeAttr(\"role\").removeAttr(\"tabIndex\").removeAttr(\"aria-labelledby\").removeAttr(\"aria-expanded\").removeAttr(\"aria-hidden\").removeAttr(\"aria-disabled\").removeUniqueId().show(),this.element.find(\".ui-menu-item\").removeClass(\"ui-menu-item\").removeAttr(\"role\").removeAttr(\"aria-disabled\").removeUniqueId().removeClass(\"ui-state-hover\").removeAttr(\"tabIndex\").removeAttr(\"role\").removeAttr(\"aria-haspopup\").children().each(function(){var t=e(this);t.data(\"ui-menu-submenu-carat\")&&t.remove()}),this.element.find(\".ui-menu-divider\").removeClass(\"ui-menu-divider ui-widget-content\")},_keydown:function(t){var i,s,n,a,o=!0;switch(t.keyCode){case e.ui.keyCode.PAGE_UP:this.previousPage(t);break;case e.ui.keyCode.PAGE_DOWN:this.nextPage(t);break;case e.ui.keyCode.HOME:this._move(\"first\",\"first\",t);break;case e.ui.keyCode.END:this._move(\"last\",\"last\",t);break;case e.ui.keyCode.UP:this.previous(t);break;case e.ui.keyCode.DOWN:this.next(t);break;case e.ui.keyCode.LEFT:this.collapse(t);break;case e.ui.keyCode.RIGHT:this.active&&!this.active.is(\".ui-state-disabled\")&&this.expand(t);break;case e.ui.keyCode.ENTER:case e.ui.keyCode.SPACE:this._activate(t);break;case e.ui.keyCode.ESCAPE:this.collapse(t);break;default:o=!1,s=this.previousFilter||\"\",n=String.fromCharCode(t.keyCode),a=!1,clearTimeout(this.filterTimer),n===s?a=!0:n=s+n,i=this._filterMenuItems(n),i=a&&-1!==i.index(this.active.next())?this.active.nextAll(\".ui-menu-item\"):i,i.length||(n=String.fromCharCode(t.keyCode),i=this._filterMenuItems(n)),i.length?(this.focus(t,i),this.previousFilter=n,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter}o&&t.preventDefault()},_activate:function(e){this.active.is(\".ui-state-disabled\")||(this.active.is(\"[aria-haspopup='true']\")?this.expand(e):this.select(e))},refresh:function(){var t,i,s=this,n=this.options.icons.submenu,a=this.element.find(this.options.menus);this.element.toggleClass(\"ui-menu-icons\",!!this.element.find(\".ui-icon\").length),a.filter(\":not(.ui-menu)\").addClass(\"ui-menu ui-widget ui-widget-content ui-front\").hide().attr({role:this.options.role,\"aria-hidden\":\"true\",\"aria-expanded\":\"false\"}).each(function(){var t=e(this),i=t.parent(),s=e(\"<span>\").addClass(\"ui-menu-icon ui-icon \"+n).data(\"ui-menu-submenu-carat\",!0);i.attr(\"aria-haspopup\",\"true\").prepend(s),t.attr(\"aria-labelledby\",i.attr(\"id\"))}),t=a.add(this.element),i=t.find(this.options.items),i.not(\".ui-menu-item\").each(function(){var t=e(this);s._isDivider(t)&&t.addClass(\"ui-widget-content ui-menu-divider\")}),i.not(\".ui-menu-item, .ui-menu-divider\").addClass(\"ui-menu-item\").uniqueId().attr({tabIndex:-1,role:this._itemRole()}),i.filter(\".ui-state-disabled\").attr(\"aria-disabled\",\"true\"),this.active&&!e.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:\"menuitem\",listbox:\"option\"}[this.options.role]},_setOption:function(e,t){\"icons\"===e&&this.element.find(\".ui-menu-icon\").removeClass(this.options.icons.submenu).addClass(t.submenu),\"disabled\"===e&&this.element.toggleClass(\"ui-state-disabled\",!!t).attr(\"aria-disabled\",t),this._super(e,t)},focus:function(e,t){var i,s;this.blur(e,e&&\"focus\"===e.type),this._scrollIntoView(t),this.active=t.first(),s=this.active.addClass(\"ui-state-focus\").removeClass(\"ui-state-active\"),this.options.role&&this.element.attr(\"aria-activedescendant\",s.attr(\"id\")),this.active.parent().closest(\".ui-menu-item\").addClass(\"ui-state-active\"),e&&\"keydown\"===e.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),i=t.children(\".ui-menu\"),i.length&&e&&/^mouse/.test(e.type)&&this._startOpening(i),this.activeMenu=t.parent(),this._trigger(\"focus\",e,{item:t})},_scrollIntoView:function(t){var i,s,n,a,o,r;this._hasScroll()&&(i=parseFloat(e.css(this.activeMenu[0],\"borderTopWidth\"))||0,s=parseFloat(e.css(this.activeMenu[0],\"paddingTop\"))||0,n=t.offset().top-this.activeMenu.offset().top-i-s,a=this.activeMenu.scrollTop(),o=this.activeMenu.height(),r=t.outerHeight(),0>n?this.activeMenu.scrollTop(a+n):n+r>o&&this.activeMenu.scrollTop(a+n-o+r))},blur:function(e,t){t||clearTimeout(this.timer),this.active&&(this.active.removeClass(\"ui-state-focus\"),this.active=null,this._trigger(\"blur\",e,{item:this.active}))},_startOpening:function(e){clearTimeout(this.timer),\"true\"===e.attr(\"aria-hidden\")&&(this.timer=this._delay(function(){this._close(),this._open(e)},this.delay))},_open:function(t){var i=e.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(\".ui-menu\").not(t.parents(\".ui-menu\")).hide().attr(\"aria-hidden\",\"true\"),t.show().removeAttr(\"aria-hidden\").attr(\"aria-expanded\",\"true\").position(i)},collapseAll:function(t,i){clearTimeout(this.timer),this.timer=this._delay(function(){var s=i?this.element:e(t&&t.target).closest(this.element.find(\".ui-menu\"));s.length||(s=this.element),this._close(s),this.blur(t),this.activeMenu=s},this.delay)},_close:function(e){e||(e=this.active?this.active.parent():this.element),e.find(\".ui-menu\").hide().attr(\"aria-hidden\",\"true\").attr(\"aria-expanded\",\"false\").end().find(\".ui-state-active\").not(\".ui-state-focus\").removeClass(\"ui-state-active\")},_closeOnDocumentClick:function(t){return!e(t.target).closest(\".ui-menu\").length},_isDivider:function(e){return!/[^\\-\\u2014\\u2013\\s]/.test(e.text())},collapse:function(e){var t=this.active&&this.active.parent().closest(\".ui-menu-item\",this.element);t&&t.length&&(this._close(),this.focus(e,t))},expand:function(e){var t=this.active&&this.active.children(\".ui-menu \").find(this.options.items).first();t&&t.length&&(this._open(t.parent()),this._delay(function(){this.focus(e,t)}))},next:function(e){this._move(\"next\",\"first\",e)},previous:function(e){this._move(\"prev\",\"last\",e)},isFirstItem:function(){return this.active&&!this.active.prevAll(\".ui-menu-item\").length},isLastItem:function(){return this.active&&!this.active.nextAll(\".ui-menu-item\").length},_move:function(e,t,i){var s;this.active&&(s=\"first\"===e||\"last\"===e?this.active[\"first\"===e?\"prevAll\":\"nextAll\"](\".ui-menu-item\").eq(-1):this.active[e+\"All\"](\".ui-menu-item\").eq(0)),s&&s.length&&this.active||(s=this.activeMenu.find(this.options.items)[t]()),this.focus(i,s)},nextPage:function(t){var i,s,n;return this.active?(this.isLastItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.nextAll(\".ui-menu-item\").each(function(){return i=e(this),0>i.offset().top-s-n}),this.focus(t,i)):this.focus(t,this.activeMenu.find(this.options.items)[this.active?\"last\":\"first\"]())),void 0):(this.next(t),void 0)},previousPage:function(t){var i,s,n;return this.active?(this.isFirstItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.prevAll(\".ui-menu-item\").each(function(){return i=e(this),i.offset().top-s+n>0}),this.focus(t,i)):this.focus(t,this.activeMenu.find(this.options.items).first())),void 0):(this.next(t),void 0)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop(\"scrollHeight\")},select:function(t){this.active=this.active||e(t.target).closest(\".ui-menu-item\");var i={item:this.active};this.active.has(\".ui-menu\").length||this.collapseAll(t,!0),this._trigger(\"select\",t,i)},_filterMenuItems:function(t){var i=t.replace(/[\\-\\[\\]{}()*+?.,\\\\\\^$|#\\s]/g,\"\\\\$&\"),s=RegExp(\"^\"+i,\"i\");return this.activeMenu.find(this.options.items).filter(\".ui-menu-item\").filter(function(){return s.test(e.trim(e(this).text()))})}}),e.widget(\"ui.autocomplete\",{version:\"1.11.4\",defaultElement:\"<input>\",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:\"left top\",at:\"left bottom\",collision:\"none\"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},requestIndex:0,pending:0,_create:function(){var t,i,s,n=this.element[0].nodeName.toLowerCase(),a=\"textarea\"===n,o=\"input\"===n;this.isMultiLine=a?!0:o?!1:this.element.prop(\"isContentEditable\"),this.valueMethod=this.element[a||o?\"val\":\"text\"],this.isNewMenu=!0,this.element.addClass(\"ui-autocomplete-input\").attr(\"autocomplete\",\"off\"),this._on(this.element,{keydown:function(n){if(this.element.prop(\"readOnly\"))return t=!0,s=!0,i=!0,void 0;t=!1,s=!1,i=!1;var a=e.ui.keyCode;switch(n.keyCode){case a.PAGE_UP:t=!0,this._move(\"previousPage\",n);break;case a.PAGE_DOWN:t=!0,this._move(\"nextPage\",n);break;case a.UP:t=!0,this._keyEvent(\"previous\",n);break;case a.DOWN:t=!0,this._keyEvent(\"next\",n);break;case a.ENTER:this.menu.active&&(t=!0,n.preventDefault(),this.menu.select(n));break;case a.TAB:this.menu.active&&this.menu.select(n);break;case a.ESCAPE:this.menu.element.is(\":visible\")&&(this.isMultiLine||this._value(this.term),this.close(n),n.preventDefault());break;default:i=!0,this._searchTimeout(n)}},keypress:function(s){if(t)return t=!1,(!this.isMultiLine||this.menu.element.is(\":visible\"))&&s.preventDefault(),void 0;if(!i){var n=e.ui.keyCode;switch(s.keyCode){case n.PAGE_UP:this._move(\"previousPage\",s);break;case n.PAGE_DOWN:this._move(\"nextPage\",s);break;case n.UP:this._keyEvent(\"previous\",s);break;case n.DOWN:this._keyEvent(\"next\",s)}}},input:function(e){return s?(s=!1,e.preventDefault(),void 0):(this._searchTimeout(e),void 0)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(e){return this.cancelBlur?(delete this.cancelBlur,void 0):(clearTimeout(this.searching),this.close(e),this._change(e),void 0)}}),this._initSource(),this.menu=e(\"<ul>\").addClass(\"ui-autocomplete ui-front\").appendTo(this._appendTo()).menu({role:null}).hide().menu(\"instance\"),this._on(this.menu.element,{mousedown:function(t){t.preventDefault(),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur});var i=this.menu.element[0];e(t.target).closest(\".ui-menu-item\").length||this._delay(function(){var t=this;this.document.one(\"mousedown\",function(s){s.target===t.element[0]||s.target===i||e.contains(i,s.target)||t.close()})})},menufocus:function(t,i){var s,n;return this.isNewMenu&&(this.isNewMenu=!1,t.originalEvent&&/^mouse/.test(t.originalEvent.type))?(this.menu.blur(),this.document.one(\"mousemove\",function(){e(t.target).trigger(t.originalEvent)}),void 0):(n=i.item.data(\"ui-autocomplete-item\"),!1!==this._trigger(\"focus\",t,{item:n})&&t.originalEvent&&/^key/.test(t.originalEvent.type)&&this._value(n.value),s=i.item.attr(\"aria-label\")||n.value,s&&e.trim(s).length&&(this.liveRegion.children().hide(),e(\"<div>\").text(s).appendTo(this.liveRegion)),void 0)},menuselect:function(e,t){var i=t.item.data(\"ui-autocomplete-item\"),s=this.previous;this.element[0]!==this.document[0].activeElement&&(this.element.focus(),this.previous=s,this._delay(function(){this.previous=s,this.selectedItem=i})),!1!==this._trigger(\"select\",e,{item:i})&&this._value(i.value),this.term=this._value(),this.close(e),this.selectedItem=i}}),this.liveRegion=e(\"<span>\",{role:\"status\",\"aria-live\":\"assertive\",\"aria-relevant\":\"additions\"}).addClass(\"ui-helper-hidden-accessible\").appendTo(this.document[0].body),this._on(this.window,{beforeunload:function(){this.element.removeAttr(\"autocomplete\")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeClass(\"ui-autocomplete-input\").removeAttr(\"autocomplete\"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(e,t){this._super(e,t),\"source\"===e&&this._initSource(),\"appendTo\"===e&&this.menu.element.appendTo(this._appendTo()),\"disabled\"===e&&t&&this.xhr&&this.xhr.abort()},_appendTo:function(){var t=this.options.appendTo;return t&&(t=t.jquery||t.nodeType?e(t):this.document.find(t).eq(0)),t&&t[0]||(t=this.element.closest(\".ui-front\")),t.length||(t=this.document[0].body),t},_initSource:function(){var t,i,s=this;e.isArray(this.options.source)?(t=this.options.source,this.source=function(i,s){s(e.ui.autocomplete.filter(t,i.term))}):\"string\"==typeof this.options.source?(i=this.options.source,this.source=function(t,n){s.xhr&&s.xhr.abort(),s.xhr=e.ajax({url:i,data:t,dataType:\"json\",success:function(e){n(e)},error:function(){n([])}})}):this.source=this.options.source},_searchTimeout:function(e){clearTimeout(this.searching),this.searching=this._delay(function(){var t=this.term===this._value(),i=this.menu.element.is(\":visible\"),s=e.altKey||e.ctrlKey||e.metaKey||e.shiftKey;(!t||t&&!i&&!s)&&(this.selectedItem=null,this.search(null,e))},this.options.delay)},search:function(e,t){return e=null!=e?e:this._value(),this.term=this._value(),e.length<this.options.minLength?this.close(t):this._trigger(\"search\",t)!==!1?this._search(e):void 0},_search:function(e){this.pending++,this.element.addClass(\"ui-autocomplete-loading\"),this.cancelSearch=!1,this.source({term:e},this._response())},_response:function(){var t=++this.requestIndex;return e.proxy(function(e){t===this.requestIndex&&this.__response(e),this.pending--,this.pending||this.element.removeClass(\"ui-autocomplete-loading\")},this)},__response:function(e){e&&(e=this._normalize(e)),this._trigger(\"response\",null,{content:e}),!this.options.disabled&&e&&e.length&&!this.cancelSearch?(this._suggest(e),this._trigger(\"open\")):this._close()},close:function(e){this.cancelSearch=!0,this._close(e)},_close:function(e){this.menu.element.is(\":visible\")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger(\"close\",e))},_change:function(e){this.previous!==this._value()&&this._trigger(\"change\",e,{item:this.selectedItem})},_normalize:function(t){return t.length&&t[0].label&&t[0].value?t:e.map(t,function(t){return\"string\"==typeof t?{label:t,value:t}:e.extend({},t,{label:t.label||t.value,value:t.value||t.label})})},_suggest:function(t){var i=this.menu.element.empty();this._renderMenu(i,t),this.isNewMenu=!0,this.menu.refresh(),i.show(),this._resizeMenu(),i.position(e.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next()},_resizeMenu:function(){var e=this.menu.element;e.outerWidth(Math.max(e.width(\"\").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(t,i){var s=this;e.each(i,function(e,i){s._renderItemData(t,i)})},_renderItemData:function(e,t){return this._renderItem(e,t).data(\"ui-autocomplete-item\",t)},_renderItem:function(t,i){return e(\"<li>\").text(i.label).appendTo(t)},_move:function(e,t){return this.menu.element.is(\":visible\")?this.menu.isFirstItem()&&/^previous/.test(e)||this.menu.isLastItem()&&/^next/.test(e)?(this.isMultiLine||this._value(this.term),this.menu.blur(),void 0):(this.menu[e](t),void 0):(this.search(null,t),void 0)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(e,t){(!this.isMultiLine||this.menu.element.is(\":visible\"))&&(this._move(e,t),t.preventDefault())}}),e.extend(e.ui.autocomplete,{escapeRegex:function(e){return e.replace(/[\\-\\[\\]{}()*+?.,\\\\\\^$|#\\s]/g,\"\\\\$&\")},filter:function(t,i){var s=RegExp(e.ui.autocomplete.escapeRegex(i),\"i\");return e.grep(t,function(e){return s.test(e.label||e.value||e)})}}),e.widget(\"ui.autocomplete\",e.ui.autocomplete,{options:{messages:{noResults:\"No search results.\",results:function(e){return e+(e>1?\" results are\":\" result is\")+\" available, use up and down arrow keys to navigate.\"}}},__response:function(t){var i;this._superApply(arguments),this.options.disabled||this.cancelSearch||(i=t&&t.length?this.options.messages.results(t.length):this.options.messages.noResults,this.liveRegion.children().hide(),e(\"<div>\").text(i).appendTo(this.liveRegion))}}),e.ui.autocomplete;var c,p=\"ui-button ui-widget ui-state-default ui-corner-all\",f=\"ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only\",m=function(){var t=e(this);setTimeout(function(){t.find(\":ui-button\").button(\"refresh\")},1)},g=function(t){var i=t.name,s=t.form,n=e([]);return i&&(i=i.replace(/'/g,\"\\\\'\"),n=s?e(s).find(\"[name='\"+i+\"'][type=radio]\"):e(\"[name='\"+i+\"'][type=radio]\",t.ownerDocument).filter(function(){return!this.form})),n};e.widget(\"ui.button\",{version:\"1.11.4\",defaultElement:\"<button>\",options:{disabled:null,text:!0,label:null,icons:{primary:null,secondary:null}},_create:function(){this.element.closest(\"form\").unbind(\"reset\"+this.eventNamespace).bind(\"reset\"+this.eventNamespace,m),\"boolean\"!=typeof this.options.disabled?this.options.disabled=!!this.element.prop(\"disabled\"):this.element.prop(\"disabled\",this.options.disabled),this._determineButtonType(),this.hasTitle=!!this.buttonElement.attr(\"title\");var t=this,i=this.options,s=\"checkbox\"===this.type||\"radio\"===this.type,n=s?\"\":\"ui-state-active\";null===i.label&&(i.label=\"input\"===this.type?this.buttonElement.val():this.buttonElement.html()),this._hoverable(this.buttonElement),this.buttonElement.addClass(p).attr(\"role\",\"button\").bind(\"mouseenter\"+this.eventNamespace,function(){i.disabled||this===c&&e(this).addClass(\"ui-state-active\")}).bind(\"mouseleave\"+this.eventNamespace,function(){i.disabled||e(this).removeClass(n)}).bind(\"click\"+this.eventNamespace,function(e){i.disabled&&(e.preventDefault(),e.stopImmediatePropagation())}),this._on({focus:function(){this.buttonElement.addClass(\"ui-state-focus\")},blur:function(){this.buttonElement.removeClass(\"ui-state-focus\")}}),s&&this.element.bind(\"change\"+this.eventNamespace,function(){t.refresh()}),\"checkbox\"===this.type?this.buttonElement.bind(\"click\"+this.eventNamespace,function(){return i.disabled?!1:void 0}):\"radio\"===this.type?this.buttonElement.bind(\"click\"+this.eventNamespace,function(){if(i.disabled)return!1;e(this).addClass(\"ui-state-active\"),t.buttonElement.attr(\"aria-pressed\",\"true\");var s=t.element[0];g(s).not(s).map(function(){return e(this).button(\"widget\")[0]}).removeClass(\"ui-state-active\").attr(\"aria-pressed\",\"false\")}):(this.buttonElement.bind(\"mousedown\"+this.eventNamespace,function(){return i.disabled?!1:(e(this).addClass(\"ui-state-active\"),c=this,t.document.one(\"mouseup\",function(){c=null}),void 0)}).bind(\"mouseup\"+this.eventNamespace,function(){return i.disabled?!1:(e(this).removeClass(\"ui-state-active\"),void 0)}).bind(\"keydown\"+this.eventNamespace,function(t){return i.disabled?!1:((t.keyCode===e.ui.keyCode.SPACE||t.keyCode===e.ui.keyCode.ENTER)&&e(this).addClass(\"ui-state-active\"),void 0)}).bind(\"keyup\"+this.eventNamespace+\" blur\"+this.eventNamespace,function(){e(this).removeClass(\"ui-state-active\")}),this.buttonElement.is(\"a\")&&this.buttonElement.keyup(function(t){t.keyCode===e.ui.keyCode.SPACE&&e(this).click()})),this._setOption(\"disabled\",i.disabled),this._resetButton()},_determineButtonType:function(){var e,t,i;this.type=this.element.is(\"[type=checkbox]\")?\"checkbox\":this.element.is(\"[type=radio]\")?\"radio\":this.element.is(\"input\")?\"input\":\"button\",\"checkbox\"===this.type||\"radio\"===this.type?(e=this.element.parents().last(),t=\"label[for='\"+this.element.attr(\"id\")+\"']\",this.buttonElement=e.find(t),this.buttonElement.length||(e=e.length?e.siblings():this.element.siblings(),this.buttonElement=e.filter(t),this.buttonElement.length||(this.buttonElement=e.find(t))),this.element.addClass(\"ui-helper-hidden-accessible\"),i=this.element.is(\":checked\"),i&&this.buttonElement.addClass(\"ui-state-active\"),this.buttonElement.prop(\"aria-pressed\",i)):this.buttonElement=this.element},widget:function(){return this.buttonElement},_destroy:function(){this.element.removeClass(\"ui-helper-hidden-accessible\"),this.buttonElement.removeClass(p+\" ui-state-active \"+f).removeAttr(\"role\").removeAttr(\"aria-pressed\").html(this.buttonElement.find(\".ui-button-text\").html()),this.hasTitle||this.buttonElement.removeAttr(\"title\")},_setOption:function(e,t){return this._super(e,t),\"disabled\"===e?(this.widget().toggleClass(\"ui-state-disabled\",!!t),this.element.prop(\"disabled\",!!t),t&&(\"checkbox\"===this.type||\"radio\"===this.type?this.buttonElement.removeClass(\"ui-state-focus\"):this.buttonElement.removeClass(\"ui-state-focus ui-state-active\")),void 0):(this._resetButton(),void 0)},refresh:function(){var t=this.element.is(\"input, button\")?this.element.is(\":disabled\"):this.element.hasClass(\"ui-button-disabled\");t!==this.options.disabled&&this._setOption(\"disabled\",t),\"radio\"===this.type?g(this.element[0]).each(function(){e(this).is(\":checked\")?e(this).button(\"widget\").addClass(\"ui-state-active\").attr(\"aria-pressed\",\"true\"):e(this).button(\"widget\").removeClass(\"ui-state-active\").attr(\"aria-pressed\",\"false\")}):\"checkbox\"===this.type&&(this.element.is(\":checked\")?this.buttonElement.addClass(\"ui-state-active\").attr(\"aria-pressed\",\"true\"):this.buttonElement.removeClass(\"ui-state-active\").attr(\"aria-pressed\",\"false\"))},_resetButton:function(){if(\"input\"===this.type)return this.options.label&&this.element.val(this.options.label),void 0;var t=this.buttonElement.removeClass(f),i=e(\"<span></span>\",this.document[0]).addClass(\"ui-button-text\").html(this.options.label).appendTo(t.empty()).text(),s=this.options.icons,n=s.primary&&s.secondary,a=[];s.primary||s.secondary?(this.options.text&&a.push(\"ui-button-text-icon\"+(n?\"s\":s.primary?\"-primary\":\"-secondary\")),s.primary&&t.prepend(\"<span class='ui-button-icon-primary ui-icon \"+s.primary+\"'></span>\"),s.secondary&&t.append(\"<span class='ui-button-icon-secondary ui-icon \"+s.secondary+\"'></span>\"),this.options.text||(a.push(n?\"ui-button-icons-only\":\"ui-button-icon-only\"),this.hasTitle||t.attr(\"title\",e.trim(i)))):a.push(\"ui-button-text-only\"),t.addClass(a.join(\" \"))}}),e.widget(\"ui.buttonset\",{version:\"1.11.4\",options:{items:\"button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)\"},_create:function(){this.element.addClass(\"ui-buttonset\")},_init:function(){this.refresh()},_setOption:function(e,t){\"disabled\"===e&&this.buttons.button(\"option\",e,t),this._super(e,t)},refresh:function(){var t=\"rtl\"===this.element.css(\"direction\"),i=this.element.find(this.options.items),s=i.filter(\":ui-button\");i.not(\":ui-button\").button(),s.button(\"refresh\"),this.buttons=i.map(function(){return e(this).button(\"widget\")[0]}).removeClass(\"ui-corner-all ui-corner-left ui-corner-right\").filter(\":first\").addClass(t?\"ui-corner-right\":\"ui-corner-left\").end().filter(\":last\").addClass(t?\"ui-corner-left\":\"ui-corner-right\").end().end()},_destroy:function(){this.element.removeClass(\"ui-buttonset\"),this.buttons.map(function(){return e(this).button(\"widget\")[0]}).removeClass(\"ui-corner-left ui-corner-right\").end().button(\"destroy\")}}),e.ui.button,e.extend(e.ui,{datepicker:{version:\"1.11.4\"}});var v;e.extend(n.prototype,{markerClassName:\"hasDatepicker\",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(e){return r(this._defaults,e||{}),this},_attachDatepicker:function(t,i){var s,n,a;s=t.nodeName.toLowerCase(),n=\"div\"===s||\"span\"===s,t.id||(this.uuid+=1,t.id=\"dp\"+this.uuid),a=this._newInst(e(t),n),a.settings=e.extend({},i||{}),\"input\"===s?this._connectDatepicker(t,a):n&&this._inlineDatepicker(t,a)},_newInst:function(t,i){var s=t[0].id.replace(/([^A-Za-z0-9_\\-])/g,\"\\\\\\\\$1\");return{id:s,input:t,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:i,dpDiv:i?a(e(\"<div class='\"+this._inlineClass+\" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>\")):this.dpDiv}},_connectDatepicker:function(t,i){var s=e(t);i.append=e([]),i.trigger=e([]),s.hasClass(this.markerClassName)||(this._attachments(s,i),s.addClass(this.markerClassName).keydown(this._doKeyDown).keypress(this._doKeyPress).keyup(this._doKeyUp),this._autoSize(i),e.data(t,\"datepicker\",i),i.settings.disabled&&this._disableDatepicker(t))},_attachments:function(t,i){var s,n,a,o=this._get(i,\"appendText\"),r=this._get(i,\"isRTL\");i.append&&i.append.remove(),o&&(i.append=e(\"<span class='\"+this._appendClass+\"'>\"+o+\"</span>\"),t[r?\"before\":\"after\"](i.append)),t.unbind(\"focus\",this._showDatepicker),i.trigger&&i.trigger.remove(),s=this._get(i,\"showOn\"),(\"focus\"===s||\"both\"===s)&&t.focus(this._showDatepicker),(\"button\"===s||\"both\"===s)&&(n=this._get(i,\"buttonText\"),a=this._get(i,\"buttonImage\"),i.trigger=e(this._get(i,\"buttonImageOnly\")?e(\"<img/>\").addClass(this._triggerClass).attr({src:a,alt:n,title:n}):e(\"<button type='button'></button>\").addClass(this._triggerClass).html(a?e(\"<img/>\").attr({src:a,alt:n,title:n}):n)),t[r?\"before\":\"after\"](i.trigger),i.trigger.click(function(){return e.datepicker._datepickerShowing&&e.datepicker._lastInput===t[0]?e.datepicker._hideDatepicker():e.datepicker._datepickerShowing&&e.datepicker._lastInput!==t[0]?(e.datepicker._hideDatepicker(),e.datepicker._showDatepicker(t[0])):e.datepicker._showDatepicker(t[0]),!1}))},_autoSize:function(e){if(this._get(e,\"autoSize\")&&!e.inline){var t,i,s,n,a=new Date(2009,11,20),o=this._get(e,\"dateFormat\");o.match(/[DM]/)&&(t=function(e){for(i=0,s=0,n=0;e.length>n;n++)e[n].length>i&&(i=e[n].length,s=n);return s},a.setMonth(t(this._get(e,o.match(/MM/)?\"monthNames\":\"monthNamesShort\"))),a.setDate(t(this._get(e,o.match(/DD/)?\"dayNames\":\"dayNamesShort\"))+20-a.getDay())),e.input.attr(\"size\",this._formatDate(e,a).length)}},_inlineDatepicker:function(t,i){var s=e(t);s.hasClass(this.markerClassName)||(s.addClass(this.markerClassName).append(i.dpDiv),e.data(t,\"datepicker\",i),this._setDate(i,this._getDefaultDate(i),!0),this._updateDatepicker(i),this._updateAlternate(i),i.settings.disabled&&this._disableDatepicker(t),i.dpDiv.css(\"display\",\"block\"))},_dialogDatepicker:function(t,i,s,n,a){var o,h,l,u,d,c=this._dialogInst;return c||(this.uuid+=1,o=\"dp\"+this.uuid,this._dialogInput=e(\"<input type='text' id='\"+o+\"' style='position: absolute; top: -100px; width: 0px;'/>\"),this._dialogInput.keydown(this._doKeyDown),e(\"body\").append(this._dialogInput),c=this._dialogInst=this._newInst(this._dialogInput,!1),c.settings={},e.data(this._dialogInput[0],\"datepicker\",c)),r(c.settings,n||{}),i=i&&i.constructor===Date?this._formatDate(c,i):i,this._dialogInput.val(i),this._pos=a?a.length?a:[a.pageX,a.pageY]:null,this._pos||(h=document.documentElement.clientWidth,l=document.documentElement.clientHeight,u=document.documentElement.scrollLeft||document.body.scrollLeft,d=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[h/2-100+u,l/2-150+d]),this._dialogInput.css(\"left\",this._pos[0]+20+\"px\").css(\"top\",this._pos[1]+\"px\"),c.settings.onSelect=s,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),e.blockUI&&e.blockUI(this.dpDiv),e.data(this._dialogInput[0],\"datepicker\",c),this\n},_destroyDatepicker:function(t){var i,s=e(t),n=e.data(t,\"datepicker\");s.hasClass(this.markerClassName)&&(i=t.nodeName.toLowerCase(),e.removeData(t,\"datepicker\"),\"input\"===i?(n.append.remove(),n.trigger.remove(),s.removeClass(this.markerClassName).unbind(\"focus\",this._showDatepicker).unbind(\"keydown\",this._doKeyDown).unbind(\"keypress\",this._doKeyPress).unbind(\"keyup\",this._doKeyUp)):(\"div\"===i||\"span\"===i)&&s.removeClass(this.markerClassName).empty(),v===n&&(v=null))},_enableDatepicker:function(t){var i,s,n=e(t),a=e.data(t,\"datepicker\");n.hasClass(this.markerClassName)&&(i=t.nodeName.toLowerCase(),\"input\"===i?(t.disabled=!1,a.trigger.filter(\"button\").each(function(){this.disabled=!1}).end().filter(\"img\").css({opacity:\"1.0\",cursor:\"\"})):(\"div\"===i||\"span\"===i)&&(s=n.children(\".\"+this._inlineClass),s.children().removeClass(\"ui-state-disabled\"),s.find(\"select.ui-datepicker-month, select.ui-datepicker-year\").prop(\"disabled\",!1)),this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e}))},_disableDatepicker:function(t){var i,s,n=e(t),a=e.data(t,\"datepicker\");n.hasClass(this.markerClassName)&&(i=t.nodeName.toLowerCase(),\"input\"===i?(t.disabled=!0,a.trigger.filter(\"button\").each(function(){this.disabled=!0}).end().filter(\"img\").css({opacity:\"0.5\",cursor:\"default\"})):(\"div\"===i||\"span\"===i)&&(s=n.children(\".\"+this._inlineClass),s.children().addClass(\"ui-state-disabled\"),s.find(\"select.ui-datepicker-month, select.ui-datepicker-year\").prop(\"disabled\",!0)),this._disabledInputs=e.map(this._disabledInputs,function(e){return e===t?null:e}),this._disabledInputs[this._disabledInputs.length]=t)},_isDisabledDatepicker:function(e){if(!e)return!1;for(var t=0;this._disabledInputs.length>t;t++)if(this._disabledInputs[t]===e)return!0;return!1},_getInst:function(t){try{return e.data(t,\"datepicker\")}catch(i){throw\"Missing instance data for this datepicker\"}},_optionDatepicker:function(t,i,s){var n,a,o,h,l=this._getInst(t);return 2===arguments.length&&\"string\"==typeof i?\"defaults\"===i?e.extend({},e.datepicker._defaults):l?\"all\"===i?e.extend({},l.settings):this._get(l,i):null:(n=i||{},\"string\"==typeof i&&(n={},n[i]=s),l&&(this._curInst===l&&this._hideDatepicker(),a=this._getDateDatepicker(t,!0),o=this._getMinMaxDate(l,\"min\"),h=this._getMinMaxDate(l,\"max\"),r(l.settings,n),null!==o&&void 0!==n.dateFormat&&void 0===n.minDate&&(l.settings.minDate=this._formatDate(l,o)),null!==h&&void 0!==n.dateFormat&&void 0===n.maxDate&&(l.settings.maxDate=this._formatDate(l,h)),\"disabled\"in n&&(n.disabled?this._disableDatepicker(t):this._enableDatepicker(t)),this._attachments(e(t),l),this._autoSize(l),this._setDate(l,a),this._updateAlternate(l),this._updateDatepicker(l)),void 0)},_changeDatepicker:function(e,t,i){this._optionDatepicker(e,t,i)},_refreshDatepicker:function(e){var t=this._getInst(e);t&&this._updateDatepicker(t)},_setDateDatepicker:function(e,t){var i=this._getInst(e);i&&(this._setDate(i,t),this._updateDatepicker(i),this._updateAlternate(i))},_getDateDatepicker:function(e,t){var i=this._getInst(e);return i&&!i.inline&&this._setDateFromField(i,t),i?this._getDate(i):null},_doKeyDown:function(t){var i,s,n,a=e.datepicker._getInst(t.target),o=!0,r=a.dpDiv.is(\".ui-datepicker-rtl\");if(a._keyEvent=!0,e.datepicker._datepickerShowing)switch(t.keyCode){case 9:e.datepicker._hideDatepicker(),o=!1;break;case 13:return n=e(\"td.\"+e.datepicker._dayOverClass+\":not(.\"+e.datepicker._currentClass+\")\",a.dpDiv),n[0]&&e.datepicker._selectDay(t.target,a.selectedMonth,a.selectedYear,n[0]),i=e.datepicker._get(a,\"onSelect\"),i?(s=e.datepicker._formatDate(a),i.apply(a.input?a.input[0]:null,[s,a])):e.datepicker._hideDatepicker(),!1;case 27:e.datepicker._hideDatepicker();break;case 33:e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(a,\"stepBigMonths\"):-e.datepicker._get(a,\"stepMonths\"),\"M\");break;case 34:e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(a,\"stepBigMonths\"):+e.datepicker._get(a,\"stepMonths\"),\"M\");break;case 35:(t.ctrlKey||t.metaKey)&&e.datepicker._clearDate(t.target),o=t.ctrlKey||t.metaKey;break;case 36:(t.ctrlKey||t.metaKey)&&e.datepicker._gotoToday(t.target),o=t.ctrlKey||t.metaKey;break;case 37:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,r?1:-1,\"D\"),o=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?-e.datepicker._get(a,\"stepBigMonths\"):-e.datepicker._get(a,\"stepMonths\"),\"M\");break;case 38:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,-7,\"D\"),o=t.ctrlKey||t.metaKey;break;case 39:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,r?-1:1,\"D\"),o=t.ctrlKey||t.metaKey,t.originalEvent.altKey&&e.datepicker._adjustDate(t.target,t.ctrlKey?+e.datepicker._get(a,\"stepBigMonths\"):+e.datepicker._get(a,\"stepMonths\"),\"M\");break;case 40:(t.ctrlKey||t.metaKey)&&e.datepicker._adjustDate(t.target,7,\"D\"),o=t.ctrlKey||t.metaKey;break;default:o=!1}else 36===t.keyCode&&t.ctrlKey?e.datepicker._showDatepicker(this):o=!1;o&&(t.preventDefault(),t.stopPropagation())},_doKeyPress:function(t){var i,s,n=e.datepicker._getInst(t.target);return e.datepicker._get(n,\"constrainInput\")?(i=e.datepicker._possibleChars(e.datepicker._get(n,\"dateFormat\")),s=String.fromCharCode(null==t.charCode?t.keyCode:t.charCode),t.ctrlKey||t.metaKey||\" \">s||!i||i.indexOf(s)>-1):void 0},_doKeyUp:function(t){var i,s=e.datepicker._getInst(t.target);if(s.input.val()!==s.lastVal)try{i=e.datepicker.parseDate(e.datepicker._get(s,\"dateFormat\"),s.input?s.input.val():null,e.datepicker._getFormatConfig(s)),i&&(e.datepicker._setDateFromField(s),e.datepicker._updateAlternate(s),e.datepicker._updateDatepicker(s))}catch(n){}return!0},_showDatepicker:function(t){if(t=t.target||t,\"input\"!==t.nodeName.toLowerCase()&&(t=e(\"input\",t.parentNode)[0]),!e.datepicker._isDisabledDatepicker(t)&&e.datepicker._lastInput!==t){var i,n,a,o,h,l,u;i=e.datepicker._getInst(t),e.datepicker._curInst&&e.datepicker._curInst!==i&&(e.datepicker._curInst.dpDiv.stop(!0,!0),i&&e.datepicker._datepickerShowing&&e.datepicker._hideDatepicker(e.datepicker._curInst.input[0])),n=e.datepicker._get(i,\"beforeShow\"),a=n?n.apply(t,[t,i]):{},a!==!1&&(r(i.settings,a),i.lastVal=null,e.datepicker._lastInput=t,e.datepicker._setDateFromField(i),e.datepicker._inDialog&&(t.value=\"\"),e.datepicker._pos||(e.datepicker._pos=e.datepicker._findPos(t),e.datepicker._pos[1]+=t.offsetHeight),o=!1,e(t).parents().each(function(){return o|=\"fixed\"===e(this).css(\"position\"),!o}),h={left:e.datepicker._pos[0],top:e.datepicker._pos[1]},e.datepicker._pos=null,i.dpDiv.empty(),i.dpDiv.css({position:\"absolute\",display:\"block\",top:\"-1000px\"}),e.datepicker._updateDatepicker(i),h=e.datepicker._checkOffset(i,h,o),i.dpDiv.css({position:e.datepicker._inDialog&&e.blockUI?\"static\":o?\"fixed\":\"absolute\",display:\"none\",left:h.left+\"px\",top:h.top+\"px\"}),i.inline||(l=e.datepicker._get(i,\"showAnim\"),u=e.datepicker._get(i,\"duration\"),i.dpDiv.css(\"z-index\",s(e(t))+1),e.datepicker._datepickerShowing=!0,e.effects&&e.effects.effect[l]?i.dpDiv.show(l,e.datepicker._get(i,\"showOptions\"),u):i.dpDiv[l||\"show\"](l?u:null),e.datepicker._shouldFocusInput(i)&&i.input.focus(),e.datepicker._curInst=i))}},_updateDatepicker:function(t){this.maxRows=4,v=t,t.dpDiv.empty().append(this._generateHTML(t)),this._attachHandlers(t);var i,s=this._getNumberOfMonths(t),n=s[1],a=17,r=t.dpDiv.find(\".\"+this._dayOverClass+\" a\");r.length>0&&o.apply(r.get(0)),t.dpDiv.removeClass(\"ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4\").width(\"\"),n>1&&t.dpDiv.addClass(\"ui-datepicker-multi-\"+n).css(\"width\",a*n+\"em\"),t.dpDiv[(1!==s[0]||1!==s[1]?\"add\":\"remove\")+\"Class\"](\"ui-datepicker-multi\"),t.dpDiv[(this._get(t,\"isRTL\")?\"add\":\"remove\")+\"Class\"](\"ui-datepicker-rtl\"),t===e.datepicker._curInst&&e.datepicker._datepickerShowing&&e.datepicker._shouldFocusInput(t)&&t.input.focus(),t.yearshtml&&(i=t.yearshtml,setTimeout(function(){i===t.yearshtml&&t.yearshtml&&t.dpDiv.find(\"select.ui-datepicker-year:first\").replaceWith(t.yearshtml),i=t.yearshtml=null},0))},_shouldFocusInput:function(e){return e.input&&e.input.is(\":visible\")&&!e.input.is(\":disabled\")&&!e.input.is(\":focus\")},_checkOffset:function(t,i,s){var n=t.dpDiv.outerWidth(),a=t.dpDiv.outerHeight(),o=t.input?t.input.outerWidth():0,r=t.input?t.input.outerHeight():0,h=document.documentElement.clientWidth+(s?0:e(document).scrollLeft()),l=document.documentElement.clientHeight+(s?0:e(document).scrollTop());return i.left-=this._get(t,\"isRTL\")?n-o:0,i.left-=s&&i.left===t.input.offset().left?e(document).scrollLeft():0,i.top-=s&&i.top===t.input.offset().top+r?e(document).scrollTop():0,i.left-=Math.min(i.left,i.left+n>h&&h>n?Math.abs(i.left+n-h):0),i.top-=Math.min(i.top,i.top+a>l&&l>a?Math.abs(a+r):0),i},_findPos:function(t){for(var i,s=this._getInst(t),n=this._get(s,\"isRTL\");t&&(\"hidden\"===t.type||1!==t.nodeType||e.expr.filters.hidden(t));)t=t[n?\"previousSibling\":\"nextSibling\"];return i=e(t).offset(),[i.left,i.top]},_hideDatepicker:function(t){var i,s,n,a,o=this._curInst;!o||t&&o!==e.data(t,\"datepicker\")||this._datepickerShowing&&(i=this._get(o,\"showAnim\"),s=this._get(o,\"duration\"),n=function(){e.datepicker._tidyDialog(o)},e.effects&&(e.effects.effect[i]||e.effects[i])?o.dpDiv.hide(i,e.datepicker._get(o,\"showOptions\"),s,n):o.dpDiv[\"slideDown\"===i?\"slideUp\":\"fadeIn\"===i?\"fadeOut\":\"hide\"](i?s:null,n),i||n(),this._datepickerShowing=!1,a=this._get(o,\"onClose\"),a&&a.apply(o.input?o.input[0]:null,[o.input?o.input.val():\"\",o]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:\"absolute\",left:\"0\",top:\"-100px\"}),e.blockUI&&(e.unblockUI(),e(\"body\").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(e){e.dpDiv.removeClass(this._dialogClass).unbind(\".ui-datepicker-calendar\")},_checkExternalClick:function(t){if(e.datepicker._curInst){var i=e(t.target),s=e.datepicker._getInst(i[0]);(i[0].id!==e.datepicker._mainDivId&&0===i.parents(\"#\"+e.datepicker._mainDivId).length&&!i.hasClass(e.datepicker.markerClassName)&&!i.closest(\".\"+e.datepicker._triggerClass).length&&e.datepicker._datepickerShowing&&(!e.datepicker._inDialog||!e.blockUI)||i.hasClass(e.datepicker.markerClassName)&&e.datepicker._curInst!==s)&&e.datepicker._hideDatepicker()}},_adjustDate:function(t,i,s){var n=e(t),a=this._getInst(n[0]);this._isDisabledDatepicker(n[0])||(this._adjustInstDate(a,i+(\"M\"===s?this._get(a,\"showCurrentAtPos\"):0),s),this._updateDatepicker(a))},_gotoToday:function(t){var i,s=e(t),n=this._getInst(s[0]);this._get(n,\"gotoCurrent\")&&n.currentDay?(n.selectedDay=n.currentDay,n.drawMonth=n.selectedMonth=n.currentMonth,n.drawYear=n.selectedYear=n.currentYear):(i=new Date,n.selectedDay=i.getDate(),n.drawMonth=n.selectedMonth=i.getMonth(),n.drawYear=n.selectedYear=i.getFullYear()),this._notifyChange(n),this._adjustDate(s)},_selectMonthYear:function(t,i,s){var n=e(t),a=this._getInst(n[0]);a[\"selected\"+(\"M\"===s?\"Month\":\"Year\")]=a[\"draw\"+(\"M\"===s?\"Month\":\"Year\")]=parseInt(i.options[i.selectedIndex].value,10),this._notifyChange(a),this._adjustDate(n)},_selectDay:function(t,i,s,n){var a,o=e(t);e(n).hasClass(this._unselectableClass)||this._isDisabledDatepicker(o[0])||(a=this._getInst(o[0]),a.selectedDay=a.currentDay=e(\"a\",n).html(),a.selectedMonth=a.currentMonth=i,a.selectedYear=a.currentYear=s,this._selectDate(t,this._formatDate(a,a.currentDay,a.currentMonth,a.currentYear)))},_clearDate:function(t){var i=e(t);this._selectDate(i,\"\")},_selectDate:function(t,i){var s,n=e(t),a=this._getInst(n[0]);i=null!=i?i:this._formatDate(a),a.input&&a.input.val(i),this._updateAlternate(a),s=this._get(a,\"onSelect\"),s?s.apply(a.input?a.input[0]:null,[i,a]):a.input&&a.input.trigger(\"change\"),a.inline?this._updateDatepicker(a):(this._hideDatepicker(),this._lastInput=a.input[0],\"object\"!=typeof a.input[0]&&a.input.focus(),this._lastInput=null)},_updateAlternate:function(t){var i,s,n,a=this._get(t,\"altField\");a&&(i=this._get(t,\"altFormat\")||this._get(t,\"dateFormat\"),s=this._getDate(t),n=this.formatDate(i,s,this._getFormatConfig(t)),e(a).each(function(){e(this).val(n)}))},noWeekends:function(e){var t=e.getDay();return[t>0&&6>t,\"\"]},iso8601Week:function(e){var t,i=new Date(e.getTime());return i.setDate(i.getDate()+4-(i.getDay()||7)),t=i.getTime(),i.setMonth(0),i.setDate(1),Math.floor(Math.round((t-i)/864e5)/7)+1},parseDate:function(t,i,s){if(null==t||null==i)throw\"Invalid arguments\";if(i=\"object\"==typeof i?\"\"+i:i+\"\",\"\"===i)return null;var n,a,o,r,h=0,l=(s?s.shortYearCutoff:null)||this._defaults.shortYearCutoff,u=\"string\"!=typeof l?l:(new Date).getFullYear()%100+parseInt(l,10),d=(s?s.dayNamesShort:null)||this._defaults.dayNamesShort,c=(s?s.dayNames:null)||this._defaults.dayNames,p=(s?s.monthNamesShort:null)||this._defaults.monthNamesShort,f=(s?s.monthNames:null)||this._defaults.monthNames,m=-1,g=-1,v=-1,y=-1,b=!1,_=function(e){var i=t.length>n+1&&t.charAt(n+1)===e;return i&&n++,i},x=function(e){var t=_(e),s=\"@\"===e?14:\"!\"===e?20:\"y\"===e&&t?4:\"o\"===e?3:2,n=\"y\"===e?s:1,a=RegExp(\"^\\\\d{\"+n+\",\"+s+\"}\"),o=i.substring(h).match(a);if(!o)throw\"Missing number at position \"+h;return h+=o[0].length,parseInt(o[0],10)},w=function(t,s,n){var a=-1,o=e.map(_(t)?n:s,function(e,t){return[[t,e]]}).sort(function(e,t){return-(e[1].length-t[1].length)});if(e.each(o,function(e,t){var s=t[1];return i.substr(h,s.length).toLowerCase()===s.toLowerCase()?(a=t[0],h+=s.length,!1):void 0}),-1!==a)return a+1;throw\"Unknown name at position \"+h},k=function(){if(i.charAt(h)!==t.charAt(n))throw\"Unexpected literal at position \"+h;h++};for(n=0;t.length>n;n++)if(b)\"'\"!==t.charAt(n)||_(\"'\")?k():b=!1;else switch(t.charAt(n)){case\"d\":v=x(\"d\");break;case\"D\":w(\"D\",d,c);break;case\"o\":y=x(\"o\");break;case\"m\":g=x(\"m\");break;case\"M\":g=w(\"M\",p,f);break;case\"y\":m=x(\"y\");break;case\"@\":r=new Date(x(\"@\")),m=r.getFullYear(),g=r.getMonth()+1,v=r.getDate();break;case\"!\":r=new Date((x(\"!\")-this._ticksTo1970)/1e4),m=r.getFullYear(),g=r.getMonth()+1,v=r.getDate();break;case\"'\":_(\"'\")?k():b=!0;break;default:k()}if(i.length>h&&(o=i.substr(h),!/^\\s+/.test(o)))throw\"Extra/unparsed characters found in date: \"+o;if(-1===m?m=(new Date).getFullYear():100>m&&(m+=(new Date).getFullYear()-(new Date).getFullYear()%100+(u>=m?0:-100)),y>-1)for(g=1,v=y;;){if(a=this._getDaysInMonth(m,g-1),a>=v)break;g++,v-=a}if(r=this._daylightSavingAdjust(new Date(m,g-1,v)),r.getFullYear()!==m||r.getMonth()+1!==g||r.getDate()!==v)throw\"Invalid date\";return r},ATOM:\"yy-mm-dd\",COOKIE:\"D, dd M yy\",ISO_8601:\"yy-mm-dd\",RFC_822:\"D, d M y\",RFC_850:\"DD, dd-M-y\",RFC_1036:\"D, d M y\",RFC_1123:\"D, d M yy\",RFC_2822:\"D, d M yy\",RSS:\"D, d M y\",TICKS:\"!\",TIMESTAMP:\"@\",W3C:\"yy-mm-dd\",_ticksTo1970:1e7*60*60*24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925)),formatDate:function(e,t,i){if(!t)return\"\";var s,n=(i?i.dayNamesShort:null)||this._defaults.dayNamesShort,a=(i?i.dayNames:null)||this._defaults.dayNames,o=(i?i.monthNamesShort:null)||this._defaults.monthNamesShort,r=(i?i.monthNames:null)||this._defaults.monthNames,h=function(t){var i=e.length>s+1&&e.charAt(s+1)===t;return i&&s++,i},l=function(e,t,i){var s=\"\"+t;if(h(e))for(;i>s.length;)s=\"0\"+s;return s},u=function(e,t,i,s){return h(e)?s[t]:i[t]},d=\"\",c=!1;if(t)for(s=0;e.length>s;s++)if(c)\"'\"!==e.charAt(s)||h(\"'\")?d+=e.charAt(s):c=!1;else switch(e.charAt(s)){case\"d\":d+=l(\"d\",t.getDate(),2);break;case\"D\":d+=u(\"D\",t.getDay(),n,a);break;case\"o\":d+=l(\"o\",Math.round((new Date(t.getFullYear(),t.getMonth(),t.getDate()).getTime()-new Date(t.getFullYear(),0,0).getTime())/864e5),3);break;case\"m\":d+=l(\"m\",t.getMonth()+1,2);break;case\"M\":d+=u(\"M\",t.getMonth(),o,r);break;case\"y\":d+=h(\"y\")?t.getFullYear():(10>t.getYear()%100?\"0\":\"\")+t.getYear()%100;break;case\"@\":d+=t.getTime();break;case\"!\":d+=1e4*t.getTime()+this._ticksTo1970;break;case\"'\":h(\"'\")?d+=\"'\":c=!0;break;default:d+=e.charAt(s)}return d},_possibleChars:function(e){var t,i=\"\",s=!1,n=function(i){var s=e.length>t+1&&e.charAt(t+1)===i;return s&&t++,s};for(t=0;e.length>t;t++)if(s)\"'\"!==e.charAt(t)||n(\"'\")?i+=e.charAt(t):s=!1;else switch(e.charAt(t)){case\"d\":case\"m\":case\"y\":case\"@\":i+=\"0123456789\";break;case\"D\":case\"M\":return null;case\"'\":n(\"'\")?i+=\"'\":s=!0;break;default:i+=e.charAt(t)}return i},_get:function(e,t){return void 0!==e.settings[t]?e.settings[t]:this._defaults[t]},_setDateFromField:function(e,t){if(e.input.val()!==e.lastVal){var i=this._get(e,\"dateFormat\"),s=e.lastVal=e.input?e.input.val():null,n=this._getDefaultDate(e),a=n,o=this._getFormatConfig(e);try{a=this.parseDate(i,s,o)||n}catch(r){s=t?\"\":s}e.selectedDay=a.getDate(),e.drawMonth=e.selectedMonth=a.getMonth(),e.drawYear=e.selectedYear=a.getFullYear(),e.currentDay=s?a.getDate():0,e.currentMonth=s?a.getMonth():0,e.currentYear=s?a.getFullYear():0,this._adjustInstDate(e)}},_getDefaultDate:function(e){return this._restrictMinMax(e,this._determineDate(e,this._get(e,\"defaultDate\"),new Date))},_determineDate:function(t,i,s){var n=function(e){var t=new Date;return t.setDate(t.getDate()+e),t},a=function(i){try{return e.datepicker.parseDate(e.datepicker._get(t,\"dateFormat\"),i,e.datepicker._getFormatConfig(t))}catch(s){}for(var n=(i.toLowerCase().match(/^c/)?e.datepicker._getDate(t):null)||new Date,a=n.getFullYear(),o=n.getMonth(),r=n.getDate(),h=/([+\\-]?[0-9]+)\\s*(d|D|w|W|m|M|y|Y)?/g,l=h.exec(i);l;){switch(l[2]||\"d\"){case\"d\":case\"D\":r+=parseInt(l[1],10);break;case\"w\":case\"W\":r+=7*parseInt(l[1],10);break;case\"m\":case\"M\":o+=parseInt(l[1],10),r=Math.min(r,e.datepicker._getDaysInMonth(a,o));break;case\"y\":case\"Y\":a+=parseInt(l[1],10),r=Math.min(r,e.datepicker._getDaysInMonth(a,o))}l=h.exec(i)}return new Date(a,o,r)},o=null==i||\"\"===i?s:\"string\"==typeof i?a(i):\"number\"==typeof i?isNaN(i)?s:n(i):new Date(i.getTime());return o=o&&\"Invalid Date\"==\"\"+o?s:o,o&&(o.setHours(0),o.setMinutes(0),o.setSeconds(0),o.setMilliseconds(0)),this._daylightSavingAdjust(o)},_daylightSavingAdjust:function(e){return e?(e.setHours(e.getHours()>12?e.getHours()+2:0),e):null},_setDate:function(e,t,i){var s=!t,n=e.selectedMonth,a=e.selectedYear,o=this._restrictMinMax(e,this._determineDate(e,t,new Date));e.selectedDay=e.currentDay=o.getDate(),e.drawMonth=e.selectedMonth=e.currentMonth=o.getMonth(),e.drawYear=e.selectedYear=e.currentYear=o.getFullYear(),n===e.selectedMonth&&a===e.selectedYear||i||this._notifyChange(e),this._adjustInstDate(e),e.input&&e.input.val(s?\"\":this._formatDate(e))},_getDate:function(e){var t=!e.currentYear||e.input&&\"\"===e.input.val()?null:this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return t},_attachHandlers:function(t){var i=this._get(t,\"stepMonths\"),s=\"#\"+t.id.replace(/\\\\\\\\/g,\"\\\\\");t.dpDiv.find(\"[data-handler]\").map(function(){var t={prev:function(){e.datepicker._adjustDate(s,-i,\"M\")},next:function(){e.datepicker._adjustDate(s,+i,\"M\")},hide:function(){e.datepicker._hideDatepicker()},today:function(){e.datepicker._gotoToday(s)},selectDay:function(){return e.datepicker._selectDay(s,+this.getAttribute(\"data-month\"),+this.getAttribute(\"data-year\"),this),!1},selectMonth:function(){return e.datepicker._selectMonthYear(s,this,\"M\"),!1},selectYear:function(){return e.datepicker._selectMonthYear(s,this,\"Y\"),!1}};e(this).bind(this.getAttribute(\"data-event\"),t[this.getAttribute(\"data-handler\")])})},_generateHTML:function(e){var t,i,s,n,a,o,r,h,l,u,d,c,p,f,m,g,v,y,b,_,x,w,k,T,D,S,M,C,N,A,P,I,H,z,F,E,O,j,W,L=new Date,R=this._daylightSavingAdjust(new Date(L.getFullYear(),L.getMonth(),L.getDate())),Y=this._get(e,\"isRTL\"),B=this._get(e,\"showButtonPanel\"),J=this._get(e,\"hideIfNoPrevNext\"),q=this._get(e,\"navigationAsDateFormat\"),K=this._getNumberOfMonths(e),V=this._get(e,\"showCurrentAtPos\"),U=this._get(e,\"stepMonths\"),Q=1!==K[0]||1!==K[1],G=this._daylightSavingAdjust(e.currentDay?new Date(e.currentYear,e.currentMonth,e.currentDay):new Date(9999,9,9)),X=this._getMinMaxDate(e,\"min\"),$=this._getMinMaxDate(e,\"max\"),Z=e.drawMonth-V,et=e.drawYear;if(0>Z&&(Z+=12,et--),$)for(t=this._daylightSavingAdjust(new Date($.getFullYear(),$.getMonth()-K[0]*K[1]+1,$.getDate())),t=X&&X>t?X:t;this._daylightSavingAdjust(new Date(et,Z,1))>t;)Z--,0>Z&&(Z=11,et--);for(e.drawMonth=Z,e.drawYear=et,i=this._get(e,\"prevText\"),i=q?this.formatDate(i,this._daylightSavingAdjust(new Date(et,Z-U,1)),this._getFormatConfig(e)):i,s=this._canAdjustMonth(e,-1,et,Z)?\"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='\"+i+\"'><span class='ui-icon ui-icon-circle-triangle-\"+(Y?\"e\":\"w\")+\"'>\"+i+\"</span></a>\":J?\"\":\"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='\"+i+\"'><span class='ui-icon ui-icon-circle-triangle-\"+(Y?\"e\":\"w\")+\"'>\"+i+\"</span></a>\",n=this._get(e,\"nextText\"),n=q?this.formatDate(n,this._daylightSavingAdjust(new Date(et,Z+U,1)),this._getFormatConfig(e)):n,a=this._canAdjustMonth(e,1,et,Z)?\"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='\"+n+\"'><span class='ui-icon ui-icon-circle-triangle-\"+(Y?\"w\":\"e\")+\"'>\"+n+\"</span></a>\":J?\"\":\"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='\"+n+\"'><span class='ui-icon ui-icon-circle-triangle-\"+(Y?\"w\":\"e\")+\"'>\"+n+\"</span></a>\",o=this._get(e,\"currentText\"),r=this._get(e,\"gotoCurrent\")&&e.currentDay?G:R,o=q?this.formatDate(o,r,this._getFormatConfig(e)):o,h=e.inline?\"\":\"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>\"+this._get(e,\"closeText\")+\"</button>\",l=B?\"<div class='ui-datepicker-buttonpane ui-widget-content'>\"+(Y?h:\"\")+(this._isInRange(e,r)?\"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>\"+o+\"</button>\":\"\")+(Y?\"\":h)+\"</div>\":\"\",u=parseInt(this._get(e,\"firstDay\"),10),u=isNaN(u)?0:u,d=this._get(e,\"showWeek\"),c=this._get(e,\"dayNames\"),p=this._get(e,\"dayNamesMin\"),f=this._get(e,\"monthNames\"),m=this._get(e,\"monthNamesShort\"),g=this._get(e,\"beforeShowDay\"),v=this._get(e,\"showOtherMonths\"),y=this._get(e,\"selectOtherMonths\"),b=this._getDefaultDate(e),_=\"\",w=0;K[0]>w;w++){for(k=\"\",this.maxRows=4,T=0;K[1]>T;T++){if(D=this._daylightSavingAdjust(new Date(et,Z,e.selectedDay)),S=\" ui-corner-all\",M=\"\",Q){if(M+=\"<div class='ui-datepicker-group\",K[1]>1)switch(T){case 0:M+=\" ui-datepicker-group-first\",S=\" ui-corner-\"+(Y?\"right\":\"left\");break;case K[1]-1:M+=\" ui-datepicker-group-last\",S=\" ui-corner-\"+(Y?\"left\":\"right\");break;default:M+=\" ui-datepicker-group-middle\",S=\"\"}M+=\"'>\"}for(M+=\"<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix\"+S+\"'>\"+(/all|left/.test(S)&&0===w?Y?a:s:\"\")+(/all|right/.test(S)&&0===w?Y?s:a:\"\")+this._generateMonthYearHeader(e,Z,et,X,$,w>0||T>0,f,m)+\"</div><table class='ui-datepicker-calendar'><thead>\"+\"<tr>\",C=d?\"<th class='ui-datepicker-week-col'>\"+this._get(e,\"weekHeader\")+\"</th>\":\"\",x=0;7>x;x++)N=(x+u)%7,C+=\"<th scope='col'\"+((x+u+6)%7>=5?\" class='ui-datepicker-week-end'\":\"\")+\">\"+\"<span title='\"+c[N]+\"'>\"+p[N]+\"</span></th>\";for(M+=C+\"</tr></thead><tbody>\",A=this._getDaysInMonth(et,Z),et===e.selectedYear&&Z===e.selectedMonth&&(e.selectedDay=Math.min(e.selectedDay,A)),P=(this._getFirstDayOfMonth(et,Z)-u+7)%7,I=Math.ceil((P+A)/7),H=Q?this.maxRows>I?this.maxRows:I:I,this.maxRows=H,z=this._daylightSavingAdjust(new Date(et,Z,1-P)),F=0;H>F;F++){for(M+=\"<tr>\",E=d?\"<td class='ui-datepicker-week-col'>\"+this._get(e,\"calculateWeek\")(z)+\"</td>\":\"\",x=0;7>x;x++)O=g?g.apply(e.input?e.input[0]:null,[z]):[!0,\"\"],j=z.getMonth()!==Z,W=j&&!y||!O[0]||X&&X>z||$&&z>$,E+=\"<td class='\"+((x+u+6)%7>=5?\" ui-datepicker-week-end\":\"\")+(j?\" ui-datepicker-other-month\":\"\")+(z.getTime()===D.getTime()&&Z===e.selectedMonth&&e._keyEvent||b.getTime()===z.getTime()&&b.getTime()===D.getTime()?\" \"+this._dayOverClass:\"\")+(W?\" \"+this._unselectableClass+\" ui-state-disabled\":\"\")+(j&&!v?\"\":\" \"+O[1]+(z.getTime()===G.getTime()?\" \"+this._currentClass:\"\")+(z.getTime()===R.getTime()?\" ui-datepicker-today\":\"\"))+\"'\"+(j&&!v||!O[2]?\"\":\" title='\"+O[2].replace(/'/g,\"&#39;\")+\"'\")+(W?\"\":\" data-handler='selectDay' data-event='click' data-month='\"+z.getMonth()+\"' data-year='\"+z.getFullYear()+\"'\")+\">\"+(j&&!v?\"&#xa0;\":W?\"<span class='ui-state-default'>\"+z.getDate()+\"</span>\":\"<a class='ui-state-default\"+(z.getTime()===R.getTime()?\" ui-state-highlight\":\"\")+(z.getTime()===G.getTime()?\" ui-state-active\":\"\")+(j?\" ui-priority-secondary\":\"\")+\"' href='#'>\"+z.getDate()+\"</a>\")+\"</td>\",z.setDate(z.getDate()+1),z=this._daylightSavingAdjust(z);M+=E+\"</tr>\"}Z++,Z>11&&(Z=0,et++),M+=\"</tbody></table>\"+(Q?\"</div>\"+(K[0]>0&&T===K[1]-1?\"<div class='ui-datepicker-row-break'></div>\":\"\"):\"\"),k+=M}_+=k}return _+=l,e._keyEvent=!1,_},_generateMonthYearHeader:function(e,t,i,s,n,a,o,r){var h,l,u,d,c,p,f,m,g=this._get(e,\"changeMonth\"),v=this._get(e,\"changeYear\"),y=this._get(e,\"showMonthAfterYear\"),b=\"<div class='ui-datepicker-title'>\",_=\"\";if(a||!g)_+=\"<span class='ui-datepicker-month'>\"+o[t]+\"</span>\";else{for(h=s&&s.getFullYear()===i,l=n&&n.getFullYear()===i,_+=\"<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>\",u=0;12>u;u++)(!h||u>=s.getMonth())&&(!l||n.getMonth()>=u)&&(_+=\"<option value='\"+u+\"'\"+(u===t?\" selected='selected'\":\"\")+\">\"+r[u]+\"</option>\");_+=\"</select>\"}if(y||(b+=_+(!a&&g&&v?\"\":\"&#xa0;\")),!e.yearshtml)if(e.yearshtml=\"\",a||!v)b+=\"<span class='ui-datepicker-year'>\"+i+\"</span>\";else{for(d=this._get(e,\"yearRange\").split(\":\"),c=(new Date).getFullYear(),p=function(e){var t=e.match(/c[+\\-].*/)?i+parseInt(e.substring(1),10):e.match(/[+\\-].*/)?c+parseInt(e,10):parseInt(e,10);return isNaN(t)?c:t},f=p(d[0]),m=Math.max(f,p(d[1]||\"\")),f=s?Math.max(f,s.getFullYear()):f,m=n?Math.min(m,n.getFullYear()):m,e.yearshtml+=\"<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>\";m>=f;f++)e.yearshtml+=\"<option value='\"+f+\"'\"+(f===i?\" selected='selected'\":\"\")+\">\"+f+\"</option>\";e.yearshtml+=\"</select>\",b+=e.yearshtml,e.yearshtml=null}return b+=this._get(e,\"yearSuffix\"),y&&(b+=(!a&&g&&v?\"\":\"&#xa0;\")+_),b+=\"</div>\"},_adjustInstDate:function(e,t,i){var s=e.drawYear+(\"Y\"===i?t:0),n=e.drawMonth+(\"M\"===i?t:0),a=Math.min(e.selectedDay,this._getDaysInMonth(s,n))+(\"D\"===i?t:0),o=this._restrictMinMax(e,this._daylightSavingAdjust(new Date(s,n,a)));e.selectedDay=o.getDate(),e.drawMonth=e.selectedMonth=o.getMonth(),e.drawYear=e.selectedYear=o.getFullYear(),(\"M\"===i||\"Y\"===i)&&this._notifyChange(e)},_restrictMinMax:function(e,t){var i=this._getMinMaxDate(e,\"min\"),s=this._getMinMaxDate(e,\"max\"),n=i&&i>t?i:t;return s&&n>s?s:n},_notifyChange:function(e){var t=this._get(e,\"onChangeMonthYear\");t&&t.apply(e.input?e.input[0]:null,[e.selectedYear,e.selectedMonth+1,e])},_getNumberOfMonths:function(e){var t=this._get(e,\"numberOfMonths\");return null==t?[1,1]:\"number\"==typeof t?[1,t]:t},_getMinMaxDate:function(e,t){return this._determineDate(e,this._get(e,t+\"Date\"),null)},_getDaysInMonth:function(e,t){return 32-this._daylightSavingAdjust(new Date(e,t,32)).getDate()},_getFirstDayOfMonth:function(e,t){return new Date(e,t,1).getDay()},_canAdjustMonth:function(e,t,i,s){var n=this._getNumberOfMonths(e),a=this._daylightSavingAdjust(new Date(i,s+(0>t?t:n[0]*n[1]),1));return 0>t&&a.setDate(this._getDaysInMonth(a.getFullYear(),a.getMonth())),this._isInRange(e,a)},_isInRange:function(e,t){var i,s,n=this._getMinMaxDate(e,\"min\"),a=this._getMinMaxDate(e,\"max\"),o=null,r=null,h=this._get(e,\"yearRange\");return h&&(i=h.split(\":\"),s=(new Date).getFullYear(),o=parseInt(i[0],10),r=parseInt(i[1],10),i[0].match(/[+\\-].*/)&&(o+=s),i[1].match(/[+\\-].*/)&&(r+=s)),(!n||t.getTime()>=n.getTime())&&(!a||t.getTime()<=a.getTime())&&(!o||t.getFullYear()>=o)&&(!r||r>=t.getFullYear())},_getFormatConfig:function(e){var t=this._get(e,\"shortYearCutoff\");return t=\"string\"!=typeof t?t:(new Date).getFullYear()%100+parseInt(t,10),{shortYearCutoff:t,dayNamesShort:this._get(e,\"dayNamesShort\"),dayNames:this._get(e,\"dayNames\"),monthNamesShort:this._get(e,\"monthNamesShort\"),monthNames:this._get(e,\"monthNames\")}},_formatDate:function(e,t,i,s){t||(e.currentDay=e.selectedDay,e.currentMonth=e.selectedMonth,e.currentYear=e.selectedYear);var n=t?\"object\"==typeof t?t:this._daylightSavingAdjust(new Date(s,i,t)):this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return this.formatDate(this._get(e,\"dateFormat\"),n,this._getFormatConfig(e))}}),e.fn.datepicker=function(t){if(!this.length)return this;e.datepicker.initialized||(e(document).mousedown(e.datepicker._checkExternalClick),e.datepicker.initialized=!0),0===e(\"#\"+e.datepicker._mainDivId).length&&e(\"body\").append(e.datepicker.dpDiv);var i=Array.prototype.slice.call(arguments,1);return\"string\"!=typeof t||\"isDisabled\"!==t&&\"getDate\"!==t&&\"widget\"!==t?\"option\"===t&&2===arguments.length&&\"string\"==typeof arguments[1]?e.datepicker[\"_\"+t+\"Datepicker\"].apply(e.datepicker,[this[0]].concat(i)):this.each(function(){\"string\"==typeof t?e.datepicker[\"_\"+t+\"Datepicker\"].apply(e.datepicker,[this].concat(i)):e.datepicker._attachDatepicker(this,t)}):e.datepicker[\"_\"+t+\"Datepicker\"].apply(e.datepicker,[this[0]].concat(i))},e.datepicker=new n,e.datepicker.initialized=!1,e.datepicker.uuid=(new Date).getTime(),e.datepicker.version=\"1.11.4\",e.datepicker,e.widget(\"ui.dialog\",{version:\"1.11.4\",options:{appendTo:\"body\",autoOpen:!0,buttons:[],closeOnEscape:!0,closeText:\"Close\",dialogClass:\"\",draggable:!0,hide:null,height:\"auto\",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:\"center\",at:\"center\",of:window,collision:\"fit\",using:function(t){var i=e(this).css(t).offset().top;0>i&&e(this).css(\"top\",t.top-i)}},resizable:!0,show:null,title:null,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},sizeRelatedOptions:{buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},resizableRelatedOptions:{maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr(\"title\"),this.options.title=this.options.title||this.originalTitle,this._createWrapper(),this.element.show().removeAttr(\"title\").addClass(\"ui-dialog-content ui-widget-content\").appendTo(this.uiDialog),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&e.fn.draggable&&this._makeDraggable(),this.options.resizable&&e.fn.resizable&&this._makeResizable(),this._isOpen=!1,this._trackFocus()},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var t=this.options.appendTo;return t&&(t.jquery||t.nodeType)?e(t):this.document.find(t||\"body\").eq(0)},_destroy:function(){var e,t=this.originalPosition;this._untrackInstance(),this._destroyOverlay(),this.element.removeUniqueId().removeClass(\"ui-dialog-content ui-widget-content\").css(this.originalCss).detach(),this.uiDialog.stop(!0,!0).remove(),this.originalTitle&&this.element.attr(\"title\",this.originalTitle),e=t.parent.children().eq(t.index),e.length&&e[0]!==this.element[0]?e.before(this.element):t.parent.append(this.element)},widget:function(){return this.uiDialog},disable:e.noop,enable:e.noop,close:function(t){var i,s=this;if(this._isOpen&&this._trigger(\"beforeClose\",t)!==!1){if(this._isOpen=!1,this._focusedElement=null,this._destroyOverlay(),this._untrackInstance(),!this.opener.filter(\":focusable\").focus().length)try{i=this.document[0].activeElement,i&&\"body\"!==i.nodeName.toLowerCase()&&e(i).blur()}catch(n){}this._hide(this.uiDialog,this.options.hide,function(){s._trigger(\"close\",t)})}},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(t,i){var s=!1,n=this.uiDialog.siblings(\".ui-front:visible\").map(function(){return+e(this).css(\"z-index\")}).get(),a=Math.max.apply(null,n);return a>=+this.uiDialog.css(\"z-index\")&&(this.uiDialog.css(\"z-index\",a+1),s=!0),s&&!i&&this._trigger(\"focus\",t),s},open:function(){var t=this;\nreturn this._isOpen?(this._moveToTop()&&this._focusTabbable(),void 0):(this._isOpen=!0,this.opener=e(this.document[0].activeElement),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this.overlay&&this.overlay.css(\"z-index\",this.uiDialog.css(\"z-index\")-1),this._show(this.uiDialog,this.options.show,function(){t._focusTabbable(),t._trigger(\"focus\")}),this._makeFocusTarget(),this._trigger(\"open\"),void 0)},_focusTabbable:function(){var e=this._focusedElement;e||(e=this.element.find(\"[autofocus]\")),e.length||(e=this.element.find(\":tabbable\")),e.length||(e=this.uiDialogButtonPane.find(\":tabbable\")),e.length||(e=this.uiDialogTitlebarClose.filter(\":tabbable\")),e.length||(e=this.uiDialog),e.eq(0).focus()},_keepFocus:function(t){function i(){var t=this.document[0].activeElement,i=this.uiDialog[0]===t||e.contains(this.uiDialog[0],t);i||this._focusTabbable()}t.preventDefault(),i.call(this),this._delay(i)},_createWrapper:function(){this.uiDialog=e(\"<div>\").addClass(\"ui-dialog ui-widget ui-widget-content ui-corner-all ui-front \"+this.options.dialogClass).hide().attr({tabIndex:-1,role:\"dialog\"}).appendTo(this._appendTo()),this._on(this.uiDialog,{keydown:function(t){if(this.options.closeOnEscape&&!t.isDefaultPrevented()&&t.keyCode&&t.keyCode===e.ui.keyCode.ESCAPE)return t.preventDefault(),this.close(t),void 0;if(t.keyCode===e.ui.keyCode.TAB&&!t.isDefaultPrevented()){var i=this.uiDialog.find(\":tabbable\"),s=i.filter(\":first\"),n=i.filter(\":last\");t.target!==n[0]&&t.target!==this.uiDialog[0]||t.shiftKey?t.target!==s[0]&&t.target!==this.uiDialog[0]||!t.shiftKey||(this._delay(function(){n.focus()}),t.preventDefault()):(this._delay(function(){s.focus()}),t.preventDefault())}},mousedown:function(e){this._moveToTop(e)&&this._focusTabbable()}}),this.element.find(\"[aria-describedby]\").length||this.uiDialog.attr({\"aria-describedby\":this.element.uniqueId().attr(\"id\")})},_createTitlebar:function(){var t;this.uiDialogTitlebar=e(\"<div>\").addClass(\"ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix\").prependTo(this.uiDialog),this._on(this.uiDialogTitlebar,{mousedown:function(t){e(t.target).closest(\".ui-dialog-titlebar-close\")||this.uiDialog.focus()}}),this.uiDialogTitlebarClose=e(\"<button type='button'></button>\").button({label:this.options.closeText,icons:{primary:\"ui-icon-closethick\"},text:!1}).addClass(\"ui-dialog-titlebar-close\").appendTo(this.uiDialogTitlebar),this._on(this.uiDialogTitlebarClose,{click:function(e){e.preventDefault(),this.close(e)}}),t=e(\"<span>\").uniqueId().addClass(\"ui-dialog-title\").prependTo(this.uiDialogTitlebar),this._title(t),this.uiDialog.attr({\"aria-labelledby\":t.attr(\"id\")})},_title:function(e){this.options.title||e.html(\"&#160;\"),e.text(this.options.title)},_createButtonPane:function(){this.uiDialogButtonPane=e(\"<div>\").addClass(\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\"),this.uiButtonSet=e(\"<div>\").addClass(\"ui-dialog-buttonset\").appendTo(this.uiDialogButtonPane),this._createButtons()},_createButtons:function(){var t=this,i=this.options.buttons;return this.uiDialogButtonPane.remove(),this.uiButtonSet.empty(),e.isEmptyObject(i)||e.isArray(i)&&!i.length?(this.uiDialog.removeClass(\"ui-dialog-buttons\"),void 0):(e.each(i,function(i,s){var n,a;s=e.isFunction(s)?{click:s,text:i}:s,s=e.extend({type:\"button\"},s),n=s.click,s.click=function(){n.apply(t.element[0],arguments)},a={icons:s.icons,text:s.showText},delete s.icons,delete s.showText,e(\"<button></button>\",s).button(a).appendTo(t.uiButtonSet)}),this.uiDialog.addClass(\"ui-dialog-buttons\"),this.uiDialogButtonPane.appendTo(this.uiDialog),void 0)},_makeDraggable:function(){function t(e){return{position:e.position,offset:e.offset}}var i=this,s=this.options;this.uiDialog.draggable({cancel:\".ui-dialog-content, .ui-dialog-titlebar-close\",handle:\".ui-dialog-titlebar\",containment:\"document\",start:function(s,n){e(this).addClass(\"ui-dialog-dragging\"),i._blockFrames(),i._trigger(\"dragStart\",s,t(n))},drag:function(e,s){i._trigger(\"drag\",e,t(s))},stop:function(n,a){var o=a.offset.left-i.document.scrollLeft(),r=a.offset.top-i.document.scrollTop();s.position={my:\"left top\",at:\"left\"+(o>=0?\"+\":\"\")+o+\" \"+\"top\"+(r>=0?\"+\":\"\")+r,of:i.window},e(this).removeClass(\"ui-dialog-dragging\"),i._unblockFrames(),i._trigger(\"dragStop\",n,t(a))}})},_makeResizable:function(){function t(e){return{originalPosition:e.originalPosition,originalSize:e.originalSize,position:e.position,size:e.size}}var i=this,s=this.options,n=s.resizable,a=this.uiDialog.css(\"position\"),o=\"string\"==typeof n?n:\"n,e,s,w,se,sw,ne,nw\";this.uiDialog.resizable({cancel:\".ui-dialog-content\",containment:\"document\",alsoResize:this.element,maxWidth:s.maxWidth,maxHeight:s.maxHeight,minWidth:s.minWidth,minHeight:this._minHeight(),handles:o,start:function(s,n){e(this).addClass(\"ui-dialog-resizing\"),i._blockFrames(),i._trigger(\"resizeStart\",s,t(n))},resize:function(e,s){i._trigger(\"resize\",e,t(s))},stop:function(n,a){var o=i.uiDialog.offset(),r=o.left-i.document.scrollLeft(),h=o.top-i.document.scrollTop();s.height=i.uiDialog.height(),s.width=i.uiDialog.width(),s.position={my:\"left top\",at:\"left\"+(r>=0?\"+\":\"\")+r+\" \"+\"top\"+(h>=0?\"+\":\"\")+h,of:i.window},e(this).removeClass(\"ui-dialog-resizing\"),i._unblockFrames(),i._trigger(\"resizeStop\",n,t(a))}}).css(\"position\",a)},_trackFocus:function(){this._on(this.widget(),{focusin:function(t){this._makeFocusTarget(),this._focusedElement=e(t.target)}})},_makeFocusTarget:function(){this._untrackInstance(),this._trackingInstances().unshift(this)},_untrackInstance:function(){var t=this._trackingInstances(),i=e.inArray(this,t);-1!==i&&t.splice(i,1)},_trackingInstances:function(){var e=this.document.data(\"ui-dialog-instances\");return e||(e=[],this.document.data(\"ui-dialog-instances\",e)),e},_minHeight:function(){var e=this.options;return\"auto\"===e.height?e.minHeight:Math.min(e.minHeight,e.height)},_position:function(){var e=this.uiDialog.is(\":visible\");e||this.uiDialog.show(),this.uiDialog.position(this.options.position),e||this.uiDialog.hide()},_setOptions:function(t){var i=this,s=!1,n={};e.each(t,function(e,t){i._setOption(e,t),e in i.sizeRelatedOptions&&(s=!0),e in i.resizableRelatedOptions&&(n[e]=t)}),s&&(this._size(),this._position()),this.uiDialog.is(\":data(ui-resizable)\")&&this.uiDialog.resizable(\"option\",n)},_setOption:function(e,t){var i,s,n=this.uiDialog;\"dialogClass\"===e&&n.removeClass(this.options.dialogClass).addClass(t),\"disabled\"!==e&&(this._super(e,t),\"appendTo\"===e&&this.uiDialog.appendTo(this._appendTo()),\"buttons\"===e&&this._createButtons(),\"closeText\"===e&&this.uiDialogTitlebarClose.button({label:\"\"+t}),\"draggable\"===e&&(i=n.is(\":data(ui-draggable)\"),i&&!t&&n.draggable(\"destroy\"),!i&&t&&this._makeDraggable()),\"position\"===e&&this._position(),\"resizable\"===e&&(s=n.is(\":data(ui-resizable)\"),s&&!t&&n.resizable(\"destroy\"),s&&\"string\"==typeof t&&n.resizable(\"option\",\"handles\",t),s||t===!1||this._makeResizable()),\"title\"===e&&this._title(this.uiDialogTitlebar.find(\".ui-dialog-title\")))},_size:function(){var e,t,i,s=this.options;this.element.show().css({width:\"auto\",minHeight:0,maxHeight:\"none\",height:0}),s.minWidth>s.width&&(s.width=s.minWidth),e=this.uiDialog.css({height:\"auto\",width:s.width}).outerHeight(),t=Math.max(0,s.minHeight-e),i=\"number\"==typeof s.maxHeight?Math.max(0,s.maxHeight-e):\"none\",\"auto\"===s.height?this.element.css({minHeight:t,maxHeight:i,height:\"auto\"}):this.element.height(Math.max(0,s.height-e)),this.uiDialog.is(\":data(ui-resizable)\")&&this.uiDialog.resizable(\"option\",\"minHeight\",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find(\"iframe\").map(function(){var t=e(this);return e(\"<div>\").css({position:\"absolute\",width:t.outerWidth(),height:t.outerHeight()}).appendTo(t.parent()).offset(t.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_allowInteraction:function(t){return e(t.target).closest(\".ui-dialog\").length?!0:!!e(t.target).closest(\".ui-datepicker\").length},_createOverlay:function(){if(this.options.modal){var t=!0;this._delay(function(){t=!1}),this.document.data(\"ui-dialog-overlays\")||this._on(this.document,{focusin:function(e){t||this._allowInteraction(e)||(e.preventDefault(),this._trackingInstances()[0]._focusTabbable())}}),this.overlay=e(\"<div>\").addClass(\"ui-widget-overlay ui-front\").appendTo(this._appendTo()),this._on(this.overlay,{mousedown:\"_keepFocus\"}),this.document.data(\"ui-dialog-overlays\",(this.document.data(\"ui-dialog-overlays\")||0)+1)}},_destroyOverlay:function(){if(this.options.modal&&this.overlay){var e=this.document.data(\"ui-dialog-overlays\")-1;e?this.document.data(\"ui-dialog-overlays\",e):this.document.unbind(\"focusin\").removeData(\"ui-dialog-overlays\"),this.overlay.remove(),this.overlay=null}}}),e.widget(\"ui.progressbar\",{version:\"1.11.4\",options:{max:100,value:0,change:null,complete:null},min:0,_create:function(){this.oldValue=this.options.value=this._constrainedValue(),this.element.addClass(\"ui-progressbar ui-widget ui-widget-content ui-corner-all\").attr({role:\"progressbar\",\"aria-valuemin\":this.min}),this.valueDiv=e(\"<div class='ui-progressbar-value ui-widget-header ui-corner-left'></div>\").appendTo(this.element),this._refreshValue()},_destroy:function(){this.element.removeClass(\"ui-progressbar ui-widget ui-widget-content ui-corner-all\").removeAttr(\"role\").removeAttr(\"aria-valuemin\").removeAttr(\"aria-valuemax\").removeAttr(\"aria-valuenow\"),this.valueDiv.remove()},value:function(e){return void 0===e?this.options.value:(this.options.value=this._constrainedValue(e),this._refreshValue(),void 0)},_constrainedValue:function(e){return void 0===e&&(e=this.options.value),this.indeterminate=e===!1,\"number\"!=typeof e&&(e=0),this.indeterminate?!1:Math.min(this.options.max,Math.max(this.min,e))},_setOptions:function(e){var t=e.value;delete e.value,this._super(e),this.options.value=this._constrainedValue(t),this._refreshValue()},_setOption:function(e,t){\"max\"===e&&(t=Math.max(this.min,t)),\"disabled\"===e&&this.element.toggleClass(\"ui-state-disabled\",!!t).attr(\"aria-disabled\",t),this._super(e,t)},_percentage:function(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min)},_refreshValue:function(){var t=this.options.value,i=this._percentage();this.valueDiv.toggle(this.indeterminate||t>this.min).toggleClass(\"ui-corner-right\",t===this.options.max).width(i.toFixed(0)+\"%\"),this.element.toggleClass(\"ui-progressbar-indeterminate\",this.indeterminate),this.indeterminate?(this.element.removeAttr(\"aria-valuenow\"),this.overlayDiv||(this.overlayDiv=e(\"<div class='ui-progressbar-overlay'></div>\").appendTo(this.valueDiv))):(this.element.attr({\"aria-valuemax\":this.options.max,\"aria-valuenow\":t}),this.overlayDiv&&(this.overlayDiv.remove(),this.overlayDiv=null)),this.oldValue!==t&&(this.oldValue=t,this._trigger(\"change\")),t===this.options.max&&this._trigger(\"complete\")}}),e.widget(\"ui.selectmenu\",{version:\"1.11.4\",defaultElement:\"<select>\",options:{appendTo:null,disabled:null,icons:{button:\"ui-icon-triangle-1-s\"},position:{my:\"left top\",at:\"left bottom\",collision:\"none\"},width:null,change:null,close:null,focus:null,open:null,select:null},_create:function(){var e=this.element.uniqueId().attr(\"id\");this.ids={element:e,button:e+\"-button\",menu:e+\"-menu\"},this._drawButton(),this._drawMenu(),this.options.disabled&&this.disable()},_drawButton:function(){var t=this;this.label=e(\"label[for='\"+this.ids.element+\"']\").attr(\"for\",this.ids.button),this._on(this.label,{click:function(e){this.button.focus(),e.preventDefault()}}),this.element.hide(),this.button=e(\"<span>\",{\"class\":\"ui-selectmenu-button ui-widget ui-state-default ui-corner-all\",tabindex:this.options.disabled?-1:0,id:this.ids.button,role:\"combobox\",\"aria-expanded\":\"false\",\"aria-autocomplete\":\"list\",\"aria-owns\":this.ids.menu,\"aria-haspopup\":\"true\"}).insertAfter(this.element),e(\"<span>\",{\"class\":\"ui-icon \"+this.options.icons.button}).prependTo(this.button),this.buttonText=e(\"<span>\",{\"class\":\"ui-selectmenu-text\"}).appendTo(this.button),this._setText(this.buttonText,this.element.find(\"option:selected\").text()),this._resizeButton(),this._on(this.button,this._buttonEvents),this.button.one(\"focusin\",function(){t.menuItems||t._refreshMenu()}),this._hoverable(this.button),this._focusable(this.button)},_drawMenu:function(){var t=this;this.menu=e(\"<ul>\",{\"aria-hidden\":\"true\",\"aria-labelledby\":this.ids.button,id:this.ids.menu}),this.menuWrap=e(\"<div>\",{\"class\":\"ui-selectmenu-menu ui-front\"}).append(this.menu).appendTo(this._appendTo()),this.menuInstance=this.menu.menu({role:\"listbox\",select:function(e,i){e.preventDefault(),t._setSelection(),t._select(i.item.data(\"ui-selectmenu-item\"),e)},focus:function(e,i){var s=i.item.data(\"ui-selectmenu-item\");null!=t.focusIndex&&s.index!==t.focusIndex&&(t._trigger(\"focus\",e,{item:s}),t.isOpen||t._select(s,e)),t.focusIndex=s.index,t.button.attr(\"aria-activedescendant\",t.menuItems.eq(s.index).attr(\"id\"))}}).menu(\"instance\"),this.menu.addClass(\"ui-corner-bottom\").removeClass(\"ui-corner-all\"),this.menuInstance._off(this.menu,\"mouseleave\"),this.menuInstance._closeOnDocumentClick=function(){return!1},this.menuInstance._isDivider=function(){return!1}},refresh:function(){this._refreshMenu(),this._setText(this.buttonText,this._getSelectedItem().text()),this.options.width||this._resizeButton()},_refreshMenu:function(){this.menu.empty();var e,t=this.element.find(\"option\");t.length&&(this._parseOptions(t),this._renderMenu(this.menu,this.items),this.menuInstance.refresh(),this.menuItems=this.menu.find(\"li\").not(\".ui-selectmenu-optgroup\"),e=this._getSelectedItem(),this.menuInstance.focus(null,e),this._setAria(e.data(\"ui-selectmenu-item\")),this._setOption(\"disabled\",this.element.prop(\"disabled\")))},open:function(e){this.options.disabled||(this.menuItems?(this.menu.find(\".ui-state-focus\").removeClass(\"ui-state-focus\"),this.menuInstance.focus(null,this._getSelectedItem())):this._refreshMenu(),this.isOpen=!0,this._toggleAttr(),this._resizeMenu(),this._position(),this._on(this.document,this._documentClick),this._trigger(\"open\",e))},_position:function(){this.menuWrap.position(e.extend({of:this.button},this.options.position))},close:function(e){this.isOpen&&(this.isOpen=!1,this._toggleAttr(),this.range=null,this._off(this.document),this._trigger(\"close\",e))},widget:function(){return this.button},menuWidget:function(){return this.menu},_renderMenu:function(t,i){var s=this,n=\"\";e.each(i,function(i,a){a.optgroup!==n&&(e(\"<li>\",{\"class\":\"ui-selectmenu-optgroup ui-menu-divider\"+(a.element.parent(\"optgroup\").prop(\"disabled\")?\" ui-state-disabled\":\"\"),text:a.optgroup}).appendTo(t),n=a.optgroup),s._renderItemData(t,a)})},_renderItemData:function(e,t){return this._renderItem(e,t).data(\"ui-selectmenu-item\",t)},_renderItem:function(t,i){var s=e(\"<li>\");return i.disabled&&s.addClass(\"ui-state-disabled\"),this._setText(s,i.label),s.appendTo(t)},_setText:function(e,t){t?e.text(t):e.html(\"&#160;\")},_move:function(e,t){var i,s,n=\".ui-menu-item\";this.isOpen?i=this.menuItems.eq(this.focusIndex):(i=this.menuItems.eq(this.element[0].selectedIndex),n+=\":not(.ui-state-disabled)\"),s=\"first\"===e||\"last\"===e?i[\"first\"===e?\"prevAll\":\"nextAll\"](n).eq(-1):i[e+\"All\"](n).eq(0),s.length&&this.menuInstance.focus(t,s)},_getSelectedItem:function(){return this.menuItems.eq(this.element[0].selectedIndex)},_toggle:function(e){this[this.isOpen?\"close\":\"open\"](e)},_setSelection:function(){var e;this.range&&(window.getSelection?(e=window.getSelection(),e.removeAllRanges(),e.addRange(this.range)):this.range.select(),this.button.focus())},_documentClick:{mousedown:function(t){this.isOpen&&(e(t.target).closest(\".ui-selectmenu-menu, #\"+this.ids.button).length||this.close(t))}},_buttonEvents:{mousedown:function(){var e;window.getSelection?(e=window.getSelection(),e.rangeCount&&(this.range=e.getRangeAt(0))):this.range=document.selection.createRange()},click:function(e){this._setSelection(),this._toggle(e)},keydown:function(t){var i=!0;switch(t.keyCode){case e.ui.keyCode.TAB:case e.ui.keyCode.ESCAPE:this.close(t),i=!1;break;case e.ui.keyCode.ENTER:this.isOpen&&this._selectFocusedItem(t);break;case e.ui.keyCode.UP:t.altKey?this._toggle(t):this._move(\"prev\",t);break;case e.ui.keyCode.DOWN:t.altKey?this._toggle(t):this._move(\"next\",t);break;case e.ui.keyCode.SPACE:this.isOpen?this._selectFocusedItem(t):this._toggle(t);break;case e.ui.keyCode.LEFT:this._move(\"prev\",t);break;case e.ui.keyCode.RIGHT:this._move(\"next\",t);break;case e.ui.keyCode.HOME:case e.ui.keyCode.PAGE_UP:this._move(\"first\",t);break;case e.ui.keyCode.END:case e.ui.keyCode.PAGE_DOWN:this._move(\"last\",t);break;default:this.menu.trigger(t),i=!1}i&&t.preventDefault()}},_selectFocusedItem:function(e){var t=this.menuItems.eq(this.focusIndex);t.hasClass(\"ui-state-disabled\")||this._select(t.data(\"ui-selectmenu-item\"),e)},_select:function(e,t){var i=this.element[0].selectedIndex;this.element[0].selectedIndex=e.index,this._setText(this.buttonText,e.label),this._setAria(e),this._trigger(\"select\",t,{item:e}),e.index!==i&&this._trigger(\"change\",t,{item:e}),this.close(t)},_setAria:function(e){var t=this.menuItems.eq(e.index).attr(\"id\");this.button.attr({\"aria-labelledby\":t,\"aria-activedescendant\":t}),this.menu.attr(\"aria-activedescendant\",t)},_setOption:function(e,t){\"icons\"===e&&this.button.find(\"span.ui-icon\").removeClass(this.options.icons.button).addClass(t.button),this._super(e,t),\"appendTo\"===e&&this.menuWrap.appendTo(this._appendTo()),\"disabled\"===e&&(this.menuInstance.option(\"disabled\",t),this.button.toggleClass(\"ui-state-disabled\",t).attr(\"aria-disabled\",t),this.element.prop(\"disabled\",t),t?(this.button.attr(\"tabindex\",-1),this.close()):this.button.attr(\"tabindex\",0)),\"width\"===e&&this._resizeButton()},_appendTo:function(){var t=this.options.appendTo;return t&&(t=t.jquery||t.nodeType?e(t):this.document.find(t).eq(0)),t&&t[0]||(t=this.element.closest(\".ui-front\")),t.length||(t=this.document[0].body),t},_toggleAttr:function(){this.button.toggleClass(\"ui-corner-top\",this.isOpen).toggleClass(\"ui-corner-all\",!this.isOpen).attr(\"aria-expanded\",this.isOpen),this.menuWrap.toggleClass(\"ui-selectmenu-open\",this.isOpen),this.menu.attr(\"aria-hidden\",!this.isOpen)},_resizeButton:function(){var e=this.options.width;e||(e=this.element.show().outerWidth(),this.element.hide()),this.button.outerWidth(e)},_resizeMenu:function(){this.menu.outerWidth(Math.max(this.button.outerWidth(),this.menu.width(\"\").outerWidth()+1))},_getCreateOptions:function(){return{disabled:this.element.prop(\"disabled\")}},_parseOptions:function(t){var i=[];t.each(function(t,s){var n=e(s),a=n.parent(\"optgroup\");i.push({element:n,index:t,value:n.val(),label:n.text(),optgroup:a.attr(\"label\")||\"\",disabled:a.prop(\"disabled\")||n.prop(\"disabled\")})}),this.items=i},_destroy:function(){this.menuWrap.remove(),this.button.remove(),this.element.show(),this.element.removeUniqueId(),this.label.attr(\"for\",this.ids.element)}}),e.widget(\"ui.slider\",e.ui.mouse,{version:\"1.11.4\",widgetEventPrefix:\"slide\",options:{animate:!1,distance:0,max:100,min:0,orientation:\"horizontal\",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},numPages:5,_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this._calculateNewMax(),this.element.addClass(\"ui-slider ui-slider-\"+this.orientation+\" ui-widget\"+\" ui-widget-content\"+\" ui-corner-all\"),this._refresh(),this._setOption(\"disabled\",this.options.disabled),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var t,i,s=this.options,n=this.element.find(\".ui-slider-handle\").addClass(\"ui-state-default ui-corner-all\"),a=\"<span class='ui-slider-handle ui-state-default ui-corner-all' tabindex='0'></span>\",o=[];for(i=s.values&&s.values.length||1,n.length>i&&(n.slice(i).remove(),n=n.slice(0,i)),t=n.length;i>t;t++)o.push(a);this.handles=n.add(e(o.join(\"\")).appendTo(this.element)),this.handle=this.handles.eq(0),this.handles.each(function(t){e(this).data(\"ui-slider-handle-index\",t)})},_createRange:function(){var t=this.options,i=\"\";t.range?(t.range===!0&&(t.values?t.values.length&&2!==t.values.length?t.values=[t.values[0],t.values[0]]:e.isArray(t.values)&&(t.values=t.values.slice(0)):t.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?this.range.removeClass(\"ui-slider-range-min ui-slider-range-max\").css({left:\"\",bottom:\"\"}):(this.range=e(\"<div></div>\").appendTo(this.element),i=\"ui-slider-range ui-widget-header ui-corner-all\"),this.range.addClass(i+(\"min\"===t.range||\"max\"===t.range?\" ui-slider-range-\"+t.range:\"\"))):(this.range&&this.range.remove(),this.range=null)},_setupEvents:function(){this._off(this.handles),this._on(this.handles,this._handleEvents),this._hoverable(this.handles),this._focusable(this.handles)},_destroy:function(){this.handles.remove(),this.range&&this.range.remove(),this.element.removeClass(\"ui-slider ui-slider-horizontal ui-slider-vertical ui-widget ui-widget-content ui-corner-all\"),this._mouseDestroy()},_mouseCapture:function(t){var i,s,n,a,o,r,h,l,u=this,d=this.options;return d.disabled?!1:(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),i={x:t.pageX,y:t.pageY},s=this._normValueFromMouse(i),n=this._valueMax()-this._valueMin()+1,this.handles.each(function(t){var i=Math.abs(s-u.values(t));(n>i||n===i&&(t===u._lastChangedValue||u.values(t)===d.min))&&(n=i,a=e(this),o=t)}),r=this._start(t,o),r===!1?!1:(this._mouseSliding=!0,this._handleIndex=o,a.addClass(\"ui-state-active\").focus(),h=a.offset(),l=!e(t.target).parents().addBack().is(\".ui-slider-handle\"),this._clickOffset=l?{left:0,top:0}:{left:t.pageX-h.left-a.width()/2,top:t.pageY-h.top-a.height()/2-(parseInt(a.css(\"borderTopWidth\"),10)||0)-(parseInt(a.css(\"borderBottomWidth\"),10)||0)+(parseInt(a.css(\"marginTop\"),10)||0)},this.handles.hasClass(\"ui-state-hover\")||this._slide(t,o,s),this._animateOff=!0,!0))},_mouseStart:function(){return!0},_mouseDrag:function(e){var t={x:e.pageX,y:e.pageY},i=this._normValueFromMouse(t);return this._slide(e,this._handleIndex,i),!1},_mouseStop:function(e){return this.handles.removeClass(\"ui-state-active\"),this._mouseSliding=!1,this._stop(e,this._handleIndex),this._change(e,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1,!1},_detectOrientation:function(){this.orientation=\"vertical\"===this.options.orientation?\"vertical\":\"horizontal\"},_normValueFromMouse:function(e){var t,i,s,n,a;return\"horizontal\"===this.orientation?(t=this.elementSize.width,i=e.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(t=this.elementSize.height,i=e.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),s=i/t,s>1&&(s=1),0>s&&(s=0),\"vertical\"===this.orientation&&(s=1-s),n=this._valueMax()-this._valueMin(),a=this._valueMin()+s*n,this._trimAlignValue(a)},_start:function(e,t){var i={handle:this.handles[t],value:this.value()};return this.options.values&&this.options.values.length&&(i.value=this.values(t),i.values=this.values()),this._trigger(\"start\",e,i)},_slide:function(e,t,i){var s,n,a;this.options.values&&this.options.values.length?(s=this.values(t?0:1),2===this.options.values.length&&this.options.range===!0&&(0===t&&i>s||1===t&&s>i)&&(i=s),i!==this.values(t)&&(n=this.values(),n[t]=i,a=this._trigger(\"slide\",e,{handle:this.handles[t],value:i,values:n}),s=this.values(t?0:1),a!==!1&&this.values(t,i))):i!==this.value()&&(a=this._trigger(\"slide\",e,{handle:this.handles[t],value:i}),a!==!1&&this.value(i))},_stop:function(e,t){var i={handle:this.handles[t],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(t),i.values=this.values()),this._trigger(\"stop\",e,i)},_change:function(e,t){if(!this._keySliding&&!this._mouseSliding){var i={handle:this.handles[t],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(t),i.values=this.values()),this._lastChangedValue=t,this._trigger(\"change\",e,i)}},value:function(e){return arguments.length?(this.options.value=this._trimAlignValue(e),this._refreshValue(),this._change(null,0),void 0):this._value()},values:function(t,i){var s,n,a;if(arguments.length>1)return this.options.values[t]=this._trimAlignValue(i),this._refreshValue(),this._change(null,t),void 0;if(!arguments.length)return this._values();if(!e.isArray(arguments[0]))return this.options.values&&this.options.values.length?this._values(t):this.value();for(s=this.options.values,n=arguments[0],a=0;s.length>a;a+=1)s[a]=this._trimAlignValue(n[a]),this._change(null,a);this._refreshValue()},_setOption:function(t,i){var s,n=0;switch(\"range\"===t&&this.options.range===!0&&(\"min\"===i?(this.options.value=this._values(0),this.options.values=null):\"max\"===i&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),e.isArray(this.options.values)&&(n=this.options.values.length),\"disabled\"===t&&this.element.toggleClass(\"ui-state-disabled\",!!i),this._super(t,i),t){case\"orientation\":this._detectOrientation(),this.element.removeClass(\"ui-slider-horizontal ui-slider-vertical\").addClass(\"ui-slider-\"+this.orientation),this._refreshValue(),this.handles.css(\"horizontal\"===i?\"bottom\":\"left\",\"\");break;case\"value\":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case\"values\":for(this._animateOff=!0,this._refreshValue(),s=0;n>s;s+=1)this._change(null,s);this._animateOff=!1;break;case\"step\":case\"min\":case\"max\":this._animateOff=!0,this._calculateNewMax(),this._refreshValue(),this._animateOff=!1;break;case\"range\":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_value:function(){var e=this.options.value;return e=this._trimAlignValue(e)},_values:function(e){var t,i,s;if(arguments.length)return t=this.options.values[e],t=this._trimAlignValue(t);if(this.options.values&&this.options.values.length){for(i=this.options.values.slice(),s=0;i.length>s;s+=1)i[s]=this._trimAlignValue(i[s]);return i}return[]},_trimAlignValue:function(e){if(this._valueMin()>=e)return this._valueMin();if(e>=this._valueMax())return this._valueMax();var t=this.options.step>0?this.options.step:1,i=(e-this._valueMin())%t,s=e-i;return 2*Math.abs(i)>=t&&(s+=i>0?t:-t),parseFloat(s.toFixed(5))},_calculateNewMax:function(){var e=this.options.max,t=this._valueMin(),i=this.options.step,s=Math.floor(+(e-t).toFixed(this._precision())/i)*i;e=s+t,this.max=parseFloat(e.toFixed(this._precision()))},_precision:function(){var e=this._precisionOf(this.options.step);return null!==this.options.min&&(e=Math.max(e,this._precisionOf(this.options.min))),e},_precisionOf:function(e){var t=\"\"+e,i=t.indexOf(\".\");return-1===i?0:t.length-i-1},_valueMin:function(){return this.options.min},_valueMax:function(){return this.max},_refreshValue:function(){var t,i,s,n,a,o=this.options.range,r=this.options,h=this,l=this._animateOff?!1:r.animate,u={};this.options.values&&this.options.values.length?this.handles.each(function(s){i=100*((h.values(s)-h._valueMin())/(h._valueMax()-h._valueMin())),u[\"horizontal\"===h.orientation?\"left\":\"bottom\"]=i+\"%\",e(this).stop(1,1)[l?\"animate\":\"css\"](u,r.animate),h.options.range===!0&&(\"horizontal\"===h.orientation?(0===s&&h.range.stop(1,1)[l?\"animate\":\"css\"]({left:i+\"%\"},r.animate),1===s&&h.range[l?\"animate\":\"css\"]({width:i-t+\"%\"},{queue:!1,duration:r.animate})):(0===s&&h.range.stop(1,1)[l?\"animate\":\"css\"]({bottom:i+\"%\"},r.animate),1===s&&h.range[l?\"animate\":\"css\"]({height:i-t+\"%\"},{queue:!1,duration:r.animate}))),t=i}):(s=this.value(),n=this._valueMin(),a=this._valueMax(),i=a!==n?100*((s-n)/(a-n)):0,u[\"horizontal\"===this.orientation?\"left\":\"bottom\"]=i+\"%\",this.handle.stop(1,1)[l?\"animate\":\"css\"](u,r.animate),\"min\"===o&&\"horizontal\"===this.orientation&&this.range.stop(1,1)[l?\"animate\":\"css\"]({width:i+\"%\"},r.animate),\"max\"===o&&\"horizontal\"===this.orientation&&this.range[l?\"animate\":\"css\"]({width:100-i+\"%\"},{queue:!1,duration:r.animate}),\"min\"===o&&\"vertical\"===this.orientation&&this.range.stop(1,1)[l?\"animate\":\"css\"]({height:i+\"%\"},r.animate),\"max\"===o&&\"vertical\"===this.orientation&&this.range[l?\"animate\":\"css\"]({height:100-i+\"%\"},{queue:!1,duration:r.animate}))},_handleEvents:{keydown:function(t){var i,s,n,a,o=e(t.target).data(\"ui-slider-handle-index\");switch(t.keyCode){case e.ui.keyCode.HOME:case e.ui.keyCode.END:case e.ui.keyCode.PAGE_UP:case e.ui.keyCode.PAGE_DOWN:case e.ui.keyCode.UP:case e.ui.keyCode.RIGHT:case e.ui.keyCode.DOWN:case e.ui.keyCode.LEFT:if(t.preventDefault(),!this._keySliding&&(this._keySliding=!0,e(t.target).addClass(\"ui-state-active\"),i=this._start(t,o),i===!1))return}switch(a=this.options.step,s=n=this.options.values&&this.options.values.length?this.values(o):this.value(),t.keyCode){case e.ui.keyCode.HOME:n=this._valueMin();break;case e.ui.keyCode.END:n=this._valueMax();break;case e.ui.keyCode.PAGE_UP:n=this._trimAlignValue(s+(this._valueMax()-this._valueMin())/this.numPages);break;case e.ui.keyCode.PAGE_DOWN:n=this._trimAlignValue(s-(this._valueMax()-this._valueMin())/this.numPages);break;case e.ui.keyCode.UP:case e.ui.keyCode.RIGHT:if(s===this._valueMax())return;n=this._trimAlignValue(s+a);break;case e.ui.keyCode.DOWN:case e.ui.keyCode.LEFT:if(s===this._valueMin())return;n=this._trimAlignValue(s-a)}this._slide(t,o,n)},keyup:function(t){var i=e(t.target).data(\"ui-slider-handle-index\");this._keySliding&&(this._keySliding=!1,this._stop(t,i),this._change(t,i),e(t.target).removeClass(\"ui-state-active\"))}}}),e.widget(\"ui.spinner\",{version:\"1.11.4\",defaultElement:\"<input>\",widgetEventPrefix:\"spin\",options:{culture:null,icons:{down:\"ui-icon-triangle-1-s\",up:\"ui-icon-triangle-1-n\"},incremental:!0,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function(){this._setOption(\"max\",this.options.max),this._setOption(\"min\",this.options.min),this._setOption(\"step\",this.options.step),\"\"!==this.value()&&this._value(this.element.val(),!0),this._draw(),this._on(this._events),this._refresh(),this._on(this.window,{beforeunload:function(){this.element.removeAttr(\"autocomplete\")}})},_getCreateOptions:function(){var t={},i=this.element;return e.each([\"min\",\"max\",\"step\"],function(e,s){var n=i.attr(s);void 0!==n&&n.length&&(t[s]=n)}),t},_events:{keydown:function(e){this._start(e)&&this._keydown(e)&&e.preventDefault()},keyup:\"_stop\",focus:function(){this.previous=this.element.val()},blur:function(e){return this.cancelBlur?(delete this.cancelBlur,void 0):(this._stop(),this._refresh(),this.previous!==this.element.val()&&this._trigger(\"change\",e),void 0)},mousewheel:function(e,t){if(t){if(!this.spinning&&!this._start(e))return!1;this._spin((t>0?1:-1)*this.options.step,e),clearTimeout(this.mousewheelTimer),this.mousewheelTimer=this._delay(function(){this.spinning&&this._stop(e)},100),e.preventDefault()}},\"mousedown .ui-spinner-button\":function(t){function i(){var e=this.element[0]===this.document[0].activeElement;e||(this.element.focus(),this.previous=s,this._delay(function(){this.previous=s}))}var s;s=this.element[0]===this.document[0].activeElement?this.previous:this.element.val(),t.preventDefault(),i.call(this),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,i.call(this)}),this._start(t)!==!1&&this._repeat(null,e(t.currentTarget).hasClass(\"ui-spinner-up\")?1:-1,t)},\"mouseup .ui-spinner-button\":\"_stop\",\"mouseenter .ui-spinner-button\":function(t){return e(t.currentTarget).hasClass(\"ui-state-active\")?this._start(t)===!1?!1:(this._repeat(null,e(t.currentTarget).hasClass(\"ui-spinner-up\")?1:-1,t),void 0):void 0},\"mouseleave .ui-spinner-button\":\"_stop\"},_draw:function(){var e=this.uiSpinner=this.element.addClass(\"ui-spinner-input\").attr(\"autocomplete\",\"off\").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml());this.element.attr(\"role\",\"spinbutton\"),this.buttons=e.find(\".ui-spinner-button\").attr(\"tabIndex\",-1).button().removeClass(\"ui-corner-all\"),this.buttons.height()>Math.ceil(.5*e.height())&&e.height()>0&&e.height(e.height()),this.options.disabled&&this.disable()\n},_keydown:function(t){var i=this.options,s=e.ui.keyCode;switch(t.keyCode){case s.UP:return this._repeat(null,1,t),!0;case s.DOWN:return this._repeat(null,-1,t),!0;case s.PAGE_UP:return this._repeat(null,i.page,t),!0;case s.PAGE_DOWN:return this._repeat(null,-i.page,t),!0}return!1},_uiSpinnerHtml:function(){return\"<span class='ui-spinner ui-widget ui-widget-content ui-corner-all'></span>\"},_buttonHtml:function(){return\"<a class='ui-spinner-button ui-spinner-up ui-corner-tr'><span class='ui-icon \"+this.options.icons.up+\"'>&#9650;</span>\"+\"</a>\"+\"<a class='ui-spinner-button ui-spinner-down ui-corner-br'>\"+\"<span class='ui-icon \"+this.options.icons.down+\"'>&#9660;</span>\"+\"</a>\"},_start:function(e){return this.spinning||this._trigger(\"start\",e)!==!1?(this.counter||(this.counter=1),this.spinning=!0,!0):!1},_repeat:function(e,t,i){e=e||500,clearTimeout(this.timer),this.timer=this._delay(function(){this._repeat(40,t,i)},e),this._spin(t*this.options.step,i)},_spin:function(e,t){var i=this.value()||0;this.counter||(this.counter=1),i=this._adjustValue(i+e*this._increment(this.counter)),this.spinning&&this._trigger(\"spin\",t,{value:i})===!1||(this._value(i),this.counter++)},_increment:function(t){var i=this.options.incremental;return i?e.isFunction(i)?i(t):Math.floor(t*t*t/5e4-t*t/500+17*t/200+1):1},_precision:function(){var e=this._precisionOf(this.options.step);return null!==this.options.min&&(e=Math.max(e,this._precisionOf(this.options.min))),e},_precisionOf:function(e){var t=\"\"+e,i=t.indexOf(\".\");return-1===i?0:t.length-i-1},_adjustValue:function(e){var t,i,s=this.options;return t=null!==s.min?s.min:0,i=e-t,i=Math.round(i/s.step)*s.step,e=t+i,e=parseFloat(e.toFixed(this._precision())),null!==s.max&&e>s.max?s.max:null!==s.min&&s.min>e?s.min:e},_stop:function(e){this.spinning&&(clearTimeout(this.timer),clearTimeout(this.mousewheelTimer),this.counter=0,this.spinning=!1,this._trigger(\"stop\",e))},_setOption:function(e,t){if(\"culture\"===e||\"numberFormat\"===e){var i=this._parse(this.element.val());return this.options[e]=t,this.element.val(this._format(i)),void 0}(\"max\"===e||\"min\"===e||\"step\"===e)&&\"string\"==typeof t&&(t=this._parse(t)),\"icons\"===e&&(this.buttons.first().find(\".ui-icon\").removeClass(this.options.icons.up).addClass(t.up),this.buttons.last().find(\".ui-icon\").removeClass(this.options.icons.down).addClass(t.down)),this._super(e,t),\"disabled\"===e&&(this.widget().toggleClass(\"ui-state-disabled\",!!t),this.element.prop(\"disabled\",!!t),this.buttons.button(t?\"disable\":\"enable\"))},_setOptions:h(function(e){this._super(e)}),_parse:function(e){return\"string\"==typeof e&&\"\"!==e&&(e=window.Globalize&&this.options.numberFormat?Globalize.parseFloat(e,10,this.options.culture):+e),\"\"===e||isNaN(e)?null:e},_format:function(e){return\"\"===e?\"\":window.Globalize&&this.options.numberFormat?Globalize.format(e,this.options.numberFormat,this.options.culture):e},_refresh:function(){this.element.attr({\"aria-valuemin\":this.options.min,\"aria-valuemax\":this.options.max,\"aria-valuenow\":this._parse(this.element.val())})},isValid:function(){var e=this.value();return null===e?!1:e===this._adjustValue(e)},_value:function(e,t){var i;\"\"!==e&&(i=this._parse(e),null!==i&&(t||(i=this._adjustValue(i)),e=this._format(i))),this.element.val(e),this._refresh()},_destroy:function(){this.element.removeClass(\"ui-spinner-input\").prop(\"disabled\",!1).removeAttr(\"autocomplete\").removeAttr(\"role\").removeAttr(\"aria-valuemin\").removeAttr(\"aria-valuemax\").removeAttr(\"aria-valuenow\"),this.uiSpinner.replaceWith(this.element)},stepUp:h(function(e){this._stepUp(e)}),_stepUp:function(e){this._start()&&(this._spin((e||1)*this.options.step),this._stop())},stepDown:h(function(e){this._stepDown(e)}),_stepDown:function(e){this._start()&&(this._spin((e||1)*-this.options.step),this._stop())},pageUp:h(function(e){this._stepUp((e||1)*this.options.page)}),pageDown:h(function(e){this._stepDown((e||1)*this.options.page)}),value:function(e){return arguments.length?(h(this._value).call(this,e),void 0):this._parse(this.element.val())},widget:function(){return this.uiSpinner}}),e.widget(\"ui.tabs\",{version:\"1.11.4\",delay:300,options:{active:null,collapsible:!1,event:\"click\",heightStyle:\"content\",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_isLocal:function(){var e=/#.*$/;return function(t){var i,s;t=t.cloneNode(!1),i=t.href.replace(e,\"\"),s=location.href.replace(e,\"\");try{i=decodeURIComponent(i)}catch(n){}try{s=decodeURIComponent(s)}catch(n){}return t.hash.length>1&&i===s}}(),_create:function(){var t=this,i=this.options;this.running=!1,this.element.addClass(\"ui-tabs ui-widget ui-widget-content ui-corner-all\").toggleClass(\"ui-tabs-collapsible\",i.collapsible),this._processTabs(),i.active=this._initialActive(),e.isArray(i.disabled)&&(i.disabled=e.unique(i.disabled.concat(e.map(this.tabs.filter(\".ui-state-disabled\"),function(e){return t.tabs.index(e)}))).sort()),this.active=this.options.active!==!1&&this.anchors.length?this._findActive(i.active):e(),this._refresh(),this.active.length&&this.load(i.active)},_initialActive:function(){var t=this.options.active,i=this.options.collapsible,s=location.hash.substring(1);return null===t&&(s&&this.tabs.each(function(i,n){return e(n).attr(\"aria-controls\")===s?(t=i,!1):void 0}),null===t&&(t=this.tabs.index(this.tabs.filter(\".ui-tabs-active\"))),(null===t||-1===t)&&(t=this.tabs.length?0:!1)),t!==!1&&(t=this.tabs.index(this.tabs.eq(t)),-1===t&&(t=i?!1:0)),!i&&t===!1&&this.anchors.length&&(t=0),t},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):e()}},_tabKeydown:function(t){var i=e(this.document[0].activeElement).closest(\"li\"),s=this.tabs.index(i),n=!0;if(!this._handlePageNav(t)){switch(t.keyCode){case e.ui.keyCode.RIGHT:case e.ui.keyCode.DOWN:s++;break;case e.ui.keyCode.UP:case e.ui.keyCode.LEFT:n=!1,s--;break;case e.ui.keyCode.END:s=this.anchors.length-1;break;case e.ui.keyCode.HOME:s=0;break;case e.ui.keyCode.SPACE:return t.preventDefault(),clearTimeout(this.activating),this._activate(s),void 0;case e.ui.keyCode.ENTER:return t.preventDefault(),clearTimeout(this.activating),this._activate(s===this.options.active?!1:s),void 0;default:return}t.preventDefault(),clearTimeout(this.activating),s=this._focusNextTab(s,n),t.ctrlKey||t.metaKey||(i.attr(\"aria-selected\",\"false\"),this.tabs.eq(s).attr(\"aria-selected\",\"true\"),this.activating=this._delay(function(){this.option(\"active\",s)},this.delay))}},_panelKeydown:function(t){this._handlePageNav(t)||t.ctrlKey&&t.keyCode===e.ui.keyCode.UP&&(t.preventDefault(),this.active.focus())},_handlePageNav:function(t){return t.altKey&&t.keyCode===e.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):t.altKey&&t.keyCode===e.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):void 0},_findNextTab:function(t,i){function s(){return t>n&&(t=0),0>t&&(t=n),t}for(var n=this.tabs.length-1;-1!==e.inArray(s(),this.options.disabled);)t=i?t+1:t-1;return t},_focusNextTab:function(e,t){return e=this._findNextTab(e,t),this.tabs.eq(e).focus(),e},_setOption:function(e,t){return\"active\"===e?(this._activate(t),void 0):\"disabled\"===e?(this._setupDisabled(t),void 0):(this._super(e,t),\"collapsible\"===e&&(this.element.toggleClass(\"ui-tabs-collapsible\",t),t||this.options.active!==!1||this._activate(0)),\"event\"===e&&this._setupEvents(t),\"heightStyle\"===e&&this._setupHeightStyle(t),void 0)},_sanitizeSelector:function(e){return e?e.replace(/[!\"$%&'()*+,.\\/:;<=>?@\\[\\]\\^`{|}~]/g,\"\\\\$&\"):\"\"},refresh:function(){var t=this.options,i=this.tablist.children(\":has(a[href])\");t.disabled=e.map(i.filter(\".ui-state-disabled\"),function(e){return i.index(e)}),this._processTabs(),t.active!==!1&&this.anchors.length?this.active.length&&!e.contains(this.tablist[0],this.active[0])?this.tabs.length===t.disabled.length?(t.active=!1,this.active=e()):this._activate(this._findNextTab(Math.max(0,t.active-1),!1)):t.active=this.tabs.index(this.active):(t.active=!1,this.active=e()),this._refresh()},_refresh:function(){this._setupDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({\"aria-selected\":\"false\",\"aria-expanded\":\"false\",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({\"aria-hidden\":\"true\"}),this.active.length?(this.active.addClass(\"ui-tabs-active ui-state-active\").attr({\"aria-selected\":\"true\",\"aria-expanded\":\"true\",tabIndex:0}),this._getPanelForTab(this.active).show().attr({\"aria-hidden\":\"false\"})):this.tabs.eq(0).attr(\"tabIndex\",0)},_processTabs:function(){var t=this,i=this.tabs,s=this.anchors,n=this.panels;this.tablist=this._getList().addClass(\"ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all\").attr(\"role\",\"tablist\").delegate(\"> li\",\"mousedown\"+this.eventNamespace,function(t){e(this).is(\".ui-state-disabled\")&&t.preventDefault()}).delegate(\".ui-tabs-anchor\",\"focus\"+this.eventNamespace,function(){e(this).closest(\"li\").is(\".ui-state-disabled\")&&this.blur()}),this.tabs=this.tablist.find(\"> li:has(a[href])\").addClass(\"ui-state-default ui-corner-top\").attr({role:\"tab\",tabIndex:-1}),this.anchors=this.tabs.map(function(){return e(\"a\",this)[0]}).addClass(\"ui-tabs-anchor\").attr({role:\"presentation\",tabIndex:-1}),this.panels=e(),this.anchors.each(function(i,s){var n,a,o,r=e(s).uniqueId().attr(\"id\"),h=e(s).closest(\"li\"),l=h.attr(\"aria-controls\");t._isLocal(s)?(n=s.hash,o=n.substring(1),a=t.element.find(t._sanitizeSelector(n))):(o=h.attr(\"aria-controls\")||e({}).uniqueId()[0].id,n=\"#\"+o,a=t.element.find(n),a.length||(a=t._createPanel(o),a.insertAfter(t.panels[i-1]||t.tablist)),a.attr(\"aria-live\",\"polite\")),a.length&&(t.panels=t.panels.add(a)),l&&h.data(\"ui-tabs-aria-controls\",l),h.attr({\"aria-controls\":o,\"aria-labelledby\":r}),a.attr(\"aria-labelledby\",r)}),this.panels.addClass(\"ui-tabs-panel ui-widget-content ui-corner-bottom\").attr(\"role\",\"tabpanel\"),i&&(this._off(i.not(this.tabs)),this._off(s.not(this.anchors)),this._off(n.not(this.panels)))},_getList:function(){return this.tablist||this.element.find(\"ol,ul\").eq(0)},_createPanel:function(t){return e(\"<div>\").attr(\"id\",t).addClass(\"ui-tabs-panel ui-widget-content ui-corner-bottom\").data(\"ui-tabs-destroy\",!0)},_setupDisabled:function(t){e.isArray(t)&&(t.length?t.length===this.anchors.length&&(t=!0):t=!1);for(var i,s=0;i=this.tabs[s];s++)t===!0||-1!==e.inArray(s,t)?e(i).addClass(\"ui-state-disabled\").attr(\"aria-disabled\",\"true\"):e(i).removeClass(\"ui-state-disabled\").removeAttr(\"aria-disabled\");this.options.disabled=t},_setupEvents:function(t){var i={};t&&e.each(t.split(\" \"),function(e,t){i[t]=\"_eventHandler\"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(!0,this.anchors,{click:function(e){e.preventDefault()}}),this._on(this.anchors,i),this._on(this.tabs,{keydown:\"_tabKeydown\"}),this._on(this.panels,{keydown:\"_panelKeydown\"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(t){var i,s=this.element.parent();\"fill\"===t?(i=s.height(),i-=this.element.outerHeight()-this.element.height(),this.element.siblings(\":visible\").each(function(){var t=e(this),s=t.css(\"position\");\"absolute\"!==s&&\"fixed\"!==s&&(i-=t.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){i-=e(this).outerHeight(!0)}),this.panels.each(function(){e(this).height(Math.max(0,i-e(this).innerHeight()+e(this).height()))}).css(\"overflow\",\"auto\")):\"auto\"===t&&(i=0,this.panels.each(function(){i=Math.max(i,e(this).height(\"\").height())}).height(i))},_eventHandler:function(t){var i=this.options,s=this.active,n=e(t.currentTarget),a=n.closest(\"li\"),o=a[0]===s[0],r=o&&i.collapsible,h=r?e():this._getPanelForTab(a),l=s.length?this._getPanelForTab(s):e(),u={oldTab:s,oldPanel:l,newTab:r?e():a,newPanel:h};t.preventDefault(),a.hasClass(\"ui-state-disabled\")||a.hasClass(\"ui-tabs-loading\")||this.running||o&&!i.collapsible||this._trigger(\"beforeActivate\",t,u)===!1||(i.active=r?!1:this.tabs.index(a),this.active=o?e():a,this.xhr&&this.xhr.abort(),l.length||h.length||e.error(\"jQuery UI Tabs: Mismatching fragment identifier.\"),h.length&&this.load(this.tabs.index(a),t),this._toggle(t,u))},_toggle:function(t,i){function s(){a.running=!1,a._trigger(\"activate\",t,i)}function n(){i.newTab.closest(\"li\").addClass(\"ui-tabs-active ui-state-active\"),o.length&&a.options.show?a._show(o,a.options.show,s):(o.show(),s())}var a=this,o=i.newPanel,r=i.oldPanel;this.running=!0,r.length&&this.options.hide?this._hide(r,this.options.hide,function(){i.oldTab.closest(\"li\").removeClass(\"ui-tabs-active ui-state-active\"),n()}):(i.oldTab.closest(\"li\").removeClass(\"ui-tabs-active ui-state-active\"),r.hide(),n()),r.attr(\"aria-hidden\",\"true\"),i.oldTab.attr({\"aria-selected\":\"false\",\"aria-expanded\":\"false\"}),o.length&&r.length?i.oldTab.attr(\"tabIndex\",-1):o.length&&this.tabs.filter(function(){return 0===e(this).attr(\"tabIndex\")}).attr(\"tabIndex\",-1),o.attr(\"aria-hidden\",\"false\"),i.newTab.attr({\"aria-selected\":\"true\",\"aria-expanded\":\"true\",tabIndex:0})},_activate:function(t){var i,s=this._findActive(t);s[0]!==this.active[0]&&(s.length||(s=this.active),i=s.find(\".ui-tabs-anchor\")[0],this._eventHandler({target:i,currentTarget:i,preventDefault:e.noop}))},_findActive:function(t){return t===!1?e():this.tabs.eq(t)},_getIndex:function(e){return\"string\"==typeof e&&(e=this.anchors.index(this.anchors.filter(\"[href$='\"+e+\"']\"))),e},_destroy:function(){this.xhr&&this.xhr.abort(),this.element.removeClass(\"ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible\"),this.tablist.removeClass(\"ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all\").removeAttr(\"role\"),this.anchors.removeClass(\"ui-tabs-anchor\").removeAttr(\"role\").removeAttr(\"tabIndex\").removeUniqueId(),this.tablist.unbind(this.eventNamespace),this.tabs.add(this.panels).each(function(){e.data(this,\"ui-tabs-destroy\")?e(this).remove():e(this).removeClass(\"ui-state-default ui-state-active ui-state-disabled ui-corner-top ui-corner-bottom ui-widget-content ui-tabs-active ui-tabs-panel\").removeAttr(\"tabIndex\").removeAttr(\"aria-live\").removeAttr(\"aria-busy\").removeAttr(\"aria-selected\").removeAttr(\"aria-labelledby\").removeAttr(\"aria-hidden\").removeAttr(\"aria-expanded\").removeAttr(\"role\")}),this.tabs.each(function(){var t=e(this),i=t.data(\"ui-tabs-aria-controls\");i?t.attr(\"aria-controls\",i).removeData(\"ui-tabs-aria-controls\"):t.removeAttr(\"aria-controls\")}),this.panels.show(),\"content\"!==this.options.heightStyle&&this.panels.css(\"height\",\"\")},enable:function(t){var i=this.options.disabled;i!==!1&&(void 0===t?i=!1:(t=this._getIndex(t),i=e.isArray(i)?e.map(i,function(e){return e!==t?e:null}):e.map(this.tabs,function(e,i){return i!==t?i:null})),this._setupDisabled(i))},disable:function(t){var i=this.options.disabled;if(i!==!0){if(void 0===t)i=!0;else{if(t=this._getIndex(t),-1!==e.inArray(t,i))return;i=e.isArray(i)?e.merge([t],i).sort():[t]}this._setupDisabled(i)}},load:function(t,i){t=this._getIndex(t);var s=this,n=this.tabs.eq(t),a=n.find(\".ui-tabs-anchor\"),o=this._getPanelForTab(n),r={tab:n,panel:o},h=function(e,t){\"abort\"===t&&s.panels.stop(!1,!0),n.removeClass(\"ui-tabs-loading\"),o.removeAttr(\"aria-busy\"),e===s.xhr&&delete s.xhr};this._isLocal(a[0])||(this.xhr=e.ajax(this._ajaxSettings(a,i,r)),this.xhr&&\"canceled\"!==this.xhr.statusText&&(n.addClass(\"ui-tabs-loading\"),o.attr(\"aria-busy\",\"true\"),this.xhr.done(function(e,t,n){setTimeout(function(){o.html(e),s._trigger(\"load\",i,r),h(n,t)},1)}).fail(function(e,t){setTimeout(function(){h(e,t)},1)})))},_ajaxSettings:function(t,i,s){var n=this;return{url:t.attr(\"href\"),beforeSend:function(t,a){return n._trigger(\"beforeLoad\",i,e.extend({jqXHR:t,ajaxSettings:a},s))}}},_getPanelForTab:function(t){var i=e(t).attr(\"aria-controls\");return this.element.find(this._sanitizeSelector(\"#\"+i))}}),e.widget(\"ui.tooltip\",{version:\"1.11.4\",options:{content:function(){var t=e(this).attr(\"title\")||\"\";return e(\"<a>\").text(t).html()},hide:!0,items:\"[title]:not([disabled])\",position:{my:\"left top+15\",at:\"left bottom\",collision:\"flipfit flip\"},show:!0,tooltipClass:null,track:!1,close:null,open:null},_addDescribedBy:function(t,i){var s=(t.attr(\"aria-describedby\")||\"\").split(/\\s+/);s.push(i),t.data(\"ui-tooltip-id\",i).attr(\"aria-describedby\",e.trim(s.join(\" \")))},_removeDescribedBy:function(t){var i=t.data(\"ui-tooltip-id\"),s=(t.attr(\"aria-describedby\")||\"\").split(/\\s+/),n=e.inArray(i,s);-1!==n&&s.splice(n,1),t.removeData(\"ui-tooltip-id\"),s=e.trim(s.join(\" \")),s?t.attr(\"aria-describedby\",s):t.removeAttr(\"aria-describedby\")},_create:function(){this._on({mouseover:\"open\",focusin:\"open\"}),this.tooltips={},this.parents={},this.options.disabled&&this._disable(),this.liveRegion=e(\"<div>\").attr({role:\"log\",\"aria-live\":\"assertive\",\"aria-relevant\":\"additions\"}).addClass(\"ui-helper-hidden-accessible\").appendTo(this.document[0].body)},_setOption:function(t,i){var s=this;return\"disabled\"===t?(this[i?\"_disable\":\"_enable\"](),this.options[t]=i,void 0):(this._super(t,i),\"content\"===t&&e.each(this.tooltips,function(e,t){s._updateContent(t.element)}),void 0)},_disable:function(){var t=this;e.each(this.tooltips,function(i,s){var n=e.Event(\"blur\");n.target=n.currentTarget=s.element[0],t.close(n,!0)}),this.element.find(this.options.items).addBack().each(function(){var t=e(this);t.is(\"[title]\")&&t.data(\"ui-tooltip-title\",t.attr(\"title\")).removeAttr(\"title\")})},_enable:function(){this.element.find(this.options.items).addBack().each(function(){var t=e(this);t.data(\"ui-tooltip-title\")&&t.attr(\"title\",t.data(\"ui-tooltip-title\"))})},open:function(t){var i=this,s=e(t?t.target:this.element).closest(this.options.items);s.length&&!s.data(\"ui-tooltip-id\")&&(s.attr(\"title\")&&s.data(\"ui-tooltip-title\",s.attr(\"title\")),s.data(\"ui-tooltip-open\",!0),t&&\"mouseover\"===t.type&&s.parents().each(function(){var t,s=e(this);s.data(\"ui-tooltip-open\")&&(t=e.Event(\"blur\"),t.target=t.currentTarget=this,i.close(t,!0)),s.attr(\"title\")&&(s.uniqueId(),i.parents[this.id]={element:this,title:s.attr(\"title\")},s.attr(\"title\",\"\"))}),this._registerCloseHandlers(t,s),this._updateContent(s,t))},_updateContent:function(e,t){var i,s=this.options.content,n=this,a=t?t.type:null;return\"string\"==typeof s?this._open(t,e,s):(i=s.call(e[0],function(i){n._delay(function(){e.data(\"ui-tooltip-open\")&&(t&&(t.type=a),this._open(t,e,i))})}),i&&this._open(t,e,i),void 0)},_open:function(t,i,s){function n(e){l.of=e,o.is(\":hidden\")||o.position(l)}var a,o,r,h,l=e.extend({},this.options.position);if(s){if(a=this._find(i))return a.tooltip.find(\".ui-tooltip-content\").html(s),void 0;i.is(\"[title]\")&&(t&&\"mouseover\"===t.type?i.attr(\"title\",\"\"):i.removeAttr(\"title\")),a=this._tooltip(i),o=a.tooltip,this._addDescribedBy(i,o.attr(\"id\")),o.find(\".ui-tooltip-content\").html(s),this.liveRegion.children().hide(),s.clone?(h=s.clone(),h.removeAttr(\"id\").find(\"[id]\").removeAttr(\"id\")):h=s,e(\"<div>\").html(h).appendTo(this.liveRegion),this.options.track&&t&&/^mouse/.test(t.type)?(this._on(this.document,{mousemove:n}),n(t)):o.position(e.extend({of:i},this.options.position)),o.hide(),this._show(o,this.options.show),this.options.show&&this.options.show.delay&&(r=this.delayedShow=setInterval(function(){o.is(\":visible\")&&(n(l.of),clearInterval(r))},e.fx.interval)),this._trigger(\"open\",t,{tooltip:o})}},_registerCloseHandlers:function(t,i){var s={keyup:function(t){if(t.keyCode===e.ui.keyCode.ESCAPE){var s=e.Event(t);s.currentTarget=i[0],this.close(s,!0)}}};i[0]!==this.element[0]&&(s.remove=function(){this._removeTooltip(this._find(i).tooltip)}),t&&\"mouseover\"!==t.type||(s.mouseleave=\"close\"),t&&\"focusin\"!==t.type||(s.focusout=\"close\"),this._on(!0,i,s)},close:function(t){var i,s=this,n=e(t?t.currentTarget:this.element),a=this._find(n);return a?(i=a.tooltip,a.closing||(clearInterval(this.delayedShow),n.data(\"ui-tooltip-title\")&&!n.attr(\"title\")&&n.attr(\"title\",n.data(\"ui-tooltip-title\")),this._removeDescribedBy(n),a.hiding=!0,i.stop(!0),this._hide(i,this.options.hide,function(){s._removeTooltip(e(this))}),n.removeData(\"ui-tooltip-open\"),this._off(n,\"mouseleave focusout keyup\"),n[0]!==this.element[0]&&this._off(n,\"remove\"),this._off(this.document,\"mousemove\"),t&&\"mouseleave\"===t.type&&e.each(this.parents,function(t,i){e(i.element).attr(\"title\",i.title),delete s.parents[t]}),a.closing=!0,this._trigger(\"close\",t,{tooltip:i}),a.hiding||(a.closing=!1)),void 0):(n.removeData(\"ui-tooltip-open\"),void 0)},_tooltip:function(t){var i=e(\"<div>\").attr(\"role\",\"tooltip\").addClass(\"ui-tooltip ui-widget ui-corner-all ui-widget-content \"+(this.options.tooltipClass||\"\")),s=i.uniqueId().attr(\"id\");return e(\"<div>\").addClass(\"ui-tooltip-content\").appendTo(i),i.appendTo(this.document[0].body),this.tooltips[s]={element:t,tooltip:i}},_find:function(e){var t=e.data(\"ui-tooltip-id\");return t?this.tooltips[t]:null},_removeTooltip:function(e){e.remove(),delete this.tooltips[e.attr(\"id\")]},_destroy:function(){var t=this;e.each(this.tooltips,function(i,s){var n=e.Event(\"blur\"),a=s.element;n.target=n.currentTarget=a[0],t.close(n,!0),e(\"#\"+i).remove(),a.data(\"ui-tooltip-title\")&&(a.attr(\"title\")||a.attr(\"title\",a.data(\"ui-tooltip-title\")),a.removeData(\"ui-tooltip-title\"))}),this.liveRegion.remove()}});var y=\"ui-effects-\",b=e;e.effects={effect:{}},function(e,t){function i(e,t,i){var s=d[t.type]||{};return null==e?i||!t.def?null:t.def:(e=s.floor?~~e:parseFloat(e),isNaN(e)?t.def:s.mod?(e+s.mod)%s.mod:0>e?0:e>s.max?s.max:e)}function s(i){var s=l(),n=s._rgba=[];return i=i.toLowerCase(),f(h,function(e,a){var o,r=a.re.exec(i),h=r&&a.parse(r),l=a.space||\"rgba\";return h?(o=s[l](h),s[u[l].cache]=o[u[l].cache],n=s._rgba=o._rgba,!1):t}),n.length?(\"0,0,0,0\"===n.join()&&e.extend(n,a.transparent),s):a[i]}function n(e,t,i){return i=(i+1)%1,1>6*i?e+6*(t-e)*i:1>2*i?t:2>3*i?e+6*(t-e)*(2/3-i):e}var a,o=\"backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor\",r=/^([\\-+])=\\s*(\\d+\\.?\\d*)/,h=[{re:/rgba?\\(\\s*(\\d{1,3})\\s*,\\s*(\\d{1,3})\\s*,\\s*(\\d{1,3})\\s*(?:,\\s*(\\d?(?:\\.\\d+)?)\\s*)?\\)/,parse:function(e){return[e[1],e[2],e[3],e[4]]}},{re:/rgba?\\(\\s*(\\d+(?:\\.\\d+)?)\\%\\s*,\\s*(\\d+(?:\\.\\d+)?)\\%\\s*,\\s*(\\d+(?:\\.\\d+)?)\\%\\s*(?:,\\s*(\\d?(?:\\.\\d+)?)\\s*)?\\)/,parse:function(e){return[2.55*e[1],2.55*e[2],2.55*e[3],e[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,parse:function(e){return[parseInt(e[1],16),parseInt(e[2],16),parseInt(e[3],16)]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])/,parse:function(e){return[parseInt(e[1]+e[1],16),parseInt(e[2]+e[2],16),parseInt(e[3]+e[3],16)]}},{re:/hsla?\\(\\s*(\\d+(?:\\.\\d+)?)\\s*,\\s*(\\d+(?:\\.\\d+)?)\\%\\s*,\\s*(\\d+(?:\\.\\d+)?)\\%\\s*(?:,\\s*(\\d?(?:\\.\\d+)?)\\s*)?\\)/,space:\"hsla\",parse:function(e){return[e[1],e[2]/100,e[3]/100,e[4]]}}],l=e.Color=function(t,i,s,n){return new e.Color.fn.parse(t,i,s,n)},u={rgba:{props:{red:{idx:0,type:\"byte\"},green:{idx:1,type:\"byte\"},blue:{idx:2,type:\"byte\"}}},hsla:{props:{hue:{idx:0,type:\"degrees\"},saturation:{idx:1,type:\"percent\"},lightness:{idx:2,type:\"percent\"}}}},d={\"byte\":{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},c=l.support={},p=e(\"<p>\")[0],f=e.each;p.style.cssText=\"background-color:rgba(1,1,1,.5)\",c.rgba=p.style.backgroundColor.indexOf(\"rgba\")>-1,f(u,function(e,t){t.cache=\"_\"+e,t.props.alpha={idx:3,type:\"percent\",def:1}}),l.fn=e.extend(l.prototype,{parse:function(n,o,r,h){if(n===t)return this._rgba=[null,null,null,null],this;(n.jquery||n.nodeType)&&(n=e(n).css(o),o=t);var d=this,c=e.type(n),p=this._rgba=[];return o!==t&&(n=[n,o,r,h],c=\"array\"),\"string\"===c?this.parse(s(n)||a._default):\"array\"===c?(f(u.rgba.props,function(e,t){p[t.idx]=i(n[t.idx],t)}),this):\"object\"===c?(n instanceof l?f(u,function(e,t){n[t.cache]&&(d[t.cache]=n[t.cache].slice())}):f(u,function(t,s){var a=s.cache;f(s.props,function(e,t){if(!d[a]&&s.to){if(\"alpha\"===e||null==n[e])return;d[a]=s.to(d._rgba)}d[a][t.idx]=i(n[e],t,!0)}),d[a]&&0>e.inArray(null,d[a].slice(0,3))&&(d[a][3]=1,s.from&&(d._rgba=s.from(d[a])))}),this):t},is:function(e){var i=l(e),s=!0,n=this;return f(u,function(e,a){var o,r=i[a.cache];return r&&(o=n[a.cache]||a.to&&a.to(n._rgba)||[],f(a.props,function(e,i){return null!=r[i.idx]?s=r[i.idx]===o[i.idx]:t})),s}),s},_space:function(){var e=[],t=this;return f(u,function(i,s){t[s.cache]&&e.push(i)}),e.pop()},transition:function(e,t){var s=l(e),n=s._space(),a=u[n],o=0===this.alpha()?l(\"transparent\"):this,r=o[a.cache]||a.to(o._rgba),h=r.slice();return s=s[a.cache],f(a.props,function(e,n){var a=n.idx,o=r[a],l=s[a],u=d[n.type]||{};null!==l&&(null===o?h[a]=l:(u.mod&&(l-o>u.mod/2?o+=u.mod:o-l>u.mod/2&&(o-=u.mod)),h[a]=i((l-o)*t+o,n)))}),this[n](h)},blend:function(t){if(1===this._rgba[3])return this;var i=this._rgba.slice(),s=i.pop(),n=l(t)._rgba;return l(e.map(i,function(e,t){return(1-s)*n[t]+s*e}))},toRgbaString:function(){var t=\"rgba(\",i=e.map(this._rgba,function(e,t){return null==e?t>2?1:0:e});return 1===i[3]&&(i.pop(),t=\"rgb(\"),t+i.join()+\")\"},toHslaString:function(){var t=\"hsla(\",i=e.map(this.hsla(),function(e,t){return null==e&&(e=t>2?1:0),t&&3>t&&(e=Math.round(100*e)+\"%\"),e});return 1===i[3]&&(i.pop(),t=\"hsl(\"),t+i.join()+\")\"},toHexString:function(t){var i=this._rgba.slice(),s=i.pop();return t&&i.push(~~(255*s)),\"#\"+e.map(i,function(e){return e=(e||0).toString(16),1===e.length?\"0\"+e:e}).join(\"\")},toString:function(){return 0===this._rgba[3]?\"transparent\":this.toRgbaString()}}),l.fn.parse.prototype=l.fn,u.hsla.to=function(e){if(null==e[0]||null==e[1]||null==e[2])return[null,null,null,e[3]];var t,i,s=e[0]/255,n=e[1]/255,a=e[2]/255,o=e[3],r=Math.max(s,n,a),h=Math.min(s,n,a),l=r-h,u=r+h,d=.5*u;return t=h===r?0:s===r?60*(n-a)/l+360:n===r?60*(a-s)/l+120:60*(s-n)/l+240,i=0===l?0:.5>=d?l/u:l/(2-u),[Math.round(t)%360,i,d,null==o?1:o]},u.hsla.from=function(e){if(null==e[0]||null==e[1]||null==e[2])return[null,null,null,e[3]];var t=e[0]/360,i=e[1],s=e[2],a=e[3],o=.5>=s?s*(1+i):s+i-s*i,r=2*s-o;return[Math.round(255*n(r,o,t+1/3)),Math.round(255*n(r,o,t)),Math.round(255*n(r,o,t-1/3)),a]},f(u,function(s,n){var a=n.props,o=n.cache,h=n.to,u=n.from;l.fn[s]=function(s){if(h&&!this[o]&&(this[o]=h(this._rgba)),s===t)return this[o].slice();var n,r=e.type(s),d=\"array\"===r||\"object\"===r?s:arguments,c=this[o].slice();return f(a,function(e,t){var s=d[\"object\"===r?e:t.idx];null==s&&(s=c[t.idx]),c[t.idx]=i(s,t)}),u?(n=l(u(c)),n[o]=c,n):l(c)},f(a,function(t,i){l.fn[t]||(l.fn[t]=function(n){var a,o=e.type(n),h=\"alpha\"===t?this._hsla?\"hsla\":\"rgba\":s,l=this[h](),u=l[i.idx];return\"undefined\"===o?u:(\"function\"===o&&(n=n.call(this,u),o=e.type(n)),null==n&&i.empty?this:(\"string\"===o&&(a=r.exec(n),a&&(n=u+parseFloat(a[2])*(\"+\"===a[1]?1:-1))),l[i.idx]=n,this[h](l)))})})}),l.hook=function(t){var i=t.split(\" \");f(i,function(t,i){e.cssHooks[i]={set:function(t,n){var a,o,r=\"\";if(\"transparent\"!==n&&(\"string\"!==e.type(n)||(a=s(n)))){if(n=l(a||n),!c.rgba&&1!==n._rgba[3]){for(o=\"backgroundColor\"===i?t.parentNode:t;(\"\"===r||\"transparent\"===r)&&o&&o.style;)try{r=e.css(o,\"backgroundColor\"),o=o.parentNode}catch(h){}n=n.blend(r&&\"transparent\"!==r?r:\"_default\")}n=n.toRgbaString()}try{t.style[i]=n}catch(h){}}},e.fx.step[i]=function(t){t.colorInit||(t.start=l(t.elem,i),t.end=l(t.end),t.colorInit=!0),e.cssHooks[i].set(t.elem,t.start.transition(t.end,t.pos))}})},l.hook(o),e.cssHooks.borderColor={expand:function(e){var t={};return f([\"Top\",\"Right\",\"Bottom\",\"Left\"],function(i,s){t[\"border\"+s+\"Color\"]=e}),t}},a=e.Color.names={aqua:\"#00ffff\",black:\"#000000\",blue:\"#0000ff\",fuchsia:\"#ff00ff\",gray:\"#808080\",green:\"#008000\",lime:\"#00ff00\",maroon:\"#800000\",navy:\"#000080\",olive:\"#808000\",purple:\"#800080\",red:\"#ff0000\",silver:\"#c0c0c0\",teal:\"#008080\",white:\"#ffffff\",yellow:\"#ffff00\",transparent:[null,null,null,0],_default:\"#ffffff\"}}(b),function(){function t(t){var i,s,n=t.ownerDocument.defaultView?t.ownerDocument.defaultView.getComputedStyle(t,null):t.currentStyle,a={};if(n&&n.length&&n[0]&&n[n[0]])for(s=n.length;s--;)i=n[s],\"string\"==typeof n[i]&&(a[e.camelCase(i)]=n[i]);else for(i in n)\"string\"==typeof n[i]&&(a[i]=n[i]);return a}function i(t,i){var s,a,o={};for(s in i)a=i[s],t[s]!==a&&(n[s]||(e.fx.step[s]||!isNaN(parseFloat(a)))&&(o[s]=a));return o}var s=[\"add\",\"remove\",\"toggle\"],n={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1};e.each([\"borderLeftStyle\",\"borderRightStyle\",\"borderBottomStyle\",\"borderTopStyle\"],function(t,i){e.fx.step[i]=function(e){(\"none\"!==e.end&&!e.setAttr||1===e.pos&&!e.setAttr)&&(b.style(e.elem,i,e.end),e.setAttr=!0)}}),e.fn.addBack||(e.fn.addBack=function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}),e.effects.animateClass=function(n,a,o,r){var h=e.speed(a,o,r);return this.queue(function(){var a,o=e(this),r=o.attr(\"class\")||\"\",l=h.children?o.find(\"*\").addBack():o;l=l.map(function(){var i=e(this);return{el:i,start:t(this)}}),a=function(){e.each(s,function(e,t){n[t]&&o[t+\"Class\"](n[t])})},a(),l=l.map(function(){return this.end=t(this.el[0]),this.diff=i(this.start,this.end),this}),o.attr(\"class\",r),l=l.map(function(){var t=this,i=e.Deferred(),s=e.extend({},h,{queue:!1,complete:function(){i.resolve(t)}});return this.el.animate(this.diff,s),i.promise()}),e.when.apply(e,l.get()).done(function(){a(),e.each(arguments,function(){var t=this.el;e.each(this.diff,function(e){t.css(e,\"\")})}),h.complete.call(o[0])})})},e.fn.extend({addClass:function(t){return function(i,s,n,a){return s?e.effects.animateClass.call(this,{add:i},s,n,a):t.apply(this,arguments)}}(e.fn.addClass),removeClass:function(t){return function(i,s,n,a){return arguments.length>1?e.effects.animateClass.call(this,{remove:i},s,n,a):t.apply(this,arguments)}}(e.fn.removeClass),toggleClass:function(t){return function(i,s,n,a,o){return\"boolean\"==typeof s||void 0===s?n?e.effects.animateClass.call(this,s?{add:i}:{remove:i},n,a,o):t.apply(this,arguments):e.effects.animateClass.call(this,{toggle:i},s,n,a)}}(e.fn.toggleClass),switchClass:function(t,i,s,n,a){return e.effects.animateClass.call(this,{add:i,remove:t},s,n,a)}})}(),function(){function t(t,i,s,n){return e.isPlainObject(t)&&(i=t,t=t.effect),t={effect:t},null==i&&(i={}),e.isFunction(i)&&(n=i,s=null,i={}),(\"number\"==typeof i||e.fx.speeds[i])&&(n=s,s=i,i={}),e.isFunction(s)&&(n=s,s=null),i&&e.extend(t,i),s=s||i.duration,t.duration=e.fx.off?0:\"number\"==typeof s?s:s in e.fx.speeds?e.fx.speeds[s]:e.fx.speeds._default,t.complete=n||i.complete,t}function i(t){return!t||\"number\"==typeof t||e.fx.speeds[t]?!0:\"string\"!=typeof t||e.effects.effect[t]?e.isFunction(t)?!0:\"object\"!=typeof t||t.effect?!1:!0:!0}e.extend(e.effects,{version:\"1.11.4\",save:function(e,t){for(var i=0;t.length>i;i++)null!==t[i]&&e.data(y+t[i],e[0].style[t[i]])},restore:function(e,t){var i,s;for(s=0;t.length>s;s++)null!==t[s]&&(i=e.data(y+t[s]),void 0===i&&(i=\"\"),e.css(t[s],i))},setMode:function(e,t){return\"toggle\"===t&&(t=e.is(\":hidden\")?\"show\":\"hide\"),t},getBaseline:function(e,t){var i,s;switch(e[0]){case\"top\":i=0;break;case\"middle\":i=.5;break;case\"bottom\":i=1;break;default:i=e[0]/t.height}switch(e[1]){case\"left\":s=0;break;case\"center\":s=.5;break;case\"right\":s=1;break;default:s=e[1]/t.width}return{x:s,y:i}},createWrapper:function(t){if(t.parent().is(\".ui-effects-wrapper\"))return t.parent();var i={width:t.outerWidth(!0),height:t.outerHeight(!0),\"float\":t.css(\"float\")},s=e(\"<div></div>\").addClass(\"ui-effects-wrapper\").css({fontSize:\"100%\",background:\"transparent\",border:\"none\",margin:0,padding:0}),n={width:t.width(),height:t.height()},a=document.activeElement;try{a.id}catch(o){a=document.body}return t.wrap(s),(t[0]===a||e.contains(t[0],a))&&e(a).focus(),s=t.parent(),\"static\"===t.css(\"position\")?(s.css({position:\"relative\"}),t.css({position:\"relative\"})):(e.extend(i,{position:t.css(\"position\"),zIndex:t.css(\"z-index\")}),e.each([\"top\",\"left\",\"bottom\",\"right\"],function(e,s){i[s]=t.css(s),isNaN(parseInt(i[s],10))&&(i[s]=\"auto\")}),t.css({position:\"relative\",top:0,left:0,right:\"auto\",bottom:\"auto\"})),t.css(n),s.css(i).show()},removeWrapper:function(t){var i=document.activeElement;\nreturn t.parent().is(\".ui-effects-wrapper\")&&(t.parent().replaceWith(t),(t[0]===i||e.contains(t[0],i))&&e(i).focus()),t},setTransition:function(t,i,s,n){return n=n||{},e.each(i,function(e,i){var a=t.cssUnit(i);a[0]>0&&(n[i]=a[0]*s+a[1])}),n}}),e.fn.extend({effect:function(){function i(t){function i(){e.isFunction(a)&&a.call(n[0]),e.isFunction(t)&&t()}var n=e(this),a=s.complete,r=s.mode;(n.is(\":hidden\")?\"hide\"===r:\"show\"===r)?(n[r](),i()):o.call(n[0],s,i)}var s=t.apply(this,arguments),n=s.mode,a=s.queue,o=e.effects.effect[s.effect];return e.fx.off||!o?n?this[n](s.duration,s.complete):this.each(function(){s.complete&&s.complete.call(this)}):a===!1?this.each(i):this.queue(a||\"fx\",i)},show:function(e){return function(s){if(i(s))return e.apply(this,arguments);var n=t.apply(this,arguments);return n.mode=\"show\",this.effect.call(this,n)}}(e.fn.show),hide:function(e){return function(s){if(i(s))return e.apply(this,arguments);var n=t.apply(this,arguments);return n.mode=\"hide\",this.effect.call(this,n)}}(e.fn.hide),toggle:function(e){return function(s){if(i(s)||\"boolean\"==typeof s)return e.apply(this,arguments);var n=t.apply(this,arguments);return n.mode=\"toggle\",this.effect.call(this,n)}}(e.fn.toggle),cssUnit:function(t){var i=this.css(t),s=[];return e.each([\"em\",\"px\",\"%\",\"pt\"],function(e,t){i.indexOf(t)>0&&(s=[parseFloat(i),t])}),s}})}(),function(){var t={};e.each([\"Quad\",\"Cubic\",\"Quart\",\"Quint\",\"Expo\"],function(e,i){t[i]=function(t){return Math.pow(t,e+2)}}),e.extend(t,{Sine:function(e){return 1-Math.cos(e*Math.PI/2)},Circ:function(e){return 1-Math.sqrt(1-e*e)},Elastic:function(e){return 0===e||1===e?e:-Math.pow(2,8*(e-1))*Math.sin((80*(e-1)-7.5)*Math.PI/15)},Back:function(e){return e*e*(3*e-2)},Bounce:function(e){for(var t,i=4;((t=Math.pow(2,--i))-1)/11>e;);return 1/Math.pow(4,3-i)-7.5625*Math.pow((3*t-2)/22-e,2)}}),e.each(t,function(t,i){e.easing[\"easeIn\"+t]=i,e.easing[\"easeOut\"+t]=function(e){return 1-i(1-e)},e.easing[\"easeInOut\"+t]=function(e){return.5>e?i(2*e)/2:1-i(-2*e+2)/2}})}(),e.effects,e.effects.effect.blind=function(t,i){var s,n,a,o=e(this),r=/up|down|vertical/,h=/up|left|vertical|horizontal/,l=[\"position\",\"top\",\"bottom\",\"left\",\"right\",\"height\",\"width\"],u=e.effects.setMode(o,t.mode||\"hide\"),d=t.direction||\"up\",c=r.test(d),p=c?\"height\":\"width\",f=c?\"top\":\"left\",m=h.test(d),g={},v=\"show\"===u;o.parent().is(\".ui-effects-wrapper\")?e.effects.save(o.parent(),l):e.effects.save(o,l),o.show(),s=e.effects.createWrapper(o).css({overflow:\"hidden\"}),n=s[p](),a=parseFloat(s.css(f))||0,g[p]=v?n:0,m||(o.css(c?\"bottom\":\"right\",0).css(c?\"top\":\"left\",\"auto\").css({position:\"absolute\"}),g[f]=v?a:n+a),v&&(s.css(p,0),m||s.css(f,a+n)),s.animate(g,{duration:t.duration,easing:t.easing,queue:!1,complete:function(){\"hide\"===u&&o.hide(),e.effects.restore(o,l),e.effects.removeWrapper(o),i()}})},e.effects.effect.bounce=function(t,i){var s,n,a,o=e(this),r=[\"position\",\"top\",\"bottom\",\"left\",\"right\",\"height\",\"width\"],h=e.effects.setMode(o,t.mode||\"effect\"),l=\"hide\"===h,u=\"show\"===h,d=t.direction||\"up\",c=t.distance,p=t.times||5,f=2*p+(u||l?1:0),m=t.duration/f,g=t.easing,v=\"up\"===d||\"down\"===d?\"top\":\"left\",y=\"up\"===d||\"left\"===d,b=o.queue(),_=b.length;for((u||l)&&r.push(\"opacity\"),e.effects.save(o,r),o.show(),e.effects.createWrapper(o),c||(c=o[\"top\"===v?\"outerHeight\":\"outerWidth\"]()/3),u&&(a={opacity:1},a[v]=0,o.css(\"opacity\",0).css(v,y?2*-c:2*c).animate(a,m,g)),l&&(c/=Math.pow(2,p-1)),a={},a[v]=0,s=0;p>s;s++)n={},n[v]=(y?\"-=\":\"+=\")+c,o.animate(n,m,g).animate(a,m,g),c=l?2*c:c/2;l&&(n={opacity:0},n[v]=(y?\"-=\":\"+=\")+c,o.animate(n,m,g)),o.queue(function(){l&&o.hide(),e.effects.restore(o,r),e.effects.removeWrapper(o),i()}),_>1&&b.splice.apply(b,[1,0].concat(b.splice(_,f+1))),o.dequeue()},e.effects.effect.clip=function(t,i){var s,n,a,o=e(this),r=[\"position\",\"top\",\"bottom\",\"left\",\"right\",\"height\",\"width\"],h=e.effects.setMode(o,t.mode||\"hide\"),l=\"show\"===h,u=t.direction||\"vertical\",d=\"vertical\"===u,c=d?\"height\":\"width\",p=d?\"top\":\"left\",f={};e.effects.save(o,r),o.show(),s=e.effects.createWrapper(o).css({overflow:\"hidden\"}),n=\"IMG\"===o[0].tagName?s:o,a=n[c](),l&&(n.css(c,0),n.css(p,a/2)),f[c]=l?a:0,f[p]=l?0:a/2,n.animate(f,{queue:!1,duration:t.duration,easing:t.easing,complete:function(){l||o.hide(),e.effects.restore(o,r),e.effects.removeWrapper(o),i()}})},e.effects.effect.drop=function(t,i){var s,n=e(this),a=[\"position\",\"top\",\"bottom\",\"left\",\"right\",\"opacity\",\"height\",\"width\"],o=e.effects.setMode(n,t.mode||\"hide\"),r=\"show\"===o,h=t.direction||\"left\",l=\"up\"===h||\"down\"===h?\"top\":\"left\",u=\"up\"===h||\"left\"===h?\"pos\":\"neg\",d={opacity:r?1:0};e.effects.save(n,a),n.show(),e.effects.createWrapper(n),s=t.distance||n[\"top\"===l?\"outerHeight\":\"outerWidth\"](!0)/2,r&&n.css(\"opacity\",0).css(l,\"pos\"===u?-s:s),d[l]=(r?\"pos\"===u?\"+=\":\"-=\":\"pos\"===u?\"-=\":\"+=\")+s,n.animate(d,{queue:!1,duration:t.duration,easing:t.easing,complete:function(){\"hide\"===o&&n.hide(),e.effects.restore(n,a),e.effects.removeWrapper(n),i()}})},e.effects.effect.explode=function(t,i){function s(){b.push(this),b.length===d*c&&n()}function n(){p.css({visibility:\"visible\"}),e(b).remove(),m||p.hide(),i()}var a,o,r,h,l,u,d=t.pieces?Math.round(Math.sqrt(t.pieces)):3,c=d,p=e(this),f=e.effects.setMode(p,t.mode||\"hide\"),m=\"show\"===f,g=p.show().css(\"visibility\",\"hidden\").offset(),v=Math.ceil(p.outerWidth()/c),y=Math.ceil(p.outerHeight()/d),b=[];for(a=0;d>a;a++)for(h=g.top+a*y,u=a-(d-1)/2,o=0;c>o;o++)r=g.left+o*v,l=o-(c-1)/2,p.clone().appendTo(\"body\").wrap(\"<div></div>\").css({position:\"absolute\",visibility:\"visible\",left:-o*v,top:-a*y}).parent().addClass(\"ui-effects-explode\").css({position:\"absolute\",overflow:\"hidden\",width:v,height:y,left:r+(m?l*v:0),top:h+(m?u*y:0),opacity:m?0:1}).animate({left:r+(m?0:l*v),top:h+(m?0:u*y),opacity:m?1:0},t.duration||500,t.easing,s)},e.effects.effect.fade=function(t,i){var s=e(this),n=e.effects.setMode(s,t.mode||\"toggle\");s.animate({opacity:n},{queue:!1,duration:t.duration,easing:t.easing,complete:i})},e.effects.effect.fold=function(t,i){var s,n,a=e(this),o=[\"position\",\"top\",\"bottom\",\"left\",\"right\",\"height\",\"width\"],r=e.effects.setMode(a,t.mode||\"hide\"),h=\"show\"===r,l=\"hide\"===r,u=t.size||15,d=/([0-9]+)%/.exec(u),c=!!t.horizFirst,p=h!==c,f=p?[\"width\",\"height\"]:[\"height\",\"width\"],m=t.duration/2,g={},v={};e.effects.save(a,o),a.show(),s=e.effects.createWrapper(a).css({overflow:\"hidden\"}),n=p?[s.width(),s.height()]:[s.height(),s.width()],d&&(u=parseInt(d[1],10)/100*n[l?0:1]),h&&s.css(c?{height:0,width:u}:{height:u,width:0}),g[f[0]]=h?n[0]:u,v[f[1]]=h?n[1]:0,s.animate(g,m,t.easing).animate(v,m,t.easing,function(){l&&a.hide(),e.effects.restore(a,o),e.effects.removeWrapper(a),i()})},e.effects.effect.highlight=function(t,i){var s=e(this),n=[\"backgroundImage\",\"backgroundColor\",\"opacity\"],a=e.effects.setMode(s,t.mode||\"show\"),o={backgroundColor:s.css(\"backgroundColor\")};\"hide\"===a&&(o.opacity=0),e.effects.save(s,n),s.show().css({backgroundImage:\"none\",backgroundColor:t.color||\"#ffff99\"}).animate(o,{queue:!1,duration:t.duration,easing:t.easing,complete:function(){\"hide\"===a&&s.hide(),e.effects.restore(s,n),i()}})},e.effects.effect.size=function(t,i){var s,n,a,o=e(this),r=[\"position\",\"top\",\"bottom\",\"left\",\"right\",\"width\",\"height\",\"overflow\",\"opacity\"],h=[\"position\",\"top\",\"bottom\",\"left\",\"right\",\"overflow\",\"opacity\"],l=[\"width\",\"height\",\"overflow\"],u=[\"fontSize\"],d=[\"borderTopWidth\",\"borderBottomWidth\",\"paddingTop\",\"paddingBottom\"],c=[\"borderLeftWidth\",\"borderRightWidth\",\"paddingLeft\",\"paddingRight\"],p=e.effects.setMode(o,t.mode||\"effect\"),f=t.restore||\"effect\"!==p,m=t.scale||\"both\",g=t.origin||[\"middle\",\"center\"],v=o.css(\"position\"),y=f?r:h,b={height:0,width:0,outerHeight:0,outerWidth:0};\"show\"===p&&o.show(),s={height:o.height(),width:o.width(),outerHeight:o.outerHeight(),outerWidth:o.outerWidth()},\"toggle\"===t.mode&&\"show\"===p?(o.from=t.to||b,o.to=t.from||s):(o.from=t.from||(\"show\"===p?b:s),o.to=t.to||(\"hide\"===p?b:s)),a={from:{y:o.from.height/s.height,x:o.from.width/s.width},to:{y:o.to.height/s.height,x:o.to.width/s.width}},(\"box\"===m||\"both\"===m)&&(a.from.y!==a.to.y&&(y=y.concat(d),o.from=e.effects.setTransition(o,d,a.from.y,o.from),o.to=e.effects.setTransition(o,d,a.to.y,o.to)),a.from.x!==a.to.x&&(y=y.concat(c),o.from=e.effects.setTransition(o,c,a.from.x,o.from),o.to=e.effects.setTransition(o,c,a.to.x,o.to))),(\"content\"===m||\"both\"===m)&&a.from.y!==a.to.y&&(y=y.concat(u).concat(l),o.from=e.effects.setTransition(o,u,a.from.y,o.from),o.to=e.effects.setTransition(o,u,a.to.y,o.to)),e.effects.save(o,y),o.show(),e.effects.createWrapper(o),o.css(\"overflow\",\"hidden\").css(o.from),g&&(n=e.effects.getBaseline(g,s),o.from.top=(s.outerHeight-o.outerHeight())*n.y,o.from.left=(s.outerWidth-o.outerWidth())*n.x,o.to.top=(s.outerHeight-o.to.outerHeight)*n.y,o.to.left=(s.outerWidth-o.to.outerWidth)*n.x),o.css(o.from),(\"content\"===m||\"both\"===m)&&(d=d.concat([\"marginTop\",\"marginBottom\"]).concat(u),c=c.concat([\"marginLeft\",\"marginRight\"]),l=r.concat(d).concat(c),o.find(\"*[width]\").each(function(){var i=e(this),s={height:i.height(),width:i.width(),outerHeight:i.outerHeight(),outerWidth:i.outerWidth()};f&&e.effects.save(i,l),i.from={height:s.height*a.from.y,width:s.width*a.from.x,outerHeight:s.outerHeight*a.from.y,outerWidth:s.outerWidth*a.from.x},i.to={height:s.height*a.to.y,width:s.width*a.to.x,outerHeight:s.height*a.to.y,outerWidth:s.width*a.to.x},a.from.y!==a.to.y&&(i.from=e.effects.setTransition(i,d,a.from.y,i.from),i.to=e.effects.setTransition(i,d,a.to.y,i.to)),a.from.x!==a.to.x&&(i.from=e.effects.setTransition(i,c,a.from.x,i.from),i.to=e.effects.setTransition(i,c,a.to.x,i.to)),i.css(i.from),i.animate(i.to,t.duration,t.easing,function(){f&&e.effects.restore(i,l)})})),o.animate(o.to,{queue:!1,duration:t.duration,easing:t.easing,complete:function(){0===o.to.opacity&&o.css(\"opacity\",o.from.opacity),\"hide\"===p&&o.hide(),e.effects.restore(o,y),f||(\"static\"===v?o.css({position:\"relative\",top:o.to.top,left:o.to.left}):e.each([\"top\",\"left\"],function(e,t){o.css(t,function(t,i){var s=parseInt(i,10),n=e?o.to.left:o.to.top;return\"auto\"===i?n+\"px\":s+n+\"px\"})})),e.effects.removeWrapper(o),i()}})},e.effects.effect.scale=function(t,i){var s=e(this),n=e.extend(!0,{},t),a=e.effects.setMode(s,t.mode||\"effect\"),o=parseInt(t.percent,10)||(0===parseInt(t.percent,10)?0:\"hide\"===a?0:100),r=t.direction||\"both\",h=t.origin,l={height:s.height(),width:s.width(),outerHeight:s.outerHeight(),outerWidth:s.outerWidth()},u={y:\"horizontal\"!==r?o/100:1,x:\"vertical\"!==r?o/100:1};n.effect=\"size\",n.queue=!1,n.complete=i,\"effect\"!==a&&(n.origin=h||[\"middle\",\"center\"],n.restore=!0),n.from=t.from||(\"show\"===a?{height:0,width:0,outerHeight:0,outerWidth:0}:l),n.to={height:l.height*u.y,width:l.width*u.x,outerHeight:l.outerHeight*u.y,outerWidth:l.outerWidth*u.x},n.fade&&(\"show\"===a&&(n.from.opacity=0,n.to.opacity=1),\"hide\"===a&&(n.from.opacity=1,n.to.opacity=0)),s.effect(n)},e.effects.effect.puff=function(t,i){var s=e(this),n=e.effects.setMode(s,t.mode||\"hide\"),a=\"hide\"===n,o=parseInt(t.percent,10)||150,r=o/100,h={height:s.height(),width:s.width(),outerHeight:s.outerHeight(),outerWidth:s.outerWidth()};e.extend(t,{effect:\"scale\",queue:!1,fade:!0,mode:n,complete:i,percent:a?o:100,from:a?h:{height:h.height*r,width:h.width*r,outerHeight:h.outerHeight*r,outerWidth:h.outerWidth*r}}),s.effect(t)},e.effects.effect.pulsate=function(t,i){var s,n=e(this),a=e.effects.setMode(n,t.mode||\"show\"),o=\"show\"===a,r=\"hide\"===a,h=o||\"hide\"===a,l=2*(t.times||5)+(h?1:0),u=t.duration/l,d=0,c=n.queue(),p=c.length;for((o||!n.is(\":visible\"))&&(n.css(\"opacity\",0).show(),d=1),s=1;l>s;s++)n.animate({opacity:d},u,t.easing),d=1-d;n.animate({opacity:d},u,t.easing),n.queue(function(){r&&n.hide(),i()}),p>1&&c.splice.apply(c,[1,0].concat(c.splice(p,l+1))),n.dequeue()},e.effects.effect.shake=function(t,i){var s,n=e(this),a=[\"position\",\"top\",\"bottom\",\"left\",\"right\",\"height\",\"width\"],o=e.effects.setMode(n,t.mode||\"effect\"),r=t.direction||\"left\",h=t.distance||20,l=t.times||3,u=2*l+1,d=Math.round(t.duration/u),c=\"up\"===r||\"down\"===r?\"top\":\"left\",p=\"up\"===r||\"left\"===r,f={},m={},g={},v=n.queue(),y=v.length;for(e.effects.save(n,a),n.show(),e.effects.createWrapper(n),f[c]=(p?\"-=\":\"+=\")+h,m[c]=(p?\"+=\":\"-=\")+2*h,g[c]=(p?\"-=\":\"+=\")+2*h,n.animate(f,d,t.easing),s=1;l>s;s++)n.animate(m,d,t.easing).animate(g,d,t.easing);n.animate(m,d,t.easing).animate(f,d/2,t.easing).queue(function(){\"hide\"===o&&n.hide(),e.effects.restore(n,a),e.effects.removeWrapper(n),i()}),y>1&&v.splice.apply(v,[1,0].concat(v.splice(y,u+1))),n.dequeue()},e.effects.effect.slide=function(t,i){var s,n=e(this),a=[\"position\",\"top\",\"bottom\",\"left\",\"right\",\"width\",\"height\"],o=e.effects.setMode(n,t.mode||\"show\"),r=\"show\"===o,h=t.direction||\"left\",l=\"up\"===h||\"down\"===h?\"top\":\"left\",u=\"up\"===h||\"left\"===h,d={};e.effects.save(n,a),n.show(),s=t.distance||n[\"top\"===l?\"outerHeight\":\"outerWidth\"](!0),e.effects.createWrapper(n).css({overflow:\"hidden\"}),r&&n.css(l,u?isNaN(s)?\"-\"+s:-s:s),d[l]=(r?u?\"+=\":\"-=\":u?\"-=\":\"+=\")+s,n.animate(d,{queue:!1,duration:t.duration,easing:t.easing,complete:function(){\"hide\"===o&&n.hide(),e.effects.restore(n,a),e.effects.removeWrapper(n),i()}})},e.effects.effect.transfer=function(t,i){var s=e(this),n=e(t.to),a=\"fixed\"===n.css(\"position\"),o=e(\"body\"),r=a?o.scrollTop():0,h=a?o.scrollLeft():0,l=n.offset(),u={top:l.top-r,left:l.left-h,height:n.innerHeight(),width:n.innerWidth()},d=s.offset(),c=e(\"<div class='ui-effects-transfer'></div>\").appendTo(document.body).addClass(t.className).css({top:d.top-r,left:d.left-h,height:s.innerHeight(),width:s.innerWidth(),position:a?\"fixed\":\"absolute\"}).animate(u,t.duration,t.easing,function(){c.remove(),i()})}});"

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(26))

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = "// This [jQuery](http://jquery.com/) plugin implements an `<iframe>`\n// [transport](http://api.jquery.com/extending-ajax/#Transports) so that\n// `$.ajax()` calls support the uploading of files using standard HTML file\n// input fields. This is done by switching the exchange from `XMLHttpRequest`\n// to a hidden `iframe` element containing a form that is submitted.\n\n// The [source for the plugin](http://github.com/cmlenz/jquery-iframe-transport)\n// is available on [Github](http://github.com/) and dual licensed under the MIT\n// or GPL Version 2 licenses.\n\n// ## Usage\n\n// To use this plugin, you simply add an `iframe` option with the value `true`\n// to the Ajax settings an `$.ajax()` call, and specify the file fields to\n// include in the submssion using the `files` option, which can be a selector,\n// jQuery object, or a list of DOM elements containing one or more\n// `<input type=\"file\">` elements:\n\n//     $(\"#myform\").submit(function() {\n//         $.ajax(this.action, {\n//             files: $(\":file\", this),\n//             iframe: true\n//         }).complete(function(data) {\n//             console.log(data);\n//         });\n//     });\n\n// The plugin will construct a hidden `<iframe>` element containing a copy of\n// the form the file field belongs to, will disable any form fields not\n// explicitly included, submit that form, and process the response.\n\n// If you want to include other form fields in the form submission, include\n// them in the `data` option, and set the `processData` option to `false`:\n\n//     $(\"#myform\").submit(function() {\n//         $.ajax(this.action, {\n//             data: $(\":text\", this).serializeArray(),\n//             files: $(\":file\", this),\n//             iframe: true,\n//             processData: false\n//         }).complete(function(data) {\n//             console.log(data);\n//         });\n//     });\n\n// ### Response Data Types\n\n// As the transport does not have access to the HTTP headers of the server\n// response, it is not as simple to make use of the automatic content type\n// detection provided by jQuery as with regular XHR. If you can't set the\n// expected response data type (for example because it may vary), you will\n// need to employ a workaround on the server side: Send back an HTML document\n// containing just a `<textarea>` element with a `data-type` attribute that\n// specifies the MIME type, and put the actual payload in the textarea:\n\n//     <textarea data-type=\"application/json\">\n//       {\"ok\": true, \"message\": \"Thanks so much\"}\n//     </textarea>\n\n// The iframe transport plugin will detect this and pass the value of the\n// `data-type` attribute on to jQuery as if it was the \"Content-Type\" response\n// header, thereby enabling the same kind of conversions that jQuery applies\n// to regular responses. For the example above you should get a Javascript\n// object as the `data` parameter of the `complete` callback, with the\n// properties `ok: true` and `message: \"Thanks so much\"`.\n\n// ### Handling Server Errors\n\n// Another problem with using an `iframe` for file uploads is that it is\n// impossible for the javascript code to determine the HTTP status code of the\n// servers response. Effectively, all of the calls you make will look like they\n// are getting successful responses, and thus invoke the `done()` or\n// `complete()` callbacks. You can only determine communicate problems using\n// the content of the response payload. For example, consider using a JSON\n// response such as the following to indicate a problem with an uploaded file:\n\n//     <textarea data-type=\"application/json\">\n//       {\"ok\": false, \"message\": \"Please only upload reasonably sized files.\"}\n//     </textarea>\n\n// ### Compatibility\n\n// This plugin has primarily been tested on Safari 5 (or later), Firefox 4 (or\n// later), and Internet Explorer (all the way back to version 6). While I\n// haven't found any issues with it so far, I'm fairly sure it still doesn't\n// work around all the quirks in all different browsers. But the code is still\n// pretty simple overall, so you should be able to fix it and contribute a\n// patch :)\n\n// ## Annotated Source\n\n(function($, undefined) {\n  \"use strict\";\n\n  // Register a prefilter that checks whether the `iframe` option is set, and\n  // switches to the \"iframe\" data type if it is `true`.\n  $.ajaxPrefilter(function(options, origOptions, jqXHR) {\n    if (options.iframe) {\n      return \"iframe\";\n    }\n  });\n\n  // Register a transport for the \"iframe\" data type. It will only activate\n  // when the \"files\" option has been set to a non-empty list of enabled file\n  // inputs.\n  $.ajaxTransport(\"iframe\", function(options, origOptions, jqXHR) {\n    var form = null,\n        iframe = null,\n        name = \"iframe-\" + $.now(),\n        files = $(options.files).filter(\":file:enabled\"),\n        markers = null;\n\n    // This function gets called after a successful submission or an abortion\n    // and should revert all changes made to the page to enable the\n    // submission via this transport.\n    function cleanUp() {\n      markers.replaceWith(function(idx) {\n        return files.get(idx);\n      });\n      form.remove();\n      iframe.attr(\"src\", \"javascript:false;\").remove();\n    }\n\n    // Remove \"iframe\" from the data types list so that further processing is\n    // based on the content type returned by the server, without attempting an\n    // (unsupported) conversion from \"iframe\" to the actual type.\n    options.dataTypes.shift();\n\n    if (files.length) {\n      form = $(\"<form enctype='multipart/form-data' method='post'></form>\").\n        hide().attr({action: options.url, target: name});\n\n      // If there is any additional data specified via the `data` option,\n      // we add it as hidden fields to the form. This (currently) requires\n      // the `processData` option to be set to false so that the data doesn't\n      // get serialized to a string.\n      if (typeof(options.data) === \"string\" && options.data.length > 0) {\n        $.error(\"data must not be serialized\");\n      }\n      $.each(options.data || {}, function(name, value) {\n        if ($.isPlainObject(value)) {\n          name = value.name;\n          value = value.value;\n        }\n        $(\"<input type='hidden'>\").attr({name:  name, value: value}).\n          appendTo(form);\n      });\n\n      // Add a hidden `X-Requested-With` field with the value `IFrame` to the\n      // field, to help server-side code to determine that the upload happened\n      // through this transport.\n      $(\"<input type='hidden' value='IFrame' name='X-Requested-With'>\").\n        appendTo(form);\n\n      // Move the file fields into the hidden form, but first remember their\n      // original locations in the document by replacing them with disabled\n      // clones. This should also avoid introducing unwanted changes to the\n      // page layout during submission.\n      markers = files.after(function(idx) {\n        return $(this).clone().prop(\"disabled\", true);\n      }).next();\n      files.appendTo(form);\n\n      return {\n\n        // The `send` function is called by jQuery when the request should be\n        // sent.\n        send: function(headers, completeCallback) {\n          iframe = $(\"<iframe src='javascript:false;' name='\" + name +\n            \"' style='display:none'></iframe>\");\n\n          // The first load event gets fired after the iframe has been injected\n          // into the DOM, and is used to prepare the actual submission.\n          iframe.bind(\"load\", function() {\n\n            // The second load event gets fired when the response to the form\n            // submission is received. The implementation detects whether the\n            // actual payload is embedded in a `<textarea>` element, and\n            // prepares the required conversions to be made in that case.\n            iframe.unbind(\"load\").bind(\"load\", function() {\n              var doc = this.contentWindow ? this.contentWindow.document :\n                (this.contentDocument ? this.contentDocument : this.document),\n                root = doc.documentElement ? doc.documentElement : doc.body,\n                textarea = root.getElementsByTagName(\"textarea\")[0],\n                type = textarea ? textarea.getAttribute(\"data-type\") : null,\n                content = {\n                  html: root.innerHTML,\n                  text: type ?\n                    textarea.value :\n                    root ? (root.innerText || root.textContent) : null\n                };\n              cleanUp();\n              completeCallback(200, \"OK\", content, type ?\n                (\"Content-Type: \" + type) :\n                null);\n            });\n\n            // Now that the load handler has been set up, submit the form.\n            form[0].submit();\n          });\n\n          // After everything has been set up correctly, the form and iframe\n          // get injected into the DOM so that the submission can be\n          // initiated.\n          $(\"body\").append(form, iframe);\n        },\n\n        // The `abort` function is called by jQuery when the request should be\n        // aborted.\n        abort: function() {\n          if (iframe !== null) {\n            iframe.unbind(\"load\").attr(\"src\", \"javascript:false;\");\n            cleanUp();\n          }\n        }\n\n      };\n    }\n  });\n\n})(jQuery);"

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(28))

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = "/*\n * Your installation or use of this SugarCRM file is subject to the applicable\n * terms available at\n * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.\n * If you do not agree to all of the applicable terms or do not have the\n * authority to bind the entity as an authorized representative, then do not\n * install or use this SugarCRM file.\n *\n * Copyright (C) SugarCRM Inc. All rights reserved.\n */\nfunction version_compare (v1, v2, operator) {\n  // http://kevin.vanzonneveld.net\n  // +      original by: Philippe Jausions (http://pear.php.net/user/jausions)\n  // +      original by: Aidan Lister (http://aidanlister.com/)\n  // + reimplemented by: Kankrelune (http://www.webfaktory.info/)\n  // +      improved by: Brett Zamir (http://brett-zamir.me)\n  // +      improved by: Scott Baker\n  // +      improved by: Theriault\n  // *        example 1: version_compare('8.2.5rc', '8.2.5a');\n  // *        returns 1: 1\n  // *        example 2: version_compare('8.2.50', '8.2.52', '<');\n  // *        returns 2: true\n  // *        example 3: version_compare('5.3.0-dev', '5.3.0');\n  // *        returns 3: -1\n  // *        example 4: version_compare('4.1.0.52','4.01.0.51');\n  // *        returns 4: 1\n  // BEGIN REDUNDANT\n  this.php_js = this.php_js || {};\n  this.php_js.ENV = this.php_js.ENV || {};\n  // END REDUNDANT\n  // Important: compare must be initialized at 0.\n  var i = 0,\n    x = 0,\n    compare = 0,\n    // vm maps textual PHP versions to negatives so they're less than 0.\n    // PHP currently defines these as CASE-SENSITIVE. It is important to\n    // leave these as negatives so that they can come before numerical versions\n    // and as if no letters were there to begin with.\n    // (1alpha is < 1 and < 1.1 but > 1dev1)\n    // If a non-numerical value can't be mapped to this table, it receives\n    // -7 as its value.\n    vm = {\n      'dev': -6,\n      'alpha': -5,\n      'a': -5,\n      'beta': -4,\n      'b': -4,\n      'RC': -3,\n      'rc': -3,\n      '#': -2,\n      'p': -1,\n      'pl': -1\n    },\n    // This function will be called to prepare each version argument.\n    // It replaces every _, -, and + with a dot.\n    // It surrounds any nonsequence of numbers/dots with dots.\n    // It replaces sequences of dots with a single dot.\n    //    version_compare('4..0', '4.0') == 0\n    // Important: A string of 0 length needs to be converted into a value\n    // even less than an unexisting value in vm (-7), hence [-8].\n    // It's also important to not strip spaces because of this.\n    //   version_compare('', ' ') == 1\n    prepVersion = function (v) {\n      v = ('' + v).replace(/[_\\-+]/g, '.');\n      v = v.replace(/([^.\\d]+)/g, '.$1.').replace(/\\.{2,}/g, '.');\n      return (!v.length ? [-8] : v.split('.'));\n    },\n    // This converts a version component to a number.\n    // Empty component becomes 0.\n    // Non-numerical component becomes a negative number.\n    // Numerical component becomes itself as an integer.\n    numVersion = function (v) {\n      return !v ? 0 : (isNaN(v) ? vm[v] || -7 : parseInt(v, 10));\n    };\n  v1 = prepVersion(v1);\n  v2 = prepVersion(v2);\n  x = Math.max(v1.length, v2.length);\n  for (i = 0; i < x; i++) {\n    if (v1[i] == v2[i]) {\n      continue;\n    }\n    v1[i] = numVersion(v1[i]);\n    v2[i] = numVersion(v2[i]);\n    if (v1[i] < v2[i]) {\n      compare = -1;\n      break;\n    } else if (v1[i] > v2[i]) {\n      compare = 1;\n      break;\n    }\n  }\n  if (!operator) {\n    return compare;\n  }\n\n  // Important: operator is CASE-SENSITIVE.\n  // \"No operator\" seems to be treated as \"<.\"\n  // Any other values seem to make the function return null.\n  switch (operator) {\n  case '>':\n  case 'gt':\n    return (compare > 0);\n  case '>=':\n  case 'ge':\n    return (compare >= 0);\n  case '<=':\n  case 'le':\n    return (compare <= 0);\n  case '==':\n  case '=':\n  case 'eq':\n    return (compare === 0);\n  case '<>':\n  case '!=':\n  case 'ne':\n    return (compare !== 0);\n  case '':\n  case '<':\n  case 'lt':\n    return (compare < 0);\n  default:\n    return null;\n  }\n}\n"

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3)(__webpack_require__(30))

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = "/* big.js v3.1.3 https://github.com/MikeMcl/big.js/LICENCE */\r\n;(function (global) {\r\n    'use strict';\r\n\r\n/*\r\n  big.js v3.1.3\r\n  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.\r\n  https://github.com/MikeMcl/big.js/\r\n  Copyright (c) 2014 Michael Mclaughlin <M8ch88l@gmail.com>\r\n  MIT Expat Licence\r\n*/\r\n\r\n/***************************** EDITABLE DEFAULTS ******************************/\r\n\r\n    // The default values below must be integers within the stated ranges.\r\n\r\n    /*\r\n     * The maximum number of decimal places of the results of operations\r\n     * involving division: div and sqrt, and pow with negative exponents.\r\n     */\r\n    var DP = 20,                           // 0 to MAX_DP\r\n\r\n        /*\r\n         * The rounding mode used when rounding to the above decimal places.\r\n         *\r\n         * 0 Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)\r\n         * 1 To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)\r\n         * 2 To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)\r\n         * 3 Away from zero.                                  (ROUND_UP)\r\n         */\r\n        RM = 1,                            // 0, 1, 2 or 3\r\n\r\n        // The maximum value of DP and Big.DP.\r\n        MAX_DP = 1E6,                      // 0 to 1000000\r\n\r\n        // The maximum magnitude of the exponent argument to the pow method.\r\n        MAX_POWER = 1E6,                   // 1 to 1000000\r\n\r\n        /*\r\n         * The exponent value at and beneath which toString returns exponential\r\n         * notation.\r\n         * JavaScript's Number type: -7\r\n         * -1000000 is the minimum recommended exponent value of a Big.\r\n         */\r\n        E_NEG = -7,                   // 0 to -1000000\r\n\r\n        /*\r\n         * The exponent value at and above which toString returns exponential\r\n         * notation.\r\n         * JavaScript's Number type: 21\r\n         * 1000000 is the maximum recommended exponent value of a Big.\r\n         * (This limit is not enforced or checked.)\r\n         */\r\n        E_POS = 21,                   // 0 to 1000000\r\n\r\n/******************************************************************************/\r\n\r\n        // The shared prototype object.\r\n        P = {},\r\n        isValid = /^-?(\\d+(\\.\\d*)?|\\.\\d+)(e[+-]?\\d+)?$/i,\r\n        Big;\r\n\r\n\r\n    /*\r\n     * Create and return a Big constructor.\r\n     *\r\n     */\r\n    function bigFactory() {\r\n\r\n        /*\r\n         * The Big constructor and exported function.\r\n         * Create and return a new instance of a Big number object.\r\n         *\r\n         * n {number|string|Big} A numeric value.\r\n         */\r\n        function Big(n) {\r\n            var x = this;\r\n\r\n            // Enable constructor usage without new.\r\n            if (!(x instanceof Big)) {\r\n                return n === void 0 ? bigFactory() : new Big(n);\r\n            }\r\n\r\n            // Duplicate.\r\n            if (n instanceof Big) {\r\n                x.s = n.s;\r\n                x.e = n.e;\r\n                x.c = n.c.slice();\r\n            } else {\r\n                parse(x, n);\r\n            }\r\n\r\n            /*\r\n             * Retain a reference to this Big constructor, and shadow\r\n             * Big.prototype.constructor which points to Object.\r\n             */\r\n            x.constructor = Big;\r\n        }\r\n\r\n        Big.prototype = P;\r\n        Big.DP = DP;\r\n        Big.RM = RM;\r\n        Big.E_NEG = E_NEG;\r\n        Big.E_POS = E_POS;\r\n\r\n        return Big;\r\n    }\r\n\r\n\r\n    // Private functions\r\n\r\n\r\n    /*\r\n     * Return a string representing the value of Big x in normal or exponential\r\n     * notation to dp fixed decimal places or significant digits.\r\n     *\r\n     * x {Big} The Big to format.\r\n     * dp {number} Integer, 0 to MAX_DP inclusive.\r\n     * toE {number} 1 (toExponential), 2 (toPrecision) or undefined (toFixed).\r\n     */\r\n    function format(x, dp, toE) {\r\n        var Big = x.constructor,\r\n\r\n            // The index (normal notation) of the digit that may be rounded up.\r\n            i = dp - (x = new Big(x)).e,\r\n            c = x.c;\r\n\r\n        // Round?\r\n        if (c.length > ++dp) {\r\n            rnd(x, i, Big.RM);\r\n        }\r\n\r\n        if (!c[0]) {\r\n            ++i;\r\n        } else if (toE) {\r\n            i = dp;\r\n\r\n        // toFixed\r\n        } else {\r\n            c = x.c;\r\n\r\n            // Recalculate i as x.e may have changed if value rounded up.\r\n            i = x.e + i + 1;\r\n        }\r\n\r\n        // Append zeros?\r\n        for (; c.length < i; c.push(0)) {\r\n        }\r\n        i = x.e;\r\n\r\n        /*\r\n         * toPrecision returns exponential notation if the number of\r\n         * significant digits specified is less than the number of digits\r\n         * necessary to represent the integer part of the value in normal\r\n         * notation.\r\n         */\r\n        return toE === 1 || toE && (dp <= i || i <= Big.E_NEG) ?\r\n\r\n          // Exponential notation.\r\n          (x.s < 0 && c[0] ? '-' : '') +\r\n            (c.length > 1 ? c[0] + '.' + c.join('').slice(1) : c[0]) +\r\n              (i < 0 ? 'e' : 'e+') + i\r\n\r\n          // Normal notation.\r\n          : x.toString();\r\n    }\r\n\r\n\r\n    /*\r\n     * Parse the number or string value passed to a Big constructor.\r\n     *\r\n     * x {Big} A Big number instance.\r\n     * n {number|string} A numeric value.\r\n     */\r\n    function parse(x, n) {\r\n        var e, i, nL;\r\n\r\n        // Minus zero?\r\n        if (n === 0 && 1 / n < 0) {\r\n            n = '-0';\r\n\r\n        // Ensure n is string and check validity.\r\n        } else if (!isValid.test(n += '')) {\r\n            throwErr(NaN);\r\n        }\r\n\r\n        // Determine sign.\r\n        x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;\r\n\r\n        // Decimal point?\r\n        if ((e = n.indexOf('.')) > -1) {\r\n            n = n.replace('.', '');\r\n        }\r\n\r\n        // Exponential form?\r\n        if ((i = n.search(/e/i)) > 0) {\r\n\r\n            // Determine exponent.\r\n            if (e < 0) {\r\n                e = i;\r\n            }\r\n            e += +n.slice(i + 1);\r\n            n = n.substring(0, i);\r\n\r\n        } else if (e < 0) {\r\n\r\n            // Integer.\r\n            e = n.length;\r\n        }\r\n\r\n        // Determine leading zeros.\r\n        for (i = 0; n.charAt(i) == '0'; i++) {\r\n        }\r\n\r\n        if (i == (nL = n.length)) {\r\n\r\n            // Zero.\r\n            x.c = [ x.e = 0 ];\r\n        } else {\r\n\r\n            // Determine trailing zeros.\r\n            for (; n.charAt(--nL) == '0';) {\r\n            }\r\n\r\n            x.e = e - i - 1;\r\n            x.c = [];\r\n\r\n            // Convert string to array of digits without leading/trailing zeros.\r\n            for (e = 0; i <= nL; x.c[e++] = +n.charAt(i++)) {\r\n            }\r\n        }\r\n\r\n        return x;\r\n    }\r\n\r\n\r\n    /*\r\n     * Round Big x to a maximum of dp decimal places using rounding mode rm.\r\n     * Called by div, sqrt and round.\r\n     *\r\n     * x {Big} The Big to round.\r\n     * dp {number} Integer, 0 to MAX_DP inclusive.\r\n     * rm {number} 0, 1, 2 or 3 (DOWN, HALF_UP, HALF_EVEN, UP)\r\n     * [more] {boolean} Whether the result of division was truncated.\r\n     */\r\n    function rnd(x, dp, rm, more) {\r\n        var u,\r\n            xc = x.c,\r\n            i = x.e + dp + 1;\r\n\r\n        if (rm === 1) {\r\n\r\n            // xc[i] is the digit after the digit that may be rounded up.\r\n            more = xc[i] >= 5;\r\n        } else if (rm === 2) {\r\n            more = xc[i] > 5 || xc[i] == 5 &&\r\n              (more || i < 0 || xc[i + 1] !== u || xc[i - 1] & 1);\r\n        } else if (rm === 3) {\r\n            more = more || xc[i] !== u || i < 0;\r\n        } else {\r\n            more = false;\r\n\r\n            if (rm !== 0) {\r\n                throwErr('!Big.RM!');\r\n            }\r\n        }\r\n\r\n        if (i < 1 || !xc[0]) {\r\n\r\n            if (more) {\r\n\r\n                // 1, 0.1, 0.01, 0.001, 0.0001 etc.\r\n                x.e = -dp;\r\n                x.c = [1];\r\n            } else {\r\n\r\n                // Zero.\r\n                x.c = [x.e = 0];\r\n            }\r\n        } else {\r\n\r\n            // Remove any digits after the required decimal places.\r\n            xc.length = i--;\r\n\r\n            // Round up?\r\n            if (more) {\r\n\r\n                // Rounding up may mean the previous digit has to be rounded up.\r\n                for (; ++xc[i] > 9;) {\r\n                    xc[i] = 0;\r\n\r\n                    if (!i--) {\r\n                        ++x.e;\r\n                        xc.unshift(1);\r\n                    }\r\n                }\r\n            }\r\n\r\n            // Remove trailing zeros.\r\n            for (i = xc.length; !xc[--i]; xc.pop()) {\r\n            }\r\n        }\r\n\r\n        return x;\r\n    }\r\n\r\n\r\n    /*\r\n     * Throw a BigError.\r\n     *\r\n     * message {string} The error message.\r\n     */\r\n    function throwErr(message) {\r\n        var err = new Error(message);\r\n        err.name = 'BigError';\r\n\r\n        throw err;\r\n    }\r\n\r\n\r\n    // Prototype/instance methods\r\n\r\n\r\n    /*\r\n     * Return a new Big whose value is the absolute value of this Big.\r\n     */\r\n    P.abs = function () {\r\n        var x = new this.constructor(this);\r\n        x.s = 1;\r\n\r\n        return x;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return\r\n     * 1 if the value of this Big is greater than the value of Big y,\r\n     * -1 if the value of this Big is less than the value of Big y, or\r\n     * 0 if they have the same value.\r\n    */\r\n    P.cmp = function (y) {\r\n        var xNeg,\r\n            x = this,\r\n            xc = x.c,\r\n            yc = (y = new x.constructor(y)).c,\r\n            i = x.s,\r\n            j = y.s,\r\n            k = x.e,\r\n            l = y.e;\r\n\r\n        // Either zero?\r\n        if (!xc[0] || !yc[0]) {\r\n            return !xc[0] ? !yc[0] ? 0 : -j : i;\r\n        }\r\n\r\n        // Signs differ?\r\n        if (i != j) {\r\n            return i;\r\n        }\r\n        xNeg = i < 0;\r\n\r\n        // Compare exponents.\r\n        if (k != l) {\r\n            return k > l ^ xNeg ? 1 : -1;\r\n        }\r\n\r\n        i = -1;\r\n        j = (k = xc.length) < (l = yc.length) ? k : l;\r\n\r\n        // Compare digit by digit.\r\n        for (; ++i < j;) {\r\n\r\n            if (xc[i] != yc[i]) {\r\n                return xc[i] > yc[i] ^ xNeg ? 1 : -1;\r\n            }\r\n        }\r\n\r\n        // Compare lengths.\r\n        return k == l ? 0 : k > l ^ xNeg ? 1 : -1;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return a new Big whose value is the value of this Big divided by the\r\n     * value of Big y, rounded, if necessary, to a maximum of Big.DP decimal\r\n     * places using rounding mode Big.RM.\r\n     */\r\n    P.div = function (y) {\r\n        var x = this,\r\n            Big = x.constructor,\r\n            // dividend\r\n            dvd = x.c,\r\n            //divisor\r\n            dvs = (y = new Big(y)).c,\r\n            s = x.s == y.s ? 1 : -1,\r\n            dp = Big.DP;\r\n\r\n        if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {\r\n            throwErr('!Big.DP!');\r\n        }\r\n\r\n        // Either 0?\r\n        if (!dvd[0] || !dvs[0]) {\r\n\r\n            // If both are 0, throw NaN\r\n            if (dvd[0] == dvs[0]) {\r\n                throwErr(NaN);\r\n            }\r\n\r\n            // If dvs is 0, throw +-Infinity.\r\n            if (!dvs[0]) {\r\n                throwErr(s / 0);\r\n            }\r\n\r\n            // dvd is 0, return +-0.\r\n            return new Big(s * 0);\r\n        }\r\n\r\n        var dvsL, dvsT, next, cmp, remI, u,\r\n            dvsZ = dvs.slice(),\r\n            dvdI = dvsL = dvs.length,\r\n            dvdL = dvd.length,\r\n            // remainder\r\n            rem = dvd.slice(0, dvsL),\r\n            remL = rem.length,\r\n            // quotient\r\n            q = y,\r\n            qc = q.c = [],\r\n            qi = 0,\r\n            digits = dp + (q.e = x.e - y.e) + 1;\r\n\r\n        q.s = s;\r\n        s = digits < 0 ? 0 : digits;\r\n\r\n        // Create version of divisor with leading zero.\r\n        dvsZ.unshift(0);\r\n\r\n        // Add zeros to make remainder as long as divisor.\r\n        for (; remL++ < dvsL; rem.push(0)) {\r\n        }\r\n\r\n        do {\r\n\r\n            // 'next' is how many times the divisor goes into current remainder.\r\n            for (next = 0; next < 10; next++) {\r\n\r\n                // Compare divisor and remainder.\r\n                if (dvsL != (remL = rem.length)) {\r\n                    cmp = dvsL > remL ? 1 : -1;\r\n                } else {\r\n\r\n                    for (remI = -1, cmp = 0; ++remI < dvsL;) {\r\n\r\n                        if (dvs[remI] != rem[remI]) {\r\n                            cmp = dvs[remI] > rem[remI] ? 1 : -1;\r\n                            break;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                // If divisor < remainder, subtract divisor from remainder.\r\n                if (cmp < 0) {\r\n\r\n                    // Remainder can't be more than 1 digit longer than divisor.\r\n                    // Equalise lengths using divisor with extra leading zero?\r\n                    for (dvsT = remL == dvsL ? dvs : dvsZ; remL;) {\r\n\r\n                        if (rem[--remL] < dvsT[remL]) {\r\n                            remI = remL;\r\n\r\n                            for (; remI && !rem[--remI]; rem[remI] = 9) {\r\n                            }\r\n                            --rem[remI];\r\n                            rem[remL] += 10;\r\n                        }\r\n                        rem[remL] -= dvsT[remL];\r\n                    }\r\n                    for (; !rem[0]; rem.shift()) {\r\n                    }\r\n                } else {\r\n                    break;\r\n                }\r\n            }\r\n\r\n            // Add the 'next' digit to the result array.\r\n            qc[qi++] = cmp ? next : ++next;\r\n\r\n            // Update the remainder.\r\n            if (rem[0] && cmp) {\r\n                rem[remL] = dvd[dvdI] || 0;\r\n            } else {\r\n                rem = [ dvd[dvdI] ];\r\n            }\r\n\r\n        } while ((dvdI++ < dvdL || rem[0] !== u) && s--);\r\n\r\n        // Leading zero? Do not remove if result is simply zero (qi == 1).\r\n        if (!qc[0] && qi != 1) {\r\n\r\n            // There can't be more than one zero.\r\n            qc.shift();\r\n            q.e--;\r\n        }\r\n\r\n        // Round?\r\n        if (qi > digits) {\r\n            rnd(q, dp, Big.RM, rem[0] !== u);\r\n        }\r\n\r\n        return q;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return true if the value of this Big is equal to the value of Big y,\r\n     * otherwise returns false.\r\n     */\r\n    P.eq = function (y) {\r\n        return !this.cmp(y);\r\n    };\r\n\r\n\r\n    /*\r\n     * Return true if the value of this Big is greater than the value of Big y,\r\n     * otherwise returns false.\r\n     */\r\n    P.gt = function (y) {\r\n        return this.cmp(y) > 0;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return true if the value of this Big is greater than or equal to the\r\n     * value of Big y, otherwise returns false.\r\n     */\r\n    P.gte = function (y) {\r\n        return this.cmp(y) > -1;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return true if the value of this Big is less than the value of Big y,\r\n     * otherwise returns false.\r\n     */\r\n    P.lt = function (y) {\r\n        return this.cmp(y) < 0;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return true if the value of this Big is less than or equal to the value\r\n     * of Big y, otherwise returns false.\r\n     */\r\n    P.lte = function (y) {\r\n         return this.cmp(y) < 1;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return a new Big whose value is the value of this Big minus the value\r\n     * of Big y.\r\n     */\r\n    P.sub = P.minus = function (y) {\r\n        var i, j, t, xLTy,\r\n            x = this,\r\n            Big = x.constructor,\r\n            a = x.s,\r\n            b = (y = new Big(y)).s;\r\n\r\n        // Signs differ?\r\n        if (a != b) {\r\n            y.s = -b;\r\n            return x.plus(y);\r\n        }\r\n\r\n        var xc = x.c.slice(),\r\n            xe = x.e,\r\n            yc = y.c,\r\n            ye = y.e;\r\n\r\n        // Either zero?\r\n        if (!xc[0] || !yc[0]) {\r\n\r\n            // y is non-zero? x is non-zero? Or both are zero.\r\n            return yc[0] ? (y.s = -b, y) : new Big(xc[0] ? x : 0);\r\n        }\r\n\r\n        // Determine which is the bigger number.\r\n        // Prepend zeros to equalise exponents.\r\n        if (a = xe - ye) {\r\n\r\n            if (xLTy = a < 0) {\r\n                a = -a;\r\n                t = xc;\r\n            } else {\r\n                ye = xe;\r\n                t = yc;\r\n            }\r\n\r\n            t.reverse();\r\n            for (b = a; b--; t.push(0)) {\r\n            }\r\n            t.reverse();\r\n        } else {\r\n\r\n            // Exponents equal. Check digit by digit.\r\n            j = ((xLTy = xc.length < yc.length) ? xc : yc).length;\r\n\r\n            for (a = b = 0; b < j; b++) {\r\n\r\n                if (xc[b] != yc[b]) {\r\n                    xLTy = xc[b] < yc[b];\r\n                    break;\r\n                }\r\n            }\r\n        }\r\n\r\n        // x < y? Point xc to the array of the bigger number.\r\n        if (xLTy) {\r\n            t = xc;\r\n            xc = yc;\r\n            yc = t;\r\n            y.s = -y.s;\r\n        }\r\n\r\n        /*\r\n         * Append zeros to xc if shorter. No need to add zeros to yc if shorter\r\n         * as subtraction only needs to start at yc.length.\r\n         */\r\n        if (( b = (j = yc.length) - (i = xc.length) ) > 0) {\r\n\r\n            for (; b--; xc[i++] = 0) {\r\n            }\r\n        }\r\n\r\n        // Subtract yc from xc.\r\n        for (b = i; j > a;){\r\n\r\n            if (xc[--j] < yc[j]) {\r\n\r\n                for (i = j; i && !xc[--i]; xc[i] = 9) {\r\n                }\r\n                --xc[i];\r\n                xc[j] += 10;\r\n            }\r\n            xc[j] -= yc[j];\r\n        }\r\n\r\n        // Remove trailing zeros.\r\n        for (; xc[--b] === 0; xc.pop()) {\r\n        }\r\n\r\n        // Remove leading zeros and adjust exponent accordingly.\r\n        for (; xc[0] === 0;) {\r\n            xc.shift();\r\n            --ye;\r\n        }\r\n\r\n        if (!xc[0]) {\r\n\r\n            // n - n = +0\r\n            y.s = 1;\r\n\r\n            // Result must be zero.\r\n            xc = [ye = 0];\r\n        }\r\n\r\n        y.c = xc;\r\n        y.e = ye;\r\n\r\n        return y;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return a new Big whose value is the value of this Big modulo the\r\n     * value of Big y.\r\n     */\r\n    P.mod = function (y) {\r\n        var yGTx,\r\n            x = this,\r\n            Big = x.constructor,\r\n            a = x.s,\r\n            b = (y = new Big(y)).s;\r\n\r\n        if (!y.c[0]) {\r\n            throwErr(NaN);\r\n        }\r\n\r\n        x.s = y.s = 1;\r\n        yGTx = y.cmp(x) == 1;\r\n        x.s = a;\r\n        y.s = b;\r\n\r\n        if (yGTx) {\r\n            return new Big(x);\r\n        }\r\n\r\n        a = Big.DP;\r\n        b = Big.RM;\r\n        Big.DP = Big.RM = 0;\r\n        x = x.div(y);\r\n        Big.DP = a;\r\n        Big.RM = b;\r\n\r\n        return this.minus( x.times(y) );\r\n    };\r\n\r\n\r\n    /*\r\n     * Return a new Big whose value is the value of this Big plus the value\r\n     * of Big y.\r\n     */\r\n    P.add = P.plus = function (y) {\r\n        var t,\r\n            x = this,\r\n            Big = x.constructor,\r\n            a = x.s,\r\n            b = (y = new Big(y)).s;\r\n\r\n        // Signs differ?\r\n        if (a != b) {\r\n            y.s = -b;\r\n            return x.minus(y);\r\n        }\r\n\r\n        var xe = x.e,\r\n            xc = x.c,\r\n            ye = y.e,\r\n            yc = y.c;\r\n\r\n        // Either zero?\r\n        if (!xc[0] || !yc[0]) {\r\n\r\n            // y is non-zero? x is non-zero? Or both are zero.\r\n            return yc[0] ? y : new Big(xc[0] ? x : a * 0);\r\n        }\r\n        xc = xc.slice();\r\n\r\n        // Prepend zeros to equalise exponents.\r\n        // Note: Faster to use reverse then do unshifts.\r\n        if (a = xe - ye) {\r\n\r\n            if (a > 0) {\r\n                ye = xe;\r\n                t = yc;\r\n            } else {\r\n                a = -a;\r\n                t = xc;\r\n            }\r\n\r\n            t.reverse();\r\n            for (; a--; t.push(0)) {\r\n            }\r\n            t.reverse();\r\n        }\r\n\r\n        // Point xc to the longer array.\r\n        if (xc.length - yc.length < 0) {\r\n            t = yc;\r\n            yc = xc;\r\n            xc = t;\r\n        }\r\n        a = yc.length;\r\n\r\n        /*\r\n         * Only start adding at yc.length - 1 as the further digits of xc can be\r\n         * left as they are.\r\n         */\r\n        for (b = 0; a;) {\r\n            b = (xc[--a] = xc[a] + yc[a] + b) / 10 | 0;\r\n            xc[a] %= 10;\r\n        }\r\n\r\n        // No need to check for zero, as +x + +y != 0 && -x + -y != 0\r\n\r\n        if (b) {\r\n            xc.unshift(b);\r\n            ++ye;\r\n        }\r\n\r\n         // Remove trailing zeros.\r\n        for (a = xc.length; xc[--a] === 0; xc.pop()) {\r\n        }\r\n\r\n        y.c = xc;\r\n        y.e = ye;\r\n\r\n        return y;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return a Big whose value is the value of this Big raised to the power n.\r\n     * If n is negative, round, if necessary, to a maximum of Big.DP decimal\r\n     * places using rounding mode Big.RM.\r\n     *\r\n     * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.\r\n     */\r\n    P.pow = function (n) {\r\n        var x = this,\r\n            one = new x.constructor(1),\r\n            y = one,\r\n            isNeg = n < 0;\r\n\r\n        if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) {\r\n            throwErr('!pow!');\r\n        }\r\n\r\n        n = isNeg ? -n : n;\r\n\r\n        for (;;) {\r\n\r\n            if (n & 1) {\r\n                y = y.times(x);\r\n            }\r\n            n >>= 1;\r\n\r\n            if (!n) {\r\n                break;\r\n            }\r\n            x = x.times(x);\r\n        }\r\n\r\n        return isNeg ? one.div(y) : y;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return a new Big whose value is the value of this Big rounded to a\r\n     * maximum of dp decimal places using rounding mode rm.\r\n     * If dp is not specified, round to 0 decimal places.\r\n     * If rm is not specified, use Big.RM.\r\n     *\r\n     * [dp] {number} Integer, 0 to MAX_DP inclusive.\r\n     * [rm] 0, 1, 2 or 3 (ROUND_DOWN, ROUND_HALF_UP, ROUND_HALF_EVEN, ROUND_UP)\r\n     */\r\n    P.round = function (dp, rm) {\r\n        var x = this,\r\n            Big = x.constructor;\r\n\r\n        if (dp == null) {\r\n            dp = 0;\r\n        } else if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {\r\n            throwErr('!round!');\r\n        }\r\n        rnd(x = new Big(x), dp, rm == null ? Big.RM : rm);\r\n\r\n        return x;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return a new Big whose value is the square root of the value of this Big,\r\n     * rounded, if necessary, to a maximum of Big.DP decimal places using\r\n     * rounding mode Big.RM.\r\n     */\r\n    P.sqrt = function () {\r\n        var estimate, r, approx,\r\n            x = this,\r\n            Big = x.constructor,\r\n            xc = x.c,\r\n            i = x.s,\r\n            e = x.e,\r\n            half = new Big('0.5');\r\n\r\n        // Zero?\r\n        if (!xc[0]) {\r\n            return new Big(x);\r\n        }\r\n\r\n        // If negative, throw NaN.\r\n        if (i < 0) {\r\n            throwErr(NaN);\r\n        }\r\n\r\n        // Estimate.\r\n        i = Math.sqrt(x.toString());\r\n\r\n        // Math.sqrt underflow/overflow?\r\n        // Pass x to Math.sqrt as integer, then adjust the result exponent.\r\n        if (i === 0 || i === 1 / 0) {\r\n            estimate = xc.join('');\r\n\r\n            if (!(estimate.length + e & 1)) {\r\n                estimate += '0';\r\n            }\r\n\r\n            r = new Big( Math.sqrt(estimate).toString() );\r\n            r.e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);\r\n        } else {\r\n            r = new Big(i.toString());\r\n        }\r\n\r\n        i = r.e + (Big.DP += 4);\r\n\r\n        // Newton-Raphson iteration.\r\n        do {\r\n            approx = r;\r\n            r = half.times( approx.plus( x.div(approx) ) );\r\n        } while ( approx.c.slice(0, i).join('') !==\r\n                       r.c.slice(0, i).join('') );\r\n\r\n        rnd(r, Big.DP -= 4, Big.RM);\r\n\r\n        return r;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return a new Big whose value is the value of this Big times the value of\r\n     * Big y.\r\n     */\r\n    P.mul = P.times = function (y) {\r\n        var c,\r\n            x = this,\r\n            Big = x.constructor,\r\n            xc = x.c,\r\n            yc = (y = new Big(y)).c,\r\n            a = xc.length,\r\n            b = yc.length,\r\n            i = x.e,\r\n            j = y.e;\r\n\r\n        // Determine sign of result.\r\n        y.s = x.s == y.s ? 1 : -1;\r\n\r\n        // Return signed 0 if either 0.\r\n        if (!xc[0] || !yc[0]) {\r\n            return new Big(y.s * 0);\r\n        }\r\n\r\n        // Initialise exponent of result as x.e + y.e.\r\n        y.e = i + j;\r\n\r\n        // If array xc has fewer digits than yc, swap xc and yc, and lengths.\r\n        if (a < b) {\r\n            c = xc;\r\n            xc = yc;\r\n            yc = c;\r\n            j = a;\r\n            a = b;\r\n            b = j;\r\n        }\r\n\r\n        // Initialise coefficient array of result with zeros.\r\n        for (c = new Array(j = a + b); j--; c[j] = 0) {\r\n        }\r\n\r\n        // Multiply.\r\n\r\n        // i is initially xc.length.\r\n        for (i = b; i--;) {\r\n            b = 0;\r\n\r\n            // a is yc.length.\r\n            for (j = a + i; j > i;) {\r\n\r\n                // Current sum of products at this digit position, plus carry.\r\n                b = c[j] + yc[i] * xc[j - i - 1] + b;\r\n                c[j--] = b % 10;\r\n\r\n                // carry\r\n                b = b / 10 | 0;\r\n            }\r\n            c[j] = (c[j] + b) % 10;\r\n        }\r\n\r\n        // Increment result exponent if there is a final carry.\r\n        if (b) {\r\n            ++y.e;\r\n        }\r\n\r\n        // Remove any leading zero.\r\n        if (!c[0]) {\r\n            c.shift();\r\n        }\r\n\r\n        // Remove trailing zeros.\r\n        for (i = c.length; !c[--i]; c.pop()) {\r\n        }\r\n        y.c = c;\r\n\r\n        return y;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return a string representing the value of this Big.\r\n     * Return exponential notation if this Big has a positive exponent equal to\r\n     * or greater than Big.E_POS, or a negative exponent equal to or less than\r\n     * Big.E_NEG.\r\n     */\r\n    P.toString = P.valueOf = P.toJSON = function () {\r\n        var x = this,\r\n            Big = x.constructor,\r\n            e = x.e,\r\n            str = x.c.join(''),\r\n            strL = str.length;\r\n\r\n        // Exponential notation?\r\n        if (e <= Big.E_NEG || e >= Big.E_POS) {\r\n            str = str.charAt(0) + (strL > 1 ? '.' + str.slice(1) : '') +\r\n              (e < 0 ? 'e' : 'e+') + e;\r\n\r\n        // Negative exponent?\r\n        } else if (e < 0) {\r\n\r\n            // Prepend zeros.\r\n            for (; ++e; str = '0' + str) {\r\n            }\r\n            str = '0.' + str;\r\n\r\n        // Positive exponent?\r\n        } else if (e > 0) {\r\n\r\n            if (++e > strL) {\r\n\r\n                // Append zeros.\r\n                for (e -= strL; e-- ; str += '0') {\r\n                }\r\n            } else if (e < strL) {\r\n                str = str.slice(0, e) + '.' + str.slice(e);\r\n            }\r\n\r\n        // Exponent zero.\r\n        } else if (strL > 1) {\r\n            str = str.charAt(0) + '.' + str.slice(1);\r\n        }\r\n\r\n        // Avoid '-0'\r\n        return x.s < 0 && x.c[0] ? '-' + str : str;\r\n    };\r\n\r\n\r\n    /*\r\n     ***************************************************************************\r\n     * If toExponential, toFixed, toPrecision and format are not required they\r\n     * can safely be commented-out or deleted. No redundant code will be left.\r\n     * format is used only by toExponential, toFixed and toPrecision.\r\n     ***************************************************************************\r\n     */\r\n\r\n\r\n    /*\r\n     * Return a string representing the value of this Big in exponential\r\n     * notation to dp fixed decimal places and rounded, if necessary, using\r\n     * Big.RM.\r\n     *\r\n     * [dp] {number} Integer, 0 to MAX_DP inclusive.\r\n     */\r\n    P.toExponential = function (dp) {\r\n\r\n        if (dp == null) {\r\n            dp = this.c.length - 1;\r\n        } else if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {\r\n            throwErr('!toExp!');\r\n        }\r\n\r\n        return format(this, dp, 1);\r\n    };\r\n\r\n\r\n    /*\r\n     * Return a string representing the value of this Big in normal notation\r\n     * to dp fixed decimal places and rounded, if necessary, using Big.RM.\r\n     *\r\n     * [dp] {number} Integer, 0 to MAX_DP inclusive.\r\n     */\r\n    P.toFixed = function (dp) {\r\n        var str,\r\n            x = this,\r\n            Big = x.constructor,\r\n            neg = Big.E_NEG,\r\n            pos = Big.E_POS;\r\n\r\n        // Prevent the possibility of exponential notation.\r\n        Big.E_NEG = -(Big.E_POS = 1 / 0);\r\n\r\n        if (dp == null) {\r\n            str = x.toString();\r\n        } else if (dp === ~~dp && dp >= 0 && dp <= MAX_DP) {\r\n            str = format(x, x.e + dp);\r\n\r\n            // (-0).toFixed() is '0', but (-0.1).toFixed() is '-0'.\r\n            // (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.\r\n            if (x.s < 0 && x.c[0] && str.indexOf('-') < 0) {\r\n        //E.g. -0.5 if rounded to -0 will cause toString to omit the minus sign.\r\n                str = '-' + str;\r\n            }\r\n        }\r\n        Big.E_NEG = neg;\r\n        Big.E_POS = pos;\r\n\r\n        if (!str) {\r\n            throwErr('!toFix!');\r\n        }\r\n\r\n        return str;\r\n    };\r\n\r\n\r\n    /*\r\n     * Return a string representing the value of this Big rounded to sd\r\n     * significant digits using Big.RM. Use exponential notation if sd is less\r\n     * than the number of digits necessary to represent the integer part of the\r\n     * value in normal notation.\r\n     *\r\n     * sd {number} Integer, 1 to MAX_DP inclusive.\r\n     */\r\n    P.toPrecision = function (sd) {\r\n\r\n        if (sd == null) {\r\n            return this.toString();\r\n        } else if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {\r\n            throwErr('!toPre!');\r\n        }\r\n\r\n        return format(this, sd - 1, 2);\r\n    };\r\n\r\n\r\n    // Export\r\n\r\n\r\n    Big = bigFactory();\r\n\r\n    //AMD.\r\n    if (typeof define === 'function' && define.amd) {\r\n        define(function () {\r\n            return Big;\r\n        });\r\n\r\n    // Node and other CommonJS-like environments that support module.exports.\r\n    } else if (typeof module !== 'undefined' && module.exports) {\r\n        module.exports = Big;\r\n\r\n    //Browser.\r\n    } else {\r\n        global.Big = Big;\r\n    }\r\n})(this);\r\n"

/***/ },
/* 31 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	var SUGAR = window.SUGAR;
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/*;
	 * SugarCRM Javascript API
	 */
	
	//create the SUGAR namespace if one does not exist already
	var SUGAR = SUGAR || {};
	
	/**
	 * SugarCRM Javascript API allows users to interact with SugarCRM instance via its REST interface.
	 *
	 * Use {@link SUGAR.Api#getInstance} method to create instances of Sugar API.
	 * This method accepts arguments object with the following properties:
	 * <pre>
	 * {
	 *   serverUrl: Sugar REST URL end-point
	 *   platform: platform name ("portal", "mobile", etc.)
	 *   keyValueStore: reference to key/value store provider used to read/save auth token from/to
	 *   timeout: request timeout in seconds
	 * }
	 * </pre>
	 *
	 * The key/value store provider must implement three methods:
	 * <pre><code>
	 *   set: void function(String key, String value)
	 *   get: String function(key)
	 *   cut: void function(String key)
	 * </code></pre>
	 * The authentication tokens are kept in memory if the key/value store is not specified.
	 *
	 * Most of Sugar API methods accept `callbacks` object:
	 * <pre>
	 * {
	 *   success: function(data) { },
	 *   error: function(error) { },
	 *   complete: function() { },
	 * }
	 * </pre>
	 *
	 * @class SUGAR.Api
	 * @singleton
	 */
	SUGAR.Api = (function() {
	    var _instance;
	    var _methodsToRequest = {
	            'read': 'GET',
	            'update': 'PUT',
	            'create': 'POST',
	            'delete': 'DELETE'
	        };
	    var _baseActions = ['read', 'update', 'create', 'delete'];
	    var _numCallsInProgress = 0;
	    var _refreshTokenSuccess = function(c) {c();};
	    var _bulkQueues = { };
	    var _state = { };
	
	    var HttpError = function(request, textStatus, errorThrown) {
	
	        request = request || {};
	        request.xhr = request.xhr || {};
	
	        /**
	         * AJAX request that caused the error.
	         * @property {SUGAR.HttpRequest}
	         * @member SUGAR.HttpError
	         */
	        this.request = request;
	
	        /**
	         * XHR status code.
	         * @property {string|number}
	         * @member SUGAR.HttpError
	         */
	        this.status = request.xhr.status;
	
	        /**
	         * XHR response text.
	         * @property {String}
	         * @member SUGAR.HttpError
	         */
	        this.responseText = request.xhr.responseText;
	
	        /**
	         * String describing the type of error that occurred.
	         *
	         * Possible values (besides null) are `"timeout"`, `"error"`, `"abort"`, and `"parsererror"`.
	         * @property {String}
	         * @member SUGAR.HttpError
	         */
	        this.textStatus = textStatus;
	
	        /**
	         * Textual portion of the HTTP status when HTTP error occurs.
	         *
	         * For example, `"Not Found"` or `"Internal Server Error"`.
	         * @property {String}
	         * @member SUGAR.HttpError
	         */
	        this.errorThrown = errorThrown;
	
	        // The response will not be always a JSON string
	
	        if (typeof(this.responseText) === 'string' && this.responseText.length > 0) {
	            try {
	                var contentType = this.request.xhr.getResponseHeader('Content-Type');
	                if (contentType && (contentType.indexOf('application/json') === 0)) {
	                    this.payload = JSON.parse(this.responseText);
	                    /**
	                     * Error code.
	                     *
	                     * Additional failure information. See SugarCRM REST API
	                     * documentation for a full list of error codes.
	                     * @property {String}
	                     * @member SUGAR.HttpError
	                     */
	                    this.code = this.payload.error;
	
	                    /**
	                     * Error message.
	                     *
	                     * Localized message appropriate for display to end user.
	                     * @property {String}
	                     * @member SUGAR.HttpError
	                     */
	                    this.message = this.payload.error_message;
	                }
	            }
	            catch (e) {
	                // Ignore this error
	            }
	        }
	    };
	
	    /**
	     * Represents AJAX error.
	     *
	     * See Jquery/Zepto documentation for details.
	     *
	     * - http://api.jquery.com/jQuery.ajax/
	     * - http://zeptojs.com/#$.ajax
	     *
	     * @class SUGAR.HttpError
	     */
	    _.extend(HttpError.prototype, {
	
	        /**
	         * Returns string representation of HTTP error.
	         * @return {String} HTTP error as a string.
	         * @member SUGAR.HttpError
	         */
	        toString: function() {
	            return 'HTTP error: ' + this.status +
	                '\ntype: ' + this.textStatus +
	                '\nerror: ' + this.errorThrown +
	                '\nresponse: ' + this.responseText +
	                '\ncode: ' + this.code +
	                '\nmessage: ' + this.message;
	        }
	
	    });
	
	    var HttpRequest = function(params, debug) {
	        /**
	         * Request parameters.
	         *
	         * See Jquery/Zepto documentation for details.
	         *
	         * - http://api.jquery.com/jQuery.ajax/
	         * - http://zeptojs.com/#$.ajax
	         *
	         * @property {Object}
	         * @member SUGAR.HttpRequest
	         */
	        this.params = params; // TODO: Consider cloning
	
	        /**
	         * Flag indicating that a request must output debug information.
	         * @property {Boolean}
	         * @member SUGAR.HttpRequest
	         */
	        this.debug = debug;
	
	        /**
	         * Number of times this request was executed.
	         * @property {Number}
	         * @member SUGAR.HttpRequest
	         */
	        this.numExecuted = 0;
	
	        /**
	         * The state object is used to store global enviroment conditions that may be relevent
	         * when processing this request but would not be passed to the server.
	         *
	         * @property {Object}
	         * @member SUGAR.HttpRequest
	         */
	        this.state = {};
	    };
	
	    /**
	     * Represents AJAX request.
	     *
	     * Encapsulates XHR object and AJAX parameters.
	     * @class SUGAR.HttpRequest
	     *
	     */
	    _.extend(HttpRequest.prototype, {
	
	        /**
	         * Executes AJAX request.
	         * @param {string} token OAuth token. Must not be supplied for login
	         *   type requests.
	         * @param {string} mdHash current private metadata hash, used to
	         *   validate the client metadata against the server.
	         * @param {string} upHash Current User preferences hash, used to
	         *   validate the client user pref data against the server.
	         */
	        execute: function(token, mdHash, upHash) {
	            if (token) {
	                this.params.headers = this.params.headers || {};
	                this.params.headers['OAuth-Token'] = token;
	            }
	            if (mdHash) {
	                this.params.headers = this.params.headers || {};
	                this.params.headers['X-Metadata-Hash'] = mdHash;
	            }
	            if (upHash) {
	                this.params.headers = this.params.headers || {};
	                this.params.headers['X-Userpref-Hash'] = upHash;
	            }
	
	            //The state object is used to store global enviroment conditions that may be relevent
	            //when processing this request but would not be passed to the server.
	            this.state = _.extend(this.state, _state);
	
	            if (this.debug) {
	                console.log('====== Ajax Request Begin ======');
	                console.log(this.params.type + ' ' + this.params.url);
	                var parsedData = this.params.data ? JSON.parse(this.params.data) : null;
	                if (parsedData && parsedData.password) parsedData.password = '***';
	                console.log('Payload: ', this.params.data ? parsedData : 'N/A');
	                var p = $.extend({}, this.params);
	                delete p.data;
	                console.log('params: ', p);
	                console.log('====== Request End ======');
	            }
	            //In order to keep track of the number of ajax call in the air, we will add
	            //a complete callback.
	            // Do it only on the first run. No need to set this logic on subsequent execute calls.
	            if (!this.numExecuted) {
	                var origCallback = this.params.complete;
	                this.params.complete = function() {
	                    _numCallsInProgress--;
	                    if (_.isFunction(origCallback))
	                        origCallback.apply(this, arguments);
	                };
	            }
	
	            /**
	             * XmlHttpRequest object.
	             * @property {Object}
	             * @member SUGAR.HttpRequest
	             */
	            this.xhr = $.ajax(this.params);
	
	            _numCallsInProgress++;
	            this.numExecuted++;
	        }
	
	    });
	
	    /**
	     * Fake jqXHR object because bulk calls do not have their own individual XHR requests
	     * @param {object} result object returned from the BulkAPI
	     * @param {string|number} [result.status=200] The response status.
	     * @param {Object} [result.status=200] The response headers.
	     * @param {Object} [result.contents={}] The response contents.
	     * @param {SUGAR.HttpRequest} parentReq bulk API request that this request is a part of.
	     */
	    var bulkXHR = function(result, parentReq) {
	        var contents = result.contents || {};
	
	        this.status = result.status || 200;
	        this.statusText = result.status_text || '';
	        this.responseText = _.isObject(contents) ? JSON.stringify(contents) : contents;
	        this.readyState = 4;
	        this._parent = parentReq.xhr;
	        this.headers = result.headers;
	    };
	
	    _.extend(bulkXHR.prototype, {
	        isResolved: function() {
	            return this._parent.isResolved();
	        },
	        getResponseHeader: function(h) {
	            return this.headers[h];
	        },
	        getAllResponseHeaders: function() {
	            return _.reduce(this.headers, function(str, value, key) {
	                return str.concat(key + ': ' + value + '\n');
	            }, '');
	        }
	    });
	
	    function SugarApi(args) {
	        var _serverUrl,
	            _platform,
	            _keyValueStore,
	            _clientID,
	            _timeout,
	            _refreshingToken,
	            _defaultErrorHandler,
	            _externalLogin,
	            _allowBulk,
	            _externalLoginUICallback = null,
	            _accessToken = null,
	            _refreshToken = null,
	            _downloadToken = null,
	            // request queue
	            // used to support multiple request while in refresh token loop
	            _rqueue = [],
	            // dictionary of currently executed requests (keys are IDs)
	            _requests = {},
	            // request unique ID (counter)
	            _ruid = 0;
	
	        // if no key/value store is provided, the auth token is kept in memory
	        _keyValueStore = args && args.keyValueStore;
	        _serverUrl = (args && args.serverUrl) || '/rest/v10';
	        // there will only be a fallback default error handler if provided here
	        _defaultErrorHandler = (args && args.defaultErrorHandler) || null;
	        _platform = (args && args.platform) || '';
	        _clientID = (args && args.clientID) || 'sugar';
	        _timeout = ((args && args.timeout) || 30) * 1000;
	        _externalLogin = false;
	        _allowBulk = !(args && args.disableBulkApi);
	
	        if (args && args.externalLoginUICallback && _.isFunction(args.externalLoginUICallback)) {
	            _externalLoginUICallback = args.externalLoginUICallback;
	        }
	
	        if (_keyValueStore) {
	            if (!$.isFunction(_keyValueStore.set) ||
	                !$.isFunction(_keyValueStore.get) ||
	                !$.isFunction(_keyValueStore.cut))
	            {
	                throw new Error('Failed to initialize Sugar API: key/value store provider is invalid');
	            }
	
	            var init = function() {
	                _accessToken = _keyValueStore.get('AuthAccessToken');
	                _refreshToken = _keyValueStore.get('AuthRefreshToken');
	                _downloadToken = _keyValueStore.get('DownloadToken');
	            };
	
	            if ($.isFunction(_keyValueStore.initAsync)) {
	                _keyValueStore.initAsync(init);
	            } else {
	                init();
	            }
	
	            if ($.isFunction(_keyValueStore.on)) {
	                _keyValueStore.on('cache:clean', function(callback) {
	                    callback(['AuthAccessToken', 'AuthRefreshToken', 'DownloadToken']);
	                });
	            }
	        }
	
	        _refreshingToken = false;
	
	        if (args && args.reset) _numCallsInProgress = 0;
	
	        var _resetAuth = function(data) {
	            // data is the response from the server
	            if (data) {
	                _accessToken = data.access_token;
	                _refreshToken = data.refresh_token;
	                _downloadToken = data.download_token;
	                if (_keyValueStore) {
	                    _keyValueStore.set('AuthAccessToken', _accessToken);
	                    _keyValueStore.set('AuthRefreshToken', _refreshToken);
	                    _keyValueStore.set('DownloadToken', _downloadToken);
	                }
	            } else {
	                _accessToken = null;
	                _refreshToken = null;
	                _downloadToken = null;
	                if (_keyValueStore) {
	                    _keyValueStore.cut('AuthAccessToken');
	                    _keyValueStore.cut('AuthRefreshToken');
	                    _keyValueStore.cut('DownloadToken');
	                }
	            }
	        };
	
	        var _handleErrorAndRefreshToken = function(self, request, callbacks) {
	            return function(xhr, textStatus, errorThrown) {
	                var error = new HttpError(request, textStatus, errorThrown);
	                var onError = function() {
	                    // Either regular request failed or token refresh failed
	                    // Call original error callback
	                    if (!_rqueue.length || self.refreshingToken(request.params.url)) {
	                        if (callbacks.error) {
	                            callbacks.error(error);
	                        }
	                        else if ($.isFunction(self.defaultErrorHandler)) {
	                            self.defaultErrorHandler(error);
	                        }
	                    } else {
	                        // Token refresh failed
	                        // Call original error callback for all queued requests
	                        for (var i = 0; i < _rqueue.length; ++i) {
	                            if (_rqueue[i]._oerror) _rqueue[i]._oerror(error);
	                        }
	                    }
	                    // duplicated due to other types of authentication
	                    self.setRefreshingToken(false);
	                };
	
	                var r, refreshFailed = true;
	                if (self.needRefreshAuthToken(request.params.url, error.code)) {
	                    //If we were unloading the queue when we got another 401, we should stop before we get into a loop
	                    if (request._dequeuing) {
	                        if (request._oerror) request._oerror(error);
	                        //The tokens we have are bad, nuke them.
	                        self.resetAuth();
	                        return;
	                    }
	                    _rqueue.push(request);
	
	                    self.setRefreshingToken(true);
	
	                    var refreshCallbacks = {
	                        complete: function() {
	
	                            // Call original complete callback for all queued requests
	                            // only if token refresh failed
	                            // In case of requests succeed, complete callback is called by ajax lib
	                            if (refreshFailed) {
	                                r = _rqueue.shift();
	                                while (r) {
	                                    if (r._ocomplete) {
	                                        r._ocomplete.call(this, r);
	                                    }
	                                    r = _rqueue.shift();
	                                }
	                            }
	                        },
	                        success: function() {
	                            self.setRefreshingToken(false);
	                            refreshFailed = false;
	                            _refreshTokenSuccess(function() {
	                                // Repeat original requests
	                                r = _rqueue.shift();
	                                while (r) {
	                                    r._dequeuing = true;
	                                    r.execute(self.getOAuthToken());
	                                    r = _rqueue.shift();
	                                }
	                            });
	                        },
	                        error: onError
	                    };
	
	                    if (!('crosstab' in window) || !crosstab.supported) {
	                        self.login(null, {refresh: true}, {
	                            complete: refreshCallbacks.complete,
	                            success: refreshCallbacks.success,
	                            error: refreshCallbacks.error
	                        });
	                        return;
	                    }
	
	                    crosstab(function() {
	                        crosstab.on('auth:refresh:complete', function(event) {
	                            var status = event.data;
	                            switch (status) {
	                                case 'success':
	                                    refreshCallbacks.success();
	                                    break;
	                                case 'error':
	                                    refreshCallbacks.error();
	                                    break;
	                                case 'complete':
	                                    refreshCallbacks.complete();
	                                    crosstab.off('auth:refresh:complete');
	                                    break;
	                            }
	                        });
	
	                        crosstab.broadcastMaster('auth:refresh');
	                    });
	
	                } else if (self.needQueue(request.params.url)) {
	                    // Queue subsequent request to execute it after token refresh completes
	                    _rqueue.push(request);
	                } else if (_externalLogin && error.status == 401 && error.payload &&
	                    error.payload.url && error.payload.platform == _platform
	                ) {
	                    self.handleExternalLogin(request, error, onError);
	                } else {
	                    onError();
	                }
	            };
	        };
	
	
	        return {
	            /**
	             * Client Id for oAuth
	             * @property {String}
	             * @member SUGAR.Api
	             */
	            clientID: _clientID,
	
	            /**
	             * URL of Sugar REST end-point.
	             * @property {String}
	             * @member SUGAR.Api
	             */
	            serverUrl: _serverUrl,
	
	            /**
	             * Default fallback HTTP error handler. Used when api.call
	             * is not supplied with an error: function in callbacks parameter.
	             * @property {Function}
	             * @member SUGAR.Api
	             */
	            defaultErrorHandler: _defaultErrorHandler,
	
	            /**
	             * Request timeout (in milliseconds).
	             * @property {Number}
	             * @member SUGAR.Api
	             */
	            timeout: _timeout,
	
	            /**
	             * Flag indicating if API should run in debug mode (console debugging of API calls).
	             * @property {Boolean}
	             * @member SUGAR.Api
	             */
	            debug: false,
	
	            /**
	             * Aborts a request by ID
	             * @param {String} id Request ID
	             */
	            abortRequest: function(id) {
	                var request = _requests[id];
	
	                if (request) {
	                    request.aborted = true;
	                    if (request.xhr) {
	                        request.xhr.aborted = true;
	                        request.xhr.abort();
	                    }
	                }
	            },
	
	            /**
	             * Gets request by ID
	             * @param {String} id Request ID
	             */
	            getRequest: function(id) {
	                return _requests[id];
	            },
	
	            /**
	             * Sets the callback to be triggered after a token refresh occurs
	             * @param callback function to be called
	             */
	            setRefreshTokenSuccessCallback: function(callback) {
	                if (_.isFunction(callback))
	                    _refreshTokenSuccess = callback;
	            },
	
	            /**
	             * Makes AJAX call via jquery/zepto AJAX API.
	             *
	             * @param {string} method CRUD action to make (read, create, update,
	             *   delete) are mapped to corresponding HTTP verb: GET, POST, PUT, DELETE.
	             * @param {String} url resource URL.
	             * @param {Object} [data] data will be stringified into JSON and
	             *   set to request body.
	             * @param {Object} [callbacks] callbacks object.
	             * @param {Object} [options] options for request that map
	             *   directly to the jquery/zepto Ajax options.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @private
	             * @member SUGAR.Api
	             */
	            call: function(method, url, data, callbacks, options) {
	                var request,
	                    args,
	                    type = _methodsToRequest[method],
	                    self = this,
	                    token = this.getOAuthToken();
	
	                options = options || {};
	                callbacks = callbacks || {};
	
	                // by default use json headers
	                var params = {
	                    type: type,
	                    dataType: 'json',
	                    headers: {},
	                    timeout: options.timeout || this.timeout,
	                    contentType: 'application/json'
	                };
	
	                // if we dont have a url from options take arg url
	                if (!options.url) {
	                    params.url = url;
	                }
	
	                if (callbacks.success) {
	                    params.success = function(data, status) {
	                        /**
	                         * XHR status code.
	                         * @property {string|number}
	                         * @member SUGAR.HttpRequest
	                         */
	                        request.status = (data && data.status) ? data.status : status;
	                        callbacks.success(data, request);
	                    };
	                }
	
	                params.complete = function() {
	
	                    _requests[request.uid] = null;
	
	                    // Do not call complete callback if we are in token refresh loop
	                    // We'll call complete callback once the refresh completes
	                    if (!_refreshingToken && callbacks.complete) {
	                        callbacks.complete(request);
	                    }
	                };
	
	                //Process the iframe transport request
	                if (options.iframe === true) {
	                    if (token) {
	                        data = data || {};
	                        data['OAuth-Token'] = token;
	                        params.data = data;
	                    }
	                } else {
	                    // set data for create, update, and delete
	                    if (data && (method == 'create' || method == 'update' || method == 'delete')) {
	                        params.data = JSON.stringify(data);
	                    }
	                }
	
	                // Don't process data on a non-GET request.
	                if (params.type !== 'GET') {
	                    params.processData = false;
	                }
	
	                // Clients may override any of AJAX options.
	                request = new HttpRequest(_.extend(params, options), this.debug);
	                params.error = _handleErrorAndRefreshToken(self, request, callbacks);
	                // Keep original error and complete callback for token refresh loop
	                request._oerror = callbacks.error;
	                request._ocomplete = callbacks.complete;
	
	                //add request to requests hash
	                request.uid = _ruid++;
	                _requests[request.uid] = request;
	
	                args = [
	                    token,
	                    options.skipMetadataHash ? null : this.getMetadataHash(),
	                    options.skipMetadataHash ? null : this.getUserprefHash()
	                ];
	                // Login request doesn't need auth token
	                if (this.isLoginRequest(url)) {
	                    request.execute();
	                } else if (this.isAuthRequest(url)) {
	                    request.execute(token);
	                } else if (params.bulk && _allowBulk) {
	                    var bulkQueue = _bulkQueues[params.bulk] || [];
	                    if (!_bulkQueues[params.bulk]) {
	                        _bulkQueues[params.bulk] = bulkQueue;
	                    }
	                    bulkQueue.push({
	                        request: request,
	                        args: args
	                    });
	                } else {
	                    request.execute.apply(request, args);
	                }
	
	                return request;
	            },
	
	            /**
	             * Begins a BulkAPI request. Previous uses of call() should have
	             * options.bulk set to an ID.
	             * Calling triggerBulkCall with the same ID will combine all the
	             * previously queued requests into a single bulk call.
	             * @param {number|string} bulkId
	             * @member SUGAR.Api
	             */
	            triggerBulkCall: function(bulkId) {
	                if (!_allowBulk) {
	                    return;
	                }
	
	                bulkId = bulkId || true;
	                var queue = _bulkQueues[bulkId],
	                    requests = [],
	                    version = _.last(this.serverUrl.split('/'));
	
	                if (!queue) {
	                    //TODO log an error here
	                    return;
	                }
	                _.each(queue, function(r) {
	                    var params = r.request.params,
	                        args = r.args,
	                        token = args[0],
	                        mdHash = args[1],
	                        upHash = args[2];
	
	                    if (token) {
	                        params.headers = params.headers || {};
	                        params.headers['OAuth-Token'] = token;
	                    }
	                    if (mdHash) {
	                        params.headers = params.headers || {};
	                        params.headers['X-Metadata-Hash'] = mdHash;
	                    }
	                    if (upHash) {
	                        params.headers = params.headers || {};
	                        params.headers['X-Userpref-Hash'] = upHash;
	                    }
	                    //Url needs to be trimmed down to the version number.
	                    if (!_.isEmpty(params.url)) {
	                        params.url = version + params.url.substring(this.serverUrl.length);
	                    }
	
	                    requests.push(params);
	                }, this);
	                this.call('create', this.buildURL('bulk'), {requests: requests}, {
	                    success: function(o, parentReq) {
	                        _.each(queue, function(r, i) {
	                            var request = r.request,
	                                result = o[i],
	                                contents = result.contents || {},
	                                xhr = new bulkXHR(result, parentReq);
	                            request.xhr = xhr;
	
	                            if (request.aborted === true || contents.error) {
	                                request.status = 'error';
	                                if (_.isFunction(request.params.error)) {
	                                    request.params.error.call(request.params, request, 'error', xhr.statusText);
	                                }
	                            }
	                            else {
	                                if (_.isFunction(request.params.success)) {
	                                    request.params.success.call(request.params, contents, 'success');
	                                }
	                            }
	                            if (_.isFunction(request.params.complete)) {
	                                request.params.complete.call(request.params, request);
	                            }
	                        });
	                    }
	                });
	                _bulkQueues[bulkId] = null;
	            },
	
	            clearBulkQueue: function() {
	                _bulkQueues = {};
	            },
	
	            /**
	             * Builds URL based on module name action and attributes of the format rooturl/module/id/action.
	             *
	             * The `attributes` hash must contain `id` of the resource being actioned upon
	             * for record CRUD and `relatedId` if the URL is build for relationship CRUD.
	             *
	             * @param  {String} module module name.
	             * @param  {String} action CRUD method.
	             * @param  {Object} [attributes] object of resource being
	             *   actioned upon, e.g. `{name: "bob", id:"123"}`.
	             * @param  {Object} [params] URL parameters.
	             * @return {String} URL for specified resource.
	             * @private
	             * @member SUGAR.Api
	             */
	            buildURL: function(module, action, attributes, params) {
	                params = params || {};
	                var parts = [];
	                var url;
	                parts.push(this.serverUrl);
	
	                if (module) {
	                    parts.push(module);
	                }
	
	                if ((action != 'create') && attributes && attributes.id) {
	                    parts.push(attributes.id);
	                }
	
	                if (attributes && attributes.link && action != 'file') {
	                    parts.push('link');
	                    if (_.isString(attributes.link)) {
	                        parts.push(attributes.link);
	                    }
	                }
	
	                if (action && $.inArray(action, _baseActions) === -1) {
	                    parts.push(action);
	                }
	
	                if (attributes && attributes.relatedId) {
	                    parts.push(attributes.relatedId);
	                }
	
	                if (attributes && action == 'file' && attributes.field) {
	                    parts.push(attributes.field);
	                    if (attributes.fileId)
	                        parts.push(attributes.fileId);
	                }
	
	                url = parts.join('/');
	
	                // URL parameters
	                // remove nullish params
	                _.each(params, function(value, key) {
	                    if (value === null || value === undefined) {
	                        delete params[key];
	                    }
	                });
	
	                params = $.param(params);
	                if (params.length > 0) {
	                    url += '?' + params;
	                }
	
	                return url;
	            },
	
	            /**
	             * Builds a file resource URL.
	             *
	             * The `attributes` hash must contain the following properties:
	             *
	             *     {
	             *         module: module name
	             *         id: record id
	             *         field: Name of the file field in the given module (optional).
	             *     }
	             *
	             * Example 1:
	             *
	             *     var url = app.api.buildFileURL({
	             *        module: 'Contacts',
	             *        id: '123',
	             *        field: 'picture'
	             *     });
	             *
	             *     // Returns:
	             *     'http://localhost:8888/sugarcrm/rest/v10/Contacts/123/file/picture?format=sugar-html-json&platform=base'
	             *
	             * The `field` property is optional. If omitted the method returns a
	             * URL for a list of file resources.
	             *
	             * Example 2:
	             *
	             *     var url = app.api.buildFileURL({
	             *        module: 'Contacts',
	             *        id: '123'
	             *     });
	             *
	             *     // Returns:
	             *     'http://localhost:8888/sugarcrm/rest/v10/Contacts/123/file?platform=base'
	             *
	             * @param {Object} attributes Hash with file information.
	             * @param {Object} [options] URL options hash.
	             * @param {boolean} [options.htmlJsonFormat] Flag indicating if
	             *   `sugar-html-json` format must be used (`true` by default if
	             *   `field` property is specified).
	             * @param {boolean} [options.passDownloadToken] Flag indicating if
	             *   download token must be passed in the URL (`false` by default).
	             * @param {boolean} [options.deleteIfFails] Flag indicating if
	             *   related record should be marked deleted:1 if file operation
	             *   unsuccessful.
	             * @param {boolean} [options.keep] Flag indicating if the temporary
	             *   file should be kept when issuing a `GET` request to the
	             *   `FileTempApi` (it is cleaned up by default).
	             * @return {string} URL for the file resource.
	             * @member SUGAR.Api
	             */
	            buildFileURL: function(attributes, options) {
	                var params = {};
	                options = options || {};
	                // We only concerned about the format if build URL for an actual file resource
	                if (attributes.field && (options.htmlJsonFormat !== false)) {
	                    params.format = 'sugar-html-json';
	                }
	
	                if (options.deleteIfFails === true) {
	                    params.delete_if_fails = true;
	                }
	
	                // This is for BWC only. Don't document it and remove as soon as 6.7 is decommissioned.
	                if (options.passOAuthToken) {
	                    params.oauth_token = this.getOAuthToken();
	                }
	
	                if (options.passDownloadToken) {
	                    params.download_token = this.getDownloadToken();
	                }
	
	                if (!_.isUndefined(options.forceDownload)) {
	                    params.force_download = (options.forceDownload) ? 1 : 0;
	                }
	
	                if (options.cleanCache === true) {
	                    params[(new Date()).getTime()] = 1;
	                }
	
	                if (options.platform !== undefined) {
	                    params.platform = options.platform;
	                } else if (_platform) {
	                    params.platform = _platform;
	                }
	
	                if (options.keep === true) {
	                    params.keep = 1;
	                }
	
	                return this.buildURL(attributes.module, 'file', attributes, params);
	            },
	
	            /**
	             * Returns the current access token
	             */
	            getOAuthToken: function() {
	                return _keyValueStore ? _keyValueStore.get('AuthAccessToken') || _accessToken : _accessToken;
	            },
	
	            /**
	             * Returns the current refresh token
	             */
	            getRefreshToken: function() {
	                return _keyValueStore ? _keyValueStore.get('AuthRefreshToken') || _refreshToken : _refreshToken;
	            },
	
	            /**
	             * Returns the current download token.
	             */
	            getDownloadToken: function() {
	                return _keyValueStore ? _keyValueStore.get('DownloadToken') || _downloadToken : _downloadToken;
	            },
	
	
	            getMetadataHash: function() {
	                return _keyValueStore ? _keyValueStore.get('meta:hash') : null;
	            },
	
	            /**
	             * Gets the user preference hash for use in checking state of change
	             *
	             * @return {String} The user preference hash set from a /me response
	             */
	            getUserprefHash: function() {
	                return _keyValueStore ? _keyValueStore.get('userpref:hash') : null;
	            },
	
	            /**
	             * Fetches metadata.
	             *
	             * @param {Objec} [options] Options to decide what to get from
	             *   the server.
	             * @param {Array} [options.types] Metadata types to fetch.
	             *   E.g.: `['vardefs','detailviewdefs']`
	             * @param {Array} [options.modules] Module names to fetch.
	             *   E.g.: `['accounts','contacts']`
	             * @param {Object} [options.callbacks] callback object.
	             * @param {Object} [options.public=false] Pass `true` to get the
	             *   public metadata.
	             * @param {Object} [options.params] Extra params to send to the
	             *   request.
	             * @return {SUGAR.HttpRequest} The AJAX request.
	             * @member SUGAR.Api
	             */
	            getMetadata: function(options) {
	
	                if (_.isString(options)) {
	                    console.warn('`SUGAR.Api::getMetadata` has changed signature since 7.9 ' +
	                        'and will drop support for old signature in 7.10. Please update your code.');
	
	                    var oldOpt = arguments[4] || {};
	                    options = {
	                        types: arguments[1],
	                        modules: arguments[2],
	                        callbacks: arguments[3],
	                        public: oldOpt.getPublic,
	                        params: oldOpt.params,
	                    };
	                }
	
	                options = options || {};
	                var params = options.params || {};
	
	                if (options.types) {
	                    params.type_filter = options.types.join(',');
	                }
	
	                if (options.modules) {
	                    params.module_filter = options.modules.join(',');
	                }
	
	                if (_platform) {
	                    params.platform = _platform;
	                }
	
	                var method = 'read';
	
	                if (options.public) {
	                    method = 'public';
	                } else {
	                    options.callbacks = options.callbacks || {};
	                    options.callbacks.success = _.wrap(options.callbacks.success, function (success, data, status) {
	                        if (data) {
	                            this._serverInfo = data.server_info;
	                        }
	
	                        if (success) {
	                            success(data, status);
	                        }
	                    });
	                }
	
	                params.module_dependencies = 1;
	
	                var url = this.buildURL('metadata', method, null, params);
	                return this.call(method, url, null, options.callbacks);
	            },
	
	            /**
	             * Executes CRUD on records.
	             *
	             * @param {String} method operation type: create, read, update, or delete.
	             * @param {String} module module name.
	             * @param {Object} data request object. If it contains id, action,
	             *   link, etc., URI will be adjusted accordingly.
	             * If methods parameter is 'create' or 'update', the data object will be put in the request body payload.
	             * @param {Object} [params] URL parameters.
	             * @param {Object} [callbacks] callback object.
	             * @param {Object} [options] request options.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            records: function(method, module, data, params, callbacks, options) {
	                var url = this.buildURL(module, method, data, params);
	                return this.call(method, url, data, callbacks, options);
	            },
	
	            /**
	             * Executes CRUD on relationships.
	             *
	             * The data paramerer represents relationship information:
	             * <pre>
	             * {
	             *    id: record ID
	             *    link: relationship link name
	             *    relatedId: ID of the related record
	             *    related: object that contains request payload (related record or relationship fields)
	             * }
	             * </pre>
	             *
	             * @param {String} method operation type: create, read, update, or delete.
	             * @param {String} module module name.
	             * @param {Object} data object with relationship information.
	             * @param {Object} [params] URL parameters.
	             * @param {Object} [callbacks] callback object.
	             * @param {Object} [options] request options.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            relationships: function(method, module, data, params, callbacks, options) {
	                var url = this.buildURL(module, null, data, params);
	                return this.call(method, url, data.related, callbacks, options);
	            },
	
	            /**
	             * Marks/unmarks a record as favorite.
	             * @param {string} module Module name.
	             * @param {string} id Record ID.
	             * @param {boolean} favorite Flag indicating if the record must be marked as favorite.
	             * @param {Object} [callbacks] Callback object.
	             * @param {Object} [options] request options.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            favorite: function(module, id, favorite, callbacks, options) {
	                var action = favorite ? 'favorite' : 'unfavorite';
	                var url = this.buildURL(module, action, { id: id });
	                return this.call('update', url, null, callbacks, options);
	            },
	
	            /**
	             * Subscribe/unsubscribe a record changes.
	             * @param {string} module Module name.
	             * @param {string} id Record ID.
	             * @param {boolean} followed Flag indicates if wants to subscribe
	             *   the record changes.
	             * @param {Object} [callbacks] Callback object.
	             * @param {Object} [options] request options.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            follow: function(module, id, followed, callbacks, options) {
	                callbacks = callbacks || {};
	                options = options || {};
	                var method = followed ? 'create' : 'delete',
	                    action = followed ? 'subscribe' : 'unsubscribe',
	                    url = this.buildURL(module, action, { id: id });
	                return this.call(method, url, null, callbacks, options);
	            },
	
	            /**
	             * Loads an enum field's options using the enum API
	             * @param {string} module Module name.
	             * @param {string} field Name of enum field.
	             * @param {Object} [callbacks] Callback object
	             * @param {Object} [options] Options object
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            enumOptions: function(module, field, callbacks, options) {
	                var url = this.buildURL(module + '/enum/' + field);
	                return this.call('read', url, null, callbacks, options);
	            },
	
	            /**
	             * Calls API requests in bulk.
	             *
	             * @param {Object} data Object with requests array.
	             * @param {Object} callbacks.
	             * @param {Object} [options] Options object.
	             * @return {SUGAR.HttpRequest}
	             */
	            bulk: function(data, callbacks, options) {
	                var url = this.buildURL('bulk');
	                return this.call('create', url, data, callbacks, options);
	            },
	
	            /**
	             * Given a url, attempt to download a file
	             * @param {string} url url to call
	             * @param {Object} [callbacks] Callback object
	             * @param {Object} [options] Options object
	             *  - iframe: jquery element upon which to attach the iframe for download
	             *    if not specified we must fall back to window.location.href
	             */
	            fileDownload: function(url, callbacks, options) {
	                options = options || {};
	                var internalCallbacks = {};
	
	                internalCallbacks.success = function(data) {
	                    // start the download with the "iframe" hack
	                    if (options.iframe) {
	                        options.iframe.prepend('<iframe class="hide" src="' + url + '"></iframe>');
	                    } else {
	                        window.location.href = url;
	                    }
	                    if (_.isFunction(callbacks.success)) {
	                        callbacks.success.apply(arguments);
	                    }
	                };
	
	                if (_.isFunction(callbacks.error)) {
	                    internalCallbacks.error = callbacks.error;
	                }
	
	                if (_.isFunction(callbacks.complete)) {
	                    internalCallbacks.complete = callbacks.complete;
	                }
	
	                // ping to make sure we have our token, then make an iframe and download away
	                return this.call('read', this.buildURL('ping'), {}, internalCallbacks, {processData: false});
	            },
	
	            /**
	             * Executes CRUD on a file resource.
	             *
	             * @param {string} method operation type: create, read, update, or delete.
	             * @param {Object} data object with file information.
	             * <pre>
	             * {
	             *   module: module name
	             *   id: model id
	             *   field: Name of the file-type field.
	             * }
	             * </pre>
	             * The `field` property is optional. If not specified, the API fetches the file list.
	             * @param {Object} [$files] jQuery/Zepto DOM elements that carry the files to upload.
	             * @param {Object} [callbacks] callback object.
	             * @param {Object} [options] Request options hash.
	             *
	             * - htmlJsonFormat: Boolean flag indicating if `sugar-html-json` format must be used (`true` by default)
	             * - iframe: Boolean flag indicating if iframe transport is used (`true` by default)
	             * See {@link SUGAR.Api#buildFileURL} function for other options.
	             *
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            file: function(method, data, $files, callbacks, options) {
	                var ajaxParams = {
	                    files: $files,
	                    processData: false
	                };
	
	                //delete method doesn't need to go through the iframe transport
	                if (method === 'delete') {
	                    ajaxParams.iframe = false;
	                } else if (!options || options.iframe !== false) {
	                    ajaxParams.iframe = true;
	
	                    // pass OAuth token as GET-parameter during file upload.
	                    // otherwise, in case if file is too large, the whole request body may be
	                    // ignored by interpreter together with the token
	                    options = options || {};
	                    options.passOAuthToken = true;
	                }
	
	                if (!options || options.deleteIfFails !== false) {
	                    options = options || {};
	                    options.deleteIfFails = true;
	                }
	
	                callbacks.success = _.wrap(callbacks.success, function(success, data) {
	                    if (data.error && _.isFunction(callbacks.error)) {
	                        callbacks.error(data);
	                    } else if (_.isFunction(success)) {
	                        success(data);
	                    }
	                });
	
	                return this.call(method, this.buildFileURL(data, options),
	                    null, callbacks, ajaxParams);
	            },
	
	            /**
	             * Fetches the total amount of records for a given module.
	             *
	             * Example 1:
	             *
	             *     app.api.count('Contacts', null, {
	             *         success: function(data) {
	             *             console.log('Total number of Contacts:' +
	             *                 data.record_count);
	             *         }
	             *     });
	             *
	             * Example 2:
	             *
	             *     app.api.count('Accounts', null,
	             *         {
	             *             success: function(data) {
	             *                 console.log('Total number of "B" Accounts:' +
	             *                     data.record_count);
	             *             }
	             *         },
	             *         {
	             *             filter: [{'name': {'$starts': 'B'}}]
	             *         }
	             *     );
	             *
	             * Example 3:
	             *
	             *     app.api.count('Accounts',
	             *         {
	             *             id: 'abcd',
	             *             link: 'cases'
	             *         },
	             *         {
	             *             success: function(data) {
	             *                 console.log('Total number of "B" cases related' +
	             *                     'to "abcd" account:' + data.record_count);
	             *             }
	             *         },
	             *         {
	             *             filter: [{'name': {'$starts': 'B'}}]
	             *         }
	             *     );
	             *
	             * @param {string} module Module to fetch the count for.
	             * @param {Object} [data] Data object containing relationship
	             *   information.
	             * @param {string} [data.link] The link module name.
	             * @param {string} [data.id] The id of the model.
	             * @param {function} [callbacks] Callback functions.
	             * @param {Object} [options] URL options hash.
	             * @param {Object} [options.filter] If supplied, the count of
	             *   filtered records will be returned, instead of the total number
	             *   of records.
	             * @return {SUGAR.HttpRequest} Result of {@link SUGAR.Api#call}.
	             * @member SUGAR.Api
	             */
	            count: function(module, data, callbacks, options) {
	                options = options || {};
	                var url = this.buildURL(module, 'count', data, options);
	
	                return this.call('read', url, null, callbacks);
	            },
	
	            /**
	             * Triggers a file download of the exported records.
	             *
	             * @param {Object} params Download parameters.
	             * @param {string} params.module Module name.
	             * @param {Array} params.uid Array of record ids to request export.
	             * @param {jQuery} $el JQuery selector to element.
	             * @param {Object} [callbacks] Various callbacks.
	             * @param {Function} [callbacks.success] Called on success.
	             * @param {Function} [callbacks.error] Called on failure.
	             * @param {Function} [callbacks.complete] Called when finished.
	             * @param {Object} [options] Request options hash.
	             *
	             * - passOAuthToken: Boolean flag indicating if OAuth token must be passed in the URL (`true` by default)
	             *
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            exportRecords: function(params, $el, callbacks, options) {
	                var self = this;
	                var recordListUrl = this.buildURL(params.module, 'record_list');
	
	                options = options || {};
	
	                return this.call(
	                    'create',
	                    recordListUrl,
	                    {'records': params.uid},
	                    {
	                        success: function(response) {
	                            params = _.omit(params, ['uid', 'module']);
	                            if (options.platform !== undefined) {
	                                params.platform = options.platform;
	                            } else if (_platform) {
	                                params.platform = _platform;
	                            }
	
	                            self.fileDownload(
	                                self.buildURL(response.module_name, 'export', {relatedId: response.id}, params),
	                                callbacks,
	                                { iframe: $el }
	                            );
	                        }
	                    }
	                );
	            },
	
	            /**
	             * Searches for specified query.
	             * @param {Object} params Properties.
	             * @param {string} params.q Query.
	             * @param {string} [params.module_list] Comma-separated module list.
	             * @param {string} [params.fields] Comma-separated list of fields.
	             * @param {number} [params.max_num] Max number of records to return.
	             * @param {number} [params.offset] Initial offset into the results.
	             * @param {Object} callbacks Hash with success and error callbacks.
	             * @param {Function} callbacks.success Function called on success.
	             *   Takes one argument.
	             * @param {Function} callbacks.error Function called on failure.
	             *   Takes one argument.
	             * @param {Object} [options] Request options.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            search: function(params, callbacks, options) {
	                options = options || {};
	                //FIXME: This is a temporary change. SC-4253 will set it back to
	                //'search' once BR-2367 will be merged.
	                var data = null;
	                if (options.data) {
	                    data = options.data;
	                    delete options.data;
	                }
	                var method = 'read';
	                if (options.fetchWithPost) {
	                    method = 'create';
	                }
	                var endpoint = options.useNewApi ? 'globalsearch' : 'search';
	                var url = this.buildURL(null, endpoint, null, params);
	
	                return this.call(method, url, data, callbacks, options);
	            },
	
	            /**
	             * Performs login.
	             *
	             * Credentials:
	             * <pre>
	             *     username: user's login name or email,
	             *     password: user's password in clear text
	             * </pre>
	             *
	             * @param {Object} credentials user credentials.
	             * @param {Object} [data] extra data to be passed in login request
	             *   such as client user agent, etc.
	             * @param {Object} [callbacks] callback object.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            login: function(credentials, data, callbacks) {
	                var payload, success, error, method, url, self = this;
	
	                credentials = credentials || {};
	                callbacks = callbacks || {};
	
	                success = function(data) {
	                    _resetAuth(data);
	                    if (_externalLogin) {
	                        self.setRefreshingToken(false);
	                        _refreshTokenSuccess(
	                            function() {
	                                // Repeat original requests
	                                var r = _rqueue.shift();
	                                while (r) {
	                                    r._dequeuing = true;
	                                    r.execute(self.getOAuthToken());
	                                    r = _rqueue.shift();
	                                }
	                            }
	                        );
	                    }
	                    if (callbacks.success) callbacks.success(data);
	                };
	
	                error = function(error) {
	                    _resetAuth();
	                    if (callbacks.error) callbacks.error(error);
	                };
	
	                if (data && data.refresh) {
	                    payload = _.extend({
	                        grant_type: 'refresh_token',
	                        client_id: this.clientID,
	                        client_secret: '',
	                        refresh_token: this.getRefreshToken(),
	                        platform: _platform ? _platform : 'base'
	                    }, data);
	                } else {
	                    payload = _.extend({
	                        grant_type: 'password',
	                        username: credentials.username,
	                        password: credentials.password,
	                        client_id: this.clientID,
	                        platform: _platform ? _platform : 'base',
	                        client_secret: ''
	                    }, data);
	                    payload.client_info = data;
	                }
	
	                method = 'create';
	                url = this.buildURL('oauth2', 'token', payload, {
	                    platform: _platform
	                });
	                return this.call(method, url, payload, {
	                    success: success,
	                    error: error,
	                    complete: callbacks.complete
	                });
	            },
	
	            /**
	             * Executes CRUD on user profile.
	             *
	             * @param {String} method operation type: read or update (reserved for the future use).
	             * @param {Object} [data] user profile object.
	             * @param {Object} [params] URL parameters.
	             * @param {Object} [callbacks] callback object.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            me: function(method, data, params, callbacks) {
	                var url = this.buildURL('me', method, data, params);
	                return this.call(method, url, data, callbacks);
	            },
	
	            /**
	             * Makes a call to the CSS Api
	             *
	             * @param {String} platform
	             * @param {Object} themeName
	             * @param {Object} [callbacks] callback object.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             */
	            css: function(platform, themeName, callbacks) {
	                var params = {
	                    platform: platform,
	                    themeName: themeName
	                };
	                var url = this.buildURL('css', 'read', {}, params);
	                return this.call('read', url, {}, callbacks);
	            },
	
	            /**
	             * Performs logout.
	             *
	             * @param {Object} [callbacks] callback object.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            logout: function (callbacks, options) {
	
	                callbacks = callbacks || {};
	
	                var payload = {
	                    token: this.getOAuthToken(),
	                    refresh_token: this.getRefreshToken(),
	                };
	
	                // Stock sidecar sends refresh token on logout
	                // 6.7.x doesn't support it. See [NOMAD-2891]/[SI 72054]
	                // TODO remove this once we drop support on 6.x on Nomad
	                if (this._serverInfo && this._serverInfo.version.charAt(0) === '6') {
	                    delete payload.refresh_token;
	                }
	
	                var url = this.buildURL('oauth2', 'logout', payload);
	
	                var originalComplete = callbacks.complete;
	                callbacks.complete = function () {
	                    _resetAuth();
	                    if (originalComplete) originalComplete();
	                };
	
	                return this.call('create', url, payload, callbacks, options);
	            },
	
	            /**
	             * Pings the server.
	             *
	             * The request doesn't send metadata hash by default.
	             * Pass `false` for "skipMetadataHash" option to override this behavior.
	             * @param {string} [action] Optional ping operation.
	             *   Currently, Sugar REST API supports "whattimeisit" only.
	             * @param {Object} [callbacks] callback object.
	             * @param {Object} [options] request options.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            ping: function(action, callbacks, options) {
	                return this.call(
	                    'read',
	                    this.buildURL('ping', action, null, {
	                        platform: _platform
	                    }),
	                    null,
	                    callbacks,
	                    _.extend({
	                        skipMetadataHash: true
	                    }, options || {})
	                );
	            },
	
	            /**
	             * Performs signup.
	             *
	             * TODO: The signup action needs another endpoint to allow a guest to signup
	             *
	             * @param  {Object} contactData user profile.
	             * @param  {Object} [data] extra data to be passed in login request
	             *   such as client user agent, etc.
	             * @param  {Object} [callbacks] callback object.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            signup: function(contactData, data, callbacks) {
	                var payload = contactData;
	                payload.client_info = data;
	
	                var method = 'create';
	                var url = this.buildURL('Leads', 'register', payload);
	                return this.call(method, url, payload, callbacks);
	            },
	
	
	            /**
	             * Verify password
	             *
	             * @param  {Object} password the password to verify
	             * @param  {Object} [callbacks] callback object.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            verifyPassword: function(password, callbacks) {
	                var payload = {
	                    password_to_verify: password
	                };
	                var method = 'create'; //POST so we don't require query params
	                var url = this.buildURL('me/password', method);
	                return this.call(method, url, payload, callbacks);
	            },
	
	            /**
	             * Update password
	             *
	             * @param  {Object} password the new password
	             * @param  {Object} password the new password
	             * @param  {Object} [callbacks] callback object.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            updatePassword: function(oldPassword, newPasword, callbacks) {
	                var payload = {
	                    new_password: newPasword,
	                    old_password: oldPassword
	                };
	                var method = 'update';
	                var url = this.buildURL('me/password', method);
	                return this.call(method, url, payload, callbacks);
	            },
	
	            /**
	             * Fetches server information.
	             * @param {Object} [callbacks] callback object.
	             * @return {SUGAR.HttpRequest} AJAX request.
	             * @member SUGAR.Api
	             */
	            info: function(callbacks) {
	                var url = this.buildURL('ServerInfo');
	                return this.call('read', url, null, callbacks);
	            },
	
	            /**
	             * Checks if API instance is currently authenticated.
	             *
	             * @return {boolean} `true` if authenticated, `false` otherwise.
	             * @member SUGAR.Api
	             */
	            isAuthenticated: function() {
	                return typeof(this.getOAuthToken()) === 'string' && this.getOAuthToken().length > 0;
	            },
	
	            /**
	             * Clears authentication tokens.
	             */
	            resetAuth: function() {
	                _resetAuth();
	            },
	
	            /**
	             * Checks if authentication token can and needs to be refreshed.
	             * @param {string} url URL of the failed request.
	             * @param {string} errorCode Failure code.
	             * @return {boolean} `true` if the OAuth2 access token can be refreshed, `false` otherwise.
	             * @member SUGAR.Api
	             * @private
	             */
	            needRefreshAuthToken: function(url, errorCode) {
	                return (!_refreshingToken) &&
	                    (typeof(this.getRefreshToken()) === 'string' && this.getRefreshToken().length > 0) &&
	                    (!this.isAuthRequest(url)) &&    // must not be auth request
	                    (errorCode === 'invalid_grant');    // means access token got expired or invalid
	            },
	
	            /**
	             * Checks if we need to queue a request while token refresh is in progress
	             * @param {string} url
	             * @return {boolean} `true` if we need to queue the request
	             * @private
	             */
	            needQueue: function(url) {
	                return _refreshingToken && !this.isAuthRequest(url);    // must not be auth request
	            },
	
	            /**
	             * Checks if the request is authentication request.
	             *
	             * It could be either login (including token refresh) our logout request.
	             * @param {string} url
	             * @return `true` if this is an authentication request
	             */
	            isAuthRequest: function(url) {
	                return new RegExp('\/oauth2\/').test(url);
	            },
	
	            /**
	             * Checks if request is a login request.
	             * @param {string} url
	             * @return `true` if this is a login request, `false` otherwise
	             */
	            isLoginRequest: function(url) {
	                return new RegExp('\/oauth2\/token').test(url);
	            },
	
	            /**
	             * Checks if the request is the refresh token request
	             * @param {string} url url of the request to check
	             * @return `true` if the request is the refresh token request,
	             *   `false` otherwise
	             * @private
	             */
	            refreshingToken: function(url) {
	                return _refreshingToken && this.isAuthRequest(url);    // must be auth request
	            },
	
	            /**
	             * Sets a flag indicating that this API instance is in the process
	             * of authentication token refresh.
	             *
	             * @param {boolean} flag Flag indicating if token refresh is in
	             * progress (`true`).
	             * @member SUGAR.Api
	             * @private
	             */
	            setRefreshingToken: function(flag) {
	                _refreshingToken = flag;
	            },
	
	            /**
	             * Handles login with an external provider.
	             *
	             * @param {SUGAR.HttpRequest} request The request to trigger.
	             * @param {Object} error The error object with at least the
	             *   `payload` property.
	             * @param {Function} onError The function to call in case of Error
	             *   during the login request.
	             */
	            handleExternalLogin: function(request, error, onError) {
	                var self = this;
	
	                if (!self.isLoginRequest(request.params.url)) {
	                    _rqueue.push(request);
	                }
	                // don't try to reauth again from here
	                self.setRefreshingToken(true);
	
	                $(window).on('message', function(event) {
	                    if (!event.originalEvent.origin || event.originalEvent.origin !== window.location.origin) {
	                        // this is not our message, ignore it
	                        return;
	                    }
	                    $(window).on('message', null);
	                    authData = $.parseJSON(event.originalEvent.data);
	                    if (!authData || !authData.access_token) {
	                        onError();
	                    }
	                    self.setRefreshingToken(false);
	                    _resetAuth(authData);
	                    _refreshTokenSuccess(
	                        function() {
	                            // Repeat original requests
	                            var r = _rqueue.shift();
	                            while (r) {
	                                r.execute(self.getOAuthToken());
	                                r = _rqueue.shift();
	                            }
	                        }
	                    );
	                });
	                if (_.isFunction(_externalLoginUICallback)) {
	                    _externalLoginUICallback(error.payload.url, '_blank',
	                        'width=600,height=400,centerscreen=1,resizable=1');
	                }
	            },
	
	            /**
	             * Returns `true` when using an external login provider.
	             *
	             * @return {boolean} `true` when we are using an external
	             *   login provider, `false` otherwise.
	             */
	            isExternalLogin: function() {
	                return _externalLogin;
	            },
	
	            /**
	             * Sets a flag indicating that external login prodecure is used.
	             * This means that 401 errors would contain external URL that we should use for authentication.
	             * @param {Boolean} flag Flag indicating if external login is in effect
	             * @member SUGAR.Api
	             */
	            setExternalLogin: function(flag) {
	                _externalLogin = flag;
	            },
	
	            /**
	             * Sets a function as external login UI callback
	             * @param {Function} callback
	             * @member SUGAR.Api
	             */
	            setExternalLoginUICallback: function(callback) {
	                if (_.isFunction(callback)) {
	                    _externalLoginUICallback = callback;
	                }
	            },
	
	            /**
	             * Retrieve a property from the current state.
	             *
	             * @param {String} key
	             * @return {Mixed}
	             */
	            getStateProperty: function(key) {
	                return _state[key];
	            },
	
	            /**
	             * Set a property of the current state. The current state will be attached to all
	             * api request objects when they are sent. Modifications to the state after the request is sent
	             * but before the request completes will not affect that requests state.
	             *
	             * States should be used to track conditions or parameters that should be applied to all requests made
	             * regardless of their source.
	             *
	             * @param {String} key
	             * @param {Mixed} value
	             */
	            setStateProperty: function(key, value) {
	                _state[key] = value;
	            },
	
	            /**
	             * Removes the given key from the current state
	             * @param {string} key
	             */
	            clearStateProperty: function(key) {
	                delete _state[key];
	            },
	
	            /**
	             * Clears the current API request state object.
	             */
	            resetState: function() {
	                _state = {};
	            }
	        };
	    }
	
	    return {
	        /**
	         * Gets an instance of Sugar API class.
	         * @param args
	         * @return {SUGAR.Api} an instance of Sugar API class.
	         * @member SUGAR.Api
	         * @static
	         */
	        getInstance: function(args) {
	            return _instance || this.createInstance(args);
	        },
	
	        /**
	         * Creates a new instance of Sugar API class.
	         * @param args
	         * @return {SUGAR.Api} a new instance of Sugar API class.
	         * @member SUGAR.Api
	         * @static
	         */
	        createInstance: function(args) {
	            _instance = new SugarApi(args);
	
	            if (!('crosstab' in window) || !crosstab.supported) {
	                return _instance;
	            }
	
	            // this event should only be triggered on master tab and if
	            // crosstab library is loaded
	            crosstab(function() {
	                crosstab.on('auth:refresh', _.bind(function() {
	
	                    // prevents concurrent events from multiple tabs asking for a
	                    // refresh token
	                    if (this._runningRefreshToken) {
	                        return;
	                    }
	                    this._runningRefreshToken = true;
	
	                    var self = this;
	
	                    this.login(null, { refresh: true }, {
	                        complete: function() {
	                            crosstab.broadcast('auth:refresh:complete', 'complete');
	                        },
	                        success: function() {
	                            delete self._runningRefreshToken;
	                            crosstab.broadcast('auth:refresh:complete', 'success');
	                        },
	                        error: function() {
	                            delete self._runningRefreshToken;
	                            crosstab.broadcast('auth:refresh:complete', 'error');
	                        }
	                    });
	                }, _instance));
	            });
	
	            return _instance;
	        },
	
	        /**
	         * Return the number of API calls currently in progress
	         * @return {number} Number of calls in progress
	         * @member SUGAR.Api
	         * @static
	         */
	        getCallsInProgressCount: function() {
	            return _numCallsInProgress;
	        },
	
	        HttpError: HttpError,
	        HttpRequest: HttpRequest
	    };
	
	})();
	


/***/ },
/* 32 */
/***/ function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	    var _doWhenStack = [],
	        _doWhenLocked = false,
	        _doWhenInterval = false,
	        _doWhenretryCount = 0,
	        _startDoWhenInterval = function _startDoWhenInterval() {
	        if (!_doWhenInterval) {
	            _doWhenInterval = window.setInterval(app.utils._doWhenCheck, 50);
	        }
	    };
	
	    /**
	     * Utils module provides several utility methods used throughout the app such as number formatting.
	     *
	     * @class Utils.Utils
	     * @alias SUGAR.App.utils
	     * @singleton
	     */
	    app.augment('utils', {
	
	        /**
	         * Capitalizes a string.
	         * @param {String} s The string to capitalize.
	         * @return {String} Capitalized string or an empty string if `s` is undefined or null.
	         */
	        capitalize: function capitalize(s) {
	            return s ? s.charAt(0).toUpperCase() + (s.length > 1 ? s.substr(1) : "") : "";
	        },
	
	        /**
	         * Capitalizes a hyphenated string.
	         *
	         * `"my-string"` becomes `"MyString"`.
	         * @param {String} s The string to capitalize.
	         * @return {String} Capitalized string or an empty string if `s` is undefined or null.
	         */
	        capitalizeHyphenated: function capitalizeHyphenated(s) {
	            return this._classify(s, '-');
	        },
	
	        /**
	         * Capitalizes an underscored string.
	         *
	         * `"my_string"` becomes `"MyString"`.
	         * @param {String} s The string to capitalize.
	         * @return {String} Capitalized string or an empty string if `s` is undefined or null.
	         */
	        classify: function classify(s) {
	            return this._classify(s, '_');
	        },
	
	        /**
	         * Capitalizes a delimited string.
	         *
	         * `"my_string"` becomes `"MyString"`.
	         * @param {String} s The string to capitalize.
	         * @param {String} delimiter(optional) Delimiter string. Defaults to `'_'`.
	         * @return {String} Capitalized string or an empty string if `s` is undefined or null.
	         */
	        _classify: function _classify(s, delimiter) {
	            var self = this,
	                result = '';
	            delimiter = delimiter || '_';
	
	            if (!s || s.lastIndexOf(delimiter) === -1) {
	                result = self.capitalize(s);
	            } else {
	                var words = s.split(delimiter);
	                _.each(words, function (word) {
	                    result += self.capitalize(word);
	                });
	            }
	            return result;
	        },
	
	        /**
	         * Extends a Class based on the given controller.
	         *
	         * If the controller has an `extendsFrom` property, it will be used to
	         * define its parent class. It should be defined as a string in order
	         * for the system to detect if there is any customization on that
	         * parent (normally prefixed with `Custom` like `Custom<ClassName>`).
	         *
	         * If the parent class defined in the `extendsFrom` property doesn't
	         * exist or the controller isn't specifying one, it will fallback to
	         * the supplied `defaultBase` param which has it's own set of fallback
	         * strategy defined by the components that call this method. See
	         * {@link View.ViewManager} and {@link Data.DataManager}.
	         *
	         * @param {Object} cache Object cache to add controller to.
	         * @param {Object} defaultBase Class to be extended from if no override
	         *   (`extendsFrom`) is defined in the controller.
	         * @param {string} className Class name to be used for new Class.
	         * @param {Object|undefined} controller Properties for new Class.
	         * @param {string} platformNamespace Platform name.
	         * @return {Object} the new extended class.
	         */
	        extendClass: function extendClass(cache, defaultBase, className, controller, platformNamespace) {
	            var klass;
	
	            if (!_.isObject(controller)) {
	                // nothing to extend from, use default
	                klass = cache[className] = defaultBase;
	                return klass;
	            }
	
	            if (_.isObject(controller.extendsFrom)) {
	                //should be avoided due to chain breakage - aka custom fallback
	                klass = cache[className] = controller.extendsFrom.extend(controller);
	                return klass;
	            }
	
	            if (!controller.extendsFrom) {
	                // follow the default fallback flow
	                klass = cache[className] = defaultBase.extend(controller);
	                return klass;
	            }
	
	            // try to find the base using the name and following the fallback flow
	            var base = cache[platformNamespace + 'Custom' + controller.extendsFrom] || cache[platformNamespace + controller.extendsFrom] || cache['Custom' + controller.extendsFrom] || cache[controller.extendsFrom];
	
	            if (!base) {
	                app.logger.warn('The "' + controller.extendsFrom + '" component was not found to be used as ' + 'the "' + className + '"\'s parent. Please update your code to point to an existing class.');
	                base = defaultBase;
	            }
	
	            klass = cache[className] = base.extend(controller);
	            return klass;
	        },
	
	        /**
	         * Formats Numbers
	         *
	         * @param {Number} value number to be formatted eg 2.134
	         * @param {Number} round number of digits to right of decimal to round at
	         * @param {Number} precision number of digits to right of decimal to take precision at
	         * @param {String} numberGroupSeparator character separator for number groups of 3 digits to the left of the decimal to add
	         * @param {String} decimalSeparator character to replace decimal in arg number with
	         * @return {String} formatted number string OR original value if it is not a number
	         */
	        formatNumber: function formatNumber(value, round, precision, numberGroupSeparator, decimalSeparator) {
	            round = round || precision;
	            var original = value;
	            if (_.isNaN(value) || !_.isFinite(value)) {
	                return original;
	            }
	            if (_.isString(value)) {
	                value = parseFloat(value, 10);
	                if (_.isNaN(value)) {
	                    return original;
	                }
	            }
	            // Return original value if it is not a number
	            if (!_.isNumber(value)) {
	                if (!_.isNull(value) && !_.isUndefined(value)) {
	                    // invalid variable type
	                    app.logger.warn('formatNumber: invalid variable type (' + (typeof original === "undefined" ? "undefined" : _typeof(original)) + ')');
	                }
	                return original;
	            }
	
	            // make sure that the precision variable is an integer and not a string
	            // Big.js doesn't like it as a string
	            if (_.isString(precision)) {
	                precision = parseInt(precision);
	            }
	
	            value = Big(value).toFixed(precision);
	            return _.isString(numberGroupSeparator) && _.isString(decimalSeparator) ? this.addNumberSeparators(value, numberGroupSeparator, decimalSeparator) : value;
	        },
	
	        /**
	         * Format number to current user locale
	         * @param {Number}  value
	         * @return {String} formatted number
	         */
	        formatNumberLocale: function formatNumberLocale(value) {
	            // use user locale, or decent defaults otherwise
	            return this.formatNumber(value, app.user.getPreference('decimal_precision') || 2, app.user.getPreference('decimal_precision') || 2, app.user.getPreference('number_grouping_separator') || ',', app.user.getPreference('decimal_separator') || '.');
	        },
	
	        /**
	         * Format full name with the provided locale format.
	         * @param {Object} params Name property values.
	         *        - first_name: first name.
	         *        - last_name: last name.
	         *        - salutation: salutation.
	         * @param {String} format Locale format (i.e. [f l s], [s l, f]).
	         * @return {String} formatted string.
	         */
	        formatName: function formatName(params, format) {
	            return format.replace(/(f)|(l)|(s)/g, function (str, firstName, lastName, salutation) {
	                if (firstName) {
	                    return params.first_name || '';
	                }
	                if (lastName) {
	                    return params.last_name || '';
	                }
	                if (salutation && (params.last_name || params.first_name)) {
	                    return params.salutation || '';
	                }
	                return '';
	            })
	            //Remove comma when last name is empty
	            .replace(/^( )?,/g, '')
	            //Remove comma when last name is provided but first name is empty
	            .replace(/, $/g, '')
	            //Remove extra spaces when middle part is missing
	            .replace(/  /g, ' ')
	            //trim spaces
	            .trim();
	        },
	
	        /**
	         * Format a record's name (ie. full name) according to the name format
	         * passed in parameters or defined in the user preferences.
	         *
	         *     @example Format you can pass:
	         *     'f l s' will output: `FirstName LastName Salutation`,
	         *     's l, f' will output: `Salutation LastName FirstName`.
	         *
	         * The module defines a `nameFormat` object that maps a letter to a
	         * field.
	         *
	         *     @example Name format mapping:
	         *     {
	         *         s: 'salutation',
	         *         f: 'first_name',
	         *         l: 'last_name'
	         *     }
	         *
	         * There is a special case for enum type fields (e.g. `salutation`):
	         * we need to pull the label from the app list strings.
	         *
	         * @param {String} module The module name the record belongs to.
	         * @param {Object} data The record attributes.
	         * @param {String} [format] The format definition.
	         * @return {String} The formatted full name string.
	         */
	        formatNameModel: function formatNameModel(module, data, format) {
	            format = format || app.user.getPreference('default_locale_name_format');
	            data = data || {};
	
	            var metadata = app.metadata.getModule(module) || { fields: {} };
	            var formatMap = metadata.nameFormat || {};
	
	            return _.reduce(format.split(''), function (formattedString, letter) {
	                // only letters a-z may be significant in the format,
	                // everything else is translated verbatim
	                if (letter < 'a' || letter > 'z') {
	                    return formattedString + letter;
	                }
	                if (!formatMap[letter]) {
	                    return formattedString;
	                }
	
	                var enumLabel,
	                    isEnum = metadata.fields[formatMap[letter]] && metadata.fields[formatMap[letter]].type === 'enum' && !_.isEmpty(metadata.fields[formatMap[letter]].options);
	
	                if (isEnum) {
	                    var list = app.lang.getAppListStrings(metadata.fields[formatMap[letter]].options);
	                    enumLabel = list[data[formatMap[letter]]] || data[formatMap[letter]] || '';
	                }
	
	                return formattedString + (enumLabel || data[formatMap[letter]] || '');
	            }, '')
	            //Remove leading comma - i.e. ", John"
	            .replace(/^( )?,/g, '')
	            //Remove trailing comma - i.e., "John, ", "John,  ", etc.
	            .replace(/, +$/g, '')
	            //Remove extra spaces when middle part is missing
	            .replace(/  /g, ' ')
	            //trim spaces
	            .trim();
	        },
	
	        /**
	         * Format full name following user locale format.
	         * @param {Object} params Name property values.
	         *        - first_name: first name.
	         *        - last_name: last name.
	         *        - salutation: salutation.
	         * @return {String} {String} formatted string.
	         */
	        formatNameLocale: function formatNameLocale(params) {
	            return this.formatName(params, app.user.getPreference('default_locale_name_format'));
	        },
	
	        /**
	         * Adds number separators to a number string
	         * @param {String} numberString string of number to be modified of the
	         *   format nn.nnn
	         * @param {String} numberGroupSeparator character separator for number
	         *   groups of 3 digits to the left of the decimal to add
	         * @param {String} decimalSeparator character to replace decimal in arg
	         *   number with
	         * @return {String}
	         */
	        addNumberSeparators: function addNumberSeparators(numberString, numberGroupSeparator, decimalSeparator) {
	            var numberArray = numberString.split(".");
	            var regex = /(\d+)(\d{3})/;
	            while (numberGroupSeparator !== '' && regex.test(numberArray[0])) {
	                numberArray[0] = numberArray[0].toString().replace(regex, '$1' + numberGroupSeparator + '$2');
	            }
	            return numberArray[0] + (numberArray.length > 1 && numberArray[1] !== '' ? decimalSeparator + numberArray[1] : '');
	        },
	
	        /**
	         * Unformats number strings
	         * @param {String} numberString
	         * @param {String} numberGroupSeparator
	         * @param {String} decimalSeparator
	         * @param {Boolean} toFloat
	         * @return {String} formatted number string
	         */
	        unformatNumberString: function unformatNumberString(numberString, numberGroupSeparator, decimalSeparator, toFloat) {
	            toFloat = toFloat || false;
	            if (typeof numberGroupSeparator === 'undefined' || typeof decimalSeparator === 'undefined') {
	                return numberString;
	            }
	
	            // if number is not as string, make it a string
	            if (!_.isString(numberString)) {
	                if (_.isFinite(numberString)) {
	                    // valid number, convert to string
	                    numberString.toString();
	                } else {
	                    // invalid value: null, undefined, NaN, etc.
	                    // set to empty string
	                    numberString = '';
	                }
	            }
	
	            // parse out number group separators
	            if (numberGroupSeparator !== '') {
	                var num_grp_sep_re = new RegExp('\\' + numberGroupSeparator, 'g');
	                numberString = numberString.replace(num_grp_sep_re, '');
	            }
	
	            // parse out decimal separators
	            numberString = numberString.replace(decimalSeparator, '.');
	
	            // remove any invalid chars
	            //numberString = numberString.replace(/[^0-9\.\+\-\%]/g, '');
	
	            // convert to float
	            if (numberString.length > 0 && toFloat) {
	                var float = parseFloat(numberString);
	                if (float == numberString) {
	                    return float;
	                }
	            }
	
	            return numberString;
	        },
	
	        /**
	         * Unformat number string with user locale
	         * @param {Number}  value
	         * @param {Boolean} toFloat convert string to float value
	         * @return {String} formatted value
	         */
	        unformatNumberStringLocale: function unformatNumberStringLocale(value, toFloat) {
	            return this.unformatNumberString(value, app.user.getPreference('number_grouping_separator') || ',', app.user.getPreference('decimal_separator') || '.', toFloat);
	        },
	
	        /**
	         * This function will take a string that has tokens like {0}, {1} and will replace
	         * those tokens with the args provided.
	         * Based on format_string function from utils.php
	         * @param {String} format String to format
	         * @param {String} args Arguments to replace
	         * @return {String} formatted string
	         */
	        formatString: function formatString(format, args) {
	            for (var idx in args) {
	                format = format.replace('{' + idx + '}', args[idx]);
	            }
	            return format;
	        },
	
	        /**
	         * This function will take a string and escape it for use in javascript regex.
	         * @param {String} string the string to escape
	         * @return {String} string escaped
	         */
	        regexEscape: function regexEscape(string) {
	            if (typeof regexEscape.specialRegExp == 'undefined') {
	                var specials = ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\', '-', ',', '^', '$', '#'];
	                regexEscape.specialRegExp = new RegExp('(\\' + specials.join('|\\') + ')', 'g');
	            }
	            return string.replace(regexEscape.specialRegExp, '\\$1');
	        },
	
	        /**
	         * Generates and returns a UUID
	         * @return {string}
	         */
	        generateUUID: function generateUUID() {
	            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                /*jshint -W016 */ // "Unexpected use of '|'.",
	                /*jshint -W116 */ // "Expected '===' and instead saw '=='."
	                var r = Math.random() * 16 | 0,
	                    v = c == 'x' ? r : r & 0x3 | 0x8;
	                return v.toString(16);
	            });
	        },
	
	        cookie: {
	            /**
	             * Sets a cookie
	             * @param {String} cName cookie name
	             * @param {String} value
	             * @param {Number} exdays days until expiration
	             * @param {String} path cookie path
	             */
	            setCookie: function setCookie(cName, value, exdays, path) {
	                var exdate = new Date(),
	                    c_value;
	                exdate.setDate(exdate.getDate() + exdays);
	                c_value = encodeURIComponent(value);
	                if (exdays) {
	                    c_value += "; expires=" + exdate.toUTCString();
	                }
	                if (path) {
	                    c_value += "; path=" + path;
	                }
	                document.cookie = cName + "=" + c_value;
	            },
	
	            /**
	             * Gets a cookie
	             * @param {String} cName
	             * @return {String}
	             */
	            getCookie: function getCookie(cName) {
	                var i,
	                    x,
	                    y,
	                    ARRcookies = document.cookie.split(";");
	                for (i = 0; i < ARRcookies.length; i++) {
	                    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
	                    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
	                    x = x.replace(/^\s+|\s+$/g, "");
	                    if (x === cName) {
	                        return decodeURIComponent(y);
	                    }
	                }
	            }
	        },
	
	        /**
	         * Checks if an email address is valid
	         *
	         * Only performs a very basic validation because the complexity of the
	         * server-side regular expression is too great to mirror on the client,
	         * both in terms of maintenance and difficulty in porting to a different
	         * engine. Even if the light-weight validation passes, the server-side
	         * validation may fail.
	         * 
	         * @param {String} address
	         * @return {Boolean}
	         */
	        isValidEmailAddress: function isValidEmailAddress(address) {
	            return (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@\S+$/.test(address)
	            );
	        },
	
	        /**
	         *  Based on YUI onAvailible, but will use any boolean function instead of an ID.
	         *  Once the given condition is met, the callback function will be executed.
	         *
	         * <pre><code>
	         * // Execute a callback once an Object is defined
	         * app.utils.doWhen("SUGAR.ObjectToWaitFor", function(){
	         *     //Use the object here
	         *     console.log(SUGAR.ObjectToWaitFor);
	         * });
	         *
	         * // Use a function for condition and set paramters for the callback
	         * var el = $("#myId");
	         * var cond = function(){return el.hasClass("foo")};
	         * var callback = function(params){this.log(params.msg); el.html(params.html);};
	         * app.utils.doWhen(cond, callback, {msg:"Hello World", html:"&lt;h1&gt;Exists!&lt;/h1&gt;"}, console);
	         * </code></pre>
	           * @param {Function|string} condition function/evaluatable string which must return a boolean value.
	         * @param {Function} callback function to execute when condition is met
	         * @param {Object} [params] object to pass to the callback function
	         * @param {Object} [scope] object to use as this when executing the callback
	         */
	        doWhen: function doWhen(condition, callback, params, scope) {
	            _doWhenStack.push({
	                check: condition,
	                fn: callback,
	                obj: params,
	                overrideContext: scope
	            });
	
	            _doWhenretryCount = 50;
	            _startDoWhenInterval();
	        },
	        /**
	         *  The guts of doWhen. Runs through the stack checking all the conditions and fires the callbacks when the conditions are met.
	         * @private
	         */
	        _doWhenCheck: function _doWhenCheck() {
	            if (_doWhenStack.length === 0) {
	                _doWhenretryCount = 0;
	                if (_doWhenInterval) {
	                    clearInterval(_doWhenInterval);
	                    _doWhenInterval = null;
	                }
	                return;
	            }
	
	            if (_doWhenLocked) {
	                return;
	            }
	
	            _doWhenLocked = true;
	
	            // keep trying until after the page is loaded.  We need to
	            // check the page load state prior to trying to bind the
	            // elements so that we can be certain all elements have been
	            // tested appropriately
	            var tryAgain = $.isReady;
	            if (!tryAgain) {
	                tryAgain = _doWhenretryCount > 0 && _doWhenStack.length > 0;
	            }
	
	            // onAvailable
	            var notAvail = [];
	
	            var executeItem = function executeItem(context, item) {
	                if (item.overrideContext) {
	                    if (item.overrideContext === true) {
	                        context = item.obj;
	                    } else {
	                        context = item.overrideContext;
	                    }
	                }
	                if (item.fn) {
	                    item.fn.call(context, item.obj);
	                }
	            };
	
	            var i, len, item, test;
	
	            // onAvailable onContentReady
	            for (i = 0, len = _doWhenStack.length; i < len; i = i + 1) {
	                item = _doWhenStack[i];
	                if (item) {
	                    test = item.check;
	                    if (typeof test == 'string' && eval(test) || // jshint ignore:line
	                    typeof test == 'function' && test()) {
	                        executeItem(this, item);
	                        _doWhenStack[i] = null;
	                    } else {
	                        notAvail.push(item);
	                    }
	                }
	            }
	
	            _doWhenretryCount--;
	
	            if (tryAgain) {
	                for (i = _doWhenStack.length - 1; i > -1; i--) {
	                    item = _doWhenStack[i];
	                    if (!item || !item.check) {
	                        _doWhenStack.splice(i, 1);
	                    }
	                }
	                _startDoWhenInterval();
	            } else {
	                if (_doWhenInterval) {
	                    clearInterval(_doWhenInterval);
	                    _doWhenInterval = null;
	                }
	            }
	            _doWhenLocked = false;
	        },
	
	        /**
	         * Compares two version strings.
	         *
	         *     app.utils.versionCompare('8.2.5rc', '8.2.5a') === 1
	         *     app.utils.versionCompare('8.2.50', '8.2.52', '<') === true
	         *     app.utils.versionCompare('5.3.0-dev', '5.3.0') === -1
	         *     app.utils.versionCompare('4.1.0.52','4.01.0.51') === 1
	         *
	         * @param {string} v1 First version.
	         * @param {string} v2 Second version.
	         * @param {string} [operator] Operator argument, if specified, test for
	         *   a particular relationship. The possible operators are:
	         *   `<`, `lt`, `<=`, `le`, `>`, `gt`, `>=`, `ge`, `==`, `=`, `eq`,
	         *   `!=`, `<>`, and `ne`.
	         *   This parameter is case-sensitive, values should be lowercase.
	         *
	         * @return {number|boolean} By default, returns -1 if the first version
	         *   is lower than the second, 0 if they are equal, and 1 if the second
	         *   is lower. When using the optional operator argument, the function
	         *   will return `true` if the relationship is the one specified by the
	         *   operator, `false` otherwise.
	         */
	        versionCompare: function versionCompare(v1, v2, operator) {
	            // Use php.js implementation
	            // http://phpjs.org/functions/version_compare/
	            return version_compare(v1, v2, operator);
	        },
	
	        extendFrom: function extendFrom(subc, superc, overrides) {
	            subc.prototype = new superc(); // set the superclass
	            // overrides
	            _.extend(subc.prototype, overrides);
	        },
	
	        /**
	         * Creates a deep clone of an object.
	         * @param {Mixed} obj
	         * @return {Mixed} Returns a value of the same type as the input.
	         */
	        deepCopy: function deepCopy(obj) {
	            return _.isObject(obj) ? JSON.parse(JSON.stringify(obj)) : obj;
	        },
	
	        /**
	         * Compare field values in the first bean with the second bean and return the field names
	         * that have different values.
	         * @param {Bean} beanA
	         * @param {Bean} beanB
	         * @return {Array}
	         */
	        compareBeans: function compareBeans(beanA, beanB) {
	            var changedFields;
	
	            if (beanA.module !== beanB.module) {
	                throw Error('Only beans of the same module can be compared.');
	            }
	
	            changedFields = _.reduce(beanA.attributes, function (memo, value, attribute) {
	                // skip id field and all fields that start with an underscore
	                if (attribute !== 'id' && attribute.indexOf('_') !== 0) {
	                    if (!this.areBeanValuesEqual(value, beanB.get(attribute)) && this.hasDefaultValueChanged(attribute, beanA)) {
	                        memo.push(attribute);
	                    }
	                }
	
	                return memo;
	            }, [], this);
	
	            return changedFields;
	        },
	
	        /**
	         * Checks to see if values in beans are equal to each other.
	         * @param {Mixed} value1
	         * @param {Mixed} value2
	         * @return {boolean}
	         */
	        areBeanValuesEqual: function areBeanValuesEqual(value1, value2) {
	            var getValueToCompare = function getValueToCompare(value) {
	                if (_.isObject(value) && _.isEmpty(value)) {
	                    return '';
	                } else if (!_.isObject(value) && (_.isUndefined(value) || _.isNull(value))) {
	                    return '';
	                } else {
	                    return value;
	                }
	            };
	
	            value1 = getValueToCompare(value1);
	            value2 = getValueToCompare(value2);
	
	            return _.isObject(value1) && _.isEqual(value1, value2) || !_.isObject(value1) && value1 === value2;
	        },
	
	        /**
	         * Checks to see if the default value has changed.
	         * @param {string} attribute
	         * @param {Data.Bean} bean
	         * @return {boolean}
	         */
	        hasDefaultValueChanged: function hasDefaultValueChanged(attribute, bean) {
	            var defaultValue = bean._defaults ? bean._defaults[attribute] : '';
	            return !this.areBeanValuesEqual(defaultValue, bean.get(attribute));
	        },
	
	        /**
	         * Checks if the AJAX error is a network connectivity error: timeout, DNS, etc.
	         *
	         * @param ajaxError AJAX error.
	         * @returns {Boolean} true if the error is a network error.
	         */
	        isConnectivityError: function isConnectivityError(ajaxError) {
	            // There can be situations when the status is not zero but the actual request times out.
	            return ajaxError.status === 0 || ajaxError.textStatus === "timeout";
	        },
	
	        /**
	         * Returns ISO8601 timestamp in UTC time
	         * @param {String|Number} [dateValue] Date string or raw msec number
	         * @param {Object} [options]
	         * @returns {String} Passed date or current date converted to UTC timezone
	         */
	        getTimestamp: function getTimestamp(dateValue, options) {
	            options = options || {};
	            var date = dateValue ? new Date(dateValue) : new Date(),
	                dateString = date.toISOString();
	
	            if (!options.msecPrecision) {
	                dateString = dateString.replace(/\.\d{3}/, '');
	            }
	
	            //Z is replaced with +00:00 for unification with server
	            return dateString.replace(/Z/, '+00:00');
	        },
	
	        /**
	         * Builds a good url based on `siteUrl` from configuration.
	         *
	         * It is ready for the several use cases that `siteUrl` can have:
	         *
	         * - relative path (aka context);
	         * - full path;
	         * - empty path.
	         *
	         * @param {string} url the full url or a relative url without the prepended `/`.
	         * @return {string}
	         */
	        buildUrl: function buildUrl(url) {
	            // Adjust relative URL: prepend it with site URL
	            if (url.indexOf("http") !== 0 && !_.isEmpty(app.config.siteUrl)) {
	                // Strip trailing forward slashes from site URL just in case
	                url = app.config.siteUrl.replace(/\/+$/, "") + "/" + url;
	            }
	            return url;
	        },
	
	        /**
	          * Get diff between `data1` and `data2`.
	         * Note: this function is targeted to compare objects with the same properties.
	         * @param {Object} data1 Changed object
	         * @param {Object} data2 Original object
	         * @param {Boolean} [strict=false] By default values are compared property by property via non-strict comparison.
	         * @returns {Object} Hash of fields from `data1` which are different from `data2`
	         */
	        getChangedProps: function getChangedProps(data1, data2, strict) {
	
	            function getType(value) {
	                if (_.isObject(value)) {
	                    if (_.isArray(value)) {
	                        return 'array';
	                    }
	                    return 'object';
	                }
	                return 'other';
	            }
	
	            function isEqualProp(value1, value2) {
	
	                if (strict) return _.isEqual(value1, value2);
	
	                var value1Type = getType(value1),
	                    value2Type = getType(value2);
	
	                if (value1Type === value2Type && _.contains(['object', 'array'], value1Type)) {
	                    if (value1Type === 'array' && value1.length !== value2.length) {
	                        return false;
	                    }
	
	                    var keys1 = _.keys(value1),
	                        keys2 = _.keys(value2);
	
	                    if (keys1.length !== keys2.length || !_.isEqual(keys1.sort(), keys2.sort())) {
	                        return false;
	                    }
	
	                    return !_.any(value1, function (val, key) {
	                        return !isEqualProp(value1[key], value2[key]);
	                    });
	                } else {
	                    return strict ? value1 === value2 : value1 == value2;
	                }
	            }
	
	            var diff = {};
	
	            _.each(data1, function (value, key) {
	                if (!isEqualProp(data1[key], data2[key])) {
	                    diff[key] = value;
	                }
	            });
	
	            return diff;
	        },
	
	        /**
	         * Get the layout container for the given component.
	         * @param {View.Component} component
	         * @return {View.Layout}
	         */
	        getParentLayout: function getParentLayout(component) {
	            var parent;
	
	            if (component.view && component.view.layout) {
	                parent = component.view.layout;
	            } else {
	                parent = component.layout;
	            }
	
	            return parent;
	        },
	
	        isSortable: function isSortable(module, fieldViewdef) {
	            var fieldVardef = app.metadata.getModule(module).fields[fieldViewdef.name],
	                isSortable = true;
	
	            if (fieldVardef && !_.isUndefined(fieldVardef.sortable)) {
	                isSortable = fieldVardef.sortable;
	            }
	            if (fieldViewdef && !_.isUndefined(fieldViewdef.sortable)) {
	                isSortable = fieldViewdef.sortable;
	            }
	            return isSortable;
	        },
	
	        /**
	         * Returns url without hypertext http(s):// prefix
	         * @param {String} url - input url
	         * @returns {String} - url without http(s):// prefix
	         */
	        stripHttpPrefix: function stripHttpPrefix(url) {
	            return url.replace(/^https?:\/\//, '');
	        },
	
	        hardRefresh: function hardRefresh() {
	            window.location.reload(true);
	        },
	
	        /**
	         * Checks if the value should be rendered in RTL.
	         *
	         * @param {string} value The value to check.
	         * @return {boolean} `true` if the string is in a RTL language.
	         */
	        isDirectionRTL: function isDirectionRTL(value) {
	            var ltrChars = "A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u0300-\u0590\u0800-\u1FFF" + "\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF",
	                rtlChars = "\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC",
	                isRTL = new RegExp('^[^' + ltrChars + ']*[' + rtlChars + ']');
	
	            return isRTL.test(value);
	        }
	
	    });
	})(SUGAR.App);

/***/ },
/* 33 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	
	    /**
	     * This class extends from moment.js and tries to provide a compatibility
	     * layer with old/previous code.
	     *
	     * @class Utils.Date
	     * @alias SUGAR.App.date
	     * @singleton
	     */
	    var date = moment;
	
	    _.extend(date, {
	
	        /**
	         * Exception to be used when an invalid date/time is passed.
	         *
	         * @param {String} message The error message.
	         * @param {String} date The date that is invalid.
	         */
	        InvalidException: function InvalidException(message, date) {
	            this.name = 'InvalidException';
	            this.message = message;
	            this.date = date;
	        },
	
	        /**
	         * Cached formats of converted date/time formats from server to client.
	         *
	         * This cache is populated by {@link #convertFormat}
	         *
	         * @type {Object}
	         * @private
	         */
	        _cachedFormats: {},
	
	        /**
	         * Server date format according to momentjs.
	         * This is exactly the same as the server is expecting `Y-m-d`.
	         *
	         * @type {String}
	         * @private
	         */
	        _serverDateFormat: 'YYYY-MM-DD',
	
	        /**
	         * Convert PHP date/time format preference to JS.
	         *
	         * Momentjs uses a different formatting tokens:
	         * {@link http://momentjs.com/docs/#/parsing/string-format/}
	         *
	         * Known possible values to convert (out of the box):
	         *
	         * ```
	         * // dates
	         * 'Y-m-d'
	         * 'd-m-Y'
	         * 'm-d-Y'
	         * 'Y/m/d'
	         * 'd/m/Y'
	         * 'm/d/Y'
	         * 'Y.m.d'
	         * 'd.m.Y'
	         * 'm.d.Y'
	         *
	         * // time
	         * 'H:i'
	         * 'h:ia'
	         * 'h:iA'
	         * 'H.i'
	         * 'h.ia'
	         * 'h.iA'
	         * ```
	         *
	         * @param {String} server The server format preference to convert.
	         * @return {String} The converted format that momentjs understands.
	         * @private
	         *
	         */
	        convertFormat: function convertFormat(server) {
	
	            if (date._cachedFormats[server]) {
	                return date._cachedFormats[server];
	            }
	
	            var convertTable = {
	                // date
	                'd': 'DD', // day of the month w\ leading zeros
	                'm': 'MM', // numeric month w\ leading zeros
	                'Y': 'YYYY', // full numeric year
	                // time
	                'H': 'HH', // 24-hour format w\ leading zeros
	                'h': 'hh', // 12-hour format w\ leading zeros
	                'i': 'mm' // minutes w\ leading zeros
	            };
	
	            var client = server;
	            _.each(convertTable, function (to, from) {
	                client = client.replace(from, to);
	            });
	            date._cachedFormats[server] = client;
	            return client;
	        },
	
	        /**
	         * Compares two dates and returns an integer that is great for sorting.
	         *
	         * @param {String} date1 The first date to compare.
	         * @param {String} date2 The second date to compare.
	         * @return {Number} Returns `-1`, `0` or `1` based on:
	         * - `-1` if date1 < date2
	         * - `0` if date1 = date2
	         * - `1` if date1 > date2
	         *
	         * @throws {Error} if any of the given dates are invalid.
	         */
	        compare: function compare(date1, date2) {
	            var mDate1 = moment(date1),
	                mDate2 = moment(date2);
	
	            if (!mDate1.isValid()) {
	                throw new date.InvalidException('Invalid date passed for comparison.', date1);
	            }
	            if (!mDate2.isValid()) {
	                throw new date.InvalidException('Invalid date passed for comparison.', date2);
	            }
	
	            if (mDate1.isBefore(mDate2)) {
	                return -1;
	            }
	            if (mDate1.isAfter(mDate2)) {
	                return 1;
	            }
	            return 0;
	        },
	
	        /**
	         * Get the date format preference for the given user.
	         * @param {Data.Bean|Object} user
	         * @return {string}
	         */
	        getUserDateFormat: function getUserDateFormat(user) {
	            user = user || app.user;
	            return this.convertFormat(user.getPreference('datepref'));
	        },
	
	        /**
	         * Get the time format preference for the given user.
	         * @param {Data.Bean|Object} user
	         * @return {string}
	         */
	        getUserTimeFormat: function getUserTimeFormat(user) {
	            user = user || app.user;
	            return this.convertFormat(user.getPreference('timepref'));
	        },
	
	        phpStrToTime: function phpStrToTime(text, now) {
	            //  discuss at: http://phpjs.org/functions/strtotime/
	            //     version: 1109.2016
	            // original by: Caio Ariede (http://caioariede.com)
	            // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	            // improved by: Caio Ariede (http://caioariede.com)
	            // improved by: A. Matías Quezada (http://amatiasq.com)
	            // improved by: preuter
	            // improved by: Brett Zamir (http://brett-zamir.me)
	            // improved by: Mirko Faber
	            //    input by: David
	            // bugfixed by: Wagner B. Soares
	            // bugfixed by: Artur Tchernychev
	            // bugfixed by: Stephan Bösch-Plepelits (http://github.com/plepe)
	            //        note: Examples all have a fixed timestamp to prevent tests to fail because of variable time(zones)
	            //   example 1: strtotime('+1 day', 1129633200);
	            //   returns 1: 1129719600
	            //   example 2: strtotime('+1 week 2 days 4 hours 2 seconds', 1129633200);
	            //   returns 2: 1130425202
	            //   example 3: strtotime('last month', 1129633200);
	            //   returns 3: 1127041200
	            //   example 4: strtotime('2009-05-04 08:30:00 GMT');
	            //   returns 4: 1241425800
	            //   example 5: strtotime('2009-05-04 08:30:00+00');
	            //   returns 5: 1241425800
	            //   example 6: strtotime('2009-05-04 08:30:00+02:00');
	            //   returns 6: 1241418600
	            //   example 7: strtotime('2009-05-04T08:30:00Z');
	            //   returns 7: 1241425800
	
	            var parsed,
	                match,
	                today,
	                year,
	                date,
	                days,
	                ranges,
	                len,
	                times,
	                regex,
	                i,
	                fail = false;
	
	            if (!text) {
	                return fail;
	            }
	
	            // Unecessary spaces
	            text = text.replace(/^\s+|\s+$/g, '').replace(/\s{2,}/g, ' ').replace(/[\t\r\n]/g, '').toLowerCase();
	
	            // in contrast to php, js Date.parse function interprets:
	            // dates given as yyyy-mm-dd as in timezone: UTC,
	            // dates with "." or "-" as MDY instead of DMY
	            // dates with two-digit years differently
	            // etc...etc...
	            // ...therefore we manually parse lots of common date formats
	            match = text.match(/^(\d{1,4})([\-\.\/\:])(\d{1,2})([\-\.\/\:])(\d{1,4})(?:\s(\d{1,2}):(\d{2})?:?(\d{2})?)?(?:\s([A-Z]+)?)?$/);
	
	            if (match && match[2] === match[4]) {
	                if (match[1] > 1901) {
	                    switch (match[2]) {
	                        case '-':
	                            {
	                                // YYYY-M-D
	                                if (match[3] > 12 || match[5] > 31) {
	                                    return fail;
	                                }
	
	                                return new Date(match[1], parseInt(match[3], 10) - 1, match[5], match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
	                            }
	                        case '.':
	                            {
	                                // YYYY.M.D is not parsed by strtotime()
	                                return fail;
	                            }
	                        case '/':
	                            {
	                                // YYYY/M/D
	                                if (match[3] > 12 || match[5] > 31) {
	                                    return fail;
	                                }
	
	                                return new Date(match[1], parseInt(match[3], 10) - 1, match[5], match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
	                            }
	                    }
	                } else if (match[5] > 1901) {
	                    switch (match[2]) {
	                        case '-':
	                            {
	                                // D-M-YYYY
	                                if (match[3] > 12 || match[1] > 31) {
	                                    return fail;
	                                }
	
	                                return new Date(match[5], parseInt(match[3], 10) - 1, match[1], match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
	                            }
	                        case '.':
	                            {
	                                // D.M.YYYY
	                                if (match[3] > 12 || match[1] > 31) {
	                                    return fail;
	                                }
	
	                                return new Date(match[5], parseInt(match[3], 10) - 1, match[1], match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
	                            }
	                        case '/':
	                            {
	                                // M/D/YYYY
	                                if (match[1] > 12 || match[3] > 31) {
	                                    return fail;
	                                }
	
	                                return new Date(match[5], parseInt(match[1], 10) - 1, match[3], match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
	                            }
	                    }
	                } else {
	                    switch (match[2]) {
	                        case '-':
	                            {
	                                // YY-M-D
	                                if (match[3] > 12 || match[5] > 31 || match[1] < 70 && match[1] > 38) {
	                                    return fail;
	                                }
	
	                                year = match[1] >= 0 && match[1] <= 38 ? +match[1] + 2000 : match[1];
	                                return new Date(year, parseInt(match[3], 10) - 1, match[5], match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
	                            }
	                        case '.':
	                            {
	                                // D.M.YY or H.MM.SS
	                                if (match[5] >= 70) {
	                                    // D.M.YY
	                                    if (match[3] > 12 || match[1] > 31) {
	                                        return fail;
	                                    }
	
	                                    return new Date(match[5], parseInt(match[3], 10) - 1, match[1], match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
	                                }
	                                if (match[5] < 60 && !match[6]) {
	                                    // H.MM.SS
	                                    if (match[1] > 23 || match[3] > 59) {
	                                        return fail;
	                                    }
	
	                                    today = new Date();
	                                    return new Date(today.getFullYear(), today.getMonth(), today.getDate(), match[1] || 0, match[3] || 0, match[5] || 0, match[9] || 0) / 1000;
	                                }
	
	                                // invalid format, cannot be parsed
	                                return fail;
	                            }
	                        case '/':
	                            {
	                                // M/D/YY
	                                if (match[1] > 12 || match[3] > 31 || match[5] < 70 && match[5] > 38) {
	                                    return fail;
	                                }
	
	                                year = match[5] >= 0 && match[5] <= 38 ? +match[5] + 2000 : match[5];
	                                return new Date(year, parseInt(match[1], 10) - 1, match[3], match[6] || 0, match[7] || 0, match[8] || 0, match[9] || 0) / 1000;
	                            }
	                        case ':':
	                            {
	                                // HH:MM:SS
	                                if (match[1] > 23 || match[3] > 59 || match[5] > 59) {
	                                    return fail;
	                                }
	
	                                today = new Date();
	                                return new Date(today.getFullYear(), today.getMonth(), today.getDate(), match[1] || 0, match[3] || 0, match[5] || 0) / 1000;
	                            }
	                    }
	                }
	            }
	
	            // other formats and "now" should be parsed by Date.parse()
	            if (text === 'now') {
	                return now === null || isNaN(now) ? new Date().getTime() / 1000 | 0 : now | 0;
	            }
	            if (!isNaN(parsed = Date.parse(text))) {
	                return parsed / 1000 | 0;
	            }
	            // Browsers != Chrome have problems parsing ISO 8601 date strings, as they do
	            // not accept lower case characters, space, or shortened time zones.
	            // Therefore, fix these problems and try again.
	            // Examples:
	            //   2015-04-15 20:33:59+02
	            //   2015-04-15 20:33:59z
	            //   2015-04-15t20:33:59+02:00
	            match = text.match(/^([0-9]{4}-[0-9]{2}-[0-9]{2})[ t]([0-9]{2}:[0-9]{2}:[0-9]{2}(\.[0-9]+)?)([\+-][0-9]{2}(:[0-9]{2})?|z)/);
	            if (match) {
	                // fix time zone information
	                if (match[4] == 'z') {
	                    match[4] = 'Z';
	                } else if (match[4].match(/^([\+-][0-9]{2})$/)) {
	                    match[4] = match[4] + ':00';
	                }
	
	                if (!isNaN(parsed = Date.parse(match[1] + 'T' + match[2] + match[4]))) {
	                    return parsed / 1000 | 0;
	                }
	            }
	
	            date = now ? new Date(now * 1000) : new Date();
	            days = {
	                'sun': 0,
	                'mon': 1,
	                'tue': 2,
	                'wed': 3,
	                'thu': 4,
	                'fri': 5,
	                'sat': 6
	            };
	            ranges = {
	                'yea': 'FullYear',
	                'mon': 'Month',
	                'day': 'Date',
	                'hou': 'Hours',
	                'min': 'Minutes',
	                'sec': 'Seconds'
	            };
	
	            function lastNext(type, range, modifier) {
	                var diff,
	                    day = days[range];
	
	                if (typeof day !== 'undefined') {
	                    diff = day - date.getDay();
	
	                    if (diff === 0) {
	                        diff = 7 * modifier;
	                    } else if (diff > 0 && type === 'last') {
	                        diff -= 7;
	                    } else if (diff < 0 && type === 'next') {
	                        diff += 7;
	                    }
	
	                    date.setDate(date.getDate() + diff);
	                }
	            }
	
	            function process(val) {
	                var splt = val.split(' '),
	                    // Todo: Reconcile this with regex using \s, taking into account browser issues with split and regexes
	                type = splt[0],
	                    range = splt[1].substring(0, 3),
	                    typeIsNumber = /\d+/.test(type),
	                    ago = splt[2] === 'ago',
	                    num = (type === 'last' ? -1 : 1) * (ago ? -1 : 1);
	
	                if (typeIsNumber) {
	                    num *= parseInt(type, 10);
	                }
	
	                if (ranges.hasOwnProperty(range) && !splt[1].match(/^mon(day|\.)?$/i)) {
	                    return date['set' + ranges[range]](date['get' + ranges[range]]() + num);
	                }
	
	                if (range === 'wee') {
	                    return date.setDate(date.getDate() + num * 7);
	                }
	
	                if (type === 'next' || type === 'last') {
	                    lastNext(type, range, num);
	                } else if (!typeIsNumber) {
	                    return false;
	                }
	
	                return true;
	            }
	
	            times = '(years?|months?|weeks?|days?|hours?|minutes?|min|seconds?|sec' + '|sunday|sun\\.?|monday|mon\\.?|tuesday|tue\\.?|wednesday|wed\\.?' + '|thursday|thu\\.?|friday|fri\\.?|saturday|sat\\.?)';
	            regex = '([+-]?\\d+\\s' + times + '|' + '(last|next)\\s' + times + ')(\\sago)?';
	
	            match = text.match(new RegExp(regex, 'gi'));
	            if (!match) {
	                return fail;
	            }
	
	            for (i = 0, len = match.length; i < len; i++) {
	                if (!process(match[i])) {
	                    return fail;
	                }
	            }
	
	            // ECMAScript 5 only
	            // if (!match.every(process))
	            //    return false;
	
	            return date.getTime() / 1000;
	        }
	
	    });
	
	    /**
	     * @deprecated since 7.2.0. Convert your code to new date functionality.
	     * @private
	     */
	    var _formatStringCache = {}; // hash table of the datetime formats that have already been parsed
	
	    /**
	     * Deprecated functionality will be kept in the old singleton prototype.
	     * @deprecated since 7.2.0. Convert your code to new date functionality.
	     */
	    _.extend(date, {
	        /**
	         * Parses date strings into js Date()s
	         * @param {String} date date string
	         * @param {String} oldFormat date format string. If not specified parse will guess the date format
	         * @return {Date} javascript date object
	         */
	        parse: function parse(date, oldFormat) {
	            var jsDate = new Date("Jan 1, 1970 00:00:00"),
	                part = "",
	                dateRemain,
	                j,
	                c,
	                i,
	                v,
	                timeformat;
	
	            //if already a Date return it
	            if (date instanceof Date) return date;
	
	            // TODO add user prefs support
	
	            if (!oldFormat) {
	                oldFormat = this.guessFormat(date);
	            }
	
	            if (oldFormat === false) {
	                //Check if date is a timestamp
	                if (/^\d+$/.test(date)) {
	                    return new Date(date);
	                }
	
	                //we cant figure out the format so return false
	                return false;
	            }
	
	            dateRemain = $.trim(date);
	            oldFormat = $.trim(oldFormat) + " "; // Trailing space to read as last separator.
	            for (j = 0; j < oldFormat.length; j++) {
	                c = oldFormat.charAt(j);
	                if (c === ':' || c === '/' || c === '-' || c === '.' || c === " " || c === 'a' || c === "A") {
	                    i = dateRemain.indexOf(c);
	                    if (i === -1) i = dateRemain.length;
	                    v = dateRemain.substring(0, i);
	                    dateRemain = dateRemain.substring(i + 1);
	                    switch (part) {
	                        case 'm':
	                            if (!(v > 0 && v < 13)) return false;
	                            jsDate.setMonth(v - 1);
	                            break;
	                        case 'd':
	                            if (!(v > 0 && v < 32)) return false;
	                            jsDate.setDate(v);
	                            break;
	                        case 'Y':
	                            if (v > 0 === false) return false;
	                            jsDate.setYear(v);
	                            break;
	                        case 'h':
	                            //Read time, assume minutes are at end of date string (we do not accept seconds)
	                            timeformat = oldFormat.substring(oldFormat.length - 4);
	                            v = parseInt(v, 10);
	                            var timeFormatString = $.trim(timeformat.toLowerCase());
	                            if (timeFormatString === "i a" || timeFormatString === c + "ia") {
	                                var postfix = dateRemain.substring(dateRemain.length - 2).toLowerCase();
	                                if (postfix === 'pm') {
	                                    if (v < 12) {
	                                        v += 12;
	                                    }
	                                }
	                                // 12:00am => 00:00:00
	                                else if (postfix === 'am' && v === 12) {
	                                        v = 0;
	                                    }
	                            }
	                            jsDate.setHours(v);
	                            break;
	                        case 'H':
	                            jsDate.setHours(v);
	                            break;
	                        case 'i':
	                            v = v.substring(0, 2);
	                            jsDate.setMinutes(v);
	                            break;
	                        case 's':
	                            jsDate.setSeconds(v);
	                            break;
	                    }
	                    part = "";
	                } else {
	                    part = c;
	                }
	            }
	            return jsDate;
	        },
	
	        /**
	         * Guesses format of a date string.
	         * @param {String} date Date string
	         * @return {String} Date format.
	         */
	        guessFormat: function guessFormat(date) {
	            if (typeof date !== "string") return false;
	            //Is there a time
	            var time = "",
	                dateSep,
	                dateParts,
	                dateFormat,
	                timeFormat,
	                timeParts,
	                timeSep,
	                ampmCase,
	                timeEnd;
	
	            if (date.indexOf(" ") !== -1) {
	                time = date.substring(date.indexOf(" ") + 1, date.length);
	                date = date.substring(0, date.indexOf(" "));
	            }
	
	            //First detect if the date contains "-" or "/"
	            dateSep = "/";
	            if (date.indexOf("/") !== -1) {} else if (date.indexOf("-") !== -1) {
	                dateSep = "-";
	            } else if (date.indexOf(".") !== -1) {
	                dateSep = ".";
	            } else {
	                return false;
	            }
	
	            dateParts = date.split(dateSep);
	            dateFormat = "";
	
	            if (dateParts[0].length === 4) {
	                dateFormat = "Y" + dateSep + "m" + dateSep + "d";
	            } else if (dateParts[2].length === 4) {
	                dateFormat = "m" + dateSep + "d" + dateSep + "Y";
	            } else {
	                return false;
	            }
	
	            timeFormat = "";
	            timeParts = [];
	
	            // Check for time
	            if (time !== "") {
	
	                // start at the i, we always have minutes
	                timeParts.push("i");
	
	                timeSep = ":";
	
	                if (time.indexOf(".") === 2) {
	                    timeSep = ".";
	                }
	
	                // if its long we have seconds
	                if (time.split(timeSep).length === 3) {
	                    timeParts.push("s");
	                }
	                ampmCase = '';
	
	                // check for am/pm
	                timeEnd = time.substring(time.length - 2, time.length);
	                if (timeEnd.toLowerCase() === "am" || timeEnd.toLowerCase() === "pm") {
	                    timeParts.unshift("h");
	                    if (timeEnd.toLowerCase() === timeEnd) {
	                        ampmCase = 'lower';
	                    } else {
	                        ampmCase = 'upper';
	                    }
	                } else {
	                    timeParts.unshift("H");
	                }
	
	                timeFormat = timeParts.join(timeSep);
	
	                // check for space between am/pm and time
	                if (time.indexOf(" ") !== -1) {
	                    timeFormat += " ";
	                }
	
	                // deal with upper and lowercase am pm
	                if (ampmCase && ampmCase === 'upper') {
	                    timeFormat += "A";
	                } else if (ampmCase && ampmCase === 'lower') {
	                    timeFormat += "a";
	                }
	
	                dateFormat = dateFormat + " " + timeFormat;
	            }
	
	            return dateFormat;
	        },
	
	        /**
	         * Parse a date format string into each of it's individual representations. Supports
	         * only the options that are supported by the date.format function.
	         *
	         * @param {String} format   date format string such as "Y-m-d H:i:s"
	         * @return {Object} object with properties representing each piece of a format
	         */
	        parseFormat: function parseFormat(format) {
	            // if this format has been seen before then don't bother parsing it again
	            if (!(format in _formatStringCache)) {
	                var parts = {},
	                    i,
	                    c;
	
	                for (i = 0; i < format.length; i++) {
	                    c = format.charAt(i);
	                    switch (c) {
	                        case 'm':
	                        case 'n':
	                            parts.month = c;
	                            break;
	                        case 'd':
	                        case 'j':
	                            parts.day = c;
	                            break;
	                        case 'Y':
	                            parts.year = c;
	                            break;
	                        case 'H':
	                        case 'h':
	                        case 'g':
	                            parts.hours = c;
	                            break;
	                        case 'i':
	                            parts.minutes = c;
	                            break;
	                        case 's':
	                            parts.seconds = c;
	                            break;
	                        case 'A':
	                        case 'a':
	                            parts.amPm = c;
	                            break;
	                        default:
	                            break;
	                    }
	                }
	
	                // cache the result so it doesn't have to be parsed again
	                _formatStringCache[format] = parts;
	            }
	
	            return _formatStringCache[format];
	        },
	
	        /**
	         * Formats javascript date objects into date strings
	         * @param {Date} date
	         * @param {String} format date format string such as "Y-m-d H:i:s"
	         * @return {String} formatted date string
	         */
	        format: function format(date, _format) {
	            if (!_.isDate(date)) return "";
	            // TODO: add support for userPrefs
	            var out = "",
	                i,
	                c,
	                d,
	                h,
	                m,
	                s;
	            for (i = 0; i < _format.length; i++) {
	                c = _format.charAt(i);
	                switch (c) {
	                    case '\\':
	                        out += _format.charAt(i + 1);
	                        // skip next character
	                        i++;
	                        break;
	                    case 'm':
	                    case 'n':
	                        m = date.getMonth() + 1;
	                        out += m < 10 && c === "m" ? "0" + m : m;
	                        break;
	                    case 'd':
	                    case 'j':
	                        d = date.getDate();
	                        out += d < 10 && c === "d" ? "0" + d : d;
	                        break;
	                    case 'Y':
	                        out += date.getFullYear();
	                        break;
	                    case 'H':
	                    case 'h':
	                    case 'g':
	                        h = date.getHours();
	                        if (c === "h" || c === "g") {
	                            h = h > 12 ? h - 12 : h;
	                            //Convert 0 to 12 for 12 hour formats
	                            h = h === 0 ? 12 : h;
	                        }
	                        out += h < 10 && c !== "g" ? "0" + h : h;
	                        break;
	                    case 'i':
	                        m = date.getMinutes();
	                        out += m < 10 ? "0" + m : m;
	                        break;
	                    case 's':
	                        s = date.getSeconds();
	                        out += s < 10 ? "0" + s : s;
	                        break;
	                    case 'a':
	                    case 'A':
	                        if (date.getHours() < 12) out += c === "a" ? "am" : "AM";else out += c === "a" ? "pm" : "PM";
	                        break;
	                    default:
	                        out += c;
	                }
	            }
	            return out;
	        },
	
	        /**
	         * Rounds a date to the nearest 15 minutes.
	         * @param {Date} date A date to round.
	         * @return {Date} Rounded date.
	         */
	        roundTime: function roundTime(date) {
	            if (!date.getMinutes) return 0;
	            var min = date.getMinutes();
	
	            if (min < 1) {
	                min = 0;
	            } else if (min < 16) {
	                min = 15;
	            } else if (min < 31) {
	                min = 30;
	            } else if (min < 46) {
	                min = 45;
	            } else {
	                min = 0;
	                date.setHours(date.getHours() + 1);
	            }
	
	            date.setMinutes(min);
	
	            return date;
	        },
	
	        /**
	         * Converts a UTC date to a local time date
	         * @param {Date} date a UTC date.
	         * @return {Date} Date converted to local date.
	         * @method
	         */
	        UTCtoLocalTime: function UTCtoLocalTime(date) {
	            //if not a Date return it
	            if (!(date instanceof Date)) return date;
	
	            // Push the UTC tag to convert the date into local date
	            return new Date(this.toUTC(date));
	        },
	
	        /**
	         * Converts a UTC date to a date in the timezone represented by the offset.
	         *
	         * @param {Date} date  A UTC date.
	         * @param {Number} offset  The timezone's UTC offset in hours.
	         * @return {Date} Converted date.
	         * @method
	         */
	        UTCtoTimezone: function UTCtoTimezone(date, offset) {
	            // if date is not a Date or there is no offset then return date
	            if (!(date instanceof Date) || undefined === offset || null === offset) {
	                return date;
	            }
	
	            // convert the offset to milliseconds
	            // parseFloat is used to guarantee that offset is numerical before converting it
	            offset = parseFloat(offset) * 60 * 60 * 1000;
	
	            // the offset really needs to be the difference between the local time offset and the user's
	            // preferred offset since javascript always represents dates in local time
	            // javascript uses +7 hours while the api uses -7 hours to represent the same timezone offset,
	            // so the javascript offset must be negated
	            offset -= date.getTimezoneOffset() * 60 * 1000 * -1;
	
	            return new Date(this.toUTC(date) + offset);
	        },
	
	        /**
	         * Converts the date from local to UTC. Even though the date on the server is UTC,
	         * JavaScript represents the date according to the local timezone. Use this function
	         * to get the time value of the real UTC date, ignoring the timezone JavaScript
	         * imposes on the date object.
	         *
	         * @param {Date} date a UTC date
	         * @return {Number}  the number of milliseconds between universal time and date
	         */
	        toUTC: function toUTC(date) {
	            //if not a Date return it
	            if (!(date instanceof Date)) {
	                return date;
	            }
	
	            var year = date.getFullYear(),
	                month = date.getMonth(),
	                day = date.getDate(),
	                hours = date.getHours(),
	                minutes = date.getMinutes(),
	                seconds = date.getSeconds(),
	                milliseconds = date.getMilliseconds();
	
	            return Date.UTC(year, month, day, hours, minutes, seconds, milliseconds);
	        },
	
	        /**
	         * Converts a date object into a relative time.
	         * @param {Date} date
	         * @return {Object} object containing relative time key string and value to push to the template
	         */
	        getRelativeTimeLabel: function getRelativeTimeLabel(date) {
	            var rightNow = new Date();
	            var isFuture = rightNow.getTime() < date.getTime();
	            //If incoming date is future we want to flip the calculation
	            var diff = isFuture ? date - rightNow : rightNow - date;
	            var second = 1000,
	                minute = second * 60,
	                hour = minute * 60,
	                day = hour * 24,
	                ctx = { str: "", value: undefined };
	
	            if (isNaN(diff) || diff < 0) {
	                return ctx; // return blank string if unknown
	            }
	            if (diff < second * 2) {
	                // within 2 seconds
	                ctx.str = 'LBL_TIME_AGO_NOW';
	                return ctx;
	            }
	
	            if (diff < minute) {
	                ctx.str = isFuture ? 'LBL_TIME_UNTIL_SECONDS' : 'LBL_TIME_AGO_SECONDS';
	                ctx.value = Math.floor(diff / second);
	                return ctx;
	            }
	            if (diff < minute * 2) {
	                ctx.str = isFuture ? 'LBL_TIME_UNTIL_MINUTE' : 'LBL_TIME_AGO_MINUTE';
	                return ctx;
	            }
	            if (diff < hour) {
	                ctx.str = isFuture ? 'LBL_TIME_UNTIL_MINUTES' : 'LBL_TIME_AGO_MINUTES';
	                ctx.value = Math.floor(diff / minute);
	                return ctx;
	            }
	            if (diff < hour * 2) {
	                ctx.str = isFuture ? 'LBL_TIME_UNTIL_HOUR' : 'LBL_TIME_AGO_HOUR';
	                return ctx;
	            }
	            if (diff < day) {
	                ctx.str = isFuture ? 'LBL_TIME_UNTIL_HOURS' : 'LBL_TIME_AGO_HOURS';
	                ctx.value = Math.floor(diff / hour);
	                return ctx;
	            }
	            if (diff > day && diff < day * 2) {
	                ctx.str = isFuture ? 'LBL_TIME_UNTIL_DAY' : 'LBL_TIME_AGO_DAY';
	                return ctx;
	            }
	            if (diff < day * 365) {
	                ctx.str = isFuture ? 'LBL_TIME_UNTIL_DAYS' : 'LBL_TIME_AGO_DAYS';
	                ctx.value = Math.floor(diff / day);
	                return ctx;
	            } else {
	                ctx.str = isFuture ? 'LBL_TIME_UNTIL_YEAR' : 'LBL_TIME_AGO_YEAR';
	                return ctx;
	            }
	        },
	
	        /**
	         * Parses display_default property which server returns for datetimecombo meta, etc. (for example,
	         * if the user sets the default in Studio). The following are possibilities:
	         * +1 day&06:00pm
	         * -1 day&06:00pm
	         * +1 week&06:00pm
	         * +1 month&06:00pm
	         * +1 year&06:00pm
	         * now&06:00pm
	         * next monday&06:00pm
	         * next friday&06:00pm
	         * first of next month@06:00pm
	         *
	         * @param {String} displayDefault
	         * @param {Date} now An optional date to use as a point of reference (since we essentially convert
	         * "+1 day", etc., to an adjusted date). This is mainly for testing odd dates like adding a month
	         * specifically to January 31, etc. If not passed, current date will be used.
	         * @return {String} String rep which can subsequently be used by later used for date.parse
	         * e.g. "2012-08-09 00:30am"
	         */
	        parseDisplayDefault: function parseDisplayDefault(displayDefault, now) {
	            var dateMap, d, dt, humanDate, defaultTime, addMonths, next, setTimePart;
	            var dateObj = now ? now : new Date(),
	                op,
	                timeAway,
	                parts;
	
	            if (!displayDefault) return displayDefault;
	
	            // This adds months from 'd' date passed in. 'n' is the number of months to add.
	            // Of course, you can use a negative sign to subtract months.
	            addMonths = function addMonths(d, n) {
	                var day = d.getDate();
	                d.setMonth(d.getMonth() + n);
	                if (d.getDate() < day) {
	                    d.setDate(1);
	                    d.setDate(d.getDate() - 1);
	                }
	                return d;
	            };
	
	            // Helper to return the number of days from now to 'day' (see dateObj initialization above)
	            next = function next(day) {
	                var days, todayDay, daysUntilNext;
	                days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
	                todayDay = dateObj.getDay();
	                day = day.toLowerCase();
	
	                for (var i = 7; i--;) {
	                    if (day === days[i]) {
	                        day = i <= todayDay ? i + 7 : i;
	                        break;
	                    }
	                }
	                daysUntilNext = day - todayDay;
	                return daysUntilNext;
	            };
	
	            // Maps keys with functions that converts human date as appropriate per key (e.g. +1 day, etc.)
	            dateMap = {
	                day: function day(operator) {
	                    return new Date(dateObj.setDate(dateObj.getDate() + operator));
	                },
	                week: function week(operator) {
	                    return new Date(dateObj.setDate(dateObj.getDate() + operator * 7));
	                },
	                month: function month(operator) {
	                    return addMonths(dateObj, operator);
	                },
	                year: function year(operator) {
	                    return addMonths(dateObj, operator * 12);
	                },
	                'now': function now() {
	                    return dateObj;
	                },
	                'next monday': function nextMonday() {
	                    return new Date(dateObj.setDate(dateObj.getDate() + next("monday")));
	                },
	                'next friday': function nextFriday() {
	                    return new Date(dateObj.setDate(dateObj.getDate() + next("friday")));
	                },
	                'first of next month': function firstOfNextMonth() {
	                    // First set date to first day of "this month" so we don't have a potential
	                    // date overrun (e.g. today's Oct 31 and we +1 month but no Nov 31 so Dec 1!)
	                    dateObj.setDate(1);
	                    // Now it's safe to add +1 months
	                    var sinceEpoch = dateObj.setMonth(dateObj.getMonth() + 1);
	                    return new Date(sinceEpoch);
	                }
	            };
	
	            // Main entry point - parses displayDefault and calls correspondingly
	            // mapped function to resolve to suitable date string for date.parse
	            if (displayDefault && displayDefault.indexOf('&') >= 0) {
	                dt = displayDefault.split("&"); //e.g. +1 day&06:00pm
	                humanDate = dt[0];
	                defaultTime = dt[1];
	            } else {
	                humanDate = displayDefault; // assume no time part e.g. for type date
	            }
	
	            if (humanDate.match(/\b(now|day|week|month|year)/g)) {
	                if (humanDate.indexOf('now') === 0) {
	                    timeAway = 'now';
	                } else if (humanDate.indexOf("first day of next month") !== -1) {
	                    timeAway = 'firstnextmonth';
	                } else {
	                    parts = humanDate.split(' ');
	                    op = parts[0];
	                    timeAway = parts[1];
	                }
	                if (timeAway.match('now')) {
	                    d = dateMap.now();
	                } else if (timeAway.match('firstnextmonth')) {
	                    d = dateMap['first of next month']();
	                } else if (timeAway.match('days?')) {
	                    d = dateMap.day(parseInt(op, 10));
	                } else if (timeAway.match('weeks?')) {
	                    d = dateMap.week(parseInt(op, 10));
	                } else if (timeAway.match('months?')) {
	                    d = dateMap.month(parseInt(op, 10));
	                } else if (timeAway.match('years?')) {
	                    d = dateMap.year(parseInt(op, 10));
	                } else {
	                    if (!dateMap[humanDate]) {
	                        return;
	                    }
	                    // TODO Better to log error???
	                    d = dateMap[humanDate]();
	                }
	            } else {
	                if (!dateMap[humanDate]) {
	                    return;
	                }
	                d = dateMap[humanDate]();
	            }
	
	            setTimePart = function (d) {
	                var timeParts, hours, minutes;
	
	                //Fixes bug SP-1280: Turns out hours in displayDefault can be either of single/double digits
	                timeParts = /^(\d\d?).(\d{2}).?([ap]m)?$/.exec(defaultTime);
	                if (timeParts && timeParts.length > 2) {
	                    hours = timeParts[1];
	
	                    if (hours) {
	
	                        if (timeParts[3] === 'pm') {
	                            if (hours < 12) {
	                                hours = parseInt(hours, 10) + 12;
	                            }
	                        } else {
	
	                            // Set 12am to 00
	                            if (hours === '12') {
	                                hours = '0';
	                            }
	                        }
	
	                        d.setHours(parseInt(hours, 10));
	                    }
	
	                    minutes = timeParts[2];
	                    if (minutes) {
	                        d.setMinutes(parseInt(minutes, 10));
	                    }
	                }
	            }(d);
	
	            return d;
	        },
	
	        /**
	         * SugarCRM has date formats using Y, m, d format characters. However, given our stylgeguide is now using the bootstrap
	         * datepicker, we need to remap those to it's format. For example: Y==yyyy, m==mm, and d==dd
	         * @param {String} formatSpec The original SugarCRM (PHP) date format.
	         * @return {String} Format spec passed in normalized to that expected by the bootstrap datepicker widget. If falsy,
	         * returns empty string.
	         */
	        toDatepickerFormat: function toDatepickerFormat(formatSpec) {
	            if (_.isUndefined(formatSpec) || !formatSpec) return '';
	            var normalizedFormatSpec,
	                sugarToDatepickerMap = {
	                'y': 'yy',
	                'Y': 'yyyy',
	                'm': 'mm',
	                'd': 'dd'
	            };
	            normalizedFormatSpec = formatSpec.replace(/[yYmd]/g, function (s) {
	                return sugarToDatepickerMap[s];
	            });
	            return normalizedFormatSpec;
	        },
	        /**
	        * Strips out the 'T' and, either the 'Z' or +00:00 by, essentially, taking just the first 19 characters
	        * @param  {String} value The value
	        * @return {String} stripped value
	        */
	        stripIsoTimeDelimterAndTZ: function stripIsoTimeDelimterAndTZ(value) {
	            if (!_.isUndefined(value) && value) {
	                // Since s.replace('T', ' ').replace('Z','') assumes we have Z it's better to do:
	                // str.replace('T', ' ').substr(0, 19) ... which works for both of following formats:
	                // '2012-11-07T04:28:52+00:00'.replace('T', ' ').substr(0, 19)
	                // "2012-11-06 20:00:06.651Z".replace('T', ' ').substring(0, 19)
	                return value.replace("T", " ").substr(0, 19);
	            }
	        },
	        /**
	        * Determines if date string is iso 8601'like ;)
	        * @param  {String} val The date string value to check
	        * @return {Boolean} True if is REST API / ISO 8601 compatible formatted date value.
	        */
	        isIso: function isIso(val) {
	            var yyyymmddExact, yyyymmddLooseMatch;
	
	            // First match most nominal case yyyy-mm-dd
	            yyyymmddExact = val.match(/^([0-9]{4})-?(1[0-2]|0[1-9])-?(3[0-1]|0[1-9]|[1-2][0-9])$/);
	            if (yyyymmddExact) {
	                return true;
	            }
	            // If we have any of the iso 8601 chars and still starts with yyyy-mm-dd
	            if (val.match(/[T\+Z ]/g)) {
	                yyyymmddLooseMatch = val.match(/^([0-9]{4})-?(1[0-2]|0[1-9])-?(3[0-1]|0[1-9]|[1-2][0-9])/);
	                if (yyyymmddLooseMatch) return true;
	            }
	            return false;
	        }
	    });
	
	    _.extend(date.fn, {
	
	        /**
	         * Formats a date to a string based on user preferences.
	         *
	         * @param {boolean} [dateOnly=false] Pass `true` to get date only.
	         * @param {Data.Bean|Object} [user=App.user] The user bean or the
	         *   current logged in user object. Defaults to current logged in
	         *   user.
	         * @return {string} The formatted date based on user's preference.
	         */
	        formatUser: function formatUser(dateOnly, user) {
	            var format = date.getUserDateFormat(user);
	
	            if (!dateOnly) {
	                format += ' ' + date.getUserTimeFormat(user);
	            }
	            return this.format(format);
	        },
	
	        /**
	         * Formats a date to a string according to server date format.
	         *
	         * @param {boolean} [dateOnly=false] Pass `true` to get date only.
	         * @return {string} The formatted date according to server date format.
	         */
	        formatServer: function formatServer(dateOnly) {
	            var format = dateOnly && date._serverDateFormat;
	
	            return this.format(format);
	        },
	
	        /**
	         * Returns `true` if the date is between the given `startDate` and
	         * `endDate`.
	         *
	         * @param {String} startDate The start date of the period to test.
	         * @param {String} endDate The end date of the period to test.
	         * @param {Boolean} [inclusive=true] Include start and end dates in
	         *   comparison.
	         */
	        isBetween: function isBetween(startDate, endDate, inclusive) {
	            // inclusive should default to true unless explicitly sent false as the param
	            inclusive = _.isUndefined(inclusive) ? true : inclusive;
	
	            var isInRange = this.isAfter(startDate) && this.isBefore(endDate);
	
	            // if we're including start and end dates and date1 hasn't been found to be inside the range yet
	            if (inclusive && !isInRange) {
	                // check if date1 is on the start or end dates
	                isInRange = this.isSame(startDate) || this.isSame(endDate);
	            }
	            return isInRange;
	        }
	
	    });
	
	    _.extend(date.duration.fn, {
	        /**
	         * Get the display string for the duration.
	         * Note: It currently supports days, hours, and minutes, not months and years.
	         * @return {string}
	         */
	        format: function format() {
	            var duration = [],
	                minutes = this.minutes(),
	                hours = this.hours(),
	                days = Math.floor(this.asDays());
	
	            if (days > 0) {
	                duration.push(days);
	                duration.push(app.lang.get(days === 1 ? 'LBL_DURATION_DAY' : 'LBL_DURATION_DAYS'));
	            }
	
	            if (hours > 0) {
	                duration.push(hours);
	                duration.push(app.lang.get(hours === 1 ? 'LBL_DURATION_HOUR' : 'LBL_DURATION_HOURS'));
	            }
	
	            if (minutes > 0) {
	                duration.push(minutes);
	                duration.push(app.lang.get(minutes === 1 ? 'LBL_DURATION_MINUTE' : 'LBL_DURATION_MINUTES'));
	            }
	
	            return duration.join(' ');
	        }
	    });
	
	    app.augment('date', date);
	})(SUGAR.App);

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	
	(function (app) {
	    /**
	     * Math module provides utility methods for working with basic calculations
	     * that JS normally fails to do well.
	     *
	     * @class Utils.Math
	     * @alias SUGAR.App.math
	     * @singleton
	     */
	    app.augment('math', {
	
	        /**
	         * Do math calculations in javascript,
	         * sans floating point errors.
	         *
	         * ex. $10.52 is really 1052 cents. Think of currency as
	         * cents and apply math that way (as integers)  and this should
	         * help keep floating point issues out of the picture.
	         *
	         * @param {String} operator
	         * @param {Number} n1
	         * @param {Number|undefined} n2
	         * @param {Number|undefined} (decimals)
	         * @param {boolean|undefined} (fixed) return value as fixed string
	         * @return {Number|String} rounded amount
	         */
	        _math: function _math(operator, n1, n2, decimals, fixed) {
	            decimals = _.isFinite(decimals) && decimals >= 0 ? parseInt(decimals) : 6;
	            Big.E_NEG = -1 * (decimals + 1);
	            fixed = fixed || false;
	            var result;
	
	            // if n1 is not a number, just return it, no need to do math on it.
	            if (!_.isFinite(n1)) {
	                return n1;
	            }
	
	            try {
	                switch (operator) {
	                    case 'round':
	                        result = Big(n1).round(decimals);
	                        break;
	                    case 'add':
	                        result = Big(n1).plus(n2);
	                        break;
	                    case 'sub':
	                        result = Big(n1).minus(n2);
	                        break;
	                    case 'mul':
	                        result = Big(n1).times(n2).round(decimals);
	                        break;
	                    case 'div':
	                        result = Big(n1).div(n2).round(decimals);
	                        break;
	                    default:
	
	                        // no valid operator, just return number
	                        return n1;
	                }
	            } catch (error) {
	                if (error.name == 'BigError') {
	                    return n1;
	                }
	            }
	
	            if (fixed && !_.isString(result)) {
	                return result.toFixed(decimals);
	            } else if (!_.isString(result)) {
	                return result.toString();
	            } else {
	                return result;
	            }
	        },
	
	        /**
	         * round a number to specified decimals as integer value.
	         *
	         * @param {Number} number
	         * @param {Number|undefined} decimals
	         * @param {boolean|undefined} fixed return value as fixed string
	         * @return {Number|String} rounded amount
	         */
	        round: function round(number, decimals, fixed) {
	            return this._math('round', number, null, decimals, fixed);
	        },
	
	        /**
	         * add two numbers as integer values
	         *
	         * @param {Number} n1
	         * @param {Number} n2
	         * @param {Number|undefined} decimals
	         * @param {boolean|undefined} fixed return value as fixed string
	         * @return {Number|String} rounded amount
	         */
	        add: function add(n1, n2, decimals, fixed) {
	            return this._math('add', n1, n2, decimals, fixed);
	        },
	
	        /**
	         * subtract two numbers as integer values
	         *
	         * @param {Number} n1
	         * @param {Number} n2
	         * @param {Number|undefined} decimals
	         * @param {boolean|undefined} fixed return value as fixed string
	         * @return {Number|String} rounded amount
	         */
	        sub: function sub(n1, n2, decimals, fixed) {
	            return this._math('sub', n1, n2, decimals, fixed);
	        },
	
	        /**
	         * multiply two numbers as integer values
	         *
	         * @param {Number} n1
	         * @param {Number} n2
	         * @param {Number|undefined} decimals
	         * @param {boolean|undefined} fixed return value as fixed string
	         * @return {Number|String} rounded amount
	         */
	        mul: function mul(n1, n2, decimals, fixed) {
	            return this._math('mul', n1, n2, decimals, fixed);
	        },
	
	        /**
	         * divide two numbers as integer values
	         *
	         * @param {Number} n1
	         * @param {Number} n2
	         * @param {Number|undefined} decimals
	         * @param {boolean|undefined} fixed return value as fixed string
	         * @return {Number|String} rounded amount
	         */
	        div: function div(n1, n2, decimals, fixed) {
	            return this._math('div', n1, n2, decimals, fixed);
	        },
	
	        /**
	         * Check to see if two values are different that will compute with a given precision
	         *
	         * This will compute the difference between the newValue and oldValue and figure out if it's changed
	         * by at least 1 rounded out to the decimal precision that the users has set in their preferences
	         *
	         * @param {string|number} newValue      The New Value
	         * @param {string|number} oldValue      The Old Value
	         * @param {number} (precision)          What precision should we use (optional)
	         * @return {boolean}
	         */
	        isDifferentWithPrecision: function isDifferentWithPrecision(newValue, oldValue, precision) {
	            var config = app.metadata.getConfig();
	            var user_precision = precision || app.user.getPreference('decimal_precision');
	            precision = _.isFinite(user_precision) ? user_precision : config.defaultCurrencySignificantDigits || 2;
	            var diff = this._math('round', this.getDifference(newValue, oldValue, true), null, precision);
	            var diffPrecision = precision === 0 ? '0' : this._math('div', 0.1, Math.pow(10, precision - 1));
	
	            // if the diff is 0 (zero) always return false, this should only happen when precision is 0
	            return diff === '0' ? false : parseFloat(diff) >= parseFloat(diffPrecision);
	        },
	
	        /**
	         * Get the difference of two number
	         *
	         * @param {Number} newValue
	         * @param {Number} oldValue
	         * @param {Boolean} [absolute=false]
	         */
	        getDifference: function getDifference(newValue, oldValue, absolute) {
	            var diff = this._math('sub', newValue, oldValue);
	            absolute = _.isUndefined(absolute) ? false : absolute;
	
	            return absolute ? Math.abs(diff) : diff;
	        }
	
	    }, false);
	})(SUGAR.App);

/***/ },
/* 35 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	
	(function (app) {
	    /**
	     * Currency module provides utility methods for working with currencies.
	     *
	     * @class Utils.Currency
	     * @alias SUGAR.App.currency
	     * @singleton
	     */
	    app.augment('currency', {
	        /**
	         * Get the base currency id.
	         * @return {String} the base currency id.
	         */
	        getBaseCurrencyId: function getBaseCurrencyId() {
	            return app.metadata.getBaseCurrencyId();
	        },
	
	        /**
	         * Helper function that returns system's base currency
	         *
	         * @return {Object} The base currency data.
	         */
	        getBaseCurrency: function getBaseCurrency() {
	            var currId = app.metadata.getBaseCurrencyId(),
	                currencyObj = app.metadata.getCurrency(currId);
	
	            // add currency_id to returned data
	            currencyObj.currency_id = currId;
	
	            return currencyObj;
	        },
	
	        /**
	         * List of all currencies mapped by id and information based on the
	         * template given.
	         *
	         * Example for the `template` param:
	         * <pre><code>
	         *   getCurrenciesSelector(Handlebars.compile('{{symbol}} ({{iso}})'));
	         * </code></pre>
	         *
	         * @param {Function}  template how to format the value returned.
	         * @return {Object} currencies with id and value (template based).
	         */
	        getCurrenciesSelector: function getCurrenciesSelector(template) {
	            var currencies = {};
	
	            _.each(app.metadata.getCurrencies(), function (currency, id) {
	                currencies[id] = template(currency);
	            });
	            return currencies;
	        },
	        /**
	         * Get the symbol for the given currency
	         * @param {String}  currencyId
	         * @return {String} currency symbol
	         */
	        getCurrencySymbol: function getCurrencySymbol(currencyId) {
	            var currency = app.metadata.getCurrency(currencyId);
	            return currency ? currency.symbol : '';
	        },
	        /**
	         * Format currency amount
	         * @param {Number}  amount the amount to be formatted
	         * @param {String}  currencyId (optional) the currency id to be used.
	         * If not specified, the system default will be used.
	         * @param {Number}  decimalPrecision (optional) the number of digits for
	         * decimal precision. Defaults to 2.
	         * @param {String}  numberGroupingSeparator (optional) the groups
	         * separator (string between thousands). Defaults to `,`.
	         * @param {String}  decimalSeparator (optional) the decimal separator
	         * (string between number and decimals). Defaults to `.`.
	         * @param {String}  symbolSeparator (optional) string between symbol and
	         * the amount. Defaults to empty (no space).
	         * @return {String} formatted currency amount
	         */
	        formatAmount: function formatAmount(amount, currencyId, decimalPrecision, numberGroupingSeparator, decimalSeparator, symbolSeparator) {
	            // we don't want to format non-numbers
	            if (!_.isFinite(amount)) {
	                return amount;
	            }
	            var currencySymbol,
	                config = app.metadata.getConfig();
	            // default to base currency
	            currencyId = currencyId || this.getBaseCurrencyId();
	            symbolSeparator = symbolSeparator || '';
	            // use reasonable defaults if none exist
	            if (!_.isFinite(decimalPrecision)) {
	                if (_.isFinite(config.defaultCurrencySignificantDigits)) {
	                    decimalPrecision = config.defaultCurrencySignificantDigits;
	                } else {
	                    decimalPrecision = 2;
	                }
	            }
	
	            decimalSeparator = decimalSeparator || config.defaultDecimalSeparator || '.';
	            // if the numberGroupingSeparator is truly undefined we need to get the defaults, if it's an empty string
	            // we need to use the empty string as it's a valid value.
	            numberGroupingSeparator = !_.isUndefined(numberGroupingSeparator) ? numberGroupingSeparator : config.defaultNumberGroupingSeparator || ',';
	
	            currencySymbol = this.getCurrencySymbol(currencyId) || this.getCurrencySymbol(this.getBaseCurrencyId());
	            amount = app.utils.formatNumber(amount, decimalPrecision, decimalPrecision, numberGroupingSeparator, decimalSeparator);
	            return currencySymbol + symbolSeparator + amount;
	        },
	        /**
	         * Format currency amount to current user locale
	         * @param {Number}  amount
	         * @param {String}  currencyId (optional) the currency id to be used.
	         * If not specified, the system default will be used.
	         * @param {String}  decimalPrecision (optional) number of digits for
	         * decimal. If not specified, the user preference will be used.
	         * @return {String} formatted currency amount
	         */
	        formatAmountLocale: function formatAmountLocale(amount, currencyId, decimalPrecision) {
	            // get user preferred formatting
	            var decimalSeparator = app.user.getPreference('decimal_separator');
	            var numberGroupingSeparator = app.user.getPreference('number_grouping_separator');
	            decimalPrecision = _.isFinite(decimalPrecision) ? decimalPrecision : app.user.getPreference('decimal_precision');
	            return this.formatAmount(amount, currencyId, decimalPrecision, numberGroupingSeparator, decimalSeparator);
	        },
	        /**
	         * Unformat currency amount
	         * @param {Number}  amount
	         * @param {String}  numberGroupingSeparator string between thousands
	         * @param {String}  decimalSeparator string between number and decimals
	         * @param {Boolean} toFloat convert string to float value
	         * @return {String} formatted currency amount
	         */
	        unformatAmount: function unformatAmount(amount, numberGroupingSeparator, decimalSeparator, toFloat) {
	            toFloat = toFloat || false;
	            // strip off currency symbol, or anything prefixed that is not a digit or separator
	            amount = amount.toString().replace(/^[^\d\.\,-]+/, '');
	            return app.utils.unformatNumberString(amount, numberGroupingSeparator, decimalSeparator, toFloat);
	        },
	        /**
	         * Unformat currency amount with user locale
	         * @param {Number}  amount
	         * @param {Boolean} toFloat convert string to float value
	         * @return {String} formatted currency amount
	         */
	        unformatAmountLocale: function unformatAmountLocale(amount, toFloat) {
	            var decimalSeparator,
	                numberGroupingSeparator,
	                config = app.metadata.getConfig();
	            // use user locale or reasonable defaults
	            decimalSeparator = app.user.getPreference('decimal_separator') || config.defaultDecimalSeparator || '.';
	            numberGroupingSeparator = app.user.getPreference('number_grouping_separator') || config.defaultNumberGroupingSeparator || ',';
	            return this.unformatAmount(amount, numberGroupingSeparator, decimalSeparator, toFloat);
	        },
	        /**
	         * convert a currency from one to another
	         *
	         * @param  {Number|String} amount
	         * @param  {String} fromId source currency id
	         * @param  {String} toId target currency id
	         * @return {String} converted amount
	         */
	        convertAmount: function convertAmount(amount, fromId, toId) {
	            var currency1;
	            var currency2;
	            if (fromId == toId) {
	                return app.math.round(amount, undefined, true);
	            }
	            currency1 = app.metadata.getCurrency(fromId);
	            currency2 = app.metadata.getCurrency(toId);
	            return this.convertWithRate(amount, currency1.conversion_rate, currency2.conversion_rate);
	        },
	        /**
	         * convert a currency to base currency
	         *
	         * @param  {Number|String} amount
	         * @param  {String} fromId source currency id
	         * @return {String} converted amount
	         */
	        convertToBase: function convertToBase(amount, fromId) {
	            return this.convertAmount(amount, fromId, this.getBaseCurrencyId());
	        },
	        /**
	         * convert base currency to another currency
	         *
	         * @param  {Number|String} amount
	         * @param  {String} toId target currency id
	         * @return {String} converted amount
	         */
	        convertFromBase: function convertFromBase(amount, toId) {
	            return this.convertAmount(amount, this.getBaseCurrencyId(), toId);
	        },
	        /**
	         * convert a currency with given conversion rate
	         *
	         * @param  {Number|String} amount
	         * @param  {Number} fromRate the origin conversion rate
	         * @param  {Number} toRate the target conversion rate
	         * @return {String} converted amount
	         */
	        convertWithRate: function convertWithRate(amount, fromRate, toRate) {
	            fromRate = fromRate || 1.0;
	            toRate = toRate || 1.0;
	            return app.math.mul(app.math.div(amount, fromRate, undefined, true), toRate, undefined, true);
	        }
	
	    }, false);
	})(SUGAR.App);

/***/ },
/* 36 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	
	    /**
	     * Regular expression used to split event strings.
	     *
	     * @private
	     * @type {RegExp}
	     */
	    var eventSplitter = /\s+/;
	
	    /**
	     * Events API used to process various event actions and handle inputs such
	     * as event maps and space-separated event names.
	     *
	     * This is taken from the Backbone.js library to simplify event-handling.
	     *
	     * @private
	     * @type {Function}
	     * @param {Object} obj Scope in which the `action` will be executed.
	     * @param {string} action The function being executed (e.g. 'triggerBefore')
	     * @param {string|Object} name Event(s) to trigger before. Accepts
	     *   multiple space-separated event names, or an event map.
	     * @param {Array} [rest] List of arguments to be passed to the before event.
	     * @return {boolean} `false` if an event map or space-separated event names
	     *   were used, `true` otherwise.
	     */
	    var eventsApi = function eventsApi(obj, action, name, rest) {
	        if (!name) return true;
	
	        // Handle event maps.
	        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	            for (var key in name) {
	                obj[action].apply(obj, [key, name[key]].concat(rest));
	            }
	            return false;
	        }
	
	        // Handle space separated event names.
	        if (eventSplitter.test(name)) {
	            var names = name.split(eventSplitter);
	            for (var i = 0, l = names.length; i < l; i++) {
	                obj[action].apply(obj, [names[i]].concat(rest));
	            }
	            return false;
	        }
	
	        return true;
	    };
	
	    /**
	     * An optimized event-triggering method used to speed up common event calls
	     * with 1, 2, or 3 arguments. Prevents the event from triggering if any
	     * provided before callback returns `false`.
	     *
	     * This is taken from the Backbone.js library to simplify event-dispatching.
	     *
	     * @private
	     * @type {Function}
	     * @param {Array} events The list of before event listeners.
	     * @param {Array} [args] Arguments passed to the before event callback.
	     * @return {boolean} `true` if the before event should be triggered, `false`
	     *   otherwise.
	     */
	    var triggerEvents = function triggerEvents(events, args) {
	        var stop = false;
	        var ev,
	            i = -1,
	            l = events.length;
	        switch (args.length) {
	            case 0:
	            case 1:
	            case 2:
	            case 3:
	                while (++i < l) {
	                    stop = (ev = events[i]).callback.call(ev.ctx, args[0], args[1], args[2]) === false || stop;
	                }break;
	            default:
	                while (++i < l) {
	                    stop = (ev = events[i]).callback.apply(ev.ctx, args) === false || stop;
	                }}
	        return !stop;
	    };
	
	    /**
	     * @class Core.BeforeEvent
	     * @alias SUGAR.App.beforeEvent
	     * @singleton
	     */
	    _.extend(app, {
	        'beforeEvent': {
	            /**
	             * Adds a callback/hook to be fired before an action is taken. If
	             * that callback returns false, the action will not be taken. The
	             * only action supported in the base component is `render`.
	             *
	             * The following example binds a callback function and passes
	             * the scope from the view component to use in that callback:
	             *
	             *     model.before('save', this.doSomethingBeforeSave, this);
	             *
	             * Multiple space-separated event names can be bound to a single
	             * callback:
	             *
	             *     view.before('save dispose', this.callback, this);
	             *
	             * This method also supports an event map syntax, as an alternative
	             * to positional arguments:
	             *
	             *     this.before({
	             *         'render': this.doSomethingBeforeRender,
	             *         'dispose': this.doSomethingBeforeDispose
	             *     });
	             *
	             * @chainable
	             * @param {string|Object} name Event(s) to trigger before. Accepts
	             *   multiple space-separated event names, or an event map.
	             * @param {Function} callback Function to be called.
	             * @param {Object} [context] Value to be assigned to `this` when the
	             *   callback is fired.
	             * @return {Core.BeforeEvent} Instance of this class.
	             */
	            before: function before(name, callback, context) {
	                if (!eventsApi(this, 'before', name, [callback, context]) || !callback) {
	                    return this;
	                }
	
	                this._before = this._before || {};
	                var events = this._before[name] || (this._before[name] = []);
	
	                events.push({
	                    callback: callback,
	                    context: context,
	                    ctx: context || this
	                });
	                return this;
	            },
	
	            /**
	             * Triggers the before callback for the given event `name` or list
	             * of events.
	             *
	             * The following example triggers the callback bound to the before
	             * 'save' event given:
	             *
	             *     this.triggerBefore('save');
	             *
	             * Multiple events can be triggered as well:
	             *
	             *     this.triggerBefore('save render dispose');
	             *
	             * Custom arguments (e.g. `a`, `b`, `c`) can be passed to the
	             * callback:
	             *
	             *     this.triggerBefore('save', a, b, c);
	             *
	             * @param {string} name The event(s) to trigger before on.
	             * @return {boolean} Returns `true` if the event should be
	             *   triggered, `false` otherwise.
	             */
	            triggerBefore: function triggerBefore(name) {
	                var stop = false;
	                if (!this._before) {
	                    return !stop;
	                }
	                var args = Array.prototype.slice.call(arguments, 1);
	
	                // Handle space separated event names.
	                if (eventSplitter.test(name)) {
	                    var names = name.split(eventSplitter);
	                    for (var i = 0, l = names.length; i < l; i++) {
	                        stop = !this.triggerBefore.apply(this, [names[i]].concat(args)) || stop;
	                    }
	                    return !stop;
	                }
	
	                var events = this._before[name];
	                var allEvents = this._before.all;
	                if (events) {
	                    stop = triggerEvents(events, args) === false;
	                }
	                if (allEvents) {
	                    stop = triggerEvents(allEvents, args) === false || stop;
	                }
	                return !stop;
	            },
	
	            /**
	             * Remove a previously-bound callback function from a before event.
	             *
	             * If no context is given, all of the versions of the callback with
	             * different contexts will be removed:
	             *
	             *     this.offBefore('render', this.onRenderBefore);
	             *
	             * If no callback is given, all callbacks for the before event will
	             * be removed:
	             *
	             *     this.offBefore('render');
	             *
	             * If no event is specified, all callbacks for all before events
	             * will be removed from the object (similar to the Backbone.js `off`
	             * event):
	             *
	             *     this.offBefore();
	             *
	             * This is taken from the Backbone.js library to simplify
	             * event-handling.
	             *
	             * @chainable
	             * @param {string} [name] Event(s) to remove the listeners for.
	             * @param {Function} [callback] Callback to remove specifically for
	             *   a given event.
	             * @param {Object} [context] Context to use when determining which
	             *   callback to remove.
	             * @return {Core.BeforeEvent} Instance of this class.
	             */
	            offBefore: function offBefore(name, callback, context) {
	                var retain, ev, events, names, i, l, j, k;
	                if (!this._before || !eventsApi(this, 'offBefore', name, [callback, context])) {
	                    return this;
	                }
	                if (!name && !callback && !context) {
	                    this._before = void 0;
	                    return this;
	                }
	                names = name ? [name] : _.keys(this._before);
	                for (i = 0, l = names.length; i < l; i++) {
	                    name = names[i];
	                    events = this._before[name];
	                    if (events) {
	                        this._before[name] = retain = [];
	                        if (callback || context) {
	                            for (j = 0, k = events.length; j < k; j++) {
	                                ev = events[j];
	                                if (callback && callback !== ev.callback || context && context !== ev.ctx) {
	                                    retain.push(ev);
	                                }
	                            }
	                        }
	                        if (!retain.length) {
	                            delete this._before[name];
	                        }
	                    }
	                }
	                return this;
	            }
	        }
	    });
	})(SUGAR.App);

/***/ },
/* 37 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	
	/**
	 * Persistent cache manager.
	 *
	 * By default, cache manager uses store.js to manipulate items in `window.localStorage` object.
	 * Use {@link Core.CacheManager#store} property to override the storage provider.
	 * The value of the key which is passed as a parameter to `get/set/add` methods is prefixed with
	 * `<env>:<appId>:` string to avoid clashes with other environments and applications running off the same domain name and port.
	 * You can set environment and application ID in {@link Config} module.
	 *
	 * @class Core.CacheManager
	 * @singleton
	 * @alias SUGAR.App.cache
	 */
	(function (app) {
	
	    var keyPrefix = '';
	
	    var buildKey = function buildKey(key) {
	        return keyPrefix + key;
	    };
	
	    var sugarStore = _.extend({}, store, {
	        // make store compatible with stash
	        cut: store.remove,
	        cutAll: store.clear
	    });
	
	    /**
	     * Helper method used by migrateOldKeys for removing quotes from previous localStorage library.
	     *
	     * @private
	     */
	    var unquote = function unquote(str) {
	        return new Function('return ' + str)();
	    }; // jshint ignore:line
	
	    /**
	     * Attempts to migrate values from Stash to Store.
	     *
	     * `stash.js` used to set values with single quotes in the `localStorage`.
	     * `store.js` uses double quotes (standard JSON encode/decode(. Hence, we
	     * need to update current values in localStorage to be complaint with the
	     * new store.
	     *
	     * @param {Object} cache Cache object to work on.
	     * @private
	     */
	    var migrateStorage = function migrateStorage(cache) {
	
	        if (cache.has('uniqueKey')) {
	            return;
	        }
	
	        // We need to clone the local storage to not mess up with it during the
	        // iterations.
	        var store = {};
	        for (var i = 0, len = localStorage.length; i < len; i++) {
	            var key = localStorage.key(i);
	            store[key] = localStorage[key];
	        }
	
	        _.each(store, function (value, key) {
	            try {
	                JSON.parse(value);
	                value = cache.store.deserialize(value);
	            } catch (e) {
	                value = unquote(value);
	            }
	
	            if (value === null) {
	                value = undefined;
	            }
	
	            cache.store.set(key, value);
	        });
	
	        cache.set('uniqueKey', app.config.uniqueKey);
	    };
	
	    var cache = {
	
	        /**
	         * Storage provider.
	         *
	         * Default: store.js
	         *
	         * @cfg {Object}
	         */
	        store: sugarStore,
	
	        /**
	         * Initializes cache manager.
	         */
	        init: function init() {
	            keyPrefix = app.config.env + ':' + app.config.appId + ':';
	
	            migrateStorage(this);
	
	            if (this.get('uniqueKey') !== app.config.uniqueKey) {
	                // do not leak information to other instances
	                this.cutAll(true);
	                this.set('uniqueKey', app.config.uniqueKey);
	            }
	
	            app.events.register('cache:clean', this);
	        },
	
	        /**
	         * Checks if the item exists in cache.
	         * @param {String} key Item key.
	         */
	        has: function has(key) {
	            return this.store.has(buildKey(key));
	        },
	
	        /**
	         * Gets an item from the cache.
	         * @param {string} key Item key.
	         * @return {number|boolean|string|Array|Object} Item with the given key.
	         */
	        get: function get(key) {
	            return this.store.get(buildKey(key));
	        },
	
	        /**
	         * Puts an item into cache.
	         * @param {string} key Item key.
	         * @param {number|boolean|string|Array|Object} value Item to put.
	         */
	        set: function set(key, value) {
	            key = buildKey(key);
	
	            try {
	                this.store.set(key, value);
	            } catch (e) {
	                if (e.name.toLowerCase().indexOf('quota') > -1) {
	                    //Localstorage is full, the app needs to handle this.
	                    this.clean();
	                    this.store.set(key, value);
	                }
	            }
	        },
	
	        /**
	         * Remove non-critical values to free up space. Should be called whenever local storage quota is exceeded.
	         * Listen for the clean event (passes callback as argument) in order to register keys to preserve after clean.
	         *
	         * Keys that are not vital should not be presvered during a cleanup.
	         * Ex.
	         * <pre><code>
	         * ({
	         *     initialize: function(options) {
	         *         app.events.on('cache:clean', function(callback) {
	         *             callback([
	         *                 'my_important_cache_key',
	         *                 'my_other_important_key',
	         *             ])
	         *         });
	         *     },
	         * });
	         * </code></pre>
	         */
	        clean: function clean() {
	            var preserveKeys = [],
	                preservedValues = {};
	
	            //First get a list of all keys to keep
	            this.trigger('cache:clean', function (keys) {
	                preserveKeys = _.union(keys, preserveKeys);
	            });
	            //Now get those values
	            _.each(preserveKeys, function (key) {
	                preservedValues[key] = this.get(key);
	            }, this);
	            //nuke all the keys we own
	            this.cutAll();
	
	            //restore any vital values
	            _.each(preservedValues, function (value, key) {
	                if (!_.isUndefined(value)) {
	                    this.set(key, value);
	                }
	            }, this);
	        },
	
	        /**
	         * Deletes an item from cache.
	         * @param {String} key Item key.
	         */
	        cut: function cut(key) {
	            key = buildKey(key);
	            if (this.store.has(key)) {
	                this.store.cut(key);
	            }
	        },
	
	        /**
	         * Deletes all items from cache.
	         *
	         * By default, this method deletes all items for the current app and environment.
	         * Pass `true` to this method to remove all items.
	         * @param {Boolean} all(optional) Flag indicating if all items must be deleted from this cache.
	         */
	        cutAll: function cutAll(all) {
	            if (all === true) {
	                return this.store.cutAll();
	            }
	
	            var obj = this.store.getAll();
	            _.each(obj, function (value, key) {
	                if (key.indexOf(keyPrefix) === 0) {
	                    this.store.cut(key);
	                }
	            }, this);
	        }
	    };
	
	    //Use eventing for cache cleaning
	    _.extend(cache, Backbone.Events);
	
	    app.augment('cache', cache);
	})(SUGAR.App);

/***/ },
/* 38 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * Cookie storage for authentication data.
	 *
	 * @class Core.CookieManager
	 * @singleton
	 * @alias SUGAR.App.cookie
	 */
	(function (app, location) {
	
	    var path = location.pathname.replace(/\/[^\/]*$/, "/cookie.html"),
	        getCookie = function getCookie() {
	        return {};
	    };
	
	    app.augment("cookie", {
	
	        initAsync: function initAsync(callback) {
	            var frame = document.createElement("iframe");
	            frame.style.display = "none";
	            frame.src = path;
	            document.body.appendChild(frame);
	
	            frame.contentWindow.onload = function () {
	                getCookie = function getCookie() {
	                    return frame.contentWindow.getCookie();
	                };
	                callback();
	            };
	        },
	
	        /**
	         * Checks if the item exists in storage.
	         * @param {String} key Item key.
	         * @return {Boolean} Whether the item exists in storage.
	         */
	        has: function has(key) {
	            return key in getCookie();
	        },
	
	        /**
	         * Gets an item from the storage.
	         * @param {String} key Item key.
	         * @return {String} Item with the given key.
	         */
	        get: function get(key) {
	            return getCookie()[key];
	        },
	
	        /**
	         * Puts an item into storage.
	         * @param {String} key Item key.
	         * @param {String} value Item to put.
	         */
	        set: function set(key, value) {
	            app.utils.cookie.setCookie(key, value, null, path);
	        },
	
	        /**
	         * Deletes an item from storage.
	         * @param {String} key Item key.
	         */
	        cut: function cut(key) {
	            app.utils.cookie.setCookie(key, "", -1, path);
	        }
	    });
	})(SUGAR.App, window.location);

/***/ },
/* 39 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	    /**
	     * Events proxy object. For inter-component communications, please register your events and please subscribe
	     * your events from the events hub. This allows components to not depend on each other in a tightly coupled capacity.
	     *
	     * <pre><code>
	     * (function(app) {
	     *   var foo = {
	     *     initialize: function() {
	     *         // Register the event with the events hub.
	     *         app.events.register("mynamespaced:event", this);
	     *     },
	     *     action: function() {
	     *         // Broadcast you revent to the events hub.
	     *         // The events hub will then broadcast this event to all its subscribers.
	     *         this.trigger("mynamespaced:event");
	     *     }
	     *   }
	     *
	     *   var bar = {
	     *     initialize: function() {
	     *         // Call a callback when the event is received.
	     *         app.events.on("mynamespaced:event", function() {
	     *             alert("Event!");
	     *         });
	     *     }
	     *   }
	     *
	     * })(SUGAR.App);
	     * </pre></code>
	     *
	     * @class Core.Events
	     * @alias SUGAR.App.events
	     * @singleton
	     */
	    app.augment('events', _.extend({}, Backbone.Events, {
	        /**
	         * List of deprecated events. A warning will be shown in console when a
	         * component is listening to them.
	         *
	         * @property {Object} _deprecated
	         * @property {string} [_deprecated.message] The custom deprecated message.
	         * @private
	         */
	        _deprecated: {},
	
	        /**
	         * Registers an event with the event proxy.
	         *
	         * @param {string} event The name of the event.
	         *   A good practice is to namespace your events with a colon.
	         *   For example: `app:start`.
	         * @param {Object} context The object that will trigger the event.
	         * @param {Object} [options] Optional params.
	         * @param {boolean} [options.deprecated=false] `true` if the event is
	         *   deprecated.
	         * @param {string} [options.message] The deprecated message to log. A
	         *   default message will be triggered if not defined.
	         */
	        register: function register(event, context, options) {
	            if (options && options.deprecated) {
	                this._deprecated[event] = _.pick(options, 'message');
	            }
	
	            context.on(event, function () {
	                var args = [].slice.call(arguments, 0);
	                args.unshift(event);
	                this.trigger.apply(this, args);
	            }, this);
	        },
	
	        /**
	         * Unregisters an event from the event proxy.
	         *
	         * @param {Object} context Source to be cleared from.
	         * @param {string} [event] Event name to be cleared.
	         * @method
	         */
	        unregister: function unregister(context, event) {
	            context.off(event);
	        },
	
	        /**
	         * Subscribe to global ajax events.
	         */
	        registerAjaxEvents: function registerAjaxEvents() {
	            var self = this;
	
	            // First unbind then rebind
	            $(document).off("ajaxStop");
	            $(document).off("ajaxStart");
	
	            $(document).on("ajaxStart", function (args) {
	                self.trigger("ajaxStart", args);
	            });
	
	            $(document).on("ajaxStop", function (args) {
	                self.trigger("ajaxStop", args);
	            });
	        },
	
	        /**
	         * Wraps [Backbone.Events#on](http://backbonejs.org/#Events-on) method
	         * to throw a warning if the event listened to is deprecated.
	         */
	        on: _.wrap(Backbone.Events.on, function (fn, name, callback, context) {
	
	            if (_.has(this._deprecated, name)) {
	                var warnMessage;
	                if (this._deprecated[name].message) {
	                    warnMessage = this._deprecated[name].message;
	                } else {
	                    warnMessage = 'The global event `' + name + '` is deprecated.';
	                }
	
	                if (context) {
	                    warnMessage += '\n' + context + ' should not listen to it anymore.';
	                }
	
	                app.logger.warn(warnMessage);
	            }
	
	            return fn.call(this, name, callback, context);
	        })
	    }));
	})(SUGAR.App);

/***/ },
/* 40 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	
	    /**
	    * Error handling module.
	     *
	    * @class Core.Error
	    * @singleton
	    */
	    var module = {
	
	        init: function init() {
	            this.initialize();
	        },
	
	        /**
	         * Setups the params for error module
	         * @param opts
	         */
	        initialize: function initialize(opts) {
	            opts = opts || {};
	
	            /**
	             * Set to true to enable remote logging to server [NOT IMPLEMENTED]
	             * @cfg {Boolean}
	             */
	            this.remoteLogging = opts.remoteLogging || false;
	
	            /**
	             * Inject a hash of status code handlers to override defaults
	             * @cfg {Object}
	             */
	            this.statusCodes = opts.statusCodes ? _.extend(this.statusCodes, opts.statusCodes) : this.statusCodes;
	
	            /**
	             * Set to true to disable onError overloading
	             * @cfg {Boolean} disableOnError
	             */
	            if (!opts.disableOnError) {
	                this.enableOnError();
	            }
	        },
	
	        // This attempts to call function fn (which may not exist), otherwise,
	        // falls back to handleStatusCodesFallback.
	        _callCustomHandler: function _callCustomHandler(error, fn, params) {
	            if (fn) {
	                fn.apply(this, _.union([error], params || []));
	            } else {
	                this.handleStatusCodesFallback(error);
	            }
	        },
	
	        /**
	         * Authentication error.
	         *
	         * OAuth2 uses 400 as a sort of catch all; see:
	         * http://tools.ietf.org/html/draft-ietf-oauth-v2-20#section-5.2
	         *
	         * Provide the following custom handlers:
	         *
	         * **handleInvalidGrantError**
	         *
	         * The provided authorization grant is invalid, expired, revoked, does
	         * not match the redirection URI used in the authorization request, or
	         * was issued to another client. Note that the server implementation
	         * will override invalid_grant as needs_login as a special case (see below).
	         *
	         * **handleNeedLoginError**
	         *
	         * The server shall use this in place of invalid_grant to tell client to handle
	         * error specifically as caused due to invalid credentials being supplied. The
	         * reason server needs to use this is because an invalid_grant oauth error may
	         * also be caused by invalid or expired token. Using needs_login allows all
	         * clients to provide proper messaging to end user without the need for extra logic.
	         *
	         * **handleInvalidClientError**
	         *
	         * Client authentication failed (e.g. unknown client, no client
	         * authentication included, multiple client authentications included,
	         * or unsupported authentication method).
	         *
	         * **handleInvalidRequestError**
	         *
	         * The request is missing a required parameter, includes an unsupported
	         * parameter or parameter value, repeats a parameter, includes multiple
	         * credentials, utilizes more than one mechanism for authenticating the
	         * client, or is otherwise malformed.
	         *
	         * **handleUnauthorizedClientError**
	         *
	         * The authenticated client is not authorized to use this authorization grant type.
	         *
	         * **handleUnsupportedGrantTypeError**
	         *
	         * The authorization grant type is not supported by the authorization server.
	         *
	         * **handleInvalidScopeError**
	         *
	         * The requested scope is invalid, unknown, malformed, or exceeds the scope granted by the resource owner.
	         *
	         *
	         * @param {SUGAR.HttpError} error HTTP error.
	         * @param {Function} alternativeCallback(optional) If this does not match an expected oauth error than this callback will be
	         * called (if provided).
	         * @method
	         * @private
	         */
	        _handleFineGrainedError: function _handleFineGrainedError(error, alternativeCallback) {
	            var handlerName = 'handle' + app.utils.classify(error.code) + 'Error';
	            (this[handlerName] || alternativeCallback || this.handleStatusCodesFallback).call(this, error);
	        },
	
	        /**
	         * An object of status code error handlers. If custom handler is defined by extending
	         * module, corresponding status code handler will attempt to use that, otherwise,
	         * handleStatusCodesFallback is used as a fallback just logging the error.
	         *
	         * @class Core.Error.statusCodes
	         * @member Core.Error
	         * @singleton
	         */
	        statusCodes: {
	            '0': function _(error, model, options) {
	                if (error.textStatus === 'timeout') {
	                    this._callCustomHandler(error, this.handleTimeoutError);
	                } else {
	                    // TODO: Need invalid url, and any other possible status: 0 conditions
	                    this.handleStatusCodesFallback(error, model, options);
	                }
	            },
	
	            /**
	             * Authentication or bad request error.
	             *
	             * Since oauth server implementation might throw 401 (as well as 400)
	             * we route this to the {@link Core.Error#_handleFineGrainedError}.
	             * If no match for oauth error then handleOAuthError will try to use
	             * handleInvalidRequestError if supplied.
	             *
	             * Provide custom `handleInvalidRequestError` handler.
	             * @method
	             */
	            '400': function _(error) {
	                this._handleFineGrainedError(error, this.handleUnspecified400Error);
	            },
	
	            /**
	             * Unauthorized.
	             *
	             * Since oauth server implementation might throw 401 (as well as 400)
	             * we route this to the {@link Core.Error#_handleFineGrainedError}.
	             * If no match for oauth error then handleOAuthError will try to use
	             * handleUnauthorizedError if supplied.
	             *
	             * Provide custom `handleUnauthorizedError` handler.
	             * @method
	             */
	            '401': function _(error) {
	                this._handleFineGrainedError(error, this.handleUnauthorizedError);
	            },
	
	            /**
	             * Forbidden.
	             *
	             * Provide custom `handleForbiddenError` handler.
	             * @method
	             */
	            '403': function _(error) {
	                this._callCustomHandler(error, this.handleForbiddenError);
	            },
	
	            /**
	             * Not found.
	             *
	             * Provide custom `handleNotFoundError` handler.
	             * @method
	             */
	            '404': function (_2) {
	                function _(_x) {
	                    return _2.apply(this, arguments);
	                }
	
	                _.toString = function () {
	                    return _2.toString();
	                };
	
	                return _;
	            }(function (error) {
	                this._callCustomHandler(error, this.handleNotFoundError, _.rest(arguments));
	            }),
	
	            /**
	             * Method not allowed.
	             *
	             * Provide custom `handleMethodNotAllowedError` handler.
	             * @method
	             */
	            '405': function _(error) {
	                this._callCustomHandler(error, this.handleMethodNotAllowedError);
	            },
	
	            /**
	             * Conflict.
	             *
	             * Provide custom `handleMethodConflictError` handler.
	             * @method
	             */
	            '409': function _(error) {
	                this._callCustomHandler(error, this.handleMethodConflictError);
	            },
	
	            /**
	             * Precondition failed.
	             *
	             * Provide custom `handleHeaderPreconditionFailed` handler.
	             * @method
	             */
	            '412': function _(error) {
	                this._callCustomHandler(error, this.handleHeaderPreconditionFailed);
	            },
	
	            /**
	             * Precondition failure.
	             *
	             * Clients can optionally sniff the error property in JSON for finer grained
	             * determination; the following values may be:
	             * missing_parameter, invalid_parameter
	             *
	             * Provide custom `handleValidationError` handler.
	             * @method
	             */
	            '422': function (_3) {
	                function _(_x2, _x3) {
	                    return _3.apply(this, arguments);
	                }
	
	                _.toString = function () {
	                    return _3.toString();
	                };
	
	                return _;
	            }(function (error, model) {
	                error.model = model;
	                this._callCustomHandler(error, this.handleValidationError, _.rest(arguments));
	            }),
	
	            /**
	             * Request Method Failure
	             * Provide custom `handleMethodFailureError` handler.
	             * @method
	             */
	            '424': function (_4) {
	                function _(_x4, _x5) {
	                    return _4.apply(this, arguments);
	                }
	
	                _.toString = function () {
	                    return _4.toString();
	                };
	
	                return _;
	            }(function (error, model) {
	                error.model = model;
	                this._callCustomHandler(error, this.handleMethodFailureError, _.rest(arguments));
	            }),
	
	            /**
	             * Internal server error
	             *
	             * Provide custom `handleServerError` handler.
	             * @method
	             */
	            '500': function _(error) {
	                this._callCustomHandler(error, this.handleServerError);
	            },
	
	            /**
	             * Bad Gateway
	             *
	             * Provide custom `handleServerError` handler.
	             * @method
	             */
	            '502': function _(error) {
	                this._callCustomHandler(error, this.handleServerError);
	            },
	
	            /**
	             * Service Unavailable
	             *
	             * Provide custom `handleServerError` handler.
	             * @method
	             */
	            '503': function _(error) {
	                this._callCustomHandler(error, this.handleServerError);
	            }
	        },
	
	        remoteLogging: false,
	
	        /**
	         * Maps validator names to error labels.
	         * @member Core.Error
	         */
	        errorName2Keys: {
	            'maxValue': 'ERROR_MAXVALUE',
	            'minValue': 'ERROR_MINVALUE',
	            'maxLength': 'ERROR_MAX_FIELD_LENGTH',
	            'minLength': 'ERROR_MIN_FIELD_LENGTH',
	            'datetime': 'ERROR_DATETIME',
	            'required': 'ERROR_FIELD_REQUIRED',
	            'email': 'ERROR_EMAIL',
	            'primaryEmail': 'ERROR_PRIMARY_EMAIL',
	            'duplicateEmail': 'ERROR_DUPLICATE_EMAIL',
	            'number': 'ERROR_NUMBER',
	            'isBefore': 'ERROR_IS_BEFORE',
	            'isAfter': 'ERROR_IS_AFTER',
	            'greaterThan': 'ERROR_IS_GREATER_THAN',
	            'lessThan': 'ERROR_IS_LESS_THAN'
	        },
	
	        /**
	         * Returns error strings given a error key and context
	         * @param errorKey
	         * @param context
	         * @member Core.Error
	         */
	        getErrorString: function getErrorString(errorKey, context) {
	            var module = context.module || '';
	            return app.lang.get(this.errorName2Keys[errorKey] || errorKey, module, context);
	        },
	
	        /**
	         * Handles validation errors. By default this just pipes the error to the
	         * error logger.
	         * @param {SUGAR.HttpError} error AJAX error.
	         * @member Core.Error
	         */
	        handleValidationError: function handleValidationError(error) {
	            var errors = error.responseText;
	            // TODO: Right now doesn't stringify the error, add it in when we finalize the
	            // structure of the error.
	
	            // TODO: Likely, we'll have a 'Saving...' alert, etc., and so we just dismiss all
	            // since we don't know the alert key. Ostensibly, validation errors will show
	            // field by field; so feedback will be provided as appropriate.
	            app.alert.dismissAll();
	
	            _.each(errors, function (fieldError, key) {
	                var errorMsg = '';
	                if (_.isObject(fieldError)) {
	                    _.each(fieldError, function (result, fieldName) {
	                        errorMsg += '(Message) ' + this.getErrorString(fieldName, result) + '\n';
	                    }, this);
	                } else {
	                    errorMsg = fieldError;
	                }
	                app.logger.debug("validation failed for field `" + key + "`:\n" + errorMsg);
	            }, this);
	        },
	
	        /**
	         * Handles http errors returned from AJAX calls.
	         * @param {SUGAR.HttpError} error AJAX error.
	         * @param {Backbone.Model} model(optional) Instance of the model for which the request was made.
	         * @member Core.Error
	         */
	        handleHttpError: function handleHttpError(error, model, options) {
	            // If we have a handler defined for this status code
	            // The context may not be correct for the handler so use app.error instead of this.
	            if (app.error.statusCodes[error.status]) {
	                app.error.statusCodes[error.status].call(app.error, error, model, options);
	            } else {
	                // TODO: Default catch all error code handler
	                // Temporarily going to the handleStatusCodesFallback handler but will probably need
	                // to go to a sensible "all other errors" type of handler.
	                app.error.handleStatusCodesFallback(error);
	            }
	        },
	
	        /**
	         * Handles unhandled javascript exceptions which are reported via `window.onerror` event.
	         *
	         * The default implementation logs the error with level `FATAL`.
	         * Consider such exceptions as fatal application errors that should never happen :)
	         * @param {String} message Error message
	         * @param {String} url URL of script
	         * @param {String} line Line number of script
	         * @member Core.Error
	         */
	        handleUnhandledError: function handleUnhandledError(message, url, line) {
	            app.logger.fatal(message + ' at ' + url + ' on line ' + line);
	        },
	
	        /**
	         * This is the fallback error handler if custom status code specific handler
	         * not provided in application specific error handler. To define custom error
	         * handlers, you should include your script from index page and do something like:
	         * <pre><code>
	         * (function(app) {
	         *
	         *     app.error = _.extend(app.error, {
	         *        // put your custom handlers here.
	         *        handleUnauthorizedError: function(error) {
	         *        },
	         *
	         *        ...
	         *     });
	         *
	         * })(SUGAR.App);
	         * </pre></code>
	         *
	         * @param {String} error Ajax error.
	         * @member Core.Error
	         */
	        handleStatusCodesFallback: function handleStatusCodesFallback(error) {
	            app.logger.error(error.toString());
	        },
	
	        /**
	         * Handles render related errors.
	         * @param {String} component The reference to calling view's this
	         * @param {String} method The method that caught the error e.g. _renderHtml
	         * @param {String} additionalInfo(optional) Any additional information required for the particular method that called. E.g. the field for _renderField.
	         * @member Core.Error
	         */
	        handleRenderError: function handleRenderError(component, method, additionalInfo) {
	            var id = 'render_error_' + component.module + '_' + component.name;
	            var level = 'error'; //Default message level
	            var title, messages;
	            // TODO: Add corresponding language agnostic app strings for title/message and use that instead.
	            switch (method) {
	                case '_renderHtml':
	                    title = app.lang.get('ERR_RENDER_FAILED_TITLE');
	                    messages = [app.lang.get('ERR_RENDER_FAILED_MSG'), app.lang.get('ERR_CONTACT_TECH_SUPPORT')];
	                    break;
	                case '_renderField':
	                    title = app.lang.get('ERR_RENDER_FIELD_FAILED_TITLE');
	                    messages = [app.utils.formatString(app.lang.get('ERR_RENDER_FIELD_FAILED_MSG'), [additionalInfo.name]), app.lang.get('ERR_CONTACT_TECH_SUPPORT')];
	                    break;
	                case 'view_render_denied':
	                    title = app.lang.get('ERR_NO_VIEW_ACCESS_TITLE');
	                    level = 'warning'; // This isn't an application error, this is ACL enforcement.
	                    var module = app.lang.getModuleName(component.module, { plural: true });
	                    messages = [app.utils.formatString(app.lang.get('ERR_NO_VIEW_ACCESS_MSG'), [module])];
	                    break;
	                case 'layout_render':
	                    title = app.lang.get('ERR_LAYOUT_RENDER_TITLE');
	                    messages = [app.lang.get('ERR_LAYOUT_RENDER_MSG')];
	                    break;
	                default:
	                    // This shouldn't happen
	                    title = app.lang.get('ERR_GENERIC_TITLE');
	                    messages = [app.lang.get('ERR_INTERNAL_ERR_MSG'), app.lang.get('ERR_CONTACT_TECH_SUPPORT')];
	                    app.logger.error('handleRenderError called for render error caught in ' + method + ', but we have no corresponding handler!');
	                    break;
	            }
	
	            app.alert.show(id, {
	                level: level,
	                title: title,
	                messages: messages
	            });
	        },
	
	        /**
	         * Overloads the window.onerror catch all function. Calls the original if any while
	         * adding the framework's custom error handling logic. Pass in a custom callback to
	         * add additional error handling.
	         * @param {Function} handler Callback function to call on error.
	         * @param {Object} context Scope of the callback
	         * @return {Boolean} False if onerror has already been overloaded.
	         * @member Core.Error
	         */
	        enableOnError: function enableOnError(handler, context) {
	            var originalHandler;
	            var self = this;
	
	            if (this.overloaded) {
	                return false;
	            }
	
	            originalHandler = window.onerror;
	
	            window.onerror = function (mesg, url, line) {
	                if (handler) {
	                    handler.call(context);
	                } else {
	                    self.handleUnhandledError(mesg, url, line);
	                }
	
	                if (originalHandler) {
	                    originalHandler();
	                }
	            };
	
	            this.overloaded = true;
	
	            return true;
	        },
	
	        /**
	         * Inserts call stack string to Error message.
	         * `window.onerror` handler is not provided with Error object
	         * (4th argument) [in Safari][1].
	         *
	         * [1]: https://bugs.webkit.org/show_bug.cgi?id=55092
	         *
	         * @param {string|Error} error Error text or Error object.
	         * @param {boolean} [skipThrow=false] Pass `true` to skip exception
	         *   raising.
	         * @return {Error} Error object with stack trace inserted into
	         *   `Error.message` property.
	         */
	        throwErrorWithCallStack: function throwErrorWithCallStack(error, skipThrow) {
	            if (_.isString(error)) {
	                error = new Error(error);
	            }
	            error.message = error.message + '; ' + error.stack;
	
	            if (skipThrow) {
	                return error;
	            }
	
	            throw error;
	        }
	    };
	
	    // We don't want to initialize error handling immediately,
	    // because the handler may use code that has not been initialized yet
	    app.augment('error', module, false);
	})(SUGAR.App);

/***/ },
/* 41 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	    //Pull the precompile header and footer from the node precompile implementation for handlebars
	    var _header = "(function() {\n  var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};\n",
	        _footer = '})();',
	        _templates = {},
	        _sources = {},
	        _templateManager;
	
	    /**
	     * Manages Handlebars templates.
	     *
	     * @class View.TemplateManager
	     * @alias SUGAR.App.template
	     * @singleton
	     */
	    _templateManager = {
	
	        /**
	         * Loads templates from local storage and populates `Handlebars.templates` collection.
	         */
	        init: function init() {
	            _templates = app.config.cacheMeta ? app.cache.get('templates') || {} : {};
	            var src = '';
	            _.each(_templates, function (t) {
	                src += t;
	            });
	
	            try {
	                eval(_header + src + _footer); // jshint ignore:line
	            } catch (e) {
	                app.logger.error('Failed to eval templates retrieved from local storage:\n' + e);
	                // TODO: Trigger app:error event
	            }
	        },
	
	        /**
	         * Used to register a template src without compiling the template yet.
	         * The template will be compiled the first time it is used (requested
	         * with getView/getLayout/getField).
	         *
	         * @param {Array} tpl The template as `[key, compiled]` pair.
	         * @param {string} src The template content (.hbs file).
	         * @param {boolean} [force=false] `true` to force recompilation on it.
	         * @private
	         */
	        _add: function _add(tpl, src, force) {
	            var key = tpl[0],
	                loaded = this.get(key, false);
	            if (loaded && !force) {
	                return;
	            }
	            //If we have already loaded this template but with a different source, we need to mark it for recompilation
	            if (loaded && force && _sources[key] != src) {
	                _templates[key] = Handlebars.templates[key] = null;
	            }
	            _sources[key] = src;
	        },
	
	        /**
	         * Conditionally compiles a template.
	         * @param {Array} tpl First item is template key, the second is
	         *   compiled template.
	         * @param {string} src Template source code.
	         * @param {boolean} [force=false] Flag indicating if the template must
	         *   be re-compiled.
	         * @private
	         */
	        _compile: function _compile(tpl, src, force) {
	            Handlebars.templates = Handlebars.templates || {};
	            _templates[tpl[0]] = Handlebars.templates[tpl[0]] = force || !tpl[1] ? this.compile(tpl[0], src) : tpl[1];
	            return _templates[tpl[0]];
	        },
	
	        /**
	         * Compiles a template.
	         *
	         * This method puts the precompiled version of the template in cache
	         * and returns the compiled template. The template can be accessed
	         * directly via `Handlebars.templates[key]` statement.
	         *
	         * @param {string} key Template identifier.
	         * @param {string} src The actual template source to be compiled.
	         * @return {Function} Compiled template.
	         */
	        compile: function compile(key, src) {
	            try {
	                _templates[key] = "templates['" + key + "'] = template(" + Handlebars.precompile(src) + ");\n";
	                eval(_header + _templates[key] + _footer); // jshint ignore:line
	            } catch (e) {
	                // Invalid templates will cause a JS error when they either pre-compile or compile.
	                app.logger.error("Failed to compile or eval template " + key + ".\n" + e);
	            }
	            return this.get(key, false) || this.empty;
	        },
	
	        /**
	         * Retrieves a compiled handlebars template.
	         * @param {string} key Identifier of the template to be retrieved.
	         * @param {boolean} [compile=true] Force the template to compile if we
	         *   have uncompiled source.
	         * @return {Function} Compiled Handlebars template.
	         */
	        get: function get(key, compile) {
	            //Undefined should default to true for compiled (not passed means compile)
	            compile = _.isUndefined(compile) || compile;
	            if (compile && !Handlebars.templates[key] && _sources[key]) {
	                this._compile([key], _sources[key]);
	            }
	            return Handlebars.templates ? Handlebars.templates[key] : null;
	        },
	
	        // Convenience private method
	        _getView: function _getView(name, module, compile) {
	            var key = name + (module ? '.' + module : '');
	            return [key, this.get(key, compile)];
	        },
	
	        /**
	         * Gets compiled template for a view.
	         * @param {string} name View name.
	         * @param {string} module (optional) Module name.
	         * @return {Function} Compiled template.
	         */
	        getView: function getView(name, module) {
	            return this._getView(name, module, true)[1];
	        },
	
	        // Convenience private method
	        _getField: function _getField(type, view, module, fallbackTemplate, skipFallbacks, compile) {
	            var foundTemplate,
	                prefix = "f." + type + ".",
	                key = prefix + (module ? module + "." : "") + view;
	
	            module += ".";
	
	            // get the module specific one first, then try the base one for this view
	            foundTemplate = this.get(prefix + module + view, compile) || this.get(prefix + view, compile);
	            //skipfallbacks indicates we should only check for the requested field,
	            if (!foundTemplate && !skipFallbacks) {
	                foundTemplate = this.get(prefix + module + fallbackTemplate, compile) || this.get(prefix + fallbackTemplate, compile);
	                // If we got nothing for the requested fallback, use base as the last ditch fallback
	                if (!foundTemplate) {
	                    foundTemplate = this.get('f.base.' + view, compile) || this.get('f.base.' + fallbackTemplate, compile);
	                }
	            }
	            return [key, foundTemplate];
	        },
	
	        /**
	         * Gets compiled template for a field.
	         * @param {string} type Field type.
	         * @param {string} view View name.
	         * @param {string} module The Module where the field is from
	         * @param {boolean} [fallbackTemplate=true] Template name to fallback
	         *   to if template for `view` is not found. If view specific is not
	         *   found.
	         * @return {Function} Compiled template.
	         */
	        getField: function getField(type, view, module, fallbackTemplate) {
	            return this._getField(type, view, module, fallbackTemplate, false, true)[1];
	        },
	
	        // Convenience private method
	        _getLayout: function _getLayout(name, moduleName, compile) {
	            var key = 'l.' + (moduleName ? moduleName + '.' : '') + name;
	            return [key, this.get(key, compile)];
	        },
	
	        /**
	         * Gets compiled template for a layout.
	         * @param {string} [name] Layout name.
	         * @param {string} [moduleName] Module name.
	         * @return {Function} Compiled template.
	         */
	        getLayout: function getLayout(name, moduleName) {
	            return this._getLayout(name, moduleName, true)[1];
	        },
	
	        /**
	         * Compiles and puts into local storage a view template.
	         * @param {string} name View name.
	         * @param {string} module Module name.
	         * @param {string} src Template source code.
	         * @param {boolean} [force=false] Flag indicating if the template must
	         *   be re-compiled.
	         * @return {Function} Compiled template.
	         */
	        setView: function setView(name, module, src, force) {
	            return this._add(this._getView(name, module, false), src, force);
	        },
	
	        /**
	         * Compiles and puts into local storage a field template.
	         * @param {string} type Field type.
	         * @param {string} view View name.
	         * @param {string} module Module where field came from.
	         * @param {string} src Template source code.
	         * @param {boolean} [force=false] Flag indicating if the template must
	         *   be re-compiled.
	         * @return {Function} Compiled template.
	         */
	        setField: function setField(type, view, module, src, force) {
	            // Don't fall back to default template (false flag)
	            return this._add(this._getField(type, view, module, null, true, false), src, force);
	        },
	
	        /**
	         * Compiles and stores layout templates
	         * @param {string} name Layout Name.
	         * @param {string} [moduleName] Module Name.
	         * @param {string} src Raw template source.
	         * @param {boolean} [force=false] Flag indicating if the template must
	         *   be re-compiled.
	         * @return {Function} Compiled template
	         */
	        setLayout: function setLayout(name, moduleName, src, force) {
	            return this._add(this._getLayout(name, moduleName, false), src, force);
	        },
	
	        /**
	         * Registers view, layout, and field templates from metadata payload
	         * for later "lazy" on-demand compilation.
	         *
	         * The metadata must contain the following sections:
	         *
	         * <pre>
	         * {
	         *    // This should now be deprecated
	         *    "view_templates": {
	         *       "detail": HB template source,
	         *       "list": HB template source,
	         *       // etc.
	         *    },
	         *
	         *    "sugarFields": {
	         *        "text": {
	         *            "templates": {
	         *               "default": HB template source,
	         *               "detail": HB template source,
	         *               "edit": ...,
	         *               "list": ...
	         *            }
	         *        },
	         *        "bool": {
	         *           // templates for boolean field
	         *        },
	         *        // etc.
	         *    }
	         *
	         *    "views": {
	         *      "text": {
	         *          "templates" {
	         *              "view": HB template source...
	         *              "view2": HB template source..
	         *          }.
	         *    }
	         * }
	         * </pre>
	         *
	         * @param {Object} metadata Metadata payload.
	         * @param {boolean} [force=false] Flag indicating if the cache is
	         *   ignored and the templates are to be recompiled.
	         */
	        set: function set(metadata, force) {
	            if (metadata.views) {
	                _.each(metadata.views, function (view, name) {
	                    if (name != '_hash') {
	                        _.each(view.templates, function (src, key) {
	                            key = name == key ? key : name + '.' + key;
	                            this.setView(key, null, src, force);
	                        }, this);
	                    }
	                }, this);
	            }
	
	            if (metadata.fields) {
	                _.each(metadata.fields, function (field, type) {
	                    if (type != '_hash') {
	                        _.each(field.templates, function (src, view) {
	                            this.setField(type, view, null, src, force);
	                        }, this);
	                    }
	                }, this);
	            }
	
	            if (metadata.layouts) {
	                _.each(metadata.layouts, function (layout, type) {
	                    if (type != '_hash') {
	                        _.each(layout.templates, function (src, key) {
	                            key = type == key ? key : type + '.' + key;
	                            this.setLayout(key, null, src, force);
	                        }, this);
	                    }
	                }, this);
	            }
	        },
	
	        /**
	         * Pre-compiled empty template.
	         *
	         * @property {Function}
	         */
	        empty: function empty() {
	            return '';
	        }
	    };
	
	    app.augment('template', _templateManager);
	})(SUGAR.App);

/***/ },
/* 42 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	
	    /**
	     * The Context object is a state variable to hold the current application state. The context contains various
	     * states of the current {@link View.View View} or {@link View.Layout Layout} -- this includes the current model and collection, as well as the current
	     * module focused and also possibly the url hash that was matched.
	     *
	     * ###Creating a Context Object
	     *
	     * Use the getContext method to get a new instance of a context.
	     * <pre><code>
	     * var myContext = SUGAR.app.context.getContext({
	     *     module: "Contacts",
	     *     url: "contacts/id"
	     * });
	     * </code></pre>
	     *
	     * ###Retrieving Data from the Context
	     *
	     * <pre><code>
	     * var module = myContext.get("module"); // module = "Contacts"
	     * </pre></code>
	     *
	     * ###Global Context Object
	     *
	     * The Application has a global context that applies to top level layer. Contexts used within
	     * nested {@link View.View Views} / {@link View.Layout Layouts} can be derived from the global context
	     * object.
	     *
	     *
	     * The global context object is stored in **`App.controller.context`**.
	     *
	     *
	     * @class Core.Context
	     * @extends Backbone.Model
	     */
	    app.Context = Backbone.Model.extend({
	
	        initialize: function initialize(attributes) {
	            Backbone.Model.prototype.initialize.call(this, attributes);
	            this.id = this.cid;
	            this.parent = null;
	            this.children = [];
	            this._fetchCalled = false;
	        },
	
	        /**
	         * Clears context's attributes. See {@link Core.Context#resetLoadFlag}.
	         *
	         * @param {Object} [options] Standard `Backbone.Model` options.
	         */
	        clear: function clear(options) {
	            var collection = this.get('collection');
	
	            if (collection) {
	                collection.abortFetchRequest();
	            }
	
	            _.each(this.children, function (child) {
	                child.clear(options);
	            });
	
	            this.children = [];
	            this.parent = null;
	
	            // Remove event listeners attached to models and collections in the context
	            // before clearing them.
	            _.each(this.attributes, function (value) {
	                if (value && value.off === Backbone.Events.off) {
	                    value.off();
	                    value.stopListening();
	                    if (_.isFunction(value.dispose)) {
	                        value.dispose();
	                    }
	                }
	            }, this);
	
	            this.off();
	            Backbone.Model.prototype.clear.call(this, options);
	
	            this.resetLoadFlag();
	        },
	
	        /**
	         * Resets "load-data" state for this context and its child contexts.
	         *
	         * The {@link Core.Context#loadData} method sets an internal boolean flag
	         * to prevent multiple identical requests to the server. This method resets this flag.
	         *
	         * @param {Object} [options] A hash of options.
	         * @param {boolean} [options.recursive = true] `true` to reset the child contexts
	         *   too.
	         * @param {boolean} [options.resetModel = true] `true` to reset the flag on the
	         *   model.
	         * @param {boolean} [options.resetCollection = true] `true` to reset the flag on
	         * the collection.
	         */
	        resetLoadFlag: function resetLoadFlag(options) {
	            if (_.isBoolean(options)) {
	                app.logger.warn('`Core.Context#resetLoadFlag` has changed signature since 7.8 ' + 'and will drop support for old signature in 7.9. Please update your code.');
	                options = { recursive: options };
	            }
	
	            options = options || {};
	            var recursive = _.isUndefined(options.recursive) ? true : options.recursive;
	            var resetModel = _.isUndefined(options.resetModel) ? true : options.resetModel;
	            var resetCollection = _.isUndefined(options.resetCollection) ? true : options.resetCollection;
	
	            this._fetchCalled = false;
	
	            if (this.get('model') && resetModel) {
	                this.get('model').dataFetched = false;
	            }
	
	            if (this.get('collection') && resetCollection) {
	                this.get('collection').dataFetched = false;
	            }
	
	            if (recursive) {
	                _.each(this.children, function (child) {
	                    child.resetLoadFlag();
	                });
	            }
	        },
	
	        /**
	         * Checks if a context is used for a create view.
	         * @return {Boolean} `true` if this context has `create` flag set.
	         */
	        isCreate: function isCreate() {
	            return this.get("create") === true;
	        },
	
	        /**
	         * Gets a related context.
	         * @param {Object} [def] Related context definition.
	         * <pre>
	         * {
	         *    module: module name,
	         *    link: link name
	         * }
	         * </pre>
	         * @return {Core.Context} New instance of the child context.
	         */
	        getChildContext: function getChildContext(def) {
	            def = def || {};
	            var context;
	            var force = def.forceNew || false;
	
	            delete def.forceNew;
	
	            // Re-use a child context if it already exists
	            // We search by either link name or module name
	            // Consider refactoring the way we store children: hash v.s. array
	            var name = def.cid || def.name || def.link || def.module;
	            if (name && !force) {
	                context = _.find(this.children, function (child) {
	                    return child.cid == name || child.get("link") == name || child.get("module") == name;
	                });
	            }
	
	            if (!context) {
	                def = _.extend({ fetch: this.get('fetch') }, def);
	                context = app.context.getContext(def);
	                this.children.push(context);
	                context.parent = this;
	            }
	
	            if (def.link) {
	                var parentModel = this.get("model");
	                context.set({
	                    parentModel: parentModel,
	                    parentModule: parentModel ? parentModel.module : null
	                });
	            } else if (!def.module) {
	                context.set({ module: this.get("module") });
	            }
	
	            this.trigger("context:child:add", context);
	
	            return context;
	        },
	
	        /**
	         * Prepares instances of model and collection.
	         *
	         * This method does nothing if this context already contains an instance of a model or a collection.
	         * Pass `true` to re-create model and collection.
	         *
	         * @param {boolean} force(optional) Flag indicating if data instances must be re-created.
	         */
	        prepare: function prepare(force, prepareRelated) {
	            var link;
	            if (force || !this.get('model') && !this.get('collection')) {
	                var modelId = this.get('modelId');
	                var create = this.get('create');
	                link = this.get('link');
	
	                this.set(link ? this._prepareRelated(link, modelId, create) : this._prepare(modelId, create));
	            }
	
	            if ((force || !this._relatedCollectionsPopulated) && (!link || prepareRelated)) {
	                this._populateRelatedContexts();
	            }
	
	            return this;
	        },
	
	        /**
	         * Sets the `fetch` attribute recursively on the context and its children.
	         *
	         * A context with `fetch` set to `false` won't load the data.
	         *
	         * @param {boolean} fetch `true` to recursively set `fetch` to `true`
	         *   in this context and its children.
	         * @param {Object} [options] A hash of options.
	         * @param {boolean} [options.recursive] `true` to recursively set the
	         *   `fetch` boolean on the children.
	         */
	        setFetch: function setFetch(fetch, options) {
	            options = options || {};
	            this.set('fetch', fetch);
	            var recursive = options.recursive === void 0 ? true : options.recursive;
	            if (recursive) {
	                _.each(this.children, function (child) {
	                    child.setFetch(fetch);
	                });
	            }
	        },
	
	        /**
	         * Prepares instances of model and collection.
	         *
	         * This method assumes that the module name (`module`) is set on the context.
	         * If not, instances of standard Backbone.Model and Backbone.Collection are created.
	         *
	         * @param {String} modelId Bean ID.
	         * @param {Boolean} create Create flag.
	         * @return {Object} State to set on this context.
	         * @private
	         */
	        _prepare: function _prepare(modelId, create) {
	            var model,
	                collection,
	                module = this.get("module"),
	                mixed = this.get("mixed"),
	                models;
	
	            if (modelId) {
	                model = app.data.createBean(module, { id: modelId });
	                models = [model];
	            } else if (create === true) {
	                model = app.data.createBean(module);
	                models = [model];
	            } else {
	                model = app.data.createBean(module);
	            }
	
	            collection = mixed === true ? app.data.createMixedBeanCollection(models) : app.data.createBeanCollection(module, models);
	
	            return {
	                collection: collection,
	                model: model
	            };
	        },
	
	        /**
	         * Prepares instances of related model and collection.
	         *
	         * This method assumes that either a parent model (`parentModel`) or
	         * parent model ID (`parentModelId`) and parent model module name (`parentModule`) are set on this context.
	         *
	         * @param {String} link Relationship link name.
	         * @param {String} modelId Related bean ID.
	         * @param {Boolean} create Create flag.
	         * @return {Object} State to set on this context.
	         * @private
	         */
	        _prepareRelated: function _prepareRelated(link, modelId, create) {
	            var model,
	                collection,
	                parentModel = this.get("parentModel");
	
	            parentModel = parentModel || app.data.createBean(this.get("parentModule"), { id: this.get("parentModelId") });
	            if (modelId) {
	                model = app.data.createRelatedBean(parentModel, modelId, link);
	                collection = app.data.createRelatedCollection(parentModel, link, [model]);
	            } else if (create === true) {
	                model = app.data.createRelatedBean(parentModel, null, link);
	                collection = app.data.createRelatedCollection(parentModel, link, [model]);
	            } else {
	                model = app.data.createRelatedBean(parentModel, null, link);
	                collection = app.data.createRelatedCollection(parentModel, link);
	            }
	
	            if (!this.has("parentModule")) {
	                this.set({ "parentModule": parentModel.module }, { silent: true });
	            }
	
	            if (!this.has("module")) {
	                this.set({ "module": model.module }, { silent: true });
	            }
	
	            return {
	                parentModel: parentModel,
	                collection: collection,
	                model: model
	            };
	        },
	
	        /**
	         * Sets the `fields` attribute on this context by extending the current
	         * `fields` attribute with the passed-in `fieldsArray`.
	         *
	         * @chainable
	         * @param {string[]} fieldsArray The list of field names.
	         * @return {Core.Context} Instance of this model.
	         */
	        addFields: function addFields(fieldsArray) {
	            if (!fieldsArray) {
	                return;
	            }
	            var fields = _.union(fieldsArray, this.get('fields') || []);
	            return this.set('fields', fields);
	        },
	
	        /**
	         * Loads data (calls fetch on either model or collection).
	         *
	         * This method sets an internal boolean flag to prevent consecutive fetch operations.
	         * Call {@link Core.Context#resetLoadFlag} to reset the context's state.
	         *
	         * @param {Object} [options] A hash of options passed to
	         *   collection/model's fetch method.
	         * @param {boolean} [options.fetch] `true` to always fetch the data.
	         */
	        loadData: function loadData(options) {
	            options = options || {};
	            if (!options.forceFetch && !this._shouldFetch()) {
	                return;
	            }
	
	            delete options.forceFetch;
	
	            var objectToFetch,
	                modelId = this.get("modelId"),
	                module = this.get("module"),
	                defaultOrdering = app.config.orderByDefaults && module ? app.config.orderByDefaults[module] : null;
	
	            objectToFetch = modelId ? this.get("model") : this.get("collection");
	
	            // If we have an orderByDefaults in the config, and this is a bean collection,
	            // try to use ordering from there (only if orderBy is not already set.)
	            if (defaultOrdering && objectToFetch instanceof app.BeanCollection && !objectToFetch.orderBy) {
	                objectToFetch.orderBy = defaultOrdering;
	            }
	
	            // TODO: Figure out what to do when models are not
	            // instances of Bean or BeanCollection. No way to fetch.
	            if (objectToFetch && (objectToFetch instanceof app.Bean || objectToFetch instanceof app.BeanCollection)) {
	
	                if (this.get('dataView') && _.isString(this.get('dataView'))) {
	                    objectToFetch.setOption('view', this.get('dataView'));
	                }
	
	                if (this.get('fields')) {
	                    objectToFetch.setOption('fields', this.get('fields'));
	                }
	
	                if (this.get('limit')) {
	                    objectToFetch.setOption('limit', this.get('limit'));
	                }
	
	                if (this.get('module_list')) {
	                    objectToFetch.setOption('module_list', this.get('module_list'));
	                }
	
	                // Track models that user is actively viewing
	                if (this.get('viewed')) {
	                    objectToFetch.setOption('viewed', this.get('viewed'));
	                }
	
	                options.context = this;
	
	                if (this.get("skipFetch") !== true) {
	                    objectToFetch.fetch(options);
	                }
	
	                this._fetchCalled = true;
	            } else {
	                app.logger.warn("Skipping fetch because model is not Bean, Bean Collection, or it is not defined, module: " + this.get("module"));
	            }
	        },
	
	        /**
	         * Creates child context for each `link` of each `collection` field
	         * present on the bean.
	         *
	         * @private
	         */
	        _populateRelatedContexts: function _populateRelatedContexts() {
	            if (!this.get('collection')) {
	                return;
	            }
	
	            this.get('collection').each(function (bean) {
	                var collectionFields = bean.fieldsOfType('collection');
	                if (!_.isEmpty(collectionFields)) {
	                    _.each(collectionFields, function (field) {
	                        var links = field.links;
	                        if (_.isString(links)) {
	                            links = [links];
	                        }
	
	                        var linkCollections = {};
	                        _.each(links, function (link) {
	                            var rc = this.getChildContext({ link: link });
	                            rc.prepare();
	                            linkCollections[link] = rc.get('collection');
	                        }, this);
	
	                        bean.set(field.name, app.data.createMixedBeanCollection([], { links: linkCollections }));
	                    }, this);
	                }
	            }, this);
	
	            this._relatedCollectionsPopulated = true;
	        },
	
	        /**
	         * Helper function to determine if {@link #loadData} can be called on
	         * this context.
	         *
	         * @protected
	         * @return {boolean} `true` if {@link #loadData} can be called. `false`
	         *   otherwise.
	         */
	        _shouldFetch: function _shouldFetch() {
	            return (this.get('fetch') === void 0 || this.get('fetch')) && !this.isDataFetched() && !this.get('create');
	        },
	
	        /**
	         * Refreshes the context's data and refetches the new data if
	         * {@link #skipFetch} is `true`.
	         *
	         * @param {Object} [options] Options for {@link #loadData} and the
	         *   `reload` event.
	         */
	        reloadData: function reloadData(options) {
	            options = options || {};
	
	            this.resetLoadFlag(options);
	            this.loadData(options);
	
	            /**
	             * @event reload
	             * Triggered before and after the context is reloaded.
	             * @param {Core.Context} this The context where the event was triggered.
	             * @param {Object} [options] The options passed during
	             *   {@link #reloadData} call.
	             */
	            this.trigger('reload', this, options);
	        },
	
	        /**
	         * Indicator to know if data has been successfully loaded
	         *
	         * @return {boolean} `true` if data has been fetched, `false` otherwise.
	         */
	        isDataFetched: function isDataFetched() {
	            var objectToFetch = this.get('modelId') ? this.get('model') : this.get('collection');
	            return this._fetchCalled || objectToFetch && !!objectToFetch.dataFetched;
	        }
	    });
	
	    app.augment('context', {
	
	        /**
	         * Returns a new instance of the context object.
	         * @param {Object} [attributes] Any parameters and state properties to
	         *   attach to the context.
	         * @return {Core.Context} New context instance.
	         * @member Core.Context
	         */
	        getContext: function getContext(attributes) {
	            return new app.Context(attributes);
	        }
	    });
	})(SUGAR.App);

/***/ },
/* 43 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	    /**
	     * Controller manages the loading and unloading of layouts within the app.
	     *
	     * **Extending controller**
	     *
	     * Application may choose to extend the controller to provide custom implementation.
	     * Your custom controller class name should be capiltalized {@link Config#appId} followed by `Controller` word.
	     * <pre><code>
	     * (function(app) {
	     *
	     *     app.PortalController = app.Controller.extend({
	     *
	     *         loadView: function(params) {
	     *            // Custom implementation of loadView
	     *
	     *            // Should you need to call super method:
	     *            app.Controller.prototype.loadView.call(this, params);
	     *         }
	     *
	     *     });
	     *
	     * })(SUGAR.App);
	     * </code></pre>
	     *
	     * @class Core.Controller
	     * @alias SUGAR.App.controller
	     * @singleton
	     */
	    var Controller = Backbone.View.extend({
	        /**
	         * Initializes this controller.
	         * @private
	         * @ignore
	         */
	        initialize: function initialize() {
	            /**
	             * The primary context of the app.
	             * This context is associated with the root layout.
	             * @property {Core.Context}
	             */
	            this.context = app.context.getContext();
	
	            app.events.on("app:sync:complete", function () {
	                app.api.setStateProperty("loadingAfterSync", true);
	                _.each(app.additionalComponents, function (component) {
	                    if (component && _.isFunction(component._setLabels)) {
	                        component._setLabels();
	                    }
	                    component.render();
	                });
	                app.router.reset();
	                app.api.clearStateProperty("loadingAfterSync");
	            });
	
	            app.events.on("app:login:success", function () {
	                app.sync();
	            });
	        },
	
	        /**
	         * Loads a view (layout).
	         *
	         * This method is called by the router when the route is changed.
	         *
	         * @param {Object} params Options that determine the current context and the view to load.
	          * - id: ID of the record to load (optional)
	         * - module: module name
	         * - layout: Name of the layout to load
	         */
	        loadView: function loadView(params) {
	
	            var oldLayout = this.layout;
	
	            //FIXME SC-5124 will remove 'app:view:load', to use 'app:view:change' instead.
	            if (!app.triggerBefore('app:view:change') || !app.triggerBefore('app:view:load')) {
	                return;
	            }
	
	            // Reset context and initialize it with new params
	            this.context.clear({ silent: true });
	            this.context.set(params);
	
	            // Prepare model and collection
	            this.context.prepare();
	            // Create an instance of the layout and bind it to the data instance
	            this.layout = app.view.createLayout({
	                name: params.layout,
	                module: params.module,
	                context: this.context
	            });
	
	            if (oldLayout) {
	                // Take out the previous layout element from the content container,
	                // and then keep it in the document fragment
	                // in order to destroy jQuery plugin safe.
	                var oldLayoutEl = document.createDocumentFragment();
	                oldLayoutEl.appendChild(oldLayout.el);
	            }
	
	            // Render the layout to the main element
	            // Since the previous element is already gone,
	            // .append is better way because .html requires
	            // additional cost for .empty().
	            app.$contentEl.append(this.layout.$el);
	
	            //initialize subcomponents in the layout
	            this.layout.initComponents();
	
	            // Fetch the data, the layout will be rendered when fetch completes
	            if (!params || params && !params.skipFetch) {
	                this.layout.loadData();
	            }
	
	            // Render the layout with empty data
	            this.layout.render();
	
	            if (oldLayout) {
	                oldLayout.dispose();
	            }
	
	            app.trigger("app:view:change", params.layout, params);
	        },
	
	        /**
	         * Creates, renders, and registers within the app additional components.
	         */
	        loadAdditionalComponents: function loadAdditionalComponents(components) {
	            if (!_.isEmpty(app.additionalComponents)) {
	                app.logger.error('`app.controller.loadAdditionalComponents` has already been called. It can not be called twice.');
	                return;
	            }
	
	            app.additionalComponents = {};
	            _.each(components, function (component, name) {
	                if (component.target) {
	                    var $el = this.$(component.target);
	                    if (!$el.get(0)) {
	                        app.logger.error('Unable to place additional component "' + name + '": the target specified does not exist.');
	                        return;
	                    }
	                    if (component.layout) {
	                        app.additionalComponents[name] = app.view.createLayout({
	                            context: this.context,
	                            type: component.layout,
	                            el: $el
	                        });
	                        app.additionalComponents[name].initComponents();
	                    } else {
	                        app.additionalComponents[name] = app.view.createView({
	                            type: component.view || name,
	                            context: this.context,
	                            el: $el
	                        });
	                    }
	                    app.additionalComponents[name].render();
	                } else {
	                    app.logger.error('Unable to place additional component "' + name + '": no target specified.');
	                }
	            }, this);
	        }
	    });
	
	    app.augment("Controller", Controller, false);
	
	    app.events.on("app:init", function (app) {
	        app.controller.setElement(app.$rootEl);
	    }, app.controller).on("app:start", function (app) {
	        app.controller.loadAdditionalComponents(app.config.additionalComponents);
	    });
	})(SUGAR.App);

/***/ },
/* 44 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	    // Can be set by routing.start().
	    var _routes;
	
	    /**
	     * Manages routing behavior.
	     *
	     * The default implementation provides `before` and `after` callbacks that are executed
	     * before and after a route gets triggered.
	     *
	     * @class Core.Routing
	     * @alias SUGAR.App.routing
	     * @singleton
	     */
	    app.augment("routing", {
	
	        /**
	         * Checks if a user is authenticated before triggering a route.
	         * @param {String} route Route name.
	         * @param args(optional) Route parameters.
	         * @return {Boolean} Flag indicating if the route should be triggered (`true`).
	         */
	        beforeRoute: function beforeRoute(route, args) {
	            if (!this.triggerBefore("route", { route: route, args: args })) return false;
	
	            // skip this check for all white-listed routes (app.config.unsecureRoutes)]
	            if (_.indexOf(app.config.unsecureRoutes, route) >= 0) return true;
	
	            // Check if a user is un-authenticated and redirect him to login
	            if (!app.api.isAuthenticated()) {
	                app.router.login();
	                return false;
	            } else if (!app.isSynced) {
	                Backbone.history.stop();
	                app.sync();
	                return false;
	            }
	            return true;
	        },
	
	        /**
	         * Gets called after a route gets triggered.
	         *
	         * The default implementation does nothing.
	         * @param {String} route Route name.
	         * @param args(optional) Route parameters.
	         */
	        after: function after(route, args) {
	            // Do nothing
	        },
	
	        /**
	         * If default routes are not desired, overwrite defaults with an array
	         * of custom routes with their handlers.
	         *
	         * @param {Array} customRoutes List of routes to replace sidecar routes
	         * with. In the format:
	         *
	         *     { route: 'route', name: 'routename', callback: function() {} }
	         */
	        setRoutes: function setRoutes(customRoutes) {
	            app.logger.warn('Core.Routing#setRoutes is deprecated since 7.8 and will be removed in 7.9. ' + 'Please use Core.Router#addRoutes.');
	            _routes = customRoutes;
	        },
	
	        /**
	         * Should be called when app has finished loading all the necessary files.
	         * This will create an instance of Backbone router.
	         */
	        start: function start() {
	            var opts = {};
	
	            if (_routes) {
	                opts.customRoutes = _routes;
	            }
	
	            app.augment("router", new app.Router(opts), false);
	            app.events.trigger("router:start", app.router);
	            app.router.init();
	            app.router.start();
	        },
	
	        /**
	         * Internal use only - for unit testing Routers.
	         *
	         * Disable `Backbone.history` temporarily.
	         */
	        stop: function stop() {
	            app.router.stop();
	            _routes = [];
	        }
	    });
	
	    //Mix in the beforeEvents
	    _.extend(app.routing, app.beforeEvent);
	
	    /**
	     * Router manages the watching of the address hash and routes to the correct handler.
	     *
	     * **Note:** The default router has no routes, routes will need to be provided via a custom route object
	     * from the `platform.js` file. Custom routes can use predefined route handlers on the default router.
	     *
	     * Deprecated Routes:
	     *
	     * - "": "index",
	     * - "logout": "logout",
	     * - "logout/?clear=:clear": "logout",
	     * - ":module": "list",
	     * - ":module/layout/:view": "layout",
	     * - ":module/create": "create",
	     * - ":module/:id/:action": "record",
	     * - ":module/:id": "record"
	     *
	     * ## Events:
	     * ### router:init
	     * Triggered after {@link Core.Routing#start} has been initialized but before it has started.
	     * Should be used to register additional custom routes:
	     *
	     *     app.events.on('router:init', function(router) {
	     *         var routes = [
	     *             {
	     *                 route: 'MyModule/my_custom_route',
	     *                 name: 'MyModule',
	     *                 callback: MyModule
	     *             }
	     *         ];
	     *         app.router.addRoutes(routes);
	     *     });
	     *
	     *
	     *
	     * @class Core.Router
	     * @alias SUGAR.App.router
	     * @extends Backbone.Router
	     * @singleton
	     */
	    app.Router = Backbone.Router.extend({
	
	        /**
	         * Sets custom routes and binds them if available.
	         * @param {Object} [opts] options to initialize the router.
	         * @param {Object} [opts.customRoutes] customRoutes to override the
	         * default sidecar ones.
	         */
	        initialize: function initialize(opts) {
	            opts = opts || {};
	
	            /**
	             * The previous fragment.
	             *
	             * @property {string}
	             * @private
	             */
	            this._previousFragment = '';
	
	            /**
	             * The current fragment.
	             *
	             * @property {string}
	             * @private
	             */
	            this._currentFragment = '';
	
	            if (opts.customRoutes) {
	                app.logger.warn('Core.Router\'s option "customRoutes", is deprecated since 7.8 and will be removed in 7.9. ' + 'Please use addRoutes.');
	                this._initRoutes = opts.customRoutes;
	            }
	        },
	
	        /**
	         * Calls {@link Core.Routing#before} before invoking a route handler
	         * and {@link Core.Routing#after} after the handler is invoked.
	         *
	         * @param {Function} handler Route callback handler.
	         * @private
	         */
	        _routeHandler: function _routeHandler(handler) {
	            var args = Array.prototype.slice.call(arguments, 1),
	                route = handler.route;
	
	            if (app.routing.beforeRoute(route, args)) {
	                this._previousFragment = this._currentFragment;
	                this._currentFragment = this.getFragment();
	                handler.apply(this, args);
	                app.routing.after(route, args);
	            }
	        },
	
	        /**
	         * Checks if module exists and displays 404 error screen if it does not
	         * @param module
	         * @return {boolean} `true` if module exists, `false` otherwise.
	         * @private
	         */
	        _moduleExists: function _moduleExists(module) {
	            if (module && _.isUndefined(app.metadata.getModule(module))) {
	                app.error.handleHttpError({ status: 404 });
	                return false;
	            }
	            return true;
	        },
	
	        _addDefaultRoutes: function _addDefaultRoutes() {
	            var defaultRoutes = [{
	                name: 'notFound',
	                route: /^.*$/,
	                callback: function callback() {
	                    // no matching routes (e.g.: '#//' or '#unkown/path/route)
	                    app.error.handleHttpError({ status: 404 });
	                }
	            }];
	            this.addRoutes(defaultRoutes);
	        },
	
	        /**
	         * Registers a handler for a named route.
	         *
	         * This method wraps the handler into {@link Core.Router#_routeHandler}
	         * method.
	         *
	         * @param {string} route Route expression.
	         * @param {string} name Route name.
	         * @param {Function} [callback] Route handler. If not supplied, will
	         *   use the method name that matches the `name` param.
	         */
	        route: function route(_route, name, callback) {
	            if (!name) {
	                app.logger.warn('Route names will be required in 7.9.');
	            } else if (!_.isEmpty(this._routes[name])) {
	                app.logger.error('Route "' + name + '" is being overridden. This is highly NOT advisable.');
	            }
	
	            this._routes[name] = callback;
	
	            if (!callback) {
	                callback = this[name];
	            }
	
	            callback.route = name;
	            callback = _.wrap(callback, this._routeHandler);
	            Backbone.Router.prototype.route.call(this, _route, name, callback);
	        },
	
	        /**
	         * Gets the current backbone fragment.
	         *
	         * @return {string}
	         */
	        getFragment: function getFragment() {
	            return Backbone.history.getFragment();
	        },
	
	        /**
	         * Updates the URL with the given fragment.
	         *
	         * @param {string} fragment The fragment to navigate to.
	         * @param {Object} [options] The options hash.
	         * @param {boolean} [options.trigger] `true` to fire the route callback.
	         * @param {boolean} [options.replace] `true` to modify the current URL
	         *   without adding an entry to the window.history object.
	         */
	        navigate: function navigate(fragment, options) {
	            Backbone.Router.prototype.navigate.apply(this, arguments);
	            if (!(options && options.trigger)) {
	                this._previousFragment = this._currentFragment;
	                this._currentFragment = this.getFragment();
	            }
	            return this;
	        },
	
	        /**
	         * Gets the previous fragment.
	         *
	         * @return {string}
	         */
	        getPreviousFragment: function getPreviousFragment() {
	            return this._previousFragment;
	        },
	
	        /**
	         * Navigates to the previous route in history.
	         *
	         * This method triggers route change event.
	         */
	        goBack: function goBack() {
	            app.logger.debug("Navigating back...");
	            window.history.back();
	        },
	
	        /**
	         * Navigates the window history.
	         *
	         * @param {Number} steps Number of steps to navigate (can be negative).
	         */
	        go: function go(steps) {
	            window.history.go(steps);
	        },
	
	        /**
	         * Initializes the router.
	         */
	        init: function init() {
	            /**
	             * Routes' hashmap by name. See {@link#get} for more info.
	             *
	             * @type {Object}
	             * @private
	             */
	            this._routes = {};
	            this._addDefaultRoutes();
	            if (this._initRoutes) {
	                this.addRoutes(this._initRoutes);
	            }
	
	            if (this.customRoutes) {
	                app.logger.warn('Core.Router\'s option "customRoutes", is deprecated since 7.8 and will be removed in 7.9. ' + 'Please use addRoutes.');
	                this.addRoutes(this.customRoutes);
	            }
	
	            app.events.trigger('router:init');
	        },
	
	        /**
	         * Starts Backbone history which in turn starts routing the hashtag.
	         *
	         * See Backbone.history documentation for details.
	         */
	        start: function start() {
	            if (!Backbone.History.started) {
	                Backbone.history.start();
	            }
	        },
	
	        stop: function stop() {
	            Backbone.history.stop();
	        },
	
	        /**
	         * Reset router.
	         * Stop Backbone.history and clean up routes.
	         * Re-initialize and start routing again.
	         */
	        reset: function reset() {
	            app.router.stop();
	            _routes = [];
	            Backbone.history.handlers = [];
	            app.router.init();
	            app.router.start();
	        },
	
	        /**
	         * Add routes into router.
	         *
	         * **Note:** Currently, Backbone stops after the first matching route.
	         * Therefore, the order of how custom routes are added is important.
	         *
	         * In general, the developer should add the more specific route first,
	         * so that the intended route gets called.
	         *
	         * For example, the route `MyRoute/create` will call `myRouteCreate` in
	         * the following code snippet:
	         *
	         *     var routes = [
	         *         {
	         *             name: 'myRouteCreate',
	         *             route: 'MyRoute/create',
	         *             callback: myRouteCreate
	         *         },
	         *         {
	         *             name: 'myRoute',
	         *             route: "MyRoute(/:my_custom_route)",
	         *             callback: myRoute
	         *         }
	         *     ];
	         *
	         * If the order of `myRouteCreate` and `myRoute` is reversed, triggering
	         * `MyRoute/create` will call `myRoute` with `:my_custom_route` set to
	         * `create`, which may not be intended.
	         *
	         * @param {Array} routes The ordered list of routes.
	         */
	        addRoutes: function addRoutes(routes) {
	            if (!routes) return;
	            var newRoutes = routes.reverse();
	            _.each(newRoutes, function (route) {
	                this.route(route.route, route.name, route.callback);
	            }, this);
	        },
	
	        /**
	         * Retrieves the callback associated with the given name.
	         *
	         * @param {string} name The route to get the callback function.
	         * @returns {Function} The callback associated with this route name.
	         */
	        get: function get(name) {
	            return this._routes[name];
	        },
	
	        /**
	         * Re-trigger the current route.
	         * Used to refresh the current layout/page without doing a hard refresh.
	         */
	        refresh: function refresh() {
	            Backbone.history.loadUrl(Backbone.history.fragment);
	        },
	
	        /**
	         * Builds a route.
	         *
	         * This is a convenience function.
	         * If you need to override this, define a customBuildRoute function on
	         * `app.utils` and return empty string if you want to fallback to this
	         * definition of build route.
	         *
	         * @param {Core.Context|string} moduleOrContext The name of the module
	         * or a context object to extract the module from.
	         * @param {string} id The model's ID.
	         * @param {string} [action] Action name.
	         * @return {string} route The built route.
	         */
	        buildRoute: function buildRoute(moduleOrContext, id, action) {
	            var route;
	
	            if (app.utils && _.isFunction(app.utils.customBuildRoute)) {
	                route = app.utils.customBuildRoute.apply(this, arguments);
	                if (!_.isEmpty(route)) {
	                    return route;
	                }
	            }
	
	            if (moduleOrContext) {
	                // If module is a context object, then extract module from it
	                route = _.isString(moduleOrContext) ? moduleOrContext : moduleOrContext.get("module");
	
	                if (id) {
	                    route += "/" + id;
	                }
	
	                if (action) {
	                    route += "/" + action;
	                }
	            } else {
	                route = action;
	            }
	
	            return route;
	        },
	
	        // ----------------------------------------------------
	        // Route handlers
	        // ----------------------------------------------------
	
	        /**
	         * Handles `index` route.
	         *
	         * Loads `home` layout for `Home` module or `list` route with default module defined in app.config
	         */
	        index: function index() {
	            app.logger.debug("Route changed to index");
	            if (app.config.defaultModule) {
	                this.navigate(app.config.defaultModule, { trigger: true });
	            } else if (app.acl.hasAccess('read', 'Home')) {
	                this.navigate('Home', { trigger: true });
	            }
	        },
	
	        /**
	         * Handles `list` route.
	         * @param module Module name.
	         */
	        list: function list(module) {
	            if (!this._moduleExists(module)) {
	                return;
	            }
	            app.logger.debug("Route changed to list of " + module);
	            app.controller.loadView({
	                module: module,
	                layout: "records"
	            });
	        },
	
	        /**
	         * Handles arbitrary layout for a module that doesn't have a record associated with the layout.
	         * @param module Module name.
	         * @param layout Layout name.
	         */
	        layout: function layout(module, _layout) {
	            if (!this._moduleExists(module)) {
	                return;
	            }
	            app.logger.debug("Route changed to layout: " + _layout + " for " + module);
	            app.controller.loadView({
	                module: module,
	                layout: _layout
	            });
	        },
	
	        /**
	         * Handles `create` route.
	         * @param module Module name.
	         */
	        create: function create(module) {
	            if (!this._moduleExists(module)) {
	                return;
	            }
	            app.logger.debug("Route changed: create " + module);
	            app.controller.loadView({
	                module: module,
	                create: true,
	                layout: "edit"
	            });
	        },
	
	        /**
	         * Handles `login` route.
	         */
	        login: function login() {
	            app.logger.debug("Logging in");
	            app.controller.loadView({
	                module: "Login",
	                layout: "login",
	                create: true
	            });
	
	            // Need to hide the megamenu here otherwise we get a login screen
	            // with a megamenu. This is done AFTER the login view loading since
	            // loadView fires a _render call on login.js, which rerenders the
	            // header in refreshAdditionalComponents().
	            app.events.trigger('app:login');
	
	            if (app.config.externalLogin) {
	                // This will attempt reauth
	                app.api.ping(null, {
	                    success: function success() {
	                        // If we have success then show the megamenu again
	                        app.events.trigger('app:login:success');
	                        app.router.refresh();
	                    },
	                    error: function error() {
	                        app.alert.show('needs_login_error', {
	                            level: 'error',
	                            messages: app.lang.getAppString('LBL_PORTAL_INVALID_CREDS_TITLE'),
	                            title: app.lang.get('LBL_PORTAL_INVALID_CREDS_TITLE')
	                        });
	                    }
	                });
	            }
	        },
	
	        /**
	         * Handles `logout` route.
	         */
	        logout: function logout(clear) {
	            if (!app.api.isAuthenticated()) {
	                // We don't want to store the #logout fragment in the URL
	                // history. This will re-direct to the root defined in the
	                // Backbone router, and replace the URL.
	                this.redirect('/');
	                return;
	            }
	
	            clear = clear === "1";
	            app.logger.debug("Logging out: " + clear);
	            app.logout({
	                complete: function complete() {
	                    app.router.navigate("#");
	                    if (clear) {
	                        //We have to reload to clear any sensitive data from browser tab memory.
	                        window.location.reload();
	                    } else {
	                        if (app.config.externalLogin) {
	                            app.controller.loadView({
	                                module: "Login",
	                                layout: "logout",
	                                skipFetch: true,
	                                create: true
	                            });
	                        } else {
	                            app.router.login();
	                        }
	                    }
	                },
	                success: function success(data) {
	                    app.events.trigger('app:logout:success', data);
	                }
	            }, clear);
	        },
	
	        /**
	         * Handles `record` route.
	         * @param {string} module Module name.
	         * @param {string} id Record ID. If `id` is `create`, it will load the create view.
	         * @param {string} [action] Action name (`edit`, etc.). Defaults to `detail` if not specified.
	         * @param {string} [layout] The layout to use for this route. Defaults to `record` if not specified.
	         */
	        record: function record(module, id, action, layout) {
	            if (!this._moduleExists(module)) {
	                return;
	            }
	            var oldCollection = app.controller.context.get('collection'),
	                oldListCollection = app.controller.context.get('listCollection'),
	                opts = {
	                module: module,
	                layout: layout || "record",
	                action: action || "detail"
	            };
	
	            if (id !== "create") {
	                _.extend(opts, { modelId: id });
	            } else {
	                _.extend(opts, { create: true });
	                opts.layout = "create";
	            }
	
	            //If we come from a list view, we get the current collection
	            if (oldCollection && oldCollection.module === module && oldCollection.get(id)) {
	                opts.listCollection = oldCollection;
	            }
	
	            //If we come from a detail view, we need to get the cached collection
	            if (oldListCollection && oldListCollection.module === module && oldListCollection.get(id)) {
	                opts.listCollection = oldListCollection;
	            }
	
	            app.controller.loadView(opts);
	        },
	
	        redirect: function redirect(route, options) {
	            this.navigate(route, _.extend({ trigger: true, replace: true }, options));
	        }
	    });
	})(SUGAR.App);

/***/ },
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	    /**
	     * Language Helper.
	     *
	     * Provides interface to pull language strings out of a language label
	     * cache.
	     *
	     * @class Core.Language
	     * @alias SUGAR.App.lang
	     * @singleton
	     */
	    app.augment('lang', {
	
	        /**
	         * The display direction for the current language.
	         *
	         * @property {string}
	         */
	        direction: 'ltr',
	
	        /**
	         * Retrieves a string for a given key.
	         *
	         * This function searches the module strings first and falls back to the
	         * app strings.
	         *
	         * If the label is a template, it will be compiled and executed with the
	         * given `context`.
	         *
	         * @param {string} key Key of the string to retrieve.
	         * @param {string|Array} [module] Module the label belongs to. If an
	         *   array is passed, it will look through each module by the given
	         *   order, returning the first string whose key is found in the
	         *   module's language strings.
	         * @param {string|boolean|number|Array|Object} [context] The template context to pass to the
	         *   string/template in case you want to populate some values.
	         * @return {string} String for the given key or the `key` parameter if
	         *   the key is not found in language pack.
	         */
	        get: function get(key, module, context) {
	            var str = this.getModString(key, module, context) || this.getAppString(key, context) || key;
	
	            return str;
	        },
	
	        /**
	         * Searches the module strings for a given key.
	         *
	         * @param {string} key Key of the string to retrieve.
	         * @param {string|Array} [module] Module the label belongs to. If an
	         *   array is passed, it will look through each module by the given
	         *   order, returning the first string whose key is found in the
	         *   module's language strings.
	         * @param {string|boolean|number|Array|Object} [context] The template context to pass to the
	         *   string/template in case you want to populate some values.
	         * @return {string|undefined} String for the given key from the module
	         *   language strings. `undefined` if not found.
	         */
	        getModString: function getModString(key, module, context) {
	            var moduleString;
	
	            if (_.isArray(module)) {
	                _.find(module, function (moduleName) {
	                    moduleString = this._get('mod_strings', key, moduleName, context);
	                    return !_.isEmpty(moduleString);
	                }, this);
	            } else {
	                moduleString = this._get('mod_strings', key, module, context);
	            }
	
	            return moduleString;
	        },
	
	        /**
	         * Retrieves an application string for a given key.
	         *
	         * @param {string} key Key of the string to retrieve.
	         * @param {string|boolean|number|Array|Object} [context] The template
	         *   context to pass to the string/template in case you want to
	         *   populate some values.
	         * @return {string|undefined} String for the given key from language
	         *   strings. `undefined` if not found.
	         */
	        getAppString: function getAppString(key, context) {
	            return this._get('app_strings', key, null, context);
	        },
	
	        /**
	         * Retrieves an application list string or object.
	         *
	         * @param {string} key Key of the string to retrieve.
	         * @return {string|Object} String or object for the given key. If key
	         *   is not found, an empty object is returned.
	         */
	        getAppListStrings: function getAppListStrings(key) {
	            var list = app.metadata.getStrings('app_list_strings')[key] || {};
	            if (_.isArray(list)) {
	                var obj = {};
	                _.each(list, function (tuple) {
	                    if (_.isString(tuple)) {
	                        obj[tuple] = tuple;
	                    } else if (_.isArray(tuple) && tuple.length === 2) {
	                        obj[tuple[0]] = tuple[1];
	                    }
	                });
	                list = obj;
	            }
	            return list;
	        },
	
	        /**
	         * Gets the translated module name (by default, in singular form).
	         *
	         * Falls back to the plural form if the singular form is not found, and
	         * eventually falls back to the `module` passed in.
	         *
	         * @param {string} module The module.
	         * @param {Object} [options] Options object for `getModuleName`.
	         * @param {boolean} [options.plural] Returns the plural form if `true`,
	         *   singular otherwise.
	         * @param {string} [options.defaultValue] Value to be returned if the
	         *   module language string is not found.
	         * @return {string} The module name.
	         */
	        getModuleName: function getModuleName(module, options) {
	            options = options || {};
	            var name = !options.plural && this.getModString('LBL_MODULE_NAME_SINGULAR', module) || this.getModString('LBL_MODULE_NAME', module);
	
	            if (!name && !_.isUndefined(options.defaultValue)) {
	                name = this.get(options.defaultValue);
	            }
	
	            return name || module;
	        },
	
	        /**
	         * Returns the correct ordered array of keys for a given list.
	         * @param {string} key Key of the string to retrieve.
	         * @return {Array}
	         */
	        getAppListKeys: function getAppListKeys(key) {
	            var keys = [],
	                list = app.metadata.getStrings('app_list_strings')[key] || {};
	            if (_.isArray(list)) {
	                _.each(list, function (tuple) {
	                    if (tuple.length === 2) {
	                        keys.push(tuple[0]);
	                    }
	                });
	            } else if (_.isObject(list)) {
	                keys = _.keys(list);
	            }
	            return keys;
	        },
	
	        /**
	         * Retrieves a string of a given type.
	         *
	         * If the label is a template, it will be compiled and executed with the given `context`.
	         * @param {string} type Type of string pack: `app_strings`, `app_list_strings`, `mod_strings`.
	         * @param {string} key Key of the string to retrieve.
	         * @param {string} [module] Module the label belongs to.
	         * @param {string|boolean|number|Array|Object} [context] Template context.
	         * @return {string|undefined} String for the given key.
	         * @private
	         */
	        _get: function _get(type, key, module, context) {
	            var str,
	                bundle = app.metadata.getStrings(type);
	
	            bundle = module ? bundle[module] : bundle;
	            if (!bundle || !_.isString(bundle[key])) {
	                return;
	            }
	
	            str = this._sanitize(bundle[key]);
	
	            if (!_.isUndefined(context) && str.indexOf('{{') > -1) {
	                key = 'lang.' + (module ? key + '.' + module : key);
	                var tpl = Handlebars.templates[key];
	                str = tpl ? tpl(context) : app.template.compile(key, str)(context);
	            }
	            return str;
	        },
	
	        /**
	         * Sanitizes a string.
	         *
	         * This function strips trailing colon.
	         *
	         * @param {string} str String to sanitize.
	         * @return {string} Sanitized string or `str` parameter if it's not a
	         *   string.
	         * @private
	         */
	        _sanitize: function _sanitize(str) {
	            return str.slice(-1) === ':' ? str.slice(0, -1) : str;
	        },
	
	        /**
	         * Gets the Sugar language code for the current app language.
	         *
	         * @return {string} The current app language code as defined in Sugar.
	         * (e.g. `en_us`, `pt_PT`)
	         */
	        getLanguage: function getLanguage() {
	            return this._currentLanguage;
	        },
	
	        /**
	         * Sets app language code and syncs it with the server.
	         * @param {string} language language code such as `en_us`.
	         * @param {Function} [callback] Callback function to be called on
	         *   language set completes.
	         * @param {Object} [options] Extra options.
	         * @param {boolean} [options.noSync]
	         * - noSync: true if you don't need to fetch /metadata.
	         * - noUserUpdate: true if you don't need to update /me.
	         */
	        setLanguage: function setLanguage(language, _callback, options) {
	            var self = this;
	            options = options || {};
	            _.each(Handlebars.templates, function (value, key) {
	                if (key.indexOf('lang.') === 0) {
	                    delete Handlebars.templates[key];
	                }
	            });
	            if (options.noSync === true) {
	                this.updateLanguage(language);
	                return;
	            }
	
	            app.sync({
	                callback: function callback(err) {
	                    var langHasChanged = false;
	                    if (!err) {
	                        self.updateLanguage(language);
	                        langHasChanged = !app.api.isAuthenticated() && !options.noUserUpdate;
	                        app.cache.set('langHasChanged', langHasChanged); //persist even after reloads
	                    }
	                    if (_callback) _callback(err);
	                },
	                getPublic: !app.api.isAuthenticated(),
	                noUserUpdate: options.noUserUpdate || false,
	                language: language,
	                forceRefresh: true, // Needed to make sure new labels are injected
	                metadataTypes: ['labels']
	            });
	        },
	
	        /**
	         * Updates language code and the display direction.
	         *
	         * @param {string} language Language code as defined in Sugar.
	         * (e.g. `en_us`, `pt_PT`)
	         */
	        updateLanguage: function updateLanguage(language) {
	            app.cache.set('lang', language);
	            app.user.setPreference('language', language);
	            this.setCurrentLanguage(language);
	            app.trigger('app:locale:change', language);
	        },
	
	        /**
	         * Sets the app default language to the language specified.
	         *
	         * See {@link #_defaultLanguage} for more information
	         *
	         * @param {string} language The Sugar language code to set the default
	         * language to. (e.g. `en_us`, `pt_PT`)
	         */
	        setDefaultLanguage: function setDefaultLanguage(language) {
	            /**
	             * The default language of the app defined by
	             * {@link #setDefaultLanguage}. Use {@link #getDefaultLanguage} to
	             * retrieve this setting.
	             *
	             * @property {string}
	             * @member Core.Language
	             * @private
	             */
	            this._defaultLanguage = language;
	        },
	
	        /**
	         * Gets the default language set in the system.
	         *
	         * @return {string} The Sugar language code of the default language.
	         * (e.g. `en_us`, `pt_PT`)
	         */
	        getDefaultLanguage: function getDefaultLanguage() {
	            return this._defaultLanguage;
	        },
	
	        /**
	         * Sets the current language to the language specified.
	         * Calls {@link #setDirection} with the new language code.
	         *
	         * See {@link #_currentLanguage} for more information.
	         *
	         * @param {string} language The language to set the current language to.
	         */
	        setCurrentLanguage: function setCurrentLanguage(language) {
	            /**
	             * The language that is loaded by the app and defined by
	             * {@link #setCurrentLanguage}. Use {@link #getLanguage} to retrieve
	             * this setting.
	             *
	             * @property {string}
	             * @member Core.Language
	             * @private
	             */
	            this._currentLanguage = language;
	            this.setDirection(language);
	        },
	
	        /**
	         * Sets the {@link #direction} to the desired direction according to
	         * the language code specified.
	         *
	         * @fires `lang:direction:change` if the language direction has
	         * changed.
	         *
	         * @param {string} lang Language code that the direction is based on.
	         */
	        setDirection: function setDirection(lang) {
	            //FIXME: SC-3358 Should be getting the RTL languages from metadata.
	            var rtlLanguages = ['he_IL', 'ar_SA'],
	                isRTL = _.contains(rtlLanguages, lang),
	                prevDirection = this.direction;
	
	            this.direction = isRTL ? 'rtl' : 'ltr';
	
	            if (this.direction !== prevDirection) {
	                app.trigger('lang:direction:change');
	            }
	        }
	    });
	})(SUGAR.App);

/***/ },
/* 46 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	    // Key prefix used to identify metadata in the local storage.
	    var _keyPrefix = 'meta:';
	
	    // Metadata memory cache
	    var _metadata = {};
	
	    //History of md types we have loaded
	    var _mdLoaded = {};
	
	    //Used to keep track if we are currently updating the metadata and prevent premature metadata validation from
	    //interval functions.
	    var _syncing = false;
	
	    function _setHash(data, isPublic) {
	        var pKey = isPublic ? 'public:' : '';
	        app.cache.set(_keyPrefix + pKey + 'hash', data._hash);
	    }
	
	    function _cacheMeta(data) {
	        app.cache.set(_keyPrefix + 'data', data);
	    }
	
	    function _getCachedMeta() {
	        return app.cache.get(_keyPrefix + 'data');
	    }
	
	    // Adds the language strings to the server metadata object.
	    // - serverMetadata Metadata from /metadata GET (public or not).
	    // ** Note we take advantage of pass be reference thus no return
	    // - labels Object which contains our language strings.
	    function _injectLabels(serverMetadata, labels) {
	        _.each(labels, function (value, key) {
	            if (key !== '_hash') {
	                serverMetadata[key] = labels[key];
	            }
	        });
	        // meta.labels longer needed; don't want it in _metadata or cache!
	        delete serverMetadata.labels;
	    }
	
	    // Parses the labels property of metadata which contains
	    // URL to a JSON file with our language strings.
	    // - metadata Metadata returned from /metadata GET
	    function _fetchLabels(metadata, options) {
	        var labels,
	            currentLanguage,
	            langStringsUrl,
	            userLang = app.user.getLanguage();
	
	        // Grab the lang strings
	        labels = metadata.ordered_labels || metadata.labels;
	
	        // Set the default language
	        app.lang.setDefaultLanguage(labels['default']);
	
	        // Since, at this stage, we may or may not have obtained our language yet,
	        // the labels property contains a 'default' property which we can use as a fallback.
	        if (options.language && labels[options.language]) {
	            currentLanguage = options.language;
	        } else if (labels[userLang]) {
	            currentLanguage = userLang;
	        } else {
	            currentLanguage = app.lang.getDefaultLanguage();
	            // since the user's preferred language does not exist, update it to the default language
	            if (app.user.id) {
	                app.user.updateLanguage(currentLanguage);
	            }
	        }
	        app.lang.setCurrentLanguage(currentLanguage);
	
	        langStringsUrl = app.utils.buildUrl(labels[currentLanguage]);
	
	        app.api.call('read', langStringsUrl, null, {
	            success: function success(labelsData) {
	                // In case server is not set up to serve mime-type correctly on .json files,
	                // e.g. honey-b seems to be misconfigured (probably a "popular misconfiguration")
	                try {
	                    labelsData = _.isString(labelsData) ? JSON.parse(labelsData) : labelsData;
	                } catch (ex) {
	                    app.logger.fatal('Failed to parse labels data: ' + ex);
	                    options.error({
	                        code: 'sync_failed',
	                        label: 'ERR_SYNC_FAILED'
	                    });
	                    return;
	                }
	
	                options.success(labelsData);
	            },
	            error: function error(err) {
	                //Force a sync fail to prevent possible infinite loops
	                err.code = 'sync_failed';
	                err.label = 'ERR_SYNC_FAILED';
	                options.error(err);
	            }
	        });
	    }
	
	    // Initializes custom layouts/views templates and controllers
	    function _initCustomComponents(module, moduleName) {
	        var self = this,
	            platforms = app.config.platform !== 'base' ? ['base', app.config.platform] : ['base'];
	
	        _.each({ 'layout': 'layout', 'view': 'view', 'fieldTemplate': 'field', 'data': 'data' }, function (type, key) {
	
	            // Order and initialize controllers. If this metadata is separated by platform, we need to
	            // sort each extended type, but, also take in to consideration the "platform weighting" of
	            // said type (hence, 'base' is always first platform!). Controllers are now only sent via jssource.
	            if (self._metaTypeIsSeparatedByPlatform(module, key, platforms)) {
	                _.each(platforms, function (platform) {
	                    var components = module[key + 's'][platform];
	                    self._sortAndDeclareComponents(components, type, moduleName, platform);
	                });
	            }
	
	            // Next pull any templates
	            _.each(module[key + 's'], function (def, name) {
	                if (type === 'view' && def.templates) {
	                    _.each(def.templates, function (tplSource, tplName) {
	                        var force = name === tplName;
	                        tplName = force ? tplName : name + '.' + tplName;
	                        app.template.setView(tplName, moduleName, tplSource, true);
	                    });
	                }
	                if (type === 'layout' && def.templates) {
	                    _.each(def.templates, function (tplSource, key) {
	                        key = name === key ? key : name + '.' + key;
	                        app.template.setLayout(key, moduleName, tplSource, true);
	                    });
	                }
	                if (type === 'field' && def.templates) {
	                    _.each(def.templates, function (template, view) {
	                        app.template.setField(name, view, moduleName, template, true);
	                    });
	                }
	            });
	        }, this);
	    }
	
	    /**
	     * The metadata manager is responsible for parsing and returning various
	     * metadata to components that request it.
	     *
	     * @class Core.MetadataManager
	     * @alias SUGAR.App.metadata
	     * @singleton
	     */
	    app.augment('metadata', {
	
	        /**
	         * Map of fields types.
	         *
	         * Specifies correspondence between field types and field widget types.
	         */
	        fieldTypeMap: {
	            varchar: 'text',
	            datetime: 'datetimecombo',
	            multienum: 'enum',
	            text: 'textarea',
	            decimal: 'float'
	        },
	
	        /**
	         * Patches view fields' definitions.
	         * @param moduleName Module name
	         * @param module Module definition
	         * @private
	         */
	        _patchMetadata: function _patchMetadata(moduleName, module) {
	
	            if (!module || module._patched === true) {
	                return module;
	            }
	
	            _.each(module.views, function (view) {
	                if (view.meta) {
	                    _.each(view.meta.panels, function (panel) {
	                        panel.fields = this._patchFields(moduleName, module, panel.fields);
	                    }, this);
	                }
	            }, this);
	
	            module._patched = true;
	            return module;
	        },
	
	        _patchFields: function _patchFields(moduleName, module, fields) {
	            var self = this;
	            _.each(fields, function (field, fieldIndex) {
	                var name = _.isString(field) ? field : field.name;
	                var fieldDef = module.fields[name];
	
	                if (field.fields) {
	                    field.fields = self._patchFields(moduleName, module, field.fields);
	                    return;
	                }
	
	                if (!_.isEmpty(fieldDef)) {
	                    // Create a definition if it doesn't exist
	                    if (_.isString(field)) {
	                        field = { name: field };
	                    }
	
	                    // Flatten out the viewdef, i.e. put 'displayParams' onto the viewdef
	                    // TODO: This should be done on the server-side on my opinion
	
	                    if (_.isObject(field.displayParams)) {
	                        _.extend(field, field.displayParams);
	                        delete field.displayParams;
	                    }
	
	                    // Assign type
	                    field.type = field.type || fieldDef.custom_type || fieldDef.type || 'base';
	                    // Patch type
	                    field.type = self.fieldTypeMap[field.type] || field.type;
	                    // Patch label
	                    field.label = field.label || fieldDef.vname || field.name;
	
	                    fields[fieldIndex] = field;
	                } else {
	                    // patch filler string fields to empty base fields of detail view
	                    if (field === '') {
	                        field = {
	                            view: 'detail'
	                        };
	                        fields[fieldIndex] = field;
	                    }
	                    // Ignore view fields that don't have module field definition
	                }
	            }, this);
	            return fields;
	        },
	
	        /**
	         * Sorts components in the order they should be declared as classes. This is required since a parent
	         * widget class must likewise be declared before a child that depends on it.
	         * @param {String} type Metadata type e.g. field, view. layout
	         * @param  {Array} components List of modules
	         * @param  {String} module Module name
	         * @return {Array} Sorted components
	         */
	        _sortControllers: function _sortControllers(type, components, module) {
	            var updated = {},
	                nameMap = {},
	                entries = {},
	                updateWeights = function updateWeights(entry) {
	                var controller = entry.controller;
	
	                // `base` will always be first
	                if (entry.type === 'base') {
	                    entries['Base' + app.utils.capitalize(type)].weight = -99999;
	                }
	
	                // Here we decrement the weight of any extended components. Note, that if sorting platform
	                // specific components (e.g. portal), and one "extends from" a base component, that parent
	                // will have already been declared since _sortControllers first gets called with base components
	                if (_.isObject(controller) && _.isString(controller.extendsFrom) && entries[controller.extendsFrom] && !updated[controller.extendsFrom]) {
	                    // Negative weights as we want to load those first
	                    entries[controller.extendsFrom].weight--;
	                    updated[controller.extendsFrom] = true;
	                    updateWeights(entries[controller.extendsFrom]);
	                }
	            };
	
	            // Start by creating a mapping from short name to final class name
	            // and precompiling all the controllers that are strings
	            _.each(components, function (entry, name) {
	                if (entry.controller) {
	                    var controller = entry.controller,
	                        className = (module || '') + app.utils.capitalizeHyphenated(name) + app.utils.capitalize(type);
	
	                    nameMap[className] = name;
	
	                    if (_.isString(controller)) {
	                        try {
	                            controller = eval("[" + controller + "][0]"); // jshint ignore:line
	                        } catch (e) {
	                            app.logger.error('Failed to eval view controller for ' + className + ': ' + e + ':\n' + entry.controller);
	                        }
	                    } else {
	                        /**
	                         * To create a layout or a view in a layout definition metadata file, the rules are:
	                         *     the name defines which metadata to use
	                         *     the type defines which js controller to use
	                         */
	                        // Log warnings when controllers for layouts/views have nothing else but "extendsFrom"
	                        var emptyController = type !== 'field' && Object.getOwnPropertyNames(controller).length === 1 && controller.hasOwnProperty('extendsFrom');
	                        if (emptyController) {
	                            app.logger.warn('Instead of creating an empty js controller `' + className + '` and specify the parent with extendsFrom, please use `type` property in the metadata `' + name + '`, to specify controller to use. It will allow you to delete your empty controllers and save memory.');
	                        }
	                    }
	
	                    entries[className] = {
	                        type: name,
	                        controller: controller,
	                        weight: 0
	                    };
	                }
	            });
	
	            // Replace standard base class with custom one if it exists
	            _.each(entries, function (entry, className) {
	                var controller = entry.controller,
	                    customExtendsFrom;
	                if (_.isObject(controller) && _.isString(controller.extendsFrom)) {
	                    customExtendsFrom = 'Custom' + controller.extendsFrom;
	                    if (customExtendsFrom in entries && className != customExtendsFrom) {
	                        controller.extendsFrom = customExtendsFrom;
	                    }
	                }
	            });
	
	            //Next calculate all the weights
	            _.each(entries, function (entry) {
	                updated = {};
	                updateWeights(entry);
	            });
	
	            return _.sortBy(entries, 'weight');
	        },
	
	        /**
	         * Helper to sort and declare components.
	         * @param  {Array} components
	         * @param  {String} type Type of component e.g. view, field, etc.
	         * @param  {String} moduleName Name of module
	         * @param  {String} platform Platform
	         */
	        _sortAndDeclareComponents: function _sortAndDeclareComponents(components, type, moduleName, platform) {
	            var entries,
	                self = this;
	
	            if (!_.isUndefined(components) && components) {
	                entries = self._sortControllers(type, components, moduleName);
	                if (type === 'data') {
	                    var model, collection;
	                    _.each(entries, function (entry) {
	                        if (entry.type === 'model') {
	                            model = entry.controller;
	                        } else if (entry.type === 'collection') {
	                            collection = entry.controller;
	                        }
	                    });
	                    app.data.declareModelClass(moduleName, null, platform, model);
	                    app.data.declareCollectionClass(moduleName, platform, collection);
	                } else {
	                    _.each(entries, function (entry) {
	                        app.view.declareComponent(type, entry.type, moduleName, entry.controller, true, platform);
	                    });
	                }
	            }
	        },
	        /**
	         * Helper to determine if the metadata type is separated by platforms
	         * e.g. <DATAOBJ>.views.portal.record.controller
	         * @param  {Object} data The object to check.
	         * @param  {String} type 'view', 'field', 'layout', etc.; will be pluralized internally
	         * @param  {Array} platforms List of currently loaded platforms e.g. ['base','portal']
	         * @return {Boolean} Indicating whether or not this meta type is separated by platform type
	         */
	        _metaTypeIsSeparatedByPlatform: function _metaTypeIsSeparatedByPlatform(data, type, platforms) {
	            if (!_.isUndefined(data[type + 's'])) {
	                // Iterate all possible platforms searching if meta type has a platform key
	                for (var i = 0; i < platforms.length; i++) {
	                    if (!_.isUndefined(data[type + 's'][platforms[i]])) {
	                        // Edge case: we have a field.base and might eventually have view.base etc.
	                        // (the field is actually named 'base'!) we're instead looking for: fields.base.x.controller
	                        if (_.isUndefined(data[type + 's'][platforms[i]].controller)) {
	                            return true;
	                        }
	                    }
	                }
	            }
	            return false;
	        },
	        /**
	         *
	         * @param data
	         * @private
	         */
	        _declareClasses: function _declareClasses(data) {
	            // Base components are always loaded first (so ordering of the following array matters!).
	            var self = this,
	                platforms = app.config.platform !== 'base' ? ['base', app.config.platform] : ['base'];
	
	            // Our root level metadata views/fields/layouts do not have separate platforms (whereas our
	            // generated jssource controllers are separated by platform). Today, only jssource has controllers.
	            // Declare field, view, layout classes that have custom controllers
	            _.each(['field', 'view', 'layout', 'data'], function (type) {
	                var components;
	
	                // Our root level metadata views/fields/layouts are not separated by platforms (whereas the
	                // "generated jssource controllers" are). Today, only jssource has controllers.
	                if (self._metaTypeIsSeparatedByPlatform(data, type, platforms)) {
	                    // Components of each platform are sorted amongst themselves. Base MUST be first (as defined in
	                    // our platforms list above). This way, all base components are guaranteed to be initialized first.
	                    _.each(platforms, function (platform) {
	                        components = data[type + 's'][platform];
	                        self._sortAndDeclareComponents(components, type, null, platform);
	                    }, this);
	                }
	            }, this);
	
	            // Patch module metadata, compile templates, and declare components for custom layouts and views
	            _.each(data.modules, function (entry, module) {
	                _initCustomComponents.call(this, entry, module);
	            }, this);
	        },
	
	        /**
	         * Gets metadata for all modules.
	         * @return {Object} Metadata for all modules.
	         */
	        getModules: function getModules() {
	            return _metadata.modules;
	        },
	
	        /**
	         * Gets list of module names that need to be hidden in subpanels
	         * @return {Object} Collection of module names that are hidden in subpanels
	         */
	        getHiddenSubpanels: function getHiddenSubpanels() {
	            return _metadata.hidden_subpanels;
	        },
	
	        /**
	         * Gets module metadata.
	         * @param {String} module Module name.
	         * @param {String} type (optional) Metadata type.
	         * @return {Object} Module metadata of specific type if type is specified. Otherwise, module's overall metadata.
	         */
	        getModule: function getModule(module, type) {
	            var metadata = this.getModules();
	            if (metadata) metadata = metadata[module];
	            if (metadata && type) metadata = metadata[type];
	            return metadata;
	        },
	
	        /**
	         * Gets a relationship definition.
	         * @param {String} name Relationship name.
	         * @return {Object} Relationship metadata or nothing if not found.
	         */
	        getRelationship: function getRelationship(name) {
	            return _metadata.relationships ? _metadata.relationships[name] : null;
	        },
	
	        /**
	         * Gets the field def for a given Module's field (or all fields if none
	         * is supplied).
	         *
	         * @param {Object} options.
	         * @param {string} options.module The module that we want to get the
	         *   vardefs.
	         * @param {string} [options.name] The field name to get the field def.
	         * @return {Object|undefined} Field def for the given Module, or all
	         *   fields if no `options.name` is supplied.
	         */
	        getField: function getField(options) {
	            if (_.isString(options) || options === void 0) {
	                var type = options;
	                app.logger.warn('`Core.Metadata#getField` signature is deprecated since 7.8 ' + 'and will be removed in 7.9. Please update your code.');
	                var metadata = _metadata.fields ? _metadata.fields[type] || _metadata.base : null;
	                return metadata ? app.metadata.copy(metadata, { field: type }) : metadata;
	            }
	
	            if (!options.module) {
	                throw new Error('Cannot get vardefs without a module');
	            }
	
	            var fields = this.getModule(options.module, 'fields');
	            if (fields && options.name) {
	                return fields[options.name];
	            }
	
	            return fields;
	        },
	
	        /**
	         * Gets view metadata.
	         * @param {string} module Module name.
	         * @param {string} [view] View name.
	         * @param {string} [loadModule] The module that should be considered base. Defaults to core metadata.
	         * @return {Object|null} View metadata if `view name` is specified.
	         *   Otherwise, metadata for all views of the given `module`.
	         *   If the optional view parameter is provided we instead return `null`
	         *   if view for module not found.
	         */
	        getView: function getView(module, view, loadModule) {
	
	            if (!module && !view) {
	                return _metadata.views;
	            }
	
	            var meta = this.getModule(module, 'views');
	
	            if (view) {
	                if (meta && meta[view] && meta[view].meta !== void 0) {
	                    meta = meta[view].meta;
	                } else if (loadModule) {
	                    meta = this.getModule(loadModule, 'views');
	                    meta = meta && meta[view] ? meta[view].meta : null;
	                } else if (_metadata.views && _metadata.views[view]) {
	                    meta = _metadata.views[view].meta;
	                } else {
	                    meta = null;
	                }
	            }
	
	            return meta ? app.metadata.copy(meta, { module: module, view: view }) : meta;
	        },
	
	        /**
	         * Gets layout metadata.
	         * @param {String} module Module name.
	         * @param {string} [layout] Layout name.
	         * @param {string} [loadModule] The module that should be considered base. Defaults to core metadata.
	         * @return {Object|null} Layout metadata if `layout` name is specified. Otherwise, metadata for all layouts of the given module.
	         * If the optional `layout` parameter is provided we instead return `null` if layout for module not found.
	         */
	        getLayout: function getLayout(module, layout, loadModule) {
	
	            if (!module && !layout) {
	                return _metadata.layouts;
	            }
	
	            var meta = this.getModule(module, 'layouts');
	
	            if (layout) {
	                if (meta && meta[layout] && meta[layout].meta !== void 0) {
	                    meta = meta[layout].meta;
	                } else if (loadModule) {
	                    meta = this.getModule(loadModule, 'layouts');
	                    meta = meta && meta[layout] ? meta[layout].meta : null;
	                } else if (_metadata.layouts && _metadata.layouts[layout]) {
	                    meta = _metadata.layouts[layout].meta;
	                } else {
	                    meta = null;
	                }
	            }
	
	            return meta ? app.metadata.copy(meta, { module: module, layout: layout }) : meta;
	        },
	
	        /**
	         * Gets an array of module names.
	         *
	         * The method signature changed.
	         * It used to accept a `visible` and `access` params, params are now
	         * contained into a single `options` object. The old signature is still
	         * supported for backward compatibility but is deprecated.
	         *
	         * @param {Object} [options] Additional options.
	         * @param {string} [options.filter] Returns only modules
	         *   that have this property enabled.
	         * @param {string} [options.access] Returns only modules
	         *   the user has permission to perform this action on.
	         *
	         * @return {Array} List of module names sorted by user settings.
	         */
	        getModuleNames: function getModuleNames(options) {
	
	            // List of available filters (and opposite filters)
	            var filters = ['enabled', '!enabled', 'visible', '!visible', 'display_tab', '!display_tab', 'show_subpanels', '!show_subpanels', 'quick_create', '!quick_create'];
	
	            options = options || {};
	            var moduleList = [];
	
	            // Clients may call an old version of the API that do not return
	            // _metadata.modules_info
	            var oldClient = _.isUndefined(_metadata.modules_info);
	            if (oldClient) {
	                moduleList = _.clone(app.user.get('module_list'));
	                if (options.access) {
	                    moduleList = _.filter(moduleList, function (module) {
	                        return app.acl.hasAccess(options.access, module);
	                    });
	                }
	                return moduleList || [];
	            }
	
	            var filter,
	                displayTabFilter = false;
	            if (options.filter) {
	                if (!_.isArray(options.filter)) {
	                    options.filter = [options.filter];
	                }
	                filter = [];
	                _.each(options.filter, function (f) {
	                    if (f && _.indexOf(filters, f) > -1) {
	                        filter.push(f);
	                        displayTabFilter = f === 'display_tab';
	                    } else if (f) {
	                        app.logger.warn('Can\'t filter getModuleNames by ' + f);
	                    }
	                });
	                if (_.isEmpty(filter)) {
	                    filter = undefined;
	                }
	            }
	
	            moduleList = _.chain(_metadata.modules_info).keys().without('_hash').value();
	
	            if (filter) {
	                _.each(filter, function (f) {
	                    var opposite = f.charAt(0) === '!';
	                    if (opposite) {
	                        // Get the opposite list and take the difference.
	                        var oppositeList = app.metadata.getModuleNames({
	                            filter: f.substring(1),
	                            access: options.access
	                        });
	                        moduleList = _.difference(moduleList, oppositeList);
	                    } else {
	                        // Filter the list
	                        moduleList = _.filter(moduleList, function (module) {
	                            return _metadata.modules_info[module][f];
	                        });
	                    }
	                });
	            }
	
	            if (!_.isEmpty(app.user.get('module_list'))) {
	                if (displayTabFilter) {
	                    moduleList = _.intersection(app.user.get('module_list'), moduleList);
	                } else if (!filter) {
	                    // Preserve order of user list
	                    moduleList = _.union(app.user.get('module_list'), moduleList);
	                }
	            }
	
	            if (options.access) {
	                moduleList = _.filter(moduleList, function (module) {
	                    return app.acl.hasAccess(options.access, module);
	                });
	            }
	
	            return moduleList;
	        },
	
	        /**
	         * Gets language strings for a given type.
	         * @param {String} type Type of string pack: `app_strings`, `app_list_strings`, `mod_strings`.
	         * @return Dictionary of strings.
	         */
	        getStrings: function getStrings(type) {
	            return _metadata[type] || {};
	        },
	
	        /**
	         * Gets FullModuleList
	         * @return Full module list.
	         */
	        getFullModuleList: function getFullModuleList() {
	            return _metadata.full_module_list || {};
	        },
	
	        /**
	         * Gets Config.
	         *
	         * @return Dictionary of Configs.
	         */
	        getConfig: function getConfig() {
	            return _metadata.config || {};
	        },
	
	        /**
	         * Gets the
	         * @return {String}
	         */
	        getBaseCurrencyId: function getBaseCurrencyId() {
	            // TODO this should be set on the _metadata
	            return '-99';
	        },
	
	        /**
	         * Gets a currency
	         *
	         * @param {String} currencyId
	         * @return {Object} currency object
	         */
	        getCurrency: function getCurrency(currencyId) {
	            return this.getCurrencies()[currencyId];
	        },
	
	        /**
	         * Gets currencies.
	         * @return {Object} Currency dictionary.
	         */
	        getCurrencies: function getCurrencies() {
	            return _metadata.currencies || {};
	        },
	
	        /**
	         * Gets company logo url
	         * @return {string} logo url
	         */
	        getLogoUrl: function getLogoUrl() {
	            return _metadata.logo_url;
	        },
	
	        /**
	         * Gets server information.
	         * @return {Object} Server information.
	         */
	        getServerInfo: function getServerInfo() {
	            return _metadata.server_info || {};
	        },
	
	        /**
	         * Gets the module tab mapping for megamenu
	         * @return {Object} Mapping of module: mappedModule
	         */
	        getModuleTabMap: function getModuleTabMap() {
	            return _metadata.module_tab_map || {};
	        },
	
	        /**
	         * Gets the mapped module name for a menu item if one exists. Otherwise
	         * gets the module that was passed in.
	         * @param  {String} module The module to get the mapped module for
	         * @return {String}
	         */
	        getTabMappedModule: function getTabMappedModule(module) {
	            var map = this.getModuleTabMap();
	            return map[module] || module;
	        },
	
	        /**
	         * Gets the list of filter operators.
	         *
	         * If any filter operators of a certain field type are defined at module
	         * level, these will take precedence over the ones available on core,
	         * thus completely overriding the latter.
	         *
	         * @param {string} [module] The module to get the filters for.
	         * @return {Object} The list of filter operators.
	         */
	        getFilterOperators: function getFilterOperators(module) {
	            var filters = _metadata.filters && _metadata.filters.operators && _metadata.filters.operators.meta || {};
	            var moduleData = module && this.getModule(module, 'filters');
	            var moduleFilters = moduleData && moduleData.operators && moduleData.operators.meta;
	
	            if (moduleFilters) {
	                return _.extend({}, filters, moduleFilters);
	            }
	
	            return filters;
	        },
	
	        /**
	         * Gets metadata object
	         *
	         * @return {Object}
	         */
	        get: function get() {
	            return _metadata;
	        },
	
	        /**
	         * Gets the list of dropdown keys that can be used when modifying a record
	         * @param  {String} dropdown The dropdown field to get the filter for
	         * @return {Object}
	         */
	        getEditableDropdownFilter: function getEditableDropdownFilter(dropdown) {
	            var filters = _metadata.editable_dropdown_filters;
	            if (filters && filters[dropdown]) {
	                return app.metadata.copy(filters[dropdown]);
	            }
	
	            return {};
	        },
	
	        /**
	         * Copies a metadata fragment.
	         *
	         * The default implementation performs deep copy. Client apps may override this behavior.
	         * @param {Object} meta Metadata object to be copied.
	         * @param {Object} options(optional) Options that describe the type of metadata to copy.
	         * The default implementation does not use them as it always performs deep copy regardless of metadata type.
	         * @return {Object} Deep copy of metadata.
	         */
	        copy: function copy(meta, options) {
	            return app.utils.deepCopy(meta);
	        },
	
	        /**
	         * Sets the metadata.
	         *
	         * By default this function is used by MetadataManager to translate server responses into metadata
	         * usable internally. The currently set metadata is preserved and extended by new metadata unless
	         * `reset` parameter equals to `true`.
	         * @param {Object} data Metadata payload returned by the server.
	         * @param {Boolean} isPublic Flag indicating if the public metadata must be fetched.
	         * @param {Boolean} reset Flag indicating if the the current metadata must be deleted.
	         */
	        set: function set(data, isPublic, reset) {
	
	            // Patch module metadata, compile templates, and declare components for custom layouts and views
	            _.each(data.modules, function (entry, module) {
	                this._patchMetadata(module, entry);
	            }, this);
	
	            this._declareClasses(data);
	
	            // Update application configuration
	            app.config = _.extend(app.config || {}, data.config);
	
	            // Compile templates if metadata has been changed
	            app.template.set(data, data._hash && data._hash != this.getHash(isPublic));
	
	            if (!_.isEmpty(data._hash)) _setHash(data, isPublic);
	
	            if (!reset) {
	                var overrideKeys = data._override_values || [];
	                delete data._override_values;
	                // Keep whatever we have and extend it with new stuff
	                _.each(data, function (value, key) {
	                    _metadata[key] = _.isObject(value) && !_.contains(overrideKeys, key) ? _.extend(_metadata[key] || {}, value) : value;
	                });
	            } else {
	                _metadata = data;
	            }
	
	            if (app.config.cacheMeta && !isPublic) {
	                _cacheMeta(_metadata);
	            }
	
	            if (app.config.env != 'prod') {
	                this._dev_data = _metadata;
	            }
	        },
	
	        /**
	         * Gets metadata hash.
	         * @param {Boolean} isPublic Flag indicating if the hash public metadata is requested (`true`).
	         * @return {String} Metadata hash tag.
	         */
	        getHash: function getHash(isPublic) {
	            var key = isPublic ? _keyPrefix + 'public:hash' : _keyPrefix + 'hash';
	            return app.cache.get(key) || _metadata._hash || '';
	        },
	
	        /**
	         * Syncs metadata from the server. Saves the metadata to the local cache.
	         * @param {Function} callback (optional) Callback function to be executed after sync completes.
	         * @param {Object} options (optional) Sync call options currently supports public:true to get public metadata.
	         */
	        sync: function sync(callback, options) {
	            _syncing = true;
	            options = options || {};
	            options.params = options.params || {};
	
	            var self = this,
	                metadataTypes = options.metadataTypes || (options.getPublic ? app.config.publicMetadataTypes : app.config.metadataTypes) || [],
	                errorCallback = function errorCallback(error) {
	                app.logger.debug('Failed fetching metadata');
	                if (!options.getPublic) {
	                    app.error.handleHttpError(error);
	                }
	                callback.call(self, error);
	            },
	                cb = callback;
	
	            // Force _syncing to be false no matter how we exit this function
	            callback = function callback(p) {
	                _syncing = false;
	                if (_.isFunction(cb)) cb(p);
	            };
	
	            app.api.getMetadata({ types: metadataTypes, callbacks: {
	                    success: function success(metadata) {
	                        var compatible;
	                        options = options || {};
	
	                        if (!_.isEmpty(metadata)) {
	                            app.logger.debug('Updating metadata');
	                            if (_mdLoaded[options.getPublic ? 'public:md' : 'md'] && self.getHash(options.getPublic) == metadata._hash && !options.forceRefresh) {
	                                app.logger.debug('Skipping update as metadata hash matches');
	                                return callback.call(self);
	                            }
	
	                            //If the response contains server_info, we need to run a compatibility check
	                            if (_.isEmpty(metadataTypes) || _.include(metadataTypes, 'server_info') && !options.getPublic) {
	                                compatible = app.isServerCompatible(metadata.server_info);
	                                //If compatible wasn't true, it will be set to an error string and we need to bomb out
	                                if (compatible !== true) {
	                                    return callback(compatible);
	                                }
	                            }
	
	                            _mdLoaded[options.getPublic ? 'public:md' : 'md'] = true;
	
	                            if (metadata.jssource) {
	                                self._loadJSSource(metadata, options, callback, errorCallback, self);
	                            } else {
	                                // Some clients may not want jssource (e.g. Nomad)
	                                if (metadata.labels || metadata.ordered_labels) {
	                                    _fetchLabels(metadata, {
	                                        language: options.language,
	                                        success: function success(labelsData) {
	                                            _injectLabels(metadata, labelsData);
	                                            self.set(metadata, options.getPublic);
	                                            callback.call(self);
	                                        },
	                                        error: errorCallback
	                                    });
	                                } else {
	                                    callback.call(self);
	                                }
	                            }
	                        } else {
	                            callback.call(self, {
	                                code: 'sync_failed',
	                                label: 'ERR_SYNC_FAILED'
	                            });
	                        }
	                    },
	                    error: errorCallback
	                }, public: options.getPublic, params: options.params });
	        },
	
	        /**
	         * Used to check if a metadata sync is currently in progress.
	         * @return {Boolean} true if a sync is in progress.
	         */
	        isSyncing: function isSyncing() {
	            return _syncing;
	        },
	
	        _loadJSSource: function _loadJSSource(metadata, options, callback, errorCallback, self) {
	            var scriptEl,
	                loadJS = this._checkJSSourceUpdated(metadata, !!options.getPublic);
	
	            //In the event of a hard reload, we can just stop the metadata sync
	            if (loadJS === 'reload') {
	                return app.utils.hardRefresh();
	            } else if (loadJS) {
	                SUGAR.jssource = false;
	                scriptEl = document.createElement("script");
	                scriptEl.src = app.utils.buildUrl(metadata.jssource);
	
	                document.head.appendChild(scriptEl);
	            }
	
	            async.parallel([function (cb) {
	                if (loadJS) {
	                    app.utils.doWhen('SUGAR.jssource', function () {
	                        self._declareClasses(SUGAR.jssource);
	                        cb();
	                    });
	                } else {
	                    cb();
	                }
	            }, function (cb) {
	                _fetchLabels(metadata, {
	                    language: options.language,
	                    success: function success(labelsData) {
	                        // Injects lang strings in server metadata. Must do this before the call to self.set in
	                        // case it's overridden by a client (bad!) which expects all meta properties in metadata.
	                        _injectLabels(metadata, labelsData);
	                        self.set(metadata, options.getPublic);
	                        cb();
	                    },
	                    error: function error() {
	                        errorCallback.apply(self, arguments);
	                        cb();
	                    }
	                });
	            }], function () {
	                if (callback) {
	                    callback.call(self);
	                }
	            });
	        },
	
	        /**
	         * Verifies that the jssource URL is new. If js was already loaded, 'reload' is returned to ensure the page
	         * loads the new javascript classes correctly.
	         * @param {object} metadata
	         * @param {boolean} isPublic
	         * @return {bool|String} true if the jssource shoudl be loaded, false if the jssource was already loaded,
	         *  and 'reload' if jssource was previously loaded from another URL
	         * @private
	         */
	        _checkJSSourceUpdated: function _checkJSSourceUpdated(metadata, isPublic) {
	            if (isPublic) {
	                //If we already loaded a JS source, we either need to clear memory for the new one,
	                //or we don't need to load the js file because it hasn't changed
	                if (this._publicJSSourceFile) {
	                    if (this._publicJSSourceFile != metadata.jssource) {
	                        return 'reload';
	                    }
	                    return false;
	                } else {
	                    this._publicJSSourceFile = metadata.jssource;
	                    return true;
	                }
	            }
	            //In private reload, if public changed, we still need a refresh
	            if (metadata.jssource_public && this._publicJSSourceFile && metadata.jssource_public != this._publicJSSourceFile) {
	                app.utils.hardRefresh();
	                return 'reload';
	            }
	            //Finally verify the private jssource file
	            if (this._jsSourceFile) {
	                if (this._jsSourceFile != metadata.jssource) {
	                    return 'reload';
	                }
	                return false;
	            }
	            // Update the private jssource file so that we don't reload it again
	            this._jsSourceFile = metadata.jssource;
	            return true;
	        },
	
	        init: function init() {
	            _.bindAll(this, 'storageHandler');
	
	            // For more information about the `storage` event, see
	            // https://developer.mozilla.org/en-US/docs/Web/Events/storage
	            window.addEventListener('storage', this.storageHandler);
	
	            // Load metadata from local storage upon app initialization
	            if (app.config.cacheMeta) {
	                var data = _getCachedMeta();
	                if (data) this.set(data, false);
	            }
	            app.events.on('cache:clean', function (cb) {
	                cb([_keyPrefix + 'public:hash', _keyPrefix + 'hash', _keyPrefix + 'data']);
	            });
	        },
	
	        /**
	         * Checks to see if the metadata needs to sync with the server.
	         */
	        storageHandler: function storageHandler() {
	
	            if (!_syncing && (this.getHash() != _metadata._hash && _mdLoaded.md || app.api.getUserprefHash() && app.user.get('_hash') && app.api.getUserprefHash() != app.user.get('_hash'))) {
	                _syncing = true;
	                _mdLoaded.md = false;
	                app.sync({
	                    getPublic: !app.api.isAuthenticated()
	                });
	            }
	        },
	
	        /**
	         * Purges metadata from the persistent cache.
	         */
	        clearCache: function clearCache() {
	            app.cache.cut(_keyPrefix + 'public:hash');
	            app.cache.cut(_keyPrefix + 'hash');
	            app.cache.cut(_keyPrefix + 'data');
	        },
	
	        /**
	         * Resets internal memory cache and clears persistent storage.
	         */
	        reset: function reset() {
	            _metadata = {};
	            this.clearCache();
	        }
	
	    }, false);
	})(SUGAR.App);

/***/ },
/* 47 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	    /**
	     * Checks ACL for modules and fields.
	     *
	     * @class Core.Acl
	     * @alias SUGAR.App.acl
	     * @singleton
	     */
	    app.augment('acl', {
	
	        /**
	         * Cache for {@link Core.Acl#hasAccessToAny} function.
	         * @property {Object} _accessToAny
	         * @private
	         */
	        _accessToAny: {},
	
	        /**
	         * Dictionary that maps actions to permissions.
	         * @property {Object}
	         */
	        action2permission: {
	            'view': 'read',
	            'readonly': 'read',
	            'edit': 'write',
	            'detail': 'read',
	            'list': 'read',
	            'disabled': 'read'
	        },
	
	        /**
	         * Initialization
	         *
	         * Setup handler on `app:sync:complete` event to clear cache.
	         * @param {App} app
	         */
	        init: function init(app) {
	            if (app) {
	                app.events.on('app:sync:complete', this.clearCache, this);
	            }
	        },
	
	        /**
	         * Clear cached variables for acl.
	         */
	        clearCache: function clearCache() {
	            this._accessToAny = {};
	        },
	
	        /**
	         * ACL helper to convert ACLs data into booleans.
	         *
	         * @param {string} action Action name.
	         * @param {Object} acls ACL hash.
	         * @return {boolean} Flag indicating if the current user has access.
	         */
	        _hasAccess: function _hasAccess(action, acls) {
	            var access;
	
	            if (acls.access === 'no') {
	                access = 'no';
	            } else {
	                access = acls[action];
	            }
	
	            return access !== 'no';
	        },
	
	        /**
	         * ACL helper to convert ACLs data on fields into booleans.
	         *
	         * @param {string} action Action name.
	         * @param {Object} acls ACL hash.
	         * @param {string} field Name of the Module's field.
	         * @return {boolean} Flag indicating if the current user has access.
	         */
	        _hasAccessToField: function _hasAccessToField(action, acls, field) {
	            var access;
	
	            action = this.action2permission[action] || action;
	            if (acls.fields[field] && acls.fields[field][action]) {
	                access = acls.fields[field][action];
	            }
	
	            return access !== 'no';
	        },
	
	        /**
	         * Checks ACLs to see if the current user has access to action on a
	         * given module or record.
	         *
	         * @param {string} action Action name.
	         * @param {string} module Module name.
	         * @param {Object} [options] Options.
	         * @param {string} [options.field] Name of the field to check access.
	         * @param {string} [options.acls] Record's ACLs that take precedence
	         *   over the module's ACLs. These are normally supplied by the server
	         *   as part of the data response in `_acl`.
	         * @return {boolean} Flag indicating if the current user has access.
	         */
	        hasAccess: function hasAccess(action, module, options) {
	            var field;
	            var recordAcls;
	
	            if (!_.isObject(options)) {
	                // TODO: Throw deprecation warning and remove this code.
	                field = arguments[3];
	                recordAcls = arguments[4];
	            } else {
	                field = options.field;
	                recordAcls = options.acls;
	            }
	
	            var acls = app.user.getAcls()[module];
	            if (!acls && !recordAcls) {
	                return true;
	            }
	
	            acls = acls || {};
	            if (recordAcls) {
	                var fieldAcls = _.extend({}, acls.fields, recordAcls.fields);
	                acls = _.extend({}, acls, recordAcls);
	                acls.fields = fieldAcls;
	            }
	
	            var access = this._hasAccess(action, acls);
	            if (access && field && acls.fields) {
	                access = this._hasAccessToField(action, acls, field);
	
	                // if the field is in a group, see if we have access to the group
	                var moduleMeta = app.metadata.getModule(module);
	                var fieldMeta = moduleMeta && moduleMeta.fields ? moduleMeta.fields[field] : null;
	                if (access && fieldMeta && fieldMeta.group) {
	                    access = this._hasAccessToField(action, acls, fieldMeta.group);
	                }
	            }
	
	            return access;
	        },
	
	        /**
	         * Checks ACLs to see if the current user has access to action on a given model's field.
	         *
	         * @param {String} action Action name.
	         * @param {Object} model(optional) Model instance.
	         * @param {String} field(optional) Name of the model field.
	         * @return {Boolean} Flag indicating if the current user has access to the given action.
	         */
	        hasAccessToModel: function hasAccessToModel(action, model, field) {
	            var id;
	            var module;
	            var assignedUserId;
	            var acls;
	
	            if (model) {
	                id = model.id;
	                module = model.module;
	                assignedUserId = model.original_assigned_user_id || model.get("assigned_user_id");
	                acls = model.get('_acl') || { fields: {} };
	            }
	
	            if (action == 'edit' && !id) {
	                action = 'create';
	            }
	
	            return this.hasAccess(action, module, assignedUserId, field, acls);
	        },
	
	        /**
	         * Checks ACLs to see if the current user has access to any module with defined action.
	         *
	         * @param {String} action Action name.
	         * @return {Boolean} Flag indicating if the current user has access to the given action.
	         *
	         *     // Check whether user has `admin` access for any module.
	         *     app.acl.hasAccessToAny('admin');
	         *
	         *     // Check whether user has `developer` access for any module.
	         *     app.acl.hasAccessToAny('developer');
	         */
	        hasAccessToAny: function hasAccessToAny(action) {
	            if (_.isUndefined(this._accessToAny[action])) {
	                this._accessToAny[action] = _.some(app.user.getAcls(), function (obj, module) {
	                    return this.hasAccess(action, module);
	                }, this);
	            }
	            return this._accessToAny[action];
	        }
	    }, true);
	})(SUGAR.App);

/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	
	    /**
	     * Represents application's current user object.
	     *
	     * The user object contains settings that are fetched from the server
	     * and whatever settings application wants to store.
	     *
	     * <pre><code>
	     * // Sample user object that is fetched from the server:
	     * {
	     *      id: "1",
	     *      full_name: "Administrator",
	     *      user_name: "admin",
	     *      preferences: {
	     *          timezone: "America\/Los_Angeles",
	     *          datepref: "m\/d\/Y",
	     *          timepref: "h:ia"
	     *      }
	     * }
	     *
	     * // Use it like this:
	     * var userId = SUGAR.App.user.get('id');
	     * // Set app specific settings
	     * SUGAR.App.user.set("sortBy:Cases", "case_number");
	     *
	     * // Bind event handlers if necessary
	     * SUGAR.App.user.on("change", function() {
	     *     // Do your thing
	     * });
	     *
	     * </code></pre>
	     *
	     * @class Core.User
	     * @alias SUGAR.App.user
	     * @singleton
	     */
	    var User = Backbone.Model.extend({
	
	        /**
	         * Retrieves and sets the user preferences
	         *
	         * @param {Function} callback(optional) Callback called when update completes.
	         */
	        load: function load(callback) {
	            app.api.me('read', null, null, {
	                success: function success(data) {
	                    if (data && data.current_user) {
	                        // Set the user pref hash into the cache for use in
	                        // checking user pref state change
	                        if (data.current_user._hash) {
	                            app.cache.set('userpref:hash', data.current_user._hash);
	                        }
	                        app.user.set(data.current_user);
	                        var language = app.user.getPreference('language');
	                        if (app.lang.getLanguage() !== language) {
	                            app.lang.setLanguage(language, null, {
	                                noUserUpdate: true,
	                                noSync: app.isSynced || app.metadata.isSyncing()
	                            });
	                        }
	                    }
	                    if (callback) callback();
	                },
	                error: function error(err) {
	                    app.error.handleHttpError(err);
	                    if (callback) callback(err);
	                }
	            });
	        },
	        // Fixme This doesn't belong in user. See TY-526.
	        loadLocale: function loadLocale(callback) {
	            app.api.call('read', app.api.buildURL('locale'), null, {
	                success: function success(data) {
	                    if (callback) callback(data);
	                },
	                error: function error(err) {
	                    app.error.handleHttpError(err);
	                    if (callback) callback(err);
	                }
	            });
	        },
	        /**
	         * Updates the preferred language of the user.
	         *
	         * @param {String} language language Key
	         * @param {Function} callback(optional) Callback called when update completes.
	         */
	        getLanguage: function getLanguage() {
	            return app.user.getPreference('language') || app.cache.get("lang");
	        },
	
	        /**
	         * Updates the preferred language of the user.
	         *
	         * @param {String} language language Key
	         * @param {Function} callback(optional) Callback called when update completes.
	         */
	        updateLanguage: function updateLanguage(language, callback) {
	            //Note that `err` is only relevant here when called for error case
	            var done = function done(err) {
	                if (!err) app.lang.updateLanguage(language);
	                if (callback) callback(err);
	            };
	            this.update("update", { preferred_language: language }, done);
	        },
	
	        /**
	         * Updates the user's profile.
	         *
	         * @param {Object} attributes The model attributes to update for user.
	         * @param {Function} callback(optional) Callback called when update completes.
	         */
	        updateProfile: function updateProfile(attributes, callback) {
	            //Note that `err` is only relevant here when called for error case
	            var done = function done(err) {
	                if (callback) callback(err);
	            };
	            this.update("update", attributes, done);
	        },
	        /**
	         * Updates the user's preferences.
	         *
	         * @param {Object} attributes The attributes to update for user.
	         * @param {Function} callback(optional) Callback called when update completes.
	         */
	        updatePreferences: function updatePreferences(attributes, callback) {
	            var self = this;
	            if (app.api.isAuthenticated()) {
	                app.api.call("update", app.api.buildURL('me/preferences'), attributes, {
	                    success: function success(data) {
	                        if (data._hash) {
	                            app.cache.set("userpref:hash", data._hash);
	                            app.user.set({ "_hash": data._hash });
	                        }
	                        //Immediately update our user's preferences to reflect latest changes
	                        _.each(attributes, function (val, key) {
	                            if (data[key]) {
	                                self.setPreference(key, data[key]);
	                            }
	                        });
	                        if (callback) callback();
	                    },
	                    error: function error(err) {
	                        app.error.handleHttpError(err);
	                        if (callback) callback(err);
	                    }
	                });
	            } else {
	                if (callback) callback();
	            }
	        },
	
	        /**
	         * Updates the user
	         *
	         * @param {String} method operation type: read, update, create, delete {@see SUGAR.Api#me}
	         * @param {Object} payload An object literal with payload
	         * @param {Object} done Callback called when update completes. In case of
	         * error, app.error.handleHttpError will already be handled here.
	         */
	        update: function update(method, payload, callback) {
	            if (app.api.isAuthenticated()) {
	                app.api.me(method, payload, null, {
	                    success: function success(data) {
	                        if (data.current_user) {
	                            if (data.current_user._hash) {
	                                app.cache.set("userpref:hash", data.current_user._hash);
	                            }
	                            app.user.set(data.current_user);
	                        }
	                        if (callback) callback();
	                    },
	                    error: function error(err) {
	                        app.error.handleHttpError(err);
	                        if (callback) callback(err);
	                    }
	                });
	            } else {
	                callback();
	            }
	        },
	
	        /**
	         * Gets ACLs.
	         *
	         * @return Dictionary of ACLs. Precondition - user's logged in or a _reset call has set the user manually.
	         */
	        getAcls: function getAcls() {
	            return app.user.get('acl') || {};
	        },
	
	        /**
	         * Get preference by name.
	         *
	         * TODO support category parameter for preferences.
	         *
	         * @param {string} name The preference name.
	         * @return {Array|Object|string|number|boolean} The value of the user
	         *   preference.
	         */
	        getPreference: function getPreference(name) {
	
	            var preferences = app.user.get('preferences') || {};
	            return preferences[name];
	        },
	
	        /**
	         * Set preference by name, will only be stored locally.
	         *
	         * TODO support category parameter for preferences.
	         * TODO support save preferences on server.
	         *
	         * @param {String} name The preference name.
	         * @param {Array/Object/String/Number/Boolean} value The new value of the user preference.
	         * @return {Object} the instance of this user.
	         */
	        setPreference: function setPreference(name, value) {
	            var preferences = app.user.get('preferences') || {};
	            preferences[name] = value;
	            return app.user.set('preferences', preferences);
	        },
	
	        /**
	         * Returns an object with all the user's currency preferences
	         * If the user hasn't specified any preferences, these default to system currency preferences
	         *
	         * @return {Object} The currency preferences of the user
	         */
	        getCurrency: function getCurrency() {
	            var preferences = app.user.get('preferences'),
	                currencyObj = {};
	
	            if (preferences) {
	                currencyObj.currency_id = preferences.currency_id;
	                currencyObj.currency_iso = preferences.currency_iso;
	                currencyObj.currency_name = preferences.currency_name;
	                currencyObj.currency_rate = preferences.currency_rate;
	                currencyObj.currency_show_preferred = preferences.currency_show_preferred;
	                currencyObj.currency_symbol = preferences.currency_symbol;
	            }
	
	            return currencyObj;
	        },
	
	        /**
	         * Allows interactions with the last state values, which are used to implement last application
	         * states or the "stickiness" of the application.
	         */
	        lastState: function () {
	            var keySeparator = ':',
	                keyPrefix = 'last-state',
	                lastStates = {},
	                preservedKeys = [];
	
	            var buildLastStateKeyForStorage = function buildLastStateKeyForStorage(key) {
	                var keyParts = key.split(keySeparator),
	                    storedKey = [app.user.id, keyPrefix];
	
	                storedKey = storedKey.concat(keyParts);
	
	                return storedKey.join(keySeparator);
	            };
	
	            var getLastStateId = function getLastStateId(component) {
	                var lastStateId;
	
	                if (component.meta && component.meta.last_state) {
	                    lastStateId = component.meta.last_state.id;
	                }
	
	                return lastStateId;
	            };
	
	            return {
	                /**
	                 * Get the last state value given a key. If doesn't exist,
	                 * return the default value as specified in the component
	                 * metadata.
	                 *
	                 * @param {string} key
	                 * @return {number|boolean|string|Array|Object} The last state
	                 *   value.
	                 */
	                get: function get(key) {
	                    var result, storedKey;
	
	                    if (!_.isUndefined(key)) {
	                        storedKey = buildLastStateKeyForStorage(key);
	                        result = app.cache.get(storedKey);
	                        result = result === void 0 ? this.defaults(key) : result;
	                    }
	
	                    return result;
	                },
	
	                /**
	                 * Save the last state in local storage.
	                 *
	                 * @param {string} key
	                 * @param {string} value
	                 */
	                set: function set(key, value) {
	                    if (!_.isUndefined(key) && !_.isUndefined(value)) {
	                        var storedKey = buildLastStateKeyForStorage(key);
	                        app.cache.set(storedKey, value);
	                    }
	                },
	
	                /**
	                 * Register a state as important (should survive a cache clean)
	                 *
	                 * @param {string} key
	                 * @param {string} value
	                 */
	                preserve: function preserve(key) {
	                    if (!_.isUndefined(key)) {
	                        preservedKeys.push(key);
	                    }
	                },
	
	                /**
	                 * Get the key for a given component, which is used as a key for CRUD operations on
	                 * last state values.
	                 *
	                 * @param {string} name
	                 * @param {Object} component
	                 * @return {string}
	                 */
	                key: function key(name, component) {
	                    var lastStateId = getLastStateId(component);
	                    return this.buildKey(name, lastStateId, component.module);
	                },
	
	                /**
	                 * Build the key for a given name, lastStateId, and (optionally) module,
	                 * which is used as a key for CRUD operations on last state values.
	                 *
	                 * @param {string} name
	                 * @param {string} lastStateId
	                 * @param {string} [module]
	                 * @return {string}
	                 */
	                buildKey: function buildKey(name, lastStateId, module) {
	                    var keyString,
	                        keyParts = [];
	
	                    if (lastStateId) {
	                        if (module) {
	                            keyParts.push(module);
	                        }
	                        keyParts.push(lastStateId, name);
	                        keyString = keyParts.join(keySeparator);
	                    }
	
	                    return keyString;
	                },
	
	                /**
	                 * Get the default last state for a key.
	                 *
	                 * @param {string} key
	                 * @return {string}
	                 */
	                defaults: function defaults(key) {
	                    return lastStates[key];
	                },
	
	                /**
	                 * Register last states default values given a component.
	                 * The default value is specified in the component metadata.
	                 *
	                 * @param {Object} component
	                 */
	                register: function register(component) {
	                    var lastStateId = getLastStateId(component);
	                    if (lastStateId) {
	                        _.each(component.meta.last_state.defaults, function (defaultState, key) {
	                            lastStates[this.key(key, component)] = defaultState;
	                        }, this);
	                    }
	                },
	
	                /**
	                 * Delete last state from local storage
	                 *
	                 * @param {String} key
	                 */
	                remove: function remove(key) {
	                    var storedKey;
	                    if (!_.isUndefined(key)) {
	                        storedKey = buildLastStateKeyForStorage(key);
	                        app.cache.cut(storedKey);
	                    }
	                },
	                /**
	                 * @return {Array} list of high value keys in cache
	                 * @private
	                 */
	                _getPreservedKeys: function _getPreservedKeys() {
	                    var ret = [];
	                    _.each(preservedKeys, function (key) {
	                        ret.push(buildLastStateKeyForStorage(key));
	                    });
	                    return ret;
	                }
	            };
	        }()
	    });
	
	    //FIXME Have a unit test to test the function in logout in TY-615
	    app.events.on('app:logout', function (clear) {
	        app.cache.cut('userpref:hash');
	        if (clear === true) {
	            app.user.clear({ silent: true });
	        }
	    });
	
	    app.events.on("cache:clean", function (cb) {
	        cb(app.user.lastState._getPreservedKeys());
	    });
	
	    app.augment("user", new User(), false);
	})(SUGAR.App);

/***/ },
/* 49 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	
	/**
	 * Manages plugins
	 *
	 * This code shows how to define plugin.
	 *
	 * <pre><code>
	 * (function(app) {
	 *
	 *      app.plugins.register('fast-click-highlight', ['view', 'field'], {
	 *          color : "red",
	 *
	 *          events: {
	 *              'click .fast-click-highlighted': 'onClickItem'
	 *          },
	 *
	 *          onClickItem: function(e) {
	 *              alert(1)
	 *          },
	 *
	 *
	 *          //The onAttach function will be called every time the plugin is attached to a new
	 *          //component. It will be executed from the scope of the component being attached to.
	 *          //Applied after the plugin has been mixed into the component
	 *          onAttach: function(component, plugin) {
	 *              this.on('render', function(){
	 *                  this.$el.css('color', this.color); //same as plugin.color and component.$el.css
	 *              });
	 *          }
	 *      });
	 *
	 * })(SUGAR.App);
	 * </code></pre>
	 *
	 * If you want to use current plugin for view, you have to declare plugin in it.
	 *
	 * <pre><code>
	 *    var MyView = app.view.View.extend({
	 *
	 *      initialize: function(options) {},
	 *
	 *      plugins: ['fast-click-highlight'],
	 *      ...
	 *
	 *      or
	 *
	 *      $plugins: [{
	 *          'fast-click-highlight': {
	 *              events:{
	 *                  'click article' : 'onClickItem'
	 *              }
	 *          }
	 *      }],
	 *
	 *      onClickItem : function() {
	 *          alert(2)
	 *      }
	 * </code></pre>
	 *
	 *
	 * If you want to disable plugin, you have to use disabledPlugins property as in following example:
	 *
	 * <pre><code>
	 *    var MyView = app.view.View.extend({
	 *
	 *      initialize: function(options) {},
	 *
	 *      disabledPlugins: ['fast-click-highlight'],
	 *
	 *      ...
	 * </code></pre>
	 *
	 * @class Core.PluginManager
	 * @alias SUGAR.App.metadata
	 * @singleton
	 */
	(function (app) {
	
	    var _pluginManager = {
	
	        plugins: {
	            view: {},
	            field: {},
	            layout: {},
	            model: {},
	            collection: {}
	        },
	
	        /**
	         * Get plugin by name.
	         * @param name String Plugin name
	         * @param type String component type. (view, layout, or field, model, collection)
	         * @private
	         */
	        _get: function _get(name, type) {
	            if (this.plugins[type] && this.plugins[type][name]) {
	                return this.plugins[type][name];
	            }
	        },
	
	        /**
	         * Attaches plugin to view.
	         *
	         * @param {View.Component|Data.Bean|Data.BeanCollection} component The
	         *   component object ({@link View.View View},
	         *   {@link View.Field Field}, {@link View.Layout Layout},
	         *   {@link Data.Bean Bean}, {@link Data.BeanCollection Collection}).
	         * @param {string} type The component type (view, layout, or field,
	         *   model, collection).
	         */
	        attach: function attach(component, type) {
	            _.each(component.plugins, function (pluginName) {
	                var prop = null;
	                if (_.isObject(pluginName)) {
	                    var n = _.keys(pluginName)[0];
	                    prop = pluginName[n];
	                    pluginName = n;
	                }
	
	                var p = this._get(pluginName, type);
	                if (p && !this._isPluginDisabled(component, pluginName)) {
	                    var events = _.extend({}, _.isFunction(component.events) ? component.events() : component.events, p.events);
	
	                    _.extend(component, p);
	
	                    if (prop) {
	                        _.extend(component, prop);
	
	                        if (prop.events) {
	                            _.extend(events, prop.events);
	                        }
	                    }
	
	                    component.events = events;
	
	                    //If a plugin has an onAttach function, call it now so that the plugin can initialize
	                    if (_.isFunction(p.onAttach)) {
	                        p.onAttach.call(component, component, p);
	                    }
	                }
	            }, this);
	        },
	
	        /**
	         * Detaches plugins and call `onDetach` method.
	         *
	         * @param {View.Component|Data.Bean|Data.BeanCollection} component The
	         *   component object ({@link View.View View},
	         *   {@link View.Field Field}, {@link View.Layout Layout},
	         *   {@link Data.Bean Bean}, {@link Data.BeanCollection Collection}).
	         * @param {string} type The component type (view, layout, or field,
	         *   model, collection).
	         */
	        detach: function detach(component, type) {
	            _.each(component.plugins, function (name) {
	                var plugin = this._get(name, type);
	                if (plugin && _.isFunction(plugin.onDetach)) {
	                    plugin.onDetach.call(component, component, plugin);
	                }
	            }, this);
	        },
	
	        /**
	         * Check plugin is disabled.
	         * @param component Component object
	         * @param pluginName Plugin name
	         * @private
	         */
	        _isPluginDisabled: function _isPluginDisabled(component, pluginName) {
	            return !!_.find(component.disabledPlugins, function (name) {
	                return name === pluginName;
	            });
	        },
	
	        /**
	         * Register plugin.
	         * @param {string} name The plugin name.
	         * @param {string|Array} validTypes The list of component types this
	         *   plugin can be applied to (view, field, layout, model, collection).
	         * @param {Object} plugin The plugin object.
	         */
	        register: function register(name, validTypes, plugin) {
	            if (!_.isArray(validTypes)) {
	                validTypes = [validTypes];
	            }
	
	            _.each(validTypes, function (type) {
	                this.plugins[type] = this.plugins[type] || {};
	                this.plugins[type][name] = plugin;
	            }, this);
	        }
	    };
	
	    app.augment("plugins", _pluginManager, false);
	})(SUGAR.App);

/***/ },
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * Application logger.
	 *
	 * ```
	 * // Log a string message
	 * SUGAR.App.logger.debug("Some debug message");
	 *
	 * // Log an object
	 * var obj = { foo: "bar" };
	 * SUGAR.App.logger.info(obj);
	 *
	 * // Log a closure.
	 * var a = 1;
	 * SUGAR.App.logger.error(function() { return a; });
	 * ```
	 *
	 * @class Utils.Logger
	 * @alias SUGAR.App.logger
	 * @singleton
	 */
	(function (app) {
	
	    app.augment('logger', {
	
	        /**
	         * Logging levels.
	         *
	         * @class Utils.Logger.levels
	         * @singleton
	         */
	        levels: {
	            /**
	             * Trace log level
	             * @property {Utils.Logger.levels}
	             */
	            TRACE: {
	                value: 1,
	                name: 'TRACE'
	            },
	            /**
	             * Debug log level
	             * @property {Utils.Logger.levels}
	             */
	            DEBUG: {
	                value: 2,
	                name: 'DEBUG'
	            },
	            /**
	             * Info log level
	             * @property {Utils.Logger.levels}
	             */
	            INFO: {
	                value: 3,
	                name: 'INFO'
	            },
	            /**
	             * Warn log level
	             * @property {Utils.Logger.levels}
	             */
	            WARN: {
	                value: 4,
	                name: 'WARN'
	            },
	            /**
	             * Error log level
	             * @property {Utils.Logger.levels}
	             */
	            ERROR: {
	                value: 5,
	                name: 'ERROR'
	            },
	            /**
	             * Fatal log level
	             * @property {Utils.Logger.levels}
	             */
	            FATAL: {
	                value: 6,
	                name: 'FATAL'
	            }
	        },
	
	        /**
	         * Turns on the warnings regarding usage of jQuery deprecated methods.
	         */
	        init: function init() {
	            // TODO this will be removed by SC-5256.
	            if (!window.jQuery) {
	                return;
	            }
	            app.on('app:sync:complete', function () {
	                jQuery.migrateMute = this.getLevel().value > this.levels.WARN.value;
	            }, this);
	        },
	
	        /**
	         * Outputs messages onto browser's console object.
	         *
	         * @class Utils.Logger.ConsoleWriter
	         * @member Utils.Logger
	         * @singleton
	         */
	        ConsoleWriter: {
	            /**
	             * Outputs a message with the specified log level onto the browser's console.
	             * The writer uses:
	             *
	             *  - `console.info`: `TRACE`, `DEBUG` and `INFO`.
	             *  - `console.warn`: `WARN`.
	             *  - `console.error`: `ERROR` and `FATAL`.
	             *
	             * @param {Utils.Logger.levels} level A logger level from logger.levels
	             * @param {String} message
	             * @method
	             */
	            write: function write(level, message) {
	                // work around for browsers without console
	                if (!window.console) window.console = {};
	                if (!window.console.log) window.console.log = function () {};
	                if (level.value <= app.logger.levels.INFO.value) {
	                    console.log(message);
	                } else if (level.value == app.logger.levels.WARN.value) {
	                    console.warn(message);
	                } else {
	                    console.error(message);
	                }
	            }
	        },
	
	        /**
	         * Writes log messages onto server.
	         *
	         * @class Utils.Logger.ServerWriter
	         * @member Utils.Logger
	         * @singleton
	         */
	        ServerWriter: {
	            /**
	             * Writes a log message with a given {@link Utils.Logger.levels}
	             * level onto the server.
	             *
	             * @param {Utils.Logger.levels} level Logger level.
	             * @param {String} message Log message.
	             * @throws {String} Exceptions are thrown whether the returned
	             *    status is `false` or an error occurred while processing the request.
	             */
	            write: function write(level, message) {
	                // FIXME: add support for other logger levels (SC-5483).
	                if (level.value < app.logger.levels.WARN.value) {
	                    return;
	                }
	
	                if (!app.api.isAuthenticated()) {
	                    return;
	                }
	
	                var write = app.config.logger && app.config.logger.writeToServer || false;
	                if (!write || !message.trim().length) {
	                    return;
	                }
	
	                var url = app.api.buildURL(undefined, 'logger');
	                var params = {
	                    level: level.name.toLowerCase(),
	                    message: message
	                };
	
	                app.api.call('create', url, params, {
	                    success: function success(data) {
	                        if (!data.status) {
	                            throw 'Failed to write log message {' + message + '} onto server';
	                        }
	                    },
	                    error: function error(e) {
	                        throw e;
	                    }
	                });
	            }
	        },
	
	        /**
	         * Formats a log message as a string with log level and UTC timestamp.
	         * <pre><code>
	         * // Log a trace message
	         * SUGAR.App.logger.trace("Blah-blah");
	         *
	         * // Output
	         * // TRACE[2012-1-26 2:38:23]: Blah-blah
	         * </code></pre>
	         *
	         * @class Utils.Logger.SimpleFormatter
	         * @member Utils.Logger
	         * @singleton
	         */
	        SimpleFormatter: {
	            /**
	             * Formats a log message by adding log level name and UTC timestamp.
	             * @param {Object} level logging level
	             * @param {String} message log message
	             * @param {Date} date logging timestamp
	             * @return {String} formatted log message
	             * @method
	             */
	            format: function format(level, message, date) {
	                var dateString = date.getUTCFullYear() + '-' + (date.getUTCMonth() + 1) + '-' + date.getUTCDate() + ' ' + date.getUTCHours() + ':' + date.getUTCMinutes() + ':' + date.getUTCSeconds();
	                return level.name + '[' + dateString + ']: ' + message;
	            }
	        },
	
	        /**
	         * Logs a message with a TRACE log level.
	         * @param {string|Object|Function} message log message
	         * @member Utils.Logger
	         */
	        trace: function trace(message) {
	            this.log(this.levels.TRACE, message);
	        },
	
	        /**
	         * Logs a message with DEBUG log level.
	         * @param {string|Object|Function} message log message
	         * @member Utils.Logger
	         */
	        debug: function debug(message) {
	            this.log(this.levels.DEBUG, message);
	        },
	
	        /**
	         * Logs a message with INFO log level.
	         * @param {string|Object|Function} message log message
	         * @member Utils.Logger
	         */
	        info: function info(message) {
	            this.log(this.levels.INFO, message);
	        },
	
	        /**
	         * Logs a message with WARN log level.
	         * @param {string|Object|Function} message log message
	         * @member Utils.Logger
	         */
	        warn: function warn(message) {
	            this.log(this.levels.WARN, message);
	        },
	
	        /**
	         * Logs a message with ERROR log level.
	         * @param {string|Object|Function} message log message
	         * @member Utils.Logger
	         */
	        error: function error(message) {
	            this.log(this.levels.ERROR, message);
	        },
	
	        /**
	         * Logs a message with FATAL log level.
	         * @param {string|Object|Function} message log message
	         * @member Utils.Logger
	         */
	        fatal: function fatal(message) {
	            this.log(this.levels.FATAL, message);
	        },
	
	        /**
	         * Retrieve logger level based on system settings.
	         *
	         * @member Utils.Logger
	         * @return {Object} Logger level or `this.levels.ERROR` if none defined.
	         */
	        getLevel: function getLevel() {
	            var level = app.config.logger && app.config.logger.level;
	
	            /**
	             * @deprecated 7.7 It will be removed in 7.9.
	             *   Use `app.config.logger.level` instead.
	             * @property logLevel
	             * @member SUGAR.App.config
	             * FIXME: SC-5469 Remove deprecatedLevel.
	             */
	            var deprecatedLevel = app.config.logLevel;
	            if (!level && deprecatedLevel) {
	                level = deprecatedLevel;
	                console.warn('The property `app.config.logLevel` has been ' + 'deprecated since 7.7.0.0 and will be removed in 7.9.0.0.' + ' Use `app.config.logger.level` instead.');
	            }
	
	            if (!level) {
	                return this.levels.ERROR;
	            }
	            level = level.toUpperCase();
	
	            // FIXME this needs to be done after SC-5483 is implemented
	            /*
	            if (!this.levels[level]) {
	                 console.error('Your logger level is set to an invalid value. ' +
	                    'Please redefine it in Administration > System Settings. ' +
	                    'If you continue to see this warning, please ' +
	                    'contact your Admin.');
	            }
	            */
	
	            return this.levels[level] || this.levels.ERROR;
	        },
	
	        // TODO: We may want to add support for format strings like "Some message %s %d", params
	        /**
	         * Logs a message with a given {@link Utils.Logger.levels} level.
	         * If the message is an object, it will be serialized into a JSON string.
	         * If the message is a function, it will evaluated in the logger's scope.
	         * @param {Utils.Logger.levels} level log level
	         * @param {string|Object|Function} message log message
	         * @member Utils.Logger
	         */
	        log: function log(level, message) {
	            try {
	                var currentLevel = this.getLevel();
	                if (level.value < currentLevel.value) {
	                    return;
	                }
	
	                message = message || '<none>';
	
	                if (_.isFunction(message)) message = message.call(this);
	                if (_.isObject(message)) {
	                    // Try to json-ify the object. It'll fail if it has circular
	                    // dependency
	                    try {
	                        message = JSON.stringify(message);
	                    } catch (e) {
	                        message = message.toString();
	                    }
	                }
	
	                // @deprecated Use `app.config.logger.formatter` instead, old
	                // property should be removed on 7.9 (SC-5469)
	                // FIXME: SC-5478 Add deprecation warning and change order of operations.
	                var logger = app.config.logger,
	                    formatter = this[app.config.logFormatter];
	                if (!formatter) {
	                    formatter = logger && this[logger.formatter] || this.SimpleFormatter;
	                }
	
	                message = formatter.format(level, message, new Date());
	
	                // @deprecated Use `app.config.logger.consoleWriter` instead, old
	                // property should be removed on 7.9 (SC-5469)
	                // FIXME: SC-5479 Add deprecation warning and change order of operations.
	                var consoleWriter = this[app.config.logWriter];
	                if (!consoleWriter) {
	                    consoleWriter = logger && this[logger.consoleWriter] || this.ConsoleWriter;
	                }
	
	                var serverWriter = logger && this[logger.serverWriter] || this.ServerWriter;
	
	                consoleWriter.write(level, message);
	                serverWriter.write(level, message);
	            } catch (e) {
	                console.log('Failed to log message {' + message + '} due to exception: ' + e);
	            }
	        }
	    }, false);
	})(SUGAR.App);

/***/ },
/* 51 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * Base bean class. Use {@link Data.DataManager} to create instances of beans.
	 *
	 * **CRUD**
	 *
	 * Use standard Backbone's `fetch`, `save`, and `destroy`
	 * methods to perform CRUD operations on beans. See {@link Data.DataManager} class for details.
	 *
	 * **Validation**
	 *
	 * This class does not override Backbone.Model's `validate` method.
	 * The validation is done in `save` method. If the bean is invalid the save is rejected.
	 * Use {@link Data.Bean#isValid} method to check if the bean is valid in other situations.
	 * Failed validations trigger an `"app:error:validation:<field-name>"` event.
	 *
	 * @class Data.Bean
	 * @alias SUGAR.App.Bean
	 * @extends Backbone.Model
	 */
	(function (app) {
	
	    /**
	     * Add doValidate method to Backbone.Model so it won't fail when calling doValidate
	     * @param {Array|Object} fields A hash of field definitions or array of field names to validate.
	     * @param {Function} callback Function called with isValid flag once the validation is complete
	     */
	    Backbone.Model.prototype.doValidate = function (fields, callback) {
	        callback(this.isValid());
	    };
	    app.augment('Bean', Backbone.Model.extend({
	        /**
	         * Model plugins are attached in the constructor to allow initialize()
	         * to be overridden.
	         *
	         * @inheritdoc
	         * @param {Object} attributes
	         * @param {Object} options
	         */
	        constructor: function constructor(attributes, options) {
	            app.plugins.attach(this, 'model');
	            Backbone.Model.prototype.constructor.call(this, attributes, options);
	        },
	
	        /**
	         * @inheritdoc
	         */
	        initialize: function initialize(attributes) {
	            Backbone.Model.prototype.initialize.call(this, attributes);
	
	            // assume our attributes from creation are synced
	            this.setSyncedAttributes(this.attributes);
	
	            this._bindEvents();
	            this._relatedCollections = this._relatedCollections || null;
	
	            /**
	             * The request object that is currently syncing against the server.
	             *
	             * This object is needed to determine if a fetch request should be
	             * aborted for the collection (e.g. if a new fetch request returns a
	             * response prior to a previous fetch request).
	             *
	             * @private
	             * @member Data.Bean
	             * @property {SUGAR.Api.HttpRequest}
	             */
	            this._activeFetchRequest = null;
	
	            // Populate with default values only if the model is new and has not yet been populated
	            if (this.isNew() && this._defaults) {
	                _.each(this._defaults, function (value, key) {
	                    if (!this.has(key)) {
	                        this.set(key, value, { silent: true });
	                    }
	                }, this);
	            }
	
	            //Clone the fields to allow dynamic changes to vardefs per bean instance
	            if (this.fields) {
	                this.fields = app.utils.deepCopy(this.fields);
	            }
	
	            this.addValidationTask('sidecar', _.bind(this._doValidate, this));
	        },
	
	        /**
	         * Fetches the bean.
	         *
	         * Only one fetch request can be executed at a time - previous fetch
	         * requests will be aborted.
	         *
	         * @param {Object} [options] Fetch options.
	         * @param {Function} [options.success] The success callback to execute.
	         * @param {Function} [options.error] The error callback to execute.
	         */
	        fetch: function fetch(options) {
	            options = _.extend({}, this.getOption(), options);
	            this.abortFetchRequest();
	            this._activeFetchRequest = Backbone.Model.prototype.fetch.call(this, options);
	            return this._activeFetchRequest;
	        },
	
	        /**
	         * Getter for {@link #_activeFetchRequest}.
	         *
	         * @return {SUGAR.Api.HttpRequest} The active fetch request.
	         */
	        getFetchRequest: function getFetchRequest() {
	            return this._activeFetchRequest;
	        },
	
	        /**
	         * Aborts the {@link #_activeFetchRequest current fetch request}.
	         */
	        abortFetchRequest: function abortFetchRequest() {
	            var req = this.getFetchRequest();
	            if (req) {
	                app.api.abortRequest(req.uid);
	            }
	        },
	
	        /**
	         * Overrides Backbone method to add specific logic for `collection`
	         * fields.
	         *
	         * @param {string|Object} key The key. Can also be an object with the
	         * key/value pair.
	         * @param {string} val The value to set.
	         * @param {Object} options A hash of options
	         */
	        set: function set(key, val, options) {
	            if (_.isUndefined(key) || _.isNull(key)) {
	                return this;
	            }
	
	            var attrs;
	            if ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object') {
	                attrs = key;
	                options = val;
	            } else {
	                (attrs = {})[key] = val;
	            }
	
	            options = options || {};
	
	            var collections = this.getCollectionFields(attrs);
	            attrs = _.omit(attrs, _.keys(collections));
	            Backbone.Model.prototype.set.call(this, attrs, options);
	            this._handleCollectionFieldValues(collections, options);
	
	            return this;
	        },
	
	        /**
	         * Adds `collection` fields records to the mixed bean collection. If
	         * a mixed bean collection does not exist yet, it will be created.
	         *
	         * @private
	         * @param {Object} collections Object containing collections fields
	         * attributes.
	         * @param {Object} options A hash of options.
	         */
	        _handleCollectionFieldValues: function _handleCollectionFieldValues(collections, options) {
	            _.each(collections, function (records, key) {
	                //If a collection field is being set to a collection, we should just accept it.
	                if (records instanceof app.MixedBeanCollection) {
	                    if (this.get(key) !== records) {
	                        this.stopListening(this.get(key));
	                        Backbone.Model.prototype.set.call(this, _.object([key], [records]), options);
	                        this.listenTo(records, 'update reset', function (collection, options) {
	                            this.trigger('change:' + key, this, collection, options);
	                        });
	
	                        this.off('sync', records.resetDelta, records);
	                        this.on('sync', records.resetDelta, records);
	                    }
	                } else {
	                    var colOptions = {};
	                    var collection = this.get(key);
	                    collection.reset();
	
	                    //Record list populated from a `collection` field response
	                    if (_.isObject(records) && records.records) {
	                        colOptions = _.extend(colOptions, _.omit(records, 'records'));
	                        records = records.records;
	                    }
	
	                    //We need a collection to add the models to.
	                    _.each(colOptions, function (v, k) {
	                        collection[k] = v;
	                    });
	
	                    collection.add(records, options);
	                }
	            }, this);
	        },
	
	        /**
	         * Creates a mixed bean collection for `collection` fields if there is
	         * none yet.
	         *
	         * @param {string} attr The attribute name.
	         */
	        get: function get(attr) {
	            var value = Backbone.Model.prototype.get.call(this, attr);
	
	            // If the field is not a `collection` field
	            if (!this.fields || !this.fields[attr] || this.fields[attr].type !== 'collection' || value instanceof app.MixedBeanCollection) {
	                return value;
	            }
	
	            // If the field is a `collection` field and has not been initialized.
	            value = this._createMixedBeanCollectionField(attr);
	            Backbone.Model.prototype.set.call(this, _.object([attr], [value]), { silent: true });
	
	            return value;
	        },
	
	        /**
	         * Creates a mixed bean collection passing the related link bean
	         * collections of this `collection` field.
	         *
	         * @private
	         * @param {string} field  A `collection` type field.
	         * @param {Object[]|Data.Bean[]} models The models to add to the collection.
	         * @return {Data.MixedBeanCollection} The newly created mixed bean
	         * collection.
	         */
	        _createMixedBeanCollectionField: function _createMixedBeanCollectionField(field, models) {
	            var fieldDef = this.fields[field];
	            if (fieldDef && fieldDef.links) {
	                var links = fieldDef.links;
	                if (_.isString(links)) {
	                    links = [links];
	                }
	
	                var linkCollections = {};
	                _.each(links, function (link) {
	                    linkCollections[link] = this.getRelatedCollection(link);
	                }, this);
	                var collection = app.data.createMixedBeanCollection(models || [], { links: linkCollections });
	
	                this.listenTo(collection, 'update reset', function (collection, options) {
	                    this.trigger('change:' + field, this, collection, options);
	                });
	
	                this.off('sync', collection.resetDelta, collection);
	                this.on('sync', collection.resetDelta, collection);
	
	                return collection;
	            }
	        },
	
	        /**
	         * Binds events on {@link Data.Bean the model}.
	         *
	         * @protected
	         */
	        _bindEvents: function _bindEvents() {
	            this.on('sync', function () {
	                this._checkAcl();
	                this.setSyncedAttributes(this.attributes);
	            }, this);
	        },
	
	        /**
	         * Checks if the `_acl` attribute has changed from its synced value on
	         * {@link Data.Bean the model}, and triggers the `acl:change` event if
	         * one field had ACL changes. All events are triggered on
	         * {@link Data.Bean the model}.
	         *
	         * @private
	         */
	        _checkAcl: function _checkAcl() {
	            var changedFieldAcls = this._checkFieldAcls();
	
	            if (_.size(changedFieldAcls) || !_.isEqual(_.omit(this.get('_acl'), 'fields'), _.omit(this.getSynced('_acl'), 'fields'))) {
	                this.trigger('acl:change', changedFieldAcls);
	            }
	        },
	
	        /**
	         * Triggers the `acl:change:<fieldname>` event on all the fields whose
	         * ACLs have changed. All events are triggered on
	         * {@link Data.Bean the model}.
	         *
	         * @private
	         * @return {Object} The hash of fields that had ACL changes.
	         */
	        _checkFieldAcls: function _checkFieldAcls() {
	            var changedFieldAcls = {};
	            var fieldsProp = _.property('fields');
	            var syncedFieldAcls = fieldsProp(this.getSynced('_acl')) || {};
	            var fieldAcls = fieldsProp(this.get('_acl')) || {};
	            var fields = _.extend({}, syncedFieldAcls, fieldAcls);
	
	            _.each(fields, function (field, fieldName) {
	                if (!_.isEqual(syncedFieldAcls[fieldName], fieldAcls[fieldName])) {
	                    this.trigger('acl:change:' + fieldName);
	                    changedFieldAcls[fieldName] = true;
	                }
	            }, this);
	
	            return changedFieldAcls;
	        },
	
	        /**
	         * Disposes a bean.
	         */
	        dispose: function dispose() {
	            app.plugins.detach(this, "model");
	        },
	
	        /**
	         * Caches a collection of related beans in this bean instance.
	         * @param {string} link Relationship link name.
	         * @param collection A collection of related beans to cache.
	         * @private
	         */
	        _setRelatedCollection: function _setRelatedCollection(link, collection) {
	            if (!this._relatedCollections) this._relatedCollections = {};
	            this._relatedCollections[link] = collection;
	        },
	
	        /**
	         * Gets a collection of related beans.
	         *
	         * This method returns a cached in memory instance of the collection. If the collection doesn't exist in the cache,
	         * it will be created using {@link Data.DataManager#createRelatedCollection} method.
	         * Use {@link Data.DataManager#createRelatedCollection} method to get a new instance of a related collection.
	         *
	         * <pre><code>
	         * // Get a cached copy or create contacts collection for an existing opportunity.
	         * var contacts = opportunity.getRelatedCollection("contacts");
	         * contacts.fetch({ relate: true });
	         * </code></pre>
	         *
	         * @param {string} link Relationship link name.
	         * @return {Data.BeanCollection} Previously created collection or a new collection of related beans.
	         */
	        getRelatedCollection: function getRelatedCollection(link) {
	            if (this._relatedCollections && this._relatedCollections[link]) {
	                return this._relatedCollections[link];
	            }
	
	            return app.data.createRelatedCollection(this, link);
	        },
	
	        /**
	         * Validates a bean asynchronously.
	         *
	         * This method simply runs validation on the bean and calls the callback
	         * with the result - it does not fire any events or display any alerts.
	         * If you need events and alerts, use {@link Data.Bean#doValidate}.
	         * Note: This method is different from the standard Backbone `isValid`
	         * method which does not support the async validation we require.
	         *
	         * @param {Array|Object} [fields] A hash of field definitions or array
	         *   of field names to validate. If not specified, all fields will be
	         *   validated. View-agnostic validation will be run. Keys are field
	         *   names, values are field definitions (combination of view defs and
	         *   vardefs).
	         * @param {Function} [callback] Function called with isValid flag and
	         *   any errors once the validation is complete.
	         */
	        isValidAsync: function isValidAsync(fields, callback) {
	            fields = fields || this.fields;
	
	            async.waterfall(
	            // run all validation tasks
	            _.flatten([function (waterfallCallback) {
	                waterfallCallback(null, fields, {});
	            }, _.sortBy(this._validationTasks)]),
	            // waterfall callback
	            function (didWaterfallFail, fields, errors) {
	                if (!didWaterfallFail) {
	                    var isValid = _.isEmpty(errors);
	                    if (_.isFunction(callback)) {
	                        callback(isValid, errors);
	                    }
	                }
	            });
	        },
	
	        /**
	         * Validates a bean asynchronously - firing events on start, complete,
	         * and failure.
	         *
	         * This method is called before {@link Data.Bean#save}.
	         *
	         * Triggers:
	         * - `validation:success` if validation passes,
	         * - `error:validation` if validation fails,
	         * - `error:validation:<field-name>` for each invalid field,
	         * - `validation:complete` when validation completes.
	         *
	         * @param {Array|Object} [fields] A hash of field definitions or array
	         *   of field names to validate. If not specified, all fields will be
	         *   validated. View-agnostic validation will be run. Keys are field
	         *   names, values are field definitions (combination of view defs and
	         *   vardefs).
	         * @param {Function} [callback] Function called with isValid flag once
	         *   the validation is complete.
	         */
	        doValidate: function doValidate(fields, callback) {
	            var self = this;
	
	            this.trigger('validation:start');
	
	            this.isValidAsync(fields, function (isValid, errors) {
	                if (isValid) {
	                    self.trigger('validation:success');
	                }
	                self.trigger('validation:complete', self._processValidationErrors(errors));
	
	                if (_.isFunction(callback)) {
	                    callback(isValid);
	                }
	            });
	        },
	
	        /**
	         * Runs sidecar validation on fields.
	         *
	         * @param {Array|Object} fields A hash of field definitions or array of field names to validate.
	         * @param {Object} errors validation errors object.
	         * @param {Function} callback Async.js waterfall callback
	         *
	         * - keys: field names, values: errors hash
	         * - errors hash is a collection of error definitions
	         * - error definition can be a primitive type or an object. It depends on validator.
	         *
	         * Example:
	         * <pre><code>
	         * {
	         *    first_name: {
	         *       maxLength: 20,
	         *       someOtherValidatorName: { some complex error definition... }
	         *    },
	         *    last_name: {
	         *       required: true
	         *    }
	         * }
	         * </code></pre>
	         *
	         * @private
	         */
	        _doValidate: function _doValidate(fields, errors, callback) {
	            var value;
	
	            // fields can be either array or object
	            _.each(fields, function (field, fieldName) {
	                if (_.isString(field)) {
	                    fieldName = field;
	                    field = this.fields[fieldName];
	                }
	
	                value = this.get(fieldName);
	
	                if (field) {
	                    // Safeguard against missing field definitions
	                    _addValidationError(errors, app.validation.requiredValidator(field, field.name, this, value), fieldName, "required");
	
	                    if (value || value === 0) {
	                        // "0" must have validation
	                        _.each(app.validation.validators, function (validator, validatorName) {
	                            _addValidationError(errors, validator(field, value, this), fieldName, validatorName);
	                        }, this);
	                    }
	                }
	            }, this);
	
	            callback(null, fields, errors);
	        },
	
	        /**
	         * Adds a validation task to the validation waterfall
	         * @param {string} taskName The name of the task.
	         * @param {Function} validate The validation task
	         */
	        addValidationTask: function addValidationTask(taskName, validate) {
	            this._validationTasks = this._validationTasks || {};
	
	            this._validationTasks[taskName] = validate;
	        },
	
	        /**
	         * Remove a specified validation task from the bean.
	         * @param {string} taskName The name of the task
	         */
	        removeValidationTask: function removeValidationTask(taskName) {
	            if (this._validationTasks) {
	                this._validationTasks = _.omit(this._validationTasks, taskName);
	            }
	        },
	
	        /**
	         * Processes validation errors and triggers validation error events.
	         * @param {Object} errors validation errors.
	         * @return {Boolean} `true` if `errors` parameter is empty, otherwise `false`.
	         * @private
	         */
	        _processValidationErrors: function _processValidationErrors(errors) {
	            var isValid = true;
	            if (!_.isEmpty(errors)) {
	                app.error.handleValidationError(this, errors);
	                _.each(errors, function (fieldErrors, fieldName) {
	                    this.trigger("error:validation:" + fieldName, fieldErrors);
	                }, this);
	                this.trigger("error:validation", errors);
	                isValid = false;
	            }
	
	            return isValid;
	        },
	
	        /**
	         * Overrides [Backbone.Model#save](http://backbonejs.org/#Model-save)
	         * so we can run async validation outside of the
	         * [standard validation loop](http://backbonejs.org/#Model-validate).
	         *
	         * This method checks if this bean is valid only if `options` hash
	         * contains `fieldsToValidate` parameter.
	         *
	         * @param {Object} [attributes] The model attributes.
	         * @param {Object} [options] standard save options as described by
	         *   Backbone docs.
	         * @param {Array} [options.fieldsToValidate] List of field names to
	         *   validate.
	         * @return {SUGAR.HttpRequest} Returns a {@link SUGAR.HttpRequest} if
	         *   There are no fields to validate, `undefined` if validation needs
	         *   to happen first.
	         */
	        save: function save(attributes, options) {
	            var _this = this;
	
	            if (!options || !options.fieldsToValidate) {
	                return Backbone.Model.prototype.save.call(this, attributes, options);
	            }
	
	            this.doValidate(options.fieldsToValidate, function (isValid) {
	                if (isValid) {
	                    return Backbone.Model.prototype.save.call(_this, attributes, options);
	                }
	            });
	        },
	
	        /**
	         * Checks if a bean can have attachments.
	         *
	         * REST API introduced a convenience field called `attachment_list` which is an array
	         * with attachment information. Modules such as `Documents` and `KBDocuments` use this field
	         * to simplify access to file revisions.
	         * @return {Boolean} `true` if bean's field definition has `attachment_list` field.
	         */
	        canHaveAttachments: function canHaveAttachments() {
	            return _.has(this.fields, 'attachment_list');
	        },
	
	        /**
	         * Fetches a list of files (attachments).
	         *
	         * This method uses REST {@link SUGAR.Api#file} API to retrieve file list.
	         * @param callbacks(optional) Hash with success, error, and complete callbacks.
	         * @param options(optional) Request options. See {@link SUGAR.Api#file} for details.
	         */
	        getFiles: function getFiles(callbacks, options) {
	            options = options || {};
	            // The token will be passed in the header
	            options.passOAuthToken = false;
	            return app.api.file("read", {
	                module: this.module,
	                id: this.id
	            }, null, callbacks, options);
	        },
	
	        /**
	         * Copies fields from a given bean into this bean.
	         *
	         * This method does not copy `id` field, `link`-type fields, and fields whose values are auto-incremented
	         * (metadata field definition has `auto_increment === true`).
	         * @param {Data.Bean} source The bean to copy the fields from.
	         * @param {Array} fields(optional) The fields to copy. All fields are copied if not specified.
	         * @param options(optional) Standard Backbone options that should be passed to `Backbone.Model#set` method.
	         */
	        copy: function copy(source, fields, options) {
	            var attrs = {};
	            var vardefs = app.metadata.getModule(this.module).fields;
	            fields = fields || _.pluck(vardefs, "name");
	
	            // Iterate over fields and copy everything except auto_increment fields, links, ID,
	            // or any field with an explicit duplicate_on_record_copy set to 'no'
	            _.each(fields, function (name) {
	                var def = vardefs[name],
	                    permitCopy;
	
	                if (!def || def.duplicate_on_record_copy === 'no') {
	                    return;
	                }
	
	                permitCopy = def.duplicate_on_record_copy === 'always' || name !== 'id' && def.type !== 'link' && !def.auto_increment;
	
	                if (permitCopy && source.has(name)) {
	
	                    var value = source.get(name);
	                    // Perform deep copy in case the value is not a primitive type
	                    if (_.isObject(value)) {
	                        value = app.utils.deepCopy(value);
	                    }
	                    attrs[name] = value;
	                }
	            });
	
	            this.set(attrs, options);
	            this.isCopied = true;
	        },
	
	        /**
	         * Returns whether the bean was populated as a result of a copy.
	         *
	         * @return {boolean} `true` if the bean was populated as a result of a
	         *   copy, `false` otherwise.
	         */
	        isCopy: function isCopy() {
	            return this.isCopied === true;
	        },
	
	        /**
	         * Uploads a file.
	         * @param {string} fieldName Name of the file field.
	         * @param {Array} $files List of DOM elements that contain file inputs.
	         * @param {Object} [callbacks] Callback hash.
	         * @param {Object} [options] Upload options. See {@link SUGAR.Api#file}
	         *   method for details.
	         * @return {Object} XHR object.
	         */
	        uploadFile: function uploadFile(fieldName, $files, callbacks, options) {
	            callbacks = callbacks || {};
	            options = options || {};
	
	            return app.api.file('create', {
	                //Set id to temp if we save a temporary file to reach correct API
	                id: options.temp !== true ? this.id : 'temp',
	                module: this.module,
	                field: fieldName
	            }, $files, callbacks, options);
	        },
	
	        /**
	         * Favorites or un-favorites a record.
	         * @param {boolean} flag Flag indicating if the record must be marked as favorite (`true`).
	         * @param {Object} options(optional) Standard Backbone options for Backbone.Model#save operation.
	         */
	        favorite: function favorite(flag, options) {
	            options = options || {};
	            options.favorite = true;
	            return this.save({ my_favorite: !!flag }, options);
	        },
	
	        /**
	         * Subscribe/unsubscribe a record changes.
	         * @param {Boolean} flag Flag indicating subscribe (`true`) or unsubscribe (`false`)
	         * the record changes.
	         * @param {Object} options Options for {@link Backbone.Model#save} operation.
	         * @return {Object} `jqXHR` object or `false` if error occurs.
	         */
	        follow: function follow(flag, options) {
	            options = options || {};
	            flag = flag || false;
	            options.following = true;
	            return this.save({ following: flag }, options);
	        },
	
	        /**
	         * Retruns a flag indicating if a record is marked as favorite.
	         * @return {Boolean} `true` if the record is marked as favorite, `false` otherwise.
	         */
	        isFavorite: function isFavorite() {
	            var flag = this.get("my_favorite");
	            return flag === "1" || flag === true;
	        },
	
	        /**
	         * Calculates difference between backup and changed model for restoring model.
	         * @param {Object} original Hash of original (backed up) values.
	         * @param {Array} exclude List of fields to exclude from comparison.
	         * @return {Object} Difference between original and the current model attributes.
	         */
	        getChangeDiff: function getChangeDiff(original, exclude) {
	            var diff = {};
	            original = original || {};
	            exclude = exclude || [];
	
	            _.each(this.attributes, function (value, key) {
	                if (_.contains(exclude, key)) return;
	                var previousValue = original[key];
	                if (!_.isEqual(previousValue, value)) {
	                    diff[key] = previousValue;
	                }
	            });
	
	            return diff;
	        },
	
	        /**
	         * @inheritdoc
	         *
	         * Checks if the bean has changed
	         * @param {string} [attr] The attribute to check. if none is passed,
	         * checks all attributes and returne `true` if at least one has changed.
	         */
	        hasChanged: function hasChanged(attr) {
	            if (_.isUndefined(attr)) {
	                var collections = this.getCollectionFields(this.attributes);
	                var hasChanged = _.some(collections, function (coll, key) {
	                    return !_.isEmpty(coll.getDelta());
	                }, this);
	
	                return hasChanged || Backbone.Model.prototype.hasChanged.call(this);
	            }
	
	            if (this.get(attr) instanceof app.MixedBeanCollection) {
	                return !_.isEmpty(this.get(attr).getDelta());
	            }
	
	            return Backbone.Model.prototype.hasChanged.call(this, attr);
	        },
	
	        /**
	         * Returns an object of attributes, containing what needs to be sent to
	         * the server when saving the bean . This method is called when
	         * JSON.stringify() is called on the bean.
	         *
	         * @inheritdoc
	         *
	         * @param {Object} [options]
	         * @param {Object} [options.fields] List of field names to be included
	         *   in the object of attributes. It retrieves all fields by default.
	         * @return {Object}
	         */
	        toJSON: function toJSON(options) {
	            var fields = options && options.fields ? options.fields : _.keys(this.attributes),
	                json = {};
	
	            _.each(fields, function (fieldName) {
	                var val = this.get(fieldName);
	                if (val instanceof app.MixedBeanCollection && !_.isEmpty(val.getDelta())) {
	                    _.each(val.getDelta(), function (val, linkName) {
	                        json[linkName] = val;
	                    });
	                } else {
	                    if (_.isObject(val) && _.isFunction(val.toJSON)) {
	                        app.logger.warn('Calling `toJSON` on object attributes is deprecated in 7.9 and will be ' + 'removed in 7.10');
	                        val = val.toJSON(options);
	                    }
	
	                    json[fieldName] = val;
	                }
	            }, this);
	
	            return json;
	        },
	
	        /**
	         * Returns string representation useful for debugging:
	         * <code>bean:[module-name]/[id]</code>
	         * @return {string} string representation of this bean
	         */
	        toString: function toString() {
	            return "bean:" + this.module + "/" + (this.id ? this.id : "<no-id>");
	        },
	
	        /**
	         * Reverts model attributes to the last values from last sync or values on creation.
	         *
	         * @fires attributes:revert if `options.silent` is falsy.
	         *
	         * @param options Options are passed onto set such as `silent:true`.
	         */
	        revertAttributes: function revertAttributes(options) {
	            options = options || {};
	            options.revert = true;
	            var changedAttr = this.changedAttributes(this.getSynced());
	            this.set(app.utils.deepCopy(changedAttr) || {}, options);
	            if (!options.silent) {
	                this.trigger('attributes:revert');
	            }
	        },
	
	        /**
	         * Gets changed attributes.
	         *
	         * @param {Object} [attrs] A hash of attributes to compare the current
	         * bean attributes against
	         * @return {Object|boolean} `false` if nothing has changed. An object
	         * containing the attributes passed in parameters that are different
	         * from the bean ones.
	         */
	        changedAttributes: function changedAttributes(attrs) {
	            var _this2 = this;
	
	            var collections = this.getCollectionFields(attrs);
	            if (!_.isUndefined(attrs)) {
	                attrs = _.omit(attrs, _.keys(collections));
	            }
	
	            var changed = Backbone.Model.prototype.changedAttributes.call(this, attrs);
	
	            _.each(collections, function (val, key) {
	                if (!_.isEmpty(_this2.get(key).getDelta())) {
	                    changed = changed || {};
	                    changed[key] = val;
	                }
	            }, this);
	
	            return changed;
	        },
	
	        /**
	         * Sets internal synced attribute hash that's used in revertAttributes.
	         *
	         * @param {Object} attributes Attributes of model to setup.
	         */
	        setSyncedAttributes: function setSyncedAttributes(attributes) {
	            this._syncedAttributes = attributes ? app.utils.deepCopy(attributes) : {};
	        },
	
	        /**
	         * Gets the value of the synced attribute for the given key. If no key
	         * is passed, {@link #_syncedAttributes all synced attributes} are
	         * returned
	         *
	         * @param {string} [key] The attribute name.
	         * @return {Mixed} The synced attribute's value.
	         */
	        getSynced: function getSynced(key) {
	            return key ? this._syncedAttributes[key] : this._syncedAttributes;
	        },
	
	        /**
	         * Gets the default values (one or many).
	         *
	         * @param {string} [key] The name of the attribute.
	         * @return {Mixed} The default value if you passed a `key`, or the hash of
	         * default values.
	         */
	        getDefault: function getDefault(key) {
	            var defaults = _.clone(this._defaults) || {};
	            if (_.isUndefined(key)) {
	                return defaults;
	            }
	            return defaults[key];
	        },
	
	        /**
	         * Sets the default values (one or many) on the model, and fill in
	         * undefined attributes with the default values.
	         *
	         * @param {string|Object} key The name of the attribute, or an hash of
	         * attributes.
	         * @param {Mixed} [val] The default value for the `key` argument.
	         *
	         * @chainable
	         */
	        setDefault: function setDefault(key, val) {
	            var attrs;
	            if (_.isObject(key)) {
	                attrs = key;
	            } else {
	                (attrs = {})[key] = val;
	            }
	            this._defaults = _.extend({}, this._defaults, attrs);
	            this.attributes = _.defaults(this.attributes, attrs);
	            return this;
	        },
	
	        /**
	         * Sets the default fetch options (one or many) on the model.
	         *
	         * @param {string|Object} key The name of the option, or an hash of
	         * options.
	         * @param {Mixed} [val] The value for the `key` option.
	         *
	         * @chainable
	         */
	        setOption: function setOption(key, val) {
	            var attrs;
	            if (_.isObject(key)) {
	                attrs = key;
	            } else {
	                (attrs = {})[key] = val;
	            }
	
	            /**
	             * List of persistent fetch options.
	             *
	             * @type {Object}
	             * @private
	             */
	            this._persistentOptions = _.extend({}, this._persistentOptions, attrs);
	            return this;
	        },
	
	        /**
	         * Unsets a default fetch option (or all).
	         *
	         * @param {string|Object} [key] The name of the option to unset, or
	         * nothing to unset all options.
	         *
	         * @chainable
	         */
	        unsetOption: function unsetOption(key) {
	            if (key) {
	                this.setOption(key, void 0);
	            } else {
	                this._persistentOptions = {};
	            }
	            return this;
	        },
	
	        /**
	         * Gets one or all persistent fetch options.
	         *
	         * @param {string|Object} [key] The name of the option to retrieve, or
	         * nothing to retrieve all options.
	         * @return {Mixed} A specific option, or the list of options.
	         */
	        getOption: function getOption(key) {
	            if (key) {
	                return this._persistentOptions[key];
	            }
	            return this._persistentOptions;
	        },
	
	        /**
	         * Return all fields of a given type.
	         *
	         * @param {string} type The type of the field to search for.
	         * @return {Array} List of fields filtered by the given type.
	         */
	        fieldsOfType: function fieldsOfType(type) {
	            return _.where(this.fields, { type: type });
	        },
	
	        /**
	         * Gets a hash of collection fields attributes.
	         * @param {Object} [attrs] The hash of attributes to get the collection
	         * fields from. If empty, we use `this.attributes`.
	         * @return {Object} A hash of collection fields attributes.
	         */
	        getCollectionFields: function getCollectionFields(attrs) {
	            return _.pick(attrs, _.pluck(this.fieldsOfType('collection'), 'name'));
	        },
	
	        /**
	         * A helper that merges changes into a bean attributes.
	         *
	         * The default implementation overrides attributes with changes.
	         * @param attributes Bean attributes.
	         * @param changes Object hash with changed attributes.
	         * @param module(optional) Module name.
	         * @returns {Object} Merged attributes.
	         */
	        merge: function merge(attributes, changes, module) {
	            return _.extend(attributes, changes);
	        }
	
	    }), false);
	
	    /**
	     * Adds validation error to the passed in error object.
	     * @param {Object} errors
	     * @param {Object} result
	     * @param {string} fieldName
	     * @param {string} validatorName
	     * @private
	     * @ignore
	     */
	    function _addValidationError(errors, result, fieldName, validatorName) {
	        if (_.isUndefined(result)) return;
	
	        if (_.isUndefined(errors[fieldName])) {
	            errors[fieldName] = {};
	        }
	        errors[fieldName][validatorName] = result;
	    }
	})(SUGAR.App);

/***/ },
/* 52 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * Base bean collection class.
	 *
	 * **Filtering and searching**
	 *
	 * The collection's {@link Data.BeanCollection#fetch} method supports filter and seach options.
	 * For example, to search favorite accounts that have `"Acme"` string in their name:
	 * <pre><code>
	 * (function(app) {
	 *
	 *     var accounts = app.data.createBeanCollection("Accounts");
	 *     accounts.fetch({
	 *         favorites: true,
	 *         query: "Acme"
	 *     });
	 *
	 * })(SUGAR.App);
	 * </code></pre>
	 *
	 *
	 * @class Data.BeanCollection
	 * @alias SUGAR.App.BeanCollection
	 * @extends Backbone.Collection
	 */
	(function (app) {
	
	    app.augment('BeanCollection', Backbone.Collection.extend({
	
	        /**
	         * The request object that is currently syncing against the server.
	         *
	         * This object is needed to determine if a fetch request should be
	         * aborted for the collection (e.g. if a new fetch request returns a
	         * response prior to a previous fetch request).
	         *
	         * @private
	         * @member Data.BeanCollection
	         * @property {SUGAR.Api.HttpRequest}
	         */
	        _activeFetchRequest: null,
	
	        /**
	         * The default model of a bean collection is a {@link Data.Bean}.
	         *
	         * **Note:** Please do not manipulate this property directly.
	         * This property should never be modified directly.
	         *
	         * @property {Data.Bean}
	         * @override
	         */
	        model: app.Bean,
	
	        /**
	         * Prepare related bean collections and attach collection plugins.
	         *
	         * @override
	         *
	         * @param {Array} models initial array of models.
	         * @param {Object} [options]
	         */
	        constructor: function constructor(models, options) {
	            app.plugins.attach(this, 'collection');
	            if (options && options.link) {
	                this.link = options.link;
	                delete options.link;
	            }
	            Backbone.Collection.prototype.constructor.call(this, models, options);
	        },
	
	        /**
	         * Saves a private copy of initial options for reset
	         *
	         * @param {Array} models initial array of models
	         * @param {Object} options
	         */
	        initialize: function initialize(models, options) {
	
	            /**
	             * List of persistent fetch options.
	             *
	             * @type {Object}
	             * @private
	             */
	            this._persistentOptions = {};
	
	            /**
	             * Object keeping track of created models added into the collection
	             * that are not synced yet.
	             *
	             * @type {Array}
	             */
	            this._create = [];
	
	            /**
	             * Initial fetch options.
	             *
	             * @deprecated 7.7 will be removed in 7.8. Please use {@link #setOption}
	             *   if you want to set persistent options.
	             *
	             * @type {Object}
	             * @private
	             */
	            if (!_.isEmpty(options)) {
	                options = app.utils.deepCopy(options);
	                this.setOption(options);
	                app.logger.warn('You should not pass persistent fetch options in initialize ' + '(The options hash is supposed to be Backbone.js options hash, allowing you ' + 'to pass Backbone options used when setting the models into the collection).' + ' Please use setOption() instead.');
	            }
	            this._initOptions = options;
	
	            this._bindCollectionEvents();
	
	            Backbone.Collection.prototype.initialize.call(this, models, options);
	
	            /**
	             * Readonly property for the total records in server.
	             *
	             * Use {@link #fetchTotal} to get the current total.
	             * @type {number}
	             */
	            this.total = null;
	        },
	
	        /**
	         * Bind collection events to activeRequest.
	         *
	         * @private
	         */
	        _bindCollectionEvents: function _bindCollectionEvents() {
	
	            this.on('data:sync:complete', function () {
	                var activeFetchRequest = this.getFetchRequest();
	                if (activeFetchRequest) {
	                    this._activeFetchRequest = null;
	                }
	            }, this);
	
	            this.on('remove', this._decrementTotal, this);
	        },
	
	        /**
	         * Decrements the {@link #total collection total}.
	         *
	         * @protected
	         */
	        _decrementTotal: function _decrementTotal() {
	            if (this.total) {
	                this.total--;
	            }
	        },
	
	        /**
	         * @inheritdoc
	         *
	         * Keeps track of the added models.
	         *
	         * @param {Object|Object[]|Data.Bean|Data.Bean[]} models The models to add.
	         * @param {Object} options A hash of options.
	         */
	        add: function add(models, options) {
	            var _this = this;
	
	            models = Backbone.Collection.prototype.add.call(this, models, options);
	
	            if (_.isUndefined(models)) {
	                return models;
	            }
	
	            models = _.isArray(models) ? models : [models];
	
	            _.each(models, function (model) {
	                if (model instanceof _this.model ? model.isNew() : !model.id) {
	                    _this._create.push(model);
	                }
	            }, this);
	
	            return models.length === 1 ? models[0] : models;
	        },
	
	        /**
	         * @inheritdoc
	         *
	         * Keeps track of the removed models.
	         *
	         * @param {Object|Object[]|Data.Bean|Data.Bean[]} models The models to remove
	         * @param {Object} options A hash of options.
	         */
	        remove: function remove(models, options) {
	            var _this2 = this;
	
	            models = Backbone.Collection.prototype.remove.call(this, models, options);
	
	            if (_.isUndefined(models)) {
	                return models;
	            }
	
	            models = _.isArray(models) ? models : [models];
	
	            _.each(models, function (model) {
	                if (model instanceof _this2.model ? model.isNew() : !model.id) {
	                    _this2._create = _.without(_this2._create, model);
	                }
	            }, this);
	
	            return models.length === 1 ? models[0] : models;
	        },
	
	        /**
	         * @inheritdoc
	         *
	         * Keeps track of the unsync changes on the collection.
	         *
	         * @param {Object|Object[]|Data.Bean|Data.Bean[]} models The models to
	         * reset the collection with.
	         * @param {Object} options A hash of options.
	         */
	        reset: function reset(models, options) {
	            this.resetDelta();
	            return Backbone.Collection.prototype.reset.call(this, models, options);
	        },
	
	        /**
	         * Gets a hash of unsynced changes operated on the collection.
	         *
	         * @return {Object} A hash representing the unsynced changes.
	         */
	        getDelta: function getDelta() {
	            if (_.isEmpty(this._create)) {
	                return {};
	            }
	
	            return {
	                create: _.invoke(this._create, 'toJSON')
	            };
	        },
	
	        /**
	         * Resets the delta object representing the unsaved collection changes
	         */
	        resetDelta: function resetDelta() {
	            this._create = [];
	        },
	
	        /**
	         * Disposes a collection.
	         *
	         */
	        dispose: function dispose() {
	            app.plugins.detach(this, "collection");
	        },
	
	        /**
	         * Prepare the model to be added to the collection
	         *
	         * @param {Data.Bean} model to be added.
	         * @param {Object} [options] to be passed to
	         *   {@link Backbone.Collection#_prepareModel} method.
	         * @return {Data.Bean} prepared model.
	         * @private
	         */
	        _prepareModel: function _prepareModel(model, options) {
	            var searchInfo = model._search;
	            delete model._search;
	
	            model = Backbone.Collection.prototype._prepareModel.call(this, model, options);
	            if (model && !model.link) model.link = this.link;
	            if (searchInfo) {
	                /**
	                 * FTS search results.
	                 * @member Data.Bean
	                 * @property {Object}
	                 *
	                 * Example:
	                 * <pre>
	                 * {
	                 *   highlighted: {
	                 *      account_name: {
	                 *        label: "LBL_ACCOUNT_NAME",
	                 *        module: "Leads",
	                 *        text: "Kings Royalty &lt;span class="highlight"&gt;Trust&lt;/span&gt;"
	                 *      }
	                 *    },
	                 *    score: 1
	                 * }
	                 * </pre>
	                 */
	                model.searchInfo = searchInfo;
	            }
	            return model;
	        },
	
	        /**
	         * Fetches beans. See {@link Data.BeanCollection#paginate} for details
	         * about pagination options.
	         *
	         * Only one fetch request can be executed at a time - previous fetch
	         * requests will be aborted.
	         *
	         * @param {Object} [options] Fetch options.
	         * @param {boolean} [options.relate] `true` if relationships should be
	         *   fetched. `false` otherwise.
	         * @param {boolean} [options.myItems] `true` if only records assigned to
	         *   the current user should be fetched. `false` otherwise.
	         * @param {boolean} [options.favorites] `true` if favorited records should
	         *   be fetched. `false` otherwise.
	         * @param {boolean} [options.add] `true` if new records should be appended
	         *   to the collection. `false` otherwise.
	         * @param {string} [options.query] Search query string.
	         * @param {Function} [options.success] The success callback to execute.
	         * @param {Function} [options.error] The error callback to execute.
	         */
	        fetch: function fetch(options) {
	            options = _.extend({}, this.getOption(), options);
	
	            this.abortFetchRequest();
	            /**
	             * Field names.
	             *
	             * A list of fields that are populated on collection members.
	             * This property is used to build `fields` URL parameter when
	             * fetching beans.
	             *
	             * @member Data.BeanCollection
	             * @property {Array}
	             */
	            options.fields = this.fields = options.fields || this.fields || null;
	            options.myItems = _.isUndefined(options.myItems) ? this.myItems : options.myItems;
	            options.favorites = _.isUndefined(options.favorites) ? this.favorites : options.favorites;
	            options.query = _.isUndefined(options.query) ? this.query : options.query;
	
	            // FIXME SC-5596: This option is temporary, and was added as part of
	            // SC-2703. It will be removed when we update our sidecar components
	            // to listen on `update` instead of reset.
	            options.reset = _.isUndefined(options.reset) ? true : options.reset;
	
	            this._activeFetchRequest = Backbone.Collection.prototype.fetch.call(this, options);
	            return this.getFetchRequest();
	        },
	
	        /**
	         * Returns currently active fetch request
	         * @returns {SUGAR.Api.HttpRequest} - active http fetch request
	         */
	        getFetchRequest: function getFetchRequest() {
	            if (_.isFunction(this._activeFetchRequest)) {
	                return this._activeFetchRequest();
	            } else {
	                return this._activeFetchRequest;
	            }
	        },
	
	        /**
	         * Aborts currently active fetch request
	         */
	        abortFetchRequest: function abortFetchRequest() {
	            var activeFetchRequest = this.getFetchRequest();
	            if (activeFetchRequest) {
	                app.api.abortRequest(activeFetchRequest.uid);
	                this._activeFetchRequest = null;
	            }
	        },
	
	        /**
	         * Resets pagination properties on a collection to initial options,
	         * otherwise defaults to first page
	         */
	        resetPagination: function resetPagination() {
	            var paginationDefaults = { offset: 0, next_offset: 0, page: 1 };
	            var optKeys = _.keys(paginationDefaults);
	            this.resetOptions(optKeys);
	            var options = this.getOption();
	            _.each(optKeys, function (optKey) {
	                this[optKey] = options[optKey] || paginationDefaults[optKey];
	            }, this);
	        },
	        /**
	         * Resets optionsList to original values from init, clears them if no optionsList specified
	         *
	         * @deprecated 7.7 will be removed in 7.8. Please use {@link #setOption}/{@link #unsetOption}
	         *   if you want to set persistent options.
	         *
	         * @param {Array} optionsList(optional) array of option keys to reset
	         */
	        resetOptions: function resetOptions(optionsList) {
	            if (_.isEmpty(this._initOptions) && _.isEmpty(this.getOption())) {
	                // clear options if none existed when we started
	                this.unsetOption();
	            } else {
	                // reset specific options if specified
	                _.each(optionsList, function (option) {
	                    if (!_.isUndefined(this._initOptions[option])) {
	                        this.setOption(option, this._initOptions[option]);
	                    } else if (!_.isEmpty(this.options) && _.has(this.options, option)) {
	                        this.unsetOption(option);
	                    }
	                }, this);
	            }
	        },
	
	        /**
	         * Paginates a collection.
	         *
	         * @param options(optional) fetch options
	         *
	         * - page: page index (integer) from the current page to paginate to.
	         *
	         * For other options see {@link Data.BeanCollection#fetch} method.
	         */
	        paginate: function paginate(options) {
	            options = options || {};
	            var maxSize = options.limit || app.config.maxQueryResult;
	            options.page = options.page || 1;
	
	            // Since we're paginating, we want the Collection.set method to be
	            // invoked instead of `reset`.
	            options.reset = _.isUndefined(options.reset) ? false : options.reset;
	
	            // fix page number since our offset is already at the end of the collection subset
	            options.page--;
	
	            if (maxSize) {
	                options.offset = this.offset + options.page * maxSize;
	            }
	
	            if (options.add) {
	                options = _.extend({ update: true, remove: false }, options);
	            }
	
	            this.fetch(options);
	        },
	
	        /**
	         * Fetches the total amount of records on the bean collection, and sets
	         * it on the {@link #total} property.
	         *
	         * Returns the total amount of filtered records if a `filterDef`
	         * property is set on the collection.
	         *
	         * @param {Object} [options] Fetch total options.
	         * @param {Function} [options.success] Success callback.
	         * @param {Function} [options.complete] Complete callback.
	         * @param {Function} [options.error] Error callback.
	         * @return {SUGAR.HttpRequest} Result of {@link SUGAR.Api#call}.
	         */
	        fetchTotal: function fetchTotal(options) {
	            options = options || {};
	
	            if (!_.isNull(this.total) && _.isFunction(options.success)) {
	                options.success.call(this, this.total);
	                return;
	            }
	
	            options.success = _.wrap(options.success, _.bind(function (orig, data) {
	                this.total = parseInt(data.record_count, 10);
	                if (orig && _.isFunction(orig)) {
	                    orig(this.total);
	                }
	            }, this));
	
	            var module = this.module;
	            var data = null;
	            options.filter = options.filterDef || this.filterDef;
	
	            if (this.link) {
	                data = {
	                    id: this.link.bean.id,
	                    link: this.link.name
	                };
	                module = this.link.bean.module;
	            }
	
	            var callbacks = _.pick(options, 'success', 'complete', 'error');
	            options = _.omit(options, 'success', 'complete', 'error');
	
	            return app.api.count(module, data, callbacks, options);
	        },
	
	        /**
	         * A convenience method that checks to see if there are at least the
	         * amount of records passed in `amount`. Also passes to a provided
	         * success callback the length of records up to `amount`, and if there
	         * are more records to be fetched (`hasMore`).
	         *
	         * Fetches the partial amount of filtered records if a `filterDef`
	         * property is set on the collection.
	         *
	         * @param {number} amount The number of records to check if there are a
	         *   minimum of.
	         * @param {Object} [options] Fetch partial total options.
	         * @param {Object} [options.filterDef] Filter definition to be applied.
	         * @param {Function} [options.success] Success callback.
	         * @param {Function} [options.complete] Complete callback.
	         * @param {Function} [options.error] Error callback.
	         * @return {SUGAR.HttpRequest} Result of {@link SUGAR.Api#call}.
	         */
	        hasAtLeast: function hasAtLeast(amount, options) {
	            options = options || {};
	            var method = 'read';
	            options.fields = ['id'];
	            delete options.view;
	            options.silent = true;
	            options.success = _.wrap(options.success, _.bind(function (orig, data) {
	                var length = data.records.length;
	                var hasAtLeastAmount = length >= amount;
	                var properties = {
	                    length: length,
	                    hasMore: data.next_offset !== -1
	                };
	
	                if (_.isFunction(orig)) {
	                    orig(hasAtLeastAmount, properties);
	                }
	
	                this.reset(null, { silent: true });
	            }, this));
	
	            var module = this.module;
	            var data = null;
	            var endpoint = 'records';
	            options.filter = options.filterDef || this.filterDef;
	            options.limit = options.limit || amount;
	
	            if (this.link) {
	                data = {
	                    id: this.link.bean.id,
	                    link: this.link.name
	                };
	                module = this.link.bean.module;
	                endpoint = 'relationships';
	            }
	
	            var callbacks = _.pick(options, 'success', 'complete', 'error');
	            options = _.omit(options, 'success', 'complete', 'error');
	            options = app.data.parseOptionsForSync(method, this, options);
	
	            return app.api[endpoint](method, module, data, options.params, callbacks, options.apiOptions);
	        },
	
	        /**
	         * Gets the current page of collection being displayed depending on the offset.
	         *
	         * @param options(Optional) fetch options used when paginating
	         *
	         * - limit: When set, it is the size of each page otherwise we use app.config.maxQueryResult
	         *
	         * @return {Number} current page number.
	         */
	        getPageNumber: function getPageNumber(options) {
	            var pageNumber = 1;
	            var maxSize = app.config.maxQueryResult;
	            if (options) {
	                maxSize = options.limit || maxSize;
	            }
	            if (this.offset && maxSize) {
	                pageNumber = Math.ceil(this.offset / maxSize);
	            }
	            return pageNumber;
	        },
	
	        /**
	         * Returns string representation useful for debugging:
	         * <code>coll:[module-name]-[length]</code>  or
	         * <code>coll:[related-module-name]/[id]/[module-name]-[length]</code> if it's a collection of related beans.
	         * @return {String} string representation of this collection.
	         */
	        toString: function toString() {
	            return "coll:" + (this.link ? this.link.bean.module + "/" + this.link.bean.id + "/" : "") + this.module + "-" + this.length;
	        },
	
	        /**
	         * Returns the next model in a collection, paginating if needed.
	         * @param {Object} current Current model or id of a model.
	         * @param {Object} callback Callback for success call.
	         * @return {Object} Next model in collection or ``null``
	         * if current model is last item in collection.
	         */
	        getNext: function getNext(current, callback) {
	            var _this3 = this;
	
	            var ind = -1;
	            var nextFn = function nextFn() {
	                callback.apply(_this3, [_this3.at(ind + 1), 'next']);
	            };
	
	            if (this.hasNextModel(current)) {
	                ind = this.getModelIndex(current);
	                if (ind + 1 >= this.length) {
	                    this.paginate({
	                        add: true,
	                        success: nextFn
	                    });
	                } else {
	                    nextFn();
	                }
	            }
	        },
	
	        /**
	         * Returns the previous model in a collection.
	         * @param {Object} current Current model or id of a model.
	         * @param {Object} callback Callback for success call.
	         * @return {Object} Previous model in collection or ``null``
	         * if current model is first item in collection.
	         */
	        getPrev: function getPrev(current, callback) {
	            var ind = -1,
	                result = null,
	                self = this;
	            if (this.hasPreviousModel(current)) {
	                ind = this.getModelIndex(current);
	                result = this.at(ind - 1);
	            }
	            callback.apply(self, [result, 'prev']);
	        },
	
	        /**
	         * Check whether is there next model in collection.
	         * @param  {Object} current Current model or id of a model.
	         * @return {Boolean} ``true`` if has next model, ``false`` otherwise.
	         */
	        hasNextModel: function hasNextModel(current) {
	            var index = this.getModelIndex(current),
	                offset = !_.isUndefined(this.next_offset) ? parseInt(this.next_offset, 10) : -1;
	            return index >= 0 && (this.length > index + 1 || offset !== -1);
	        },
	
	        /**
	         * Check whether is there previous model in collection.
	         * @param  {Object} current Current model or id of a model.
	         * @return {Boolean} ``true`` if has previous model, ``false`` otherwise.
	         */
	        hasPreviousModel: function hasPreviousModel(current) {
	            return this.getModelIndex(current) > 0;
	        },
	
	        /**
	         * Return index of the model in collection.
	         * @param  {Object} model Current model.
	         * @return {Number}
	         */
	        getModelIndex: function getModelIndex(model) {
	            return this.indexOf(this.get(model.id));
	        },
	
	        /**
	         * Sets the default fetch options (one or many) on the model.
	         *
	         * @param {string|Object} key The name of the attribute, or an hash of
	         * attributes.
	         * @param {Mixed} [val] The default value for the `key` argument.
	         *
	         * @chainable
	         */
	        setOption: function setOption(key, val) {
	            var attrs;
	            if (_.isObject(key)) {
	                attrs = key;
	            } else {
	                (attrs = {})[key] = val;
	            }
	
	            _.extend(this._persistentOptions, attrs);
	            return this;
	        },
	
	        /**
	         * Unsets a default fetch option (or all).
	         *
	         * @param {string|Object} [key] The name of the option to unset, or
	         * nothing to unset all options.
	         *
	         * @chainable
	         */
	        unsetOption: function unsetOption(key) {
	            if (key) {
	                this.setOption(key, void 0);
	            } else {
	                this._persistentOptions = {};
	            }
	            return this;
	        },
	
	        /**
	         * Gets one or all persistent fetch options.
	         *
	         * @param {string|Object} [key] The name of the option to retrieve, or
	         * nothing to retrieve all options.
	         * @return {Mixed} A specific option, or the list of options.
	         */
	        getOption: function getOption(key) {
	            if (key) {
	                return this._persistentOptions[key];
	            }
	            return this._persistentOptions;
	        },
	
	        /**
	         * Clones the {@link #link} and all the persistent options of the
	         * Collection.
	         *
	         * @return {Data.BeanCollection} The new collection with an identical
	         * list of models as this one.
	         *
	         * @override
	         */
	        clone: function clone() {
	            var newCol = Backbone.Collection.prototype.clone.call(this);
	            newCol.link = _.clone(this.link);
	            newCol.setOption(_.clone(this.getOption()));
	            return newCol;
	        }
	    }), false);
	})(SUGAR.App);

/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * Mixed collection class.
	 *
	 * Supports wrapping multiple related collections by link to allow aggregated interactions across
	 * multiple relationships. Does not support direct fetch at this time except in search mode.
	 *
	 * **Filtering and searching**
	 *
	 * The collection's {@link Data.BeanCollection#fetch} method supports filter and search options.
	 * For example, to search across accounts, opportunities, and contacts for favorite records
	 * that have `"Acme"` string in their searchable fields:
	 * <pre><code>
	 * (function(app) {
	 *
	 *     var records = app.data.getMixedBeanCollection();
	 *     records.fetch({
	 *         favorites: true,
	 *         query: "Acme",
	 *         module_list: "Accounts,Opportunities,Contacts"
	 *     });
	 *
	 * })(SUGAR.App);
	 * </code></pre>
	 *
	 *
	 * @class Data.MixedBeanCollection
	 * @alias SUGAR.App.MixedBeanCollection
	 * @extends Data.BeanCollection
	 */
	(function (app) {
	
	    app.augment("MixedBeanCollection", app.BeanCollection.extend({
	
	        /**
	         * Creates collections for each one of the links passed in the options.
	         * The mixed bean collection will keep those collection in sync with
	         * the mixed bean collection.
	         *
	         * @param {Array} models The initial models of the mixed bean collection.
	         * @param {Object} options A hash of options.
	         * @param {Array} options.links The links related to the mixed bean
	         *   collection. A link is a collection of a particular module. A mixed
	         *   bean collection will handle synchronization between its records and
	         *   the ones in its link collections.
	         */
	        initialize: function initialize(models, options) {
	            this._linkedCollections = {};
	
	            options = options || {};
	            if (options.links) {
	                _.each(options.links, function (collection, link) {
	                    //Check if collection is a module name rather than an existing collection
	                    if (_.isString(collection)) {
	                        this._linkedCollections[link] = app.data.createBeanCollection(collection);
	                    } else {
	                        this._linkedCollections[link] = collection;
	                    }
	
	                    this.listenTo(this._linkedCollections[link], 'add', this._onLinkAdd);
	                    this.listenTo(this._linkedCollections[link], 'remove', this._onLinkRemove);
	                    this.listenTo(this._linkedCollections[link], 'reset', this._onLinkReset);
	                }, this);
	
	                delete options.links;
	            }
	
	            app.BeanCollection.prototype.initialize.call(this, models, options);
	        },
	
	        /**
	         * Sets the `model` class to match the given model.
	         * @param {Data.Bean} model The bean to be added to the collection.
	         * @param {Object} options A hash of options.
	         * @return {Data.Bean} The prepared bean.
	         */
	        _prepareModel: function _prepareModel(model, options) {
	            var module = model instanceof app.Bean ? model.module : model._module;
	            this.model = app.data.getBeanClass(module);
	            return app.BeanCollection.prototype._prepareModel.call(this, model, options);
	        },
	
	        /**
	         * Callback to add a bean to the collection when it got added to a
	         * linked collection.
	         * @param {Data.Bean} model The bean to add.
	         * @param {Data.BeanCollection} collection The collection where the
	         * bean got added.
	         * @param {Object} [options] A hash of options.
	         */
	        _onLinkAdd: function _onLinkAdd(model, collection, options) {
	            if (this._updating) {
	                return;
	            }
	
	            app.BeanCollection.prototype.add.call(this, model);
	        },
	
	        /**
	         * Callback to remove a bean from the collection when it got removed
	         * from a linked collection.
	         *
	         * @param {Data.Bean} model The bean to remove.
	         * @param {Data.BeanCollection} collection The collection from which the
	         * bean got removed.
	         * @param {Object} [options] A hash of options.
	         */
	        _onLinkRemove: function _onLinkRemove(model, collection, options) {
	            if (this._updating) {
	                return;
	            }
	
	            app.BeanCollection.prototype.remove.call(this, model);
	        },
	
	        /**
	         * Callback to update the collection when a linked collection got reset.
	         *
	         * @param {Data.BeanCollection} collection The linked collection that
	         * got reset.
	         */
	        _onLinkReset: function _onLinkReset(collection) {
	            var groupedBeans = _.groupBy(this.models, function (model) {
	                return model instanceof app.Bean ? model.get('_link') : model._link;
	            });
	
	            var linkName = _.findKey(this._linkedCollections, function (val) {
	                return val === collection;
	            });
	
	            app.BeanCollection.prototype.remove.call(this, groupedBeans[linkName]);
	            app.BeanCollection.prototype.add.call(this, collection.models);
	        },
	
	        /**
	         * Adds models to the matching linked collections.
	         */
	        add: function add(models, options) {
	            // We don't call the BeanCollection method because a mixed bean
	            // collection does not need to track it's own deltas.
	            models = Backbone.Collection.prototype.add.call(this, models, options);
	            if (_.isEmpty(this._linkedCollections)) {
	                return models;
	            }
	
	            this._updating = true;
	            options = options || {};
	
	            if (!_.isUndefined(models) && !_.isArray(models)) {
	                models = [models];
	            }
	
	            _.each(models, function (model) {
	                var link = model.get('_link');
	                if (!link) {
	                    return;
	                }
	
	                if (this._linkedCollections[link]) {
	                    this._linkedCollections[link].add(model, options);
	                }
	            }, this);
	
	            this._updating = false;
	
	            return models;
	        },
	
	        /**
	         * Removes models from the matching linked collections.
	         */
	        remove: function remove(models, options) {
	            // We don't call the BeanCollection method because a mixed bean
	            // collection does not need to track it's own deltas.
	            models = Backbone.Collection.prototype.remove.call(this, models, options);
	            if (_.isEmpty(this._linkedCollections)) {
	                return models;
	            }
	
	            this._updating = true;
	            options = options || {};
	
	            if (!_.isUndefined(models) && !_.isArray(models)) {
	                models = [models];
	            }
	
	            _.each(models, function (model) {
	                var link = model.get('_link');
	                if (!link) {
	                    return;
	                }
	
	                if (this._linkedCollections[link]) {
	                    this._linkedCollections[link].remove(model, options);
	                }
	            }, this);
	
	            this._updating = false;
	
	            return models;
	        },
	
	        /**
	         * Resets linked collection
	         */
	        reset: function reset(models, options) {
	            if (_.isEmpty(this._linkedCollections)) {
	                // We don't call the BeanCollection method because a mixed bean
	                // collection does not need to track it's own deltas.
	                return Backbone.Collection.prototype.reset.call(this, models, options);
	            }
	
	            var sortedBeans = _.groupBy(models, function (model) {
	                return model instanceof app.Bean ? model.get('_link') : model._link;
	            });
	
	            _.each(this._linkedCollections, function (collection, link) {
	                collection.reset(sortedBeans[link], options);
	            }, this);
	        },
	
	        /**
	         * Gets changes made on the linked collections.
	         *
	         * @return {Object} The object representing the changes made on the
	         * linked collections since the last sync.
	         *
	         * TODO: SC-6145 will add `add` and `delete` arrays.
	         */
	        getDelta: function getDelta() {
	            var result = {};
	            _.each(this._linkedCollections, function (val, linkName) {
	                var delta = val.getDelta();
	                if (_.isEmpty(delta)) {
	                    return;
	                }
	
	                result[linkName] = delta;
	            }, this);
	
	            return result;
	        },
	
	        /**
	         * Resets the delta object on each linked collection.
	         */
	        resetDelta: function resetDelta() {
	            _.each(this._linkedCollections, function (val, linkName) {
	                val.resetDelta();
	            });
	        },
	
	        /**
	         * Fetches records.
	         *
	         * This method performs global search across multiple modules.
	         * @param options(optional) Fetch options.
	         *
	         * - module_list: comma-delimited list of modules to search across. The default is a list of all displayable modules.
	         *
	         * See {@link Data.BeanCollection#fetch} method for details about the reset of the options.
	         *
	         */
	        fetch: function fetch(options) {
	            options = options || {};
	            // We set a list of all modules by default
	            options.module_list = this.module_list = options.module_list || this.module_list || app.metadata.getModuleNames({ filter: 'visible' });
	            return app.BeanCollection.prototype.fetch.call(this, options);
	        },
	
	        /**
	         * Groups models by module name.
	         * @return {Object} Sets of models. Key is module name, value is array of models.
	         */
	        groupByModule: function groupByModule() {
	            return _.groupBy(this.models, function (model) {
	                return model.module;
	            });
	        },
	
	        /**
	         * Returns string representation of this collection:
	         * <code>mcoll:[length]</code>
	         * @return {String} string representation of this collection.
	         */
	        toString: function toString() {
	            return "mcoll:" + this.length;
	        }
	
	    }), false);
	})(SUGAR.App);

/***/ },
/* 54 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * Manages bean model and collection classes.
	 *
	 * **Data manager provides:**
	 *
	 * - Interface to declare bean model and collection classes from metadata.
	 * - Factory methods for creating instances of beans and bean collections.
	 * - Factory methods for creating instances of bean relations and relation collections.
	 * - Custom implementation of <code>Backbone.sync</code> pattern.
	 *
	 * **Data model metadata**
	 *
	 * Metadata that describes the data model contains information about module fields and its relationships.
	 * From the following sample metadata, data manager would declare two classes: Opportunities and Contacts.
	 * <pre><code>
	 * var metadata =
	 * {
	 *   "modules": {
	 *     "Opportunities": {
	 *        "fields": {
	 *            "name": { ... },
	 *            ...
	 *        }
	 *      },
	 *      "Contacts": { ... }
	 *    }
	 *    "relationships": {
	 *        "opportunities_contacts": { ... },
	 *         ...
	 *    }
	 *
	 * }
	 * </code></pre>
	 *
	 * **Working with beans**
	 *
	 * <pre><code>
	 * (function(app) {
	 *
	 * // Declare bean classes from metadata payload.
	 * // This method should be called at application start-up and whenever the metadata changes.
	 * app.data.declareModels(metadata);
	 * // You may now create bean instances using factory methods.
	 * var opportunity = app.data.createBean("Opportunities", { name: "Cool opportunity" });
	 * // You can save a bean using standard Backbone.Model.save method.
	 * // The save method will use data manager's sync method to communicate changes to the remote server.
	 * opportunity.save();
	 *
	 * // Create an empty collection of contacts.
	 * var contacts = app.data.createBeanCollection("Contacts");
	 * // Fetch a list of contacts
	 * contacts.fetch();
	 *
	 * })(SUGAR.App);
	 * </code></pre>
	 *
	 * **Working with relationships**
	 *
	 * <pre><code>
	 * (function(app) {
	 *
	 * var attrs = {
	 *   firstName: "John",
	 *   lastName: "Smith",
	 *   // relationship field
	 *   opportunityRole: "Influencer"
	 * }
	 * // Create a new instance of a contact related to an existing opportunity
	 * var contact = app.data.createRelatedBean(opportunity, null, "contacts", attrs);
	 * // This will save the contact and create the relationship
	 * contact.save(null, { relate: true });
	 *
	 * // Create an instance of contact collection related to an existing opportunity
	 * var contacts = app.data.createRelatedCollection(opportunity, "contacts");
	 * // This will fetch related contacts
	 * contacts.fetch({ relate: true });
	 *
	 * })(SUGAR.App);
	 * </code></pre>
	 *
	 * @class Data.DataManager
	 * @alias SUGAR.App.data
	 * @singleton
	 */
	(function (app) {
	
	    // Bean class cache
	    var _models = {};
	    // Bean collection class cache
	    var _collections = {};
	
	    var _dataManager = _.extend({
	
	        /**
	         * Reference to the base bean model class. Defaults to {@link Data.Bean}.
	         * @property {Data.Bean}
	         */
	        beanModel: app.Bean,
	        /**
	         * Reference to the base bean collection class. Defaults to {@link Data.BeanCollection}.
	         * @property {Data.BeanCollection}
	         */
	        beanCollection: app.BeanCollection,
	        /**
	         * Reference to the base mixed bean collection class. Defaults to {@link Data.MixedBeanCollection}.
	         * @property {Data.MixedBeanCollection}
	         */
	        mixedBeanCollection: app.MixedBeanCollection,
	
	        /**
	         * Initializes data manager.
	         * @method
	         */
	        init: function init() {
	            var sync = _.bind(this.sync, this);
	            app.Bean.prototype.sync = sync;
	            app.BeanCollection.prototype.sync = sync;
	
	            app.events.register(
	            /**
	             * Fires when the sync operation starts.
	             *
	             * Two parameters are passed to the callback:
	             *
	             *  - operation name (`method`)
	             *  - reference to the model/collection
	             *  - options
	             *
	             * <pre><code>
	             * (function(app) {
	             *     app.events.on("data:sync:start", function(method, model, options) {
	             *         app.logger.debug("Started operation " + method + " on " + model);
	             *     });
	             * })(SUGAR.App);
	             * </code></pre>
	             * @event
	             */
	            "data:sync:start", this);
	
	            app.events.register(
	            /**
	             * Fires when the sync operation ends.
	             *
	             * Three parameters are passed to the callback:
	             *
	             *  - operation name (`method`)
	             *  - reference to the model/collection
	             *  - options
	             *  - request (SUGAR.Api.HttpRequest)
	             *
	             * <pre><code>
	             * (function(app) {
	             *     app.events.on("data:sync:complete", function(method, model, options, request) {
	             *         app.logger.debug("Finished operation " + method + " on " + model);
	             *     });
	             * })(SUGAR.App);
	             * </code></pre>
	             * @event
	             */
	            "data:sync:complete", this);
	
	            app.events.register(
	            /**
	             * Fires when the sync operation ends successfully.
	             *
	             * Four parameters are passed to the callback:
	             *
	             *  - operation name (`method`)
	             *  - reference to the model/collection
	             *  - options
	             *  - request (SUGAR.Api.HttpRequest)
	             *
	             * <pre><code>
	             * (function(app) {
	             *     app.events.on("data:sync:success", function(method, model, options, request) {
	             *         app.logger.debug("Finished operation " + method + " on " + model);
	             *     });
	             * })(SUGAR.App);
	             * </code></pre>
	             * @event
	             */
	            "data:sync:success", this);
	
	            app.events.register(
	            /**
	             * Fires when the sync operation ends unsuccessfully.
	             *
	             * Four parameters are passed to the callback:
	             *
	             *  - operation name (`method`)
	             *  - reference to the model/collection
	             *  - options
	             *  - error (SUGAR.Api.HttpError)
	             *
	             * <pre><code>
	             * (function(app) {
	             *     app.events.on("data:sync:error", function(method, model, options, error) {
	             *         app.logger.debug("Operation failed " + method + " on " + model);
	             *     });
	             * })(SUGAR.App);
	             * </code></pre>
	             * @event
	             */
	            "data:sync:error", this);
	
	            app.events.register(
	            /**
	             * Fires when the sync operation was aborted.
	             *
	             * Four parameters are passed to the callback:
	             *
	             *  - operation name (`method`)
	             *  - reference to the model/collection
	             *  - options
	             *  - request {@link SUGAR.Api.HttpRequest}
	             *
	             *     (function(app) {
	             *         app.events.on("data:sync:abort", function(method, model, options, request) {
	             *             app.logger.debug("Operation aborted " + method + " on " + model);
	             *         });
	             *     })(SUGAR.App);
	             *
	             * @event
	             */
	            'data:sync:abort', this);
	        },
	
	        /**
	         * Resets class declarations.
	         * @param {String} module(optional) module name. If not specified, resets models of all modules.
	         * @method
	         */
	        reset: function reset(module) {
	            this.resetModel(module);
	            this.resetCollection(module);
	        },
	
	        /**
	         * Resets model class declarations.
	         * @param {String} module(optional) module name. If not specified, resets models of all modules.
	         * @method
	         */
	        resetModel: function resetModel(module) {
	            if (module) {
	                delete _models[module];
	            } else {
	                _models = {};
	            }
	        },
	
	        /**
	         * Resets collection class declarations.
	         * @param {String} module(optional) module name. If not specified, resets collections of all modules.
	         * @method
	         */
	        resetCollection: function resetCollection(module) {
	            if (module) {
	                delete _collections[module];
	            } else {
	                _collections = {};
	            }
	        },
	
	        /**
	         * Declares bean model and collection classes for a given module.
	         * @param {String} moduleName module name.
	         * @param module module metadata object.
	         * @method
	         */
	        declareModel: function declareModel(moduleName, module, platform, modelController, collectionController) {
	            // Bug 54814 init fields to something sane if module metadata is empty
	            platform = platform || app.config.platform || 'base';
	
	            this.declareModelClass(moduleName, module, platform, modelController);
	            this.declareCollectionClass(moduleName, platform, collectionController);
	        },
	
	        /**
	         * Declares the bean model class for a given module.
	         *
	         * @param {String} moduleName The module name.
	         * @param {String} module The module metadata.
	         * @param {String} platform The platform name.
	         * @param {Object} [modelController] The model controller.
	         */
	        declareModelClass: function declareModelClass(moduleName, module, platform, modelController) {
	            var platformNamespace = app.utils.capitalize(platform);
	            moduleName = moduleName || platformNamespace + 'Model';
	
	            this.resetModel(moduleName);
	
	            var fields = module ? module.fields : {};
	            var defaults = null;
	
	            _.each(_.values(fields), function (field) {
	                if (!_.isUndefined(field['default'])) {
	                    if (defaults === null) {
	                        defaults = {};
	                    }
	                    defaults[field.name] = field['default'];
	                }
	            });
	
	            var baseProperties = {
	                /**
	                 * The hash of field names and default values.
	                 *
	                 * This hash should be used instead of
	                 * [Backbone.Model#default](http://backbonejs.org/#Model-defaults)
	                 * property. Setting default values is done in {@link Bean#initialize}
	                 * only if the given model is new.
	                 *
	                 * @member Data.Bean
	                 * @property {Object}
	                 */
	                _defaults: defaults,
	
	                /**
	                 * The module name.
	                 *
	                 * **Note:** Please do not manipulate this property directly. This
	                 * property is set by {@link Data.DataManager} and is available for
	                 * reading but should never be modified directly.
	                 *
	                 * @member Data.Bean
	                 * @property {String}
	                 */
	                module: moduleName,
	
	                /**
	                 * The list of fields and their vardefs.
	                 *
	                 * **Note:** Please do not manipulate this property directly. This
	                 * property is set by {@link Data.DataManager} and is available for
	                 * reading but should never be modified directly, like
	                 * [Backbone.Model#attributes](http://backbonejs.org/#Model-attributes).
	                 *
	                 * @member Data.Bean
	                 * @property {Object}
	                 */
	                fields: fields
	            };
	
	            var superModel = _models[platformNamespace + 'Model'] || _models.BaseModel || this.beanModel;
	
	            modelController = _.extend(modelController || {}, baseProperties);
	
	            return app.utils.extendClass(_models, superModel, moduleName, modelController, platformNamespace);
	        },
	
	        /**
	         * Declares bean collection class for a given module.
	         *
	         * @param {String} moduleName The module name.
	         * @param {String} platform The platform name.
	         * @param {Object} [collectionController] The controller.
	         */
	        declareCollectionClass: function declareCollectionClass(moduleName, platform, collectionController) {
	            var platformNamespace = app.utils.capitalize(platform);
	            var modelName = moduleName || platformNamespace + 'Model';
	            var model = _models[modelName];
	
	            moduleName = moduleName || platformNamespace + 'Collection';
	
	            if (!model) {
	                return;
	            }
	            this.resetCollection(moduleName);
	
	            var baseCollectionProperties = {
	                model: model,
	
	                /**
	                 * The module name.
	                 *
	                 * **Note:** Please do not manipulate this property directly.
	                 * This property is available for reading but should never be
	                 * modified directly.
	                 *
	                 * @member Data.BeanCollection
	                 * @property {String}
	                 */
	                module: moduleName,
	
	                /**
	                 * Current collection offset for pagination.
	                 *
	                 * This property is set by {@link #paginate} or {@link #resetPagination}
	                 * and should never be modified directly.
	                 *
	                 * @member Data.BeanCollection
	                 * @property {Number}
	                 */
	                offset: 0
	            };
	
	            var superCollection = _collections[platformNamespace + 'Collection'] || _collections.BaseCollection || this.beanCollection;
	
	            collectionController = _.extend(collectionController || {}, baseCollectionProperties);
	
	            return app.utils.extendClass(_collections, superCollection, moduleName, collectionController, platformNamespace);
	        },
	
	        /**
	         * Merges a model with its metadata.
	         *
	         * @param {String} name The module name.
	         * @param {Object} [module] The module metadata.
	         */
	        mergeModel: function mergeModel(name, module) {
	            var fields = module ? module.fields : {};
	            var defaults = null;
	
	            _.each(_.values(fields), function (field) {
	                if (!_.isUndefined(field['default'])) {
	                    if (defaults === null) {
	                        defaults = {};
	                    }
	                    defaults[field.name] = field['default'];
	                }
	            });
	
	            var baseProperties = {
	                /**
	                 * Same as {@link Data.Bean#_defaults}
	                 * @inheritdoc
	                 */
	                _defaults: defaults,
	
	                /**
	                 * Same as {@link Data.Bean#module}
	                 * @inheritdoc
	                 */
	                module: name,
	
	                /**
	                 * Same as {@link Data.Bean#fields}
	                 * @inheritdoc
	                 */
	                fields: fields
	            };
	
	            _.extend(_models[name].prototype, baseProperties);
	        },
	
	        /**
	         * Accessor for declared models
	         */
	        getModelClasses: function getModelClasses() {
	            return _models;
	        },
	
	        /**
	         * Accessor for declared collections
	         */
	        getCollectionClasses: function getCollectionClasses() {
	            return _collections;
	        },
	
	        /**
	         * Declares bean models and collections classes for each module definition.
	         * @param modules(optional) metadata hash in which keys are module names and values are module definitions.
	         * Data manager uses {@link Core.MetadataManager#getModules} method to fetch metadata
	         * if `modules` parameter is not specified.
	         */
	        declareModels: function declareModels(modules) {
	            modules = modules || app.metadata.getModules();
	            _.each(modules, function (module, name) {
	                if (!_models[name]) {
	                    this.declareModel(name, module);
	                } else {
	                    this.mergeModel(name, module);
	                }
	            }, this);
	        },
	
	        /**
	         * Gets declaration of a bean class.
	         *
	         * This method is for internal use only.
	         * @param {String} module Module name.
	         */
	        getBeanClass: function getBeanClass(module) {
	            return _models[module] || this.beanModel;
	        },
	
	        /**
	         * Creates instance of a bean.
	         *
	         * <pre><code>
	         * (function(app) {
	         *
	         * // Create an account bean. The account's name property will be set to "Acme".
	         * var account = app.data.createBean("Accounts", { name: "Acme" });
	         *
	         * // Create a team set bean with a given ID
	         * var teamSet = app.data.createBean("TeamSets", { id: "xyz" });
	         *
	         * })(SUGAR.App);
	         * </code></pre>
	         * @param {String} module Sugar module name.
	         * @param {Object} [attrs] Initial values of bean attributes, which
	         *   will be set on the model.
	         * @param {Object} [options] Backbone options hash.
	         * @return {Data.Bean} A new instance of bean model.
	         */
	        createBean: function createBean(module, attrs, options) {
	            return _models[module] ? new _models[module](attrs, options) : new app.data.beanModel(attrs, options);
	        },
	
	        /**
	         * Creates instance of a bean collection.
	         *
	         * <pre><code>
	         * (function(app) {
	         * // Create an empty collection of account beans.
	         * var accounts = app.data.createBeanCollection("Accounts");
	         *
	         * })(SUGAR.App);
	         * </code></pre>
	         * @param {String} module Sugar module name.
	         * @param {Data.Bean[]} models(optional) initial array or collection of models.
	         * @param {Object} options(optional) options hash.
	         * @return {Data.BeanCollection} A new instance of bean collection.
	         */
	        createBeanCollection: function createBeanCollection(module, models, options) {
	            return _collections[module] ? new _collections[module](models, options) : new app.data.beanCollection(models, options);
	        },
	
	        /**
	         * Creates an instance of related {@link Data.Bean} or updates an
	         * existing bean with link information.
	         *
	         *     (function(app) {
	         *
	         *     // Create a new contact related to the given opportunity.
	         *     var contact = app.data.createRelatedBean(opportunity, '1', 'contacts', {
	         *        'first_name': 'John',
	         *        'last_name': 'Smith',
	         *        'contact_role': 'Decision Maker'
	         *     });
	         *     contact.save(null, { relate: true });
	         *
	         *     })(SUGAR.App);
	         *
	         * @param {Data.Bean} bean1 instance of the first bean
	         * @param {Data.Bean|string} beanOrId2 instance or ID of the second
	         *   bean. A new instance is created if this parameter is `null`.
	         * @param {string} link relationship link name
	         * @param {Object} attrs(optional) bean attributes hash
	         * @return {Data.Bean} a new instance of the related bean or existing
	         *   bean instance updated with relationship link information.
	         */
	        createRelatedBean: function createRelatedBean(bean1, beanOrId2, link, attrs) {
	            var relatedModule = this.getRelatedModule(bean1.module, link);
	
	            attrs = attrs || {};
	            if (_.isString(beanOrId2)) {
	                attrs.id = beanOrId2;
	                beanOrId2 = this.createBean(relatedModule, attrs);
	            } else if (_.isNull(beanOrId2)) {
	                beanOrId2 = this.createBean(relatedModule, attrs);
	            } else {
	                beanOrId2.set(attrs);
	            }
	
	            /**
	             * Relationship link information.
	             *
	             * <pre>
	             * {
	             *   name: link name,
	             *   bean: reference to the related bean
	             *   isNew: flag indicating that it is a new relationship
	             * }
	             * </pre>
	             *
	             * The `link.isNew` flag is used to distinguish between an existing relationship and a relationship
	             * that is about to be created. Please, refer to REST API specification for details.
	             * In brief, REST API supports creating a new relationship for two existing records as well as
	             * updating an existing relationship (updating relationship fields).
	             * The `link.isNew` flag equals to `true` by default. The flag is set to `false` by data manager
	             * once a relationship is created and whenever relationships are fetched from the server.
	             *
	             * @member Data.Bean
	             */
	            beanOrId2.link = {
	                name: link,
	                bean: bean1,
	                isNew: true
	            };
	
	            beanOrId2.setOption('relate', true);
	
	            return beanOrId2;
	        },
	
	        /**
	         * Creates a new instance of related beans collection.
	         *
	         * <pre><code>
	         * (function(app) {
	         *
	         * // Create contacts collection for an existing opportunity.
	         * var contacts = app.data.createRelatedCollection(opportunity, "contacts");
	         * contacts.fetch({ relate: true });
	         *
	         * })(SUGAR.App);
	         * </code></pre>
	         *
	         * The newly created collection is cached in the given bean instance.
	         *
	         * @param {Data.Bean} bean the related beans are linked to the specified bean
	         * @param {string} link relationship link name
	         * @param {Array|Data.BeanCollection} models(optional) an array of related beans to populate the newly created collection with
	         * @return {Data.BeanCollection} a new instance of the bean collection
	         */
	        createRelatedCollection: function createRelatedCollection(bean, link, models) {
	            var relatedModule = this.getRelatedModule(bean.module, link);
	            var collection = this.createBeanCollection(relatedModule, models, {
	                /**
	                 * Link information.
	                 *
	                 * <pre>
	                 * {
	                 *   name: link name,
	                 *   bean: reference to the related bean
	                 * }
	                 * </pre>
	                 *
	                 * @member Data.BeanCollection
	                 */
	                link: {
	                    name: link,
	                    bean: bean
	                }
	            });
	
	            collection.setOption('relate', true);
	
	            bean._setRelatedCollection(link, collection);
	            return collection;
	        },
	
	        /**
	         * Creates a collection of beans of different modules.
	         * @param {Array|Data.BeanCollection} [models] A list of models to
	         *   populate the new collection with.
	         * @return {Data.MixedBeanCollection} Collection of mixed module
	         *   collection.
	         */
	        createMixedBeanCollection: function createMixedBeanCollection(models, options) {
	            return new app.data.mixedBeanCollection(models, options);
	        },
	
	        /**
	         * Checks if a given module can have multiple relationships via a given link.
	         * @param {String} module Name of the module to do the check for.
	         * @param {String} link Relationship link name.
	         * @return {Boolean} `true` if the module's link is 'many'-type relationship, `false` otherwise.
	         */
	        canHaveMany: function canHaveMany(module, link) {
	            var meta = app.metadata.getModule(module);
	            if (!meta || !meta.fields || !meta.fields[link]) {
	                return false;
	            }
	            if (meta.fields[link].link_type) {
	                return meta.fields[link].link_type === 'many';
	            }
	            var name = meta.fields[link].relationship;
	            var relationship = app.metadata.getRelationship(name);
	            var t = relationship.relationship_type.split('-');
	            var type;
	            if (meta.fields[link].side) {
	                type = meta.fields[link].side === 'left' ? t[0] : t[2];
	            } else if (relationship.lhs_module !== relationship.rhs_module) {
	                type = module === relationship.rhs_module ? t[0] : t[2];
	            } else {
	                type = t[0] === 'many' || t[2] === 'many' ? 'many' : 'one';
	            }
	            return type === 'many';
	        },
	
	        /**
	         * Gets fields of type `relate` for a link.
	         *
	         * Suppose a module `parentModule` has a link field named `link`.
	         * For example, `Accounts` module has a link field `cases`.
	         * It is one-to-many relationship: an account may have many related cases,
	         * however a case can have only one associated account and this association is
	         * made via a `relate` field called `Cases.account_name`.
	         *
	         * So, for the above example the following call:
	         * <pre><code>
	         * var relateField = app.data.getRelateField("Accounts", "cases");
	         * </code></pre>
	         * would return definition of `Cases.account_name` field.
	         *
	         * @param {String} parentModuleName Name of the module that has a link field named `link`.
	         * @param {String} link Link name.
	         * @return {Array} Definitions of the `relate` fields if found or empty array if not found.
	         * The array will contain one item most of the time. However, some modules have multiple
	         * `relate` fields that have the same link.
	         */
	        getRelateFields: function getRelateFields(parentModuleName, link) {
	            //Overridden to provide safeguard against exception filed in NOMAD-2979
	            //We couldn't reproduce the issue or find out exact place where data/metadata is inconsistent
	            var parentModuleDef = app.metadata.getModule(parentModuleName);
	            if (!parentModuleDef.fields[link]) {
	                return [];
	            }
	
	            var relationship = parentModuleDef.fields[link].relationship;
	            var relatedModule = this.getRelatedModule(parentModuleName, link);
	            var fields = app.metadata.getModule(relatedModule).fields;
	
	            // Find the opposite link field on related module
	            var f = _.find(fields, function (field) {
	                return field.type == "link" && field.relationship == relationship;
	            });
	
	            if (f) {
	                f = _.filter(fields, function (field) {
	                    return field.type == "relate" && field.link == f.name;
	                });
	            }
	
	            return f || [];
	        },
	
	        /**
	         * Gets relationship fields for a complex relationship.
	         *
	         * Some relationships have custom fields.
	         * For example, the `opporutnities_contacts` relationship has a custom field `contact_role`.
	         * The `Contacts` module has a field called `opportunity_role` that corresponds to the `contact_role`
	         * relationship field:
	         * <pre><code>
	         * // ['opportunity_role']
	         * var relationshipFields = app.data.getRelationshipFields("Opportunities", "contacts");
	         * </code></pre>
	         *
	         * Use this method to determine a list of relationship fields that should be rendered
	         * on views for related record(s). In the above use case, the edit view for a contact related
	         * to an opportunity should display a drop-down field for the opportunity role.
	         * The list view and detail view should also display this field.
	         *
	         * @param {String} parentModule Name of the module that has a link field called `link`.
	         * @param {String} link Link name.
	         * @return {Array} Relationship fields.
	         */
	        getRelationshipFields: function getRelationshipFields(parentModule, link) {
	            var ff = null;
	            var linkField = app.metadata.getModule(parentModule).fields[link];
	            if (linkField.rel_fields) {
	                var relationship = linkField.relationship;
	                var relatedModule = this.getRelatedModule(parentModule, link);
	                var fields = app.metadata.getModule(relatedModule).fields;
	
	                // Find the opposite link field on related module
	                var f = _.find(fields, function (field) {
	                    return field.type == "link" && field.relationship == relationship;
	                });
	
	                // Find relationship_info field
	                if (f) {
	                    f = _.find(fields, function (field) {
	                        return field.link == f.name && field.link_type == "relationship_info";
	                    });
	                }
	
	                // Extract relationship fields
	                if (f && f.relationship_fields) {
	                    var fieldNames = _.keys(linkField.rel_fields);
	                    _.each(f.relationship_fields, function (field, name) {
	                        if (_.include(fieldNames, name)) {
	                            if (!ff) ff = [];
	                            ff.push(field);
	                        }
	                    });
	                }
	            }
	
	            return ff;
	        },
	
	        /**
	         * Gets related module name.
	         * @param {String} module Name of the parent module.
	         * @param {String} link Relationship link name.
	         * @return {String} The name of the related module.
	         */
	        getRelatedModule: function getRelatedModule(module, link) {
	            var meta = app.metadata.getModule(module);
	            if (!meta || !meta.fields || !meta.fields[link]) {
	                return false;
	            }
	            var name = meta.fields[link] && meta.fields[link].relationship;
	            var relationship = app.metadata.getRelationship(name);
	            if (!relationship) {
	                return meta.fields[link].module || false;
	            }
	
	            return meta.fields[link].module || (module === relationship.rhs_module ? relationship.lhs_module : relationship.rhs_module);
	        },
	
	        /*
	         * Returns field definition of related name field
	         * @param {String} module Name of the field's module
	         * @param {String} idFieldName Name of the id field
	         */
	        getRelatedNameField: function getRelatedNameField(module, idFieldName) {
	            return _.find(app.metadata.getModule(module).fields, function (field) {
	                if (field.name !== idFieldName && field.id_name === idFieldName) {
	                    return field;
	                }
	            }, this);
	        },
	
	        /**
	         * Gets editable fields.
	         * @param {Data.Bean|Data.BeanCollection} model to get fields from.
	         * @param {Array} [fields] Names to be checked.
	         * @return {Object} Hash of editable fields.
	         */
	        getEditableFields: function getEditableFields(model, fields) {
	            var editableFields = ['id'],
	                //Always have the id included (without the id, the routing will not work correctly)
	            ignoreTypeList = ["parent", "relate"];
	
	            fields = fields || [];
	
	            // No fields were specified, try the model's attributes instead
	            if (!fields.length) {
	                fields = _.keys(model.attributes);
	            }
	
	            // Editable fields are fields that are either DB fields, such as
	            // name, or related fields that do have a real DB field behind them,
	            // such as opportunity_role (contact_role), that the user has access to edit.
	            // The following code will filter out fields such as assigned_user_name.
	            _.each(fields, function (fieldName) {
	                var fieldValue;
	
	                if (model.has(fieldName) && // Model has that field AND
	                model.fields[fieldName] && ( // Field exists in the model AND
	                !model.fields[fieldName].source || // (The field does not have a source specified OR
	                model.fields[fieldName].source !== 'non-db' || // the field's source is something other than 'non-db' OR
	                !model.fields[fieldName].type || // The field does not have a field type specified OR
	                ignoreTypeList.indexOf(model.fields[fieldName].type) === -1) && // The field's source is 'non-db', but the field's type is not in our ignore list) AND
	                app.acl.hasAccessToModel("edit", model, fieldName)) {
	                    // The user has access to edit the field
	
	                    fieldValue = model.get(fieldName);
	                    //FIXME: This if condition is deprecated. It relies on a
	                    //format created by VirtualCollection Mango plugin which
	                    //sidecar does not know about and needs to be be removed.
	                    if (fieldValue && model.fields[fieldName].type === 'collection' && !_.isEmpty(fieldValue.links)) {
	                        _.each(fieldValue.links, function (link) {
	                            editableFields.push(link.link.name);
	                        });
	                    } else {
	                        editableFields.push(fieldName);
	                    }
	                }
	            });
	
	            return model.toJSON({
	                fields: editableFields
	            });
	        },
	
	        /**
	         * Custom implementation of `Backbone.sync` pattern. Syncs models with
	         * the remote server using {@link SUGAR.Api}.
	         *
	         * @param {string} method The CRUD method: ('create', 'read', 'update',
	         *   or 'delete').
	         * @param {Data.Bean|Data.BeanCollection} model The model/collection to
	         *   be synced/read.
	         * @param {Object} [options] Standard Backbone options as well as
	         *   Sugar-specific options.
	         */
	        sync: function sync(method, model, options) {
	            app.logger.trace('data-sync-' + (options.relate ? 'relate-' : '') + method + ": " + model);
	            options = this.parseOptionsForSync(method, model, options);
	            var callbacks = this.getSyncCallbacks(method, model, options),
	                request = null;
	
	            model.dataFetched = false;
	            // trigger global data:sync:start event
	            this.trigger("data:sync:start", method, model, options);
	
	            /**
	             * Fires on model when the sync operation starts.
	             *
	             * Two parameters are passed to the callback:
	             *
	             *  - operation name (`method`)
	             *  - options
	             *
	             * <pre><code>
	             * (function(app) {
	             *     model.on("data:sync:start", function(method, options) {
	             *         app.logger.debug("Started operation " + method + " on " + model);
	             *     });
	             * })(SUGAR.App);
	             * </code></pre>
	             * @event
	             */
	            model.trigger("data:sync:start", method, options);
	
	            if (_.isFunction(options.endpoint)) {
	                options.endpoint(method, model, options, callbacks);
	            } else if (model.link && model.link.bean && options.relate === true) {
	                // Related data is an object should contain:
	                // - related bean (including relationship fields) in case of create method
	                // - just relationship fields in case of update method
	                // - null for read/delete method
	                var relatedData = null;
	                if (method == "create" || method == "update") {
	                    // Pass all fields: bean fields + relationship fields
	                    relatedData = this.getEditableFields(model, options.fields);
	                    // Change 'update' method to 'create' if the relationship is a new one
	                    if (method == "update" && model.link.isNew) {
	                        method = "create";
	                    }
	                }
	
	                if (!model.link.bean.id) {
	                    console.error("Attempted to load linked context with no id on the linked bean");
	                    console.log(model.link.bean);
	                    return false;
	                }
	
	                request = app.api.relationships(method, model.link.bean.module, {
	                    id: model.link.bean.id,
	                    link: model.link.name,
	                    relatedId: model.id,
	                    related: relatedData
	                }, options.params, callbacks, options.apiOptions);
	            } else if (options.favorite) {
	
	                request = app.api.favorite(model.module, model.id, model.isFavorite(), callbacks, options.apiOptions);
	            } else if (options.following) {
	                request = app.api.follow(model.module, model.id, model.get('following'), callbacks, options.apiOptions);
	            } else {
	                // Use global search API whenever a query is specified or a mixed collection is used
	                if (options.query || model instanceof app.MixedBeanCollection) {
	                    request = app.api.search(options.params, callbacks, options.apiOptions);
	                } else if (model.module) {
	                    request = app.api.records(method, model.module, method == "update" || method == "create" ? this.getEditableFields(model, options.fields) : model.attributes, options.params, callbacks, options.apiOptions);
	                } else {
	                    app.logger.error("Unable to sync model with no module");
	                }
	            }
	
	            return request;
	        },
	
	        parseOptionsForSync: function parseOptionsForSync(method, model, options) {
	            options = options || {};
	            options.params = _.extend({}, options.params);
	            options.filterDef = options.filter || model.filterDef;
	            options.method = method;
	
	            if (options.view && _.isString(options.view) && method == "read") {
	                options.params.view = options.view;
	            }
	
	            if (options.fields && method == "read") {
	                options.params.fields = options.fields.join(",");
	            }
	
	            // Track as recently viewed
	            if (options.viewed === true) {
	                options.params.viewed = "1";
	            }
	
	            if (method == "read" && model instanceof app.BeanCollection) {
	                if (options.offset && options.offset !== 0) {
	                    options.params.offset = options.offset;
	                }
	
	                if (options.limit || app.config && app.config.maxQueryResult) {
	                    options.params.max_num = options.limit || app.config.maxQueryResult;
	                }
	
	                if (model.orderBy && model.orderBy.field) {
	                    options.params.order_by = model.orderBy.field + ":" + model.orderBy.direction;
	                }
	
	                if (options.myItems === true) {
	                    options.params.my_items = "1";
	                }
	
	                if (options.favorites === true) {
	                    options.params.favorites = "1";
	                }
	
	                if (!_.isEmpty(options.filterDef)) {
	                    var filterDef = app.utils.deepCopy(options.filterDef);
	
	                    // We want to assign to params.filter the filter definition
	                    // itself (the value assigned to the "filter" key).
	                    if (_.has(filterDef, "filter")) {
	                        filterDef = filterDef.filter;
	                    }
	
	                    if (!_.isArray(filterDef)) {
	                        filterDef = [filterDef];
	                    }
	                    options.params.filter = filterDef;
	                }
	
	                if (!_.isEmpty(options.query)) {
	                    options.params.q = options.query;
	                    if (_.isEmpty(options.module_list) && model.module) {
	                        // Set module list to be the collection's module
	                        options.module_list = [model.module];
	                    }
	                }
	
	                if (options.module_list) {
	                    options.params.module_list = options.module_list.join(",");
	                }
	            }
	
	            if (method === 'update' && options.lastModified) {
	                options.apiOptions = options.apiOptions || {};
	                options.apiOptions.headers = options.apiOptions.headers || {};
	                options.apiOptions.headers['X-TIMESTAMP'] = options.lastModified;
	            }
	
	            return options;
	        },
	
	        getSyncCallbacks: function getSyncCallbacks(method, model, options) {
	            return {
	                success: this.getSyncSuccessCallback(method, model, options),
	                error: this.getSyncErrorCallback(method, model, options),
	                complete: this.getSyncCompleteCallback(method, model, options),
	                abort: this.getSyncAbortCallback(method, model, options)
	            };
	        },
	
	        getSyncSuccessCallback: function getSyncSuccessCallback(method, model, options) {
	            var self = this;
	            return function (data, request) {
	                model.inSync = true;
	                model.original_assigned_user_id = model.get("assigned_user_id");
	                if (method == "read" && model instanceof app.BeanCollection) {
	                    var offset = options.offset || 0;
	                    data = data || {};
	
	                    if (data.next_offset) {
	                        model.offset = data.next_offset != -1 ? data.next_offset : offset + (data.records || []).length;
	                        model.next_offset = data.next_offset;
	                        model.page = model.getPageNumber(options);
	                    }
	
	                    if (!options.update) {
	                        // We need to invalidate the cached version of the total
	                        // when a reset is fired on the collection from actions
	                        // such as filtering. If however, the total is being
	                        // populated from the server response, that will be
	                        // used instead.
	                        model.total = _.isNumber(data.total) ? data.total : null;
	                    }
	
	                    // We need `xmod_aggs` property which are the facets
	                    // for search.
	                    if (model instanceof app.MixedBeanCollection) {
	                        model.xmod_aggs = data.xmod_aggs || null;
	                        model.tags = data.tags || null;
	                    }
	                    data = data.records || [];
	
	                    // Update collection filter/search properties on success
	                    self._updateCollectionProperties(model, options);
	                }
	
	                if (options.relate === true) {
	                    // Reset the flag to indicate that relationship(s) do exist.
	                    model.link.isNew = false;
	
	                    if (method != "read") {
	                        // The response for create/update/delete relationship contains updated beans
	                        if (model.link.bean) {
	                            var syncedAttributes = model.link.bean.getSynced(),
	                                updatedAttributes = _.reduce(data.record, function (memo, val, key) {
	                                if (!_.isEqual(syncedAttributes[key], val)) {
	                                    memo[key] = val;
	                                }
	                                return memo;
	                            }, {});
	                            model.link.bean.set(updatedAttributes);
	                            //Once parent model is reset, reset internal synced attributes as well
	                            model.link.bean.setSyncedAttributes(data.record);
	                        }
	                        data = data.related_record;
	                        // Attributes will be set automatically for create/update but not for delete
	                        // Also, break the link
	                        if (method == "delete") {
	                            model.set(data);
	                            delete model.link;
	                        }
	                    }
	                }
	
	                model.dataFetched = true;
	                if (options.success) options.success(data);
	                // trigger global data:sync:success event
	                self.trigger("data:sync:success", method, model, options, request);
	                model.inSync = null;
	            };
	        },
	
	        /**
	         * Returns the callback to the sync `error` event.
	         *
	         * Triggers the global `data:sync:complete` event (registered on
	         * {@link Core.Events app.events}), as well as on the `model`.
	         *
	         * Executes the abort callback if we are aborting from a previous
	         * collection fetch request.
	         *
	         * @param {string} method The CRUD method: ('create', 'read', 'update',
	         *   or 'delete').
	         * @param {Data.Bean|Data.BeanCollection} model The model/collection to
	         *   be synced/read.
	         * @param {Object} [options] Standard Backbone options as well as
	         *   Sugar-specific options.
	         * @param {Object} [options.error] Custom `error` callback
	         *   function to be executed.
	         * @return {Function} The wrapped `error` callback function.
	         */
	        getSyncErrorCallback: function getSyncErrorCallback(method, model, options) {
	            return _.bind(function (error) {
	                if (error.request && error.request.aborted) {
	                    var abortCallback = this.getSyncAbortCallback(method, model, options);
	                    return abortCallback(error.request);
	                }
	                app.error.handleHttpError(error, model, options);
	                this.trigger('data:sync:error', method, model, options, error);
	                /**
	                 * Fires on model when the sync operation ends unsuccessfully.
	                 *
	                 * Three parameters are passed to the callback:
	                 *
	                 *  - operation name (`method`)
	                 *  - options
	                 *  - error {@link SUGAR.Api.HttpError}
	                 *
	                 *     (function(app) {
	                 *         model.on('data:sync:error', function(method, options, error) {
	                 *             app.logger.debug('Operation failed:' + method + ' on ' + model);
	                 *         });
	                 *     })(SUGAR.App);
	                 *
	                 * @event
	                 */
	                model.trigger('data:sync:error', method, options, error);
	
	                if (_.isFunction(options.error)) {
	                    options.error(error);
	                }
	            }, this);
	        },
	
	        /**
	         * Returns the callback to the `complete` event, which fires after
	         * either `success`, or `error`.
	         *
	         * Triggers the global `data:sync:complete` event (registered on
	         * {@link Core.Events app.events}), as well as on the `model`.
	         *
	         * @param {string} method The CRUD method: ('create', 'read', 'update',
	         *   or 'delete').
	         * @param {Data.Bean|Data.BeanCollection} model The model/collection to
	         *   be synced/read.
	         * @param {Object} [options] Standard Backbone options as well as
	         *   Sugar-specific options.
	         * @param {Object} [options.complete] Custom `complete` callback
	         *   function to be executed.
	         * @return {Function} The wrapped `complete` callback function.
	         */
	        getSyncCompleteCallback: function getSyncCompleteCallback(method, model, options) {
	            return _.bind(function (request) {
	                this.trigger('data:sync:complete', method, model, options, request);
	                /**
	                 * Fires on model when the sync operation ends.
	                 *
	                 * Three parameters are passed to the callback:
	                 *
	                 *  - operation name (`method`)
	                 *  - options
	                 *  - request {@link SUGAR.Api.HttpRequest}
	                 *
	                 *     (function(app) {
	                 *         model.on('data:sync:complete', function(method, options, request) {
	                 *             app.logger.debug('Finished operation ' + method + ' on ' + model);
	                 *         });
	                 *     })(SUGAR.App);
	                 *
	                 * @event
	                 */
	                model.trigger('data:sync:complete', method, options, request);
	
	                if (_.isFunction(options.complete)) {
	                    options.complete(request);
	                }
	
	                // Prevent memory leaking
	                options.previousModels = null;
	                options = {};
	            }, this);
	        },
	
	        /**
	         * Returns the callback to the `abort` event, which fires after
	         * either `success`, or `error`.
	         *
	         * Triggers the global `data:sync:abort` event (registered on
	         * {@link Core.Events app.events}), as well as on the `model`.
	         *
	         * @param {string} method The CRUD method: ('create', 'read', 'update',
	         *   or 'delete').
	         * @param {Data.Bean|Data.BeanCollection} model The model/collection to
	         *   be synced/read.
	         * @param {Object} [options] Standard Backbone options as well as
	         *   Sugar-specific options.
	         * @param {Object} [options.abort] Custom `abort` callback
	         *   function to be executed.
	         * @return {Function} The wrapped `abort` callback function.
	         */
	        getSyncAbortCallback: function getSyncAbortCallback(method, model, options) {
	            return _.bind(function (request) {
	                this._updateCollectionProperties(model, options);
	                this.trigger('data:sync:abort', method, model, options, request);
	                /**
	                 * Fires on model when the sync operation ends.
	                 *
	                 * Three parameters are passed to the callback:
	                 *
	                 *  - operation name (`method`)
	                 *  - options
	                 *  - request {@link SUGAR.Api.HttpRequest}
	                 *
	                 *     (function(app) {
	                 *         model.on('data:sync:abort', function(method, options, request) {
	                 *             app.logger.debug("Operation aborted " + method + " on " + model);
	                 *         });
	                 *     })(SUGAR.App);
	                 *
	                 * @event
	                 */
	                model.trigger('data:sync:abort', method, options, request);
	            }, this);
	        },
	
	        /**
	         * Updates various properties on the bean collection passed.
	         *
	         * @private
	         * @param {Data.BeanCollection} model The collection.
	         * @param {Object} [options] Standard Backbone options as well as
	         *   Sugar-specific options.
	         */
	        _updateCollectionProperties: function _updateCollectionProperties(model, options) {
	            options = options || {};
	
	            /**
	             * Flag indicating if a collection contains items assigned to the
	             * current user (read-only).
	             *
	             * @member Data.BeanCollection
	             * @property {boolean}
	             */
	            model.myItems = options.myItems;
	            /**
	             * Flag indicating if a collection contains current user's favorite
	             * items (read-only).
	             *
	             * @member Data.BeanCollection
	             * @property {boolean}
	             */
	            model.favorites = options.favorites;
	            /**
	             * Search query (read-only).
	             *
	             * @member Data.BeanCollection
	             * @property {string}
	             */
	            model.query = options.query;
	            /**
	             * List of modules searched (read-only).
	             *
	             * @member Data.MixedBeanCollection
	             * @property {string}
	             */
	            model.modelList = options.modelList;
	            /**
	             * Filter definition to filter the collection by.
	             *
	             * @member Data.BeanCollection
	             * @property {Array}
	             */
	            model.filterDef = options.filterDef;
	        }
	
	    }, Backbone.Events);
	
	    app.augment("data", _dataManager, false);
	})(SUGAR.App);

/***/ },
/* 55 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * Validation module.
	 *
	 * The validation module is used by {@link Data.Bean#validate} method.
	 * Each bean field is validated by each of the validators specified in the {@link Data.Validation.validators} hash.
	 *
	 * The bean is also checked for required fields by {@link Data.Validation#requiredValidator} method.
	 *
	 * @class Data.Validation
	 * @alias SUGAR.App.validation
	 * @singleton
	 */
	(function (app) {
	
	    // IMPORTANT: Validators must return nothing (undefined) if validation passes
	
	    app.augment("validation", {
	
	        /**
	         * A hash of validators. Each validator function must return error definition or nothing otherwise.
	         * Error definition could be a primitive value such as max length or an array, e.g. range's lower and upper limits.
	         * Validator function accepts field metadata and the value to be validated.
	         *
	         * @class Data.Validation.validators
	         * @member Data.Validation
	         * @singleton
	         */
	        validators: function () {
	            // Helper that validates either min or max
	            var _minMaxValue = function _minMaxValue(field, value, type) {
	                var limit = _.isUndefined(field[type]) ? field.validation ? field.validation[type] : null : field[type];
	                if (_.contains(['int', 'float', 'decimal', 'currency'], field.type) && _.isFinite(limit)) {
	                    if (field.type == 'int') {
	                        value = parseInt(value);
	                    } else {
	                        value = parseFloat(value);
	                    }
	                    if (type == 'max') {
	                        if (value > limit) return limit;
	                    } else if (type == 'min') {
	                        if (value < limit) return limit;
	                    } else if (type == 'greaterthan') {
	                        if (value <= limit) return limit;
	                    } else if (type == 'lessthan') {
	                        if (value >= limit) return limit;
	                    }
	                }
	            };
	
	            // Helper that validates the given date is before/after the date of another field
	            var _isBeforeAfter = function _isBeforeAfter(field, value, type, model) {
	                if (_.indexOf(['date', 'datetimecombo'], field.type) !== -1 && field.validation && field.validation.type === type) {
	                    var compareTo = model.fields[field.validation.compareto];
	                    if (!_.isUndefined(compareTo) && _.indexOf(['date', 'datetimecombo'], compareTo.type) != -1) {
	                        var compareToValue = Date.parse(model.get(compareTo.name));
	                        value = Date.parse(value.toString());
	                        if (!_.isNaN(compareToValue) && !_.isNaN(value)) {
	                            var compareToLabel = app.lang.get(compareTo.label || compareTo.vname || compareTo.name, model.module);
	                            if (type == "isbefore") {
	                                return compareToValue < value ? compareToLabel : undefined;
	                            }
	                            if (type == "isafter") {
	                                return compareToValue > value ? compareToLabel : undefined;
	                            }
	                        }
	                    }
	                }
	            };
	
	            return {
	
	                /**
	                 * Validates the max length of a given value.
	                 * @param {String} field bean field metadata
	                 * @param {String|Number} value bean field value
	                 * @return {Number} max length or nothing if the field is valid.
	                 * @method
	                 */
	                maxLength: function maxLength(field, value) {
	                    if (_.isNumber(value)) {
	                        value = value.toString();
	                    }
	                    if (_.isNumber(field.len) && _.isString(value)) {
	                        var maxLength = field.len;
	                        value = value || "";
	                        value = value.toString();
	                        if (value.length > maxLength) {
	                            return maxLength;
	                        }
	                    }
	                },
	
	                /**
	                 * Validates the min length of a given value.
	                 * @param {String} field bean field metadata
	                 * @param {String} value bean field value
	                 * @return {Number} min length or nothing if the field is valid.
	                 * @method
	                 */
	                minLength: function minLength(field, value) {
	                    if (_.isNumber(field.minlen)) {
	                        // TODO: Not sure what the proper property is if there is one
	                        var minLength = field.minlen;
	                        value = value || "";
	                        value = value.toString();
	
	                        if (value.length < minLength) {
	                            return minLength;
	                        }
	                    }
	                },
	
	                /**
	                 * Validates that a given value is a valid URL.
	                 * NOTE: Should be noted we can't do full validation of urls w/ javascript as that is impossible.
	                 * @param {String} field bean field metadata
	                 * @param {String} value bean field value
	                 * @return {Boolean} `true` if the field is not valid
	                 */
	                url: function url(field, value) {
	                    // TODO: we should probably remove the requirement for http/https prefix
	                    //                if ((field.type == "url") && (!(/^(https?|http):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/.test(value)))) {
	                    //                    return true;
	                    //                }
	                },
	
	                /**
	                 * Validates that a given value is a valid email address.
	                 *
	                 * NOTE: Should be noted that we can't do full email validation w/ javascript.
	                 * @param {String} field bean field metadata
	                 * @param {String} emails bean field value which is an array of email objects
	                 * @return {Array} Array of invalid email addresses.
	                 */
	                email: function email(field, emails) {
	                    var results;
	                    if (field.type == 'email' || field.type === 'email-text') {
	                        if (emails.length > 0) {
	                            _.each(emails, function (email) {
	                                // if email is blank but not required, let it go
	                                if (email.email_address === '' && (_.isUndefined(field.required) || !field.required)) {
	                                    return;
	                                }
	                                if (!app.utils.isValidEmailAddress(email.email_address)) {
	                                    if (!results) results = [];
	                                    results.push(email.email_address);
	                                }
	                            });
	                        }
	                        if (results && results.length > 0) {
	                            return results;
	                        }
	                    }
	                },
	
	                /**
	                 * Validates that a given email array has at least one email set as the primary email.
	                 *
	                 * @param {String} field bean field metadata
	                 * @param {String} emails bean field value which is an array of email objects
	                 * @return {Array} Array of invalid email addresses.
	                 */
	                primaryEmail: function primaryEmail(field, emails) {
	                    if (field.type == "email") {
	                        if (emails.length > 0 && !_.find(emails, function (email) {
	                            return email.primary_address == "1";
	                        })) {
	                            return true;
	                        }
	                    }
	                },
	
	                /**
	                 * Validates that a given email array has no duplicate email addresses.
	                 *
	                 * @param {String} field bean field metadata
	                 * @param {String} emails bean field value which is an array of email objects
	                 * @return {Array} Array of invalid email addresses.
	                 */
	                duplicateEmail: function duplicateEmail(field, emails) {
	                    if (field.type == "email") {
	                        var values = _.pluck(emails, "email_address"),
	                            duplicates = [],
	                            n = values.length,
	                            i,
	                            j;
	                        // to ensure the fewest possible comparisons
	                        for (i = 0; i < n; i++) {
	                            // outer loop uses each item i at 0 through n
	                            for (j = i + 1; j < n; j++) {
	                                // inner loop only compares items j at i+1 to n
	                                if (values[i] == values[j]) duplicates.push(values[i]);
	                            }
	                        }
	                        if (duplicates && duplicates.length > 0) {
	                            return duplicates;
	                        }
	                    }
	                },
	
	                /**
	                 * Validates that a given value is a real date or datetime
	                 *
	                 * @param {Object} field metadata
	                 * @param {String} Date or Datetime value as String
	                 * @return {String} The invalid date / datetime
	                 */
	                datetime: function datetime(field, value) {
	                    var val, invalidNumberOfDigits, format, sep, formatParts, parts, i, len;
	
	                    function inRange(val, min, max) {
	                        var value = parseInt(val, 10);
	                        return !isNaN(value) && value >= min && value <= max;
	                    }
	
	                    if (field.type === "date" || field.type === "datetimecombo") {
	                        // First check will short circuit (falsy) if the value is a valid server ISO date string.
	                        // For datepicker values, however, we need the second check since Safari chokes on '.', '-'
	                        if (_.isNaN(Date.parse(value)) && _.isNaN(Date.parse(value.replace(/[\.\-]/g, '/')))) {
	                            return value;
	                        } else {
	
	                            // Check for valid date parts for non ISO dates as IE and FF both successfully parse 
	                            // 2014/13/22 simply wrapping extra months around to following year (so previous example
	                            // becomes 2015/01/22).
	                            if (!app.date.isIso(value)) {
	                                // The first set of Date.parse conditionals will negate three digit days or months
	                                // but 3 digit years are valid for JavaScript dates so they'll slip through. The reason 
	                                // we explicitly invalidate 3 digit years is datepicker auto corrects 1 and 2 digit years
	                                // in yyyy but cannot do anything sensible with 3 digit years. Moreover, it was decided 
	                                // that it's much more likely a 3 digit years is a user entry error; they don't really
	                                // intend to enter a date year (e.g. 100-999 A.D.). Also any part > 4 digits is considered
	                                // invalid as well since we only support:
	                                // 2010-12-23, Y-m-d
	                                // 12-23-2010, m-d-Y
	                                // 23-12-2010, d-m-Y
	                                // 2010/12/23, Y/m/d
	                                // 12/23/2010, m/d/Y
	                                // 23/12/2010, d/m/Y
	                                // 2010.12.23, Y.m.d
	                                // 23.12.2010, d.m.Y
	                                // 12.23.2010, m.d.Y
	                                parts = value.replace(/[\.\-]/g, '/').split('/');
	                                invalidNumberOfDigits = _.filter(parts, function (part) {
	                                    return part.length === 3 || part.length > 4;
	                                });
	
	                                if (invalidNumberOfDigits.length) {
	                                    return value;
	                                }
	
	                                // Invalidate consecutive separators e.g. 12--23--2013
	                                if (/([\.\/\-])\1/.test(value) === true) {
	                                    return value;
	                                }
	
	                                // Lastly, validate month and day ranges
	                                format = app.user.getPreference('datepref');
	                                sep = format.match(/[.\/\-\s].*?/);
	                                formatParts = format.split(sep);
	                                for (i = 0, len = formatParts.length; i < len; i++) {
	                                    val = parts[i];
	                                    switch (formatParts[i].toLowerCase().charAt(0)) {
	                                        case 'm':
	                                            if (!inRange(val, 1, 12)) {
	                                                return value;
	                                            }
	                                            break;
	                                        case 'd':
	                                            if (!inRange(val, 1, 31)) {
	                                                return value;
	                                            }
	                                            break;
	                                    }
	                                }
	                            } else {
	                                // The datepicker plugin will leave 3 digit years and this validation is supposed to
	                                // invalidate; but to iso date will turn that to something like: 0201-01-31T08:00:00.000Z
	                                // We have to reject 100-999 to be consistent with the rest of our date year validation.
	                                if (value.charAt(0) === '0') return value;
	                            }
	                        }
	                    }
	                },
	
	                /**
	                 * Validates min integer values
	                 *
	                 * @param {String} field bean field metadata
	                 * @param {String} value field value which is a number
	                 * @return {Array} value of actual min
	                 */
	                minValue: function minValue(field, value) {
	                    return _minMaxValue(field, value, "min");
	                },
	
	                /**
	                 * Validates max integer values
	                 *
	                 * @param {String} field bean field metadata
	                 * @param {String} value field value which is a number
	                 * @return {Array} value of actual max
	                 */
	                maxValue: function maxValue(field, value) {
	                    return _minMaxValue(field, value, "max");
	                },
	
	                /**
	                 * Validates a value to make sure it's larger than a given value
	                 *
	                 * @param {String} field bean field metadata
	                 * @param {String} value field value which is a number
	                 * @param {String|Undefined} String is returned when validation fails, and it's what number the value
	                 *                           needs to be greater than
	                 */
	                greaterThan: function greaterThan(field, value) {
	                    return _minMaxValue(field, value, 'greaterthan');
	                },
	
	                /**
	                 * Validates a value to make sure it's less than a given value
	                 *
	                 * @param {String} field bean field metadata
	                 * @param {String} value field value which is a number
	                 * @param {String|Undefined} String is returned when validation fails, and it's what number the value
	                 *                           needs to be less than
	                 */
	                lessThan: function lessThan(field, value) {
	                    return _minMaxValue(field, value, 'lessthan');
	                },
	
	                /**
	                 * Validates numeric values
	                 *
	                 * @param {String} field bean field metadata
	                 * @param {String} value field value which is an integer
	                 * @return {Boolean} true if value is invalid, undefined otherwise
	                 */
	                number: function number(field, value) {
	                    if (_.indexOf(['int', 'float', 'decimal', 'currency'], field.type) != -1) {
	                        return _.isBoolean(value) || _.isString(value) && !value.trim().length || isNaN(parseFloat(value)) || !_.isFinite(value) ? true : undefined;
	                    }
	                },
	
	                /**
	                 * Validates that the given date is before the date of another field
	                 *
	                 * @param {Object} field metadata
	                 * @param {String} value field value which is an integer
	                 * @param {Object} model model
	                 * @return {String} compare field label if is invalid, undefined otherwise
	                 */
	                isBefore: function isBefore(field, value, model) {
	                    return _isBeforeAfter(field, value, 'isbefore', model);
	                },
	
	                /**
	                 * Validates that the given date is after the date of another field
	                 *
	                 * @param {Object} field metadata
	                 * @param {String} value field value which is an integer
	                 * @param {Object} model model
	                 * @return {String} compare field label if is invalid, undefined otherwise
	                 */
	                isAfter: function isAfter(field, value, model) {
	                    return _isBeforeAfter(field, value, 'isafter', model);
	                }
	            };
	        }(),
	
	        /**
	         * Validates if the required field is set on a bean or about to be set.
	         *
	         * @member Data.Validation
	         * @param field field metadata
	         * @param {String} fieldName bean field name
	         * @param {Data.Bean} model bean instance
	         * @param {String} value value to be set
	         * @return {Boolean} `true` if the validation fails, `undefined` otherwise
	         * @method
	         */
	        requiredValidator: function requiredValidator(field, fieldName, model, value) {
	            // Image type fields have their own requiredValidator
	            if (field.required === true && fieldName !== 'id' && field.type !== 'image' && _.isUndefined(field.auto_increment)) {
	                var currentValue = model.get(fieldName);
	                var currentUndefined = _.isUndefined(currentValue);
	                var valueEmpty = _.isNull(value) || value === '' || value === false || _.isArray(value) && this._isArrayEmpty(value) || value instanceof Backbone.Collection && !value.length;
	                if (currentUndefined && _.isUndefined(value) || valueEmpty) {
	                    return true;
	                }
	            }
	        },
	
	        /**
	          * Check if the given array contains only empty values.
	          * 
	          * @member Data.Validation
	          * @param {Array} value array to be check.
	          * @return {boolean} `true` if all array elements are empty, `false` otherwise.
	          */
	        _isArrayEmpty: function _isArrayEmpty(value) {
	            return _.every(value, _.isEmpty);
	        }
	
	    }, false);
	})(SUGAR.App);

/***/ },
/* 56 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * Handlebars helpers.
	 *
	 * These functions are to be used in handlebars templates.
	 *
	 * @class View.Handlebars.helpers
	 */
	(function (app) {
	
	    /**
	     * Creates a field widget.
	     *
	     * Example:
	     * <pre><code>
	     * {{field view model=mymodel template=edit parent=fieldset}}
	     * </code></pre>
	     *
	     * @method field
	     * @param {View.View} view Parent view
	     * @param {Object} [options] Optional params to pass to the field.
	     * @param {Backbone.Model} [options.model] The model associated with the field.
	     * @param {string} [options.template] The name of the template to be used.
	     * @param {Field} [options.parent] The parent field of this field.
	     * @return {Object} HTML placeholder for the widget as handlebars safe string.
	     */
	    Handlebars.registerHelper('field', function (view, options) {
	        var field = app.view.createField({
	            def: this,
	            viewDefs: this,
	            view: view,
	            model: options.hash.model,
	            viewName: options.hash.template
	        });
	
	        if (options.hash.parent && _.isArray(options.hash.parent.fields)) {
	            options.hash.parent.fields.push(field);
	        }
	
	        return field.getPlaceholder();
	    });
	
	    /**
	     * Creates a field widget.
	     *
	     * This helper is used for fields that don't have view definition.
	     *
	     * @method fieldOfType
	     * @param {String} type Field type
	     * @param {String} label Label key
	     * @return {Object} HTML placeholder for the widget as handlebars safe string.
	     */
	    Handlebars.registerHelper('fieldOfType', function (type, label) {
	        var def = {
	            type: type,
	            name: type,
	            label: label
	        };
	
	        var field = app.view.createField({
	            def: def,
	            view: this
	        });
	
	        return field.getPlaceholder();
	    });
	
	    /**
	     * Create a layout or a view in a given layout.
	     * @method component
	     * @param {View.Layout} layout Layout that the new layout should be created in
	     * @param {string} name Name of the component to be created
	     */
	    Handlebars.registerHelper('component', function (layout, name) {
	        var viewDef,
	            newComponent,
	            placeholder = '';
	
	        viewDef = _.find(layout.meta.components, function (defs) {
	            var componentName, componentDef;
	
	            componentDef = defs.layout || defs.view;
	
	            if (_.isString(componentDef)) {
	                componentName = componentDef;
	            } else {
	                componentName = componentDef.name || componentDef.type;
	            }
	
	            return componentName === name;
	        });
	
	        if (_.isObject(viewDef) && !_.isEmpty(viewDef)) {
	            newComponent = layout.initComponents([viewDef])[0];
	            viewDef.initializedInTemplate = true;
	            placeholder = newComponent.getPlaceholder();
	        }
	
	        return placeholder;
	    });
	
	    /**
	     * Iterates through options specified by a key.
	     *
	     * The options collection is retrieved from the language helper.
	     * @method eachOptions
	     * @param {String} key Options key.
	     * @param {Function} hbsOptions HBS options.
	     * @return {String} HTML string.
	     */
	    Handlebars.registerHelper('eachOptions', function (key, hbsOptions) {
	        var options,
	            ret = "",
	            iterator;
	
	        // Retrieve app list strings
	        options = _.isString(key) ? app.lang.getAppListStrings(key) : key;
	
	        if (_.isArray(options)) {
	            iterator = function iterator(element, index) {
	                ret = ret + hbsOptions.fn({ key: index, value: element });
	            };
	        } else if (_.isObject(options)) {
	            // Is object evaluates arrays to true, so put it second
	            iterator = function iterator(value, key) {
	                ret = ret + hbsOptions.fn({ key: key, value: value });
	            };
	        } else {
	            options = null;
	        }
	
	        // Don't iterate if options is not iteratable
	        if (options) _.each(options, iterator, this);
	
	        return ret;
	    });
	
	    /**
	     * @method buildRoute
	     * Builds a route based on hashes sent on handlebars helper.
	     *
	     * Example:
	     * <pre><code>
	     * {{buildRoute context=this.context}}
	     * {{buildRoute model=myModel action="create"}}
	     * {{buildRoute module="Employees" action="edit"}}
	     * </code></pre>
	     *
	     * If both `module` and `model` are sent, `module` will take precedence
	     * over `model.module`.
	     * Same applies for `id` (`id` will take precedence over `model.id`).
	     *
	     * @param {Object} options Handlebars options hash.
	     * @param {Object} options.hash More parameters to be used by this helper.
	     *   It needs at least one of `options.hash.module`, `options.hash.model`
	     *   or `options.hash.context`.
	     * @param {String} [options.hash.module=options.hash.model.module]
	     *   The name of the module.
	     * @param {Data.Bean} [options.hash.model=options.hash.context.get('model')]
	     *   The model to extract the module and/or id.
	     * @param {Core.Context} [options.hash.context]
	     *   A context to extract the module from.
	     * @param {String} [options.hash.id=options.hash.model.id]
	     *   The id of the bean record.
	     * @param {String} [options.hash.action]
	     *   The action name.
	     * @return {String}
	     *   The built route.
	     */
	    Handlebars.registerHelper('buildRoute', function (options) {
	        var ctx = options.hash.context,
	            model = options.hash.model || (ctx && ctx.get('model') ? ctx.get('model') : {}),
	            module = options.hash.module || model.module || (ctx && ctx.get('module') ? ctx.get('module') : null),
	            id = options.hash.id || model.id,
	            action = options.hash.action;
	
	        return app.router.buildRoute(module, id, action);
	    });
	
	    /**
	     * @method fieldValue
	     *
	     * Extracts bean field value.
	     *
	     * @param {Data.Bean} bean Bean instance.
	     * @param {String} field Field name.
	     * @param {String} [defaultValue=''] Default value to return if field
	     *   is not set on a bean.
	     *
	     * @return {String} Field value of the given bean. If field is not set the
	     *   default value or empty string.
	     */
	    Handlebars.registerHelper('fieldValue', function (bean, field, options) {
	        return bean.get(field) || options.hash.defaultValue || '';
	    });
	
	    /**
	     * Executes a given block if a given array has a value.
	     * @method has
	     * @param {string|Object} val value
	     * @param {Object|Array} array or hash object
	     * @return {string} Result of the `block` execution if the `array` contains `val` or the result of the inverse block.
	     */
	    Handlebars.registerHelper('has', function (val, array, options) {
	        // Since we need to check both just val = val 2 and also if val is in an array, we cast
	        // non arrays into arrays
	        if (!_.isArray(array) && !_.isObject(array)) {
	            array = [array];
	        }
	
	        return _.include(array, val) ? options.fn(this) : options.inverse(this);
	    });
	
	    /**
	     * Executes a given block if a given array doesn't have a value.
	     * @method notHas
	     * @param {string|Object} val value
	     * @param {Object|Array} array or hash object
	     * @return {string} Result of the `block` execution if the `array` doesn't contain `val` or the result of the inverse block.
	     */
	    Handlebars.registerHelper('notHas', function (val, array, options) {
	        var fn = options.fn,
	            inverse = options.inverse;
	        options.fn = inverse;
	        options.inverse = fn;
	
	        return Handlebars.helpers.has.call(this, val, array, options);
	    });
	
	    /**
	     * We require sortable to be the default if not defined in either field viewdef or vardefs. Otherwise,
	     * we use whatever is provided in either field vardefs or field's viewdefs where the view def has more
	     * specificity.
	     * @method has
	     * @param {String} module name
	     * @param {Object} the field view defintion (e.g. looping through meta.panels.field it will be 'this')
	     * @return {String} Result of the `block` execution if sortable, otherwise empty string.
	     */
	    Handlebars.registerHelper('isSortable', function (module, fieldViewdef, options) {
	        if (app.utils.isSortable(module, fieldViewdef)) {
	            return options.fn(this);
	        } else {
	            return '';
	        }
	    });
	
	    /**
	     * Executes a given block if a given values are equal.
	     * @method eq
	     * @param {String} val1 first value to compare
	     * @param {String} val2 second value to compare.
	     * @return {String} Result of the `block` execution if the given values are equal or the result of the inverse block.
	     */
	    Handlebars.registerHelper('eq', function (val1, val2, options) {
	        return val1 == val2 ? options.fn(this) : options.inverse(this);
	    });
	
	    /**
	     * Opposite of `eq` helper.
	     * @method notEq
	     * @param {String} val1 first value to compare
	     * @param {String} val2 second value to compare.
	     * @return {String} Result of the `block` execution if the given values are not equal or the result of the inverse block.
	     */
	    Handlebars.registerHelper('notEq', function (val1, val2, options) {
	        return val1 != val2 ? options.fn(this) : options.inverse(this);
	    });
	
	    /**
	     * Same as eq helper but second value is a {String} regex expression. Unfortunately, we have to do this because the
	     * Handlebar's parser gets confused by regex literals like /foo/
	     * @method match
	     * @param {String} val1 first value to compare
	     * @param {String} val2 A String representing a RegExp constructor argument. So if RegExp('foo.*') is the desired regex,
	     * val2 would contain "foo.*". No support for modifiers.
	     * @return {String} Result of the `block` execution if the given values are equal or the result of the inverse block.
	     */
	    Handlebars.registerHelper('match', function (val1, val2, options) {
	        var re = new RegExp(val2);
	        if (re.test(val1)) {
	            return options.fn(this);
	        } else {
	            return options.inverse(this);
	        }
	    });
	
	    /**
	     * Same as notEq helper but second value is a {String} regex expression.
	     * @method notMatch
	     * @param {String} val1 first value to compare
	     * @param {String} val2 A String representing a RegExp constructor argument. So if RegExp('foo.*') is the desired regex,
	     * val2 would contain "foo.*". No support for modifiers.
	     * @return {String} Result of the `block` execution if the given values are not equal or the result of the inverse block.
	     */
	    Handlebars.registerHelper('notMatch', function (val1, val2, options) {
	        var re = new RegExp(val2);
	        if (!re.test(val1)) {
	            return options.fn(this);
	        } else {
	            return options.inverse(this);
	        }
	    });
	
	    /**
	     * Logs a value.
	     * @method log
	     * @param value
	     */
	    Handlebars.registerHelper("log", function (value) {
	        app.logger.debug("*****HBS: Current Context*****");
	        app.logger.debug(this);
	        app.logger.debug("*****HBS: Current Value*****");
	        app.logger.debug(value);
	        console.log(value);
	        app.logger.debug("***********************");
	    });
	
	    /**
	     * Retrives a string by key.
	     *
	     * The helper queries {@link Core.Language} module to retrieve an i18n-ed string.
	     * @method str
	     * @param {String} key Key of the label.
	     * @param {String} module(optional) Module name.
	     * @param {String} content(optional) Template content.
	     * @return {String} The string for the given label key.
	     */
	    Handlebars.registerHelper("str", function (key, module, content) {
	        module = _.isString(module) ? module : null;
	        return app.lang.get(key, module, content);
	    });
	
	    /**
	     * Creates a relative time element to display the human readable related
	     * time.
	     *
	     * To provide an automatic update of this relative time, use a plugin like
	     * {@link sugar.liverelativetime.js}.
	     *
	     * @method relativeTime
	     * @param {String} iso8601 The ISO-8601 date string to be used for a new
	     *   date.
	     * @param {Object} [options] Handlebars options hash.
	     * @param {Object} [options.hash] More parameters to be used by this helper.
	     * @param {String} [options.hash.title] The title attribute. Defaults to
	     *   current user date/time preference format.
	     * @param {boolean} [options.hash.dateOnly] Setting this to `true` will
	     *   format the `title` attribute with the user-formatted date only.
	     * @return {string} The relative time like `10 minutes ago`.
	     */
	    Handlebars.registerHelper('relativeTime', function (iso8601, options) {
	
	        var date = app.date(iso8601),
	            attrs,
	            html;
	
	        options.hash.title = options.hash.title || date.formatUser(options.hash.dateOnly);
	
	        attrs = _.map(options.hash, function (attr, key) {
	            return key + '="' + Handlebars.Utils.escapeExpression(attr) + '"';
	        }).join(' ');
	
	        // TODO we need to support dateOnly on formatNow().
	        html = '<time datetime="' + date.format() + '" ' + attrs + '>' + date.fromNow() + '</time>';
	
	        return new Handlebars.SafeString(html);
	    });
	
	    /**
	     * Joins an arrays elements by a glue string
	     * @method field
	     * @param {Array} array Array of strings
	     * @param {String} glue string glue
	     * @return {String} String
	     */
	    Handlebars.registerHelper('arrayJoin', function (array, glue) {
	        return array.join(glue);
	    });
	
	    /**
	     * Converts `\r\n`, `\n\r`, `\r`, `\n` to `<br>`.
	     * @method nl2br
	     * @param {String} s Raw string to filter
	     * @return {String} String
	     */
	    Handlebars.registerHelper('nl2br', function (s) {
	        s = Handlebars.Utils.escapeExpression(s);
	        var nl2br = s.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>');
	        return new Handlebars.SafeString(nl2br);
	    });
	
	    /**
	     * Formats given currency to users preferences
	     * @method formatCurrency
	     * @param {Number} number      The number to format.
	     * @param {String|Object} currencyId  The currency id.
	     * @return {String} The formatted number.
	     */
	    Handlebars.registerHelper('formatCurrency', function (number, currencyId) {
	        if (_.isObject(currencyId)) {
	            currencyId = currencyId.hash.currencyId || undefined;
	        }
	        return app.currency.formatAmountLocale(number, currencyId);
	    });
	
	    /**
	     * Formats a given string by returning the first n characters.
	      */
	    Handlebars.registerHelper('firstChars', function (text, n) {
	        return text.substring(0, n);
	    });
	
	    /**
	     * Formats given date to users preferences
	     * @method formatDate
	     * @param {Date|string} date The date to format.
	     * @param {Object} [options] More attributes to be used on this element for
	     *   reuse.
	     * @param {Object} [options.hash] More parameters to be used by this helper.
	     * @param {boolean} [options.hash.dateOnly] Flag to determine whether to
	     *   return just date current user date/time preference format.
	     * @return {string} The formatted date.
	     */
	    Handlebars.registerHelper('formatDate', function (date, options) {
	        date = app.date(date);
	        return date.formatUser(options.hash.dateOnly);
	    });
	
	    /**
	     * Gets the translated module name (plural or singular).
	     *
	     * For instance, to get the singular version of the module name (make sure
	     * `LBL_MODULE_NAME_SINGULAR` is defined in the module language strings of
	     * your module):
	     *
	     *     {{getModuleName 'Accounts'}}
	     *
	     * To get the plural version, set `plural` to true and make sure
	     * `LBL_MODULE_NAME` is defined in the module language strings of your
	     * module:
	     *
	     *     {{getModuleName 'Accounts' plural=true}}
	     *
	     * You can pass a default value that will be returned in case the module
	     * language string of your module is not found. The following example will
	     * return 'Module' (since `LBL_MODULE` is defined in the module strings or
	     * the app strings):
	     *
	     *     {{getModuleName 'undefinedModule' defaultValue='LBL_MODULE'}}
	     *
	     * In the worst case scenario (the module language string is not found and
	     * no default value is specified), the module key name is returned. The
	     * following example will return 'undefinedModule':
	     *
	     *     {{getModuleName 'undefinedModule'}}
	     *
	     * @param {string} module The module defined in the language strings.
	     * @param {Object} [options] Optional params to pass to the helper.
	     * @param {Object} [options.hash] More parameters to be used by this helper.
	     * @param {boolean} [options.hash.plural] Returns the plural form if `true`,
	     *   singular otherwise.
	     * @param {string} [options.hash.defaultValue] Value to be returned if the
	     *   module language string is not found.
	     * @return {string} The module name.
	     */
	    Handlebars.registerHelper('getModuleName', function (module, options) {
	        var opts = {
	            plural: options.hash.plural,
	            defaultValue: options.hash.defaultValue
	        };
	        return app.lang.getModuleName(module, opts);
	    });
	
	    /**
	     * @method partial
	     * Helper for rendering a partial template. This helper can load a partial from the templateOptions
	     * or from the same relative location as the current template.
	     *
	     *     {{partial 'partial-name' componentFrom defaultProperties dynamicProperty=value}}
	     *
	     * The data supplied to the partial with be an object with the list of
	     * `dynamicProperty`s merged into `defaultProperties` object (defaults to
	     * empty object if not explicitly passed).
	     *
	     *
	     * For fields
	     *
	     *     {{partial 'edit' this properties fallbackTemplate='detail'}}
	     *
	     * For layouts
	     *
	     *     {{partial 'ActivityStream' this properties}}
	     *
	     * For views
	     *
	     *     {{partial 'record' this properties}}
	     *
	     * @param {string} name Name of the partial.
	     * @param {view.View|view.Field|view.Layout} component The view component.
	     * @param {Object} [properties] Data supplied to the partial. `options.hash`
	     *   is merged into this before it is used for the template. This allows the
	     *   partial to provide dynamic parameters on top of the default properties.
	     *   The original component is kept as `templateComponent` in these
	     *   properties.
	     * @param {Object} [options] Optional params.
	     * @param {Object} [options.hash] The hash of the optional params.
	     * @param {Object} [options.hash.module=component.module] Module to use.
	     * @param {Object} [options.hash.fallbackTemplate] Fallback template for
	     *   field partials.
	     * @return {string} The handlebars safestring for the partial template.
	     */
	    Handlebars.registerHelper('partial', function (name, component, properties, options) {
	        var module, template, data;
	
	        // `properties` is optional, so `options` is `properties` is no `properties` is passed.
	        if (!options && properties.hash) {
	            options = properties;
	            properties = {};
	        }
	
	        // Data supplied to the partial
	        data = _.extend({ templateComponent: component }, properties, options.hash);
	
	        module = options.hash.module || component.module;
	        if (component && component.options.templateOptions && component.options.templateOptions.partials) {
	            template = component.options.templateOptions.partials[name];
	        }
	        // TODO: need to do recursive walk up the tree if template is not found, until we find it. see _super in component.js for an example
	        else if (component instanceof app.view.Field) {
	                var fallbackTemplate = options.hash.fallbackTemplate;
	                template = app.template.getField(component.type, // field type
	                name || 'detail', // template name
	                module, fallbackTemplate);
	            } else if (component instanceof app.view.View) {
	                var templateName = component.tplName;
	
	                //FIXME SC-3363 use the real inheritance chain when loading partial templates
	                //Try the current component first in case the template was overriden.
	                template = app.template.getView(component.name + '.' + name, module) || app.template.getView(component.name + '.' + name);
	
	                if (!template && templateName) {
	                    template = app.template.getView(templateName + '.' + name, module) || app.template.getView(templateName + '.' + name);
	                }
	            } else if (component instanceof app.view.Layout) {
	                template = app.template.getLayout(component.name + '.' + name, module) || app.template.getLayout(component.name + '.' + name);
	            }
	        return new Handlebars.SafeString(template ? template(data) : '');
	    });
	})(SUGAR.App);

/***/ },
/* 57 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * View manager is used to create views, layouts, and fields based on optional
	 * metadata inputs.
	 *
	 * The view manager's factory methods (`createView`, `createLayout`, and
	 * `createField`) first check `views`, `layouts`, and `fields` hashes
	 * respectively for custom class declaration before falling back the base class.
	 *
	 * Note the following is deprecated in favor of putting these controllers in the
	 * `sugarcrm/clients/<platform>` directory, or using one of the appropriate
	 * factory methods like `createView`, `createField`, or `createLayout`. Using
	 * either of these idioms, your components will be internally namespaced by
	 * platform for you. If you do choose to use the following idiom of defining
	 * your controller directly on `app.view.<type>`, please be forewarned that you
	 * will lose any automatic namespacing benefits and possibly encounter naming
	 * collisions if your controller names are not unique. If you must define
	 * directly, you may choose to prefix your controller name by your application
	 * or platform e.g. `MyappMyCustom<Type>` where 'Myapp' is the platform prefix.
	 *
	 * Put declarations of your custom views, layouts, fields in the corresponding
	 * hash (see note above; this is deprecated):
	 * <pre><code>
	 * app.view.views.MyappMyCustomView = app.view.View.extend({
	 *  // Put your custom logic here
	 * });
	 *
	 * app.view.layouts.MyappMyCustomLayout = app.view.Layout.extend({
	 *  // Put your custom logic here
	 * });
	 *
	 * app.view.fields.MyappMyCustomField = app.view.Field.extend({
	 *  // Put your custom logic here
	 * });
	 *
	 * </code></pre>
	 *
	 *
	 * @class View.ViewManager
	 * @alias SUGAR.App.view
	 * @singleton
	 */
	(function (app) {
	
	    // Ever incrementing field ID
	    var _sfId = 0;
	
	    var _viewManager = {
	
	        /**
	         * Resets class declarations of custom components.
	         */
	        reset: function reset() {
	            _.each(this.layouts, function (layout, name) {
	                delete this.layouts[name];
	            }, this);
	            _.each(this.views, function (view, name) {
	                delete this.views[name];
	            }, this);
	            _.each(this.fields, function (field, name) {
	                delete this.fields[name];
	            }, this);
	        },
	
	        /**
	         * Gets ID of the last created field.
	         * @return {number} ID of the last created field.
	         */
	        getFieldId: function getFieldId() {
	            return _sfId;
	        },
	
	        /**
	         * Hash of view classes.
	         */
	        views: {},
	
	        /**
	         * Hash of layout classes.
	         */
	        layouts: {},
	
	        /**
	         * Hash of field classes.
	         */
	        fields: {},
	
	        /**
	         * Creates an instance of a component and binds data changes to it.
	         *
	         * @param {string} type Component type (`layout`, `view`, `field`).
	         * @param {string} name Component name.
	         * @param {Object} params Parameters to pass to the Component's class
	         *   constructor.
	         * @param {string} params.type The component type.
	         * @param {string} params.module The component's module.
	         * @param {string} [params.loadModule=params.module] The module to
	         *   create the component from.
	         * @return {View.Component} New instance of a component.
	         * @private
	         */
	        _createComponent: function _createComponent(type, name, params) {
	            var Klass = this.declareComponent(type, params.type || name, params.loadModule || params.module, params.controller, false, this._getPlatform(params));
	            var component = new Klass(params);
	            component.trigger("init");
	            component.bindDataChange();
	            return component;
	        },
	
	        /**
	         * Creates an instance of a view.
	         *
	         * Examples:
	         *
	         * Create a list view. The view manager will use metadata for the view
	         * named 'list' defined in Contacts module.
	         * The controller's current context will be set on the new view instance.
	         *
	         *     var listView = app.view.createView({
	         *         type: 'list',
	         *         module: 'Contacts'
	         *     });
	         *
	         * Create a custom view class. Note the following is deprecated in favor
	         * of putting these controllers in the `sugarcrm/clients/<platform>`
	         * directory, or using one of the appropriate factory methods like
	         * `createView`, `createField`, or `createLayout`. Using that idiom, the
	         * metadata manager will declare these components and take care of
	         * namespacing by platform for you. If you do choose to use the
	         * following idiom please be forwarned that you will lose any
	         * namespacing benefits and possibly encounter naming collisions!
	         *
	         *     // Declare your custom view class.
	         *     // might cause collisions if another MyCustomView!
	         *     app.view.views.MyCustomView = app.view.View.extend({
	         *         // Put your custom logic here
	         *     });
	         *     // if you must define directly on app.view.views, you may instead
	         *     // prefer to do:
	         *     `app.view.views.<YOUR_PLATFORM>MyCustomView` = app.view.View.extend({
	         *          // Put your custom logic here
	         *     });
	         *
	         *     var myCustomView = app.view.createView({
	         *         type: 'myCustom'
	         *     });
	         *
	         * Create a view with custom metadata payload.
	         *
	         *     var view = app.view.createView({
	         *         type: 'detail',
	         *         meta: { ... your custom metadata ... }
	         *     });
	         *
	         * Look at {@link View.View}, particularly
	         * {@link View.View#_loadTemplate} for more information on how the
	         * `meta.template` property can be used.
	         *
	         * @param {Object} params View parameters.
	         * @param {string} params.type The view identifier (`default`, `base`,
	         *   etc.). Matches the controller to be used.
	         * @param {string} [params.name=params.type] View name that
	         *   distinguishes between multiple instances of the same view type.This
	         *   matches the metadata to read from {@link Core.MetadataManager} and
	         *   it is the easier way to reuse view types with different
	         *   configurations.
	         * @param {Object} [params.context=app.controller.context] Context to
	         * associate the newly created view with.
	         * @param {string} [params.module] Module name.
	         * @param {string} [params.loadModule] The module that should be
	         *   considered the base.
	         * @param {Object} [params.meta] Custom metadata.
	         * @return {View.View} New instance of view.
	         */
	        createView: function createView(params) {
	            // context is always defined on the controller
	            params.context = params.context || app.controller.context;
	            params.module = params.module || params.context.get('module');
	            // name defines which metadata to load
	            params.name = params.name || params.type;
	            params.meta = params.meta || app.metadata.getView(params.module, params.name, params.loadModule);
	
	            if (params.def && params.def.xmeta) {
	                params.meta = _.extend({}, params.meta, params.def.xmeta);
	            }
	
	            // type defines which controller to use
	            var meta = params.meta || {};
	            params.type = params.type || meta.type || params.name;
	
	            return this._createComponent('view', params.type, params);
	        },
	
	        /**
	         * Creates an instance of a layout.
	         *
	         * Parameters define creation rules as well as layout properties.
	         * The factory needs either layout name or type. Also, the layout type
	         * must be specified. The layout type is retrieved either from the
	         * `params` hash or layout metadata.
	         *
	         * Examples:
	         *
	         * Create a list layout. The view manager will use metadata for the
	         * `list` layout defined in the Contacts module.
	         * The controller's current context will be set on the new layout
	         * instance.
	         *
	         *     var listLayout = app.view.createLayout({
	         *         type: 'list',
	         *         module: 'Contacts'
	         *     });
	         *
	         *
	         * Create a custom layout class. Note that following is deprecated in
	         * favor of using the `createLayout` factory or placing controller in
	         * `sugarcrm/clients/<platform>/layouts` in which case the metadata
	         * manager will take care of namespacing your controller by platform
	         * name for you (e.g. MyCustomLayout becomes
	         * `app.view.layouts.MyappMyCustomLayout`).
	         *
	         *     // Declare your custom layout class.
	         *     // might cause collisions if already a MyCustomLayout!
	         *     app.view.layouts.MyCustomLayout = app.view.Layout.extend({
	         *         // Put your custom logic here
	         *     });
	         *     // if you must define directly on app.view.layouts,
	         *     // you may instead prefer to do:
	         *     `app.view.layouts.<YOUR_PLATFORM>MyCustomLayout` = app.view.Layout.extend({
	         *         // Put your custom logic here
	         *     });
	         *
	         *     var myCustomLayout = app.view.createLayout({
	         *         type: 'myCustom'
	         *     });
	         *
	         * Create a layout with custom metadata payload.
	         *
	         *     var layout = app.view.createLayout({
	         *         type: 'detail',
	         *         meta: { ... your custom metadata ... }
	         *     });
	         *
	         * @param {Object} params layout parameters.
	         * @param {string} [params.type] Layout identifier (`default`, `base`,
	         *   etc.).
	         * @param {string} [params.name=params.type] Layout name that
	         *   distinguishes between multiple instances of the same layout type.
	         * @param {Object} [params.context=app.controller.context]
	         *   Context to associate the newly created layout with.
	         * @param {string} params.module Module name.
	         * @param {string} [params.loadModule] The module to load the Layout
	         *   from. Defaults to `params.module` or the context's module, in that
	         *   order.
	         * @param {Object} [params.meta] Custom metadata.
	         * @return {View.Layout} New instance of the layout.
	         */
	        createLayout: function createLayout(params) {
	            params.context = params.context || app.controller.context;
	            params.module = params.module || params.context.get('module');
	            // name defines which metadata to load
	            params.name = params.name || params.type;
	            params.meta = params.meta || app.metadata.getLayout(params.module, params.name, params.loadModule);
	
	            if (params.def && params.def.xmeta) {
	                params.meta = _.extend({}, params.meta, params.def.xmeta);
	            }
	
	            // type defines which controller to use
	            var meta = params.meta || {};
	            params.type = params.type || meta.type || params.name;
	
	            return this._createComponent('layout', params.type, params);
	        },
	
	        /**
	         * Creates an instance of a field and registers it with the parent view
	         * (`params.view`).
	         *
	         * The parameters define creation rules as well as field properties.
	         *
	         * For example,
	         *
	         *     var params = {
	         *         view: new Backbone.View,
	         *         def: {
	         *             type: 'text',
	         *             name: 'first_name',
	         *             label: 'LBL_FIRST_NAME'
	         *         },
	         *         context: optional context,
	         *         model: optional model,
	         *         meta: optional custom metadata,
	         *         viewName: optional
	         *     }
	         *
	         *
	         * The view manager queries the metadata manager for field type specific
	         * metadata (templates and JS controller) unless custom metadata is
	         * passed in the `params` hash.
	         *
	         * Note the following is deprecated in favor of placing custom field
	         * controllers in `sugarcrm/clients/<platform>/fields` or using the
	         * `createField` factory.
	         *
	         * To create instances of custom fields, first declare its class in the
	         * `app.view.fields` hash:
	         *
	         *     // might cause collision if MyCustomField already exists!
	         *     app.view.fields.MyCustomField = app.view.Field.extend({
	         *         // Put your custom logic here
	         *     });
	         *     // if you must define directly on app.view.fields
	         *     // you may instead prefer to do:
	         *     app.view.fields.<YOUR_PLATFORM>MyCustomField = app.view.Field.extend({ ...
	         *
	         *     var myCustomField = app.view.createField({
	         *         view: someView,
	         *         def: {
	         *             type: 'myCustom',
	         *             name: 'my_custom'
	         *         }
	         *     });
	         *
	         * @param {Object} params Field parameters.
	         * @param {Backbone.View} params.view Backbone View object.
	         * @param {Object} params.def Field definition.
	         * @param {Object} [params.context=`SUGAR.App.controller.context`] The
	         *   context.
	         * @param {Object} [params.model] The model to use. If not specified,
	         *   the model which is set on the context is used.
	         * @param {Object} [params.meta] Custom metadata.
	         * @param {string} [params.viewName=params.view.name] View name to
	         *   determine the field template.
	         * @return {View.Field} a new instance of field.
	         */
	        createField: function createField(params) {
	            var type = params.viewDefs ? params.viewDefs.type : params.def.type;
	            params.context = params.context || params.view.context || app.controller.context;
	            params.model = params.model || params.context.get("model");
	            params.module = params.module || (params.model && params.model.module ? params.model.module : params.context.get('module')) || "";
	            if (params.meta) {
	                app.logger.warn('`params.meta` is deprecated in `View.ViewManager#createField` since 7.8 and will be removed in 7.9.');
	            }
	
	            if (params.meta && params.meta.controller) params.controller = params.meta.controller;
	            params.sfId = ++_sfId;
	
	            var field = this._createComponent("field", type, params);
	            // Register new field within its parent view.
	            params.view.fields[field.sfId] = field;
	
	            return field;
	        },
	
	        /**
	         * Returns the platform from the given params, falling back to
	         * `app.config.platform` or else 'base'.
	         *
	         * @param {Object} params Parameters.
	         * @param [params.platform] The platform (`base`, `portal`, etc.).
	         * @return {string} The platform.
	         * @private
	         */
	        _getPlatform: function _getPlatform(params) {
	            return params.platform || (app.config && app.config.platform ? app.config.platform : 'base');
	        },
	
	        /**
	         * Gets a controller of type field, layout, or view.
	         * @param {Object} params Parameters for the controller.
	         * @param {string} params.type The controller type.
	         * @param {string} params.name the filename of the controller
	         *   (e.g. 'flex-list', 'record', etc.).
	         * @param {string} [params.platform] The platform, e.g. 'portal'.
	         *   Will first attempt to fall back to app.config.platform, then 'base'.
	         * @param {string} [params.module] The module name.
	         * @return {Object|null} The controller or `null` if not found.
	         * @private
	         */
	        _getController: function _getController(params) {
	            var c = this._getBaseComponent(params.type, params.name, params.module, params.platform);
	            //Check to see if we have the module specific class; if so return that
	            if (c.cache[c.moduleBasedClassName]) {
	                return c.cache[c.moduleBasedClassName];
	            }
	            return c.baseClass;
	        },
	
	        /**
	         * This function is used to verify if a component has a certain plugin.
	         *
	         * @param {Object} params Set of parameters passed to function.
	         * @param {string} params.type Type of component to check.
	         * @param {string} params.name Name of component to check.
	         * @param {string} params.plugin Name of plugin to check.
	         * @param {string} [params.module=''] Name of module to check for custom
	         *   components in.
	         *
	         * @return {boolean|null} `true` if the specified component exists and
	         *   has that plugin, `false` if the component does not exist or lacks
	         *   that plugin, and `null` if incorrect arguments were passed.
	         */
	        componentHasPlugin: function componentHasPlugin(params) {
	            var controller;
	            if (!params.type || !params.name || !params.plugin) {
	                app.logger.error("componentHasPlugin requires type, name, and plugin parameters");
	                return null;
	            }
	            controller = this._getController(params);
	            return controller && controller.prototype && _.contains(controller.prototype.plugins, params.plugin);
	        },
	
	        /**
	         * Retrieves class declaration for a component or creates a new
	         * component class.
	         *
	         * This method creates a subclass of the base class if controller
	         * parameter is not null and such subclass hasn't been created yet.
	         * Otherwise, the method tries to retrieve the most appropriate class by
	         * searching in the following order:
	         *
	         * - Custom class name: `<module><component-name><component-type>`.
	         * For example, for Contacts module one could have:
	         * `ContactsDetailLayout`, `ContactsFluidLayout`, `ContactsListView`.
	         *
	         * - Class name: `<component-name><component-type>`.
	         * For example: `ListLayout`, `ColumnsLayout`, `DetailView`, `IntField`.
	         *
	         * - Custom base class: `<capitalized-appId><component-type>`
	         * For example, if `app.config.appId == 'portal'`, custom base classes
	         * would be:
	         * `PortalLayout`, `PortalView`, `PortalField`.
	         *
	         * Declarations of such classes must be in the `app.view` namespace.
	         * There are use cases when an app has some common component code.
	         * In such cases, using custom base classes is beneficial. For example,
	         * any app may need to override validation error handling for fields:
	         *
	         *     // Assuming app.config.appId === 'portal':
	         *     app.view.PortalField = app.view.Field.extend({
	         *         initialize: function(options) {
	         *             // Call super
	         *             app.view.Field.prototype.initialize.call(this, options);
	         *             // Custom initialization code...
	         *         },
	         *
	         *        handleValidationError: function(errors) {
	         *            // Custom validation logic
	         *        }
	         *     });
	         *
	         * The above declaration will make all field controllers extend
	         * `app.view.PortalField` instead of `app.view.Field`.
	         *
	         * - Base class: `<component-type>` - `Layout`, `View`, `Field`.
	         *
	         * Note 1. Although the view manager supports module specific fields
	         * like `ContactsIntField`, the server does not provide such
	         * customization.
	         *
	         * Note 2. The layouts is a special case because their class name is
	         * built both from layout name and layout type. One could have
	         * `ListLayout` or `ColumnsLayout` including their module specific
	         * counterparts like `ContactsListView` and `ContactsColumnsLayout`.
	         * The "named" class name is checked first.
	         *
	         * @param {string} type Lower-cased component type: `layout`, `view`, or
	         *   `field`.
	         * @param {string} name Lower-cased component name. For example, 'list'
	         *   (layout or view), or 'bool' (field).
	         * @param {string} [module] Module name.
	         * @param {string} [controller] Controller source code string.
	         * @param {boolean} [overwrite] Will overwrite if duplicate
	         *   custom class or layout is cached. Note that if no controller is
	         *   passed, overwrite is ignored since we can't create a meaningful
	         *   component without a controller.
	         * @param {string} [platform] The platform e.g. 'base', 'portal', etc.
	         * @return {Function} Component class.
	         */
	        declareComponent: function declareComponent(type, name, module, controller, overwrite, platform) {
	            var c = this._getBaseComponent(type, name, module, platform, overwrite && controller);
	            if (overwrite && controller) {
	                if (c.cache[c.moduleBasedClassName]) delete c.cache[c.moduleBasedClassName];
	            }
	            return c.cache[c.moduleBasedClassName] || app.utils.extendClass(c.cache, c.baseClass, c.moduleBasedClassName, controller, c.platformNamespace) || c.baseClass;
	        },
	
	        /**
	         * Internal helper function for getting a component (controller). Do not
	         * call directly and instead use `declareComponent`, etc.
	         * depending on your needs.
	         * @param {string} type Lower-cased component type: `layout`, `view`, or
	         *   `field`.
	         * @param {string} name Lower-cased component name. For example, `list`
	         *   (layout or view), or `bool` (field).
	         * @param {string} [module] Module name.
	         * @param {string} [platform] The platform e.g. 'base', 'portal', etc.
	         * @param {boolean} [overwrite=true] When `true`, custom controller
	         *   overrides will be ignored and only components that exactly match
	         *   the name will be returned. The base class returned is `base`.
	         * @return {Object} The base component information.
	         * @return {Object} return.cache The collection of controllers of the
	         *   given component type.
	         * @return {string} return.platformNamespace The platform prefix.
	         * @return {string} return.moduleBasedClassName The prefixed class name.
	         * @return {Object} return.baseClass The class for the base component.
	         * @private
	         */
	        _getBaseComponent: function _getBaseComponent(type, name, module, platform, overwrite) {
	            platform = this._getPlatform({ platform: platform });
	            // The type e.g. View, Field, Layout
	            var ucType = app.utils.capitalize(type),
	
	            // The platform e.g. Base, Portal, etc.
	            platformNamespace = app.utils.capitalize(platform),
	
	            // The component name and type concatenated e.g. ListView
	            className = app.utils.capitalizeHyphenated(name) + ucType,
	
	            // The combination of platform, optional module, and className e.g. BaseAccountsListView
	            moduleBasedClassName = platformNamespace + (module || "") + className,
	                customModuleBasedClassName = platformNamespace + (module || "") + "Custom" + className,
	                cache = app.view[type + "s"],
	
	            // App id and type fallback
	            customBaseClassName = app.utils.capitalize(app.config.appId) + ucType,
	
	            // Components are now namespaced by <platform> so we must prefix className to find in cache
	            // if we don't find platform-specific, than we next look in Base<className> and so on
	            baseClass = cache[platformNamespace + "Custom" + className] || cache[platformNamespace + className] || cache["BaseCustom" + className] || cache["Base" + className] ||
	            // For backwards compatibility, if they define app.view.views.MyView we should still find
	            cache[className] || cache["BaseBase" + ucType] || app.view["Custom" + customBaseClassName] || app.view[customBaseClassName] || app.view[ucType];
	            // Override to use the custom class instead of the standard one if it exists.
	            if (cache[customModuleBasedClassName] && !overwrite) {
	                moduleBasedClassName = customModuleBasedClassName;
	            }
	            return {
	                cache: cache,
	                platformNamespace: platformNamespace,
	                moduleBasedClassName: moduleBasedClassName,
	                baseClass: baseClass
	            };
	        }
	    };
	
	    app.augment("view", _viewManager, false);
	})(SUGAR.App);

/***/ },
/* 58 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * Represents base view class for layouts, views, and fields.
	 *
	 * This is an abstract class.
	 *
	 * @class View.Component
	 * @alias SUGAR.app.view.Component
	 * @extends Backbone.View
	 */
	(function (app) {
	
	    app.view.Component = Backbone.View.extend({
	
	        /**
	         * Internal flag used to prevent {@link #events} from being delegated
	         * prior to {@link #initialize}, in {@link #delegateEvents}. Do not use
	         * this flag!
	         *
	         * FIXME SC-5690: This property will be removed when we have mixin
	         * support with an ES6-style super method.
	         *
	         * @private
	         * @deprecated Deprecated in 7.8.0 and will be removed in 7.9.0.
	         * @type {boolean}
	         */
	        _isInitialized: false,
	
	        /**
	         * Constructor for sidecar components, currently used to define the
	         * order of event delegation on {@link #events this component's events},
	         * after Backbone changed the order in which events are delegated from
	         * 0.9.10 to 1.2.0. Also temporarily defines {@link #options} on the
	         * component, as Backbone no longer does this by default.
	         *
	         * @constructor
	         * @param {Object} options The Backbone.View initialization options.
	         */
	        constructor: function constructor(options) {
	            /**
	             * Attaches the `options` passed into the constructor to this
	             * component.
	             *
	             * FIXME SC-5597: Since this is no longer supported by Backbone, it
	             * will be removed from Sidecar components as well.
	             *
	             * @deprecated Deprecated since 7.8.0. Will be removed in 7.10.0.
	             * @property {Object}
	             */
	            this.options = options || {};
	
	            this._wrapInitialize(options);
	
	            return Backbone.View.apply(this, arguments);
	        },
	
	        /**
	         * Wraps the initialize method to delegate the events on the element,
	         * after it initializes.
	         *
	         * @protected
	         * @param {Object} options The Backbone.View initialization options.
	         */
	        _wrapInitialize: function _wrapInitialize(options) {
	            this.initialize = _.wrap(this.initialize, _.bind(function (init) {
	                init.call(this, options);
	                this.initialize = init;
	                this._isInitialized = true;
	                this.delegateEvents();
	            }, this));
	        },
	
	        /**
	         * Initializes a component.
	         *
	         * @param {Object} options The Backbone.View initialization options.
	         *
	         * - context
	         * - meta
	         * - module
	         * - model
	         * - collection
	         *
	         * `context` is the only required option.
	         */
	        initialize: function initialize(options) {
	
	            /**
	             * Reference to the context (required).
	             * @property {Core.Context}
	             */
	            this.context = options.context || app.controller && app.controller.context || new Backbone.Model();
	
	            /**
	             * Component metadata (optional).
	             * @property {Object}
	             */
	            this.meta = options.meta;
	
	            /**
	             * Module name (optional).
	             * @property {String}
	             */
	            this.module = options.module || this.context.get('module');
	
	            /**
	             * Reference to the model this component is bound to.
	             * @property {Data.Bean}
	             */
	            this.model = options.model || this.context.get('model');
	
	            /**
	             * Reference to the collection this component is bound to.
	             * @property {Data.BeanCollection}
	             */
	            this.collection = options.collection || this.context.get('collection');
	
	            // Adds classes to the component based on the metadata.
	            if (this.meta && this.meta.css_class) {
	                this.$el.addClass(this.meta.css_class);
	            }
	
	            this.updateVisibleState(true);
	
	            // Register last state defaults
	            app.user.lastState.register(this);
	        },
	
	        /**
	         * Renders a component.
	         *
	         * Override this method to provide custom logic.
	         * The default implementation does nothing.
	         * See [Backbone.View](http://backbonejs.org/#View-render)
	         * documentation for details.
	         * The convention is for {@link #_render} to always return `this`.
	         *
	         * @return {View.Component} Instance of this component.
	         *
	         * @template
	         * @protected
	         */
	        _render: function _render() {
	            return this;
	        },
	
	        /**
	         * Renders a component.
	         *
	         * IMPORTANT: Do not override this method.
	         * Instead, override {@link View.Component#_render} to provide render logic.
	         * @return {View.Component} Instance of this component.
	         */
	        render: function render() {
	            if (this.disposed === true) {
	                app.logger.error("Unable to render component because it's disposed " + this + '\n');
	                return false;
	            }
	            if (!this.triggerBefore('render')) return false;
	            this._render();
	
	            this.trigger('render');
	
	            return this;
	        },
	
	        /**
	         * Proxies the parent method on `Backbone.View`, but only called after
	         * {@link #initialize this view instance initializes}.
	         *
	         * @return {View.Component} Returns {@link View.Component this instance}.
	         */
	        delegateEvents: function delegateEvents() {
	            if (!this._isInitialized) {
	                return this;
	            }
	
	            // FIXME SC-5680: We can't call `_super` from View.Component - it
	            // would just call this method again. SC-5680 will address fixing
	            // the `_super` method.
	            return Backbone.View.prototype.delegateEvents.apply(this, arguments);
	        },
	
	        /**
	         * Sets template option.
	         *
	         * If the given option already exists it is augmented by the value of the given `option` parameter.
	         * See Handlebars.js documentation for details.
	         * @param {String} key Option key.
	         * @param {Object} option Option value.
	         */
	        setTemplateOption: function setTemplateOption(key, option) {
	            this.options.templateOptions = this.options.templateOptions || {};
	            this.options.templateOptions[key] = _.extend({}, this.options.templateOptions[key], option);
	        },
	
	        /**
	         * Binds data changes to this component.
	         *
	         * This method should be overridden by derived views.
	         */
	        bindDataChange: function bindDataChange() {
	            // Override this method to wire up model/collection events
	        },
	
	        /**
	         * Removes this component's event handlers from model and collection.
	         *
	         * Performs the opposite of what {@link View.Component#bindDataChange} method does.
	         * Override this method to provide custom logic.
	         */
	        unbindData: function unbindData() {
	            if (this.model) this.model.off(null, null, this);
	            if (this.collection) this.collection.off(null, null, this);
	        },
	
	        /**
	         * Removes all event callbacks registered within this component
	         * and undelegates Backbone events.
	         *
	         * Override this method to provide custom logic.
	         */
	        unbind: function unbind() {
	            this.off();
	            this.offBefore();
	            this.undelegateEvents();
	            app.events.off(null, null, this);
	            app.events.unregister(this);
	            if (this.context) this.context.off(null, null, this);
	            if (this.layout) this.layout.off(null, null, this);
	        },
	
	        /**
	         * Fetches data for layout's model or collection.
	         *
	         * The default implementation does nothing.
	         * See {@link View.Layout#loadData} and {@link View.View#loadData} methods.
	         */
	        loadData: _.noop,
	
	        /**
	         * Disposes a component.
	         *
	         * This method:
	         *
	         * - unbinds the component from model and collection.
	         * - removes all event callbacks registered within this component.
	         * - removes the component from the DOM.
	         *
	         * Override this method to provide custom logic:
	         * <pre><code>
	         * app.view.views.MyView = app.view.View.extend({
	         *      _dispose: function() {
	         *          // Perform custom clean-up. For example, clear timeout handlers, etc.
	         *          ...
	         *          // Call super
	         *          app.view.View.prototype._dispose.call(this);
	         *      }
	         * });
	         * </code></pre>
	         * @protected
	         */
	        _dispose: function _dispose() {
	            this.unbindData();
	            this.unbind();
	            this.remove();
	            this.model = null;
	            this.collection = null;
	            this.context = null;
	            this.$el = null;
	            this.el = null;
	        },
	
	        /**
	         * Disposes a component.
	         *
	         * Once the component gets disposed it can not be rendered.
	         * Do not override this method. Instead override {@link View.Component#_dispose} method
	         * if you need custom disposal logic.
	         */
	        dispose: function dispose() {
	            if (this.disposed === true) return;
	            this._dispose();
	            this.disposed = true;
	        },
	
	        /**
	         * Gets a string representation of this component.
	         * @return {String} String representation of this component.
	         */
	        toString: function toString() {
	            return this.cid + '-' + (this.$el && this.$el.id ? this.$el.id : '<no-id>') + '/' + this.module + '/' + this.model + '/' + this.collection;
	        },
	
	        /**
	         * Traverse upwards from the current component to find the first
	         * component that matches the name.
	         *
	         * The default implementation does nothing.
	         * See {@link View.Layout#closestComponent},
	         * {@link View.View#closestComponent} and
	         * {@link View.Field#closestComponent} methods.
	         *
	         * @param {String} name The name of the component to find.
	         * @return {View.Component} The component or `undefined` if not found.
	         */
	        closestComponent: _.noop,
	
	        /**
	         * Pass through function to jQuery's show to show view.
	         */
	        show: function show() {
	            if (!this.isVisible()) {
	                if (!this.triggerBefore('show')) {
	                    return false;
	                }
	
	                this._show();
	                this.trigger('show');
	            }
	        },
	
	        /**
	         * Pass through function to jQuery's hide to hide view.
	         */
	        hide: function hide() {
	            if (this.isVisible()) {
	                if (!this.triggerBefore('hide')) {
	                    return false;
	                }
	
	                this._hide();
	                this.trigger('hide');
	            }
	        },
	
	        /**
	         * Checks if the component is visible on the page.
	         */
	        isVisible: function isVisible() {
	            return this._isVisible;
	        },
	
	        /**
	         * Updates the visible property.
	         *
	         * **Note:** This does not show/hide the component. Please use
	         * {@link #show} and {@link #hide} for this use case.
	         */
	        updateVisibleState: function updateVisibleState(visible) {
	            /**
	             * Flag to indicate the visible state of the component.
	             *
	             * @type {boolean}
	             * @private
	             */
	            this._isVisible = !!visible;
	        },
	
	        /**
	         * @protected
	         */
	        _show: function _show() {
	            this.$el.removeClass('hide').show();
	            this.updateVisibleState(true);
	        },
	
	        /**
	         * @protected
	         */
	        _hide: function _hide() {
	            this.$el.addClass('hide').hide();
	            this.updateVisibleState(false);
	        },
	
	        /**
	         *  _super is used to retrieve and invoke parent prototype functions.
	         *  Requires a method paramter to function. The method called should be named the same as the function
	         *  being called from.
	         *
	         * Examples:
	         *
	         * * Good:
	         * <pre><code>
	         * ({
	         *     initialize: function(options) {
	         *         //extend the base meta with some custom meta
	         *         options.meta = _.extend({}, myMeta, options.meta || {});
	         *         //Only call parent initialize from initialize
	         *         this._super('initialize', [options]);
	         *         this.buildFoo(options);
	         *     }
	         * });
	         * </code></pre>
	         *
	         * * Bad:
	         * <pre><code>
	         * ({
	         *     initialize: function(options) {
	         *         //extend the base meta with some custom meta
	         *         options.meta = _.extend({}, myMeta, options.meta || {});
	         *         //Calling a function like buildFoo from initialize is incorrect. Should call directly on this
	         *         this._super('buildFoo',[options]);
	         *     }
	         * });
	         * </code></pre>
	         *
	         * @param {string} method The name of the method to call (e.g.
	         *   `initialize`, `_renderHtml`).
	         * @param {Array} [args] Arguments to pass to the parent method.
	         * @return {Mixed}
	         * @protected
	         */
	        _super: function _super(method, args) {
	            //Must be used to invoke parent methods
	            if (!method || !_.isString(method)) {
	                return app.logger.error('tried to call _super without specifying a parent method in ' + this.name);
	            }
	
	            var parent,
	                thisProto = Object.getPrototypeOf(this);
	            args = args || [];
	
	            //_lastSuperClass is used to walk the prototype chain
	            this._superStack = this._superStack || {};
	            this._superStack[method] = this._superStack[method] || [];
	            if (this._superStack[method].length > 0) {
	                parent = Object.getPrototypeOf(_.last(this._superStack[method]));
	                if (_.contains(this._superStack[method], parent)) {
	                    return app.logger.error('Loop detected calling ' + method + ' from ' + this.name);
	                }
	            } else {
	                parent = Object.getPrototypeOf(thisProto);
	            }
	
	            //First verify that the method exists on the current object
	            if (!thisProto[method]) {
	                return app.logger.error('Unable to find method ' + method + ' on class ' + this.name);
	            }
	
	            //Walk up the chain until we find a parent that implements the method.
	            while (!parent.hasOwnProperty(method) && parent !== app.view.Component.prototype) {
	                parent = Object.getPrototypeOf(parent);
	            }
	
	            //Walk up the chain until we find a parent that overrode the method.
	            while (thisProto[method] === parent[method] && parent !== app.view.Component.prototype) {
	                thisProto = parent;
	                parent = Object.getPrototypeOf(parent);
	            }
	            this._superStack[method].push(parent);
	
	            //Verify that we found a valid parent that implements this method
	            if (!parent) {
	                return app.logger.error('Unable to find parent of component ' + this.name);
	            }
	            if (!parent[method]) {
	                return app.logger.error('Unable to find method ' + method + ' on parent class of ' + this.name);
	            }
	
	            //Finally make the parent call
	            var ret = parent[method].apply(this, args);
	
	            //Reset the last parent to step down the prototype chain
	            this._superStack[method].pop();
	            //When we reach the end of the chain, also remove the method name requirement
	            if (_.isEmpty(this._superStack[method])) {
	                this._superStack[method] = null;
	            }
	
	            return ret;
	        },
	
	        /**
	         * Gets HTML placeholder for a component.
	         * @return {string} HTML placeholder to be used in a handlebars template.
	         */
	        getPlaceholder: function getPlaceholder() {
	            return new Handlebars.SafeString('<span cid="' + this.cid + '"></span>');
	        }
	    });
	
	    //Mix in the beforeEvents
	    _.extend(app.view.Component.prototype, app.beforeEvent);
	})(SUGAR.App);

/***/ },
/* 59 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	
	    /**
	     * Base View class. Use {@link View.ViewManager} to create instances of views.
	     *
	     * @class View.View
	     * @alias SUGAR.App.view.View
	     * @extends View.Component
	     */
	    app.view.View = app.view.Component.extend({
	
	        /**
	         * TODO: add docs (describe options parameter, see Component class for an example).
	         * @param options
	         */
	        initialize: function initialize(options) {
	            app.plugins.attach(this, "view");
	            app.view.Component.prototype.initialize.call(this, options);
	
	            /**
	             * View type
	             * @cfg {string}
	             */
	            this.type = options.type;
	
	            /**
	             * Name of the view.
	             * @cfg {string}
	             */
	            this.name = options.name || this.type;
	
	            /**
	             * Name of the action (optional).
	             *
	             * Used in acl checks for user permissions. By default, set to the view name.
	             * @cfg {String}
	             */
	            this.action = options.meta && options.meta.action ? options.meta.action : this.name;
	
	            this._loadTemplate(options);
	
	            /**
	             * Dictionary of field widgets.
	             *
	             * - keys: field IDs (sfuuid)
	             * - value: instances of `app.view.Field` class
	             */
	            this.fields = {};
	
	            /**
	             * A template to use for view fields if a field does not have a template defined for its parent view.
	             * Defaults to `"default"`.
	             *
	             * For example, if you have a subview and don't want to define subview template for all field types,
	             * you may choose to use existing templates like `detail` if your subview is in fact a detail view.
	             *
	             * @property {String}
	             */
	            this.fallbackFieldTemplate = this.fallbackFieldTemplate || "detail";
	
	            /**
	             * Reference to the parent layout instance.
	             * @property {View.Layout}
	             */
	            this.layout = this.options.layout;
	
	            /**
	             * Flag indicating whether a view is primary or not.
	             *
	             * If the primary view is not rendered due to the access control,
	             * a warning message will be displayed.
	             *
	             * @property {Boolean}
	             */
	            this.primary = options.primary;
	
	            this._setLabels();
	
	            /**
	             * The view name that contains the list of fields to use when
	             * fetching the model/collection from the server.
	             *
	             * List, record or detail views might have too many fields defined
	             * in the metadata. This property avoids having to list all these
	             * fields in the request params.
	             *
	             * @property {string} dataView
	             */
	            if (this.dataView) {
	                this.context.set('dataView', this.dataView);
	            } else {
	                this.context.addFields(this.getFieldNames());
	            }
	
	            app.events.on('app:locale:change', function () {
	                this._setLabels();
	            }, this);
	        },
	
	        /**
	         * Gets the template falling back using `loadModule` property when
	         * specified.
	         *
	         * @param {string} name The template's name to get.
	         * @param {string} [fallbackModule] The module to fallback to if the
	         *   template does not exist in this view's module. If undefined, the
	         *   template is grabbed in `base`.
	         * @private
	         */
	        _getTemplate: function _getTemplate(name, fallbackModule) {
	            return app.template.getView(name, this.module) || app.template.getView(name, fallbackModule);
	        },
	
	        /**
	         * Sets the appropriate template for this view to {@link #template}.
	         * Sets the name of the template to {@link #tplName}.
	         *
	         * @param {Object} [options] The options that may specify the template to
	         *   load.
	         * @param {Object} [options] A hash of options.
	         * @param {Function} [options.template] The compiled template.
	         * @param {string} [options.loadModule] The fallback module to get the
	         *   template from.
	         * @private
	         */
	        _loadTemplate: function _loadTemplate(options) {
	            var template, templateName;
	            options = options || {};
	
	            if (options.template) {
	                template = options.template;
	                templateName = null;
	            } else if (this.meta && this.meta.template) {
	                template = this._getTemplate(this.meta.template, options.loadModule);
	                templateName = this.meta.template;
	            } else {
	                template = this._getTemplate(this.name, options.loadModule);
	                templateName = this.name;
	            }
	
	            if (!template) {
	                if (this.meta && this.meta.type) {
	                    template = this._getTemplate(this.meta.type, options.loadModule);
	                    templateName = this.meta.type;
	                } else {
	                    template = app.template.empty;
	                    templateName = '';
	                }
	            }
	
	            /**
	             * The name of the template that is loaded.
	             * This is a public read-only property. This property should not be
	             * modified directly.
	             *
	             * @property {string|null} tplName
	             * @member View.View
	             */
	            this.tplName = templateName;
	
	            /**
	             * The template for this view.
	             *
	             * @property {Function} template
	             * @member View.View
	             */
	            this.template = template;
	        },
	
	        /**
	         * Renders a view onto the page.
	         *
	         * This method uses `ctx` parameter as the context for the view's Handlebars {@link View.View#template}
	         * and view's `options.templateOptions` property as template options.
	         *
	         * If no `ctx` parameter is specified, `this` is passed as the context for the template.
	         * If no `options` parameter is specified, `this.options.templateOptions` is used.
	         *
	         * You can override this method if you have custom rendering logic and don't use Handlebars templating
	         * or if you need to pass different context object for the template.
	         *
	         * Note the following use of app.view.View.extend is deprecated in favor of putting these controllers in the
	         * sugarcrm/clients/<platform> directory. Using that idiom, the metadata manager will declare these components
	         * and take care of namespacing by platform for you (so MyCustomView will be stored internally as MyappMyCustomView).
	         * If you do choose to use the following idiom please be forwarned that you will lose any namespacing benefits and
	         * possibly encounter naming collisions!
	         *
	         * Example:
	         * <pre><code>
	         * // Note that using the following technique of defining custom views directly on the app.view.views object
	         * // can result in naming collisions unless you ensure your name is unique. See note above.
	         * app.view.views.CustomView = app.view.View.extend({
	         *    _renderHtml: function() {
	         *       var ctx = {
	         *         // Your custom context for this view template
	         *       };
	         *       app.view.View.prototype._renderHtml.call(this, ctx);
	         *    }
	         * });
	         *
	         * // Or totally different logic that doesn't use this.template
	         * app.view.views.AnotherCustomView = app.view.View.extend({
	         *    _renderHtml: function() {
	         *       // Never do this :)
	         *       return "&lt;div&gt;Hello, world!&lt;/div&gt;";
	         *    }
	         * });
	         *
	         *
	         * </code></pre>
	         *
	         * This method uses this view's {@link View.View#template} property to render itself.
	         * @param {Data.Context} [ctx] Template context.
	         * @param {Object} [options] Template options.
	         * <pre><code>
	         * {
	         *    helpers: helpers,
	         *    partials: partials,
	         *    data: data
	         * }
	         * </code></pre>
	         * See Handlebars.js documentation for details.
	         * @protected
	         */
	        _renderHtml: function _renderHtml(ctx, options) {
	            if (this.template) {
	                try {
	                    this.$el.html(this.template(ctx || this, options || this.options.templateOptions));
	                } catch (e) {
	                    app.logger.error("Failed to render " + this + "\n" + e);
	                    app.error.handleRenderError(this, '_renderHtml');
	                }
	            }
	        },
	
	        /**
	         * Renders all the fields.
	         *
	         * @protected
	         */
	        _renderFields: function _renderFields() {
	            var self = this;
	
	            // In terms of performance it is better to search the DOM once for
	            // all the fields, than to search the DOM for each field. That's why
	            // we cache placeholders locally and pass them to
	            // {@link View.Field#_renderField}.
	            var fieldElems = {};
	
	            this.$('span[sfuuid]').each(function () {
	                var $this = $(this),
	                    sfId = $this.attr('sfuuid');
	                fieldElems[sfId] = $this;
	            });
	
	            _.each(this.fields, function (field) {
	                self._renderField(field, fieldElems[field.sfId]);
	            });
	        },
	
	        /**
	         * Sets field's view element and invokes render on the given field.
	         *
	         * @param {View.Field} field The field to render.
	         * @param {jQuery} $fieldEl The field placeholder.
	         * @protected
	         */
	        _renderField: function _renderField(field, $fieldEl) {
	            field.setElement($fieldEl || this.$("span[sfuuid='" + field.sfId + "']"));
	            try {
	                field.render();
	            } catch (e) {
	                app.logger.error("Failed to render " + field + " on " + this + "\n" + e);
	                app.error.handleRenderError(this, '_renderField', field);
	            }
	        },
	
	        /**
	         * Renders a view onto the page.
	         *
	         * The method first renders this view by calling {@link View.View#_renderHtml}
	         * and then for each field invokes {@link View.View#_renderField}.
	         *
	         * NOTE: Do not override this method, otherwise you will loose ACL check.
	         * Consider overriding {@link View.View#_renderHtml} instead.
	         *
	         * @return {View.View} The instance of this view.
	         * @protected
	         */
	        _render: function _render() {
	            if (app.acl.hasAccessToModel(this.action, this.model)) {
	                this._disposeFields();
	                this._renderHtml();
	                this._renderFields();
	            } else {
	
	                app.logger.info("Current user does not have access to this module view. name: " + this.name + " module:" + this.module);
	                // See Bug56941.
	                // We suppress this warning from being presented to user in situations where we're trying
	                // to display a view for a Linked module where the user does not have access.  If you clicked on
	                // a Bug and you shouldn't get warnings about Notes, etc, if you didn't have access to those other modules.
	                if (this.primary) {
	                    app.error.handleRenderError(this, 'view_render_denied');
	                }
	            }
	
	            return this;
	        },
	
	        _setLabels: function _setLabels() {
	            /**
	             * Pluralized i18n-ed module name.
	             * @property {String}
	             * @member View.View
	             */
	            this.modulePlural = app.lang.getAppListStrings("moduleList")[this.module] || this.module;
	
	            /**
	             * Singular i18n-ed module name.
	             * @property {String}
	             * @member View.View
	             */
	            this.moduleSingular = app.lang.getAppListStrings("moduleListSingular")[this.module] || this.modulePlural;
	        },
	
	        /**
	         * Fetches data for view's model or collection.
	         *
	         * This method calls view's context {@link Core.Context#loadData} method.
	         *
	         * Override this method to provide custom fetch algorithm.
	         * @param {Object} [options] Options that are passed to
	         *   collection/model's fetch method.
	         */
	        loadData: function loadData(options) {
	            // FIXME This should be removed by 7.9.
	            if (arguments.length === 2) {
	                app.logger.warn('The `setFields` argument is no longer supported. Views and Layouts must ' + 'add the fields they need without affecting other Views and Layouts');
	            }
	
	            // See Bug56941.
	            // Lets only load the data for views where user has read access.
	            // Otherwise we generate REST API errors.
	            if (app.acl.hasAccess("read", this.module)) {
	                this.context.loadData(options);
	            }
	        },
	
	        /**
	         * Extracts the field names from the metadata for directly related views/panels.
	         *
	         * @param {string} [module] Module name. Defaults to the Context module.
	         * @return {Array} List of fields used on this view
	         */
	        getFieldNames: function getFieldNames(module) {
	            var fields = [];
	            module = module || this.context.get('module');
	
	            if (this.meta && this.meta.panels) {
	                fields = _.reduce(_.map(this.meta.panels, function (panel) {
	                    var nestedFields = _.flatten(_.compact(_.pluck(panel.fields, "fields")));
	                    return _.pluck(panel.fields, 'name').concat(_.pluck(nestedFields, 'name')).concat(_.flatten(_.compact(_.pluck(panel.fields, 'related_fields'))));
	                }), function (memo, field) {
	                    return memo.concat(field);
	                }, []);
	            }
	
	            fields = _.compact(_.uniq(fields));
	
	            var fieldMetadata = app.metadata.getModule(module, 'fields');
	            if (fieldMetadata) {
	                // Filter out all fields that are not actual bean fields
	                fields = _.reject(fields, function (name) {
	                    return _.isUndefined(fieldMetadata[name]);
	                });
	
	                // we need to find the relates and add the actual id fields
	                var relates = [];
	                _.each(fields, function (name) {
	                    if (fieldMetadata[name].type == 'relate') {
	                        relates.push(fieldMetadata[name].id_name);
	                    } else if (fieldMetadata[name].type == 'parent') {
	                        relates.push(fieldMetadata[name].id_name);
	                        relates.push(fieldMetadata[name].type_name);
	                    }
	                    if (_.isArray(fieldMetadata[name].fields)) {
	                        relates = relates.concat(fieldMetadata[name].fields);
	                    }
	                });
	
	                fields = _.union(fields, relates);
	            }
	
	            return fields;
	        },
	
	        /**
	         * Gets a hash of fields that are currently displayed on this view.
	         *
	         * The hash has field names as keys and field definitions as values.
	         * @param {String} module(optional) Module name.
	         * @param {Bean} model(optional) model to match fields against. Only fields the correspond with the given model will be returned.
	         * @return {Object} The currently displayed fields.
	         */
	        getFields: function getFields(module, model) {
	            var fields = {};
	            var fieldNames = this.getFieldNames(module);
	            _.each(fieldNames, function (name) {
	                var field = this.getField(name, model);
	                if (field) {
	                    fields[name] = field.def;
	                }
	            }, this);
	            return fields;
	        },
	
	        /**
	         * Returns a field by name.
	         * @param {String} name Field name.
	         * @param {Bean=} optional model to find the field for.
	         * @return {View.Field} Instance of the field widget.
	         */
	        getField: function getField(name, model) {
	            return _.find(this.fields, function (field) {
	                return field.name == name && (!model || field.model == model);
	            });
	        },
	
	        /**
	         * @inheritdoc
	         */
	        closestComponent: function closestComponent(name) {
	            if (!this.layout) {
	                return;
	            }
	            if (this.layout.name === name) {
	                return this.layout;
	            }
	            return this.layout.closestComponent(name);
	        },
	
	        /**
	         * @inheritdoc
	         */
	        _show: function _show() {
	            app.view.Component.prototype._show.call(this);
	            _.each(this.fields, function (component) {
	                component.updateVisibleState(true);
	            });
	        },
	
	        /**
	         * @inheritdoc
	         */
	        _hide: function _hide() {
	            app.view.Component.prototype._hide.call(this);
	            _.each(this.fields, function (component) {
	                component.updateVisibleState(true);
	            });
	        },
	
	        /**
	         * Disposes a view.
	         *
	         * This method disposes view fields and calls
	         * {@link View.Component#_dispose} method of the base class.
	         * @protected
	         */
	        _dispose: function _dispose() {
	            app.plugins.detach(this, "view");
	            this._disposeFields();
	            app.view.Component.prototype._dispose.call(this);
	        },
	
	        /**
	         * Disposes all the fields.
	         *
	         * @protected
	         */
	        _disposeFields: function _disposeFields() {
	            _.each(this.fields, function (field) {
	                field.dispose();
	            });
	            this.fields = {};
	        },
	
	        /**
	         * Gets a string representation of this view.
	         * @return {String} String representation of this view.
	         */
	        toString: function toString() {
	            return "view-" + this.name + "-" + app.view.Component.prototype.toString.call(this);
	        },
	
	        /**
	         * Gets a field's metadata.
	         * @param {String} name Field name.
	         * @param {Boolean} includeChild optional flag indicating that we should check if this is a child field when true.
	         * @return {Object} field metadata.
	         */
	        getFieldMeta: function getFieldMeta(field, includeChild) {
	            var fields = _.flatten(_.pluck(this.meta.panels, "fields")),
	                ret = _.find(fields, function (def) {
	                return def.name === field;
	            });
	
	            if (!ret && includeChild) {
	                ret = _.find(_.flatten(_.pluck(fields, "fields")), function (def) {
	                    return def && def.name === field;
	                });
	
	                if (ret) {
	                    ret._isChild = true;
	                }
	            }
	
	            return ret;
	        },
	
	        /**
	         * Sets a field's metadata.
	         * @param {String} name Field name.
	         * @param {Object} meta Field metadata
	         */
	        setFieldMeta: function setFieldMeta(field, meta) {
	            _.each(this.meta.panels, function (panel) {
	                _.each(panel.fields, function (def, i) {
	                    if (def.name === field) {
	                        panel.fields[i] = _.extend(def, meta);
	                    } else if (_.isArray(def.fields)) {
	                        _.each(def.fields, function (childDef, j) {
	                            if (childDef.name === field) {
	                                def.fields[j] = _.extend(childDef, meta);
	                            }
	                        });
	                    }
	                });
	            });
	        }
	    });
	})(SUGAR.App);

/***/ },
/* 60 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	
	    /**
	     * SugarField widget. A field widget is a low level field widget. Some examples of fields are
	     * text boxes, date pickers, drop down menus.
	     *
	     * ##Creating a SugarField
	     * SugarCRM allows for customized "fields" which are visual representations of a type of data (e.g. url would
	     * be displayed as a hyperlink).
	     *
	     * ###Anatomy of a SugarField
	     * Field files reside in the **`sugarcrm/clients/base/fields/{field_type}`** folder.
	     *
	     * Inside the {field_type} directory is a set of files that define templates for different views and field controller.
	     * A typical directory structure will look like the following:
	     * <pre>
	     * clients
	     * |- base
	     *    |- bool
	     *       |- bool.js
	     *       |- detail.hbs
	     *       |- edit.hbs
	     *       |- list.hbs
	     *    |- int
	     *       ...
	     *    |- text
	     *       ...
	     * |- portal
	     *    |- portal specific overrides
	     * |- mobile
	     *    |- mobile specific overrides
	     * </pre>
	     * **`[sugarFieldType].js`** files are optional.
	     * Sometimes a SugarField needs to do more than just display a simple input element, other times input elements
	     * need additional data such as drop down menu choices. To support advanced functionality, just add your additional
	     * controller logic to **`[sugarFieldType].js`** javascript file where sugarFieldType is the type of the SugarField.
	     * Example for `bool.js` controller:
	     * <pre><code>
	     * ({
	     *    events: {
	     *         handler: function() {
	     *             // Actions
	     *         }
	     *    },
	     *
	     *    initialize: function(options) {
	     *       app.view.Field.prototype.initialize(options);
	     *       // Your constructor code here follows...
	     *    },
	     *
	     *    unformat: function(value) {
	     *        value = this.el.children[0].children[1].checked ? "1" : "0";
	     *        return value;
	     *    },
	     *    format: function(value) {
	     *        value = (value == "1") ? true : false;
	     *        return value;
	     *    }
	     * })
	     * </code></pre>
	     *
	     * **`.hbs`** files contain your templates corresponding to the type of {@link View.View} the field is to be displayed on.
	     * Sugar uses Handlebars.js as its client side template of choice. At this time no other templating engines are
	     * supported. Sample:
	     * <pre><code>
	     * &lt;span name="{{name}}"&gt;{{value}}&lt;/span&gt;
	     * </code></pre>
	     *
	     * These files will be used by the metadata manager to generate metadata for your SugarFields and pass them onto the
	     * Sugar JavaScript client.
	     *
	     * </pre></code>
	     *
	     * ####SugarField Template Values
	     * TODO:
	     *
	     *
	     * @class View.Field
	     * @alias SUGAR.App.view.Field
	     * @extends View.Component
	     */
	    app.view.Field = app.view.Component.extend({
	
	        /**
	         * HTML tag of the field.
	         * @property {String}
	         */
	        fieldTag: "input",
	
	        /**
	         * TODO: add docs (describe options, see Component class for details)
	         * @param options
	         */
	        initialize: function initialize(options) {
	            app.plugins.attach(this, "field");
	            app.view.Component.prototype.initialize.call(this, options);
	
	            /**
	             * ID of the field (autogenerated).
	             * @property {Number}
	             * @member View.Field
	             */
	            this.sfId = options.sfId;
	
	            /**
	             * Reference to the view this field is attached to.
	             * @property {View.View}
	             * @member View.Field
	             */
	            this.view = options.view;
	
	            /**
	             * View definitions for the field (doesn't include vardefs).
	             *
	             * The view definitions are the properties used for field rendering.
	             * Exple: A `link` property can specify if the field should be
	             * displayed as a link.
	             *
	             * @property {Object} viewDefs
	             * @property {Object} [viewDefs.defs] A hash of properties that
	             *   will override the field definitions (vardefs).
	             */
	            this.viewDefs = options.viewDefs || {};
	
	            /**
	             * Field name.
	             * @property {string}
	             * @member View.Field
	             */
	            this.name = this.viewDefs.name || options.def && options.def.name;
	
	            var fieldDefs = this.model && this.model.fields ? this.model.fields[this.name] : null;
	            /**
	             * Field definitions (vardefs).
	             *
	             * Field definitions are properties that define the field and its
	             * internal behavior.
	             *
	             * @property {Object}
	             */
	            this.fieldDefs = _.extend({}, fieldDefs, this.viewDefs.defs);
	
	            /**
	             * Field metadata definition (fieldDefs + viewdefs).
	             *
	             * Viewdef are copied over vardef.
	             * @property {Object}
	             * @member View.Field
	             * @deprecated
	             */
	            this.def = _.extend({}, fieldDefs, options.def);
	
	            /**
	             * Widget type (text, bool, int, etc.).
	             * @property {String}
	             * @member View.Field
	             */
	            this.type = this.viewDefs.type || this.def.type || this.fieldDefs.type;
	
	            // TODO deprecate this fallback, since label vs vname is already patched in metadata
	            var oldLabel = this.def.label || this.def.vname || this.name;
	            /**
	             * i18n-ed field label.
	             * @property {String}
	             * @member View.Field
	             */
	            this.label = app.lang.get(this.viewDefs.label || oldLabel, this.module);
	
	            /**
	             * Compiled template.
	             * @property {Function}
	             * @member View.Field
	             */
	            this.template = app.template.empty;
	
	            // Bind validation error event
	            // Note we bind it regardless of which view we on (only need for edit type views)
	            if (this.model) {
	                this.model.on('error:validation:' + this.name, this.handleValidationError, this);
	                this.model.on('validation:start attributes:revert', this.removeValidationErrors, this);
	                this.model.on('acl:change:' + this.name, this.handleAclChange, this);
	            }
	        },
	
	        /**
	         * Defines fallback rules for ACL checking.
	         *
	         * For example, if a user doesn't have `edit` permission for the given field
	         * the template falls back to `detail` view template.
	         */
	        viewFallbackMap: {
	            'edit': 'detail'
	        },
	
	        /**
	         * Handler for when an ACL changes at the field-level.
	         *
	         * FIXME SC-3363: The previous action needs to be cleared in order to
	         * load the correct template when the user potentially loses access to a
	         * field. SC-3363 will address this.
	         */
	        handleAclChange: function handleAclChange() {
	            this._resetAction();
	            this.render();
	        },
	
	        /**
	         * Set field's action to undefined
	         * @protected
	         */
	        _resetAction: function _resetAction() {
	            this.action = void 0;
	        },
	
	        /**
	         * Checks ACLs to see if the current user has access to action.
	         *
	         * @param {String} action Action name.
	         * @return {Boolean} Flag indicating if the current user has access to the given action.
	         * see {@link View.Field#_loadTemplate}
	         */
	        _checkAccessToAction: function _checkAccessToAction(action) {
	            return app.acl.hasAccessToModel(action, this.model, this.name);
	        },
	        /**
	         * Returns fallback template for view
	         *
	         * @param {string} viewName
	         * @return {string}
	         * @protected
	         */
	        _getFallbackTemplate: function _getFallbackTemplate(viewName) {
	            return this.isDisabled() && viewName === 'disabled' ? 'edit' : this.view.fallbackFieldTemplate || 'detail';
	        },
	        /**
	         * Loads template for this field.
	         * @private
	         */
	        _loadTemplate: function _loadTemplate() {
	            var fallbackFieldTemplate;
	
	            // options.viewName or view metadata type is used to override the template
	            var viewName = this.options.viewName || this.options.def.view || (this.view.meta && this.view.meta.type ? this.view.meta.type : this.view.name);
	
	            var actionName = this.action;
	            if (this.isDisabled() && viewName === 'edit') {
	                viewName = this.action;
	            } else {
	                actionName = this.action || (this.view.action && this.view.name != this.view.action ? this.view.action : viewName);
	            }
	
	            while (viewName) {
	
	                if (this._checkAccessToAction(actionName)) break;
	                viewName = this.viewFallbackMap[viewName];
	                actionName = viewName;
	            }
	
	            if (viewName) {
	                // Set fallback template to base/view or default.
	                var moduleName = this.module || this.context.get('module');
	
	                fallbackFieldTemplate = this._getFallbackTemplate(viewName);
	                this.template = app.template.getField(this.type, viewName, moduleName, fallbackFieldTemplate) ||
	                // Fallback to text field if template is not defined for this type
	                app.template.getField("base", viewName, moduleName, fallbackFieldTemplate) ||
	                // Safeguard with an empty template
	                app.template.empty;
	            } else {
	                // Safeguard with an empty template
	                this.template = app.template.empty;
	            }
	
	            // Update template name and action.
	            // These properties are useful for a client app to make decisions when formatting values, rendering, etc.
	            /**
	             * Template (view) name.
	             *
	             * The view name can be different from the one the field belongs to.
	             * The template is selected based on ACLs. It may also be overridden by field's metadata definition.
	             * @property {String}
	             * @member View.Field
	             */
	            this.tplName = viewName;
	            /**
	             * Action name.
	             *
	             * The action the field is rendered for. Usually, the action name equals to {@link View.Field#tplName}.
	             * @property {String}
	             * @member View.Field
	             */
	            this.action = actionName;
	        },
	
	        /**
	         * Override default Backbone.Events to also use custom handlers.
	         *
	         * The events hash is similar to Backbone.View events hash.
	         * You can specify event handler as method of field or as name of event
	         * that should be triggered. You cannot use javascript code in metadata.
	         * The framework stores the event handlers as anonimous function binded
	         * to this field as part of the field instance with the `"callback_"`
	         * prefix. When event is fired it calls `triggerMetadataEvent` method
	         * if it exists in field. The default behavior of `triggerMetadataEvent`
	         * is implemented in {@link app.plugins.MetadataEventDriven} plugin.
	         *
	         * <pre><code>
	         * events: {
	         *     handler: triggerSomeEvent;
	         * }
	         * </code></pre>
	         *
	         * triggerSomeEvent should be method of certain field.
	         *
	         * OR
	         *
	         * <pre><code>
	         * events: {
	         *     handler: "fire:some:event";
	         * }
	         * </code></pre>
	         *
	         * @private
	         * @param {Object} events Hash of events and their handlers
	         */
	        delegateEvents: function delegateEvents(events) {
	            // We may have:
	            // this.events -- comes from custom .js controllers
	            // this.def.events -- comes from metadata. See, for example, buttons section in portal.js file
	            // FIXME SC-5676: The metadata events should typically be extended
	            // or mixed-in to the events, not OR'ed with `this.events`. SC-5676
	            // should address refactoring this method.
	            events = events || _.result(this, 'events') || (this.def ? this.def.events : null);
	            if (!events) return;
	
	            events = _.clone(events);
	
	            _.each(events, function (eventHandler, handlerName) {
	                var callback = this[eventHandler];
	
	                // If our callbacks / events have not been registered in field,
	                // go ahead and registered it as method.
	                if (!callback && _.isString(eventHandler)) {
	                    callback = _.bind(function (event) {
	                        if (_.isFunction(this.triggerMetadataEvent)) {
	                            this.triggerMetadataEvent(event, eventHandler);
	                        }
	                    }, this);
	                    this['callback_' + handlerName] = callback;
	                    events[handlerName] = 'callback_' + handlerName;
	                }
	
	                if (!_.isFunction(eventHandler) && !callback) {
	                    delete events[handlerName];
	                }
	            }, this);
	
	            Backbone.View.prototype.delegateEvents.call(this, events);
	        },
	
	        /**
	         * Renders a field widget.
	         *
	         * This method checks ACLs to choose the correct template.
	         * Once the template is rendered, DOM changes are bound to the model.
	         * @return {View.Field} The instance of this field.
	         *
	         * @protected
	         */
	        _render: function _render() {
	            this._loadTemplate();
	            if (this.model instanceof Backbone.Model) {
	                /**
	                 * Model property value.
	                 * @property {String}
	                 * @member View.Field
	                 */
	                this.value = this.getFormattedValue();
	            }
	
	            /**
	             * The direction of the field. The default value `undefined` means
	             * that the field would use the inherited direction from the DOM.
	             *
	             * Override this property with a specific direction string if the
	             * field has a set direction that it always follows.
	             *
	             * Override this property with a function if logic is needed to
	             * determine the direction of the field. The function should return
	             * either a `string` indicating the direction of the field or
	             * `undefined`. This function is only called after the value is set
	             * so that we can base the direction on the value.
	             *
	             * Example using a function
	             *
	             *      direction: function() {
	             *          return this.isRTL ? 'rtl' : 'ltr';
	             *      }
	             *
	             * @property {string|Function|undefined} direction
	             * @return {string|undefined}
	             * @member View.Field
	             */
	            /**
	             * The direction attribute for the field to be used in the template.
	             *
	             * @property {string|undefined} dir
	             * @member View.Field
	             */
	            this.dir = _.result(this, 'direction');
	            if (app.lang.direction === this.dir) {
	                delete this.dir;
	            }
	
	            this.unbindDom();
	            this.$el.html(this.template(this) || '');
	
	            // Adds classes to the component based on the metadata.
	            if (this.def && this.def.css_class) {
	                this.getFieldElement().addClass(this.def.css_class);
	            }
	
	            this.$(this.fieldTag).attr('dir', this.dir);
	
	            this.bindDomChange();
	            return this;
	        },
	
	        /**
	         * Get the correspond field DOM element
	         *
	         * This method will return the placeholder element.
	         * Override this method in the subclass to point the specified field element
	         *
	         * @return {Object} DOM Element
	         */
	        getFieldElement: function getFieldElement() {
	            return this.$el;
	        },
	
	        /**
	         * Binds DOM changes to a model.
	         *
	         * The default implementation of this method binds value changes of {@link View.Field#fieldTag} element
	         * to model's `Backbone.Model#set` method. Override this method if you need custom binding.
	         */
	        bindDomChange: function bindDomChange() {
	
	            if (!(this.model instanceof Backbone.Model)) return;
	
	            var self = this;
	            var el = this.$el.find(this.fieldTag);
	            el.on("change", function () {
	                self.model.set(self.name, self.unformat(el.val()));
	            });
	        },
	
	        /**
	         * Binds model changes to this field.
	         *
	         * The default implementation makes sure this field gets re-rendered
	         * whenever the corresponding model attribute changes.
	         */
	        bindDataChange: function bindDataChange() {
	            if (this.model) {
	                this.model.on("change:" + this.name, function (model, value) {
	                    // FIXME: we need to track the `options` send by
	                    // `model.set()` and only call `this.render()` if it didn't
	                    // came from `bindDomChange`
	                    if (this.action === 'edit') {
	                        // Should directly set the value in edit instead of re-rendering the whole field (see MAR-1617).
	                        this.$(this.fieldTag).val(this.format(value));
	                    } else {
	                        this.render();
	                    }
	                }, this);
	            }
	        },
	
	        /**
	         * Checks to see if the field's value has been changed from the saved model
	         * This is not the same as {@link Backbone.Model#hasChanged} which checks if the model
	         * has changed from the last time it was set whereas this function checks if what is
	         * currently in the input field is the same as what is synced on the model
	         *
	         * @return {boolean} `true` if the value is different, `false` if field is synced with the
	         * saved model
	         */
	        hasChanged: function hasChanged() {
	            return !_.isEqual(this.format(this.model.getSynced(this.name)), this.format(this.model.get(this.name)));
	        },
	
	        /**
	         * Formats the value to be used in handlebars template and displayed on
	         * screen.
	         *
	         * The default implementation returns `value` without modifying it.
	         * Override this method to provide custom formatting in field
	         * controller (`[type].js` file).
	         *
	         * @param {Array|Object|string|number|boolean} value The value to format.
	         * @return {Array|Object|string|number|boolean} Formatted value.
	         */
	        format: function format(value) {
	            return value;
	        },
	
	        /**
	         * Unformats the value for storing in a model. This should do the
	         * inverse of {@link #format}.
	         *
	         * The default implementation returns `value` without modifying it.
	         * Override this method to provide custom unformatting in field
	         * controller (`[type].js` file).
	         *
	         * @param {string} value The value to unformat.
	         * @return {Array|Object|string|number|boolean} Unformatted value.
	         */
	        unformat: function unformat(value) {
	            return value;
	        },
	
	        /**
	         * Returns the value of this field in the associated model.
	         *
	         * If you need to override the formatted value please override
	         * {@link #format}.
	         *
	         * @return {Array|Object|string|number|boolean} The formatted data as
	         *   provided by {@link #format}.
	         */
	        getFormattedValue: function getFormattedValue() {
	            return this.format(this.model.has(this.name) ? this.model.get(this.name) : null);
	        },
	
	        /**
	         * Handles validation errors.
	         *
	         * The default implementation does nothing.
	         * Override this method to provide custom display logic.
	         * <pre><code>
	         * app.view.Field = app.view.Field.extend({
	         *     handleValidationError: function(errors) {
	         *       // Your custom logic goes here
	         *     }
	         * });
	         * </code></pre>
	         *
	         * @param {Object} errors hash of validation errors
	         * @template
	         */
	        handleValidationError: function handleValidationError(errors) {
	            // Override this method
	        },
	
	        /**
	         * Removes the validation error properties on the field that were set by
	         * {@link #handleValidationError}.
	         *
	         * The default implementation does nothing.
	         *
	         * Override this method to provide custom logic:
	         *
	         *      @example
	         *      app.view.Field = app.view.Field.extend({
	         *          removeValidationErrors: function(errors) {
	         *              // Your custom logic goes here
	         *          }
	         *      });
	         *
	         * @template
	         */
	        removeValidationErrors: function removeValidationErrors() {
	            // Override this method
	        },
	
	        /**
	         * Gets HTML placeholder for a field.
	         * @return {String} HTML placeholder for the field as Handlebars safe string.
	         */
	        getPlaceholder: function getPlaceholder() {
	            return new Handlebars.SafeString('<span sfuuid="' + this.sfId + '"></span>');
	        },
	
	        /**
	         * Disables the edit mode by switching the element as detail mode
	         * @param {Boolean} true or undefined to disable the edit mode
	         *               otherwise, it will restore back to the previous mode
	         */
	        setDisabled: function setDisabled(disable) {
	            disable = _.isUndefined(disable) ? true : disable;
	
	            if (disable && this.isDisabled() === false) {
	                //Set disabled
	                this._previousAction = this.action;
	                this.action = 'disabled';
	                this.render();
	            } else if (disable === false && this.isDisabled()) {
	                //disabled release
	                this.action = this._previousAction;
	                delete this._previousAction;
	                this.render();
	            }
	        },
	
	        /**
	         * Is the field disabled?
	         * @return {Boolean} true if the field is disabled, false otherwise.
	         */
	        isDisabled: function isDisabled() {
	            return this.action === 'disabled';
	        },
	
	        /**
	         * Set view name of this field.
	         * This only switches the template reference.
	         * @param {String} view name.
	         */
	        setViewName: function setViewName(view) {
	            this.options.viewName = view;
	        },
	
	        /**
	         * Set action name of this field.
	         * This switches action name as well as the template reference.
	         *
	         * @param name {String} action name
	         **/
	        setMode: function setMode(name) {
	            if (this.isDisabled()) {
	                this._previousAction = name;
	            } else {
	                this.action = name;
	            }
	            this.setViewName(name);
	            this.render();
	        },
	
	        /**
	         * Unbinds DOM changes from field's element.
	         *
	         * This method performs the opposite of what {@link View.Field#bindDomChange} method does.
	         * Override this method if you need custom logic.
	         */
	        unbindDom: function unbindDom() {
	            this.$el.find(this.fieldTag).off();
	        },
	
	        /**
	         * Disposes a field.
	         *
	         * Calls {@link View.Field#unbindDom} and {@link View.Component#_dispose} method of the base class.
	         * @protected
	         */
	        _dispose: function _dispose() {
	            app.plugins.detach(this, "field");
	            this.unbindDom();
	            app.view.Component.prototype._dispose.call(this);
	        },
	
	        /**
	         * Gets a string representation of this field.
	         * @return {String} String representation of this field.
	         */
	        toString: function toString() {
	            return "field-" + this.name + "-" + this.sfId + "-" + app.view.Component.prototype.toString.call(this);
	        },
	
	        /**
	         * @inheritdoc
	         */
	        _show: function _show() {
	            this.getFieldElement().removeClass('hide').show();
	            this.updateVisibleState(true);
	        },
	
	        /**
	         * @inheritdoc
	         */
	        _hide: function _hide() {
	            this.getFieldElement().addClass('hide').hide();
	            this.updateVisibleState(false);
	        },
	
	        /**
	         * Compare formatted values for equality.
	         *
	         * @param {Field} other Other field component.
	         * @return {Boolean} It returns `true` for equal value.
	         */
	        equals: function equals(other) {
	            return this.type === other.type && _.isEqual(this.getFormattedValue(), other.getFormattedValue());
	        },
	
	        /**
	         * @inheritdoc
	         */
	        closestComponent: function closestComponent(name) {
	            if (!this.view) {
	                return;
	            }
	            if (this.view.name === name) {
	                return this.view;
	            }
	            return this.view.closestComponent(name);
	        }
	    });
	})(SUGAR.App);

/***/ },
/* 61 */
/***/ function(module, exports) {

	"use strict";
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	
	    /**
	     * The Layout Object is a definition of views and their placement on a certain 'page'.
	     *
	     * Use {@link View.ViewManager} to create instances of layouts.
	     *
	     * ###A Quick Guide for Creating a Layout Definition###
	     *
	     * Creating Layouts is easy, all it takes is adding the appropriate metadata file. Let's create a
	     * layout called **`SampleLayout`**.
	     *
	     * ####The Layout File and Directory Structure####
	     * Layouts are located in the **`modules/MODULE/metadata/layouts`** folder. Add a file
	     * called **`SampleLayout.php`** in the folder and it should be picked up in the next
	     * metadata sync call.
	     *
	     * ####The Metadata####
	     * <pre><code>
	     * $viewdefs['MODULE']['PLATFORM (portal / mobile / base)']['layout']['samplelayout'] = array(
	     *     'type' => 'columns',
	     *     'components' => array(
	     *         0 => array(
	     *             'layout' => array(
	     *             'type' => 'column',
	     *             'components' => array(
	     *                 array(
	     *                     'view' => 'list',
	     *                 ),
	     *                 array(
	     *                     'view' => 'list',
	     *                     'context' => array(
	     *                         'module' => 'Leads',
	     *                     ),
	     *                 ),
	     *             ),
	     *         ),
	     *     ),
	     * );
	     * </code></pre>
	     *
	     * As you can see we are defining a column style layout with two subcomponents: A normal list view
	     * of the MODULE, and also a list view of Leads.
	     *
	     * ####Accessing the New Layout####
	     * The last step is to add a route in the Router to display the new layout. // TODO: Custom routes?
	     *
	     *
	     * @class View.Layout
	     * @alias SUGAR.App.view.Layout
	     * @extends View.Component
	     */
	    app.view.Layout = app.view.Component.extend({
	
	        /**
	         * TODO docs (describe constructor options, see Component class for an example).
	         *
	         * @param options
	         */
	        initialize: function initialize(options) {
	            app.plugins.attach(this, "layout");
	            app.view.Component.prototype.initialize.call(this, options);
	
	            this._components = [];
	
	            this.meta = this.meta || {};
	
	            this.type = this.meta.type || this.options.type;
	            /**
	             * Layout Name.
	             * @type {*|string}
	             */
	            this.name = this.meta.name || this.options.name || this.type || "";
	
	            /**
	             * Layout Label.
	             * @type {*|string}
	             */
	            if (this.meta.label) {
	                this.label = this.meta.label;
	            } else if (this.options.def && this.options.def.label) {
	                this.label = this.options.def.label;
	            } else if (this.options.label) {
	                this.label = this.options.label;
	            } else {
	                this.label = '';
	            }
	
	            /**
	             * Reference to the parent layout instance.
	             * @property {View.Layout}
	             */
	            this.layout = this.options.layout;
	
	            this._loadTemplate(options);
	
	            if (this.template) {
	                // Need to do .append() rather than .html() because we create new components
	                // in templates. By performing .html(), we remove that component from the document.
	                this.$el.append(this.template(this, options));
	                this.placeComponentsFromTemplate();
	            }
	
	            if (this.meta.lazy_loaded) {
	                /**
	                 * Holds the components metadata in case if it is a lazy loaded
	                 * layout. This property should be used to to initialize
	                 * components manually.
	                 *
	                 * @property {Array} The array of components.
	                 * @protected
	                 */
	                this._componentsMeta = this.meta.components;
	                this.meta.components = [];
	            }
	
	            app.events.on('app:locale:change', function () {
	                this.render();
	            }, this);
	        },
	
	        /**
	         * Sets the appropriate template for this layout to {@link #template}.
	         *
	         * Gets the template from this layout's module, or falls back to the
	         * module specified in the `loadModule` meta property, or falls back to
	         * base.
	         *
	         * @param {Object} [options] A hash of options.
	         * @param {string} [options.loadModule] The fallback module to get the
	         *   template from.
	         * @private
	         */
	        _loadTemplate: function _loadTemplate(options) {
	            options = options || {};
	            if (this.meta.template) {
	                this.template = app.template.getLayout(this.meta.template, this.module) || app.template.getLayout(this.meta.template, options.loadModule);
	                return;
	            }
	
	            var tpl = app.template.getLayout(this.name, this.module) || app.template.getLayout(this.type, this.module);
	            if (!tpl) {
	                if (options.loadModule) {
	                    tpl = app.template.getLayout(this.name, options.loadModule) || app.template.getLayout(this.type, options.loadModule);
	                } else {
	                    tpl = app.template.getLayout(this.name) || app.template.getLayout(this.type);
	                }
	            }
	
	            this.template = tpl;
	        },
	
	        /**
	         * Move components created in templates to their appropriate placeholders.
	         */
	        placeComponentsFromTemplate: function placeComponentsFromTemplate() {
	            var componentElems = {};
	
	            if (_.isEmpty(this._components)) {
	                return;
	            }
	
	            this.$('span[cid]').each(function () {
	                var $this = $(this),
	                    cid = $this.attr('cid');
	
	                componentElems[cid] = $this;
	            });
	
	            _.each(this._components, function (component) {
	                var $placeholder = componentElems[component.cid];
	                if ($placeholder) {
	                    $placeholder.replaceWith(component.el);
	                }
	            }, this);
	        },
	
	        /**
	         * Creates subcomponents in the layout and appends them to the layout's
	         * {@link #_components}. It recursively initializes all components
	         * within the specified subcomponents.
	         *
	         * Calls {@link #_addComponentsFromDef} to help add components.
	         * Triggers `init` on this layout once all subcomponent initializes.
	         *
	         * Immediate subcomponent will default to the passed in context and
	         * module.
	         *
	         * Subsequent subcomponents will default to their parents' context and
	         * module.
	         *
	         * @param {Array} [components=this.meta.components] The definitions of
	         *   the subcomponents.
	         * @param {Object} [context] Context to pass to the new components.
	         * @param {string} [module] Module to create the components from.
	         * @return {Array} initialized components
	         */
	        initComponents: function initComponents(components, context, module) {
	            if (this.disposed) {
	                return;
	            }
	
	            var newSubComponents, initialLength;
	            components = components || this.meta.components;
	
	            initialLength = this._components.length;
	            this._addComponentsFromDef(components, context, module);
	            newSubComponents = this._components.slice(initialLength);
	
	            _.each(newSubComponents, function (comp) {
	                if (_.isFunction(comp.initComponents)) {
	                    comp.initComponents();
	                }
	            });
	
	            this.trigger('init');
	
	            return newSubComponents;
	        },
	
	        /**
	         *
	         * @param {Object} def Metadata defining this component.
	         * @param {Core.Context} context Default context to pass to the new
	         *   component. (Will be overridden by the context in 'def' param, if
	         *   defined).
	         * @param {string} module The module to pass to the component.
	         *   (Will be overridden by the context's module in 'def' param, if
	         *   defined).
	         * @return {Mixed}
	         */
	        createComponentFromDef: function createComponentFromDef(def, context, module) {
	            context = context || this.context;
	            module = module || this.module;
	
	            // Switch context if necessary
	            if (def.context) {
	                if (def.context instanceof app.Context) {
	                    context = def.context;
	                } else {
	                    context = context.getChildContext(def.context);
	                    context.prepare();
	                }
	                module = context.get('module');
	            }
	
	            // Layouts/Views can either by referenced by name or have metadata defined inline
	            if (def.view) {
	                if (_.isString(def.view)) {
	                    return app.view.createView({
	                        context: context,
	                        name: def.view,
	                        def: def,
	                        module: module,
	                        loadModule: def.loadModule,
	                        primary: def.primary,
	                        layout: this
	                    });
	                } else if (_.isObject(def.view)) {
	                    if (def.view.meta) {
	                        app.logger.warn('`meta` property in metadata layout definitions is deprecated since 7.8 and ' + 'will be removed in 7.9. Please use `xmeta` instead.');
	                    }
	
	                    //Inline definition of a sublayout
	                    return app.view.createView({
	                        context: context,
	                        module: module,
	                        loadModule: def.loadModule,
	                        meta: def.view.meta || def.view,
	                        type: def.view.type,
	                        name: def.view.name,
	                        primary: def.view.primary,
	                        layout: this
	                    });
	                }
	            } else if (def.layout) {
	                if (_.isString(def.layout)) {
	                    return app.view.createLayout({
	                        context: context,
	                        name: def.layout,
	                        def: def,
	                        module: module,
	                        loadModule: def.loadModule,
	                        layout: this
	                    });
	                } else if (_.isObject(def.layout)) {
	                    if (def.layout.meta) {
	                        app.logger.warn('`meta` property in metadata layout definitions is deprecated since 7.8 and ' + 'will be removed in 7.9. Please use `xmeta` instead.');
	                    }
	
	                    //Inline definition of a sublayout
	                    return app.view.createLayout({
	                        context: context,
	                        module: module,
	                        loadModule: def.loadModule,
	                        meta: def.layout.meta || def.layout,
	                        type: def.layout.type,
	                        name: def.layout.name,
	                        def: def,
	                        layout: this
	                    });
	                }
	            } else {
	                app.logger.warn("Invalid layout definition:\n" + def.layout);
	            }
	        },
	
	        /**
	         * Creates and adds components to the current layout.
	         *
	         * Calls {@link #addComponent} to help add components.
	         * Calls {@link #createComponentFromDef} to help create components.
	         *
	         * @param {Array} [components=[]] The components to be created.
	         * @param {Object} [context] Context to pass to the new components.
	         * @param {string} [module] Module to create the components from.
	         * @protected
	         */
	        _addComponentsFromDef: function _addComponentsFromDef(components, context, module) {
	            components = components || [];
	            _.each(components, function (def) {
	                // If component has already been initialized by the template, do
	                // not initialize again.
	                if (def.initializedInTemplate) {
	                    delete def.initializedInTemplate;
	                    return;
	                }
	
	                if (def.view || def.layout) {
	                    this.addComponent(this.createComponentFromDef(def, context, module), def);
	                }
	            }, this);
	        },
	
	        /**
	         * Adds a component to this layout.
	         * @param {View.Layout|View.View} component Component (view or layout) to add
	         * @param {Object} def Metadata definition
	         */
	        addComponent: function addComponent(component, def) {
	            if (!component.layout) component.layout = this;
	            this._components.push(component);
	            this._placeComponent(component, def); // Some implementations of placeComponent require a def
	        },
	
	        /**
	         * Places layout component in the DOM.
	         *
	         * Default implementation just appends all the components to itself.
	         * Override this method to support custom placement of components.
	         *
	         * @param {View.View|View.Layout} component View or layout component.
	         * @protected
	         */
	        _placeComponent: function _placeComponent(component) {
	            this.$el.append(component.el);
	        },
	
	        /**
	         * Removes a component from this layout.
	          * If component is an index, remove the component at that index. Otherwise see if component is in the array.
	         * @param {View.Layout|View.View|number} component The layout or view to remove.
	         */
	        removeComponent: function removeComponent(component) {
	            var i = _.isNumber(component) ? component : this._components.indexOf(component);
	
	            if (i > -1) {
	                var removed = this._components.splice(i, 1);
	                removed[0].layout = null;
	            }
	        },
	
	        /**
	         * Gets a component by name.
	         * @param {String} name Component name.
	         * @return {View.View|View.Layout} Component with the given name.
	         */
	        getComponent: function getComponent(name) {
	            return _.find(this._components, function (component) {
	                return component.name === name;
	            });
	        },
	
	        /**
	         * Renders all the components.
	         *
	         * @return {View.Layout} The instance of this layout.
	         *
	         * @protected
	         */
	        _render: function _render() {
	            if (this._components && this._components.length > 0) {
	                //default layout will pass render container divs and pass down to all its views.
	                _.each(this._components, function (component) {
	                    component.render();
	                }, this);
	            } else {
	                app.logger.info("Can't render anything because the layout has no components: " + this.toString() + "\n" + "Either supply metadata or override Layout.render method");
	            }
	            return this;
	        },
	
	        /**
	         * Fetches data for layout's model or collection.
	         *
	         * The default implementation first calls the {@link Core.Context#loadData} method for the layout's context
	         * and then iterates through the components and calls their {@link View.Component#loadData} method,
	         * setting their contexts' `fields` property beforehand.
	         *
	         * Override this method to provide custom fetch algorithm.
	         *
	         * @param {Object} [options] Options that are passed to
	         *   collection/model's fetch method.
	         */
	        loadData: function loadData(options) {
	            // FIXME This should be removed by 7.9.
	            if (arguments.length === 2) {
	                app.logger.warn('The `setFields` argument is no longer supported. Views and Layouts must ' + 'add the fields they need without affecting other Views and Layouts');
	            }
	
	            if (this.disposed) {
	                return;
	            }
	
	            this.context.loadData(options);
	
	            _.each(this._components, function (component) {
	                component.loadData(options);
	            }, this);
	        },
	
	        /**
	         * Gets a list of all fields used on this layout and its sub layouts/views.
	         *
	         * @param {String} module(optional) Module name.
	         * @return {Array} The list of fields used by this layout.
	         */
	        getFieldNames: function getFieldNames(module) {
	            var fields = [];
	            module = module || this.module;
	            _.each(this._components, function (component) {
	                if (component.module == module) {
	                    fields = _.union(fields, component.getFieldNames(null, true));
	                }
	            }, this);
	
	            return fields;
	        },
	
	        /**
	         * Gets a hash of fields that are currently displayed on this layout.
	         *
	         * The hash has field names as keys and field definitions as values.
	         * @param {String} module(optional) Module name.
	         * @return {Object} The currently displayed fields.
	         */
	        getFields: function getFields(module) {
	            var fields = {};
	            _.each(this._components, function (component) {
	                _.extend(fields, component.getFields(module));
	            });
	            return fields;
	        },
	
	        /**
	         * @inheritdoc
	         */
	        closestComponent: function closestComponent(name) {
	            if (!this.layout) {
	                return;
	            }
	            if (this.layout.name === name) {
	                return this.layout;
	            }
	            return this.layout.closestComponent(name);
	        },
	
	        /**
	         * @inheritdoc
	         */
	        _show: function _show() {
	            app.view.Component.prototype._show.call(this);
	            _.each(this._components, function (component) {
	                component.updateVisibleState(true);
	            });
	        },
	
	        /**
	         * @inheritdoc
	         */
	        _hide: function _hide() {
	            app.view.Component.prototype._hide.call(this);
	            _.each(this._components, function (component) {
	                component.updateVisibleState(true);
	            });
	        },
	
	        /**
	         * Disposes a layout.
	         *
	         * Disposes each of this layout's components and calls
	         * {@link View.Component#_dispose} method of the base class.
	         *
	         * @protected
	         */
	        _dispose: function _dispose() {
	            app.plugins.detach(this, "layout");
	            this._disposeComponents();
	            app.view.Component.prototype._dispose.call(this);
	        },
	
	        /**
	         * Disposes the layout's components and empties the `_components`
	         * property.
	         *
	         * @private
	         */
	        _disposeComponents: function _disposeComponents() {
	            _.each(this._components, function (component) {
	                component.dispose();
	            });
	            this._components = [];
	        },
	
	        /**
	         * Gets a string representation of this layout.
	         *
	         * @return {String} String representation of this layout.
	         */
	        toString: function toString() {
	            return "layout-" + (this.options.type || this.options.name) + "-" + app.view.Component.prototype.toString.call(this);
	        }
	    });
	})(SUGAR.App);

/***/ },
/* 62 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * Alert View.
	 *
	 * Interface for creating alerts via show and dismiss. Also, this module
	 * keeps an internal dictionary of alerts created which can later be accessed
	 * by key. This is useful so that client code can dismiss a particular alert.
	 *
	 * Note that the client application may provide custom implementation of {@link View.AlertView} class.
	 * This implementation will be in charge of rendering the alert to its UI.
	 *
	 * At minimum, a client app's must provide:
	 *
	 * 1. `#alerts` element in its `index.html`.
	 * 2. Pre-compiled template called `alert`. The template can be compiled at application start-up:
	 * <code>app.template.compile("alert", "template body...");</code>
	 */
	(function (app) {
	
	    // Dictionary of alerts
	    var _alerts = {};
	
	    var _alert = {
	
	        //When this flag is set to true, it prevents any new alert to be shown.
	        //This is useful for `confirmation` type alerts because you want the
	        //user to focus and confirm/cancel the action and don't bother him with
	        //anything else.
	        preventAnyAlert: false,
	
	        /**
	         * Initializes alert module at application start-up.
	         */
	        init: function init() {
	            /**
	             * Alert element selector.
	             *
	             * The default value is `$('#alerts')`. Override using {@link Config#alertsEl} setting.
	             * @property {Object}
	             */
	            this.$alerts = $('#alerts');
	
	            /**
	             * Alert view class.
	             *
	             * The default value is {@link View.AlertView}.
	             * However, if `app.view.[Capitalized-appId]AlertView` or `app.view.[Capitalized-platform]AlertView` class
	             * exists, it will be used instead.
	             * @property {Function}
	             */
	            this.klass = app.view.AlertView;
	
	            if (app.config) {
	                this.$alerts = $(app.config.alertsEl).length ? $(app.config.alertsEl) : this.$alerts;
	
	                this.klass = app.view[app.utils.capitalize(app.config.appId) + "AlertView"] || app.view.views[app.utils.capitalize(app.config.platform) + 'AlertView'] || app.view.views.BaseAlertView || app.view[app.utils.capitalize(app.config.platform) + "AlertView"] || this.klass;
	            }
	
	            // Check for existing alerts and convert them into AlertView.
	            _.each(this.$alerts.find('.alert-wrapper'), function (el, i) {
	                var key = 'init-' + i;
	                _alerts[key] = this._create(key, { el: el });
	            }, this);
	        },
	
	        /**
	         * Displays an alert message and adds to internal dictionary of alerts.
	         * Use supplied key later to dismiss the alert. Caller is responsible for using language translation
	         * before calling!
	         *
	         * To create and close alerts, this function uses private factory method {@link View.Alert#_create}
	         * which instantiates alert view class specified by the {@link View.Alert#klass} property and places the alert
	         * instance in the DOM as the first element in the {@link View.Alert#$alerts} element.
	         *
	         * The {@link View.AlertView} class provides boilerplate implementation for a typical single alert view.
	         * You can customize alert behavior by extending {@link View.AlertView} class.
	         * At minimum, you have to make sure that a pre-compiled template named `"alert"` exists.
	         *
	         * In case we are showing a `confirmation` alert, we want to dismiss all other
	         * existing alerts and prevent any other alerts
	         *
	         * </code></pre>
	         *
	         * Examples:
	         * <pre><code>
	         * var a1 = app.alert.show('delete_warning', {
	         *     level: 'warning',
	         *     title: 'Warning',
	         *     messages: 'Are you sure you want to delete this record?',
	         *     autoclose: true
	         * });
	         *
	         * var a2 = app.alert.show('internal_error', {
	         *     level: 'error',
	         *     messages: ['Internal Error', 'Response code: 500']
	         * })
	         *
	         * </code></pre>
	         *
	         * @param {Object} [options] The options specified here are handled by
	         *   the framework. The base application
	         *   {@link View.Views.Base.AlertView#initialize AlertView}
	         *   defines more options for specific behaviors.
	         * @param {string} [options.level] Alert level. `alert-[level]` class
	         *   will be added to the alert view.
	         * @param {boolean} [options.autoClose] Boolean flag indicating if the
	         *   alert must be closed after dismiss delay: See
	         *   {@link Config#alertAutoCloseDelay} setting.
	         * @param {string|string[]} [options.messages] Messages.
	         * @param {string} [options.title] The title of the alert.
	         *   It's displayed in bold.
	         * @return {View.AlertView} Alert instance.
	         */
	        show: function show(key, options) {
	            if (!this.$alerts || !this.$alerts.length) {
	                return null;
	            }
	
	            if (this.preventAnyAlert) return null;
	
	            options = _.extend({
	                level: 'info',
	                autoClose: false
	            }, options || {});
	
	            if (options.level === 'confirmation') {
	                this.dismissAll();
	                this.preventAnyAlert = true;
	            }
	
	            if (options.messages) {
	                options.messages = _.isString(options.messages) ? [options.messages] : options.messages;
	            }
	
	            var alert = _alerts[key];
	            // Create a new alert view if it doesn't exist
	            if (!alert) {
	                alert = this._create(key, options);
	                _alerts[key] = alert;
	            }
	
	            alert.level = options.level;
	
	            // Initialize autoclose timer
	            if (!!options.autoClose) this._setAutoCloseTimer(alert, options.onAutoClose, options.autoCloseDelay);
	
	            alert.render();
	
	            return alert;
	        },
	
	        /**
	         * Creates an instance of alert view class and places view in the DOM.
	         * @param {String} key Alert ID.
	         * @param {Object} options Options.
	         * @return {View.AlertView} Instance of alert view class.
	         * @private
	         */
	        _create: function _create(key, options) {
	            var alert = new this.klass(options);
	            alert.key = key;
	            alert.$el.prependTo(this.$alerts);
	            return alert;
	        },
	
	        /**
	         * Sets the timeout to dismiss the alert view after either the alertAutoCloseDelay configured or 9 seconds
	         * @param {Object} alert the alert to auto close
	         * @param {Function} onAutoClose callback function to call on the autoclose
	         * @private
	         */
	        _setAutoCloseTimer: function _setAutoCloseTimer(alert, onAutoClose, autoCloseDelay) {
	            if (alert.timerId) clearTimeout(alert.timerId);
	            alert.timerId = setTimeout(_.bind(function () {
	                if (_.isFunction(onAutoClose)) {
	                    onAutoClose(alert.key); //callback for when the timeout occurs and the alert is closing
	                }
	                this.dismiss(alert.key);
	            }, this), autoCloseDelay || app.config.alertAutoCloseDelay || 5000);
	        },
	
	        /**
	         * Removes an alert message by key.
	         * @param {String} key The key provided when previously calling show.
	         * @param {Object} options(optional) Options.
	         * @method
	         */
	        dismiss: function dismiss(key, options) {
	            this.preventAnyAlert = false;
	            var alert = _alerts[key];
	            if (!alert) return;
	            if (alert.timerId) clearTimeout(alert.timerId);
	            alert.close(options);
	            delete _alerts[key];
	        },
	
	        /**
	         * Removes all alert messages with a given level.
	         * @param {String} level(optional) Level of alerts to dismiss.
	         * @param {Object} options(optional) Options.
	         * Dismisses all alerts if the level is not specified.
	         * @method
	         */
	        dismissAll: function dismissAll(level, options) {
	            _.each(_alerts, function (alert, key) {
	                if (!level || alert.level == level) {
	                    this.dismiss(key, options);
	                }
	            }, this);
	        },
	
	        /**
	         * Gets an alert with a given key.
	         * @param {String} key The key of the alert to retrieve.
	         * @return {View.AlertView} Alert view with the specified key.
	         */
	        get: function get(key) {
	            return _alerts[key];
	        },
	
	        /**
	         * Gets alerts that are currently displayed.
	         * @return {Object} All alerts.
	         */
	        getAll: function getAll() {
	            return _alerts;
	        }
	    };
	
	    /**
	     * Base class for alerts.
	     *
	     * Extend this class to provide custom alert behavior:
	     * <pre><code>
	     * var PortalAlertView = app.view.AlertView.extend({
	     *
	     *    initialize: function(options) {
	     *       app.view.AlertView.prototype.initialize.call(this, options);
	     *
	     *       // You may override and/or pre-compile alert template
	     *       this.tpl = 'my-alert';
	     *       app.template.compile('my-alert', 'handlebars code...');     *
	     *    },
	     *
	     *    render: function(options) {
	     *        // Provide your custom rendering logic.
	     *        // For example, switch between different templates
	     *        this.tpl = "alert2";
	     *        app.view.AlertView.prototype.render.call(this, options);
	     *    },
	     *
	     *    close: function() {
	     *        // Provide your custom dismiss logic: animation, fade effects, etc.
	     *    }
	     * });
	     * </code></pre>
	     *
	     * @class View.AlertView
	     * @alias SUGAR.App.view.AlertView
	     */
	    app.view.AlertView = app.view.Component.extend({
	
	        /**
	         * Name of the default template.
	         */
	        tpl: '<div class="alert alert-block">{{#if title}}<strong>{{title}}</strong>{{/if}}{{#each messages}}{{./this}}{{/each}}</div>',
	
	        /**
	         * Closes an alert.
	         *
	         * @deprecated since 7.7 please use {@link #dispose}.
	         */
	        close: function close() {
	            this.remove();
	        },
	
	        /**
	         * Renders an alert.
	         *
	         * The method executes a pre-compiled template and replaces the inner
	         * HTML of this view root DOM element.
	         * Additionally, `alert-[level]` class is added to the root element.
	         */
	        render: function render() {
	            var tpl = Handlebars.compile(this.tpl);
	            this.$el.html(tpl(this.options));
	            this.$('.alert').addClass('alert-' + this.options.level);
	        }
	
	    });
	
	    app.augment("alert", _alert, true);
	})(SUGAR.App);

/***/ },
/* 63 */
/***/ function(module, exports) {

	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	
	/**
	 * SugarCRM Analytics API allows user actions to be tracked via an analytics engine.
	 *
	 * The application event "app:analytics:init" will fire on app.start(). It is recommended that applications use a
	 * universal handler to handle pave view changes. Please see the Page Tracking section below for an example of this.
	 *
	 * Connectors:
	 *
	 * Analytics connectors are loaded from SUGAR.App.analytics.connectors.
	 *
	 * Connectors implement the following functions:
	 *
	 * initialize()
	 *
	 * - called on app:init, load the analytics api.
	 *
	 * start(id, options)
	 *
	 * - called on app:start, prepare or open the connection to the analytics system.
	 *
	 * @param  {String}id, tracking id of for analytics system
	 * @param  {Object}options, SUGAR.App.config.analytics configuration.
	 *
	 * trackPageView(pageURI)
	 *
	 * - track a change of page.
	 *
	 * @param  {String} pageURI.
	 *
	 * trackEvent()
	 *
	 * - track an event on the page.
	 *
	 * @param  {Object} event, with the following attributes: category, action, label, value. Label is always set as the current route the user is on.
	 *
	 * Below is a sample connector.
	 * <pre>
	 * (function(app) {
	 * SUGAR.App.analytics = SUGAR.App.analytics || {};
	 * SUGAR.App.analytics.connectors = SUGAR.App.analytics.connectors || {};
	 * SUGAR.App.analytics.connectors["FakeConnector"]  = {
	 *     initialized: false,
	 *     connectorId: null,
	 *       pageLog: [],
	 *       eventLog: [],
	 *       initialize: function() {
	 *           this.initialized = true;
	 *       },
	 *       start: function(id, options) {
	 *           this.connectorId = id;
	 *       },
	 *       trackPageView: function(pageUri) {
	 *           this.pageLog.push(pageUri);
	 *       },
	 *       trackEvent: function(event) {
	 *           this.eventLog.push(event);
	 *       }
	 *   };
	 * })(SUGAR.App);
	 * </pre>
	 *
	 *
	 * Configuration:
	 *
	 * Set the following in SUGAR.App.config.analytics. The entire config is passed to the connector start method as options.
	 *
	 * <pre>
	 * {
	 *     enabled: true,
	 *     connector: "GoogleAnalytics",
	 *     id: 'UA-XXXXXXXX-X'
	 * }
	 * </pre>
	 *
	 *
	 * Page Tracking:
	 *
	 * Use SUGAR.App.analytics.trackPageView(uri); to track page views. An example of a universal way of handling page
	 * tracking would be the following.
	 *
	 * <pre>
	 * app.on("app:analytics:init", function() {
	 *     app.routing.before('route', function(options){
	 *          options = options || {};
	 *          var args = options.args || [];
	 *          var subroute;
	 *          if (args[0]) {
	 *              var qpos = args[0].indexOf('?');
	 *              subroute = qpos > -1 ? args[0].substring(0, args[0].indexOf('?')) : args[0];
	 *          }
	 *          var viewId = options.route + (subroute ? '/' + subroute : '');
	 *
	 *          app.analytics.currentViewId = viewId;
	 *          app.analytics.trackPageView(app.analytics.currentViewId);
	 *      }, this);
	 * });
	 * app.start();
	 * </pre>
	 *
	 *
	 * Event Tracking:
	 *
	 * Use SUGAR.App.analytics.trackEvent(category, action, event, value); to track events.
	 *
	 * The label will always be the app.analytics.currentViewId for any event.
	 *
	 * In JavaScript, this method can be called directly to track any event.
	 *
	 * In Templates, the analytics engine plugs into all views to look for elements with a track attribute on them.
	 * The value of the attribute will contain the event data <category>:<action>.<css class to check>.
	 * The event value is sent as 1 or 0 depending on if that css class is present on the element.
	 *
	 * <pre>
	 *    <a href="#" class="trackedClass" track="click:home.trackedClass">Home</a>
	 * </pre>
	 *
	 * @class SUGAR.analytics
	 */
	(function(app) {
	
	    var _analytics = {
	
	        eventSplitter: /\s{2,}/,
	        currentViewId: '',
	
	        /**
	         * Object containing the list of events to track, mapped to their
	         * respective DOM selector.
	         *
	         * @protected
	         * @type {Object}
	         */
	        _eventsHash: {
	            click: '[track^=click]',
	            swipeleft: '[track^=swipeleft]',
	            swiperight: '[track^=swiperight]'
	        },
	
	        init: function() {
	            if (!app.config.analytics || !app.config.analytics.enabled ||
	                !app.config.analytics.connector || !app.analytics.connectors[app.config.analytics.connector]
	            ) {
	                this.trackPageView = function() {};
	                this.trackEvent = function() {};
	                return;
	            }
	
	            var self = this;
	            app.on('app:init', function() {
	                app.events.register('app:analytics:init', this);
	                app.analytics.connector = app.analytics.connectors[app.config.analytics.connector];
	                app.analytics.connector.initialize();
	
	                _.each(self._eventsHash, function(val, key) {
	                    $('html').on(key, val, function(e) {
	                        var data = self._parseTrackTag($(this).attr('track'));
	                        app.analytics.trackEvent(key, data.action, e, data.value);
	                    });
	                });
	            }).on('app:start', function() {
	
	                // Apps should do their initialization of page tracking based on the following event.
	                app.trigger('app:analytics:init');
	
	                var id = app.config.analytics.id;
	                // Keep backwards compatible with nomad
	                if (_.isObject(id)) {
	                    app.logger.warn('Analytics config id needs to be a valid tracking ID.');
	                    id = app.isNative ? id.native : id.web;
	                }
	
	                app.analytics.connector.start(id, app.config.analytics);
	
	            }).on('app:sync:complete', function() {
	
	                var serverInfo = app.metadata.getServerInfo();
	
	                app.analytics.connector.set('appName',
	                    'SugarCRM:' + app.config.platform + ':' + (serverInfo.flavor || '').toLowerCase()
	                );
	                app.analytics.connector.set('appVersion', serverInfo.version + ':' + serverInfo.build);
	
	            }).on('app:locale:change', function() {
	
	                app.analytics.connector.set('language', app.user.getLanguage());
	            }).on('app:view:change', function(layout, params){
	                app.analytics.currentViewId = layout + (params.module ? '/' + params.module : '');
	                app.analytics.trackPageView(app.analytics.currentViewId);
	            });
	        },
	
	        /**
	         * Track a page view.
	         *
	         * @param {string} page URI.
	         * @member SUGAR.analytics
	         */
	        trackPageView: function(page) {
	            app.logger.debug("GAN-page: " + page);
	            app.analytics.connector.trackPageView(page);
	        },
	
	        /**
	         * Track an event.
	         *
	         * @param {string} category Category of the event.
	         * @param {string} action Action of the event.
	         * @param {Object} event Event to track.
	         * @param {number} [value] Value associated with the event.
	         * @member SUGAR.analytics
	         */
	        trackEvent: function(category, action, event, value) {
	            action = (_.isEmpty(action) && event ? event.currentTarget.id : action) || '[unknown]';
	            app.logger.debug('GAN-event: ' + category + ':' + action  + '(' + value + ')' + ' on ' + this.currentViewId);
	            app.analytics.connector.trackEvent({
	                category: category,
	                action: action,
	                label: this.currentViewId,
	                value: value
	            });
	        },
	
	        /**
	         * Parses the `track` attribute.
	         *
	         * @param {String} track The value of the `track` attribute.
	         * @return {Object} The hash containing the data to pass to
	         *   {@link SUGAR.analytics#trackEvent}
	         * @return {string} return.action The action (example: 'mass_delete').
	         * @return {number|null} return.value The value corresponding to the action.
	         * @private
	         */
	        _parseTrackTag: function(track) {
	            var result = {action: '', value: null};
	            var pieces = track.split(':');
	            if (!pieces[1]) {
	                return result;
	            }
	            var actionValue = pieces[1].split('.');
	            result.action = actionValue[0];
	            if (actionValue[1]) {
	                result.value = actionValue[1];
	            }
	
	            return result;
	        },
	
	        /**
	         * @private
	         * @member SUGAR.analytics
	         */
	        _attachEvents: function(events, action, css, $el) {
	            if (events) {
	                $el.off(events);
	                $el.on(events, function (e) {
	                    app.analytics.trackEvent(e.type, action, e, (css && $(this).hasClass(css) ? 1 : 0));
	                });
	            }
	        },
	
	        dispose: function() {
	            app.off(null, null, this);
	        }
	    };
	
	    app.augment('analytics', _analytics);
	
	})(SUGAR.App);


/***/ },
/* 64 */
/***/ function(module, exports) {

	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function(app) {
	    var optOut;
	
	    app.analytics = app.analytics || {};
	    app.analytics.connectors = app.analytics.connectors || {};
	
	    // Use with newer Universal GA clients
	    app.analytics.connectors.GoogleAnalytics  = {
	
	        /* initialize()
	         *
	         * - called on app:init, load the analytics api.
	         *
	         * @member SUGAR.analytics.connectors.GoogleAnalytics
	         */
	        initialize: function() {
	            // this code is taken directly from Google's analytics.js API
	            // https://developers.google.com/analytics/devguides/collection/analyticsjs/advanced
	            /* jshint ignore:start */
	            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
	                (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
	            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	            })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
	            /* jshint ignore:end */
	        },
	
	        /* start(id, options)
	         *
	         * - called on app:start, prepare or open the connection to the analytics system.
	         *
	         * @param {string} id Tracking id for the analytics system.
	         * @param {Object} options SUGAR.App.config.analytics configuration.
	         * @member SUGAR.analytics.connectors.GoogleAnalytics
	         */
	        start: function (id, options) {
	            options.gaOptions = options.gaOptions || {};
	            _.defaults(options.gaOptions, {
	                cookieDomain: 'none',
	                forceSSL: true,
	            });
	            ga('create', id, options.gaOptions);
	            optOut = options.optOut;
	            if (optOut) {
	                window['ga-disable-' + id] = true;
	            }
	        },
	        /* trackPageView(pageURI)
	         *
	         * - track a change of page.
	         *
	         * @param {string} pageURI URI of the page viewed.
	         * @member SUGAR.analytics.connectors.GoogleAnalytics
	         */
	        trackPageView: function(pageUri) {
	            ga('send', 'pageview', pageUri);
	        },
	        /* trackEvent()
	         *
	         * - track an event on the page.
	         *
	         * @param {Object} event Google Analytics event to track.
	         * @param {string} event.category Category of the event.
	         * @param {string} event.action Action of the event.
	         * @param {string} event.label Always set to the route the user is on.
	         * @param {int} [event.value] Value of the event.
	         * @member SUGAR.analytics.connectors.GoogleAnalytics
	         */
	        trackEvent: function(event) {
	            ga('send', 'event', event.category, event.action, event.label, event.value);
	        },
	
	        /**
	         * Set tracker params.
	         * @param {string} key The param name.
	         * @param {Mixed} value The value to send to the tracker.
	         */
	        set: function(key, value) {
	            ga('set', key, value);
	        }
	    };
	})(SUGAR.App);


/***/ },
/* 65 */
/***/ function(module, exports) {

	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	/**
	 * LiveRelativeDate plugin is a jQuery/Zepto plugin for sidecar that converts a
	 * date into a relative time with a timer to keep it relative to current time.
	 *
	 * To use it is simple, just run:
	 *
	 * ```
	 * $('[data-relative-to]').liverelativedate();
	 * ```
	 *
	 * To define the attribute where the ISO-8601 date can be found (defaults to
	 * `datetime` attribute of used by `<time>` tag):
	 *
	 * ```
	 * $('[data-my-iso-8601]').liverelativedate({
	 *     'attr': 'data-my-iso-8601'
	 * });
	 * ```
	 *
	 * To get the current update interval configured:
	 *
	 * ```
	 * $.liverelativedate('interval');
	 * ```
	 *
	 * To change the current update interval, do:
	 *
	 * ```
	 * $.liverelativedate('interval', 10e3);
	 * ```
	 *
	 * This plugin has a hard dependency with {@link Utils.Date} functions
	 * available in Sidecar library. If you wish to override that behavior,
	 * provide the override on those utility functions.
	 *
	 */
	(function(plugin) {
	    plugin(window.jQuery || window.Zepto, SUGAR.App.date);
	}(function($, date) {
	
	    var updateInterval = 6e4, // every minute
	        $liveDates = $([]),
	        timeout;
	
	    /**
	     * This is the running cycle. It will automatically stop if we don't have
	     * dates to listen to.
	     */
	    var run = function() {
	        if (!$liveDates.length) {
	            return;
	        }
	        timeout = setTimeout(run, updateInterval);
	        liveRelativeDateGlobal.update();
	    };
	
	    /**
	     * List of methods available from the plugin directly. These are the global
	     * methods.
	     */
	    var liveRelativeDateGlobal = {
	
	        /**
	         * Updates provided Elements or all stored elements if none provided.
	         *
	         * On each update of an element, we check if the new date is different
	         * from the old (to minimize the DOM changes) and trigger an event
	         * `change.liveRelativeDate` if it is, to check if any subscribed
	         * listeners want to stop the DOM update.
	         *
	         * This method also keeps the `$liveDates` array clean from lost
	         * elements that weren't properly destroyed.
	         *
	         * @param {jQuery} [$el] The jQuery elements to update. If empty, will
	         *   update all stored elements.
	         */
	        update: function($el) {
	            $el = $el || $liveDates;
	
	            $el.each(function(i, el) {
	                var $this = $(el),
	                    options = $this.data('liveRelativeDate'),
	                    value;
	
	                if (!options) {
	                    // auto clean up in case some one forgot to destroy it.
	                    $liveDates = $liveDates.not(el);
	                    return;
	                }
	
	                value = options.date ? $this.data(options.date) : $this.attr('datetime');
	
	                var from = $this.html(),
	                    // TODO we need to support dateOnly which would show "today" if there is no time available
	                    to = date(value).fromNow();
	
	                if (from === to) {
	                    return;
	                }
	
	                var e = $.Event('change.liveRelativeDate');
	                $this.trigger(e, [from, to]);
	
	                if (!e.isDefaultPrevented()) {
	                    $this.html(to);
	                }
	            });
	        },
	
	        /**
	         * Pauses the relative date time update.
	         */
	        pause: function() {
	            clearTimeout(timeout);
	            timeout = null;
	        },
	
	        /**
	         * Resumes the live relative date auto update if it isn't already
	         * running.
	         */
	        resume: function() {
	            if (!timeout) {
	                run();
	            }
	        },
	
	        /**
	         * Sets the interval if the param is provided, returns the current
	         * configured interval if no param is given.
	         *
	         * @param {number} [interval] The interval to set. Pass `undefined` to
	         *   get the current value.
	         *
	         * @return {number|undefined} The current interval or `undefined` if
	         *   setting the value.
	         */
	        interval: function(interval) {
	            if (interval === undefined) {
	                return updateInterval;
	            }
	            updateInterval = interval;
	        }
	    };
	
	    /**
	     * List of methods that are available based on the provided jQuery
	     * elements.
	     */
	    var liveRelativeDateLocal = {
	
	        /**
	         * Adds a set of Elements to the current live relative dates list.
	         *
	         * Accepts options that will be stored in the element itself to be used
	         * during the update of its content.
	         * This might **not** trigger an update to the added elements
	         * automatically, but will make sure the timer is running for the new
	         * elements.
	         *
	         * @param {jQuery} $el The set of elements to add to the updater.
	         * @param {Object} options The list of options to use in the
	         *   {@link #update} method.
	         * @return {jQuery} The elements being added.
	         */
	        add: function($el, options) {
	
	            if (!$el || $el.length === 0) {
	                return $el;
	            }
	            options = options || {};
	
	            $el.data('liveRelativeDate', JSON.stringify(options));
	            $liveDates = $liveDates.add($el);
	
	            liveRelativeDateGlobal.resume();
	
	            return $el;
	        },
	
	        /**
	         * Clears a set of Elements from the list of live dates to update.
	         *
	         * Clears the data `live-relative-date` from the element.
	         * Doesn't restore the original value of the element when this plugin
	         * was applied.
	         *
	         * @param {jQuery} $el The jQuery elements to remove from the listener.
	         * @return {jQuery} The elements removed from the list of updates.
	         */
	        destroy: function($el) {
	
	            $liveDates = $liveDates.not($el);
	            $el.removeAttr('data-live-relative-date');
	            return $el;
	        },
	
	        /**
	         * Returns `true` if the passed Elements are being tracked/updated by
	         * this plugin.
	         *
	         * @param {jQuery} $els The elements to check.
	         * @return {Boolean} Returns `true` if all elements are being tracked
	         *   by the plugin, `false` otherwise.
	         */
	        isLiveRelativeDate: function($els) {
	
	            var tracked = true;
	            $.each($els, function(el) {
	                if ($(el).data('liveRelativeDate') === undefined) {
	                    tracked = false;
	                    return true;
	                }
	            });
	            return tracked;
	        }
	    };
	
	    $.liverelativedate = liveRelativeDateGlobal;
	
	    $.fn.liverelativedate = function(method, options) {
	
	        if (!liveRelativeDateLocal[method]) {
	            options = method;
	            method = 'add';
	        }
	
	        return liveRelativeDateLocal[method](this, options);
	    };
	}));


/***/ },
/* 66 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Your installation or use of this SugarCRM file is subject to the applicable
	 * terms available at
	 * http://support.sugarcrm.com/Resources/Master_Subscription_Agreements/.
	 * If you do not agree to all of the applicable terms or do not have the
	 * authority to bind the entity as an authorized representative, then do not
	 * install or use this SugarCRM file.
	 *
	 * Copyright (C) SugarCRM Inc. All rights reserved.
	 */
	(function (app) {
	    app.events.on('app:init', function () {
	
	        _.mixin({
	            /**
	             * Check to see if a value is empty.
	             *
	             * Returns true if:
	             *
	             * - value is undefined or null
	             * - value is an empty string
	             * - value is an empty object
	             * - value is an empty array
	             *
	             * All other values return false.
	             *
	             * @param value
	             * @return {boolean}
	             */
	            isEmptyValue: function isEmptyValue(value) {
	                return !_.isNumber(value) && !_.isBoolean(value) && !_.isDate(value) && _.isEmpty(value);
	            },
	
	            /**
	             * Performs a deep-diff comparison between two javascript objects,
	             * and returns a hash of key-values of keys merged between `obj1`
	             * and `obj2`, and `true` if there were changes, `false` if not.
	             *
	             * It does not matter which order you pass the parameters, the
	             * return object will remain the same.
	             *
	             * Example:
	             *
	             *     var newModelAttributes = {
	             *         a: 1,
	             *         b: {create: true, edit: false},
	             *         c: 'test',
	             *         d: {a: 'b', c: {d: true}}
	             *     };
	             *
	             *     var oldModelAttributes = {
	             *         a: 1,
	             *         b: {create: true},
	             *         c: undefined,
	             *         e: [1, 2]
	             *     };
	             *
	             *     _.changed(newModelAttributes, oldModelAttributes);
	             *     >> {a: false, b: true, c: true, d: true, e: true}
	             *
	             * @param {Object} obj1 The first of two objects to diff between.
	             * @param {Object} obj2 The second of two objects to diff between.
	             * @return {Object|undefined} The hash of differences between `obj1`
	             *   and `obj2`. Returns `undefined` if `obj1` and `obj2` are empty.
	             */
	            changed: function changed(obj1, obj2) {
	                if (_.isEmpty(obj1) && _.isEmpty(obj2)) {
	                    return;
	                }
	
	                var result = {};
	                var allKeys = _.keys(_.extend(result, obj2, obj1));
	
	                _.each(allKeys, function (key) {
	                    var changed = false;
	                    if (!_.has(obj1, key) || !_.has(obj2, key) || !_.isEqual(obj1[key], obj2[key])) {
	                        changed = true;
	                    }
	                    result[key] = changed;
	                });
	
	                return result;
	            }
	        });
	    });
	})(SUGAR.App);

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// sidecar.min.js